//@flow
export default {
  en: {
    invalid_area: "Invalid area, please set area again.",
    invalid_lot_size: "Invalid property lot size, please set lot size again.",
    property_area: "Property Area",
    app_store_name: "Listed Near Me - Buy used items, Sell for cash",
    app_store_short:
      "A marketplace for local sellers. List an item for sale and make money.",
    app_store_full:
      "Listed Near Me makes it easy to find great deals on the things you want and make money on the things you want to sell. This is the best way to buy and sell in your community or neighborhood with people you can trust. How it works: 1- Buy or sell anything; easily post your items for sale in seconds. 2- Find great deals and discounts on clothes, furniture, cell phones, electronics, baby and kids items, sports equipment, used cars, dresses, shoes, and watches, to books, used toys, used laptops, a secondhand car and even real estate for sale or rent. 3- Browse local items for sale. 4- Message buyers and sellers from within the app. 5- Browse items by image and sort by category. Fun facts about Listed Near Me: 1- With Listed Near Me you can easily sell anything, from clothes to used cars to electronics. 2- Communication between buyers and sellers happens through the app via messaging. 3- Listed Near Me is better than a garage sale; find anything you want at a discount, right on your phone or tablet.",
    app_store_release:
      "Listed Near Me - Trade With Locals. Join the mobile marketplace for local buyers and sellers!",
    app_name: "Listed Near Me",
    title_buy: "Buy",
    title_messages: "Messages",
    title_sell: "Sell",
    title_profile_image: "Profile Image",
    title_account: "Account",
    account_settings: "Account Settings",
    settings: "Settings",
    color_theme: "Color Theme",
    device_settings: "Device Settings",
    public_profile: "Public Profile",
    light_mode: "Light Mode",
    dark_mode: "Dark Mode",
    title_sell_faster: "Sell Faster",
    send_button_label: "Send",
    rate_message: "Rate Me...",
    already_rated: "You already submitted review",
    rate_review_question: "Would you like to deal with",
    again: "again?",
    action_logout: "Logout",
    action_category: "Category",
    action_search: "Search",
    action_refer: "Refer a friend",
    dialog_choose_location: "Choose Location",
    dialog_change_username: "Change User name",
    dialog_change_language: "Change Language",
    dialog_image_tags: "Image Tags",
    dialog_emails_notifications: "Emails Notifications",
    dialog_push_notifications: "Push Notifications",
    fragment_product_detail: "Product Detail",
    fragment_message_details: "Messages Detail",
    fragment_sell: "Sell",
    dialog_tags_title: "Tags",
    dialog_location_title: "Update Location",
    dialog_username_title: "Change User name",
    tab_photo: "Photo",
    tab_details: "Details",
    tab_price: "Price",
    tab_finish: "Finish",
    profile: "Profile",
    search: "Search",
    choose_product: "Choose Product",
    rating_review: "Rating and Review",
    select_buyer: "Select a buyer",
    tab_my_used_products: "My Products",
    price_label: "Price",
    text_savings: "You save",
    search_hint: "Search for products…",
    empty_text:
      "There are no products listed in this category or within the selected distance.",
    filter_menu_text: "Filter",
    error_contacting_seller: "Error contacting seller",
    edit_product: "Edit Product",
    contact_seller: "Contact Seller",
    signup_to_contact_seller: "Sign Up To Contact Seller",
    signup_to_make_offer: "Sign Up To Make Offer",
    product_details: "Details",
    product_category: "Category",
    product_condition: "Condition",
    product_description: "Description",
    product_location: "Product Location",
    product_location_approximate: "Location is approximate",
    over_week_time_ago: "Over a week ago",
    boosted: "Boosted",
    threads_no_results: "No Messages",
    message_no_results: "No Messages",
    message_warning:
      "You are solely responsible for taking all necessary precautions when interacting with others, particularly when meeting a stranger in person for first time. Please do not share any personal information, verification codes or any payment information. Please review Terms of Service for more details.",
    message_block: "You can not send or receive messages at this time.",
    select_location: "Select Location",
    location_permission_denied_message:
      "The app requires location permission to work properly.",
    signed_in: "Signed in!",
    sign_in_canceller: "Sign in cancelled",
    version: "Version",
    build: "Build",
    name: "Name",
    location: "Location",
    language: "Language",
    about_app: "About Listed Near Me",
    terms_of_service: "Terms of Service",
    privacy_policy: "Privacy Policy",
    report_feedback: "Send Feedback",
    report_bug: "Shake phone to report a bug",
    change_image: "Change Image",
    update_location: "Update Location",
    about_the_app: "About The App",
    update_label: "Update",
    uploading: "Uploading",
    adding: "Adding Listing",
    removing: "Removing Listing",
    updating: "Updating Listing",
    uploaded_image: "Uploaded image: ",
    image_storage_failed: "Failed to store image: ",
    product_updated: "Product Updated Successfully",
    location_error: "Location not saved, please try again",
    product_removed: "Product Removed Successfully",
    deleted_product: "This Product Is Deleted",
    invalid_title: "Invalid title, please set title again.",
    invalid_image: "Invalid image path, try add image again.",
    invalid_price: "Invalid price, please set price again.",
    invalid_location: "Invalid location, please set location again.",
    invalid_category: "Invalid category, please set category again.",
    invalid_condition: "Invalid condition, please set condition again.",
    removing_title: "Removing Profile Image",
    image_not_saved: "Image Save Failed!",
    product_load_failed: "No Products",
    take_photo: "Take Photo",
    select_photo: "Select Photo",
    product_title_hint: "What is it? Name, brand, model, etc.",
    delete_photo: "Delete Photo",
    product_title: "Title",
    mark_as_sold: "Mark As Sold",
    product_share: "Share",
    product_make_offer: "Make Offer",
    product_cover: "Set As Cover Image",
    product_tags: "Tags",
    product_posted: "Posted: ",
    product_change: "Change",
    product_post: "Post",
    product_selling_from: "Selling From Location",
    product_select_location: "Select Location",
    product_map_approximate:
      "Map is approximate to keep the seller's location private",
    product_terms:
      "By tapping post to publish your product, you agree to <u>Listed Near Me Terms of Service.</u>",
    condition_other: "Other (see description)",
    condition_for_parts: "For Parts",
    condition_used: "Used (normal wear)",
    condition_open_box: "Open Box (never used)",
    condition_reconditioned: "Reconditioned/Certified",
    condition_new: "New (never used)",
    select_category: "Select Category",
    select_all_category: "Select All",
    category_loading_error:
      "Can not update categories list, please try again later.",
    category_vehicles: "Vehicles",
    category_furniture: "Furniture",
    category_electronics: "Electronics",
    category_appliances: "Home & Appliances",
    category_fashion_accessories: "Fashion & Accessories",
    category_baby_kids: "Baby & Kids",
    category_antiques_collectibles: "Antiques & Collectibles",
    category_auto_parts_tools_machinery: "Auto Parts, Tools & Machinery",
    category_sports_outdoors: "Sports & Outdoors",
    category_others: "Others",
    location_enter_zip_code: "Enter Zip Code",
    location_get_current_location: "Get Current Location",
    location_select_location: "Select Location",
    location_update_location: "Update Location",
    location_new_location: "New Location",
    search_filter_results: "Filter Results",
    search_filter_min: "Filter minimum",
    search_filter_at_least: "At least",
    price_filter: "Price Filter",
    product_name: "Product Name",
    english_language: "English",
    arabic_language: "Arabic",
    spanish_language: "Spanish",
    system_language: "System",
    share_link: "Share Link",
    save: "Save",
    cancel: "Cancel",
    loading: "Loading",
    yes: "Yes",
    no: "No",
    report: "Report",
    report_product: "Report Product",
    report_user: "Report User",
    block_user: "Block User",
    un_block_user: "UnBlock User",
    why_product: "Why do you want to report this item?",
    why_user: "Why do you want to report this user?",
    block_user_confirm: "Do you want to permanently block this user?",
    un_block_user_confirm: "Do you want to permanently unblock this user?",
    prohibited: "Prohibited on Listed Near Me",
    offensive: "Offensive or inappropriate",
    duplicate: "Duplicate post",
    wrong_category: "Wrong category",
    scam: "Looks like a scam",
    stolen: "I think it is stolen",
    product_other: "Other",
    product_is_sold: "This product was sold",
    missed_meeting: "They missed our meeting",
    low_offer: "Made a low offer",
    rude: "Rude or inappropriate",
    items: "Problem with items",
    trouble_meetup: "Trouble at meet up",
    messaging: "Messaging problems",
    user_other: "Other",
    new_version_available: "New version available",
    please_update_app: "Please, update app to new version to continue.",
    update: "Update",
    no_thanks: "No, thanks",
    contact_support_confirmation:
      "The current response time is 24-48 hours. Do you want to contact Listed Near Me App chat support?",
    unboost_confirmation: "Are you sure you want to unboost this product?",
    no_used_products: "You don’t have any listings yet",
    no_boosted_products: "You don’t have any boosted products",
    next: "Next",
    previous: "Previous",
    skip: "Skip",
    start: "Start",
    list_used: "List a used product",
    buy_description:
      "Discover and search for products offered by neighbours around you",
    sell_description: "List products you no longer need for sale",
    list_used_description:
      "List a used product for sale in less than 20 seconds",
    boost_product_option_1: "<b>Boost 1\nday </b>\n\n<b>$0.99</b>",
    boost_product_option_2: "<b>Boost 3\ndays</b>\n\n<b>$1.99</b>",
    boost_product_option_3: "<b>Boost 7\ndays</b>\n\n<b>$3.99</b>",
    boost_product_description:
      "Get more views each day. Your item will appear in featured positions within the top 30 items in buy and category. Promoted items are rotated among the designated spots so every item gets fair exposure.",
    boost_cta: "Sell Faster",
    boost_terms:
      "By tapping boost, you agree to <u>Listed Near Me Terms of Service.</u>",
    boost_best_value: "Best Value",
    already_boosted: "This product is boosted",
    clicks: "Clicks",
    impressions: "Impressions",
    end: "End",
    transactions_empty_text:
      "You do not have any boost transactions yet. You can visit sell tab and start boosting your products.",
    transactions_loading_error:
      "Can not update transactions list, please try again later.",
    transactions_history_title: "Boost Transactions History",
    communicative_postive: "Communicative",
    communicative_negative: "Uncommunicative",
    ontime_postive: "On time",
    ontime_negative: "Late",
    reliable_postive: "Reliable",
    reliable_negative: "Unreliable",
    friendly_postive: "Friendly",
    friendly_negative: "Impolite",
    itemasdescribed_postive: "Item as described",
    itemasdescribed_negative: "Item not as described",
    other: "Other",
    submit: "Submit",
    adding_rating_reviews: "Adding Rating and Reviews",
    no_internet_title: "No Internet Connection",
    no_internet_message:
      "Make sure you are connected to the Internet and try again",
    retry: "Retry",
    near_me: "Near Me",
    newest_first: "Newest First",
    miles: "miles",
    km: "km",
    similar_products: "Similar Products",
    favorite_products: "Favorite Products",
    items_for_sale: "Items for sale",
    joined: "Joined",
    favorites_transactions_title: "Favorites",
    boosted_products_transactions_history:
      "Boosted Products Transactions History",
    views: "Views",
    boost_graph_title: "Boost Graph",
    no_favorite_products: "You don’t have any favorite products",
    make_offer_buy: "I would like to buy",
    make_offer_buy_for: "for",
    notifications: "Notifications",
    push_notifications: "Push",
    emails_notifications: "Email",
    apply: "Apply",
    email_messages: "Email for messages",
    email_new_products: "Email for new products",
    push_day_only: "Push notifications day only",
    push_24_hours: "Push notifications 24 hours",
    edit: "Edit",
    map: "Map",
    camera: "Camera",
    gallery: "Gallery",
    delete: "Delete",
    no_sell_items: "No Items For Sale",
    who_bought_question: "Who bought it?",
    sold_elsewhere_question: "Sold it somewhere else",
    confirm: "Confirm",
    over_limit_camera: "You cannot add more than five images",
    boost_failed: "Boost Failed. Please try again later",
    after_purchase: "Payment successful\nProduct boosted",
    pay_failed: "Payment Failed. Please try again",
    done: "Done",
    not_now: "Not Now",
    boost: "Boost",
    invalid_zip_code: "Invalid Zip Code",
    invalid_user_name: "Invalid User Name",
    comments: "Comments",
    questions: "Questions",
    bug_reports: "Bug Reports",
    feature_request: "Feature Request",
    feedback_type: "Feedback Type",
    feedback_description:
      "We would love to hear your thoughts or feedback on how we can improve your experience!",
    feedback: "Feedback",
    feedback_text: "Your answer",
    suggestions: "Suggestions for improvement",
    delete_account: "Delete Account",
    new_message: "New Message",
    online: "Online",
    km_50: "50 KM",
    km_100: "100 KM",
    km_200: "200 KM",
    miles_30: "30 Miles",
    miles_60: "60 Miles",
    miles_120: "120 Miles",
    rate_app_question: "How about a rating on the App Store, then?",
    enjoying_question: "Enjoying Listed Near Me?",
    not_enjoy: "Not really",
    feedback_question: "Would you mind giving us some feedback?",
    yes_sure: "Ok, sure",
    product_available_question: "Hi, is this still available?",
    buy_question: "Hi, I'd like to buy this",
    meet_question: "Hi, can you meet today?",
    follow: "Follow",
    followers: "Followers",
    following: "Following",
    feedback_thanks: "Thanks for your feedback",
    all_categories: "All Categories",
    deleted_account: "This Account Is Deleted",
    delete_account_question: "Are you sure you want to delete this account?",
    no_followings: "doesn't follow anyone",
    when_following: "when",
    no_followings_subtitle: "follows people, you will see them here",
    no_followers: "doesn't have followers",
    no_followers_subtitle: "followed by people, you will see them here",
    distance: "Distance",
    filter_method: "Filter Method",
    see_listings: "See Listings",
    sold: "Sold",
    bought: "Bought",
    no_notifications: "When you receive notifications, they'll appear here",
    items_title: "Items",
    new_listing_title: "Create New Listing",
    dialog_year_title: "Year",
    dialog_make_title: "Make",
    dialog_model_title: "Model",
    dialog_body_style_title: "Body Style",
    dialog_exterior_color_title: "Exterior Color",
    dialog_interior_color_title: "Interior Color",
    dialog_transmission_title: "Transmission",
    dialog_fuel_type_title: "Fuel Type",
    dialog_owners_num_title: "Number of Owners",
    dialog_vehicle_owed_money_title:
      "Is there money still owed on this vehicle?",
    automatic_transmission: "Automatic",
    manual_transmission: "Manual",
    not_sure: "Not Sure",
    wagon_hatchback: "Wagon & Hatchback",
    convertible: "Convertible",
    coupe: "Coupe",
    sedan: "Sedan",
    black_color: "Black",
    blue_color: "Blue",
    brown_color: "Brown",
    gold_color: "Gold",
    green_color: "Green",
    grey_color: "Grey",
    pink_color: "Pink",
    purple_color: "Purple",
    red_color: "Red",
    silver_color: "Silver",
    orange_color: "Orange",
    white_color: "White",
    yellow_color: "Yellow",
    charcol_color: "Charcol",
    fuel_diesel: "Diesel",
    fuel_electric: "Electric",
    fuel_gasoline: "Gasoline",
    fuel_flex: "Flex",
    fuel_hybrid: "Hybrid",
    fuel_petrol: "Petrol",
    fuel_plugin_hybrid: "Plug-in hybrid",
    truck: "Truck",
    van_minivan: "Van & Minivan",
    suv_crossover: "SUV & Crossover",
    awd_4wd: "AWD/4WD",
    fwd: "FWD",
    rwd: "RWD",
    off_white_color: "Off White",
    tan_color: "Tan",
    beige_color: "Beige",
    burgundy_color: "Burgundy",
    turquoise_color: "Turquoise",
    title_status_clean: "Clean",
    title_status_rebuilt: "Rebuilt",
    title_status_salvage: "Salvage",
    title_status_missing: "Missing",
    title_status_lien: "Lien",
    title_status: "Title Status",
    mileage: "Mileage",
    dialog_drivetrain_title: "Drivetrain",
    model_warning: "Please select Make first",
    required_field_warning: "This field is required",
    vehicle_vin: "Vin",
    invalid_vin: "Invalid vin, please set vin again.",
    invalid_mileage: "Invalid mileage, please set mileage again.",
    clean_description: "Most vehicles that haven’t been in an accident",
    rebuilt_description: "A salvaged car that has been rebuilt",
    salvage_description: "Is considered totalled after an accident",
    missing_description: "Will need a new DMV issues title",
    lien_description: "Owned by a bank or court settlement",
    nearme: "NearMe",
    newest: "Newest",
    contact_support: "Contact Support",
    create_home_title: "Homes for Sale or Rent",
    for_sale: "For Sale",
    for_rent: "For Rent",
    property_type: "Property type",
    apartment: "Apartment",
    house: "House",
    room_only: "Room only",
    townhouse: "Townhouse",
    bedrooms: "Bedrooms",
    bathrooms: "Bathrooms",
    property_address: "Property address",
    price_per_month: "Price per month",
    square_feet: "Square feet",
    year_built: "Year built",
    year_renovated: "Year renovated",
    lot_size: "Lot size",
    laundry_type: "Laundry type",
    in_unit_laundry: "In-unit laundry",
    laundry_building: "Laundry in building",
    laundry_available: "Laundry available",
    none: "None",
    parking_type: "Parking type",
    garage_parking: "Garage parking",
    street_parking: "Street parking",
    off_street_parking: "Off-street parking",
    available_parking: "Parking available",
    air_cond_type: "Air conditioning type",
    ac_available: "AC available",
    central_ac: "Central AC",
    heating_type: "Heating type",
    electric_heating: "Electric heating",
    gas_heating: "Gas heating",
    radiator_heating: "Radiator heating",
    available_heating: "Heating available",
    amenities: "Amenities",
    date_available: "Date available",
    lease_length: "Lease length",
    month_to_month: "Month to month",
    three_months: "3 months",
    six_months: "6 months",
    one_year: "1 year",
    more_one_year: "1+ years",
    cat_friendly: "Cat friendly",
    dog_friendly: "Dog friendly",
    balcony: "Balcony",
    basement: "Basement",
    bike_parking: "Bike Parking",
    cable_tv: "Cable TV",
    ceiling_fan: "Ceiling Fan",
    concierge: "Concierge",
    dishwasher: "Dishwasher",
    doorman: "Doorman",
    elevator: "Elevator",
    fireplace: "Fireplace",
    fitness_center: "Fitness Center",
    garbage_disposal: "Garbage Disposal",
    microwave: "Microwave",
    online_app: "Online Application",
    oven: "Oven",
    package_service: "Package Service",
    patio: "Patio",
    pet_park: "Pet Park",
    refrigerator: "Refrigerator",
    resident_lounge: "Resident Lounge",
    roof_deck: "Roof Deck",
    secured_entry: "Secured Entry",
    storage: "Storage",
    walk_in_closet: "Walk-in Closet",
    swimming_pool: "Swimming Pool",
    wheelchair_access: "Wheelchair Access",
    central_heating: "Central heating",
    invalid_bedrooms: "Invalid bedrooms, please set bedrooms again.",
    invalid_bathrooms: "Invalid bathrooms, please set bathrooms again.",
    chinese_simplified_language: "Chinese Simplified",
    chinese_traditional_language: "Chinese Traditional",
    czech_language: "Czech",
    danish_language: "Danish",
    dutch_language: "Dutch",
    finnish_language: "Finnish",
    french_language: "French",
    german_language: "German",
    greek_language: "Greek",
    hungarian_language: "Hungarian",
    indonesian_language: "Indonesian",
    italian_language: "Italian",
    japanese_language: "Japanese",
    korean_language: "Korean",
    norwegian_language: "Norwegian",
    polish_language: "Polish",
    portuguese_language: "Portuguese",
    portuguese_brazilian_language: "Portuguese, Brazilian",
    romanian_language: "Romanian",
    russian_language: "Russian",
    swedish_language: "Swedish",
    turkish_language: "Turkish",
    ukrainian_language: "Ukrainian",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "Vietnamese",
    category_home_sale_or_rent: "Home for Sale or Rent",
    square_meter: "Square meter",
    copy_text: "Copy",
    copyied_to_clipboard: "Copied to clipboard",
    inbox: "Inbox",
    input_title_listening: "Listening…",
    input_subtitle_listening: "Say something",
    input_title_error: "Sorry, we didn't quite get that.",
    input_subtitle_error: "Try repeating your request.",
    input_hint_error: "Try again",
    price_less_than_or_equal: "Price less than or equal to",
    any_price: "Any Price",
    any_condition: "Any Condition",
    any_time: "Any Time",
    days_ago: "days ago",
    any_distance: "Any Distance",
    distance_within: "Distance within",
    new_notification: "New Notification",
    deleted: "Deleted",
    processing_image: "Processing Image",
    remove_dialog_message: "Do you really want to remove this product?",
    deleted_thread: "This Message Is Deleted",
    category_yard_sale_event: "Yard Sale Event",
    yard_first_date: "Yard Sale First Date",
    yard_second_date: "Yard Sale Second Date",
    yard_third_date: "Yard Sale Third Date",
    yard_start_time: "Start Time",
    yard_end_time: "End Time",
    yard_end_timestamp: "End Timestamp",
    invalid_date1: "Invalid first date, please set first date again",
    invalid_start_time: "Invalid start time, please set start time again",
    invalid_end_time: "Invalid end time, please set end time again",
    yard_sale_title: "Yard Sale",
    garage_tag: "garage",
    yard_tag: "yard",
    from: "From",
    to: "To",
    block: "Block",
    un_block: "Unblock",
    sign_email: "Sign in with email",
    invalid_first_date:
      "Invalid first date, please make sure first date is before second and third",
    invalid_second_date:
      "Invalid second date, please make sure second date is before third date",
    invalid_start_time_value:
      "Invalid start time, please make sure start time is before end time",
    use_default_yard_photo: "Use Default Yard Sale Photo",
    active_label: "Active",
    enable_notifications: "Enable Notifications",
    login: "Login",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    since: "Since",
    shop_views: "Shop views",
    total_sales: "Total sales",
    total_orders: "Total orders",
    last_twelvth_months: "Last twelvth months",
    last_nine_months: "Last nine months",
    last_six_months: "Last six months",
    last_three_months: "Last three months",
    last_12_months: "Last 12 months",
    last_9_months: "Last 9 months",
    last_6_months: "Last 6 months",
    last_3_months: "Last 3 months",
    months: "Months",
    open: "Open",
    reset_password: "Reset password",
    create_new_shop: "Create new shop",
    download_app: "Download app",
    log_in: "Log in",
    sign_up: "Sign up",
    no_result: "No result",
    max_price: "Max price",
    max_distance: "Max distance",
    max_time: "Max time",
    posted_less_than: "Posted less than",
    result: "Result",
    more: "More",
    or: "OR",
    password: "Password",
    forgot_password: "Forgot password?",
    and: "and",
    download_for: "Download for",
    apple_ios: "Apple IOS",
    android: "Android",
    image: "Image",
    edit_image: "Edit image",
    please_complete: "Please complete",
    enter_your_offer: "Enter your offer",
    categories: "Categories",
    upload_image: "Upload image",
    upload_images: "Upload images",
    back: "Back",
    see_more: "See more",
    add_product: "Add product",
    selected: "Selected",
    create: "Create",
    rate_the_buyer: "Rate the buyer",
    delete_product: "Delete product",
    product: "Product",
    un_block_product: "UnBlock Product",
    share_your_product: "Share your product",
    boost_details: "Boost details",
    remove_all_products: "Remove all products",
    remove_all: "Remove all",
    add_vehicle: "Add vehicle",
    edit_vehicle: "Edit vehicle",
    upload_a_photo: "Upload a photo",
    view_details: "View details",
    add_yard_sale: "Add yard sale",
    edit_yard_sale: "Edit yard sale",
    users: "Users",
    users_details: "Users details",
    users_by_country: "Users by country",
    blocked_users: "Blocked users",
    products_cards: "Products cards",
    archived_products: "Archived products",
    blocked_products: "Blocked products",
    product_views: "Product views",
    products_by_country: "Products by country",
    reports: "Report",
    reports_details: "Reports details",
    closed_reports: "Closed reports",
    threads: "Threads",
    threads_details: "Threads details",
    chat_support: "Chat support",
    actions: "Actions",
    search_actions: "Search actions",
    product_view_actions: "Product view actions",
    contact_seller_product: "Contact seller product",
    contact_owner_shop: "Contact owner shop",
    ratings: "Ratings",
    reviews: "Reviews",
    products_all_countries: "Products all countries",
    edit_profile: "Edit profile",
    my_profile: "My profile",
    profile_updated_successfully: "Profile updated successfully",
    are_you_sure: "Are you sure",
    my_used_products: "My used products",
    my_shops: "My shops",
    my_boosted_products: "My boosted products",
    messages_type_message_here: "Type your message here",
    messages_product_sold: "This product is sold or removed",
    seen: "Seen",
    messages_never_miss_message: "Never miss a message",
    enable: "Enable",
    send_notify: "Send notify",
    un_close: "UnClose",
    type_your_review: "Type your review",
    again_question: "again ?",
    ratings_already_submitted_review: "You already submitted review",
    set_product_category: "Set product category",
    auth_email_password_incorrect: "Your E-mail or password incorrect",
    auth_insert_your_name: "Please insert your name",
    auth_email_address_badly: "The email address is badly formatted",
    auth_email_address_used:
      "The email address is already in use by another account",
    auth_invalid_password: "Password should be at least 6 characters",
    auth_reset_email: "Enter your email to reset your password",
    auth_check_email: "Please, check your email to reset password",
    auth_can_sign_in_google: "You can sign in with google button",
    auth_do_not_have_account: "Don't you have an account?",
    auth_have_account: "Do you have an account?",
    log_terms_privacy_part1:
      "By signing up or logging in, you agree to the Listed Near Me",
    boost_this_product: "Boost this product?",
    product_successfully_boosted: "The product has been successfully boosted",
    product_failed_boost: "The product has been failed in boost",
    no_products_for_sale:
      "You currently don’t have any used products listed for sale.",
    not_sold_listed_near_me: "I didn’t sell it on Listed Near Me",
    agree_add_product:
      "By tapping post to publish your product, you agree to the Listed Near Me Terms of Service and Privacy Policy.",
    click_to_boost: "Click on product to boosted it",
    listed_terms_of_service: "Listed Near Me Terms of Service",
    receive_emails_for_users: "Receive emails for users messages",
    receive_emails_for_newly_posted:
      "Receive emails for your newly posted products",
    disable_push_notifications: "Disable push notifications",
    sms_during_day: "Receive SMS during the day",
    sms_24_hours: "Receive SMS 24 hours",
    products: "Products",
    product_no_longer_available: "Sorry, this product is no longer available",
    add_home: "Add home",
    edit_home: "Edit home",
    fill_required_fields: "Fill all the required fields",
    no_notification: "There are no notifications",
    orders_history: "Orders history",
    privacy: "Privacy",
    terms: "Terms",
    report_a_problem: "Report a problem",
    approximation_protect_user_privacy:
      "Approximation to protect user's privacy",
    do_not_have_products: "You don't have products",
    emails: "Emails",
    lead_deletion_products:
      "This will lead to the deletion of all your products",
    confirm_legal_message:
      "You are solely responsible for taking all necessary precautions when interacting with others, particularly when meeting a stranger in person for first time. please review Terms of Service for more details.",
    push_notifications_notified_instantly:
      "Enable push notifications to be notified instantly",
    rate_seller: "Rate seller",
    user_journey: "User Journey",
    user: "User",
    user_id: "User Id",
    action_id: "Action Id",
    select_model_car: "Select model of car",
    boost_1_day: "Boost 1 day",
    boost_3_days: "Boost 3 days",
    boost_7_days: "Boost 7 days",
    agree_boost_terms: "By tapping boost, you agree to",
    add: "Add",
    add_tag: "Add tag",
    brand_title: "Brand",
    category_mobiles: "Mobiles",
    category_tablets: "Tablets",
    screen_size: "Screen Size",
    has_cellular_capability: "Has Cellular Capability",
    default_internal_memory: "Internal Memory",
    network_carrier: "Network Carrier",
    is_unlocked: "Is Unlocked",
    mobile_model_warning: "Please select Brand first",
    missing_image: "Missing image, try add image again.",
    add_mobile: "Add Mobile",
    edit_mobile: "Edit Mobile",
    add_tablet: "Add Tablet",
    edit_tablet: "Edit Tablet",
    keywords:
      "shopping, buy, sell, make money, trade, locals, neighbors, auto, vehicles",
    country: "Country",
    phone_number: "Phone number",
    verification_code: "Verification Code",
    error_occurred: "An error occurred, please try again later",
    invalid_state:
      "Invalid state: A login callback was received, but no login request was sent.",
    sign_in: "Sign in",
    sign_in_apple: "Sign in with Apple",
    sign_in_google: "Sign in with Google",
    sign_in_phone: "Sign in with Phone",
    sign_in_facebook: "Sign in with Facebook",
    create_account: "Create an account",
    email: "Email",
    invalid_field: "Please fill in the required fields",
    code_sent: "The code has been sent by SMS",
    verify_number: "Verify Phone Number",
    tapping_verify_number: "By tapping (Verify Phone Number), an SMS be sent.",
    email_exists:
      "The account already exists and you need to access it via Google button, Facebook button or Apple button",
    ok: "Ok",
    sure_back: "Are you sure to back ?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "ago",
    add_model: "Add Model",
    no_search_results_us:
      "No search results near you within 120 miles. Try to change the search filter or search keyword.",
    no_search_results:
      "No search results near you within 200 km. Try to change the search filter or search keyword.",
    plan_date: "Plan date",
    plan_time: "Plan time",
    invalid_plan_date: "Invalid plan date, please set plan date again",
    invalid_plan_time: "Invalid plan time, please set plan time again",
    plan_name: "Plan name",
    plan_title: "Plan",
    update_plan_name: "Update plan name",
    delete_plan_question: "Are you sure you want to delete this plan?",
    plan_reminder_message: "You will be reminded one hour before",
    plan_dialog_title: "Meeting Plan",
    planners_title: "Planners",
    unable_sending_messages:
      "They will see your messages when they are back online.",
    its_text: "It's",
    for_your_text: "for your receiver.",
    "symbols.question": "?",
  },
  ar: {
    invalid_area: "منطقة غير صالحة، يرجى ضبط المنطقة مرة أخرى.",
    invalid_lot_size: "حجم خاص خاصية غير صالح، يرجى ضبط حجم الكثير مرة أخرى.",
    property_area: "منطقة الملكية",
    app_store_name: "Listed Near Me - Buy used items, Sell for cash",
    app_store_short: "سوق للبائعين المحليين. قائمة بندا للبيع وكسب المال.",
    app_store_full:
      "يُسهل Listed Near Me العثور على صفقات رائعة على الأشياء التي تريدها وكسب المال من الأشياء التي تريد بيعها. هذه هي أفضل طريقة للشراء والبيع في مجتمعك أو منطقتك مع أشخاص يمكنك الوثوق بهم. كيف يعمل: 1- بيع وشراء أي شيء. بسهولة نشر عناصرك للبيع في ثوان. 2- ابحث عن صفقات وخصومات رائعة على الملابس والأثاث والهواتف المحمولة والإلكترونيات وأدوات الأطفال والرضع والمعدات الرياضية والسيارات المستعملة والفساتين والأحذية والساعات والكتب والألعاب المستعملة وأجهزة الكمبيوتر المحمولة المستعملة والسيارة المستعملة وحتى الحقيقية عقارات للبيع أو الإيجار. 3- تصفح الأصناف المحلية المعروضة للبيع. 4- مراسلة المشترين والبائعين من داخل التطبيق. 5- تصفح العناصر بالصورة وفرزها حسب الفئة. حقائق ممتعة حول Listed Near Me: 1- مع Listed Near Me ، يمكنك بسهولة بيع أي شيء ، من الملابس إلى السيارات المستعملة إلى الإلكترونيات. 2- يتم التواصل بين المشترين والبائعين من خلال التطبيق عبر الرسائل. 3- Listed Near Me أفضل من بيع المرآب ؛ اعثر على أي شيء تريده بسعر مخفض ، مباشرة على هاتفك أو جهازك اللوحي.",
    app_store_release:
      "المدرجة بالقرب مني - التجارة مع السكان المحليين. انضم إلى سوق الهاتف المحمول للمشترين والبائعين المحليين!",
    app_name: "Listed Near Me",
    title_buy: "شراء",
    title_messages: "رسائل",
    title_sell: "بيع",
    title_profile_image: "صورة المستخدم",
    title_account: "الحساب",
    account_settings: "إعدادات الحساب",
    settings: "إعدادات الحساب",
    color_theme: "لون المظهر",
    device_settings: "إعدادات الجهاز",
    public_profile: "الحساب العام",
    light_mode: "وضع نهاري",
    dark_mode: "وضع ليلي",
    title_sell_faster: "بيع أسرع",
    send_button_label: "ارسل",
    rate_message: "قيّمني ...",
    already_rated: "لقد قمت مسبقاً بالمراجعة",
    rate_review_question: "هل تود التعامل مع",
    again: "مرّة أخرى؟",
    action_logout: "تسجيل الخروج",
    action_category: "الفئة",
    action_search: "بحث",
    action_refer: "اخبر الاصدقاء",
    dialog_choose_location: "اختر الموقع",
    dialog_change_username: "تعديل اسم المستخدم",
    dialog_change_language: "تعديل اللغة",
    dialog_image_tags: "مميزات الصورة",
    dialog_emails_notifications: "رسائل البريد الإلكتروني",
    dialog_push_notifications: "دفع الإشعارات",
    fragment_product_detail: "تفاصيل المنتج",
    fragment_message_details: "تفاصيل الرسائل",
    fragment_sell: "بيع",
    dialog_tags_title: "علامات",
    dialog_location_title: "تحديث الموقع",
    dialog_username_title: "غير اسم المستخدم",
    tab_photo: "صورة",
    tab_details: "تفاصيل",
    tab_price: "السعر",
    tab_finish: "إنهاء",
    profile: "ملف للمستخدم",
    search: "بحث",
    choose_product: "اختر المنتج",
    rating_review: "التقييم والمراجعة",
    select_buyer: "حدد المشتري",
    tab_my_used_products: "منتجاتي",
    price_label: "السعر",
    text_savings: "أنت توفر",
    search_hint: "البحث عن المنتجات ...",
    empty_text: "لا توجد منتجات مدرجة في هذه الفئة أو ضمن المسافة المحددة.",
    filter_menu_text: "تصفية البحث",
    error_contacting_seller: "خطأ في الاتصال مع البائع",
    edit_product: "تحرير المنتج",
    contact_seller: "تواصل مع البائع",
    signup_to_contact_seller: "اشترك للتواصل مع البائع",
    signup_to_make_offer: "اشترك لتقديم عرض",
    product_details: "تفاصيل",
    product_category: "الفئة",
    product_condition: "حالة المنتج",
    product_description: "وصف المنتج",
    product_location: "موقع المنتج",
    product_location_approximate: "الموقع تقريبي",
    over_week_time_ago: "منذ أكثر من أسبوع",
    boosted: "إعلان",
    threads_no_results: "لا توجد رسائل",
    message_no_results: "لا توجد رسائل.",
    message_warning:
      "أنت وحدك مسؤول عن اتخاذ جميع الاحتياطات اللازمة عند التفاعل مع الآخرين ، وخاصة عند مقابلة شخص غريب شخصيًا للمرة الأولى. يرجى عدم مشاركة أي معلومات شخصية أو رموز التحقق أو أي معلومات دفع. يرجى مراجعة شروط الخدمة لمزيد من التفاصيل.",
    message_block: "لا يمكنك إرسال أو استقبال رسائل في الوقت الحالي.",
    select_location: "اختر الموقع",
    location_permission_denied_message:
      "يتطلب التطبيق إذن الموقع الجغرافي للعمل بشكل صحيح",
    signed_in: "تم الدخول!",
    sign_in_canceller: "تم إلغاء تسجيل الدخول",
    version: "الإصدار",
    build: "رمز",
    name: "الاسم",
    location: "الموقع",
    language: "اللغة",
    about_app: "حول التطبيق",
    terms_of_service: "شروط الخدمة",
    privacy_policy: "سياسة الخصوصية",
    report_feedback: "أرسل ملاحظاتك حول التطبيق",
    report_bug: "هز الهاتف للإبلاغ عن خطأ",
    change_image: "تغيير الصورة",
    update_location: "تحديث الموقع",
    about_the_app: "التطبيق",
    update_label: "تحديث",
    uploading: "جار التحميل",
    adding: "يتم اضافة المنتج",
    removing: "جار إزالة المنتج",
    updating: "يتم تحديث المنتج",
    uploaded_image: "الصورة المحملة:",
    image_storage_failed: "فشل حفظ الصورة:",
    product_updated: "تم تحديث المنتج بنجاح",
    location_error: "لم يتم حفظ الموقع ، يرجى اعادة المحاولة",
    product_removed: "تم حذف المنتج بنجاح",
    deleted_product: "تم حذف هذا المنتج",
    invalid_title: "عنوان غير صالح ، يرجى تعيين العنوان مرة أخرى.",
    invalid_image: "مسار صورة غير صالح ، حاول إضافة صورة مرة أخرى.",
    invalid_price: "سعر غير صالح ، يرجى تحديد السعر مرة أخرى.",
    invalid_location: "موقع غير صالح ، يرجى اختيار الموقع مرة أخرى.",
    invalid_category: "فئة غير صالحة ، يرجى اختيار الفئة مرة أخرى.",
    invalid_condition: "يرجى تحديد حالة المنتج مرة أخرى.",
    removing_title: "إزالة صورة الملف الشخصي",
    image_not_saved: "فشل حفظ الصورة!",
    product_load_failed: "لا توجد منتجات",
    take_photo: "التقاط صورة",
    select_photo: "اختر الصورة",
    product_title_hint: "ما هو المنتج؟ الاسم ، العلامة التجارية ، المصنع...",
    delete_photo: "حذف الصورة",
    product_title: "العنوان",
    mark_as_sold: "تم بيع المنتج",
    product_share: "شارك",
    product_make_offer: "تقديم عرض",
    product_cover: "تعيين كصورة الغلاف",
    product_tags: "علامات",
    product_posted: "نشر:",
    product_change: "تعديل",
    product_post: "انشر المنتج",
    product_selling_from: "الموقع",
    product_select_location: "اختر الموقع",
    product_map_approximate: "الخريطة تقريبية للحفاظ على خصوصية البائع",
    product_terms:
      "من خلال النقر على انشر المنتج ، فإنك توافق على شروط خدمة ليستد نير مي",
    condition_other: "غير ذلك (انظر الوصف)",
    condition_for_parts: "قطع غيار",
    condition_used: "مستخدم",
    condition_open_box: "العلبة مفتوحة (لم يستخدم قط)",
    condition_reconditioned: "مجددة",
    condition_new: "جديد (لم يستخدم قط)",
    select_category: "اختر الفئة",
    select_all_category: "اختر الكل",
    category_loading_error:
      "لا يمكن تحديث قائمة الفئات ، يرجى المحاولة مرة أخرى لاحقًا.",
    category_vehicles: "السيارات",
    category_furniture: "مفروشات",
    category_electronics: "الالكترونيات",
    category_appliances: "الأجهزة المنزلية",
    category_fashion_accessories: "الأزياء والاكسسوارات",
    category_baby_kids: "مستلزمات الأطفال",
    category_antiques_collectibles: "التحف والمقتنيات",
    category_auto_parts_tools_machinery: "قطع غيار والأدوات والآلات",
    category_sports_outdoors: "مستلزمات رياضية",
    category_others: "متفرقات",
    location_enter_zip_code: "أدخل الرمز البريدي",
    location_get_current_location: "احصل على الموقع الحالي",
    location_select_location: "اختر الموقع",
    location_update_location: "تحديث الموقع",
    location_new_location: "موقع جديد",
    search_filter_results: "نتائج التصفية",
    search_filter_min: "تصفية الحد الأدنى",
    search_filter_at_least: "على الأقل",
    price_filter: "تصفية حسب السعر",
    product_name: "اسم المنتج",
    english_language: "الإنجليزية",
    arabic_language: "العربية",
    spanish_language: "الأسبانية",
    system_language: "لغة النظام الافتراضية",
    share_link: "مشاركة الرابط",
    save: "حفظ",
    cancel: "إلغاء",
    loading: "جار التحميل",
    yes: "نعم",
    no: "لا",
    report: "بلغ عن المنتج",
    report_product: "بلغ عن المنتج",
    report_user: "بلغ عن شخص",
    block_user: "احظر المستخدم",
    un_block_user: "إلغاء حظر المستخدم",
    why_product: "لماذا تريد الإبلاغ عن هذا المنتج؟",
    why_user: "لماذا تريد الإبلاغ عن هذا المستخدم؟",
    block_user_confirm: "هل تريد حظر هذا المستخدم بشكل دائم؟",
    un_block_user_confirm: "هل تريد إلغاء حظر هذا المستخدم بشكل دائم؟",
    prohibited: "ممنوع على تطبيق ليستد نير مي",
    offensive: "مسيء أو غير لائق",
    duplicate: "مشاركة مكررة",
    wrong_category: "فئة خاطئة",
    scam: "يبدو احتيال",
    stolen: "أعتقد أنها مسروقة",
    product_other: "سبب اخر",
    product_is_sold: "هذا المنتج تم بيعه",
    missed_meeting: "فاتهم اجتماعنا",
    low_offer: "قدم عرضا منخفضا",
    rude: "وقح أو غير مناسب",
    items: "مشكلة مع المنتجات",
    trouble_meetup: "صعوبة في اللقاء",
    messaging: "مشاكل المراسلة",
    user_other: "سبب اخر",
    new_version_available: "يتوفر إصدار جديد",
    please_update_app:
      "من فضلك ، قم بتحديث التطبيق إلى الإصدار الجديد للمتابعة.",
    update: "تحديث",
    no_thanks: "لا شكرا",
    contact_support_confirmation:
      "وقت الاستجابة الحالي هو 24-48 ساعة. هل تريد الاتصال بدعم دردشة تطبيق ليستد نير مي؟",
    unboost_confirmation: "هل أنت متأكد من أنك تريد إلغاء تعزيز هذا المنتج؟",
    no_used_products: "ليس لديك أي منتجات مستعملة مدرجة للبيع.",
    no_boosted_products: "ليس لديك أي منتجات مروجة",
    next: "التالي",
    previous: "السابق",
    skip: "تخطى",
    start: "أبدأ",
    list_used: "أدرج منتجًا مستخدمًا",
    buy_description: "اكتشف وابحث عن المنتجات التي يقدمها الجيران من حولك",
    sell_description: "أدرج المنتجات التي لم تعد بحاجة إليها للبيع",
    list_used_description: "قم بإدراج منتج مستعمل للبيع في أقل من 20 ثانية",
    boost_product_option_1: "<b>تعزيز 1\nيوم </b>\n\n<b>$0.99</b>",
    boost_product_option_2: "<b>تعزيز 3أيام </b>\n\n<b>$1.99</b>",
    boost_product_option_3: "<b>تعزيز 7\nأيام </b>\n\n<b>$3.99</b>",
    boost_product_description: "<strike>$0.99</strike>",
    boost_cta: "البيع بشكل أسرع",
    boost_terms:
      "بالنقر على التعزيز ، فإنك توافق على <u> بنود خدمة ليستد نير مي.",
    boost_best_value: "القيمة الأفضل",
    already_boosted: "تم تعزيز هذا المنتج",
    clicks: "نقرات",
    impressions: "الانطباعات",
    end: "النهاية",
    transactions_empty_text:
      "ليس لديك أي معاملات تعزيز حتى الآن. يمكنك زيارة قسم البيع والبدء في تعزيز منتجاتك.",
    transactions_loading_error:
      "لا يمكن تحديث قائمة المعاملات ، يرجى المحاولة مرة أخرى في وقت لاحق.",
    transactions_history_title: "سجل المعاملات",
    communicative_postive: "سريع التواصل",
    communicative_negative: "بطيء التواصل",
    ontime_postive: "في الوقت المحدد",
    ontime_negative: "متأخر",
    reliable_postive: "موثوق",
    reliable_negative: "غير موثوق",
    friendly_postive: "ودود",
    friendly_negative: "غير مهذب",
    itemasdescribed_postive: "المنتج كما هو موصوف",
    itemasdescribed_negative: "المنتج ليس كما هو موصوف",
    other: "آخر",
    submit: "إرسال",
    adding_rating_reviews: "إضافة التقييم والمراجعات",
    no_internet_title: "لا يوجد اتصال بالإنترنت",
    no_internet_message: "تأكد من الاتصال بالإنترنت وحاول مرة أخرى",
    retry: "أعد المحاولة",
    near_me: "بجانبي",
    newest_first: "الأحدث أولاً",
    miles: "اميال",
    km: "كم",
    similar_products: "المنتجات المشابهة",
    favorite_products: "المنتجات المفضلة",
    items_for_sale: "منتجات للبيع",
    joined: "انضم",
    favorites_transactions_title: "المفضّلة ",
    boosted_products_transactions_history: "سجل معاملات المنتجات المعززة",
    views: "المشاهدات",
    boost_graph_title: "مخطط التعزيزات",
    no_favorite_products: "ليس لديك أي منتجات مفضلة مدرجة",
    make_offer_buy: "أريد أن أشتري",
    make_offer_buy_for: "ب",
    notifications: "الإشعارات",
    push_notifications: "دفع الإشعارات",
    emails_notifications: "رسائل البريد الإلكتروني",
    apply: "تطبيق",
    email_messages: "بريد إلكتروني للرسائل",
    email_new_products: "البريد الإلكتروني للمنتجات الجديدة",
    push_day_only: "دفع الإشعارات اليوم فقط",
    push_24_hours: "دفع الإشعارات 24 ساعة",

    edit: "تعديل",
    map: "الخريطة",
    camera: "الكاميرا",
    gallery: "المعرض",
    delete: "حذف",
    no_sell_items: "لا يوجد منتجات للبيع",
    who_bought_question: "من اشترى هذا المنتج؟",
    sold_elsewhere_question: "تم بيع المنتج في مكان آخر",
    confirm: "تأكيد",
    over_limit_camera: "لا يمكنك إضافة أكثر من 5 صور",
    boost_failed: "فشل التعزيز. الرجاء معاودة المحاولة في وقت لاحق.",
    after_purchase: "تم الدفع بنجاح.\n تم تعزيز المنتج.",
    pay_failed: "عملية الدفع فشلت. حاول مرة اخرى",
    done: "تم",
    not_now: "ليس الآن",
    boost: "تعزيز المنتج",
    invalid_zip_code: "الرمز البريدي غير صالح",
    invalid_user_name: "اسم المستخدم غير صالح",
    comments: "تعليقات",
    questions: "أسئلة",
    bug_reports: "تقارير الأخطاء",
    feature_request: "طلب المواصفات",
    feedback_type: "نوع الانطباع",
    feedback_description:
      "We would love to hear your thoughts or feedback on how we can improve your experience!",
    feedback: "استجابة",
    feedback_text: "إجابتك",
    suggestions: "اقتراحات للتحسين",
    delete_account: "حذف الحساب",
    new_message: "رسالة جديدة",
    online: "متصل الآن",
    km_50: "50 كم",
    km_100: "100 كم",
    km_200: "200 كم",
    miles_30: "30 ميل",
    miles_60: "60 ميل",
    miles_120: "120 ميل",
    rate_app_question: "ماذا عن تصنيف على متجر التطبيقات ، إذن؟",
    enjoying_question: "هل استمتعت باستخدام التطبيق؟",
    not_enjoy: "لا",
    feedback_question: "هل تمانع في إعطائنا بعض الملاحظات؟",
    yes_sure: "حسنا بالطبع",
    product_available_question: "مرحبا، هل هذه مازال المنتج متوفر؟",
    buy_question: "مرحبًا ، أود شراء هذا المنتج",
    meet_question: "مرحبا هل يمكن ان نلتقي اليوم ؟",
    follow: "متابعة",
    followers: "المتابعون",
    following: "متابع لهم",
    feedback_thanks: "شكرا لملاحظاتك",
    all_categories: "جميع الفئات",
    deleted_account: "تم حذف هذا الحساب",
    delete_account_question: "هل أنت متأكد أنك تريد حذف هذا الحساب؟",
    no_followings: "لا يتابع أحد",
    when_following: "عندما",
    no_followings_subtitle: "يتابع الناس ، ستراهم هنا",
    no_followers: "ليس لديه متابعين",
    no_followers_subtitle: "يتابعه أحد، ستراه هنا",
    distance: "المسافة",
    filter_method: "طريقة الفلترة",
    see_listings: "انظر القوائم",
    sold: "مُباع",
    bought: "مُشترى",
    no_notifications: "لا توجد إشعارات",
    items_title: "عناصر",
    new_listing_title: "إنشاء قائمة جديدة",
    dialog_year_title: "السنة",
    dialog_make_title: "صنع",
    dialog_model_title: "قالب",
    dialog_body_style_title: "نمط الجسم",
    dialog_exterior_color_title: "اللون الخارجي",
    dialog_interior_color_title: "اللون الداخلي",
    dialog_transmission_title: "ناقل حركة",
    dialog_fuel_type_title: "نوع الوقود",
    dialog_owners_num_title: "عدد المالكين",
    dialog_vehicle_owed_money_title:
      "هل هناك أموال لا تزال مستحقة على هذه السيارة؟",
    automatic_transmission: "تلقائي",
    manual_transmission: "يدوي",
    not_sure: "لست متأكد",
    wagon_hatchback: "عربة وهاتشباك",
    convertible: "قابل للتحويل",
    coupe: "كوبيه",
    sedan: "سيدان",
    black_color: "أسود",
    blue_color: "أزرق",
    brown_color: "بني",
    gold_color: "ذهبي",
    green_color: "أخضر",
    grey_color: "رمادي",
    pink_color: "وردي",
    purple_color: "بنفسجي",
    red_color: "أحمر",
    silver_color: "فضي",
    orange_color: "برتقالي",
    white_color: "أبيض",
    yellow_color: "أصفر",
    charcol_color: "شاركول",
    fuel_diesel: "ديزل",
    fuel_electric: "كهربائي",
    fuel_gasoline: "الغازولين",
    fuel_flex: "مرن",
    fuel_hybrid: "هجين",
    fuel_petrol: "بنزين",
    fuel_plugin_hybrid: "هجين يعمل بالكهرباء",
    truck: "شاحنة نقل",
    van_minivan: "فان وميني فان",
    suv_crossover: "سيارات الدفع الرباعي وكروس أوفر",
    awd_4wd: "دفع رباعي / دفع رباعي",
    fwd: "دفع أمامي",
    rwd: "دفع خلفي",
    off_white_color: "أوف وايت",
    tan_color: "أسمر",
    beige_color: "بيج",
    burgundy_color: "بورجوندي",
    turquoise_color: "فيروزي",
    title_status_clean: "مظيف",
    title_status_rebuilt: "أعيد بناؤها",
    title_status_salvage: "استخلاص",
    title_status_missing: "مفقود",
    title_status_lien: "حجز",
    title_status: "الحالة",
    mileage: "عدد الأميال",
    dialog_drivetrain_title: "نظام الدفع",
    model_warning: "من فضلك حدد الصنع أولاً",
    required_field_warning: "هذا الحقل مطلوب",
    vehicle_vin: "رقم تعريف السيارة",
    invalid_vin:
      "رقم تعريف المركبة غير صحيح ، يرجى تعيين رقم تعريف السيارة مرة أخرى.",
    invalid_mileage: "الأميال غير صالحة ، يرجى تحديد الأميال مرة أخرى.",
    clean_description: "معظم المركبات التي لم تتعرض لحادث",
    rebuilt_description: "سيارة تم إنقاذها أعيد بناؤها",
    salvage_description: "تعتبر مجمعة بعد وقوع حادث",
    missing_description: "سوف تحتاج إلى عنوان إصدارات DMV جديد",
    lien_description: "مملوكة من قبل بنك أو تسوية قضائية",
    nearme: "قريبة",
    newest: "الأحدث",
    contact_support: "اتصل بالدعم",
    create_home_title: "منازل للبيع أو الإيجار",
    for_sale: "للبيع",
    for_rent: "للإيجار",
    property_type: "نوع الملكية",
    apartment: "شقة",
    house: "منزل",
    room_only: "غرفة فقط",
    townhouse: "تاون هاوس",
    bedrooms: "غرف نوم",
    bathrooms: "الحمامات",
    property_address: "عنوان العقار",
    price_per_month: "السعر بالشهر",
    square_feet: "قدم مكعب",
    year_built: "بنيت عام",
    year_renovated: "سنة التجديد",
    lot_size: "حجم كبير",
    laundry_type: "نوع الغسيل",
    in_unit_laundry: "الغسيل في الوحدة",
    laundry_building: "مغسلة في المبنى",
    laundry_available: "الغسيل متاح",
    none: "لا أحد",
    parking_type: "نوع وقوف السيارات",
    garage_parking: "مرآب للسيارات",
    street_parking: "وقوف السيارات في الشارع",
    off_street_parking: "وقوف السيارات خارج الشارع",
    available_parking: "وقوف السيارات المتاحة",
    air_cond_type: "نوع التكييف",
    ac_available: "تكييف متاح",
    central_ac: "تكييف مركزي",
    heating_type: "نوع التسخين",
    electric_heating: "تدفئة كهربائية",
    gas_heating: "تسخين الغاز",
    radiator_heating: "تدفئة المبرد",
    available_heating: "التدفئة المتاحة",
    amenities: "وسائل الراحة",
    date_available: "التاريخ المتوفر",
    lease_length: "طول عقد الإيجار",
    month_to_month: "من شهر إلى شهر",
    three_months: "3 اشهر",
    six_months: "6 اشهر",
    one_year: "سنة واحدة",
    more_one_year: "1+ سنة",
    cat_friendly: "القط ودية",
    dog_friendly: "يسمح باصطحاب الكلاب",
    balcony: "شرفة",
    basement: "قبو",
    bike_parking: "مواقف دراجات",
    cable_tv: "الكيبل التلفزيوني",
    ceiling_fan: "مروحة سقف",
    concierge: "خدمات الاستقبال والإرشاد",
    dishwasher: "غسالة صحون",
    doorman: "بواب",
    elevator: "مصعد",
    fireplace: "المدفأة",
    fitness_center: "مركز اللياقة البدنية",
    garbage_disposal: "التخلص من القمامة",
    microwave: "الميكروويف",
    online_app: "طلب عبر الإنترنت",
    oven: "فرن",
    package_service: "خدمة الحزمة",
    patio: "فناء",
    pet_park: "بيت بارك",
    refrigerator: "ثلاجة",
    resident_lounge: "صالة المقيم",
    roof_deck: "سطح السفينة",
    secured_entry: "دخول آمن",
    storage: "تخزين",
    walk_in_closet: "خزانة كبيرة",
    swimming_pool: "حمام السباحة",
    wheelchair_access: "مسموح الكرسي المتحركة",
    central_heating: "تدفئة مركزية",
    invalid_bedrooms: "غرف نوم غير صالحة ، يرجى ضبط غرف النوم مرة أخرى.",
    invalid_bathrooms: "الحمامات غير صالحة ، يرجى ضبط الحمامات مرة أخرى.",
    chinese_simplified_language: "الصينية المبسطة",
    chinese_traditional_language: "الصينية التقليدية",
    czech_language: "التشيكية",
    danish_language: "دانماركي",
    dutch_language: "الهولندية",
    finnish_language: "الفنلندية",
    french_language: "الفرنسية",
    german_language: "ألمانية",
    greek_language: "اليونانية",
    hungarian_language: "المجرية",
    indonesian_language: "الأندونيسية",
    italian_language: "إيطالي",
    japanese_language: "اليابانية",
    korean_language: "الكورية",
    norwegian_language: "النرويجية",
    polish_language: "البولندية",
    portuguese_language: "البرتغالية",
    portuguese_brazilian_language: "البرتغالية والبرازيلية",
    romanian_language: "روماني",
    russian_language: "الروسية",
    swedish_language: "السويدية",
    turkish_language: "التركية",
    ukrainian_language: "الأوكرانية",
    urdu_pakistan_language: "الأردية (باكستان)",
    vietnamese_language: "فيتنامي",
    category_home_sale_or_rent: "منزل للبيع أو الإيجار",
    square_meter: "متر مربع",
    copy_text: "ينسخ",
    copyied_to_clipboard: "نسخ إلى الحافظة",
    inbox: "صندوق الوارد",
    input_title_listening: "الاستماع ...",
    input_subtitle_listening: "قل شيئا",
    input_title_error: "آسف، لم نتحمل ذلك تماما.",
    input_subtitle_error: "حاول تكرار طلبك.",
    input_hint_error: "حاول مجددا",
    price_less_than_or_equal: "سعر أقل من أو يساوي",
    any_price: "اي سعر",
    any_condition: "أي حالة",
    any_time: "في أي وقت",
    days_ago: "أيام مضت",
    any_distance: "أي مسافة",
    distance_within: "المسافة داخل",
    new_notification: "إعلام جديد",
    deleted: "تم الحذف",
    processing_image: "معالجة الصورة",
    remove_dialog_message: "هل تريد حقا إزالة هذا المنتج؟",
    deleted_thread: "تم حذف هذه الرسالة",
    category_yard_sale_event: "حدث بيع الفناء",
    yard_first_date: "بيع الفناء التاريخ الأول",
    yard_second_date: "بيع الفناء التاريخ الثاني",
    yard_third_date: "بيع الفناء التاريخ الثالث",
    yard_start_time: "وقت البدء",
    yard_end_time: "وقت النهاية",
    yard_end_timestamp: "نهاية الطابع الزمني",
    invalid_date1: "التاريخ الأول غير صالح، يرجى تعيين التاريخ الأول مرة أخرى",
    invalid_start_time: "وقت البدء غير صالح، يرجى تعيين وقت البدء مرة أخرى",
    invalid_end_time: "وقت غير صالح، يرجى تعيين وقت النهاية مرة أخرى",
    yard_sale_title: "ساحة بيع",
    garage_tag: "كراج",
    yard_tag: "حديقة منزل",
    from: "من",
    to: "ل",
    block: "منع",
    un_block: "رفع الحظر",
    sign_email: "تسجيل الدخول مع البريد الإلكتروني",
    invalid_first_date:
      "التاريخ الأول غير صالح، يرجى التأكد من التاريخ الأول قبل الثانية والثالثة",
    invalid_second_date:
      "التاريخ الثاني غير صالح، يرجى التأكد من التاريخ الثاني هو قبل التاريخ الثالث",
    invalid_start_time_value:
      "وقت البدء غير صالح، يرجى التأكد من وقت البدء هو وقت انتهاء الوقت",
    use_default_yard_photo: "استخدام الصور الفوتوغرافية الافتراضي",
    active_label: "نشيط",
    enable_notifications: "تمكين الإشعارات",
    login: "تسجيل الدخول",
    january: "كانون الثاني",
    february: "شهر فبراير",
    march: "مارس",
    april: "أبريل",
    may: "قد",
    june: "يونيو",
    july: "تموز",
    august: "أغسطس",
    september: "شهر تسعة",
    october: "اكتوبر",
    november: "شهر نوفمبر",
    december: "ديسمبر",
    since: "حيث",
    product_views: "وجهات نظر المنتج",
    shop_views: "مشاهدات المتجر",
    total_sales: "إجمالي المبيعات",
    total_orders: "إجمالي الطلبات",
    last_twelvth_months: "آخر اثني عشر شهرا",
    last_nine_months: "آخر تسعة أشهر",
    last_six_months: "آخر ستة أشهر",
    last_three_months: "آخر ثلاثة أشهر",
    last_12_months: "آخر 12 شهرا",
    last_9_months: "آخر 9 أشهر",
    last_6_months: "آخر 6 أشهر",
    last_3_months: "آخر 3 أشهر",
    months: "شهور",
    open: "فتح",
    reset_password: "إعادة تعيين كلمة المرور",
    create_new_shop: "إنشاء متجر جديد",
    download_app: "تحميل التطبيق",
    log_in: "تسجيل الدخول",
    sign_up: "إنشاء حساب",
    no_result: "لا نتيجة",
    max_price: "السعر الأقصى",
    max_distance: "المسافة القصوى",
    max_time: "الزمن الأقصى",
    posted_less_than: "نشر أقل من",
    result: "نتيجة",
    more: "أكثر",
    or: "أو",
    password: "كلمة المرور",
    forgot_password: "هل نسيت كلمة السر؟",
    and: "و",
    download_for: "تحميل ل",
    apple_ios: "على الأبل",
    android: "على الأندرويد",
    image: "صورة",
    edit_image: "تعديل الصورة",
    please_complete: "من فضلك أكمل",
    enter_your_offer: "أدخل عرضك",
    categories: "التصنيفات",
    upload_image: "تحميل الصور",
    upload_images: "تحميل الصور",
    back: "عودة",
    see_more: "شاهد المزيد",
    add_product: "أضف منتج",
    selected: "المحدد",
    create: "إنشاء",
    rate_the_buyer: "قيم المشتري",
    delete_product: "حذف المنتج",
    product: "منتج",
    un_block_product: "إلغاء حظر المنتج",
    share_your_product: "مشاركة المنتج الخاص بك",
    boost_details: "تفاصيل التعزيز",
    remove_all_products: "إزالة جميع المنتجات",
    remove_all: "حذف الكل",
    add_vehicle: "إضافة مركبة",
    edit_vehicle: "تحرير السيارة",
    upload_a_photo: "حمل الصورة",
    view_details: "عرض التفاصيل",
    add_yard_sale: "إضافة ساحة بيع",
    edit_yard_sale: "تعديل ساحة البيع",
    users: "المستخدمين",
    users_details: "تفاصيل المستخدمين",
    users_by_country: "المستخدمين حسب البلد",
    blocked_users: "مستخدمين محجوبين",
    products_cards: "بطاقات المنتجات",
    archived_products: "المنتجات المؤرشفة",
    blocked_products: "المنتجات المحظورة",
    products_by_country: "المنتجات حسب الدولة",
    reports: "نقل",
    reports_details: "تفاصيل التقارير",
    closed_reports: "تقارير مغلقة",
    threads: "الخيوط",
    threads_details: "تفاصيل المواضيع",
    chat_support: "دعم الدردشة",
    actions: "أجراءات",
    search_actions: "إجراءات البحث",
    product_view_actions: "إجراءات عرض المنتج",
    contact_seller_product: "اتصل بمنتج البائع",
    contact_owner_shop: "اتصل بالمالك Shop.",
    ratings: "التقييمات",
    reviews: "تقييم",
    products_all_countries: "منتجات جميع البلدان",
    edit_profile: "تعديل الملف الشخصي",
    my_profile: "ملفي الشخصي",
    profile_updated_successfully: "تم تحديث الملف الشخصي بنجاح",
    are_you_sure: "هل أنت متأكد",
    my_used_products: "منتجاتي المستخدمة",
    my_shops: "متاجري",
    my_boosted_products: "بلدي المنتجات المعززة",
    messages_type_message_here: "اكتب رسالتك هنا",
    messages_product_sold: "تم بيع هذا المنتج أو إزالته",
    seen: "مرئي",
    messages_never_miss_message: "لا تفوت رسالة",
    send_notify: "إرسال إعلام",
    un_close: "فتح",
    type_your_review: "اكتب رأيك",
    again_question: "مرة أخرى",
    ratings_already_submitted_review: "لقد قمت مسبقا بالمراجعة",
    set_product_category: "تعيين فئة المنتج",
    auth_email_password_incorrect:
      "البريد الإلكتروني الخاص بك أو كلمة المرور غير صحيحة",
    auth_insert_your_name: "يرجى إدخال اسمك",
    auth_email_address_badly: "عنوان البريد الإلكتروني منسق بشكل سيء",
    auth_email_address_used:
      "عنوان البريد الإلكتروني قيد الاستخدام بالفعل بواسطة حساب آخر",
    auth_invalid_password: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    auth_reset_email:
      "أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور الخاصة بك",
    auth_check_email:
      "من فضلك، تحقق من بريدك الإلكتروني لإعادة تعيين كلمة المرور",
    auth_can_sign_in_google: "يمكنك تسجيل الدخول باستخدام زر جوجل",
    auth_do_not_have_account: "ليس لديك حساب؟",
    auth_have_account: "هل لديك حساب؟",
    log_terms_privacy_part1: "بالتسجيل أو تسجيل الدخول ، فإنك توافق على",
    boost_this_product: "تعزيز هذا المنتج؟",
    product_successfully_boosted: "تم تعزيز المنتج بنجاح",
    product_failed_boost: "فشل تعزيز المنتج",
    no_products_for_sale: "ليس لديك حاليا أي منتجات مستعملة مدرجة للبيع.",
    not_sold_listed_near_me: "أنا لم أبيعها في Listed Near Me",
    agree_add_product:
      "من خلال النقر على انشر المنتج ، فإنك توافق على شروط خدمة Listed Near Me.",
    click_to_boost: "انقر على المنتج لتعزيزه",
    listed_terms_of_service: "بنود خدمة Listed Near Me",
    receive_emails_for_users: "تلقي رسائل البريد الإلكتروني لرسائل المستخدمين",
    receive_emails_for_newly_posted:
      "تلقي رسائل البريد الإلكتروني لمنتجاتك المنشورة حديثا",
    disable_push_notifications: "تعطيل الإشعارات",
    sms_during_day: "تلقي الرسائل القصيرة خلال اليوم",
    sms_24_hours: "تلقي الرسائل القصيرة 24 ساعة",
    products: "منتجات",
    product_no_longer_available: "عذرا, هذا المنتج لم يعد متوفرا",
    add_home: "إضافة منزل",
    edit_home: "تعديل المنزل",
    fill_required_fields: "املأ جميع الحقول المطلوبة",
    no_notification: "لا توجد إشعارات",
    orders_history: "تاريخ الطلبات",
    privacy: "خصوصية",
    terms: "شروط",
    report_a_problem: "الإبلاغ عن مشكلة",
    approximation_protect_user_privacy: "تقريب لحماية خصوصية المستخدم",
    do_not_have_products: "ليس لديك منتجات",
    emails: "رسائل البريد الإلكتروني",
    lead_deletion_products: "سيؤدي ذلك إلى حذف جميع منتجاتك",
    confirm_legal_message:
      "أنت مسؤول فقط عن اتخاذ جميع الاحتياطات اللازمة عند التفاعل مع الآخرين، خاصة عند مقابلة شخص غريب في المرة الأولى. يرجى مراجعة شروط الخدمة لمزيد من التفاصيل.",
    push_notifications_notified_instantly:
      "تمكين إشعارات الدفع ليتم إعلامك على الفور",
    enable: "تفعيل",
    rate_seller: "قيّم البائع",
    user_journey: "رحلة المستخدم",
    user: "مستخدم",
    user_id: "معرف المستخدم",
    action_id: "معرف العمل",
    select_model_car: "حدد طراز السيارة",
    boost_1_day: "تعزيز 1 يوم",
    boost_3_days: "تعزيز 3 أيام",
    boost_7_days: "تعزيز 7 أيام",
    agree_boost_terms: "بالنقر على التعزيز ، فإنك توافق على ",
    add: "إضافة",
    add_tag: "إضافة علامة",
    brand_title: "ماركة",
    category_mobiles: "الهواتف المحمولة",
    category_tablets: "أجهزة لوحية",
    screen_size: "حجم الشاشة",
    has_cellular_capability: "لديه القدرة الخلوية",
    default_internal_memory: "الذاكرة الداخلية",
    network_carrier: "شبكة الناقل",
    is_unlocked: "غير مقفلة",
    mobile_model_warning: "يرجى اختيار العلامة التجارية أولا",
    missing_image: "صورة مفقودة، حاول إضافة صورة مرة أخرى.",
    add_mobile: "إضافة الموبايل",
    edit_mobile: "تحرير الموبايل",
    add_tablet: "إضافة الجهاز اللوحي",
    edit_tablet: "تحرير الجهاز اللوحي",
    keywords:
      "التسوق، شراء، بيع، عمل المال، التجارة، السكان المحليين، الجيران، السيارات، المركبات",
    country: "دولة",
    phone_number: "رقم الهاتف",
    verification_code: "رمز التأكيد",
    error_occurred: "لقد حدث خطأ، رجاء أعد المحاولة لاحقا",
    invalid_state:
      "حالة غير صالحة: تم استلام رد اتصال تسجيل الدخول، ولكن لم يتم إرسال طلب تسجيل الدخول.",
    sign_in: "تسجيل الدخول",
    sign_in_apple: "تسجيل الدخول باستخدام أبل",
    sign_in_google: "تسجيل الدخول باستخدام جوجل",
    sign_in_phone: "تسجيل الدخول باستخدام الهاتف",
    sign_in_facebook: "تسجيل الدخول باستخدام الفيسبوك",
    create_account: "انشئ حساب",
    email: "بريد الالكتروني",
    invalid_field: "يرجى تعبئة الحقول المطلوبة",
    code_sent: "تم إرسال الرمز بواسطة SMS",
    verify_number: "تحقق من رقم الهاتف",
    tapping_verify_number:
      "عن طريق النقر (تحقق من رقم الهاتف)، يتم إرسال الرسائل القصيرة.",
    email_exists:
      "يوجد الحساب بالفعل وتحتاج إلى الوصول إليه عبر زر Google أو زر Facebook أو زر Apple",
    ok: "موافق",
    sure_back: "هل أنت متأكد من العودة؟",
    terms_url: "https://listednearme.com/dynamicLinks/JTT6",
    privacy_url: "https://listednearme.com/dynamicLinks/QYkB",
    ago: "منذ",
    add_model: "إضافة نموذج",
    no_search_results_us:
      "لا توجد نتائج بحث بالقرب منك على بعد 120 ميلًا. حاول تغيير مرشح البحث أو البحث عن الكلمة الرئيسية.",
    no_search_results:
      "لا توجد نتائج بحث بالقرب منك على بعد 200 كم. حاول تغيير مرشح البحث أو البحث عن الكلمة الرئيسية.",
    plan_date: "تاريخ الخطة",
    plan_time: "تخطيط الوقت",
    invalid_plan_date: "تاريخ خطة غير صالح ، يرجى تعيين تاريخ الخطة مرة أخرى",
    invalid_plan_time: "وقت خطة غير صالح ، يرجى تعيين وقت الخطة مرة أخرى",
    plan_name: "اسم الخطة",
    plan_title: "يخطط",
    update_plan_name: "تحديث اسم خطة",
    delete_plan_question: "هل أنت متأكد من أنك تريد حذف هذه الخطة؟",
    plan_reminder_message: "سيتم تذكيرك قبل ساعة واحدة",
    plan_dialog_title: "خطة الاجتماع",
    planners_title: "المخططون",
    unable_sending_messages: "سيرون رسائلك عندما يعودون عبر الإنترنت.",
    its_text: "إنه",
    for_your_text: "لجهاز الاستقبال الخاص بك.",
  },
  esp: {
    invalid_area: "Área no válida, ajuste el área nuevamente.",
    invalid_lot_size:
      "Propiedad no válida Tamaño del lote, ajuste el tamaño del lote nuevamente.",
    property_area: "Área de propiedad",
    app_store_name:
      "Listado cerca de mí: compre artículos usados, venda en efectivo",
    app_store_short:
      "Un mercado para vendedores locales. Enumere un artículo para la venta y gane dinero.",
    app_store_full:
      "Listado cerca de mí hace que sea fácil encontrar grandes ofertas sobre las cosas que desea y ganar dinero con las cosas que desea vender. Esta es la mejor manera de comprar y vender en su comunidad o vecindario con personas en las que pueda confiar. Cómo funciona: 1- Compre o venda cualquier cosa; Publique fácilmente sus artículos para la venta en segundos. 2- Encuentre excelentes ofertas y descuentos en ropa, muebles, teléfonos celulares, productos electrónicos, artículos para bebés y niños, equipos deportivos, autos usados, vestidos, zapatos y relojes, libros, juguetes usados, computadoras portátiles usadas, un automóvil de segunda mano e incluso real. patrimonio en venta o alquiler. 3- Examine los artículos locales para la venta. 4- Compradores de mensajes y vendedores de la aplicación. 5- Examine los elementos por imagen y ordene por categoría. Datos curiosos sobre Listado cerca de mí: 1- Con la lista cercana a mí, puede vender fácilmente cualquier cosa, desde ropa hasta autos usados, electrónica. 2- La comunicación entre compradores y vendedores ocurre a través de la aplicación a través de mensajes. 3- Listado cerca de mí es mejor que una venta de garaje; Encuentre todo lo que desee con un descuento, justo en su teléfono o tableta.",
    app_store_release:
      "Listado cerca de mí: comercio con locales. ¡Únase al mercado móvil para compradores y vendedores locales!",
    app_name: "Listado cerca de mi",
    title_buy: "Comprar",
    title_messages: "Mensajes",
    title_sell: "Vender",
    title_profile_image: "Imagen de perfil",
    title_account: "Cuenta",
    account_settings: "Configuraciones de la cuenta",
    settings: "Ajustes",
    color_theme: "Tema de color",
    device_settings: "Configuración de dispositivo",
    public_profile: "Perfil público",
    light_mode: "Modo de luz",
    dark_mode: "Modo oscuro",
    title_sell_faster: "Vender más rápido",
    send_button_label: "Enviar",
    rate_message: "Calificándome ...",
    already_rated: "Ya envió una revisión",
    rate_review_question: "¿Te gustaría lidiar con",
    again: "¿otra vez?",
    action_logout: "Cerrar sesión",
    action_category: "Categoría",
    action_search: "Buscar",
    action_refer: "Recomendar un amigo",
    dialog_choose_location: "Elegir la ubicación",
    dialog_change_username: "Cambie el nombre de usuario",
    dialog_change_language: "Cambiar idioma",
    dialog_image_tags: "Etiquetas de imagen",
    dialog_emails_notifications: "Notificaciones de correos electrónicos",
    dialog_push_notifications: "Notificaciones push",
    fragment_product_detail: "Detalle del producto",
    fragment_message_details: "Detalles de mensajes",
    fragment_sell: "Vender",
    dialog_tags_title: "Etiquetas",
    dialog_location_title: "Ubicación de actualización",
    dialog_username_title: "Cambie el nombre de usuario",
    tab_photo: "Foto",
    tab_details: "Detalles",
    tab_price: "Precio",
    tab_finish: "Terminar",
    profile: "Perfil",
    search: "Buscar",
    choose_product: "Elija el producto",
    rating_review: "Calificación y revisión",
    select_buyer: "Seleccione un comprador",
    tab_my_used_products: "Mis productos",
    price_label: "Precio",
    text_savings: "Ahorras",
    search_hint: "Buscar productos ...",
    empty_text:
      "No hay productos enumerados en esta categoría o dentro de la distancia seleccionada.",
    filter_menu_text: "Filtrar",
    error_contacting_seller: "Error contactando al vendedor",
    edit_product: "Editar producto",
    contact_seller: "Contacte al vendedor",
    signup_to_contact_seller: "Regístrese para contactar al vendedor",
    signup_to_make_offer: "Regístrese para hacer la oferta",
    product_details: "Detalles",
    product_category: "Categoría",
    product_condition: "Condición",
    product_description: "Descripción",
    product_location: "Ubicación del producto",
    product_location_approximate: "La ubicación es aproximada",
    over_week_time_ago: "Hace más de una semana",
    boosted: "Impulsado",
    threads_no_results: "Ningún mensaje",
    message_no_results: "Ningún mensaje",
    message_warning:
      "Usted es el único responsable de tomar todas las precauciones necesarias al interactuar con los demás, particularmente cuando conoce a un extraño en persona por primera vez. No comparta ninguna información personal, códigos de verificación o ninguna información de pago. Revise los Términos de servicio para obtener más detalles.",
    message_block: "No puede enviar ni recibir mensajes en este momento.",
    select_location: "Seleccionar ubicación",
    location_permission_denied_message:
      "La aplicación requiere permiso de ubicación para funcionar correctamente.",
    signed_in: "¡Registrado!",
    sign_in_canceller: "Iniciar sesión cancelado",
    version: "Versión",
    build: "Construir",
    name: "Nombre",
    location: "Localización",
    language: "Idioma",
    about_app: "Acerca de la lista cerca de mí",
    terms_of_service: "Términos de servicio",
    privacy_policy: "Política de privacidad",
    report_feedback: "Enviar comentarios",
    report_bug: "Agite el teléfono para informar un error",
    change_image: "Cambiar imagen",
    update_location: "Ubicación de actualización",
    about_the_app: "Sobre la aplicación",
    update_label: "Actualizar",
    uploading: "Carga",
    adding: "Agregar listado",
    removing: "Eliminar listado",
    updating: "Listado de actualización",
    uploaded_image: "Imagen cargada:",
    image_storage_failed: "No se pudo almacenar la imagen:",
    product_updated: "Producto actualizado con éxito",
    location_error: "Ubicación no guardada, intente nuevamente",
    product_removed: "Producto eliminado con éxito",
    deleted_product: "Este producto se elimina",
    invalid_title: "Título no válido, configure el título nuevamente.",
    invalid_image:
      "Ruta de imagen no válida, intente agregar imagen nuevamente.",
    invalid_price: "Precio no válido, establezca el precio nuevamente.",
    invalid_location: "Ubicación no válida, configure la ubicación nuevamente.",
    invalid_category: "Categoría no válida, configure la categoría nuevamente.",
    invalid_condition:
      "Condición no válida, por favor configure la condición de nuevo.",
    removing_title: "Remover la imagen de perfil",
    image_not_saved: "¡Falló la imagen!",
    product_load_failed: "Sin productos",
    take_photo: "Tomar foto",
    select_photo: "Seleccione Foto",
    product_title_hint: "¿Qué es? Nombre, marca, modelo, etc.",
    delete_photo: "Borrar foto",
    product_title: "Título",
    mark_as_sold: "Marca como se vende",
    product_share: "Cuota",
    product_make_offer: "Hacer oferta",
    product_cover: "Establecer como imagen de cubierta",
    product_tags: "Etiquetas",
    product_posted: "Al corriente:",
    product_change: "Cambio",
    product_post: "Correo",
    product_selling_from: "Venta desde la ubicación",
    product_select_location: "Seleccione la ubicación",
    product_map_approximate:
      "El mapa es aproximado para mantener la ubicación del vendedor privada",
    product_terms:
      "Al tocar la publicación para publicar su producto, usted acepta <u> Listado cerca de mí Términos de servicio. </ U>",
    condition_other: "Otro (ver Descripción)",
    condition_for_parts: "Por partes",
    condition_used: "Utilizado (desgaste normal)",
    condition_open_box: "Caja abierta (nunca usado)",
    condition_reconditioned: "Reacondicionado / certificado",
    condition_new: "Nuevo (nunca usado)",
    select_category: "selecciona una categoría",
    select_all_category: "Seleccionar todo",
    category_loading_error:
      "No se puede actualizar la lista de categorías, inténtelo de nuevo más tarde.",
    category_vehicles: "Vehículos",
    category_furniture: "Muebles",
    category_electronics: "Electrónica",
    category_appliances: "Hogar y amplificador; Accesorios",
    category_fashion_accessories: "Moda y amplificador; Accesorios",
    category_baby_kids: "Bebé y  Niños",
    category_antiques_collectibles:
      "Antigüedades y amplificadores; Coleccionables",
    category_auto_parts_tools_machinery:
      "Piezas de automóviles, herramientas y amplificadores; Maquinaria",
    category_sports_outdoors: "Deportes y amplificadores; Al aire libre",
    category_others: "Otros",
    location_enter_zip_code: "Introduzca código postal",
    location_get_current_location: "Obtener ubicación actual",
    location_select_location: "Seleccione la ubicación",
    location_update_location: "Ubicación de actualización",
    location_new_location: "Nueva ubicacion",
    search_filter_results: "Filtrar Resultados",
    search_filter_min: "Filtro mínimo",
    search_filter_at_least: "Por lo menos",
    price_filter: "Filtro de precios",
    product_name: "nombre del producto",
    english_language: "inglés",
    arabic_language: "Arábica",
    spanish_language: "español",
    system_language: "Sistema",
    share_link: "Enlace compartir",
    save: "Ahorrar",
    cancel: "Cancelar",
    loading: "Cargando",
    yes: "sí",
    no: "No",
    report: "Reporte",
    report_product: "Producto de informe",
    report_user: "Reportar usuario",
    block_user: "Bloquear usuario",
    un_block_user: "Desbloquear usuario",
    why_product: "¿Por qué quieres reportar este artículo?",
    why_user: "¿Por qué quieres reportar a este usuario?",
    block_user_confirm: "¿Quieres bloquear permanentemente a este usuario?",
    un_block_user_confirm:
      "¿Quieres desbloquear permanentemente a este usuario?",
    prohibited: "Prohibido en la lista cerca de mí",
    offensive: "Ofensivo o inapropiado",
    duplicate: "Poste duplicado",
    wrong_category: "Categoría incorrecta",
    scam: "Parece una estafa",
    stolen: "Creo que es robado",
    product_other: "Otro",
    product_is_sold: "Este producto fue vendido.",
    missed_meeting: "Se perdieron nuestra reunión",
    low_offer: "Hizo una oferta baja",
    rude: "Grosero o inapropiado",
    items: "Problema con los artículos",
    trouble_meetup: "Problemas en la reunión",
    messaging: "Problemas de mensajería",
    user_other: "Otro",
    new_version_available: "Nueva versión disponible",
    please_update_app:
      "Por favor, actualice la aplicación a la nueva versión para continuar.",
    update: "Actualizar",
    no_thanks: "No, gracias",
    contact_support_confirmation:
      "El tiempo de respuesta actual es de 24 a 48 horas. ¿Quieres contactar en la lista cerca de ME App Chat Support?",
    unboost_confirmation:
      "¿Estás seguro de que desea desajustar este producto?",
    no_used_products: "No tienes ningún listado todavía",
    no_boosted_products: "No tienes ningún producto impulsado",
    next: "próximo",
    previous: "Anterior",
    skip: "Saltar",
    start: "Comienzo",
    list_used: "Listar un producto usado",
    buy_description:
      "Descubrir y buscar productos ofrecidos por vecinos a tu alrededor.",
    sell_description: "Listar productos que ya no necesita para la venta",
    list_used_description:
      "Listar un producto usado para la venta en menos de 20 segundos",
    boost_product_option_1: "<B> BOOST 1  Nday </ b>  n  n <b> $ 0.99 </ b>",
    boost_product_option_2: "<B> BOOST 3  Ndays </ B>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<B> BOOST 7  Ndays </ B>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "Obtenga más vistas cada día. Su artículo aparecerá en posiciones destacadas dentro de los 30 elementos principales en Comprar y Categoría. Los artículos promovidos se rotan entre los puntos designados para que cada artículo reciba una exposición justa.",
    boost_cta: "Vender más rápido",
    boost_terms:
      "Al tocar BOOST, usted acepta <U> enumerados cerca de mí Términos de servicio. </ U>",
    boost_best_value: "Mejor valor",
    already_boosted: "Este producto está impulsado.",
    clicks: "Clics",
    impressions: "Impresiones",
    end: "Fin",
    transactions_empty_text:
      "No tienes ninguna transacción de impulso todavía. Puede visitar la pestaña Vender y comenzar a impulsar sus productos.",
    transactions_loading_error:
      "No se puede actualizar la lista de transacciones, inténtelo de nuevo más tarde.",
    transactions_history_title: "Boost Historial de transacciones",
    communicative_postive: "Comunicativo",
    communicative_negative: "Poco comunicativo",
    ontime_postive: "A tiempo",
    ontime_negative: "Tarde",
    reliable_postive: "De confianza",
    reliable_negative: "No fidedigno",
    friendly_postive: "Simpático",
    friendly_negative: "Descortés",
    itemasdescribed_postive: "Artículo según lo descrito",
    itemasdescribed_negative: "El objeto no es como se describe",
    other: "Otro",
    submit: "Entregar",
    adding_rating_reviews: "Añadiendo calificación y revisiones",
    no_internet_title: "Sin conexión a Internet",
    no_internet_message:
      "Asegúrate de estar conectado a internet e intentarlo de nuevo.",
    retry: "Rever",
    near_me: "Cerca de mí",
    newest_first: "El más reciente primero",
    miles: "millas",
    km: "km",
    similar_products: "productos similares",
    favorite_products: "Productos favoritos",
    items_for_sale: "productos en venta",
    joined: "Unido",
    favorites_transactions_title: "Favoritos",
    boosted_products_transactions_history:
      "Historial de transacciones de productos impulsados",
    views: "Puntos de vista",
    boost_graph_title: "Gráfico de refuerzo",
    no_favorite_products: "No tienes ningún producto favorito.",
    make_offer_buy: "me gustaría comprar",
    make_offer_buy_for: "por",
    notifications: "Notificaciones",
    push_notifications: "Empujar",
    emails_notifications: "Correo electrónico",
    apply: "Solicitar",
    email_messages: "Correo electrónico para mensajes",
    email_new_products: "Correo electrónico para nuevos productos",
    push_day_only: "Empuje las notificaciones del día solamente",
    push_24_hours: "Notificaciones push 24 horas.",
    edit: "Editar",
    map: "Mapa",
    camera: "Cámara",
    gallery: "Galería",
    delete: "Borrar",
    no_sell_items: "No hay artículos en venta",
    who_bought_question: "¿Quién lo compró?",
    sold_elsewhere_question: "Lo vendió en otro lugar",
    confirm: "Confirmar",
    over_limit_camera: "No puedes agregar más de cinco imágenes.",
    boost_failed: "Boost falló. Por favor, inténtelo de nuevo más tarde",
    after_purchase: "Pago exitoso  Nproduct impulsado",
    pay_failed: "Pago fallido. Inténtalo de nuevo",
    done: "Hecho",
    not_now: "Ahora no",
    boost: "Aumentar",
    invalid_zip_code: "Código postal no válido",
    invalid_user_name: "Nombre de usuario no válido",
    comments: "Comentarios",
    questions: "Preguntas",
    bug_reports: "Informes de errores",
    feature_request: "Solicitud de función",
    feedback_type: "Tipo de Comentarios",
    feedback_description:
      "¡Nos encantaría escuchar sus pensamientos o comentarios sobre cómo podemos mejorar su experiencia!",
    feedback: "Reacción",
    feedback_text: "Tu respuesta",
    suggestions: "Sugerencias para mejorar",
    delete_account: "Borrar cuenta",
    new_message: "Nuevo mensaje",
    online: "En línea",
    km_50: "50 km",
    km_100: "100 km",
    km_200: "200 km",
    miles_30: "30 millas",
    miles_60: "60 millas",
    miles_120: "120 millas",
    rate_app_question:
      "¿Qué tal una calificación en la tienda de aplicaciones, entonces?",
    enjoying_question: "¿Disfrutando enumerados cerca de mí?",
    not_enjoy: "Realmente no",
    feedback_question: "¿Te importaría darnos algún comentario?",
    yes_sure: "Claro",
    product_available_question: "Hola, ¿esta todavía disponible?",
    buy_question: "Hola, me gustaría comprar esto",
    meet_question: "Hola, ¿puedes reunirte hoy?",
    follow: "Seguir",
    followers: "Seguidores",
    following: "Siguiente",
    feedback_thanks: "Gracias por sus comentarios",
    all_categories: "todas las categorias",
    deleted_account: "Esta cuenta es eliminada",
    delete_account_question:
      "¿Estás seguro de que quieres eliminar esta cuenta?",
    no_followings: "no sigue a nadie",
    when_following: "Cuándo",
    no_followings_subtitle: "Sigue a la gente, los verás aquí.",
    no_followers: "no tiene seguidores",
    no_followers_subtitle: "seguido de la gente, los verás aquí",
    distance: "Distancia",
    filter_method: "Método de filtro",
    see_listings: "Ver listados",
    sold: "Vendido",
    bought: "Comprado",
    no_notifications: "Cuando recibe notificaciones, aparecerán aquí.",
    items_title: "Elementos",
    new_listing_title: "Crear nuevo listado",
    dialog_year_title: "Año",
    dialog_make_title: "Fabricar",
    dialog_model_title: "Modelo",
    dialog_body_style_title: "Tipo de cuerpo",
    dialog_exterior_color_title: "Color exterior",
    dialog_interior_color_title: "color interior",
    dialog_transmission_title: "Transmisión",
    dialog_fuel_type_title: "Tipo de combustible",
    dialog_owners_num_title: "Número de propietarios",
    dialog_vehicle_owed_money_title:
      "¿Hay dinero todavía adeudado en este vehículo?",
    automatic_transmission: "Automático",
    manual_transmission: "Manual",
    not_sure: "No estoy seguro",
    wagon_hatchback: "Vagón y  Hatchback",
    convertible: "Convertible",
    coupe: "Cupé",
    sedan: "Sedán",
    black_color: "Negro",
    blue_color: "Azul",
    brown_color: "marrón",
    gold_color: "Oro",
    green_color: "Verde",
    grey_color: "Gris",
    pink_color: "Rosa",
    purple_color: "Púrpura",
    red_color: "rojo",
    silver_color: "Plata",
    orange_color: "naranja",
    white_color: "blanco",
    yellow_color: "Amarillo",
    charcol_color: "Carro",
    fuel_diesel: "Diesel",
    fuel_electric: "Eléctrico",
    fuel_gasoline: "Gasolina",
    fuel_flex: "Flexionar",
    fuel_hybrid: "Híbrido",
    fuel_petrol: "Gasolina",
    fuel_plugin_hybrid: "Híbrido enchufable",
    truck: "Camión",
    van_minivan: "Van &  Minivan",
    suv_crossover: "SUV &  Transversal",
    awd_4wd: "AWD / 4WD",
    fwd: "Fwd",
    rwd: "Rwd",
    off_white_color: "Blanquecino",
    tan_color: "Broncearse",
    beige_color: "Beige",
    burgundy_color: "borgoña",
    turquoise_color: "Turquesa",
    title_status_clean: "Limpio",
    title_status_rebuilt: "Reconstruido",
    title_status_salvage: "Salvar",
    title_status_missing: "Desaparecido",
    title_status_lien: "Derecho de retención",
    title_status: "Estado del título",
    mileage: "Kilometraje",
    dialog_drivetrain_title: "Transmisión",
    model_warning: "Por favor seleccione hacer primero",
    required_field_warning: "Este campo es obligatorio",
    vehicle_vin: "Vin",
    invalid_vin: "Vin no válido, por favor, establezca VIN nuevamente.",
    invalid_mileage:
      "Kilometraje inválido, por favor, configure el kilometraje nuevamente.",
    clean_description:
      "La mayoría de los vehículos que no han estado en un accidente.",
    rebuilt_description: "Un auto salvado que ha sido reconstruido.",
    salvage_description: "Se considera totalizado después de un accidente.",
    missing_description: "Necesitará un nuevo título de problemas de DMV",
    lien_description: "Propiedad de un banco o liquidación judicial",
    nearme: "Cerca de mí",
    newest: "El más nuevo",
    contact_support: "Soporte de contacto",
    create_home_title: "Casas en venta o alquiler",
    for_sale: "En venta",
    for_rent: "En renta",
    property_type: "Tipo de propiedad",
    apartment: "Departamento",
    house: "casa",
    room_only: "Solo habitación",
    townhouse: "Casa adosada",
    bedrooms: "Dormitorios",
    bathrooms: "Baños",
    property_address: "Dirección de Propiedad",
    price_per_month: "Precio por mes",
    square_feet: "Pies cuadrados",
    year_built: "Año de construcción",
    year_renovated: "Año renovado",
    lot_size: "Tamaño del lote",
    laundry_type: "Tipo de lavandería",
    in_unit_laundry: "Lavandería en la unidad",
    laundry_building: "Lavandería en edificio",
    laundry_available: "Lavandería disponible",
    none: "Ninguna",
    parking_type: "Tipo de estacionamiento",
    garage_parking: "Estacionamiento de garaje",
    street_parking: "Estacionamiento de la calle",
    off_street_parking: "Aparcamiento en la calle",
    available_parking: "Estacionamiento disponible",
    air_cond_type: "Tipo de aire acondicionado",
    ac_available: "AC disponible",
    central_ac: "AC central",
    heating_type: "Tipo de calefacción",
    electric_heating: "Calefacción eléctrica",
    gas_heating: "Calefacción de gas",
    radiator_heating: "Calefacción de radiador",
    available_heating: "Calefacción disponible",
    amenities: "Comodidades",
    date_available: "Fecha disponible",
    lease_length: "Longitud de arrendamiento",
    month_to_month: "Mes a mes",
    three_months: "3 meses",
    six_months: "6 meses",
    one_year: "1 año",
    more_one_year: "1+ años",
    cat_friendly: "Amistoso gato",
    dog_friendly: "Amistoso para perros",
    balcony: "Balcón",
    basement: "Sótano",
    bike_parking: "Estacionamiento para bicicletas",
    cable_tv: "Televisión por cable",
    ceiling_fan: "Ventilador de techo",
    concierge: "Conserje",
    dishwasher: "Lavavajillas",
    doorman: "Portero",
    elevator: "Ascensor",
    fireplace: "Hogar",
    fitness_center: "Gimnasio",
    garbage_disposal: "Basurero",
    microwave: "Microonda",
    online_app: "Aplicaciones en linea",
    oven: "Horno",
    package_service: "Servicio de paquetes",
    patio: "Patio",
    pet_park: "Parque de mascotas",
    refrigerator: "Refrigerador",
    resident_lounge: "Salón residente",
    roof_deck: "Cubierta de la azotea",
    secured_entry: "Entrada asegurada",
    storage: "Almacenamiento",
    walk_in_closet: "Vestidor",
    swimming_pool: "Alberca",
    wheelchair_access: "Acceso en silla de ruedas",
    central_heating: "Calefacción central",
    invalid_bedrooms:
      "Dormitorios no válidos, por favor, configure habitaciones nuevamente.",
    invalid_bathrooms:
      "Baños no válidos, por favor, configure los baños de nuevo.",
    chinese_simplified_language: "Chino simplificado",
    chinese_traditional_language: "Chino tradicional",
    czech_language: "checo",
    danish_language: "danés",
    dutch_language: "holandés",
    finnish_language: "finlandés",
    french_language: "francés",
    german_language: "alemán",
    greek_language: "griego",
    hungarian_language: "húngaro",
    indonesian_language: "indonesio",
    italian_language: "italiano",
    japanese_language: "japonés",
    korean_language: "coreano",
    norwegian_language: "noruego",
    polish_language: "polaco",
    portuguese_language: "portugués",
    portuguese_brazilian_language: "Portugués, brasileño",
    romanian_language: "rumano",
    russian_language: "ruso",
    swedish_language: "sueco",
    turkish_language: "turco",
    ukrainian_language: "ucranio",
    urdu_pakistan_language: "Urdu (Pakistán)",
    vietnamese_language: "vietnamita",
    category_home_sale_or_rent: "Casa en venta o alquiler",
    square_meter: "Metro cuadrado",
    copy_text: "Dupdo",
    copyied_to_clipboard: "Copiado al portapapeles",
    inbox: "Bandeja de entrada",
    input_title_listening: "Escuchando…",
    input_subtitle_listening: "Di algo",
    input_title_error: "Lo siento, no logramos eso.",
    input_subtitle_error: "Intenta repetir tu solicitud.",
    input_hint_error: "Intentar otra vez",
    price_less_than_or_equal: "Precio menos o igual a",
    any_price: "Cualquier precio",
    any_condition: "Cualquier condición",
    any_time: "Cualquier momento",
    days_ago: "hace días",
    any_distance: "Cualquier distancia",
    distance_within: "Distancia dentro de",
    new_notification: "Nueva notificación",
    deleted: "Borrado",
    processing_image: "Imagen de procesamiento",
    remove_dialog_message: "¿De verdad quieres eliminar este producto?",
    deleted_thread: "Este mensaje es eliminado",
    category_yard_sale_event: "Evento de venta de patio",
    yard_first_date: "Venta de patio primera cita",
    yard_second_date: "Venta de patio segunda cita",
    yard_third_date: "Venta de patio Tercera cita",
    yard_start_time: "Hora de inicio",
    yard_end_time: "Hora de finalización",
    yard_end_timestamp: "Timestamp final",
    invalid_date1:
      "Primera fecha no válida, por favor configure la primera fecha de nuevo",
    invalid_start_time:
      "Tiempo de inicio no válido, por favor configure la hora de inicio de nuevo",
    invalid_end_time:
      "Tiempo final no válido, por favor configure la hora del final de nuevo",
    yard_sale_title: "Venta de garaje",
    garage_tag: "garaje",
    yard_tag: "yarda",
    from: "Desde",
    to: "A",
    block: "Cuadra",
    un_block: "Desatascar",
    sign_email: "Inicia sesión con el correo electrónico",
    invalid_first_date:
      "Primera fecha inválida, asegúrese de que la primera cita sea antes de la segunda y la tercera",
    invalid_second_date:
      "Segunda fecha no válida, asegúrese de que la segunda fecha sea antes de la tercera fecha",
    invalid_start_time_value:
      "Tiempo de inicio no válido, asegúrese de que la hora de inicio sea antes de la hora del final",
    use_default_yard_photo: "Use la venta de venta de patio predeterminada",
    active_label: "Activo",
    enable_notifications: "Permitir notificaciones",
    login: "Acceso",
    january: "enero",
    february: "febrero",
    march: "marcha",
    april: "abril",
    may: "Mayo",
    june: "junio",
    july: "mes de julio",
    august: "agosto",
    september: "septiembre",
    october: "octubre",
    november: "noviembre",
    december: "diciembre",
    since: "Ya que",
    product_views: "Vistas del producto",
    shop_views: "Vistas de la tienda",
    total_sales: "Ventas totales",
    total_orders: "Órdenes totales",
    last_twelvth_months: "Último doce meses",
    last_nine_months: "Últimos nueve meses",
    last_six_months: "Últimos seis meses",
    last_three_months: "Últimos tres meses",
    last_12_months: "Últimos 12 meses",
    last_9_months: "Últimos 9 meses",
    last_6_months: "Últimos 6 meses",
    last_3_months: "Últimos 3 meses",
    months: "Meses",
    reset_password: "Restablecer la contraseña",
    create_new_shop: "Crear nueva tienda",
    download_app: "Descargar aplicación",
    log_in: "Iniciar sesión",
    sign_up: "Inscribirse",
    no_result: "Sin resultados",
    max_price: "Precio máximo",
    max_distance: "distancia maxima",
    max_time: "Tiempo máximo",
    posted_less_than: "Publicado menos de",
    result: "Resultado",
    more: "Más",
    or: "O",
    password: "Contraseña",
    forgot_password: "¿Se te olvidó tu contraseña?",
    and: "y",
    download_for: "Descargar para",
    apple_ios: "Apple iOS",
    android: "Androide",
    image: "Imagen",
    edit_image: "Editar imagen",
    please_complete: "Por favor complete",
    enter_your_offer: "Ingrese su oferta",
    categories: "Categorías",
    upload_image: "Cargar imagen",
    upload_images: "Sube imágenes",
    back: "atrás",
    see_more: "Ver más",
    add_product: "Agregar producto",
    selected: "Seleccionado",
    create: "Crear",
    rate_the_buyer: "Calificar el comprador",
    delete_product: "Eliminar producto",
    product: "Producto",
    un_block_product: "Producto desbloquear",
    share_your_product: "Comparte tu producto",
    boost_details: "Boost Detalles",
    remove_all_products: "Eliminar todos los productos",
    remove_all: "Eliminar todo",
    add_vehicle: "Añadir vehículo",
    edit_vehicle: "Editar vehículo",
    upload_a_photo: "Sube una foto",
    view_details: "Ver detalles",
    add_yard_sale: "Añadir venta de patio",
    edit_yard_sale: "Editar venta de patio",
    users: "Usuarios",
    users_details: "Detalles de los usuarios",
    users_by_country: "Usuarios por país",
    blocked_users: "Usuarios bloqueados",
    products_cards: "Tarjetas de productos",
    archived_products: "Productos archivados",
    blocked_products: "Productos bloqueados",
    products_by_country: "Productos por país",
    reports: "Reporte",
    reports_details: "Informes Detalles",
    closed_reports: "Informes cerrados",
    threads: "Hilos",
    threads_details: "Detalles de los hilos",
    chat_support: "Soporte de chat",
    actions: "Comportamiento",
    search_actions: "Acciones de búsqueda",
    product_view_actions: "Producto Ver acciones",
    contact_seller_product: "Contactar el producto del vendedor",
    contact_owner_shop: "Póngase en contacto con la tienda del propietario",
    ratings: "Calificaciones",
    reviews: "Comentarios",
    products_all_countries: "Productos Todos los países",
    edit_profile: "Editar perfil",
    my_profile: "Mi perfil",
    profile_updated_successfully: "perfil actualizado con éxito",
    are_you_sure: "Está seguro",
    my_used_products: "Mis productos usados",
    my_shops: "Mis tiendas",
    my_boosted_products: "Mis productos impulsados",
    messages_type_message_here: "Escribe tu mensaje aquí",
    messages_product_sold: "Este producto es vendido o eliminado.",
    seen: "Visto",
    messages_never_miss_message: "Nunca te pierdas un mensaje",
    enable: "Permitir",
    send_notify: "Enviar notificar",
    un_close: "No cerrar",
    type_your_review: "Escriba su reseña",
    again_question: "de nuevo ?",
    ratings_already_submitted_review: "Ya has enviado revisión",
    open: "Abierto",
    set_product_category: "Establecer categoría de producto",
    auth_email_password_incorrect:
      "Su correo electrónico o contraseña incorrecta",
    auth_insert_your_name: "Por favor, inserte su nombre",
    auth_email_address_badly:
      "La dirección de correo electrónico está muy formateada.",
    auth_email_address_used:
      "La dirección de correo electrónico ya está en uso por otra cuenta",
    auth_invalid_password: "La contraseña debe tener al menos 6 caracteres.",
    auth_reset_email:
      "Ingrese su correo electrónico para restablecer su contraseña",
    auth_check_email:
      "Por favor, revise su correo electrónico para restablecer la contraseña",
    auth_can_sign_in_google: "Puedes iniciar sesión con el botón de Google",
    auth_do_not_have_account: "¿No tienes una cuenta?",
    auth_have_account: "¿Tiene usted una cuenta?",
    log_terms_privacy_part1:
      "Al registrarse o iniciar sesión, usted acepta la lista cerca de mí",
    boost_this_product: "BOOST ESTE PRODUCTO?",
    product_successfully_boosted: "El producto ha sido impulsado con éxito.",
    product_failed_boost: "El producto ha sido fallado en Boost.",
    no_products_for_sale:
      "Actualmente no tiene ningún producto usado enumerado para la venta.",
    not_sold_listed_near_me: "No lo vendí en la lista cerca de mí",
    agree_add_product:
      "Al tocar la publicación para publicar su producto, usted acepta los Términos de Servicio y Política de privacidad cerca de mí.",
    click_to_boost: "Haga clic en el producto para impulsarlo.",
    listed_terms_of_service: "Enumerado cerca de mí Términos de servicio",
    receive_emails_for_users:
      "Recibe correos electrónicos para los mensajes de los usuarios.",
    receive_emails_for_newly_posted:
      "Recibe correos electrónicos para sus productos recién publicados.",
    disable_push_notifications: "Deshabilitar notificaciones push",
    sms_during_day: "Recibir SMS durante el día",
    sms_24_hours: "Recibir SMS 24 horas",
    products: "Productos",
    product_no_longer_available:
      "Lo sentimos, este producto ya no está disponible",
    add_home: "Añadir a casa",
    edit_home: "Casa de edición",
    fill_required_fields: "Llene todos los campos requeridos",
    no_notification: "No hay notificaciones.",
    orders_history: "Historia de los pedidos",
    privacy: "Intimidad",
    terms: "Condiciones",
    report_a_problem: "Reportar un problema",
    approximation_protect_user_privacy:
      "Aproximación para proteger la privacidad del usuario.",
    do_not_have_products: "No tienes productos",
    emails: "Correos electrónicos",
    lead_deletion_products:
      "Esto llevará a la eliminación de todos sus productos.",
    confirm_legal_message:
      "Usted es el único responsable de tomar todas las precauciones necesarias cuando interactúe con otros, especialmente al conocer a un extraño en persona por primera vez. Por favor revise los Términos de servicio para obtener más detalles.",
    push_notifications_notified_instantly:
      "Habilitar notificaciones push para ser notificadas instantáneamente",
    rate_seller: "Vendedor de velocidad",
    user_journey: "Viaje de usuario",
    user: "Usuario",
    user_id: "ID de usuario",
    action_id: "ID de acción",
    select_model_car: "Seleccionar modelo de coche",
    boost_1_day: "BOOST 1 día",
    boost_3_days: "BOOST 3 DÍAS",
    boost_7_days: "BOOST 7 DÍAS",
    agree_boost_terms: "Al tocar el impulso, usted acepta",
    add: "Agregar",
    add_tag: "Añadir etiqueta",
    brand_title: "Marca",
    category_mobiles: "Mobiles",
    category_tablets: "Tabletas",
    screen_size: "Tamaño de pantalla",
    has_cellular_capability: "Tiene capacidad celular",
    default_internal_memory: "Memoria interna",
    network_carrier: "Portador de red",
    is_unlocked: "Está desbloqueado",
    mobile_model_warning: "Por favor seleccione la marca primero",
    missing_image: "Falta imagen, intente agregar imagen de nuevo.",
    add_mobile: "Añadir móvil",
    edit_mobile: "Editar móvil",
    add_tablet: "Añadir tableta",
    edit_tablet: "Editar tableta",
    keywords:
      "Compras, comprar, vender, ganar dinero, comercio, lugareños, vecinos, automóviles, vehículos",
    country: "País",
    phone_number: "Número de teléfono",
    verification_code: "Código de verificación",
    error_occurred: "Se produjo un error, inténtalo de nuevo más tarde",
    invalid_state:
      "Estado no válido: se recibió una devolución de llamada de inicio de sesión, pero no se envió una solicitud de inicio de sesión.",
    sign_in: "Registrarse",
    sign_in_apple: "Inicia sesión con Apple",
    sign_in_google: "Inicia sesión con Google",
    sign_in_phone: "Inicia sesión con el teléfono",
    sign_in_facebook: "Iniciar sesión usando Facebook",
    create_account: "Crea una cuenta",
    email: "Correo electrónico",
    invalid_field: "Por favor llene los campos requeridos",
    code_sent: "El código ha sido enviado por SMS.",
    verify_number: "Verificar el número de teléfono",
    tapping_verify_number:
      "Al tocar (verificar el número de teléfono), se envíe un SMS.",
    email_exists:
      "La cuenta ya existe y debe acceder a ella a través del botón de Google, el botón de Facebook o el botón de Apple",
    ok: "De acuerdo",
    sure_back: "¿Estás seguro de que?",
    terms_url: "https://bingodeal.page.link/tqgE",
    privacy_url: "https://bingodeal.page.link/QL6B",
    ago: "atrás",
    add_model: "Modelo",
    no_search_results_us:
      "No hay resultados de búsqueda cerca de usted en 120 millas. Intente cambiar el filtro de búsqueda o la palabra clave de búsqueda.",
    no_search_results:
      "No hay resultados de búsqueda cerca de usted dentro de 200 km. Intente cambiar el filtro de búsqueda o la palabra clave de búsqueda.",
    plan_date: "Fecha de plan",
    plan_time: "Tiempo de planificación",
    invalid_plan_date:
      "Fecha de plan no válida, establezca la fecha del plan nuevamente",
    invalid_plan_time:
      "Tiempo de plan no válido, establezca la hora del plan nuevamente",
    plan_name: "Nombre del plan",
    plan_title: "Plan",
    update_plan_name: "Nombre del plan de actualización",
    delete_plan_question: "¿Estás seguro de que quieres eliminar este plan?",
    plan_reminder_message: "Se le recordarán una hora antes",
    plan_dialog_title: "Plan de reunión",
    planners_title: "Planificadores",
    unable_sending_messages:
      "Verán sus mensajes cuando vuelvan a estar en línea.",
    its_text: "Es",
    for_your_text: "para tu receptor.",
  },
  "zh-CN": {
    invalid_area: "无效区域，请再次设置区域。",
    invalid_lot_size: "无效的属性批量大小，请再次设置批次大小。",
    property_area: "财产区",
    app_store_name: "在我附近列出 - 购买二手物品，出售现金",
    app_store_short: "当地卖家的市场。列出待售物品并赚钱。",
    app_store_full:
      "在我附近上市使您可以轻松找到您想要的东西，并在您想要销售的东西上赚钱。这是您可以信任的人们在社区或社区购买和销售的最佳方式。它是如何运作的：1-买或卖任何东西;轻松发布您的物品以单位出售。 2-在衣服，家具，手机，电子，婴儿和儿童物品，运动器材，二手车，连衣裙，鞋子和手表上找到大量优惠和折扣，用于书籍，二手玩具，使用的笔记本电脑，二手车甚至是真实的销售或租金。 3-浏览本地物品出售。 4-消息从应用程序中的购买者和卖家。 5-按图像浏览物品，按类别排序。关于我附近的有趣事实：1-与我附近的列出，您可以轻松销售任何东西，从衣服到使用汽车到电子产品。 2-买家与卖家之间的通信通过应用程序通过消息传递。 3-我附近列出比车库销售更好;在您的手机或平板电脑上找到任何您想要的折扣。",
    app_store_release:
      "在我附近列出 - 与当地人交易。加入当地买家和卖家的移动市场！",
    app_name: "在我附近上市",
    title_buy: "买",
    title_messages: "消息",
    title_sell: "卖",
    title_profile_image: "轮廓图像",
    title_account: "帐户",
    account_settings: "帐号设定",
    settings: "设置",
    color_theme: "颜色主题",
    device_settings: "设备设置",
    public_profile: "公共简介",
    light_mode: "光模式",
    dark_mode: "黑暗模式",
    title_sell_faster: "卖得更快",
    send_button_label: "发送",
    rate_message: "评价我......",
    already_rated: "您已经提交了审核",
    rate_review_question: "你想处理吗？",
    again: "再次？",
    action_logout: "登出",
    action_category: "类别",
    action_search: "搜索",
    action_refer: "介绍个朋友",
    dialog_choose_location: "选择地点",
    dialog_change_username: "更改用户名",
    dialog_change_language: "改变语言",
    dialog_image_tags: "图像标签",
    dialog_emails_notifications: "电子邮件通知",
    dialog_push_notifications: "推送通知",
    fragment_product_detail: "产品信息",
    fragment_message_details: "消息详情",
    fragment_sell: "卖",
    dialog_tags_title: "标签",
    dialog_location_title: "更新位置",
    dialog_username_title: "更改用户名",
    tab_photo: "照片",
    tab_details: "细节",
    tab_price: "价格",
    tab_finish: "结束",
    profile: "轮廓",
    search: "搜索",
    choose_product: "选择产品",
    rating_review: "评级和评估",
    select_buyer: "选择买方",
    tab_my_used_products: "我的产品",
    price_label: "价格",
    text_savings: "您保存",
    search_hint: "搜索产品......",
    empty_text: "此类别中没有任何产品或在所选距离内。",
    filter_menu_text: "筛选",
    error_contacting_seller: "联系卖家错误",
    edit_product: "编辑产品",
    contact_seller: "联络卖家",
    signup_to_contact_seller: "注册联系卖家",
    signup_to_make_offer: "注册以提供",
    product_details: "细节",
    product_category: "类别",
    product_condition: "状况",
    product_description: "描述",
    product_location: "产品位置",
    product_location_approximate: "位置是近似的",
    over_week_time_ago: "一周前",
    boosted: "提升",
    threads_no_results: "没有消息",
    message_no_results: "没有消息",
    message_warning:
      "与他人互动时，您将负责采取所有必要的预防措施，尤其是在第一次见面陌生人时。请不要共享任何个人信息，验证代码或任何付款信息。请查看服务条款以获取更多详细信息。",
    message_block: "您此时无法发送或接收消息。",
    select_location: "选择位置",
    location_permission_denied_message: "该应用程序需要正确的允许正常工作。",
    signed_in: "登录！",
    sign_in_canceller: "登录取消",
    version: "版本",
    build: "建造",
    name: "名称",
    location: "地点",
    language: "语",
    about_app: "关于我附近的",
    terms_of_service: "服务条款",
    privacy_policy: "隐私政策",
    report_feedback: "发送反馈",
    report_bug: "握手报告一个错误",
    change_image: "改变图像",
    update_location: "更新位置",
    about_the_app: "关于这个应用程序",
    update_label: "更新",
    uploading: "上传",
    adding: "添加清单",
    removing: "删除上市",
    updating: "更新清单",
    uploaded_image: "上传图像：",
    image_storage_failed: "无法存储图像：",
    product_updated: "产品成功更新",
    location_error: "位置未保存，请再试一次",
    product_removed: "产品成功删除",
    deleted_product: "此产品已删除",
    invalid_title: "无效标题，请再次设置标题。",
    invalid_image: "无效的图像路径，尝试再次添加图像。",
    invalid_price: "价格无效，请再次设置价格。",
    invalid_location: "位置无效，请再次设置位置。",
    invalid_category: "无效类别，请再次设置类别。",
    invalid_condition: "条件无效，请再次设置条件。",
    removing_title: "删除档案映像",
    image_not_saved: "图像保存失败！",
    product_load_failed: "没有产品",
    take_photo: "拍照",
    select_photo: "选择照片",
    product_title_hint: "它是什么？名称，品牌，模型等",
    delete_photo: "删除照片",
    product_title: "标题",
    mark_as_sold: "标记售出",
    product_share: "分享",
    product_make_offer: "提供",
    product_cover: "设置为封面图像",
    product_tags: "标签",
    product_posted: "发布：",
    product_change: "改变",
    product_post: "邮政",
    product_selling_from: "从地点出售",
    product_select_location: "选择位置",
    product_map_approximate: "Map致致允许卖家的位置私密",
    product_terms:
      "通过轻拍帖子发布您的产品，您同意<U>在我附近的服务条款附近。</ U>",
    condition_other: "其他（参见描述）",
    condition_for_parts: "适用于零件",
    condition_used: "使用（正常磨损）",
    condition_open_box: "打开盒子（从未使用过）",
    condition_reconditioned: "重新处理/认证",
    condition_new: "新（从未使用过）",
    select_category: "选择类别",
    select_all_category: "全选",
    category_loading_error: "无法更新类别列表，请稍后再试。",
    category_vehicles: "车辆",
    category_furniture: "家具",
    category_electronics: "电子产品",
    category_appliances: "家庭＆电器",
    category_fashion_accessories: "时尚＆配件",
    category_baby_kids: "宝贝＆孩子们",
    category_antiques_collectibles: "古董＆收藏品",
    category_auto_parts_tools_machinery: "汽车零件，工具＆机械",
    category_sports_outdoors: "运动＆户外",
    category_others: "其他",
    location_enter_zip_code: "输入邮政编号",
    location_get_current_location: "获取当前位置",
    location_select_location: "选择位置",
    location_update_location: "更新位置",
    location_new_location: "新的位置",
    search_filter_results: "过滤结果",
    search_filter_min: "过滤最小",
    search_filter_at_least: "至少",
    price_filter: "价格过滤器",
    product_name: "产品名称",
    english_language: "英语",
    arabic_language: "阿拉伯",
    spanish_language: "西班牙语",
    system_language: "系统",
    share_link: "分享链接",
    save: "保存",
    cancel: "取消",
    loading: "装载",
    yes: "是的",
    no: "不",
    report: "报告",
    report_product: "报告产品",
    report_user: "举报用户",
    block_user: "阻止用户",
    un_block_user: "解锁用户",
    why_product: "你为什么要报告这个项目？",
    why_user: "您为什么要报告此用户？",
    block_user_confirm: "你想永久阻挡这个用户吗？",
    un_block_user_confirm: "你想永久解锁这个用户吗？",
    prohibited: "禁止在我附近上市",
    offensive: "冒犯或不合适",
    duplicate: "重复帖子",
    wrong_category: "错误的类别",
    scam: "看起来像一个骗局",
    stolen: "我认为它被盗了",
    product_other: "其他",
    product_is_sold: "该产品已售出",
    missed_meeting: "他们错过了我们的会议",
    low_offer: "提供了低价",
    rude: "粗鲁或不合适",
    items: "物品的问题",
    trouble_meetup: "遇见麻烦",
    messaging: "消息问题",
    user_other: "其他",
    new_version_available: "新版本可用",
    please_update_app: "请更新应用程序到新版本继续。",
    update: "更新",
    no_thanks: "不用了，谢谢",
    contact_support_confirmation:
      "当前响应时间为24-48小时。您想联系我附近的应用程序聊天支持吗？",
    unboost_confirmation: "您确定要卸载此产品吗？",
    no_used_products: "你还没有任何房源",
    no_boosted_products: "您没有任何提升产品",
    next: "下一个",
    previous: "以前的",
    skip: "跳过",
    start: "开始",
    list_used: "列出二手产品",
    buy_description: "发现和搜索您周围邻居提供的产品",
    sell_description: "清单产品您不再需要出售",
    list_used_description: "在不到20秒内销售使用的二手产品",
    boost_product_option_1: "<b> Boost 1  nday </ b>  n  n <b> $ 0.99 </ b>",
    boost_product_option_2: "<b> Boost 3  ndays </ b>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<b> boost 7  ndays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "每天获得更多的观点。您的物品将出现在购买和类别的前30个项目中的特色位置。促销的物品在指定的斑点之间旋转，因此每个项目都会公平曝光。",
    boost_cta: "卖得更快",
    boost_terms: "通过敲击提升，您同意<U>在我附近的服务条款附近。</ U>",
    boost_best_value: "最超值",
    already_boosted: "该产品已升高",
    clicks: "点击",
    impressions: "印象",
    end: "结尾",
    transactions_empty_text:
      "您还没有任何助推器交易。您可以访问销售选项卡并开始提升您的产品。",
    transactions_loading_error: "无法更新事务列表，请稍后再试。",
    transactions_history_title: "促进交易历史记录",
    communicative_postive: "交际",
    communicative_negative: "毫无疑问",
    ontime_postive: "准时",
    ontime_negative: "晚了",
    reliable_postive: "可靠的",
    reliable_negative: "不可靠",
    friendly_postive: "友好的",
    friendly_negative: "不礼貌",
    itemasdescribed_postive: "项目如上所述",
    itemasdescribed_negative: "物品没有描述",
    other: "其他",
    submit: "提交",
    adding_rating_reviews: "添加评级和评论",
    no_internet_title: "没有网络连接",
    no_internet_message: "确保您已连接到互联网，然后重试",
    retry: "重试",
    near_me: "靠近我",
    newest_first: "新的先来",
    miles: "里程",
    km: "km.",
    similar_products: "类似产品",
    favorite_products: "最喜欢的产品",
    items_for_sale: "出售物品",
    joined: "加入",
    favorites_transactions_title: "最爱",
    boosted_products_transactions_history: "提升产品交易历史记录",
    views: "意见",
    boost_graph_title: "升压图形",
    no_favorite_products: "您没有任何最喜欢的产品",
    make_offer_buy: "我想买",
    make_offer_buy_for: "为了",
    notifications: "通知",
    push_notifications: "推",
    emails_notifications: "电子邮件",
    apply: "申请",
    email_messages: "电子邮件为消息",
    email_new_products: "新产品的电子邮件",
    push_day_only: "仅推送通知日",
    push_24_hours: "推送通知24小时",
    edit: "编辑",
    map: "地图",
    camera: "相机",
    gallery: "画廊",
    delete: "删除",
    no_sell_items: "没有物品出售",
    who_bought_question: "谁买了它？",
    sold_elsewhere_question: "把它卖给了其他地方",
    confirm: "确认",
    over_limit_camera: "您不能添加超过五种图像",
    boost_failed: "Boost失败了。请稍后再试",
    after_purchase: "付款成功 n新鲜提升",
    pay_failed: "支付失败。请再试一次",
    done: "完毕",
    not_now: "现在不要",
    boost: "促进",
    invalid_zip_code: "无效的邮政编码",
    invalid_user_name: "无效的用户名",
    comments: "评论",
    questions: "问题",
    bug_reports: "错误报告",
    feature_request: "功能要求",
    feedback_type: "反馈类型",
    feedback_description: "我们很乐意听到您的想法或反馈我们如何提高您的经验！",
    feedback: "回馈",
    feedback_text: "你的答案",
    suggestions: "改进建议",
    delete_account: "删除帐户",
    new_message: "新消息",
    online: "在线的",
    km_50: "50公里.",
    km_100: "100公里.",
    km_200: "200公里",
    miles_30: "30英里",
    miles_60: "60英里",
    miles_120: "120英里",
    rate_app_question: "那么评级如何？然后？",
    enjoying_question: "享受在我附近上市？",
    not_enjoy: "并不真地",
    feedback_question: "你介意给我们一些反馈吗？",
    yes_sure: "是当然",
    product_available_question: "嗨，这还有吗？",
    buy_question: "嗨，我想买这个",
    meet_question: "嗨，你能今天见面吗？",
    follow: "跟随",
    followers: "追随者",
    following: "下列的",
    feedback_thanks: "感谢您的反馈意见",
    all_categories: "所有类别",
    deleted_account: "此帐户已删除",
    delete_account_question: "您确定要删除此帐户吗？",
    no_followings: "不跟随任何人",
    when_following: "什么时候",
    no_followings_subtitle: "跟随人，你会在这里看到它们",
    no_followers: "没有追随者",
    no_followers_subtitle: "接着是人，你会在这里看到它们",
    distance: "距离",
    filter_method: "过滤方法",
    see_listings: "查看列表",
    sold: "卖",
    bought: "买",
    no_notifications: "当您收到通知时，它们会出现在这里",
    items_title: "项目",
    new_listing_title: "创建新列表",
    dialog_year_title: "年",
    dialog_make_title: "制作",
    dialog_model_title: "模型",
    dialog_body_style_title: "身材",
    dialog_exterior_color_title: "外观颜色",
    dialog_interior_color_title: "室内颜色",
    dialog_transmission_title: "传播",
    dialog_fuel_type_title: "燃油类型",
    dialog_owners_num_title: "所有者的数量",
    dialog_vehicle_owed_money_title: "这辆车还有钱吗？",
    automatic_transmission: "自动的",
    manual_transmission: "手动的",
    not_sure: "不确定",
    wagon_hatchback: "马车＆掀背车",
    convertible: "敞篷车",
    coupe: "轿跑车",
    sedan: "轿车",
    black_color: "黑色的",
    blue_color: "蓝色",
    brown_color: "棕色的",
    gold_color: "金子",
    green_color: "绿",
    grey_color: "灰色的",
    pink_color: "粉色的",
    purple_color: "紫色的",
    red_color: "红色的",
    silver_color: "银",
    orange_color: "橘子",
    white_color: "白色的",
    yellow_color: "黄色的",
    charcol_color: "Charcol.",
    fuel_diesel: "柴油机",
    fuel_electric: "电的",
    fuel_gasoline: "汽油",
    fuel_flex: "柔性",
    fuel_hybrid: "杂交种",
    fuel_petrol: "汽油",
    fuel_plugin_hybrid: "插入式混合动力车",
    truck: "卡车",
    van_minivan: "范＆小型货车",
    suv_crossover: "SUV＆交叉",
    awd_4wd: "AWD / 4WD.",
    fwd: "FWD.",
    rwd: "rwd.",
    off_white_color: "米白色",
    tan_color: "晒黑",
    beige_color: "浅褐色的",
    burgundy_color: "勃艮第",
    turquoise_color: "绿松石",
    title_status_clean: "干净的",
    title_status_rebuilt: "重建",
    title_status_salvage: "打捞",
    title_status_missing: "失踪",
    title_status_lien: "留置权",
    title_status: "标题状态",
    mileage: "里程",
    dialog_drivetrain_title: "传动系统",
    model_warning: "请选择首先",
    required_field_warning: "这是必填栏",
    vehicle_vin: "vin.",
    invalid_vin: "VIN无效，请再次设置VIN。",
    invalid_mileage: "中里线无效，请再次设置里程。",
    clean_description: "大多数没有发生意外的车辆",
    rebuilt_description: "一辆已重建的销售汽车",
    salvage_description: "被认为是事故发生后的总数",
    missing_description: "需要一个新的DMV问题标题",
    lien_description: "由银行或法院定居",
    nearme: "靠近我",
    newest: "最新",
    contact_support: "联系支持",
    create_home_title: "销售或租金",
    for_sale: "出售",
    for_rent: "出租",
    property_type: "财产种类",
    apartment: "公寓",
    house: "房子",
    room_only: "仅限房间",
    townhouse: "联排别墅",
    bedrooms: "卧室",
    bathrooms: "浴室",
    property_address: "物业地址",
    price_per_month: "每月价格",
    square_feet: "平方英尺",
    year_built: "年份建成",
    year_renovated: "年份翻新",
    lot_size: "批量",
    laundry_type: "洗衣型",
    in_unit_laundry: "内部洗衣店",
    laundry_building: "在建筑物的洗衣店",
    laundry_available: "洗衣店",
    none: "没有任何",
    parking_type: "停车类型",
    garage_parking: "车库停车",
    street_parking: "街边停车",
    off_street_parking: "街边停车",
    available_parking: "停车场",
    air_cond_type: "空调类型",
    ac_available: "可用",
    central_ac: "中央AC",
    heating_type: "加热类型",
    electric_heating: "电热",
    gas_heating: "气体加热",
    radiator_heating: "散热器加热",
    available_heating: "供暖可供选择",
    amenities: "设施",
    date_available: "可用日期",
    lease_length: "租赁长度",
    month_to_month: "一个月到一个月",
    three_months: "3个月",
    six_months: "6个月",
    one_year: "1年",
    more_one_year: "1岁以上",
    cat_friendly: "猫友好",
    dog_friendly: "狗友好",
    balcony: "阳台",
    basement: "地下室",
    bike_parking: "自行车停车",
    cable_tv: "有线电视",
    ceiling_fan: "吊扇",
    concierge: "门房",
    dishwasher: "洗碗机",
    doorman: "门徒",
    elevator: "电梯",
    fireplace: "壁炉",
    fitness_center: "健身中心",
    garbage_disposal: "垃圾处理",
    microwave: "微波",
    online_app: "在线申请",
    oven: "烤箱",
    package_service: "包裹服务",
    patio: "露台",
    pet_park: "宠物公园",
    refrigerator: "冰箱",
    resident_lounge: "居民休息室",
    roof_deck: "屋顶平台",
    secured_entry: "担保入境",
    storage: "贮存",
    walk_in_closet: "步入式衣橱",
    swimming_pool: "游泳池",
    wheelchair_access: "轮椅通道",
    central_heating: "暖气",
    invalid_bedrooms: "无效卧室，请再次设置卧室。",
    invalid_bathrooms: "浴室无效，请再次设置浴室。",
    chinese_simplified_language: "简体中文",
    chinese_traditional_language: "中国传统的",
    czech_language: "捷克语",
    danish_language: "丹麦语",
    dutch_language: "荷兰人",
    finnish_language: "芬兰",
    french_language: "法语",
    german_language: "德语",
    greek_language: "希腊语",
    hungarian_language: "匈牙利",
    indonesian_language: "印度尼西亚",
    italian_language: "意大利人",
    japanese_language: "日本人",
    korean_language: "韩国人",
    norwegian_language: "挪威",
    polish_language: "抛光",
    portuguese_language: "葡萄牙语",
    portuguese_brazilian_language: "葡萄牙语，巴西人",
    romanian_language: "罗马尼亚人",
    russian_language: "俄语",
    swedish_language: "瑞典",
    turkish_language: "土耳其",
    ukrainian_language: "乌克兰",
    urdu_pakistan_language: "乌尔都语（巴基斯坦）",
    vietnamese_language: "越南语",
    category_home_sale_or_rent: "销售或租金",
    square_meter: "平方米",
    copy_text: "复制",
    copyied_to_clipboard: "复制到剪贴板",
    inbox: "收件箱",
    input_title_listening: "听...",
    input_subtitle_listening: "说些什么",
    input_title_error: "对不起，我们没有完全得到。",
    input_subtitle_error: "尝试重复您的请求。",
    input_hint_error: "再试一次",
    price_less_than_or_equal: "价格小于或等于",
    any_price: "任何价格",
    any_condition: "任何条件",
    any_time: "随时",
    days_ago: "几天前",
    any_distance: "任何距离",
    distance_within: "距离内",
    new_notification: "新通知",
    deleted: "删除了",
    processing_image: "处理镜像",
    remove_dialog_message: "你真的想删除这个产品吗？",
    deleted_thread: "此消息已删除",
    category_yard_sale_event: "院子里销售活动",
    yard_first_date: "院子里销售第一日",
    yard_second_date: "院子里销售第二次日期",
    yard_third_date: "院子里销售第三日期",
    yard_start_time: "开始时间",
    yard_end_time: "时间结束",
    yard_end_timestamp: "结束时间戳",
    invalid_date1: "无效的第一个日期，请再次设置第一个日期",
    invalid_start_time: "无效的开始时间，请再次设置开始时间",
    invalid_end_time: "无效结束时间，请再次设置结束时间",
    yard_sale_title: "院子里卖",
    garage_tag: "车库",
    yard_tag: "院子",
    from: "从",
    to: "到",
    block: "堵塞",
    un_block: "解锁",
    sign_email: "用电子邮件登录",
    invalid_first_date: "首次日期无效，请确保第一次日期是第二和第三日",
    invalid_second_date: "第二次日期无效，请确认第二日在第三日之前",
    invalid_start_time_value: "无效的开始时间，请确保开始时间在结束时间之前",
    use_default_yard_photo: "使用默认庭院销售照片",
    active_label: "积极的",
    enable_notifications: "启用通知",
    login: "登录",
    january: "一月",
    february: "二月",
    march: "行进",
    april: "四月",
    may: "可能",
    june: "六月",
    july: "七月",
    august: "八月",
    september: "九月",
    october: "十月",
    november: "十一月",
    december: "十二月",
    since: "自从",
    product_views: "产品观点",
    shop_views: "商店观点",
    total_sales: "总销售额",
    total_orders: "总订单",
    last_twelvth_months: "最后一个月",
    last_nine_months: "最后九个月",
    last_six_months: "过去六个月",
    last_three_months: "过去三个月",
    last_12_months: "过去12个月",
    last_9_months: "过去9个月",
    last_6_months: "过去6个月",
    last_3_months: "过去3个月",
    months: "几个月",
    reset_password: "重设密码",
    create_new_shop: "创造新的商店",
    download_app: "下载应用程序",
    log_in: "登录",
    sign_up: "注册",
    no_result: "没有结果",
    max_price: "最高价",
    max_distance: "最大距离",
    max_time: "最大时间",
    posted_less_than: "发布少于",
    result: "结果",
    more: "更多的",
    or: "或者",
    password: "密码",
    forgot_password: "忘记密码？",
    and: "和",
    download_for: "下载",
    apple_ios: "苹果ios.",
    android: "安卓",
    image: "图片",
    edit_image: "编辑映像",
    please_complete: "请完成",
    enter_your_offer: "输入您的优惠",
    categories: "类别",
    upload_image: "上传图片",
    upload_images: "上传图像",
    back: "后退",
    see_more: "查看更多",
    add_product: "添加产品",
    selected: "选择",
    create: "创建",
    rate_the_buyer: "评价买方",
    delete_product: "删除产品",
    product: "产品",
    un_block_product: "解锁产品",
    share_your_product: "分享您的产品",
    boost_details: "提升细节",
    remove_all_products: "删除所有产品",
    remove_all: "移除所有",
    add_vehicle: "添加车辆",
    edit_vehicle: "编辑车辆",
    upload_a_photo: "上传一张照片",
    view_details: "查看详情",
    add_yard_sale: "加码销售",
    edit_yard_sale: "编辑围场销售",
    users: "用户",
    users_details: "用户详细信息",
    users_by_country: "用户按国家",
    blocked_users: "阻止用户",
    products_cards: "产品卡",
    archived_products: "存档的产品",
    blocked_products: "封锁产品",
    products_by_country: "产品由国家/地区",
    reports: "报告",
    reports_details: "报告详情",
    closed_reports: "封闭式报告",
    threads: "线程",
    threads_details: "线程细节",
    chat_support: "聊天支持",
    actions: "行动",
    search_actions: "搜索操作",
    product_view_actions: "产品视图操作",
    contact_seller_product: "联系卖家产品",
    contact_owner_shop: "联系所有者商店",
    ratings: "评分",
    reviews: "回顾",
    products_all_countries: "产品所有国家",
    edit_profile: "编辑个人资料",
    my_profile: "我的简历",
    profile_updated_successfully: "配置文件已成功更新",
    are_you_sure: "你确定吗",
    my_used_products: "我的使用产品",
    my_shops: "我的商店",
    my_boosted_products: "我的提升产品",
    messages_type_message_here: "在这里输入你的消息",
    messages_product_sold: "该产品已售出或删除",
    seen: "看",
    messages_never_miss_message: "永远不要错过留言",
    enable: "使能够",
    send_notify: "发送通知",
    un_close: "un",
    type_your_review: "输入您的评论",
    again_question: "再次 ？",
    ratings_already_submitted_review: "您已经提交了审核",
    open: "打开",
    set_product_category: "设置产品类别",
    auth_email_password_incorrect: "您的电子邮件或密码不正确",
    auth_insert_your_name: "请插入您的姓名",
    auth_email_address_badly: "电子邮件地址差异很大",
    auth_email_address_used: "电子邮件地址已被另一个帐户使用",
    auth_invalid_password: "密码应至少为6个字符",
    auth_reset_email: "输入您的电子邮件以重置您的密码",
    auth_check_email: "请检查您的电子邮件以重置密码",
    auth_can_sign_in_google: "您可以使用Google按钮登录",
    auth_do_not_have_account: "你有账号吗？",
    auth_have_account: "你有没有账号？",
    log_terms_privacy_part1: "通过注册或登录，您同意我附近的上市",
    boost_this_product: "提升这个产品？",
    product_successfully_boosted: "该产品已成功提升",
    product_failed_boost: "该产品的增压失败了",
    no_products_for_sale: "您目前没有任何销售的使用产品。",
    not_sold_listed_near_me: "我没有在我附近上市",
    agree_add_product:
      "通过轻敲帖子来发布您的产品，您同意我附近的服务条款和隐私政策。",
    click_to_boost: "单击产品以提升它",
    listed_terms_of_service: "在我附近的服务条款附近",
    receive_emails_for_users: "收到用户消息的电子邮件",
    receive_emails_for_newly_posted: "收到新发布的产品的电子邮件",
    disable_push_notifications: "禁用推送通知",
    sms_during_day: "在白天接收短信",
    sms_24_hours: "收到短信24小时",
    products: "产品",
    product_no_longer_available: "对不起，此产品已不再可用",
    add_home: "加上衣",
    edit_home: "编辑家庭",
    fill_required_fields: "填写所有必填字段",
    no_notification: "没有通知",
    orders_history: "订单历史",
    privacy: "隐私",
    terms: "条款",
    report_a_problem: "报告一个问题",
    approximation_protect_user_privacy: "近似保护用户隐私",
    do_not_have_products: "你没有产品",
    emails: "电子邮件",
    lead_deletion_products: "这将导致所有产品删除",
    confirm_legal_message:
      "您只负责在与他人互动时采取所有必要的预防措施，特别是在第一次亲自遇见陌生人时。有关更多详细信息，请审核服务条款。",
    push_notifications_notified_instantly: "启用推送通知即时通知",
    rate_seller: "利率卖方",
    user_journey: "用户旅程",
    user: "用户",
    user_id: "用户身份",
    action_id: "行动ID.",
    select_model_car: "选择汽车型号",
    boost_1_day: "提升1天",
    boost_3_days: "提升3天",
    boost_7_days: "提升7天",
    agree_boost_terms: "通过攻丝提升，您同意",
    add: "添加",
    add_tag: "添加标记",
    brand_title: "品牌",
    category_mobiles: "手机",
    category_tablets: "片剂",
    screen_size: "屏幕尺寸",
    has_cellular_capability: "具有蜂窝能力",
    default_internal_memory: "内部存储器",
    network_carrier: "网络承运人",
    is_unlocked: "是解锁的",
    mobile_model_warning: "请先选择品牌",
    missing_image: "缺少图像，再次尝试添加图像。",
    add_mobile: "添加手机",
    edit_mobile: "编辑手机",
    add_tablet: "添加平板电脑",
    edit_tablet: "编辑平板电脑",
    keywords: "购物，购买，卖，赚钱，贸易，当地人，邻居，汽车，车辆",
    country: "国家",
    phone_number: "电话号码",
    verification_code: "验证码",
    error_occurred: "发生了一个错误。请稍后重试",
    invalid_state: "状态无效：收到登录回调，但未发送登录请求。",
    sign_in: "登入",
    sign_in_apple: "用苹果登录",
    sign_in_google: "用谷歌登录",
    sign_in_phone: "用手机登录",
    sign_in_facebook: "使用Facebook登录",
    create_account: "创建一个帐户",
    email: "电子邮件",
    invalid_field: "请填写必填字段",
    code_sent: "代码已由SMS发送",
    verify_number: "验证电话号码",
    tapping_verify_number: "通过点击（验证电话号码），发送短信。",
    email_exists:
      "该帐户已存在，您需要通过Google按钮，Facebook按钮或Apple按钮访问它",
    ok: "行",
    sure_back: "你一定要回吗？",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "前",
    add_model: "添加模型",
    no_search_results_us:
      "在120英里内，您附近没有搜索结果。尝试更改搜索过滤器或搜索关键字。",
    no_search_results:
      "在200公里以内的您附近没有搜索结果。尝试更改搜索过滤器或搜索关键字。",
    plan_date: "计划日期",
    plan_time: "计划时间",
    invalid_plan_date: "计划日期无效，请再次设置计划日期",
    invalid_plan_time: "无效计划时间，请再次设置计划时间",
    plan_name: "计划名称",
    plan_title: "计划",
    update_plan_name: "更新计划名称",
    delete_plan_question: "您确定要删除此计划吗？",
    plan_reminder_message: "一小时前提醒您",
    plan_dialog_title: "会议计划",
    planners_title: "计划者",
    unable_sending_messages: "当他们回到网上时，他们会看到您的消息。",
    its_text: "它是",
    for_your_text: "为您的接收器。",
  },
  "zh-TW": {
    invalid_area: "無效區域，請再次設置區域。",
    invalid_lot_size: "無效的屬性批量大小，請再次設置批次大小。",
    property_area: "財產區",
    app_store_name: "在我附近列出 - 購買二手物品，出售現金",
    app_store_short: "當地賣家的市場。列出待售物品並賺錢。",
    app_store_full:
      "在我附近上市使您可以輕鬆找到您想要的東西，並在您想要銷售的東西上賺錢。這是您可以信任的人們在社區或社區購買和銷售的最佳方式。它是如何運作的：1-買或賣任何東西;輕鬆發布您的物品以單位出售。 2-在衣服，家具，手機，電子，嬰兒和兒童物品，運動器材，二手車，連衣裙，鞋子和手錶上找到大量優惠和折扣，用於書籍，二手玩具，使用的筆記本電腦，二手車甚至是真實的銷售或租金。 3-瀏覽本地物品出售。 4-消息從應用程序中的購買者和賣家。 5-按圖像瀏覽物品，按類別排序。關於我附近的有趣事實：1-與我附近的列出，您可以輕鬆銷售任何東西，從衣服到使用汽車到電子產品。 2-買家與賣家之間的通信通過應用程序通過消息傳遞。 3-我附近列出比車庫銷售更好;在您的手機或平板電腦上找到任何您想要的折扣。",
    app_store_release:
      "在我附近列出 - 與當地人交易。加入當地買家和賣家的移動市場！",
    app_name: "在我附近上市",
    title_buy: "買",
    title_messages: "消息",
    title_sell: "賣",
    title_profile_image: "輪廓圖像",
    title_account: "帳戶",
    account_settings: "帳號設定",
    settings: "設置",
    color_theme: "顏色主題",
    device_settings: "設備設置",
    public_profile: "公共簡介",
    light_mode: "光模式",
    dark_mode: "黑暗模式",
    title_sell_faster: "賣得更快",
    send_button_label: "發送",
    rate_message: "評價我......",
    already_rated: "您已經提交了審核",
    rate_review_question: "你想處理嗎？",
    again: "再次？",
    action_logout: "登出",
    action_category: "類別",
    action_search: "搜索",
    action_refer: "介紹個朋友",
    dialog_choose_location: "選擇地點",
    dialog_change_username: "更改用戶名",
    dialog_change_language: "改變語言",
    dialog_image_tags: "圖像標籤",
    dialog_emails_notifications: "電子郵件通知",
    dialog_push_notifications: "推送通知",
    fragment_product_detail: "產品信息",
    fragment_message_details: "消息詳情",
    fragment_sell: "賣",
    dialog_tags_title: "標籤",
    dialog_location_title: "更新位置",
    dialog_username_title: "更改用戶名",
    tab_photo: "照片",
    tab_details: "細節",
    tab_price: "價格",
    tab_finish: "結束",
    profile: "輪廓",
    search: "搜索",
    choose_product: "選擇產品",
    rating_review: "評級和評估",
    select_buyer: "選擇買方",
    tab_my_used_products: "我的產品",
    price_label: "價格",
    text_savings: "您保存",
    search_hint: "搜索產品......",
    empty_text: "此類別中沒有任何產品或在所選距離內。",
    filter_menu_text: "篩選",
    error_contacting_seller: "聯繫賣家錯誤",
    edit_product: "編輯產品",
    contact_seller: "聯絡賣家",
    signup_to_contact_seller: "註冊聯繫賣家",
    signup_to_make_offer: "註冊以提供",
    product_details: "細節",
    product_category: "類別",
    product_condition: "狀況",
    product_description: "描述",
    product_location: "產品位置",
    product_location_approximate: "位置是近似的",
    over_week_time_ago: "一周前",
    boosted: "提升",
    threads_no_results: "沒有消息",
    message_no_results: "沒有消息",
    message_warning:
      "與他人互動時，您將負責採取所有必要的預防措施，尤其是在第一次見面陌生人時。請不要共享任何個人信息，驗證代碼或任何付款信息。請查看服務條款以獲取更多詳細信息。",
    message_block: "您此時無法發送或接收消息。",
    select_location: "選擇位置",
    location_permission_denied_message: "該應用程序需要正確的允許正常工作。",
    signed_in: "登錄！",
    sign_in_canceller: "登錄取消",
    version: "版本",
    build: "建造",
    name: "名稱",
    location: "地點",
    language: "語",
    about_app: "關於我附近的",
    terms_of_service: "服務條款",
    privacy_policy: "隱私政策",
    report_feedback: "發送反饋",
    report_bug: "握手報告一個錯誤",
    change_image: "改變圖像",
    update_location: "更新位置",
    about_the_app: "關於這個應用程序",
    update_label: "更新",
    uploading: "上傳",
    adding: "添加清單",
    removing: "刪除上市",
    updating: "更新清單",
    uploaded_image: "上傳圖像：",
    image_storage_failed: "無法存儲圖像：",
    product_updated: "產品成功更新",
    location_error: "位置未保存，請再試一次",
    product_removed: "產品成功刪除",
    deleted_product: "此產品已刪除",
    invalid_title: "無效標題，請再次設置標題。",
    invalid_image: "無效的圖像路徑，嘗試再次添加圖像。",
    invalid_price: "價格無效，請再次設置價格。",
    invalid_location: "位置無效，請再次設置位置。",
    invalid_category: "無效類別，請再次設置類別。",
    invalid_condition: "條件無效，請再次設置條件。",
    removing_title: "刪除檔案映像",
    image_not_saved: "圖像保存失敗！",
    product_load_failed: "沒有產品",
    take_photo: "拍照",
    select_photo: "選擇照片",
    product_title_hint: "它是什麼？名稱，品牌，模型等",
    delete_photo: "刪除照片",
    product_title: "標題",
    mark_as_sold: "標記售出",
    product_share: "分享",
    product_make_offer: "提供",
    product_cover: "設置為封面圖像",
    product_tags: "標籤",
    product_posted: "發布：",
    product_change: "改變",
    product_post: "郵政",
    product_selling_from: "從地點出售",
    product_select_location: "選擇位置",
    product_map_approximate: "Map致致允許賣家的位置私密",
    product_terms:
      "通過輕拍帖子發布您的產品，您同意<U>在我附近的服務條款附近。</ U>",
    condition_other: "其他（參見描述）",
    condition_for_parts: "適用於零件",
    condition_used: "使用（正常磨損）",
    condition_open_box: "打開盒子（從未使用過）",
    condition_reconditioned: "重新處理/認證",
    condition_new: "新（從未使用過）",
    select_category: "選擇類別",
    select_all_category: "全選",
    category_loading_error: "無法更新類別列表，請稍後再試。",
    category_vehicles: "車輛",
    category_furniture: "家具",
    category_electronics: "電子產品",
    category_appliances: "家庭＆電器",
    category_fashion_accessories: "時尚＆配件",
    category_baby_kids: "寶貝＆孩子們",
    category_antiques_collectibles: "古董＆收藏品",
    category_auto_parts_tools_machinery: "汽車零件，工具＆機械",
    category_sports_outdoors: "運動＆戶外",
    category_others: "其他",
    location_enter_zip_code: "輸入郵政編號",
    location_get_current_location: "獲取當前位置",
    location_select_location: "選擇位置",
    location_update_location: "更新位置",
    location_new_location: "新地點",
    search_filter_results: "過濾結果",
    search_filter_min: "過濾最小",
    search_filter_at_least: "至少",
    price_filter: "價格過濾器",
    product_name: "產品名稱",
    english_language: "英語",
    arabic_language: "阿拉伯",
    spanish_language: "西班牙語",
    system_language: "系統",
    share_link: "分享鏈接",
    save: "保存",
    cancel: "取消",
    loading: "裝載",
    yes: "是的",
    no: "不",
    report: "報告",
    report_product: "報告產品",
    report_user: "舉報用戶",
    block_user: "阻止用戶",
    un_block_user: "解鎖用戶",
    why_product: "你為什麼要報告這個項目？",
    why_user: "您為什麼要報告此用戶？",
    block_user_confirm: "你想永久阻擋這個用戶嗎？",
    un_block_user_confirm: "你想永久解鎖這個用戶嗎？",
    prohibited: "禁止在我附近上市",
    offensive: "冒犯或不合適",
    duplicate: "重複帖子",
    wrong_category: "錯誤的類別",
    scam: "看起來像一個騙局",
    stolen: "我認為它被盜了",
    product_other: "其他",
    product_is_sold: "該產品已售出",
    missed_meeting: "他們錯過了我們的會議",
    low_offer: "提供了低價",
    rude: "粗魯或不合適",
    items: "物品的問題",
    trouble_meetup: "遇見麻煩",
    messaging: "消息問題",
    user_other: "其他",
    new_version_available: "新版本可用",
    please_update_app: "請更新應用程序到新版本繼續。",
    update: "更新",
    no_thanks: "不用了，謝謝",
    contact_support_confirmation:
      "當前響應時間為24-48小時。您想聯繫我附近的應用程序聊天支持嗎？",
    unboost_confirmation: "您確定要卸載此產品嗎？",
    no_used_products: "你還沒有任何房源",
    no_boosted_products: "您沒有任何提升產品",
    next: "下一個",
    previous: "以前的",
    skip: "跳過",
    start: "開始",
    list_used: "列出二手產品",
    buy_description: "發現和搜索您周圍鄰居提供的產品",
    sell_description: "清單產品您不再需要出售",
    list_used_description: "在不到20秒內銷售使用的二手產品",
    boost_product_option_1: "<b> Boost 1  nday </ b>  n  n <b> $ 0.99 </ b>",
    boost_product_option_2: "<b> Boost 3  ndays </ b>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<b> boost 7  ndays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "每天獲得更多的觀點。您的物品將出現在購買和類別的前30個項目中的特色位置。促銷的物品在指定的斑點之間旋轉，因此每個項目都會公平曝光。",
    boost_cta: "賣得更快",
    boost_terms: "通過敲擊提升，您同意<U>在我附近的服務條款附近。</ U>",
    boost_best_value: "最超值",
    already_boosted: "該產品已升高",
    clicks: "點擊",
    impressions: "印象",
    end: "結尾",
    transactions_empty_text:
      "您還沒有任何助推器交易。您可以訪問銷售選項卡並開始提升您的產品。",
    transactions_loading_error: "無法更新事務列表，請稍後再試。",
    transactions_history_title: "促進交易歷史記錄",
    communicative_postive: "交際",
    communicative_negative: "毫無疑問",
    ontime_postive: "準時",
    ontime_negative: "晚了",
    reliable_postive: "可靠的",
    reliable_negative: "不可靠",
    friendly_postive: "友好的",
    friendly_negative: "不禮貌",
    itemasdescribed_postive: "項目如上所述",
    itemasdescribed_negative: "物品沒有描述",
    other: "其他",
    submit: "提交",
    adding_rating_reviews: "添加評級和評論",
    no_internet_title: "沒有網絡連接",
    no_internet_message: "確保您已連接到互聯網，然後重試",
    retry: "重試",
    near_me: "靠近我",
    newest_first: "新的先來",
    miles: "里程",
    km: "km.",
    similar_products: "類似產品",
    favorite_products: "最喜歡的產品",
    items_for_sale: "出售物品",
    joined: "加入",
    favorites_transactions_title: "最愛",
    boosted_products_transactions_history: "提升產品交易歷史記錄",
    views: "意見",
    boost_graph_title: "升壓圖形",
    no_favorite_products: "您沒有任何最喜歡的產品",
    make_offer_buy: "我想買",
    make_offer_buy_for: "為了",
    notifications: "通知",
    push_notifications: "推",
    emails_notifications: "電子郵件",
    apply: "申請",
    email_messages: "電子郵件為消息",
    email_new_products: "新產品的電子郵件",
    push_day_only: "僅推送通知日",
    push_24_hours: "推送通知24小時",
    edit: "編輯",
    map: "地圖",
    camera: "相機",
    gallery: "畫廊",
    delete: "刪除",
    no_sell_items: "沒有物品出售",
    who_bought_question: "誰買了它？",
    sold_elsewhere_question: "把它賣給​​了其他地方",
    confirm: "確認",
    over_limit_camera: "您不能添加超過五種圖像",
    boost_failed: "Boost失敗了。請稍後再試",
    after_purchase: "付款成功 n新鮮提升",
    pay_failed: "支付失敗。請再試一次",
    done: "完畢",
    not_now: "現在不要",
    boost: "促進",
    invalid_zip_code: "無效的郵政編碼",
    invalid_user_name: "無效的用戶名",
    comments: "評論",
    questions: "問題",
    bug_reports: "錯誤報告",
    feature_request: "功能要求",
    feedback_type: "反饋類型",
    feedback_description: "我們很樂意聽到您的想法或反饋我們如何提高您的經驗！",
    feedback: "回饋",
    feedback_text: "你的答案",
    suggestions: "改進建議",
    delete_account: "刪除帳戶",
    new_message: "新消息",
    online: "在線的",
    km_50: "50公里.",
    km_100: "100公里.",
    km_200: "200公里",
    miles_30: "30英里",
    miles_60: "60英里",
    miles_120: "120英里",
    rate_app_question: "那麼評級如何？然後？",
    enjoying_question: "享受在我附近上市？",
    not_enjoy: "並不真地",
    feedback_question: "你介意給我們一些反饋嗎？",
    yes_sure: "是當然",
    product_available_question: "嗨，這還有嗎？",
    buy_question: "嗨，我想買這個",
    meet_question: "嗨，你能今天見面嗎？",
    follow: "跟隨",
    followers: "追隨者",
    following: "下列的",
    feedback_thanks: "感謝您的反饋意見",
    all_categories: "所有類別",
    deleted_account: "此帳戶已刪除",
    delete_account_question: "您確定要刪除此帳戶嗎？",
    no_followings: "不跟隨任何人",
    when_following: "什麼時候",
    no_followings_subtitle: "跟隨人，你會在這裡看到它們",
    no_followers: "沒有追隨者",
    no_followers_subtitle: "接著是人，你會在這裡看到它們",
    distance: "距離",
    filter_method: "過濾方法",
    see_listings: "查看列表",
    sold: "賣",
    bought: "買",
    no_notifications: "當您收到通知時，它們會出現在這裡",
    items_title: "項目",
    new_listing_title: "創建新列表",
    dialog_year_title: "年",
    dialog_make_title: "製作",
    dialog_model_title: "模型",
    dialog_body_style_title: "身材",
    dialog_exterior_color_title: "外觀顏色",
    dialog_interior_color_title: "室內顏色",
    dialog_transmission_title: "傳播",
    dialog_fuel_type_title: "燃油類型",
    dialog_owners_num_title: "所有者的數量",
    dialog_vehicle_owed_money_title: "這輛車還有錢嗎？",
    automatic_transmission: "自動的",
    manual_transmission: "手動的",
    not_sure: "不確定",
    wagon_hatchback: "馬車＆掀背車",
    convertible: "敞篷車",
    coupe: "轎跑車",
    sedan: "轎車",
    black_color: "黑色的",
    blue_color: "藍色",
    brown_color: "棕色的",
    gold_color: "金子",
    green_color: "綠",
    grey_color: "灰色的",
    pink_color: "粉色的",
    purple_color: "紫色的",
    red_color: "紅色的",
    silver_color: "銀",
    orange_color: "橘子",
    white_color: "白色的",
    yellow_color: "黃色的",
    charcol_color: "Charcol.",
    fuel_diesel: "柴油機",
    fuel_electric: "電的",
    fuel_gasoline: "汽油",
    fuel_flex: "柔性",
    fuel_hybrid: "雜交種",
    fuel_petrol: "汽油",
    fuel_plugin_hybrid: "插入式混合動力車",
    truck: "卡車",
    van_minivan: "範＆小型貨車",
    suv_crossover: "SUV＆交叉",
    awd_4wd: "AWD / 4WD.",
    fwd: "FWD.",
    rwd: "rwd.",
    off_white_color: "米白色",
    tan_color: "曬黑",
    beige_color: "淺褐色的",
    burgundy_color: "勃艮第",
    turquoise_color: "綠松石",
    title_status_clean: "乾淨的",
    title_status_rebuilt: "重建",
    title_status_salvage: "打撈",
    title_status_missing: "失踪",
    title_status_lien: "留置權",
    title_status: "標題狀態",
    mileage: "里程",
    dialog_drivetrain_title: "傳動系統",
    model_warning: "請選擇首先",
    required_field_warning: "這是必填欄",
    vehicle_vin: "vin.",
    invalid_vin: "VIN無效，請再次設置VIN。",
    invalid_mileage: "中里線無效，請再次設置里程。",
    clean_description: "大多數沒有發生意外的車輛",
    rebuilt_description: "一輛已重建的銷售汽車",
    salvage_description: "被認為是事故發生後的總數",
    missing_description: "需要一個新的DMV問題標題",
    lien_description: "由銀行或法院定居",
    nearme: "靠近我",
    newest: "最新",
    contact_support: "聯繫支持",
    create_home_title: "銷售或租金",
    for_sale: "出售",
    for_rent: "出租",
    property_type: "財產種類",
    apartment: "公寓",
    house: "房子",
    room_only: "僅限房間",
    townhouse: "聯排別墅",
    bedrooms: "臥室",
    bathrooms: "浴室",
    property_address: "物業地址",
    price_per_month: "每月價格",
    square_feet: "平方英尺",
    year_built: "年份建成",
    year_renovated: "年份翻新",
    lot_size: "批量",
    laundry_type: "洗衣型",
    in_unit_laundry: "內部洗衣店",
    laundry_building: "在建築物的洗衣店",
    laundry_available: "洗衣店",
    none: "沒有任何",
    parking_type: "停車類型",
    garage_parking: "車庫停車",
    street_parking: "街邊停車",
    off_street_parking: "街邊停車",
    available_parking: "停車場",
    air_cond_type: "空調類型",
    ac_available: "可用",
    central_ac: "中央AC",
    heating_type: "加熱類型",
    electric_heating: "電熱",
    gas_heating: "氣體加熱",
    radiator_heating: "散熱器加熱",
    available_heating: "供暖可供選擇",
    amenities: "設施",
    date_available: "可用日期",
    lease_length: "租賃長度",
    month_to_month: "一個月到一個月",
    three_months: "3個月",
    six_months: "6個月",
    one_year: "1年",
    more_one_year: "1歲以上",
    cat_friendly: "貓友好",
    dog_friendly: "狗友好",
    balcony: "陽台",
    basement: "地下室",
    bike_parking: "自行車停車",
    cable_tv: "有線電視",
    ceiling_fan: "吊扇",
    concierge: "門房",
    dishwasher: "洗碗機",
    doorman: "門徒",
    elevator: "電梯",
    fireplace: "壁爐",
    fitness_center: "健身中心",
    garbage_disposal: "垃圾處理",
    microwave: "微波",
    online_app: "在線申請",
    oven: "烤箱",
    package_service: "包裹服務",
    patio: "露台",
    pet_park: "寵物公園",
    refrigerator: "冰箱",
    resident_lounge: "居民休息室",
    roof_deck: "屋頂平台",
    secured_entry: "擔保入境",
    storage: "貯存",
    walk_in_closet: "步入式衣櫥",
    swimming_pool: "游泳池",
    wheelchair_access: "輪椅通道",
    central_heating: "暖氣",
    invalid_bedrooms: "無效臥室，請再次設置臥室。",
    invalid_bathrooms: "浴室無效，請再次設置浴室。",
    chinese_simplified_language: "簡體中文",
    chinese_traditional_language: "中國傳統的",
    czech_language: "捷克語",
    danish_language: "丹麥語",
    dutch_language: "荷蘭人",
    finnish_language: "芬蘭",
    french_language: "法語",
    german_language: "德語",
    greek_language: "希臘語",
    hungarian_language: "匈牙利",
    indonesian_language: "印度尼西亞",
    italian_language: "意大利人",
    japanese_language: "日本人",
    korean_language: "韓國人",
    norwegian_language: "挪威",
    polish_language: "拋光",
    portuguese_language: "葡萄牙語",
    portuguese_brazilian_language: "葡萄牙語，巴西人",
    romanian_language: "羅馬尼亞人",
    russian_language: "俄語",
    swedish_language: "瑞典",
    turkish_language: "土耳其",
    ukrainian_language: "烏克蘭",
    urdu_pakistan_language: "烏爾都語（巴基斯坦）",
    vietnamese_language: "越南語",
    category_home_sale_or_rent: "銷售或租金",
    square_meter: "平方米",
    copy_text: "複製",
    copyied_to_clipboard: "複製到剪貼板",
    inbox: "收件箱",
    input_title_listening: "聽...",
    input_subtitle_listening: "說些什麼",
    input_title_error: "對不起，我們沒有完全得到。",
    input_subtitle_error: "嘗試重複您的請求。",
    input_hint_error: "再試一次",
    price_less_than_or_equal: "價格小於或等於",
    any_price: "任何價格",
    any_condition: "任何條件",
    any_time: "隨時",
    days_ago: "幾天前",
    any_distance: "任何距離",
    distance_within: "距離內",
    new_notification: "新通知",
    deleted: "刪除了",
    processing_image: "處理鏡像",
    remove_dialog_message: "你真的想刪除這個產品嗎？",
    deleted_thread: "此消息已刪除",
    category_yard_sale_event: "院子裡銷售活動",
    yard_first_date: "院子裡銷售第一日",
    yard_second_date: "院子裡銷售第二次日期",
    yard_third_date: "院子裡銷售第三日期",
    yard_start_time: "開始時間",
    yard_end_time: "時間結束",
    yard_end_timestamp: "結束時間戳",
    invalid_date1: "無效的第一個日期，請再次設置第一個日期",
    invalid_start_time: "無效的開始時間，請再次設置開始時間",
    invalid_end_time: "無效結束時間，請再次設置結束時間",
    yard_sale_title: "院子裡賣",
    garage_tag: "車庫",
    yard_tag: "院子",
    from: "從",
    to: "到",
    block: "堵塞",
    un_block: "解鎖",
    sign_email: "用電子郵件登錄",
    invalid_first_date: "首次日期無效，請確保第一次日期是第二和第三日",
    invalid_second_date: "第二次日期無效，請確認第二日在第三日之前",
    invalid_start_time_value: "無效的開始時間，請確保開始時間在結束時間之前",
    use_default_yard_photo: "使用默認庭院銷售照片",
    active_label: "積極的",
    enable_notifications: "啟用通知",
    login: "登錄",
    january: "一月",
    february: "二月",
    march: "行進",
    april: "四月",
    may: "可能",
    june: "六月",
    july: "七月",
    august: "八月",
    september: "九月",
    october: "十月",
    november: "十一月",
    december: "十二月",
    since: "自從",
    product_views: "產品觀點",
    shop_views: "商店觀點",
    total_sales: "總銷售額",
    total_orders: "總訂單",
    last_twelvth_months: "最後一個月",
    last_nine_months: "最後九個月",
    last_six_months: "過去六個月",
    last_three_months: "過去三個月",
    last_12_months: "過去12個月",
    last_9_months: "過去9個月",
    last_6_months: "過去6個月",
    last_3_months: "過去3個月",
    months: "幾個月",
    reset_password: "重設密碼",
    create_new_shop: "創造新的商店",
    download_app: "下載應用程序",
    log_in: "登錄",
    sign_up: "註冊",
    no_result: "沒有結果",
    max_price: "最高價",
    max_distance: "最大距離",
    max_time: "最大時間",
    posted_less_than: "發布少於",
    result: "結果",
    more: "更多的",
    or: "或者",
    password: "密碼",
    forgot_password: "忘記密碼？",
    and: "和",
    download_for: "下載",
    apple_ios: "蘋果ios.",
    android: "安卓",
    image: "圖片",
    edit_image: "編輯映像",
    please_complete: "請完成",
    enter_your_offer: "輸入您的優惠",
    categories: "類別",
    upload_image: "上傳圖片",
    upload_images: "上傳圖像",
    back: "後退",
    see_more: "查看更多",
    add_product: "添加產品",
    selected: "選擇",
    create: "創建",
    rate_the_buyer: "評價買方",
    delete_product: "刪除產品",
    product: "產品",
    un_block_product: "解鎖產品",
    share_your_product: "分享您的產品",
    boost_details: "提升細節",
    remove_all_products: "刪除所有產品",
    remove_all: "移除所有",
    add_vehicle: "添加車輛",
    edit_vehicle: "編輯車輛",
    upload_a_photo: "上傳一張照片",
    view_details: "查看詳情",
    add_yard_sale: "加碼銷售",
    edit_yard_sale: "編輯圍場銷售",
    users: "用戶",
    users_details: "用戶詳細信息",
    users_by_country: "用戶按國家",
    blocked_users: "阻止用戶",
    products_cards: "產品卡",
    archived_products: "存檔的產品",
    blocked_products: "封鎖產品",
    products_by_country: "產品由國家/地區",
    reports: "報告",
    reports_details: "報告詳情",
    closed_reports: "封閉式報告",
    threads: "線程",
    threads_details: "線程細節",
    chat_support: "聊天支持",
    actions: "行動",
    search_actions: "搜索操作",
    product_view_actions: "產品視圖操作",
    contact_seller_product: "聯繫賣家產品",
    contact_owner_shop: "聯繫所有者商店",
    ratings: "評分",
    reviews: "回顧",
    products_all_countries: "產品所有國家",
    edit_profile: "編輯個人資料",
    my_profile: "我的簡歷",
    profile_updated_successfully: "配置文件已成功更新",
    are_you_sure: "你確定嗎",
    my_used_products: "我的使用產品",
    my_shops: "我的商店",
    my_boosted_products: "我的提升產品",
    messages_type_message_here: "在這裡輸入你的消息",
    messages_product_sold: "該產品已售出或刪除",
    seen: "看",
    messages_never_miss_message: "永遠不要錯過留言",
    enable: "使能夠",
    send_notify: "發送通知",
    un_close: "un",
    type_your_review: "輸入您的評論",
    again_question: "再次 ？",
    ratings_already_submitted_review: "您已經提交了審核",
    open: "打開",
    set_product_category: "設置產品類別",
    auth_email_password_incorrect: "您的電子郵件或密碼不正確",
    auth_insert_your_name: "請插入您的姓名",
    auth_email_address_badly: "電子郵件地址差異很大",
    auth_email_address_used: "電子郵件地址已被另一個帳戶使用",
    auth_invalid_password: "密碼應至少為6個字符",
    auth_reset_email: "輸入您的電子郵件以重置您的密碼",
    auth_check_email: "請檢查您的電子郵件以重置密碼",
    auth_can_sign_in_google: "您可以使用Google按鈕登錄",
    auth_do_not_have_account: "你有賬號嗎？",
    auth_have_account: "你有沒有賬號？",
    log_terms_privacy_part1: "通過註冊或登錄，您同意我附近的上市",
    boost_this_product: "提升這個產品？",
    product_successfully_boosted: "該產品已成功提升",
    product_failed_boost: "該產品的增壓失敗了",
    no_products_for_sale: "您目前沒有任何銷售的使用產品。",
    not_sold_listed_near_me: "我沒有在我附近上市",
    agree_add_product:
      "通過輕敲帖子來發布您的產品，您同意我附近的服務條款和隱私政策。",
    click_to_boost: "單擊產品以提升它",
    listed_terms_of_service: "在我附近的服務條款附近",
    receive_emails_for_users: "收到用戶消息的電子郵件",
    receive_emails_for_newly_posted: "收到新發布的產品的電子郵件",
    disable_push_notifications: "禁用推送通知",
    sms_during_day: "在白天接收短信",
    sms_24_hours: "收到短信24小時",
    products: "產品",
    product_no_longer_available: "對不起，此產品已不再可用",
    add_home: "加上衣",
    edit_home: "編輯家庭",
    fill_required_fields: "填寫所有必填字段",
    no_notification: "沒有通知",
    orders_history: "訂單歷史",
    privacy: "隱私",
    terms: "條款",
    report_a_problem: "報告一個問題",
    approximation_protect_user_privacy: "近似保護用戶隱私",
    do_not_have_products: "你沒有產品",
    emails: "電子郵件",
    lead_deletion_products: "這將導致所有產品刪除",
    confirm_legal_message:
      "您只負責在與他人互動時採取所有必要的預防措施，特別是在第一次親自遇見陌生人時。有關更多詳細信息，請審核服務條款。",
    push_notifications_notified_instantly: "啟用推送通知即時通知",
    rate_seller: "利率賣方",
    user_journey: "用戶旅程",
    user: "用戶",
    user_id: "用戶身份",
    action_id: "行動ID.",
    select_model_car: "選擇汽車型號",
    boost_1_day: "提升1天",
    boost_3_days: "提升3天",
    boost_7_days: "提升7天",
    agree_boost_terms: "通過攻絲提升，您同意",
    add: "添加",
    add_tag: "添加標記",
    brand_title: "品牌",
    category_mobiles: "手機",
    category_tablets: "片劑",
    screen_size: "屏幕尺寸",
    has_cellular_capability: "具有蜂窩能力",
    default_internal_memory: "內部存儲器",
    network_carrier: "網絡承運人",
    is_unlocked: "是解鎖的",
    mobile_model_warning: "請先選擇品牌",
    missing_image: "缺少圖像，再次嘗試添加圖像。",
    add_mobile: "添加手機",
    edit_mobile: "編輯手機",
    add_tablet: "添加平板電腦",
    edit_tablet: "編輯平板電腦",
    keywords: "購物，購買，賣，賺錢，貿易，當地人，鄰居，汽車，車輛",
    country: "國家",
    phone_number: "電話號碼",
    verification_code: "驗證碼",
    error_occurred: "發生了一個錯誤。請稍後重試",
    invalid_state: "狀態無效：收到登錄回調，但未發送登錄請求。",
    sign_in: "登入",
    sign_in_apple: "用蘋果登錄",
    sign_in_google: "用谷歌登錄",
    sign_in_phone: "用手機登錄",
    sign_in_facebook: "使用Facebook登錄",
    create_account: "創建一個帳戶",
    email: "電子郵件",
    invalid_field: "請填寫必填字段",
    code_sent: "代碼已由SMS發送",
    verify_number: "驗證電話號碼",
    tapping_verify_number: "通過點擊（驗證電話號碼），發送短信。",
    email_exists:
      "該帳戶已存在，您需要通過Google按鈕，Facebook按鈕或Apple按鈕訪問它",
    ok: "行",
    sure_back: "你一定要回嗎？",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "前",
    add_model: "添加模型",
    no_search_results_us:
      "在120英里內，您附近沒有搜索結果。嘗試更改搜索過濾器或搜索關鍵字。",
    no_search_results:
      "在200公里以內的您附近沒有搜索結果。嘗試更改搜索過濾器或搜索關鍵字。",
    plan_date: "計劃日期",
    plan_time: "計劃時間",
    invalid_plan_date: "計劃日期無效，請再次設置計劃日期",
    invalid_plan_time: "無效計劃時間，請再次設置計劃時間",
    plan_name: "計劃名稱",
    plan_title: "計劃",
    update_plan_name: "更新計劃名稱",
    delete_plan_question: "您確定要刪除此計劃嗎？",
    plan_reminder_message: "一小時前提醒您",
    plan_dialog_title: "會議計劃",
    planners_title: "計劃者",
    unable_sending_messages: "當他們回到網上時，他們會看到您的消息。",
    its_text: "它是",
    for_your_text: "為您的接收器。",
  },
  cs: {
    invalid_area: "Neplatná oblast, znovu nastavte oblast.",
    invalid_lot_size:
      "Neplatná velikost vlastnosti, znovu nastavte velikost šarže.",
    property_area: "Oblast vlastnictví",
    app_store_name:
      "Uvedeno v blízkosti mě - koupit použité zboží, prodávat za hotovost",
    app_store_short:
      "Marketplace pro místní prodejce. Seznam položky k prodeji a vydělávejte peníze.",
    app_store_full:
      "V blízkosti mě je snadné najít skvělé nabídky na věcech, které chcete a vydělat peníze na věci, které chcete prodat. To je nejlepší způsob, jak koupit a prodávat ve vaší komunitě nebo sousedství s lidmi, které můžete důvěřovat. Jak to funguje: 1- koupit nebo prodat něco; Snadno zveřejnit své položky na prodej v sekundách. 2- najít skvělé nabídky a slevy na oblečení, nábytek, mobilní telefony, elektronika, dětské a děti předměty, sportovní vybavení, ojeté vozy, šaty, boty, a hodinky, knih, použité hračky, použité notebooky, z druhé ruky auto a dokonce i skutečné na prodej nebo pronájem. 3- Procházet místní položky k prodeji. 4- Zprávy kupující a prodejci z aplikace. 5- Procházet položky podle obrázku a řazení podle kategorie. Zábavné fakta o tom uvedené v blízkosti mě: 1- S uvedenými v blízkosti mě můžete snadno prodat něco, z oblečení na použité vozy do elektroniky. 2- Komunikace mezi kupujícími a prodejcemi se stane prostřednictvím aplikace prostřednictvím zasílání zpráv. 3- uvedený v blízkosti mě je lepší než prodej garáže; Najít něco, co chcete slevu, přímo na telefonu nebo tabletu.",
    app_store_release:
      "V blízkosti mě - obchod s místními obyvateli. Připojte se k mobilnímu trhu pro místní kupce a prodejce!",
    app_name: "V blízkosti mě",
    title_buy: "Koupit",
    title_messages: "Zprávy",
    title_sell: "Prodat",
    title_profile_image: "Profilový obrázek",
    title_account: "Účet",
    account_settings: "Nastavení účtu",
    settings: "Nastavení",
    color_theme: "Barevné téma",
    device_settings: "Nastavení zařízení",
    public_profile: "Veřejný profil",
    light_mode: "Světelný režim",
    dark_mode: "Tmavý režim",
    title_sell_faster: "Prodávat rychleji",
    send_button_label: "Poslat",
    rate_message: "Hodnotit mě...",
    already_rated: "Už jste odeslali recenzi",
    rate_review_question: "Chtěli byste se vypořádat",
    again: "znovu?",
    action_logout: "Odhlásit se",
    action_category: "Kategorie",
    action_search: "Vyhledávání",
    action_refer: "Odkazujte si přítele",
    dialog_choose_location: "Vyberte umístění",
    dialog_change_username: "Změnit uživatelské jméno",
    dialog_change_language: "Změnit jazyk",
    dialog_image_tags: "Image Tags.",
    dialog_emails_notifications: "Oznámení e-mailů",
    dialog_push_notifications: "Push oznámení",
    fragment_product_detail: "Detail produktu",
    fragment_message_details: "Detail zpráv",
    fragment_sell: "Prodat",
    dialog_tags_title: "Tagy",
    dialog_location_title: "Update Umístění",
    dialog_username_title: "Změnit uživatelské jméno",
    tab_photo: "Fotografie",
    tab_details: "Podrobnosti",
    tab_price: "Cena",
    tab_finish: "Dokončit",
    profile: "Profil",
    search: "Vyhledávání",
    choose_product: "Vyberte si produkt",
    rating_review: "Hodnocení a recenze",
    select_buyer: "Vyberte kupujícího",
    tab_my_used_products: "Mé produkty",
    price_label: "Cena",
    text_savings: "Ušetříš",
    search_hint: "Vyhledávání produktů ...",
    empty_text:
      "V této kategorii nejsou uvedeny žádné produkty uvedené v kategorii nebo ve vybrané vzdálenosti.",
    filter_menu_text: "Filtr",
    error_contacting_seller: "Chyba kontaktování prodávajícího",
    edit_product: "Upravit produkt.",
    contact_seller: "Kontaktovat prodejce",
    signup_to_contact_seller: "Zaregistrujte se a kontaktujte prodejce",
    signup_to_make_offer: "Zaregistrujte se a proveďte nabídku",
    product_details: "Podrobnosti",
    product_category: "Kategorie",
    product_condition: "Stav",
    product_description: "Popis",
    product_location: "Poloha produktu",
    product_location_approximate: "Umístění je přibližně přibližně",
    over_week_time_ago: "Před týdnem",
    boosted: "Posílený",
    threads_no_results: "Žádné zprávy",
    message_no_results: "Žádné zprávy",
    message_warning:
      "Jste výhradně zodpovědní za přijetí všech nezbytných opatření při interakci s ostatními, zejména při setkání s cizincem osobně poprvé. Prosím, nesdílejte žádné osobní údaje, ověřovací kódy ani žádné platební údaje. Další podrobnosti naleznete v oblasti smluvních podmínek.",
    message_block: "V tuto chvíli nelze odesílat ani přijímat zprávy.",
    select_location: "Vyberte umístění",
    location_permission_denied_message:
      "Aplikace vyžaduje povolení umístění pracovat správně.",
    signed_in: "Přihlaste se!",
    sign_in_canceller: "Přihlásit se zrušeno",
    version: "Verze",
    build: "Stavět",
    name: "název",
    location: "Umístění",
    language: "Jazyk",
    about_app: "Asi v blízkosti mě",
    terms_of_service: "Podmínky služby",
    privacy_policy: "Zásady ochrany osobních údajů",
    report_feedback: "Poslat zpětnou vazbu",
    report_bug: "Potřást telefonu Chcete-li hlásit chybu",
    change_image: "Změnit obrázek",
    update_location: "Update Umístění",
    about_the_app: "O aplikaci",
    update_label: "Aktualizace",
    uploading: "Nahrávání",
    adding: "Přidání listu",
    removing: "Odstranění seznamu",
    updating: "Aktualizace seznamu",
    uploaded_image: "Nahravý obraz:",
    image_storage_failed: "Nepodařilo se uložit obrázek:",
    product_updated: "Produkt úspěšně aktualizován",
    location_error: "Umístění není uloženo, zkuste to prosím znovu",
    product_removed: "Produkt byl úspěšně odstraněn",
    deleted_product: "Tento produkt se vymaže",
    invalid_title: "Neplatný název, znovu nastavte titul znovu.",
    invalid_image: "Neplatná cesta obrazu zkuste znovu přidat obrázek.",
    invalid_price: "Neplatná cena, prosím, nastavte cenu znovu.",
    invalid_location: "Neplatné místo, znovu nastavte umístění.",
    invalid_category: "Neplatná kategorie, znovu nastavte kategorii.",
    invalid_condition: "Neplatný stav, znovu nastavte stav.",
    removing_title: "Vyjmutí profilu Image.",
    image_not_saved: "Uložení obrázku se nezdařilo!",
    product_load_failed: "Žádné produkty",
    take_photo: "Vyfotit",
    select_photo: "Vyberte Photo.",
    product_title_hint: "Co je to? Jméno, značka, model atd.",
    delete_photo: "Smazat foto",
    product_title: "Titul",
    mark_as_sold: "Označit jako prodané",
    product_share: "Podíl",
    product_make_offer: "Vytvořte nabídku",
    product_cover: "Nastavit jako kryt",
    product_tags: "Tagy",
    product_posted: "Vyslán:",
    product_change: "Změna",
    product_post: "Pošta",
    product_selling_from: "Prodej z umístění",
    product_select_location: "Vyberte umístění",
    product_map_approximate: "Mapa je přibližná umístění prodávajícího",
    product_terms:
      "Odebírací příspěvek pro publikování vašeho produktu, souhlasíte s <U> uvedeny v blízkosti ME Service. </ U>",
    condition_other: "Ostatní (viz popis)",
    condition_for_parts: "Pro díly",
    condition_used: "(Normální opotřebení)",
    condition_open_box: "Otevřete box (nikdy nepoužívaný)",
    condition_reconditioned: "Rekonstrukce / certifikováno",
    condition_new: "Nové (nikdy nepoužívané)",
    select_category: "vybrat kategorii",
    select_all_category: "Vybrat vše",
    category_loading_error:
      "Nelze aktualizovat seznam kategorií, zkuste to prosím znovu později.",
    category_vehicles: "Vozidla",
    category_furniture: "Nábytek",
    category_electronics: "Elektronika",
    category_appliances: "Domů &  Spotřebiče",
    category_fashion_accessories: "Móda &  Příslušenství",
    category_baby_kids: "Baby &  Děti",
    category_antiques_collectibles: "Starožitnosti a  Sběratelské předměty",
    category_auto_parts_tools_machinery: "Auto díly, nástroje a  Stroje",
    category_sports_outdoors: "Sport &  Venku",
    category_others: "Ostatní",
    location_enter_zip_code: "Zadejte PSČ",
    location_get_current_location: "Získejte aktuální polohu",
    location_select_location: "Vyberte umístění",
    location_update_location: "Update Umístění",
    location_new_location: "Nové umístění",
    search_filter_results: "Výsledky filtru",
    search_filter_min: "Minimálně filtr",
    search_filter_at_least: "Alespoň",
    price_filter: "Cenový filtr",
    product_name: "jméno výrobku",
    english_language: "Angličtina",
    arabic_language: "arabština",
    spanish_language: "španělština",
    system_language: "Systém",
    share_link: "Sdílet odkaz",
    save: "Uložit",
    cancel: "zrušení",
    loading: "načítání",
    yes: "Ano",
    no: "Ne",
    report: "Zpráva",
    report_product: "Zpráva Produkt",
    report_user: "Nahlásit uživatele",
    block_user: "Zablokovat uživatele",
    un_block_user: "Odblokovat uživatele",
    why_product: "Proč chcete tuto položku oznámit?",
    why_user: "Proč chcete tento uživatel hlásit?",
    block_user_confirm: "Chcete tento uživatel trvale blokovat?",
    un_block_user_confirm: "Chcete trvale odblokovat tento uživatel?",
    prohibited: "Zakázáno na základě mě",
    offensive: "Urážlivé nebo nevhodné",
    duplicate: "Duplicitní příspěvek",
    wrong_category: "Špatná kategorie",
    scam: "Vypadá jako podvod",
    stolen: "Myslím, že je ukraden",
    product_other: "jiný",
    product_is_sold: "Tento produkt byl prodán",
    missed_meeting: "Zůstali naše setkání",
    low_offer: "Nízkou nabídku",
    rude: "Hrubý nebo nevhodný",
    items: "Problém s položkami",
    trouble_meetup: "Problémy se setkat",
    messaging: "Problémy s zasíláním zpráv",
    user_other: "jiný",
    new_version_available: "Nová verze je k dispozici",
    please_update_app:
      "Chcete-li pokračovat, aktualizujte aplikaci na novou verzi.",
    update: "Aktualizace",
    no_thanks: "Ne, díky",
    contact_support_confirmation:
      "Aktuální doba odezvy je 24-48 hodin. Chcete kontaktovat blízko ME APP Chat Support?",
    unboost_confirmation: "Opravdu chcete tento výrobek uniknout?",
    no_used_products: "Ještě nemáte žádné záznamy",
    no_boosted_products: "Nemáte žádné zvyšované produkty",
    next: "další",
    previous: "Předchozí",
    skip: "Přeskočit",
    start: "Start",
    list_used: "Seznam použitého produktu",
    buy_description: "Objevte a hledat produkty nabízené sousedy kolem vás",
    sell_description: "Seznam produktů, které již nepotřebujete k prodeji",
    list_used_description:
      "Seznam použitého produktu pro prodej za méně než 20 sekund",
    boost_product_option_1: "<b> boost 1 nday </ b> n <b> $ 0.99 </ b>",
    boost_product_option_2: "<b> boost 3 ndays </ b> n <b> $ 1,99 </ b>",
    boost_product_option_3: "<b> boost 7 ndays </ b> n <b> $ 3.99 </ b>",
    boost_product_description:
      "Získejte každý den více pohledů. Vaše položka se zobrazí v nejformovaných pozicích v rámci top 30 položek v nákupu a kategorii. Propagované položky se otočí mezi určené skvrny, takže každá položka dostane spravedlivou expozici.",
    boost_cta: "Prodávat rychleji",
    boost_terms:
      "Tím, že Boost souhlasíte s <U> uvedeny v blízkosti ME Service. </ U>",
    boost_best_value: "Nejlepší hodnota",
    already_boosted: "Tento výrobek je posílen",
    clicks: "Kliknutí",
    impressions: "Dojmy",
    end: "Konec",
    transactions_empty_text:
      "Ještě nemáte žádné boost transakce. Můžete navštívit kartu Prodat a začněte posílit své produkty.",
    transactions_loading_error:
      "Nelze aktualizovat seznam transakcí, zkuste to prosím znovu později.",
    transactions_history_title: "Zvyšte historii transakcí",
    communicative_postive: "Komunikativní",
    communicative_negative: "Nekomunikativní",
    ontime_postive: "Včas",
    ontime_negative: "Pozdě",
    reliable_postive: "Spolehlivý",
    reliable_negative: "Nespolehlivý",
    friendly_postive: "Přátelský",
    friendly_negative: "Nezdvořilý",
    itemasdescribed_postive: "Položka popsaná",
    itemasdescribed_negative: "Položka není popsána",
    other: "jiný",
    submit: "Předložit",
    adding_rating_reviews: "Přidání hodnocení a recenzí",
    no_internet_title: "Žádné internetové připojení",
    no_internet_message:
      "Ujistěte se, že jste připojeni k Internetu a zkuste to znovu",
    retry: "Opakovat se",
    near_me: "Blízko mne",
    newest_first: "Nejnovější první",
    miles: "míle",
    km: "km",
    similar_products: "Podobné produkty",
    favorite_products: "Oblíbené produkty",
    items_for_sale: "položky na prodej",
    joined: "Připojený",
    favorites_transactions_title: "Favorites.",
    boosted_products_transactions_history: "Historie transakcí produktů",
    views: "Pohledy",
    boost_graph_title: "Zvyšte graf",
    no_favorite_products: "Nemáte žádné oblíbené produkty",
    make_offer_buy: "Chtěl bych si koupit",
    make_offer_buy_for: "pro",
    notifications: "Oznámení",
    push_notifications: "Tam",
    emails_notifications: "E-mailem",
    apply: "Aplikovat",
    email_messages: "E-mail pro zprávy",
    email_new_products: "E-mail pro nové produkty",
    push_day_only: "Pouze den oznámení",
    push_24_hours: "Push oznámení 24 hodin",
    edit: "Upravit",
    map: "Mapa",
    camera: "Fotoaparát",
    gallery: "Galerie",
    delete: "Vymazat",
    no_sell_items: "Žádné položky na prodej",
    who_bought_question: "Kdo to koupil?",
    sold_elsewhere_question: "Prodal to někde jinde",
    confirm: "Potvrdit",
    over_limit_camera: "Nemůžete přidat více než pět snímků",
    boost_failed: "Boost selhal. Prosím zkuste to znovu později",
    after_purchase: "Úspěšná platba NProdukt zesílená",
    pay_failed: "Platba selhala. Prosím zkuste to znovu",
    done: "Hotovo",
    not_now: "Teď ne",
    boost: "Boost.",
    invalid_zip_code: "Neplatný PSČ",
    invalid_user_name: "Neplatné uživatelské jméno",
    comments: "Komentáře",
    questions: "Otázky",
    bug_reports: "Zprávy o chybách",
    feature_request: "Budoucí žádost",
    feedback_type: "Typ zpětné vazby",
    feedback_description:
      "Rádi bychom slyšeli vaše myšlenky nebo zpětnou vazbu o tom, jak můžeme zlepšit vaše zkušenosti!",
    feedback: "Zpětná vazba",
    feedback_text: "Tvoje odpověď",
    suggestions: "Návrhy na zlepšení",
    delete_account: "Smazat účet",
    new_message: "Nová zpráva",
    online: "Online",
    km_50: "50 km",
    km_100: "100 km",
    km_200: "200 km",
    miles_30: "30 mil",
    miles_60: "60 mil",
    miles_120: "120 mil",
    rate_app_question: "A co hodnocení v App Store, pak?",
    enjoying_question: "Těší se v blízkosti mě?",
    not_enjoy: "Spíš ne",
    feedback_question: "Vadilo by vám, že nám dáte nějakou zpětnou vazbu?",
    yes_sure: "OK Jistě",
    product_available_question: "Ahoj, je to stále k dispozici?",
    buy_question: "Ahoj, mám to koupit",
    meet_question: "Ahoj, můžete se dnes setkat?",
    follow: "Následovat",
    followers: "Následovníci",
    following: "Následující",
    feedback_thanks: "Děkujeme za vaši odezvu",
    all_categories: "Všechny kategorie",
    deleted_account: "Tento účet je vymazán",
    delete_account_question: "Opravdu chcete tento účet smazat?",
    no_followings: "Následuje nikoho",
    when_following: "když",
    no_followings_subtitle: "Sleduje lidi, uvidíte je zde",
    no_followers: "nemá následovníci",
    no_followers_subtitle: "následují lidé, uvidíte je zde",
    distance: "Vzdálenost",
    filter_method: "Metoda filtru",
    see_listings: "Viz záznamy",
    sold: "Prodaný",
    bought: "Koupil",
    no_notifications: "Když obdržíte oznámení, objeví se zde",
    items_title: "Položky",
    new_listing_title: "Vytvořit nový seznam",
    dialog_year_title: "Rok",
    dialog_make_title: "Udělat",
    dialog_model_title: "Modelka",
    dialog_body_style_title: "Styl těla",
    dialog_exterior_color_title: "Exteriérová barva",
    dialog_interior_color_title: "Interiérová barva",
    dialog_transmission_title: "Přenos",
    dialog_fuel_type_title: "Typ paliva",
    dialog_owners_num_title: "Počet vlastníků",
    dialog_vehicle_owed_money_title:
      "Je tam peníze ještě dlužné na tomto vozidle?",
    automatic_transmission: "Automatický",
    manual_transmission: "Manuál",
    not_sure: "Nejsem si jistý",
    wagon_hatchback: "Vůz &  Hatchback",
    convertible: "Konvertibilní",
    coupe: "Kupé",
    sedan: "Sedan.  t",
    black_color: "Černá",
    blue_color: "Modrý",
    brown_color: "Hnědý",
    gold_color: "Zlato",
    green_color: "Zelená",
    grey_color: "Šedá",
    pink_color: "Růžový",
    purple_color: "Nachový",
    red_color: "Červené",
    silver_color: "stříbrný",
    orange_color: "oranžový",
    white_color: "Bílý",
    yellow_color: "Žlutá",
    charcol_color: "Charcol.",
    fuel_diesel: "Deesel.",
    fuel_electric: "Elektrický",
    fuel_gasoline: "Benzín",
    fuel_flex: "Flex",
    fuel_hybrid: "Hybridní",
    fuel_petrol: "Benzín",
    fuel_plugin_hybrid: "Plug-in hybrid",
    truck: "Truck",
    van_minivan: "Van &  Minivan.",
    suv_crossover: "SUV &  Crossover",
    awd_4wd: "AWD / 4WD.",
    fwd: "Fwd.",
    rwd: "Rwd.",
    off_white_color: "Vypnuto White.",
    tan_color: "Opálení",
    beige_color: "Béžový",
    burgundy_color: "burgundské",
    turquoise_color: "Tyrkysový",
    title_status_clean: "Čistý",
    title_status_rebuilt: "Přestavěn",
    title_status_salvage: "Zachránit",
    title_status_missing: "Chybějící",
    title_status_lien: "Lien.",
    title_status: "Stav titulů",
    mileage: "Kilometru",
    dialog_drivetrain_title: "Drivetrain",
    model_warning: "Vyberte prosím první",
    required_field_warning: "Toto pole je povinné",
    vehicle_vin: "Vin",
    invalid_vin: "Neplatný vin, prosím, nastavte znovu vin.",
    invalid_mileage:
      "Neplatný počet kilometrů, prosím, nastavte znovu kilometr.",
    clean_description: "Většina vozidel, která nebyla v nehodě",
    rebuilt_description: "Zachráněný auto, které bylo přestavěno",
    salvage_description: "Po nehodě",
    missing_description: "Bude potřebovat nové otázky DMV",
    lien_description: "Vlastnictví banky nebo soudu",
    nearme: "Blízko mne",
    newest: "Nejnovější",
    contact_support: "Kontaktujte podporu",
    create_home_title: "Domy na prodej nebo pronájem",
    for_sale: "Na prodej",
    for_rent: "K pronájmu",
    property_type: "Typ majetku",
    apartment: "Byt",
    house: "Dům",
    room_only: "Jen pokoj",
    townhouse: "Městský dům",
    bedrooms: "Ložnice",
    bathrooms: "Koupelny",
    property_address: "Adresa vlastnictví",
    price_per_month: "Cena za měsíc",
    square_feet: "Čtvereční stopa",
    year_built: "Postavený rok",
    year_renovated: "Renovovaný rok",
    lot_size: "Velikost pozemku",
    laundry_type: "Typ prádla",
    in_unit_laundry: "Prádelna v jednotce",
    laundry_building: "Prádelna v budově",
    laundry_available: "Praní prádla",
    none: "Žádný",
    parking_type: "Parkovací typ",
    garage_parking: "Garážové stání",
    street_parking: "Parkování na ulici",
    off_street_parking: "Parkování mimo ulici",
    available_parking: "Parkování dostupné",
    air_cond_type: "Typ klimatizace",
    ac_available: "AC k dispozici",
    central_ac: "Centrální AC.",
    heating_type: "Typ topení",
    electric_heating: "Elektrické topení",
    gas_heating: "Plynový topení",
    radiator_heating: "Topení chladiče",
    available_heating: "Topení k dispozici",
    amenities: "Vybavení",
    date_available: "Datum k dispozici",
    lease_length: "Délka leasingu",
    month_to_month: "Měsíc od měsíce",
    three_months: "3 měsíce",
    six_months: "6 měsíců",
    one_year: "1 rok",
    more_one_year: "1+ let",
    cat_friendly: "Kočka přátelský",
    dog_friendly: "Psí přátelský",
    balcony: "Balkón",
    basement: "Suterén",
    bike_parking: "Parkování na kole",
    cable_tv: "Kabelová televize",
    ceiling_fan: "Stropní větrák",
    concierge: "Concierge",
    dishwasher: "Myčka",
    doorman: "Vrátný",
    elevator: "Výtah",
    fireplace: "Krb",
    fitness_center: "Fitness centrum",
    garbage_disposal: "Likvidace odpadků",
    microwave: "Mikrovlnná trouba",
    online_app: "Online Application.",
    oven: "Trouba",
    package_service: "Služba balíčku",
    patio: "Patio",
    pet_park: "Pet park",
    refrigerator: "Lednička",
    resident_lounge: "Rezidentní lounge",
    roof_deck: "Střešní balíček",
    secured_entry: "Zajištěný vstup",
    storage: "Úložný prostor",
    walk_in_closet: "Šatna",
    swimming_pool: "Plavecký bazén",
    wheelchair_access: "Bezbariérový přístup",
    central_heating: "Ústřední topení",
    invalid_bedrooms: "Neplatné ložnice, prosím, znovu nastavte ložnice.",
    invalid_bathrooms: "Neplatné koupelny, znovu nastavit koupelny.",
    chinese_simplified_language: "Zjednodušená čínština",
    chinese_traditional_language: "Čínská tradiční",
    czech_language: "čeština",
    danish_language: "dánština",
    dutch_language: "holandský",
    finnish_language: "Finština",
    french_language: "francouzština",
    german_language: "Němec",
    greek_language: "řecký",
    hungarian_language: "maďarský",
    indonesian_language: "indonéština",
    italian_language: "italština",
    japanese_language: "japonský",
    korean_language: "korejština",
    norwegian_language: "Norwegian.",
    polish_language: "polština",
    portuguese_language: "portugalština",
    portuguese_brazilian_language: "Portugalština, Brazilština",
    romanian_language: "rumunština",
    russian_language: "ruština",
    swedish_language: "švédský",
    turkish_language: "turečtina",
    ukrainian_language: "ukrajinština",
    urdu_pakistan_language: "Urdu (Pákistán)",
    vietnamese_language: "vietnamština",
    category_home_sale_or_rent: "Domov pro prodej nebo pronájem",
    square_meter: "Metr čtvereční",
    copy_text: "kopírovat",
    copyied_to_clipboard: "Zkopírován do schránky",
    inbox: "Doručená pošta",
    input_title_listening: "Naslouchání…",
    input_subtitle_listening: "Řekni něco",
    input_title_error: "Promiň, že jsme to dostali docela.",
    input_subtitle_error: "Zkuste opakovat svůj požadavek.",
    input_hint_error: "Zkus to znovu",
    price_less_than_or_equal: "Cena menší nebo rovna",
    any_price: "Jakákoli cena",
    any_condition: "Jakýkoliv stav",
    any_time: "Kdykoliv.",
    days_ago: "před pár dny",
    any_distance: "Jakákoliv vzdálenost",
    distance_within: "Vzdálenost",
    new_notification: "Nové oznámení",
    deleted: "Smazaný",
    processing_image: "Zpracování obrazu",
    remove_dialog_message: "Opravdu chcete tento produkt odstranit?",
    deleted_thread: "Tato zpráva je vymazána",
    category_yard_sale_event: "Událost výprodeje YARD.",
    yard_first_date: "První den YARD",
    yard_second_date: "Druhý den yard",
    yard_third_date: "YARD PRODEJ TRÁTO DATUM",
    yard_start_time: "Doba spuštění",
    yard_end_time: "Konec času",
    yard_end_timestamp: "Konec časová značka",
    invalid_date1: "Neplatný první datum, nastavte prosím první datum znovu",
    invalid_start_time: "Neplatný čas spuštění, znovu nastavte čas začátku",
    invalid_end_time: "Neplatný čas ukončení, znovu nastavte čas ukončení",
    yard_sale_title: "Výprodej",
    garage_tag: "garáž",
    yard_tag: "yard",
    from: "Z",
    to: "Na",
    block: "Blok",
    un_block: "Odblokovat",
    sign_email: "Přihlaste se s e-mailem",
    invalid_first_date:
      "Neplatné první datum, ujistěte se, že první datum je před druhým a třetím",
    invalid_second_date:
      "Neplatný druhý datum, ujistěte se, že druhé datum je před třetím datem",
    invalid_start_time_value:
      "Neplatný čas začátku, ujistěte se, že čas spuštění je před ukončením času",
    use_default_yard_photo: "Použijte výchozí prodej na yard photo",
    active_label: "Aktivní",
    enable_notifications: "Povolit oznámení",
    login: "Přihlásit se",
    january: "leden",
    february: "Únor",
    march: "březen",
    april: "duben",
    may: "Smět",
    june: "červen",
    july: "červenec",
    august: "srpen",
    september: "září",
    october: "říjen",
    november: "listopad",
    december: "prosinec",
    since: "Od té doby",
    product_views: "Zobrazení produktu",
    shop_views: "Obchod s výhledem",
    total_sales: "Celkový prodej",
    total_orders: "Celkem objednávky",
    last_twelvth_months: "Poslední dvanáct měsíců",
    last_nine_months: "Posledních devět měsíců",
    last_six_months: "Posledních šest měsíců",
    last_three_months: "Poslední tři měsíce",
    last_12_months: "Posledních 12 měsíců",
    last_9_months: "Posledních 9 měsíců",
    last_6_months: "Posledních 6 měsíců",
    last_3_months: "Poslední 3 měsíce",
    months: "Měsíce",
    reset_password: "Obnovit heslo",
    create_new_shop: "Vytvořit nový obchod",
    download_app: "Stáhnout aplikaci",
    log_in: "Přihlásit se",
    sign_up: "Přihlásit se",
    no_result: "Žádný výsledek",
    max_price: "Max Cena",
    max_distance: "Maximální vzdálenost",
    max_time: "Maximální čas",
    posted_less_than: "Publikováno méně než",
    result: "Výsledek",
    more: "Více",
    or: "NEBO",
    password: "Heslo",
    forgot_password: "Zapomenuté heslo?",
    and: "a",
    download_for: "Stáhnout For",
    apple_ios: "Apple ios.",
    android: "Android.",
    image: "obraz",
    edit_image: "Upravit obrázek",
    please_complete: "Prosím dokončete",
    enter_your_offer: "Zadejte svou nabídku",
    categories: "Kategorie",
    upload_image: "Nahrát obrázek",
    upload_images: "Nahrát obrázky",
    back: "Zadní",
    see_more: "Vidět víc",
    add_product: "Přidat produkt",
    selected: "Vybraný",
    create: "Vytvořit",
    rate_the_buyer: "Hodnotit kupujícího",
    delete_product: "Smazat produkt",
    product: "Produkt",
    un_block_product: "Odblokovat produkt",
    share_your_product: "Sdílejte svůj produkt",
    boost_details: "Podrobnosti o zvýšení",
    remove_all_products: "Odstraňte všechny produkty",
    remove_all: "Odebrat všechny",
    add_vehicle: "Přidat vozidlo",
    edit_vehicle: "Upravit vozidlo",
    upload_a_photo: "Nahrát fotografii",
    view_details: "Zobrazit podrobnosti",
    add_yard_sale: "Přidat prodej na yard.",
    edit_yard_sale: "Upravit prodej na yard.",
    users: "Uživatelé",
    users_details: "Podrobnosti o uživateli",
    users_by_country: "Uživatelé podle země",
    blocked_users: "Blokované uživatele",
    products_cards: "Produkty karet",
    archived_products: "Archivované produkty",
    blocked_products: "Blokované produkty",
    products_by_country: "Produkty podle země",
    reports: "Zpráva",
    reports_details: "Přehledy podrobnosti",
    closed_reports: "Uzavřené přehledy",
    threads: "Vlákna",
    threads_details: "Podrobnosti vláken",
    chat_support: "Podpora chatu",
    actions: "Akce",
    search_actions: "Hledat akce",
    product_view_actions: "Akce zobrazení produktu",
    contact_seller_product: "Kontakt Prodejce Produkt.",
    contact_owner_shop: "Kontaktní vlastník obchod",
    ratings: "Ratings.",
    reviews: "Recenze",
    products_all_countries: "Produkty Všechny země",
    edit_profile: "Upravit profil",
    my_profile: "Můj profil",
    profile_updated_successfully: "Profil úspěšně aktualizován",
    are_you_sure: "jsi si jistá",
    my_used_products: "Mé použité produkty",
    my_shops: "Moje obchody",
    my_boosted_products: "Moje posílené produkty",
    messages_type_message_here: "zde Napište svou zprávu",
    messages_product_sold: "Tento produkt se prodává nebo odstraní",
    seen: "Viděný",
    messages_never_miss_message: "Nikdy nezmeškáte zprávu",
    enable: "Umožnit",
    send_notify: "Poslat oznámit",
    un_close: "Neuzavřený",
    type_your_review: "Zadejte své recenze",
    again_question: "znovu ?",
    ratings_already_submitted_review: "Už jste odeslali recenzi",
    open: "Otevřeno",
    set_product_category: "Nastavit kategorii produktu",
    auth_email_password_incorrect: "Nesprávné e-maily nebo heslo",
    auth_insert_your_name: "Vložte své jméno",
    auth_email_address_badly: "E-mailová adresa je špatně formátovaná",
    auth_email_address_used: "E-mailová adresa je již používána jiným účtem",
    auth_invalid_password: "Heslo by mělo být nejméně 6 znaků",
    auth_reset_email: "Zadejte svůj e-mail pro obnovení hesla",
    auth_check_email: "Zkontrolujte prosím svůj e-mail pro obnovení hesla",
    auth_can_sign_in_google: "Můžete se přihlásit pomocí tlačítka Google",
    auth_do_not_have_account: "Nemáte účet?",
    auth_have_account: "Máte účet?",
    log_terms_privacy_part1:
      "Přihlášením nebo přihlášením souhlasíte s uvedeným v blízkosti mě",
    boost_this_product: "Zvyšte tento produkt?",
    product_successfully_boosted: "Produkt byl úspěšně posílen",
    product_failed_boost: "Produkt byl neúspěšný v podpoře",
    no_products_for_sale:
      "V současné době nemáte žádné použité produkty uvedené na prodej.",
    not_sold_listed_near_me: "Neprodal jsem to na seznamu",
    agree_add_product:
      "Odebírací příspěvek pro publikování vašeho produktu, souhlasíte s uvedenými podmínkami Service a zásad ochrany osobních údajů.",
    click_to_boost: "Kliknutím na produkt jej posílil",
    listed_terms_of_service: "Uvedeno v blízkosti Služby ME",
    receive_emails_for_users: "Přijímat e-maily pro zprávy uživatelů",
    receive_emails_for_newly_posted:
      "Přijímat e-maily pro vaše nově zveřejněné produkty",
    disable_push_notifications: "Zakázat push oznámení",
    sms_during_day: "Přijměte SMS během dne",
    sms_24_hours: "Přijímat SMS 24 hodin",
    products: "produkty",
    product_no_longer_available:
      "Je nám líto, tento výrobek již není k dispozici",
    add_home: "Přidat domů",
    edit_home: "Upravit domů",
    fill_required_fields: "Vyplňte všechna požadovaná pole",
    no_notification: "Neexistují žádná oznámení",
    orders_history: "Historie objednávek",
    privacy: "Soukromí",
    terms: "Podmínky",
    report_a_problem: "Nahlásit problém",
    approximation_protect_user_privacy:
      "Aproximace pro ochranu soukromí uživatele",
    do_not_have_products: "Nemáte produkty",
    emails: "E-maily",
    lead_deletion_products: "To povede k vymazání všech vašich produktů",
    confirm_legal_message:
      "Jste výhradně zodpovědný za přijetí všech nezbytných bezpečnostních opatření při interakci s ostatními, zejména při setkání s cizincem osobně poprvé. Pro více informací prosím přečtěte podmínky služby.",
    push_notifications_notified_instantly: "Povolit okamžitě oznámit oznámení",
    rate_seller: "Hodnotit prodejce",
    user_journey: "Uživatelská cesta",
    user: "Uživatel",
    user_id: "Uživatelské ID",
    action_id: "ID akce",
    select_model_car: "Vyberte model auta",
    boost_1_day: "Boost 1 Day.",
    boost_3_days: "Boost 3 dny",
    boost_7_days: "Zvyšte 7 dní",
    agree_boost_terms: "Tím, že se posílíte, souhlasíte",
    add: "Přidat",
    add_tag: "Přidat značku",
    brand_title: "Značka",
    category_mobiles: "Mobilní telefony",
    category_tablets: "Tablety",
    screen_size: "Velikost obrazovky",
    has_cellular_capability: "Má buněčnou schopnost",
    default_internal_memory: "Vnitřní paměť",
    network_carrier: "Síťový dopravce",
    is_unlocked: "Je odemčena",
    mobile_model_warning: "Nejdříve vyberte Značku",
    missing_image: "Chybí obraz, zkuste znovu přidat obrázek.",
    add_mobile: "Přidat mobilní telefon",
    edit_mobile: "Upravit mobilní telefon",
    add_tablet: "Přidat tableta",
    edit_tablet: "Upravit tabletu",
    keywords:
      "nakupování, nakupovat, prodávat, vydělat peníze, obchod, místní obyvatelé, sousedé, auto, vozidla",
    country: "Země",
    phone_number: "Telefonní číslo",
    verification_code: "Ověřovací kód",
    error_occurred: "Vyskytla se chyba. Zkuste to prosím později",
    invalid_state:
      "Neplatný stav: Přijetí přihlašovacího zpětného volání bylo přijato, ale nebyl odeslán žádný požadavek na přihlášení.",
    sign_in: "Přihlásit se",
    sign_in_apple: "Přihlaste se s Apple",
    sign_in_google: "Přihlaste se pomocí Google",
    sign_in_phone: "Přihlaste se pomocí telefonu",
    sign_in_facebook: "Přihlásit se pomocí Facebooku",
    create_account: "Vytvořit účet",
    email: "E-mailem",
    invalid_field: "Vyplňte prosím požadovaná pole",
    code_sent: "Kodex byl odeslán SMS",
    verify_number: "Ověřte telefonní číslo",
    tapping_verify_number:
      "Poklepáním (Ověřte telefonní číslo), SMS je odeslána.",
    email_exists:
      "Účet již existuje a musíte se k němu přistupovat přes tlačítko Google, tlačítko Facebook nebo tlačítko Apple",
    ok: "OK",
    sure_back: "Jste si jistý, že se vrátíte?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "před",
    add_model: "Přidat model.",
    no_search_results_us:
      "Žádné výsledky vyhledávání ve vašem okolí do 120 mil. Zkuste změnit vyhledávací filtr nebo klíčové slovo vyhledávání.",
    no_search_results:
      "Žádné výsledky vyhledávání ve vašem okolí do 200 km. Zkuste změnit vyhledávací filtr nebo klíčové slovo vyhledávání.",
    plan_date: "Datum plánu",
    plan_time: "Plánovat čas",
    invalid_plan_date:
      "Neplatné datum plánu, prosím nastavte datum plánu znovu",
    invalid_plan_time: "Neplatný čas plánu, nastavte prosím čas plánu",
    plan_name: "Název plánu",
    plan_title: "Plán",
    update_plan_name: "Aktualizovat název plánu",
    delete_plan_question: "Jste si jisti, že chcete tento plán odstranit?",
    plan_reminder_message: "Předtím vám bude připomenout",
    plan_dialog_title: "Plán setkání",
    planners_title: "Plánovači",
    unable_sending_messages: "Uvidí vaše zprávy, až budou zpět online.",
    its_text: "Své",
    for_your_text: "pro váš přijímač.",
  },
  da: {
    invalid_area: "Ugyldigt område, bedes du sætte området igen.",
    invalid_lot_size:
      "Ugyldig ejendomsartstørrelse, bedes du sætte meget størrelse igen.",
    property_area: "Ejendomsområde",
    app_store_name:
      "Opført i nærheden af ​​mig - køb brugte varer, sælge til kontanter",
    app_store_short:
      "En markedsplads for lokale sælgere. Angiv et emne til salg og tjene penge.",
    app_store_full:
      "Opført i nærheden af ​​mig gør det nemt at finde gode tilbud på de ting, du vil have, og tjene penge på de ting, du vil sælge. Dette er den bedste måde at købe og sælge i dit fællesskab eller kvarter med folk, du kan stole på. Hvordan det virker: 1- Køb eller Sælg noget; Send nemt dine varer til salg i sekunder. 2- Find gode tilbud og rabatter på tøj, møbler, mobiltelefoner, elektronik, baby og kids, sportsudstyr, brugte biler, kjoler, sko og ure, til bøger, brugt legetøj, brugte bærbare computere, en brugte bil og endda reel ejendom til salg eller leje. 3- Gennemse lokale varer til salg. 4- Message købere og sælgere fra appen. 5- Gennemse elementer efter billede og sorter efter kategori. Sjove fakta om noteret i nærheden af ​​mig: 1- Med noteret i nærheden af ​​mig kan du nemt sælge noget, fra tøj til brugte biler til elektronik. 2- Kommunikation mellem købere og sælgere sker gennem appen via messaging. 3- Listet i nærheden af ​​mig er bedre end et garage salg; Find alt, hvad du vil have til en rabat, lige på din telefon eller tablet.",
    app_store_release:
      "Opført i nærheden af ​​mig - Handel med lokalbefolkningen. Deltag i mobilmarkedet for lokale købere og sælgere!",
    app_name: "Opført i nærheden af ​​mig",
    title_buy: "Købe",
    title_messages: "Beskeder",
    title_sell: "Sælge",
    title_profile_image: "Profilbillede.",
    title_account: "Konto",
    account_settings: "Bruger indstillinger",
    settings: "Indstillinger.",
    color_theme: "Farve tema.",
    device_settings: "Enhedsindstillinger.",
    public_profile: "Offentlig profil",
    light_mode: "Let tilstand",
    dark_mode: "Mørk tilstand",
    title_sell_faster: "Sælge hurtigere",
    send_button_label: "Sende",
    rate_message: "Bedøm mig...",
    already_rated: "Du har allerede sendt anmeldelse",
    rate_review_question: "Vil du gerne beskæftige dig med",
    again: "igen?",
    action_logout: "Log ud",
    action_category: "Kategori",
    action_search: "Søg",
    action_refer: "Henvis en ven",
    dialog_choose_location: "Vælg Placering",
    dialog_change_username: "Skift brugernavn",
    dialog_change_language: "Skift sprog",
    dialog_image_tags: "Billedmærke",
    dialog_emails_notifications: "E-mails notifikationer",
    dialog_push_notifications: "Push notifications.",
    fragment_product_detail: "Produktdetalje.",
    fragment_message_details: "Meddelelser detaljer",
    fragment_sell: "Sælge",
    dialog_tags_title: "Tags.",
    dialog_location_title: "Opdater placering",
    dialog_username_title: "Skift brugernavn",
    tab_photo: "Foto",
    tab_details: "detaljer",
    tab_price: "Pris",
    tab_finish: "Afslut",
    profile: "Profil",
    search: "Søg",
    choose_product: "Vælg produkt",
    rating_review: "Bedømmelse og gennemgang",
    select_buyer: "Vælg en køber.",
    tab_my_used_products: "Mine produkter.",
    price_label: "Pris",
    text_savings: "Du redder",
    search_hint: "Søg efter produkter ...",
    empty_text:
      "Der er ingen produkter opført i denne kategori eller inden for den valgte afstand.",
    filter_menu_text: "Filter",
    error_contacting_seller: "Fejl ved at kontakte sælger",
    edit_product: "Rediger produkt",
    contact_seller: "Kontakt sælger",
    signup_to_contact_seller: "Tilmeld dig for at kontakte sælger",
    signup_to_make_offer: "Tilmeld dig for at lave tilbud",
    product_details: "detaljer",
    product_category: "Kategori",
    product_condition: "Tilstand",
    product_description: "Beskrivelse",
    product_location: "Produkt placering",
    product_location_approximate: "Placering er omtrentlig",
    over_week_time_ago: "Over en uge siden",
    boosted: "Boosted.",
    threads_no_results: "Ingen beskeder.",
    message_no_results: "Ingen beskeder.",
    message_warning:
      "Du er alene ansvarlig for at tage alle nødvendige forholdsregler, når du interagerer med andre, især når du møder en fremmed person for første gang. Del ikke nogen personlige oplysninger, verifikationskoder eller betalingsoplysninger. Gennemgå servicevilkår for flere detaljer.",
    message_block:
      "Du kan ikke sende eller modtage beskeder på dette tidspunkt.",
    select_location: "Vælg Placering",
    location_permission_denied_message:
      "Appen kræver placeringstilladelse til at fungere korrekt.",
    signed_in: "Logget ind!",
    sign_in_canceller: "Log ind annulleret",
    version: "Version",
    build: "Build.",
    name: "Navn",
    location: "Beliggenhed",
    language: "Sprog",
    about_app: "Om opført i nærheden af ​​mig",
    terms_of_service: "Servicevilkår.",
    privacy_policy: "Fortrolighedspolitik",
    report_feedback: "Send feedback",
    report_bug: "Ryste telefonen for at rapportere en fejl",
    change_image: "Skift billede.",
    update_location: "Opdater placering",
    about_the_app: "Om appen",
    update_label: "UPDATE.",
    uploading: "Uploading",
    adding: "Tilføjelse Listing",
    removing: "Fjernelse af notering",
    updating: "Opdatering af Listing.",
    uploaded_image: "Uploadet billede:",
    image_storage_failed: "Kunne ikke gemme billedet:",
    product_updated: "Produkt opdateret med succes",
    location_error: "Placering ikke gemt, prøv igen",
    product_removed: "Produktet fjernet med succes",
    deleted_product: "Dette produkt er slettet",
    invalid_title: "Ugyldig titel, bedes du angive titel igen.",
    invalid_image: "Ugyldig billedsti, prøv at tilføje billede igen.",
    invalid_price: "Ugyldig pris, bedes du angive pris igen.",
    invalid_location: "Ugyldig placering, bedes du angive placering igen.",
    invalid_category: "Ugyldig kategori, bedes du angive kategori igen.",
    invalid_condition: "Ugyldig tilstand, bedes du angive tilstand igen.",
    removing_title: "Fjernelse af profilbillede",
    image_not_saved: "Billede gem mislykkedes!",
    product_load_failed: "Ingen produkter.",
    take_photo: "Tag et billede",
    select_photo: "Vælg Photo.",
    product_title_hint: "Hvad er det? Navn, mærke, model osv.",
    delete_photo: "Slet foto.",
    product_title: "Titel",
    mark_as_sold: "Marker som solgt",
    product_share: "Del",
    product_make_offer: "Kom med et tilbud",
    product_cover: "Indstil som omslagsbillede",
    product_tags: "Tags.",
    product_posted: "Indsendt:",
    product_change: "Lave om",
    product_post: "Stolpe",
    product_selling_from: "Sælger fra placering",
    product_select_location: "Vælg Placering",
    product_map_approximate:
      "Kort er omtrentlig for at holde sælgerens placering privat",
    product_terms:
      "Ved at trykke på POST for at offentliggøre dit produkt accepterer du <U> nævnt i nærheden af ​​Servicevilkår. </ U>",
    condition_other: "Andet (se beskrivelse)",
    condition_for_parts: "Til dele.",
    condition_used: "Brugt (normalt slid)",
    condition_open_box: "Åben boks (aldrig brugt)",
    condition_reconditioned: "Reconditioned / Certified.",
    condition_new: "Ny (aldrig brugt)",
    select_category: "Vælg Kategori",
    select_all_category: "Vælg alle",
    category_loading_error:
      "Kan ikke opdatere kategorier liste, prøv igen senere.",
    category_vehicles: "Køretøjer",
    category_furniture: "Møbel",
    category_electronics: "Electronics.",
    category_appliances: "Hjem &  Hårde hvidevarer",
    category_fashion_accessories: "Mode &  tilbehør",
    category_baby_kids: "Baby &  Kids.",
    category_antiques_collectibles: "Antikviteter &  Collectibles.",
    category_auto_parts_tools_machinery: "Auto dele, værktøjer og  Maskineri",
    category_sports_outdoors: "Sport &  Udendørs",
    category_others: "Andre",
    location_enter_zip_code: "Indtast postnummer",
    location_get_current_location: "Få den nuværende placering",
    location_select_location: "Vælg Placering",
    location_update_location: "Opdater placering",
    location_new_location: "Ny placering",
    search_filter_results: "Filtrer resultater",
    search_filter_min: "Filter minimum",
    search_filter_at_least: "I det mindste",
    price_filter: "Prisfilter",
    product_name: "produktnavn",
    english_language: "engelsk",
    arabic_language: "Arabisk.",
    spanish_language: "spansk",
    system_language: "System",
    share_link: "Del link",
    save: "Gemme",
    cancel: "Afbestille",
    loading: "Indlæser",
    yes: "Ja",
    no: "Ingen",
    report: "Rapport",
    report_product: "Rapport produkt",
    report_user: "Rapporter bruger",
    block_user: "Bloker bruger",
    un_block_user: "Unblock bruger",
    why_product: "Hvorfor vil du rapportere denne vare?",
    why_user: "Hvorfor vil du rapportere denne bruger?",
    block_user_confirm: "Vil du permanent blokere denne bruger?",
    un_block_user_confirm: "Vil du permanent fjerne blokering af denne bruger?",
    prohibited: "Forbudt på noteret nær mig",
    offensive: "Offensiv eller upassende",
    duplicate: "Duplicate Post.",
    wrong_category: "Forkert kategori.",
    scam: "Ligner en fidus",
    stolen: "Jeg synes, det er stjålet",
    product_other: "Andet",
    product_is_sold: "Dette produkt blev solgt",
    missed_meeting: "De savnede vores møde",
    low_offer: "Lavet et lavt tilbud",
    rude: "Uhøfligt eller upassende",
    items: "Problem med varer",
    trouble_meetup: "Problemer ved at mødes op",
    messaging: "Messaging problemer",
    user_other: "Andet",
    new_version_available: "Ny version tilgængelig",
    please_update_app: "Venligst opdater app til ny version for at fortsætte.",
    update: "UPDATE.",
    no_thanks: "Nej tak",
    contact_support_confirmation:
      "Den nuværende responstid er 24-48 timer. Ønsker du at kontakte nævnt i nærheden af ​​Me App Chat Support?",
    unboost_confirmation: "Er du sikker på, at du vil unboost dette produkt?",
    no_used_products: "Du har ikke nogen fortegnelser endnu",
    no_boosted_products: "Du har ikke nogen øgede produkter",
    next: "Næste",
    previous: "Tidligere",
    skip: "Springe",
    start: "Start",
    list_used: "Angiv et brugt produkt",
    buy_description:
      "Oplev og søg efter produkter, der tilbydes af naboer omkring dig",
    sell_description: "Liste produkter, du ikke længere har brug for til salg",
    list_used_description:
      "Skriv et brugt produkt til salg på mindre end 20 sekunder",
    boost_product_option_1: "<b> Boost 1  nDays </ b>  n  n <b> $ 0.99 </ b>",
    boost_product_option_2: "<b> Boost 3  ndays </ b>  n  n <b> $ 1,99 </ b>",
    boost_product_option_3: "<b> Boost 7  ndays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "Få flere visninger hver dag. Dit produkt vises i featured positioner inden for de øverste 30 varer i køb og kategori. Fremme varer roteres blandt de udpegede pletter, så hvert element får retfærdig eksponering.",
    boost_cta: "Sælge hurtigere",
    boost_terms:
      "Ved at trykke på BOOST, accepterer du <U> nævnt i nærheden af ​​Servicevilkår. </ U>",
    boost_best_value: "Bedste værdi",
    already_boosted: "Dette produkt er øget",
    clicks: "Klik",
    impressions: "Visninger.",
    end: "Ende",
    transactions_empty_text:
      "Du har ikke nogen øget transaktioner endnu. Du kan besøge Sælg Tab og begynde at øge dine produkter.",
    transactions_loading_error:
      "Kan ikke opdatere transaktioner listen, prøv igen senere.",
    transactions_history_title: "Boost Transactions History.",
    communicative_postive: "Kommunikative",
    communicative_negative: "Communicative.",
    ontime_postive: "En gang",
    ontime_negative: "Sent",
    reliable_postive: "Pålidelig",
    reliable_negative: "Upåliteligt",
    friendly_postive: "Venlige",
    friendly_negative: "Uhøfligt",
    itemasdescribed_postive: "Vare som beskrevet",
    itemasdescribed_negative: "Vare ikke som beskrevet",
    other: "Andet",
    submit: "Indsend",
    adding_rating_reviews: "Tilføjelse af bedømmelse og anmeldelser",
    no_internet_title: "Ingen internetforbindelse",
    no_internet_message:
      "Sørg for at du er forbundet til internettet og prøv igen",
    retry: "Prøve igen",
    near_me: "Tæt på mig",
    newest_first: "Nyeste først",
    miles: "Miles.",
    km: "km.",
    similar_products: "Lignende produkter.",
    favorite_products: "Favorit produkter.",
    items_for_sale: "ting til salg",
    joined: "Tilsluttet",
    favorites_transactions_title: "Favoritter.",
    boosted_products_transactions_history:
      "Forstærkede produkter Transaktioner Historie",
    views: "Visninger.",
    boost_graph_title: "Boost Graph.",
    no_favorite_products: "Du har ikke nogen favoritprodukter",
    make_offer_buy: "jeg vil gerne købe",
    make_offer_buy_for: "til",
    notifications: "Meddelelser",
    push_notifications: "Skubbe",
    emails_notifications: "Email.",
    apply: "ansøge",
    email_messages: "Email til beskeder.",
    email_new_products: "Email til nye produkter",
    push_day_only: "Push notifications dag kun",
    push_24_hours: "Push notifikationer 24 timer",
    edit: "Redigere",
    map: "Kort",
    camera: "Kamera",
    gallery: "Galleri",
    delete: "Delete.",
    no_sell_items: "Ingen varer til salg",
    who_bought_question: "Hvem købte det?",
    sold_elsewhere_question: "Solgte det et andet sted",
    confirm: "Bekræfte",
    over_limit_camera: "Du kan ikke tilføje mere end fem billeder",
    boost_failed: "Boost mislykkedes. Prøv igen senere",
    after_purchase: "Betaling Succesfuld  Nproduct Boosted",
    pay_failed: "Betaling mislykkedes. Prøv igen",
    done: "Færdig",
    not_now: "Ikke nu",
    boost: "Boost.",
    invalid_zip_code: "Ugyldig postnummer",
    invalid_user_name: "Ugyldigt brugernavn",
    comments: "Kommentarer.",
    questions: "Spørgsmål.",
    bug_reports: "Fejlrapporter.",
    feature_request: "Funktionsanmodning",
    feedback_type: "Feedback Type",
    feedback_description:
      "Vi ville elske at høre dine tanker eller feedback om, hvordan vi kan forbedre din oplevelse!",
    feedback: "Feedback.",
    feedback_text: "Dit svar",
    suggestions: "Forslag til forbedring",
    delete_account: "Slet konto.",
    new_message: "Ny besked",
    online: "Online.",
    km_50: "50 km.",
    km_100: "100 km.",
    km_200: "200 km.",
    miles_30: "30 miles",
    miles_60: "60 Miles.",
    miles_120: "120 Miles.",
    rate_app_question: "Hvad med en bedømmelse på App Store, så?",
    enjoying_question: "Nyd opført i nærheden af ​​mig?",
    not_enjoy: "Ikke rigtig",
    feedback_question: "Har du noget imod at give os nogle feedback?",
    yes_sure: "Ok selvfølgelig",
    product_available_question: "Hej, er det stadig tilgængeligt?",
    buy_question: "Hej, jeg vil gerne købe dette",
    meet_question: "Hej, kan du mødes i dag?",
    follow: "Følge med",
    followers: "Tilhængere.",
    following: "Følge",
    feedback_thanks: "Tak for din tilbagemelding",
    all_categories: "alle kategorier",
    deleted_account: "Denne konto slettes",
    delete_account_question: "Er du sikker på, at du vil slette denne konto?",
    no_followings: "Følg ikke nogen",
    when_following: "hvornår",
    no_followings_subtitle: "Følger folk, du vil se dem her",
    no_followers: "har ikke tilhængere",
    no_followers_subtitle: "efterfulgt af mennesker, vil du se dem her",
    distance: "Afstand",
    filter_method: "Filter metode.",
    see_listings: "Se Listings",
    sold: "SOLD",
    bought: "Købt",
    no_notifications: "Når du modtager meddelelser, vises de her",
    items_title: "Varer",
    new_listing_title: "Opret ny notering",
    dialog_year_title: "År",
    dialog_make_title: "Lave",
    dialog_model_title: "Model",
    dialog_body_style_title: "Kropsstil",
    dialog_exterior_color_title: "Udvendig farve.",
    dialog_interior_color_title: "Indvendig farve.",
    dialog_transmission_title: "Smitte",
    dialog_fuel_type_title: "Brændstof type",
    dialog_owners_num_title: "Antal ejere",
    dialog_vehicle_owed_money_title: "Er der penge stadig på dette køretøj?",
    automatic_transmission: "Automatisk",
    manual_transmission: "brugervejledning",
    not_sure: "Ikke sikker",
    wagon_hatchback: "Vogn &  Hatchback.",
    convertible: "Konvertible",
    coupe: "Coupe.",
    sedan: "Sedan.",
    black_color: "Sort",
    blue_color: "Blå",
    brown_color: "Brun",
    gold_color: "Guld",
    green_color: "Grøn",
    grey_color: "Grå",
    pink_color: "Lyserød",
    purple_color: "Lilla.",
    red_color: "Rød",
    silver_color: "Sølv",
    orange_color: "orange",
    white_color: "hvid",
    yellow_color: "Gul",
    charcol_color: "Carcol.",
    fuel_diesel: "Diesel.",
    fuel_electric: "Elektrisk",
    fuel_gasoline: "Benzin",
    fuel_flex: "Flex.",
    fuel_hybrid: "Hybrid.",
    fuel_petrol: "Benzin",
    fuel_plugin_hybrid: "Plug-in hybrid",
    truck: "Lastbil",
    van_minivan: "Van &  Minivan.",
    suv_crossover: "SUV &  Crossover.",
    awd_4wd: "AWD / 4WD.",
    fwd: "Fwd.",
    rwd: "RWD.",
    off_white_color: "Off White.",
    tan_color: "Tan.",
    beige_color: "Beige",
    burgundy_color: "Burgundy.",
    turquoise_color: "Turkis.",
    title_status_clean: "Ren",
    title_status_rebuilt: "Genopbygget",
    title_status_salvage: "Salvage.",
    title_status_missing: "Mangler",
    title_status_lien: "Lien",
    title_status: "Titelstatus.",
    mileage: "Kilometertal",
    dialog_drivetrain_title: "Drivetrain.",
    model_warning: "Vælg venligst Gør først",
    required_field_warning: "dette felt er påkrævet",
    vehicle_vin: "Vin.",
    invalid_vin: "Ugyldig VIN, vær venlig at sætte VIN igen.",
    invalid_mileage: "Ugyldigt kilometertal, bedes du sætte kilometertal igen.",
    clean_description: "De fleste køretøjer, der ikke har været i en ulykke",
    rebuilt_description: "En reddet bil, der er blevet genopbygget",
    salvage_description: "Anses for udsat for en ulykke",
    missing_description: "Vil have brug for en ny DMV-problemer titel",
    lien_description: "Ejet af en bank eller en retspleje",
    nearme: "Tæt på mig",
    newest: "Nyeste.",
    contact_support: "Kontakt support",
    create_home_title: "Boliger til salg eller leje",
    for_sale: "Til salg",
    for_rent: "Til leje",
    property_type: "Ejendomstype",
    apartment: "Lejlighed",
    house: "Hus",
    room_only: "Kun værelse",
    townhouse: "Rækkehus",
    bedrooms: "Soveværelser.",
    bathrooms: "Badeværelser",
    property_address: "Ejendomsadresse.",
    price_per_month: "Pris pr. Måned",
    square_feet: "Kvadratfod",
    year_built: "Bygget år",
    year_renovated: "År renoveret.",
    lot_size: "Meget størrelse",
    laundry_type: "Tøjvask type",
    in_unit_laundry: "In-Unit Tøjvask",
    laundry_building: "Vaskeri i bygning",
    laundry_available: "Vaskeri til rådighed",
    none: "Ingen",
    parking_type: "Parkering Type",
    garage_parking: "Garage parkering",
    street_parking: "Gade parkering",
    off_street_parking: "Off-street parkering",
    available_parking: "Parkering til rådighed",
    air_cond_type: "Aircondition type",
    ac_available: "AC tilgængelig",
    central_ac: "Central AC.",
    heating_type: "Varme type",
    electric_heating: "Elvarme",
    gas_heating: "Gasopvarmning",
    radiator_heating: "Radiatoropvarmning",
    available_heating: "Opvarmning tilgængelig",
    amenities: "Bekvemmeligheder.",
    date_available: "Dato tilgængelig",
    lease_length: "Lease længde",
    month_to_month: "Måned til måned",
    three_months: "3 måneder",
    six_months: "6 måneder",
    one_year: "1 år",
    more_one_year: "1+ år",
    cat_friendly: "Cat Friendly.",
    dog_friendly: "Hund venlig",
    balcony: "Balkon",
    basement: "Kælderen.",
    bike_parking: "Cykel parkering",
    cable_tv: "Kabel TV",
    ceiling_fan: "Loftsventilator",
    concierge: "Concierge.",
    dishwasher: "Opvaskemaskine",
    doorman: "Dørmand",
    elevator: "Elevator",
    fireplace: "Ildsted",
    fitness_center: "Fitness center",
    garbage_disposal: "Bortskaffelse af affald",
    microwave: "Mikrobølgeovn.",
    online_app: "Online applikation",
    oven: "Ovn.",
    package_service: "Pakke service.",
    patio: "Gårdhave",
    pet_park: "Pet Park.",
    refrigerator: "Køleskab",
    resident_lounge: "Resident Lounge.",
    roof_deck: "Tagdæk",
    secured_entry: "Sikret indgang",
    storage: "Opbevaring",
    walk_in_closet: "Walk-in closet",
    swimming_pool: "Svømmepøl",
    wheelchair_access: "Kørestols adgang",
    central_heating: "Centralvarme",
    invalid_bedrooms:
      "Ugyldige soveværelser, bedes du sætte soveværelser igen.",
    invalid_bathrooms:
      "Ugyldige badeværelser, bedes du sætte badeværelser igen.",
    chinese_simplified_language: "Kinesisk forenklet",
    chinese_traditional_language: "Kinesisk traditionel",
    czech_language: "Tjekkisk",
    danish_language: "dansk",
    dutch_language: "hollandsk",
    finnish_language: "Finsk",
    french_language: "fransk",
    german_language: "tysk",
    greek_language: "Græsk",
    hungarian_language: "Ungarian.",
    indonesian_language: "Indonesisk",
    italian_language: "Italiensk",
    japanese_language: "Japansk",
    korean_language: "Koreansk.",
    norwegian_language: "Norsk",
    polish_language: "Polere",
    portuguese_language: "Portugisisk.",
    portuguese_brazilian_language: "Portugisisk, brasiliansk",
    romanian_language: "Rumænsk.",
    russian_language: "Russisk",
    swedish_language: "Svensk",
    turkish_language: "tyrkisk",
    ukrainian_language: "Ukrainske.",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "Vietnamesisk.",
    category_home_sale_or_rent: "Hjem til salg eller leje",
    square_meter: "Kvadratmeter",
    copy_text: "Kopi",
    copyied_to_clipboard: "Kopieret til udklipsholder",
    inbox: "Indbakke",
    input_title_listening: "Hører efter…",
    input_subtitle_listening: "Sig noget",
    input_title_error: "Beklager, vi fik det ikke rigtigt.",
    input_subtitle_error: "Prøv at gentage din anmodning.",
    input_hint_error: "Prøv igen",
    price_less_than_or_equal: "Pris mindre end eller lig med",
    any_price: "Nogen pris.",
    any_condition: "Enhver betingelse.",
    any_time: "Enhver gang",
    days_ago: "dage siden",
    any_distance: "Enhver afstand",
    distance_within: "Afstand Indent.",
    new_notification: "Ny anmeldelse.",
    deleted: "Slettet",
    processing_image: "Behandlingsbehandling",
    remove_dialog_message: "Vil du virkelig fjerne dette produkt?",
    deleted_thread: "Denne meddelelse slettes",
    category_yard_sale_event: "Yard Sale Event.",
    yard_first_date: "Yard Sale First Date",
    yard_second_date: "Yard Sale anden dato",
    yard_third_date: "Yard Sale Tredje Dato",
    yard_start_time: "Starttidspunkt",
    yard_end_time: "Sluttidspunktet",
    yard_end_timestamp: "Ende timestamp.",
    invalid_date1:
      "Ugyldig første dato, vær venlig at indstille første dato igen",
    invalid_start_time: "Ugyldig starttid, bedes du sætte starttidspunkt igen",
    invalid_end_time: "Ugyldig sluttid, bedes du sætte sluttidspunktet igen",
    yard_sale_title: "Loppemarked",
    garage_tag: "garage",
    yard_tag: "gård",
    from: "Fra",
    to: "Til",
    block: "Blok",
    un_block: "Fjern blokering",
    sign_email: "Log ind med e-mail",
    invalid_first_date:
      "Ugyldig første dato, sørg for, at første dato er før anden og tredje",
    invalid_second_date:
      "Ugyldig anden dato, sørg for, at anden dato er før tredje dato",
    invalid_start_time_value:
      "Ugyldig starttid, vær sikker på, at starttidspunktet er før sluttidspunktet",
    use_default_yard_photo: "Brug standard Yard Sale Photo",
    active_label: "Aktiv",
    enable_notifications: "Aktivér meddelelser.",
    login: "Log på",
    january: "januar",
    february: "februar",
    march: "marts",
    april: "April",
    may: "Kan",
    june: "juni",
    july: "juli",
    august: "august",
    september: "september",
    october: "oktober",
    november: "november",
    december: "december",
    since: "Siden",
    product_views: "Produktudsigter",
    shop_views: "Shop Views.",
    total_sales: "Total Sales.",
    total_orders: "Samlede ordrer.",
    last_twelvth_months: "Sidste twelvte måneder",
    last_nine_months: "Sidste ni måneder",
    last_six_months: "Sidste seks måneder",
    last_three_months: "Sidste tre måneder",
    last_12_months: "Sidste 12 måneder",
    last_9_months: "Sidste 9 måneder",
    last_6_months: "Sidste 6 måneder",
    last_3_months: "Sidste 3 måneder",
    months: "Måneder",
    reset_password: "Nulstille kodeord",
    create_new_shop: "Opret ny butik",
    download_app: "Download App",
    log_in: "Log på",
    sign_up: "Tilmelde",
    no_result: "Intet resultat",
    max_price: "Max pris",
    max_distance: "Max afstand",
    max_time: "Max Time.",
    posted_less_than: "Bogført mindre end",
    result: "Resultat",
    more: "Mere",
    or: "ELLER",
    password: "Adgangskode",
    forgot_password: "glemt kodeord?",
    and: "og",
    download_for: "Download for.",
    apple_ios: "Apple iOS.",
    android: "Android.",
    image: "Billede",
    edit_image: "Rediger billede.",
    please_complete: "Venligst udfyldelse.",
    enter_your_offer: "Indtast dit tilbud",
    categories: "Kategorier",
    upload_image: "Upload billede.",
    upload_images: "Upload billeder",
    back: "Tilbage",
    see_more: "Se mere",
    add_product: "Tilføj produkt",
    selected: "Valgte",
    create: "skab",
    rate_the_buyer: "Vurder køberen",
    delete_product: "Slet produkt",
    product: "Produkt",
    un_block_product: "Unblock produkt",
    share_your_product: "Del dit produkt",
    boost_details: "Boost detaljer.",
    remove_all_products: "Fjern alle produkter",
    remove_all: "Fjern alt",
    add_vehicle: "Tilføj køretøj",
    edit_vehicle: "Rediger køretøj",
    upload_a_photo: "Upload et billede.",
    view_details: "Se detaljer",
    add_yard_sale: "Tilføj Yard Sale.",
    edit_yard_sale: "Rediger Yard Sale.",
    users: "Brugere",
    users_details: "Brugere Detaljer.",
    users_by_country: "Brugere efter land",
    blocked_users: "Blokerede brugere",
    products_cards: "Produkter kort",
    archived_products: "Arkiverede produkter",
    blocked_products: "Blokerede produkter.",
    products_by_country: "Produkter efter land",
    reports: "Rapport",
    reports_details: "Rapporter detaljer.",
    closed_reports: "Lukkede rapporter",
    threads: "Tråde",
    threads_details: "Tråde detaljer.",
    chat_support: "Chat support.",
    actions: "Handlinger",
    search_actions: "Søgningshunktioner.",
    product_view_actions: "Produktvisning Handlinger.",
    contact_seller_product: "Kontakt sælger produkt",
    contact_owner_shop: "Kontakt ejerbutik",
    ratings: "Ratings.",
    reviews: "Anmeldelser",
    products_all_countries: "Produkter alle lande",
    edit_profile: "Rediger profil",
    my_profile: "Min profil",
    profile_updated_successfully: "Profil opdateret succes",
    are_you_sure: "Er du sikker",
    my_used_products: "Mine brugte produkter.",
    my_shops: "Mine butikker",
    my_boosted_products: "Mine boosted produkter.",
    messages_type_message_here: "Indtast din besked her",
    messages_product_sold: "Dette produkt sælges eller fjernes",
    seen: "Set",
    messages_never_miss_message: "Gå aldrig glip af en besked",
    enable: "Aktivér.",
    send_notify: "Send beskeden",
    un_close: "Unclose",
    type_your_review: "Indtast din anmeldelse",
    again_question: "igen ?",
    ratings_already_submitted_review: "Du har allerede sendt anmeldelse",
    open: "Åben",
    set_product_category: "Indstil produktkategori.",
    auth_email_password_incorrect: "Din e-mail eller adgangskode er forkert",
    auth_insert_your_name: "Indsæt venligst dit navn",
    auth_email_address_badly: "E-mail-adressen er dårligt formateret",
    auth_email_address_used:
      "E-mail-adressen er allerede i brug af en anden konto",
    auth_invalid_password: "Adgangskoden skal være mindst 6 tegn",
    auth_reset_email: "Indtast din email for at nulstille dit kodeord",
    auth_check_email: "Venligst tjek din e-mail for at nulstille adgangskoden",
    auth_can_sign_in_google: "Du kan logge ind med Google-knappen",
    auth_do_not_have_account: "Har du ikke en konto?",
    auth_have_account: "Har du en konto?",
    log_terms_privacy_part1:
      "Ved at tilmelde dig eller logge ind, accepterer du den noterede i nærheden af ​​mig",
    boost_this_product: "Forøg dette produkt?",
    product_successfully_boosted: "Produktet er blevet øget med succes",
    product_failed_boost: "Produktet er blevet mislykket i Boost",
    no_products_for_sale:
      "Du har i øjeblikket ikke brugte produkter, der er angivet til salg.",
    not_sold_listed_near_me:
      "Jeg har ikke solgt det på noteret i nærheden af ​​mig",
    agree_add_product:
      "Ved at trykke på POST for at offentliggøre dit produkt accepterer du de noterede i nærheden af ​​Servicevilkår og Privacy Policy.",
    click_to_boost: "Klik på produktet for at øge det",
    listed_terms_of_service: "Opført i nærheden af ​​mig Servicevilkår",
    receive_emails_for_users: "Modtag e-mails til brugernes meddelelser",
    receive_emails_for_newly_posted:
      "Modtag e-mails til dine nyligt udsendte produkter",
    disable_push_notifications: "Deaktiver push notifikationer",
    sms_during_day: "Modtag SMS om dagen",
    sms_24_hours: "Modtag SMS 24 timer",
    products: "Produkter",
    product_no_longer_available:
      "Beklager, dette produkt er ikke længere tilgængeligt",
    add_home: "Tilføj hjem",
    edit_home: "Rediger Hjem",
    fill_required_fields: "Fyld alle de nødvendige felter",
    no_notification: "Der er ingen meddelelser",
    orders_history: "Ordrer historie",
    privacy: "Privatliv",
    terms: "Vilkår",
    report_a_problem: "Rapporter et problem",
    approximation_protect_user_privacy:
      "Tilnærmelse for at beskytte brugerens privatliv",
    do_not_have_products: "Du har ikke produkter",
    emails: "E-mails.",
    lead_deletion_products:
      "Dette vil føre til sletning af alle dine produkter",
    confirm_legal_message:
      "Du er eneansvarlig for at tage alle nødvendige forholdsregler, når du interagerer med andre, især når du møder en fremmed i første gang. Venligst gennemgå Servicevilkår for flere detaljer.",
    push_notifications_notified_instantly:
      "Aktivér push-meddelelser, der skal meddeles øjeblikkeligt",
    rate_seller: "Vurder sælger sælger",
    user_journey: "Brugerrejse",
    user: "Bruger",
    user_id: "Bruger ID",
    action_id: "Handlings-id.",
    select_model_car: "Vælg model af bil",
    boost_1_day: "Boost 1 dag",
    boost_3_days: "Boost 3 dage",
    boost_7_days: "Boost 7 dage",
    agree_boost_terms: "Ved at tappe boost accepterer du det",
    add: "Tilføje",
    add_tag: "Tilføj tag",
    brand_title: "Mærke",
    category_mobiles: "Mobiler.",
    category_tablets: "Tabletter.",
    screen_size: "Skærmstørrelse",
    has_cellular_capability: "Har cellulær kapacitet",
    default_internal_memory: "Intern hukommelse",
    network_carrier: "Network Carrier.",
    is_unlocked: "Er ulåst",
    mobile_model_warning: "Vælg venligst mærke først",
    missing_image: "Manglende billede, prøv at tilføje billede igen.",
    add_mobile: "Tilføj mobil",
    edit_mobile: "Rediger mobil",
    add_tablet: "Tilføj tablet",
    edit_tablet: "Rediger tablet",
    keywords:
      "shopping, køb, sælge, tjene penge, handel, lokalbefolkningen, naboer, auto, køretøjer",
    country: "Land",
    phone_number: "Telefonnummer",
    verification_code: "Verifikationskode",
    error_occurred: "Der opstod en fejl. Prøv venligst igen senere",
    invalid_state:
      "Ugyldig tilstand: En login tilbagekald blev modtaget, men der blev ikke sendt nogen login-anmodning.",
    sign_in: "Log ind",
    sign_in_apple: "Log ind med Apple",
    sign_in_google: "Log ind med Google",
    sign_in_phone: "Log ind med telefon",
    sign_in_facebook: "Log ind med Facebook",
    create_account: "Opret en konto",
    email: "Email.",
    invalid_field: "Udfyld venligst de obligatoriske felter",
    code_sent: "Koden er blevet sendt af SMS",
    verify_number: "Bekræft telefonnummer",
    tapping_verify_number:
      "Ved at trykke på (bekræft telefonnummer), sendes en SMS.",
    email_exists:
      "Kontoen eksisterer allerede, og du skal have adgang til den via Google-knap, Facebook-knap eller Apple-knap",
    ok: "Okay",
    sure_back: "Er du sikker på at tilbage?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "siden",
    add_model: "Tilføj model",
    no_search_results_us:
      "Ingen søgeresultater i nærheden af ​​dig inden for 120 miles. Prøv at ændre søgefilteret eller søgen nøgleord.",
    no_search_results:
      "Ingen søgeresultater i nærheden af ​​dig inden for 200 km. Prøv at ændre søgefilteret eller søgen nøgleord.",
    plan_date: "Planlægningsdato",
    plan_time: "Planlæg tid",
    invalid_plan_date: "Ugyldigt plandato, indstil Plan Dato igen",
    invalid_plan_time: "Ugyldig plan tid, indstil planen igen",
    plan_name: "Plannavn",
    plan_title: "Plan",
    update_plan_name: "Opdatering af plannavn",
    delete_plan_question: "Er du sikker på, at du vil slette denne plan?",
    plan_reminder_message: "Du bliver mindet om en time før",
    plan_dialog_title: "Mødeplan",
    planners_title: "Planlæggere",
    unable_sending_messages:
      "De vil se dine beskeder, når de er tilbage online.",
    its_text: "Det er",
    for_your_text: "til din modtager.",
  },
  nl: {
    invalid_area: "Ongeldig gebied, stel het gebied weer in.",
    invalid_lot_size:
      "Invalid onroerend goedgrootte, geef opnieuw partijgrootte in.",
    property_area: "Onroerend goed",
    app_store_name:
      "Vermeld in de buurt - Koop Gebruikte items, verkoop voor contanten",
    app_store_short:
      "Een marktplaats voor lokale verkopers. Maak een lijst van een item te koop en verdien geld.",
    app_store_full:
      "Meldingen in de buurt van mij maakt het gemakkelijk om geweldige deals te vinden over de dingen die je wilt en geld verdienen met de dingen die je wilt verkopen. Dit is de beste manier om in uw gemeenschap of buurt te kopen en verkopen met mensen die u kunt vertrouwen. Hoe het werkt: 1- koop of verkoop of verkoopt; Plaats eenvoudig uw artikelen te koop in seconden. 2- Vind geweldige aanbiedingen en kortingen op kleding, meubels, mobiele telefoons, elektronica, baby- en kinderartikelen, sportuitrusting, gebruikte auto's, jurken, schoenen en horloges, naar boeken, gebruikte speelgoed, gebruikte laptops, een tweedehands auto en zelfs echt landgoed te koop of te huur. 3- Blader door lokale artikelen te koop. 4- Bericht kopers en verkopers van binnenin de app. 5- Blader door items op afbeelding en sorteer op categorie. Leuke feiten over vermeld in de buurt van mij: 1- met vermeld in de buurt van mij, kunt u eenvoudig iets verkopen, van kleding tot gebruikte auto's voor elektronica. 2- Communicatie tussen kopers en verkopers gebeurt via de app via berichten. 3 - vermeld in de buurt van mij is beter dan een garage-verkoop; Zoek alles wat u wilt met korting, direct aan uw telefoon of tablet.",
    app_store_release:
      "Vermeld bij mij - handel met de lokale bevolking. Word lid van de mobiele markt voor lokale kopers en verkopers!",
    app_name: "Vermeld in de buurt van mij",
    title_buy: "Kopen",
    title_messages: "Berichten",
    title_sell: "Verkopen",
    title_profile_image: "Profielfoto",
    title_account: "Rekening",
    account_settings: "Account instellingen",
    settings: "Instellingen",
    color_theme: "Kleurenthema",
    device_settings: "Apparaat instellingen",
    public_profile: "Publiek profiel",
    light_mode: "Lichtmodus",
    dark_mode: "Donkere modus",
    title_sell_faster: "Verkocht sneller",
    send_button_label: "Versturen",
    rate_message: "Geef me een cijfer...",
    already_rated: "U hebt al een beoordeling ingediend",
    rate_review_question: "Wil je omgaan met",
    again: "nog een keer?",
    action_logout: "Uitloggen",
    action_category: "Categorie",
    action_search: "Zoekopdracht",
    action_refer: "Verwijs een vriend",
    dialog_choose_location: "Kies locatie",
    dialog_change_username: "Gebruikersnaam wijzigen",
    dialog_change_language: "Verander de taal",
    dialog_image_tags: "Afbeelding tags",
    dialog_emails_notifications: "E-mails meldingen",
    dialog_push_notifications: "Pushmeldingen",
    fragment_product_detail: "Product detail",
    fragment_message_details: "Berichten detail",
    fragment_sell: "Verkopen",
    dialog_tags_title: "Tags",
    dialog_location_title: "Update locatie",
    dialog_username_title: "Gebruikersnaam wijzigen",
    tab_photo: "Foto",
    tab_details: "Details",
    tab_price: "Prijs",
    tab_finish: "Finish",
    profile: "Profiel",
    search: "Zoekopdracht",
    choose_product: "Kies product",
    rating_review: "Beoordeling en beoordeling",
    select_buyer: "Selecteer een koper",
    tab_my_used_products: "Mijn producten",
    price_label: "Prijs",
    text_savings: "Je bespaart",
    search_hint: "Zoeken naar producten ...",
    empty_text:
      "Er zijn geen producten vermeld in deze categorie of binnen de geselecteerde afstand.",
    filter_menu_text: "Filter",
    error_contacting_seller: "Fout bij het contacteren van de verkoper",
    edit_product: "Bewerk product",
    contact_seller: "Contact met de verkoper",
    signup_to_contact_seller:
      "Meld u aan om contact op te nemen met de verkoper",
    signup_to_make_offer: "Meld je aan om het aanbod te doen",
    product_details: "Details",
    product_category: "Categorie",
    product_condition: "Voorwaarde",
    product_description: "Beschrijving",
    product_location: "Productlocatie",
    product_location_approximate: "Locatie is bij benadering",
    over_week_time_ago: "Meer dan een week geleden",
    boosted: "Verhogen",
    threads_no_results: "Geen berichten",
    message_no_results: "Geen berichten",
    message_warning:
      "U bent als enige verantwoordelijk voor het nemen van alle noodzakelijke voorzorgsmaatregelen bij het omgaan met anderen, vooral wanneer u een vreemde voor het eerst persoonlijk ontmoet. Deel geen persoonlijke informatie, verificatiecodes of betalingsinformatie. Bekijk de servicevoorwaarden voor meer informatie.",
    message_block:
      "U kunt op dit moment geen berichten verzenden of ontvangen.",
    select_location: "Selecteer een locatie",
    location_permission_denied_message:
      "De app vereist de toestemming van de locatie om goed te werken.",
    signed_in: "Ingelogd!",
    sign_in_canceller: "Aanmelden in geannuleerd",
    version: "Versie",
    build: "Bouwen",
    name: "Naam",
    location: "Plaats",
    language: "Taal",
    about_app: "Over vermeld in de buurt van mij",
    terms_of_service: "Servicevoorwaarden",
    privacy_policy: "Privacybeleid",
    report_feedback: "Feedback verzenden",
    report_bug: "Telefoon schudden om een ​​bug te melden",
    change_image: "Verander afbeelding",
    update_location: "Update locatie",
    about_the_app: "Over de app",
    update_label: "Bijwerken",
    uploading: "Uploading",
    adding: "Lijst toevoegen",
    removing: "Verwijderen van de vermelding",
    updating: "Update Listing",
    uploaded_image: "Geüploade afbeelding:",
    image_storage_failed: "Mislukt om beeld op te slaan:",
    product_updated: "Product met succes bijgewerkt",
    location_error: "Locatie niet opgeslagen, probeer het opnieuw",
    product_removed: "Product is succesvol verwijderd",
    deleted_product: "Dit product is verwijderd",
    invalid_title: "Ongeldige titel, stel de titel opnieuw in.",
    invalid_image: "Ongeldig beeldpad, probeer foto opnieuw toe te voegen.",
    invalid_price: "Ongeldige prijs, stel de prijs opnieuw in.",
    invalid_location: "Ongeldige locatie, stel de locatie opnieuw in.",
    invalid_category: "Ongeldige categorie, geef opnieuw categorie in.",
    invalid_condition: "Ongeldige staat, stel de toestand opnieuw in.",
    removing_title: "Profielbeeld verwijderen",
    image_not_saved: "Beeld opslaan mislukt!",
    product_load_failed: "Geen producten",
    take_photo: "Foto's maken",
    select_photo: "Selecteer foto",
    product_title_hint: "Wat is het? Naam, merk, model, enz.",
    delete_photo: "Verwijder foto",
    product_title: "Titel",
    mark_as_sold: "Mark zoals verkocht",
    product_share: "Deel",
    product_make_offer: "Aanbieding",
    product_cover: "Instellen als cover image",
    product_tags: "Tags",
    product_posted: "Geplaatst:",
    product_change: "Wijziging",
    product_post: "Na",
    product_selling_from: "Verkopen van de locatie",
    product_select_location: "Selecteer een locatie",
    product_map_approximate:
      "Kaart is bij benadering om de locatie van de verkoper privé te houden",
    product_terms:
      "Door de post te tikken om uw product te publiceren, gaat u akkoord met <u> die bij me in de buurt van Servicevoorwaarden zijn vermeld. </ U>",
    condition_other: "Anders (zie beschrijving)",
    condition_for_parts: "Voor onderdelen",
    condition_used: "Gebruikt (normale slijtage)",
    condition_open_box: "Open doos (nooit gebruikt)",
    condition_reconditioned: "Gereconditioneerd / gecertificeerd",
    condition_new: "Nieuw (nooit gebruikt)",
    select_category: "selecteer categorie",
    select_all_category: "Selecteer alles",
    category_loading_error:
      "Kan categorieën niet bijwerken, probeer het later opnieuw.",
    category_vehicles: "Voertuigen",
    category_furniture: "Meubilair",
    category_electronics: "Elektronica",
    category_appliances: "Home &  Huishoudelijke apparaten",
    category_fashion_accessories: "Mode &  Accessoires",
    category_baby_kids: "Baby &  Kinderen",
    category_antiques_collectibles: "Antiques &  Collectibles",
    category_auto_parts_tools_machinery:
      "Auto-onderdelen, gereedschap &  Machines",
    category_sports_outdoors: "Sport &  Buitenshuis",
    category_others: "Andere",
    location_enter_zip_code: "Vul de zip code in",
    location_get_current_location: "Krijg de huidige locatie",
    location_select_location: "Selecteer een locatie",
    location_update_location: "Update locatie",
    location_new_location: "Nieuwe locatie",
    search_filter_results: "Filter resultaten",
    search_filter_min: "Filter minimum",
    search_filter_at_least: "Minstens",
    price_filter: "Prijsfilter",
    product_name: "productnaam",
    english_language: "Engels",
    arabic_language: "Arabisch",
    spanish_language: "Spaans",
    system_language: "Systeem",
    share_link: "Deel link",
    save: "Sparen",
    cancel: "Annuleren",
    loading: "Bezig met laden",
    yes: "Ja",
    no: "Nee",
    report: "Verslag doen van",
    report_product: "Rapporteer product",
    report_user: "Rapporteer gebruiker",
    block_user: "Blokkeer gebruiker",
    un_block_user: "Deblokkeer gebruiker",
    why_product: "Waarom wil je dit artikel melden?",
    why_user: "Waarom wil je deze gebruiker melden?",
    block_user_confirm: "Wilt u deze gebruiker permanent blokkeren?",
    un_block_user_confirm: "Wilt u deze gebruiker permanent deblokkeren?",
    prohibited: "Verboden op vermeld in de buurt van mij",
    offensive: "Aanstootgevend of ongepast",
    duplicate: "Duplicate Post",
    wrong_category: "Verkeerde categorie",
    scam: "Ziet eruit als een scam",
    stolen: "Ik denk dat het is gestolen",
    product_other: "Ander",
    product_is_sold: "Dit product is verkocht",
    missed_meeting: "Ze misten onze vergadering",
    low_offer: "Maakte een lage aanbieding",
    rude: "Onbeleefd of ongepast",
    items: "Probleem met items",
    trouble_meetup: "Problemen bij elkaar",
    messaging: "Problemen met berichten",
    user_other: "Ander",
    new_version_available: "Nieuwe versie beschikbaar",
    please_update_app: "Werk de app bij op nieuwe versie om door te gaan.",
    update: "Bijwerken",
    no_thanks: "Nee bedankt",
    contact_support_confirmation:
      "De huidige responstijd is 24-48 uur. Wilt u contact opnemen met vermeld bij ME-app-chatondersteuning?",
    unboost_confirmation: "Weet je zeker dat je dit product wilt verwijderen?",
    no_used_products: "Je hebt nog geen vermeldingen",
    no_boosted_products: "Je hebt geen verhoogde producten",
    next: "Volgende",
    previous: "Vorig",
    skip: "Overslaan",
    start: "Begin",
    list_used: "Maak een lijst van een gebruikt product",
    buy_description:
      "Ontdek en zoek naar producten die worden aangeboden door buren om u heen",
    sell_description: "Lijst Producten U hoeft niet langer te koop",
    list_used_description:
      "Maak een lijst van een gebruikt product te koop in minder dan 20 seconden",
    boost_product_option_1: "<B> Boost 1  Nday </ b>  n  n <b> $ 0,99 </ b>",
    boost_product_option_2: "<b> Boost 3  Ndays </ b>  n  n <b> $ 1,99 </ b>",
    boost_product_option_3: "<b> Boost 7  Ndays </ b>  n  n <b> $ 3,99 </ b>",
    boost_product_description:
      "Krijg meer weergaven elke dag. Uw artikel verschijnt in Uitgelichte posities binnen de TOP 30-items in het kopen en de categorie. Gepromote items worden geroteerd onder de aangewezen plekken, zodat elk item eerlijke blootstelling krijgt.",
    boost_cta: "Verkocht sneller",
    boost_terms:
      "Door boost te tikken, gaat u akkoord met <u> vermeld in de buurt van Servicevoorwaarden. </ U>",
    boost_best_value: "Beste waarde",
    already_boosted: "Dit product wordt gestimuleerd",
    clicks: "Klikken",
    impressions: "Indrukken",
    end: "Einde",
    transactions_empty_text:
      "U hebt nog geen boosttransacties. U kunt het tabblad Verkoop bezoeken en beginnen met het stimuleren van uw producten.",
    transactions_loading_error:
      "Kan de lijst van transacties niet bijwerken, probeer het later opnieuw.",
    transactions_history_title: "Boost transacties geschiedenis",
    communicative_postive: "Communicatief vaardig",
    communicative_negative: "Oncommunicatief",
    ontime_postive: "Op tijd",
    ontime_negative: "Laat",
    reliable_postive: "Betrouwbaar",
    reliable_negative: "Onbetrouwbaar",
    friendly_postive: "Vriendelijk",
    friendly_negative: "Onbeleefd",
    itemasdescribed_postive: "Voorwerp als beschreven",
    itemasdescribed_negative: "Item niet zoals beschreven",
    other: "Ander",
    submit: "Indienen",
    adding_rating_reviews: "Rating en beoordelingen toevoegen",
    no_internet_title: "Geen internet verbinding",
    no_internet_message:
      "Zorg ervoor dat u verbinding hebt met internet en het opnieuw probeert",
    retry: "Opnieuw proberen",
    near_me: "Dicht bij mij",
    newest_first: "Nieuwste eerst",
    miles: "mijl",
    km: "Km",
    similar_products: "vergelijkbare producten",
    favorite_products: "Favoriete producten",
    items_for_sale: "Producten te koop",
    joined: "Toegetreden",
    favorites_transactions_title: "Favorieten",
    boosted_products_transactions_history:
      "Versterkte producten van producten Transacties Geschiedenis",
    views: "Keer bekeken",
    boost_graph_title: "Boost grafiek",
    no_favorite_products: "Je hebt geen favoriete producten",
    make_offer_buy: "ik zou graag willen kopen",
    make_offer_buy_for: "voor",
    notifications: "Meldingen",
    push_notifications: "Duw",
    emails_notifications: "E-mail",
    apply: "Van toepassing zijn",
    email_messages: "E-mail voor berichten",
    email_new_products: "E-mail voor nieuwe producten",
    push_day_only: "Alleen pushmeldingen",
    push_24_hours: "Pushmeldingen 24 uur",
    edit: "Bewerk",
    map: "Kaart",
    camera: "Camera",
    gallery: "Galerij",
    delete: "Verwijderen",
    no_sell_items: "Geen items te koop",
    who_bought_question: "Wie heeft het gekocht?",
    sold_elsewhere_question: "Het ergens anders verkocht",
    confirm: "Bevestigen",
    over_limit_camera: "Je kunt niet meer dan vijf afbeeldingen toevoegen",
    boost_failed: "Boost is mislukt. Probeer het later opnieuw",
    after_purchase: "Betaling succesvol  Nproduct gestimuleerd",
    pay_failed: "Betaling mislukt. Probeer het opnieuw",
    done: "Gedaan",
    not_now: "Niet nu",
    boost: "Boost",
    invalid_zip_code: "Ongeldige postcode",
    invalid_user_name: "Ongeldige gebruikersnaam",
    comments: "Opmerkingen",
    questions: "Vragen",
    bug_reports: "Foutmeldingen",
    feature_request: "Functieaanvraag",
    feedback_type: "Soort feedback",
    feedback_description:
      "We horen graag uw gedachten of feedback over hoe we uw ervaring kunnen verbeteren!",
    feedback: "Feedback",
    feedback_text: "Uw antwoord",
    suggestions: "Suggesties voor verbetering",
    delete_account: "Account verwijderen",
    new_message: "Nieuw bericht",
    online: "Online",
    km_50: "50 km",
    km_100: "100 km",
    km_200: "200 km",
    miles_30: "30 mijl",
    miles_60: "60 mijl",
    miles_120: "120 mijl",
    rate_app_question: "Hoe zit het met een beoordeling in de App Store?",
    enjoying_question: "Genieten van vermeld in de buurt van me?",
    not_enjoy: "Niet echt",
    feedback_question: "Zou je het erg vinden om ons wat feedback te geven?",
    yes_sure: "OK zeker",
    product_available_question: "Hallo, is dit nog steeds beschikbaar?",
    buy_question: "Hallo, ik hou ervan om dit te kopen",
    meet_question: "Hallo, kun je vandaag ontmoeten?",
    follow: "Volgen",
    followers: "Volgers",
    following: "Volgend",
    feedback_thanks: "Bedankt voor je feedback",
    all_categories: "Alle categorieën",
    deleted_account: "Dit account wordt verwijderd",
    delete_account_question: "Weet u zeker dat u dit account wilt verwijderen?",
    no_followings: "volgt niemand",
    when_following: "wanneer",
    no_followings_subtitle: "volgt mensen, je zult ze hier zien",
    no_followers: "heeft geen volgers",
    no_followers_subtitle: "gevolgd door mensen, zul je ze hier zien",
    distance: "Afstand",
    filter_method: "Filtermethode",
    see_listings: "Zie aanbiedingen",
    sold: "Verkocht",
    bought: "Gekocht",
    no_notifications: "Wanneer u meldingen ontvangt, verschijnen ze hier",
    items_title: "Items",
    new_listing_title: "Maak een nieuwe lijst",
    dialog_year_title: "Jaar",
    dialog_make_title: "Maken",
    dialog_model_title: "Model",
    dialog_body_style_title: "Lichaamsstijl",
    dialog_exterior_color_title: "Exterieurkleur",
    dialog_interior_color_title: "Interieurkleur",
    dialog_transmission_title: "Overdragen",
    dialog_fuel_type_title: "Brandstoftype",
    dialog_owners_num_title: "Aantal eigenaren",
    dialog_vehicle_owed_money_title: "Is er geld op dit voertuig verschuldigd?",
    automatic_transmission: "Automatisch",
    manual_transmission: "Handleiding",
    not_sure: "Niet zeker",
    wagon_hatchback: "Wagon &  Hatchback",
    convertible: "Converteerbaar",
    coupe: "Coupe",
    sedan: "Sedan",
    black_color: "Zwart",
    blue_color: "Blauw",
    brown_color: "bruin",
    gold_color: "Goud",
    green_color: "Groente",
    grey_color: "Grijs",
    pink_color: "Roze",
    purple_color: "Purper",
    red_color: "rood",
    silver_color: "Zilver",
    orange_color: "Oranje",
    white_color: "wit",
    yellow_color: "Geel",
    charcol_color: "Charcol",
    fuel_diesel: "Diesel",
    fuel_electric: "Elektrisch",
    fuel_gasoline: "Benzine",
    fuel_flex: "Buigen",
    fuel_hybrid: "Hybride",
    fuel_petrol: "Benzine",
    fuel_plugin_hybrid: "Plug-in hybride",
    truck: "Vrachtauto",
    van_minivan: "Van &  Busje",
    suv_crossover: "SUV &  Crossover",
    awd_4wd: "AWD / 4WD",
    fwd: "Fwd",
    rwd: "Rwd",
    off_white_color: "Van wit",
    tan_color: "Bruinen",
    beige_color: "Beige",
    burgundy_color: "Bourgondië",
    turquoise_color: "Turkoois",
    title_status_clean: "Schoon",
    title_status_rebuilt: "Herbouwd",
    title_status_salvage: "Redden",
    title_status_missing: "Missend",
    title_status_lien: "Lien",
    title_status: "Titelstatus",
    mileage: "Kilometers",
    dialog_drivetrain_title: "Drivetrain",
    model_warning: "Selecteer eerst MAAK",
    required_field_warning: "dit veld is verplicht",
    vehicle_vin: "Vin",
    invalid_vin: "Ongeldige Vin, stel VIN opnieuw in.",
    invalid_mileage: "Ongeldige kilometers, stel de kilometers opnieuw in.",
    clean_description:
      "De meeste voertuigen die niet in een ongeluk zijn geweest",
    rebuilt_description: "Een geborgen auto die is herbouwd",
    salvage_description: "Wordt overwogen na een ongeluk",
    missing_description: "Heeft een nieuwe DMV-problemen nodig",
    lien_description: "Eigendom van een bank of rechtbank",
    nearme: "Dicht bij mij",
    newest: "Nieuwste",
    contact_support: "Contact opnemen met ondersteuning",
    create_home_title: "Huizen te koop of te huur",
    for_sale: "Te koop",
    for_rent: "Te huur",
    property_type: "Eigendom type",
    apartment: "Appartement",
    house: "huis",
    room_only: "Alleen",
    townhouse: "Herenhuis",
    bedrooms: "Slaapkamers",
    bathrooms: "Badkamers",
    property_address: "Eigendom adres",
    price_per_month: "Prijs per maand",
    square_feet: "Vierkante meter",
    year_built: "Bouwjaar",
    year_renovated: "Jaar gerenoveerd",
    lot_size: "Lotgrootte",
    laundry_type: "Wasserijtype",
    in_unit_laundry: "Wasserij in eenheid",
    laundry_building: "Wasserij in gebouw",
    laundry_available: "Wasserij beschikbaar",
    none: "Geen",
    parking_type: "Parkeerplaats",
    garage_parking: "Garage parkeren",
    street_parking: "Parkeren op straat",
    off_street_parking: "Off-Street Parking",
    available_parking: "Parkeergelegenheid beschikbaar",
    air_cond_type: "Airconditioning type",
    ac_available: "AC beschikbaar",
    central_ac: "Centraal AC",
    heating_type: "Verwarmingstype",
    electric_heating: "Elektrische verwarming",
    gas_heating: "Gasverwarming",
    radiator_heating: "Radiateurverwarming",
    available_heating: "Verwarming beschikbaar",
    amenities: "Voorzieningen",
    date_available: "Datum beschikbaar",
    lease_length: "Lengte",
    month_to_month: "Maand tot maand",
    three_months: "3 maanden",
    six_months: "6 maanden",
    one_year: "1 jaar",
    more_one_year: "1+ jaar",
    cat_friendly: "Katvriendelijk",
    dog_friendly: "Hondvriendelijk",
    balcony: "Balkon",
    basement: "Kelder",
    bike_parking: "Bike Parking",
    cable_tv: "Kabel TV",
    ceiling_fan: "Plafondventilator",
    concierge: "Conciërge",
    dishwasher: "Afwasmachine",
    doorman: "Portier",
    elevator: "Lift",
    fireplace: "Haard",
    fitness_center: "Fitness centrum",
    garbage_disposal: "Afvalverwijdering",
    microwave: "Magnetron",
    online_app: "Online app",
    oven: "Oven",
    package_service: "Pakketdienst",
    patio: "Patio",
    pet_park: "Huisdier",
    refrigerator: "Koelkast",
    resident_lounge: "Woonkamer",
    roof_deck: "Dakterras",
    secured_entry: "Beveiligde invoer",
    storage: "Opslag",
    walk_in_closet: "Inloopkast",
    swimming_pool: "Zwembad",
    wheelchair_access: "Rolstoel toegang",
    central_heating: "Centrale verwarming",
    invalid_bedrooms:
      "Ongeldige slaapkamers, plaats alsjeblieft weer slaapkamers.",
    invalid_bathrooms: "Ongeldige badkamers, stel de badkamers weer in.",
    chinese_simplified_language: "Versimpeld Chinees",
    chinese_traditional_language: "Chinese traditionele",
    czech_language: "Tsjechisch",
    danish_language: "Deens",
    dutch_language: "Nederlands",
    finnish_language: "Fins",
    french_language: "Frans",
    german_language: "Duits",
    greek_language: "Grieks",
    hungarian_language: "Hongaars",
    indonesian_language: "Indonesisch",
    italian_language: "Italiaans",
    japanese_language: "Japans",
    korean_language: "Koreaans",
    norwegian_language: "Noors",
    polish_language: "Pools",
    portuguese_language: "Portugees",
    portuguese_brazilian_language: "Portugees, Braziliaans",
    romanian_language: "Roemeense",
    russian_language: "Russisch",
    swedish_language: "Zweeds",
    turkish_language: "Turks",
    ukrainian_language: "Oekraïens",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "Vietnamees",
    category_home_sale_or_rent: "Thuis te koop of te huur",
    square_meter: "Vierkante meter",
    copy_text: "Kopiëren",
    copyied_to_clipboard: "Gekopieerd naar het klembord",
    inbox: "Postvak IN",
    input_title_listening: "Luisteren ...",
    input_subtitle_listening: "Zeg iets",
    input_title_error: "Sorry, we hebben dat niet helemaal.",
    input_subtitle_error: "Probeer uw verzoek te herhalen.",
    input_hint_error: "Probeer opnieuw",
    price_less_than_or_equal: "Prijs minder dan of gelijk aan",
    any_price: "Iedere prijs",
    any_condition: "Elke voorwaarde",
    any_time: "Op elk gewenst moment",
    days_ago: "dagen geleden",
    any_distance: "Elke afstand",
    distance_within: "Afstand binnen",
    new_notification: "Nieuwe melding",
    deleted: "Verwijderd",
    processing_image: "Bewerking afbeelding",
    remove_dialog_message: "Wilt u dit product echt verwijderen?",
    deleted_thread: "Dit bericht wordt verwijderd",
    category_yard_sale_event: "Werf verkoopevenement",
    yard_first_date: "Yard sale eerste date",
    yard_second_date: "Yard sale tweede datum",
    yard_third_date: "Yard Sale Derde datum",
    yard_start_time: "Starttijd",
    yard_end_time: "Eindtijd",
    yard_end_timestamp: "Einde tijdstempel",
    invalid_date1: "Ongeldige eerste date, stel de eerste date opnieuw in",
    invalid_start_time: "Ongeldige starttijd, stel de starttijd opnieuw in",
    invalid_end_time: "Ongeldige eindtijd, stel de eindtijd opnieuw in",
    yard_sale_title: "Tuinverkoop",
    garage_tag: "garage",
    yard_tag: "tuin",
    from: "Van",
    to: "Naar",
    block: "Blok",
    un_block: "Deblokkeren",
    sign_email: "Log in met e-mail",
    invalid_first_date:
      "Ongeldige eerste date, zorg ervoor dat de eerste date vóór de tweede en derde is",
    invalid_second_date:
      "Ongeldige tweede datum, zorg ervoor dat de tweede datum vóór de derde datum is",
    invalid_start_time_value:
      "Ongeldige starttijd, zorg ervoor dat de starttijd vóór eindtijd is",
    use_default_yard_photo: "Gebruik standaard werf verkoop foto",
    active_label: "Actief",
    enable_notifications: "Notificaties aanzetten",
    login: "Log in",
    january: "januari",
    february: "februari",
    march: "maart",
    april: "april",
    may: "Kunnen",
    june: "juni-",
    july: "juli-",
    august: "augustus",
    september: "september",
    october: "oktober",
    november: "November",
    december: "december",
    since: "Sinds",
    product_views: "Productweergaven",
    shop_views: "Winkel uitzicht",
    total_sales: "Totale verkoop",
    total_orders: "Totale bestellingen",
    last_twelvth_months: "Laatste twaalvth maanden",
    last_nine_months: "Laatste negen maanden",
    last_six_months: "Laatste zes maanden",
    last_three_months: "Laatste drie maanden",
    last_12_months: "Afgelopen 12 maanden",
    last_9_months: "Laatste 9 maanden",
    last_6_months: "Laatste 6 maanden",
    last_3_months: "Laatste 3 maanden",
    months: "Maanden",
    open: "Open",
    reset_password: "Wachtwoord opnieuw instellen",
    create_new_shop: "Maak een nieuwe winkel",
    download_app: "Download app",
    log_in: "Log in",
    sign_up: "Inschrijven",
    no_result: "Geen resultaat",
    max_price: "Max",
    max_distance: "Maximale afstand",
    max_time: "Maximale tijd",
    posted_less_than: "Geplaatst minder dan",
    result: "Resultaat",
    more: "Meer",
    or: "OF",
    password: "Wachtwoord",
    forgot_password: "Wachtwoord vergeten?",
    and: "en",
    download_for: "Downloaden voor",
    apple_ios: "Apple iOS",
    android: "Android",
    image: "Afbeelding",
    edit_image: "Bewerk afbeelding",
    please_complete: "graag invullen",
    enter_your_offer: "Voer je aanbod in",
    categories: "Categorieën",
    upload_image: "Afbeelding uploaden",
    upload_images: "Upload afbeeldingen",
    back: "Rug",
    see_more: "Bekijk meer",
    add_product: "Product toevoegen",
    selected: "Geselecteerd",
    create: "Creëren",
    rate_the_buyer: "Beoordeel de koper",
    delete_product: "Product verwijderen",
    product: "Product",
    un_block_product: "Deblokkeer product",
    share_your_product: "Deel uw product",
    boost_details: "Verbreek details",
    remove_all_products: "Verwijder alle producten",
    remove_all: "Verwijder alles",
    add_vehicle: "Voeg voertuig toe",
    edit_vehicle: "Bewerk voertuig",
    upload_a_photo: "Upload een foto",
    view_details: "Bekijk details",
    add_yard_sale: "Voeg werfverkoop toe",
    edit_yard_sale: "Edit Yard Sale",
    users: "Gebruikers",
    users_details: "Gebruikers details",
    users_by_country: "Gebruikers per land",
    blocked_users: "Geblokkeerde gebruikers",
    products_cards: "Producten kaarten",
    archived_products: "Gearchiveerde producten",
    blocked_products: "Geblokkeerde producten",
    products_by_country: "Producten per land",
    reports: "Verslag doen van",
    reports_details: "Rapporteert details",
    closed_reports: "Gesloten rapporten",
    threads: "Draden",
    threads_details: "Draad Details",
    chat_support: "Chatondersteuning",
    actions: "Acties",
    search_actions: "Zoekacties",
    product_view_actions: "Productweergave Acties",
    contact_seller_product: "Neem contact op met de verkoper Product",
    contact_owner_shop: "Neem contact op met de eigenaarwinkel",
    ratings: "Waarderingen",
    reviews: "Beoordelingen",
    products_all_countries: "Producten Alle landen",
    edit_profile: "Bewerk profiel",
    my_profile: "Mijn profiel",
    profile_updated_successfully: "profiel succesvol bijgewerkt",
    are_you_sure: "Weet je zeker dat",
    my_used_products: "Mijn gebruikte producten",
    my_shops: "Mijn winkels",
    my_boosted_products: "Mijn verhoogde producten",
    messages_type_message_here: "Schrijf je bericht hier",
    messages_product_sold: "Dit product wordt verkocht of verwijderd",
    seen: "Gezien",
    messages_never_miss_message: "Mis nooit een bericht",
    enable: "Inschakelen",
    send_notify: "Verzenden",
    un_close: "Openmaken",
    type_your_review: "Typ uw beoordeling",
    again_question: "nog een keer ?",
    ratings_already_submitted_review: "U hebt al een beoordeling ingediend",
    set_product_category: "Productcategorie instellen",
    auth_email_password_incorrect: "Uw e-mail of wachtwoord onjuist",
    auth_insert_your_name: "Voer uw naam in",
    auth_email_address_badly: "Het e-mailadres is slecht geformatteerd",
    auth_email_address_used:
      "Het e-mailadres is al in gebruik door een ander account",
    auth_invalid_password: "Wachtwoord moet minimaal 6 tekens zijn",
    auth_reset_email:
      "Voer uw e-mailadres in om uw wachtwoord opnieuw in te stellen",
    auth_check_email:
      "Controleer alstublieft uw e-mail om het wachtwoord opnieuw in te stellen",
    auth_can_sign_in_google: "U kunt inloggen met Google-knop",
    auth_do_not_have_account: "Heb je geen account?",
    auth_have_account: "Heb je een account?",
    log_terms_privacy_part1:
      "Door aan te melden of in te loggen, gaat u akkoord met de vermelde bij mij",
    boost_this_product: "Boost dit product?",
    product_successfully_boosted: "Het product is succesvol verhoogd",
    product_failed_boost: "Het product is mislukt in boost",
    no_products_for_sale:
      "U hebt momenteel geen gebruikte producten die worden vermeld te koop.",
    not_sold_listed_near_me: "Ik heb het niet opgesomd in de buurt van me",
    agree_add_product:
      "Door POST te tikken om uw product te publiceren, gaat u akkoord met de vermelde servicevoorwaarden en het privacybeleid.",
    click_to_boost: "Klik op het product om het te verhogen",
    listed_terms_of_service: "Vermeld bij mij Servicevoorwaarden",
    receive_emails_for_users: "Ontvang e-mails voor gebruikersberichten",
    receive_emails_for_newly_posted:
      "Ontvang e-mails voor uw nieuw geposte producten",
    disable_push_notifications: "Schakel pushmeldingen uit",
    sms_during_day: "Ontvang SMS gedurende de dag",
    sms_24_hours: "Ontvang sms 24 uur",
    products: "Producten",
    product_no_longer_available:
      "Sorry, dit product is niet langer beschikbaar",
    add_home: "Toevoegen",
    edit_home: "Bewerken",
    fill_required_fields: "Vul alle vereiste velden",
    no_notification: "Er zijn geen meldingen",
    orders_history: "Bestellingen geschiedenis",
    privacy: "Privacy",
    terms: "Termen",
    report_a_problem: "Meld een probleem",
    approximation_protect_user_privacy:
      "Benadering om de privacy van de gebruiker te beschermen",
    do_not_have_products: "Je hebt geen producten",
    emails: "E-mails",
    lead_deletion_products:
      "Dit zal leiden tot het verwijderen van al uw producten",
    confirm_legal_message:
      "U bent uitsluitend verantwoordelijk voor het nemen van alle noodzakelijke voorzorgsmaatregelen bij het interageren met anderen, vooral bij het voldoen aan een vreemde persoon voor de eerste keer. Bekijk de Servicevoorwaarden voor meer informatie.",
    push_notifications_notified_instantly:
      "Schakel duwmeldingen onmiddellijk in staat te stellen",
    rate_seller: "Beoordeel verkoper",
    user_journey: "Gebruikersreis",
    user: "Gebruiker",
    user_id: "Gebruikersnaam",
    action_id: "Actie-ID",
    select_model_car: "Selecteer het model van de auto",
    boost_1_day: "Boost 1 dag",
    boost_3_days: "Boost 3 dagen",
    boost_7_days: "Boost 7 dagen",
    agree_boost_terms: "Door boost te tikken, gaat u akkoord met",
    add: "Toevoegen",
    add_tag: "Tag toevoegen",
    brand_title: "Merk",
    category_mobiles: "Mobiles",
    category_tablets: "Tabletten",
    screen_size: "Scherm grootte",
    has_cellular_capability: "Heeft cellulaire mogelijkheden",
    default_internal_memory: "Intern geheugen",
    network_carrier: "Netwerkcarrier",
    is_unlocked: "Is ontgrendeld",
    mobile_model_warning: "Selecteer eerst het merk",
    missing_image: "Ontbrekende afbeelding, probeer opnieuw beeld toe.",
    add_mobile: "Mobiel toevoegen",
    edit_mobile: "Bewerk mobiel",
    add_tablet: "Voeg tablet toe",
    edit_tablet: "Bewerk tablet",
    keywords:
      "Winkelen, kopen, verkopen, geld verdienen, handel, locals, buren, auto, voertuigen",
    country: "Land",
    phone_number: "Telefoonnummer",
    verification_code: "Verificatie code",
    error_occurred: "Er is een fout opgetreden, probeer het later opnieuw",
    invalid_state:
      "Ongeldige toestand: een inlograllback is ontvangen, maar er is geen inlogverzoek verzonden.",
    sign_in: "Inloggen",
    sign_in_apple: "Log in met Apple",
    sign_in_google: "Log in met Google",
    sign_in_phone: "Log in met telefoon",
    sign_in_facebook: "Meld je aan met facebook",
    create_account: "Account aanmaken",
    email: "E-mail",
    invalid_field: "Vul de vereiste velden in",
    code_sent: "De code is verzonden door SMS",
    verify_number: "Controleer het telefoonnummer",
    tapping_verify_number:
      "Door tikken (verifiëren van het telefoonnummer), wordt een sms verzonden.",
    email_exists:
      "Het account bestaat al en u moet deze toegang krijgen via Google-knop, Facebook-knop of Apple-knop",
    ok: "OK",
    sure_back: "Weet je het zeker?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "geleden",
    add_model: "Voeg model toe",
    no_search_results_us:
      "Geen zoekresultaten bij u in de buurt binnen 120 mijl. Probeer het zoekfilter of zoekwoord te wijzigen.",
    no_search_results:
      "Geen zoekresultaten bij u in de buurt binnen 200 km. Probeer het zoekfilter of zoekwoord te wijzigen.",
    plan_date: "Plan datum",
    plan_time: "Plan tijd",
    invalid_plan_date: "Ongeldig plandatum, stel de plandatum opnieuw in",
    invalid_plan_time: "Ongeldig plantijd, stel de plantijd weer in",
    plan_name: "Plannaam",
    plan_title: "Plan",
    update_plan_name: "Update plannaam",
    delete_plan_question: "Weet u zeker dat u dit plan wilt verwijderen?",
    plan_reminder_message: "U wordt een uur eerder herinnerd",
    plan_dialog_title: "Ontmoetingsplan",
    planners_title: "Planners",
    unable_sending_messages:
      "Ze zullen uw berichten zien wanneer ze weer online zijn.",
    its_text: "Zijn",
    for_your_text: "voor uw ontvanger.",
  },
  fi: {
    invalid_area: "Virheellinen alue, aseta alue uudelleen.",
    invalid_lot_size:
      "Virheellinen kiinteistöjen koko, aseta paljon kokoa uudelleen.",
    property_area: "Kiinteistöalue",
    app_store_name:
      "Listattu lähellä minua - osta käytetyt kohteet, myydä käteistä",
    app_store_short:
      "Paikallisten myyjien markkinapaikka. Luettele myytävänä oleva kohde ja tee rahaa.",
    app_store_full:
      "Listattu lähistöllä on helppo löytää hyviä tarjouksia haluamallasi asioista ja tehdä rahaa sellaisiin asioihin, jotka haluat myydä. Tämä on paras tapa ostaa ja myydä yhteisössä tai naapurustossa ihmisten kanssa, johon voit luottaa. Miten se toimii: 1 - Osta tai myy mitään; Voit helposti lähettää kohteita myyntiin sekunnissa. 2 - Etsi hyviä tarjouksia ja alennuksia vaatteista, huonekaluista, matkapuhelimista, elektroniikasta, vauvoista ja lasten tuotteista, urheiluvälineistä, käytetyistä autoista, mekkoista, kengistä ja kelloista, kirjoista, käytetyistä leluista, käytetyistä kannettavista tietokoneista, käytetty auto ja jopa todellinen kiinteistö myytävänä tai vuokraa. 3 - Selaa paikallisia kohteita myytävänä. 4 - Viestin ostajat ja myyjät sovelluksesta. 5 - Selaa kohteita kuvan mukaan ja lajittele kategorioittain. Hauskoja tosiasiat lueteltu lähellä minua: 1- lueteltu lähellä minua voit helposti myydä mitään, vaatteista käyttää autoja elektroniikkaan. 2 - Viestintä ostajien ja myyjien välillä tapahtuu sovelluksen kautta viestin kautta. 3- listan lähellä minua on parempi kuin autotalli; Etsi mitä haluat alennuksella, aivan puhelimessa tai tabletissa.",
    app_store_release:
      "Listattu lähellä minua - kauppaa paikallisten kanssa. Liity paikallisten ostajien ja myyjien matkapuhelimeen!",
    app_name: "Listattu lähellä minua",
    title_buy: "Ostaa",
    title_messages: "Viestit",
    title_sell: "Myydä",
    title_profile_image: "Profiilikuva",
    title_account: "Tili",
    account_settings: "Tilin asetukset",
    settings: "asetukset",
    color_theme: "Väri teema",
    device_settings: "Laite asetukset",
    public_profile: "Julkinen profiili",
    light_mode: "Valotila",
    dark_mode: "Tumma tila",
    title_sell_faster: "Myydä nopeammin",
    send_button_label: "Lähettää",
    rate_message: "Arvioi minut...",
    already_rated: "Olet jo lähettänyt tarkistuksen",
    rate_review_question: "Haluatko käsitellä",
    again: "uudelleen?",
    action_logout: "Kirjautua ulos",
    action_category: "Kategoria",
    action_search: "Hae",
    action_refer: "Katso ystävä",
    dialog_choose_location: "Valitse sijainti",
    dialog_change_username: "Muuta käyttäjänimi",
    dialog_change_language: "Vaihda kieltä",
    dialog_image_tags: "Kuvatunnisteet",
    dialog_emails_notifications: "Sähköpostilaitteet",
    dialog_push_notifications: "Push-ilmoitukset",
    fragment_product_detail: "Tuotetiedot",
    fragment_message_details: "Viestit tiedot",
    fragment_sell: "Myydä",
    dialog_tags_title: "Tunnisteet",
    dialog_location_title: "Päivitä sijainti",
    dialog_username_title: "Muuta käyttäjänimi",
    tab_photo: "Kuva",
    tab_details: "Yksityiskohdat",
    tab_price: "Hinta",
    tab_finish: "Viedä loppuun",
    profile: "Profiili",
    search: "Hae",
    choose_product: "Valitse tuote",
    rating_review: "Luokitus ja tarkistus",
    select_buyer: "Valitse ostaja",
    tab_my_used_products: "Omat tuotteet",
    price_label: "Hinta",
    text_savings: "Säästät",
    search_hint: "Etsi tuotteita ...",
    empty_text: "Tässä luokassa tai valitulla etäisyydellä ei ole tuotteita.",
    filter_menu_text: "Suodattaa",
    error_contacting_seller: "Virhe ottamalla yhteyttä myyjään",
    edit_product: "Muokkaa tuotetta",
    contact_seller: "Ota yhteyttä myyjään",
    signup_to_contact_seller: "Kirjaudu yhteyttä myyjään",
    signup_to_make_offer: "Rekisteröidy tarjouksen",
    product_details: "Yksityiskohdat",
    product_category: "Kategoria",
    product_condition: "Kunto",
    product_description: "Kuvaus",
    product_location: "Tuotepaikka",
    product_location_approximate: "Sijainti on likimääräinen",
    over_week_time_ago: "Yli viikko sitten",
    boosted: "Kasvatti",
    threads_no_results: "Ei viestejä",
    message_no_results: "Ei viestejä",
    message_warning:
      "Olet yksin vastuussa kaikkien välttämättömien varotoimenpiteiden toteuttamisesta vuorovaikutuksessa muiden kanssa, etenkin kun tapaat muukalaista henkilökohtaisesti ensimmäistä kertaa. Älä jaa henkilökohtaisia ​​tietoja, varmennuskoodeja tai maksutietoja. Tarkista palvelusehdot saadaksesi lisätietoja.",
    message_block: "Et voi lähettää tai vastaanottaa viestejä tällä hetkellä.",
    select_location: "Valitse sijainti",
    location_permission_denied_message:
      "Sovellus edellyttää sijaintiluvan toimimaan oikein.",
    signed_in: "Kirjautunut sisään!",
    sign_in_canceller: "Kirjaudu sisään peruutettu",
    version: "Versio",
    build: "Rakentaa",
    name: "Nimi",
    location: "Sijainti",
    language: "Kieli",
    about_app: "Tietoja listalle lähelle minua",
    terms_of_service: "Käyttöehdot",
    privacy_policy: "Tietosuojakäytäntö",
    report_feedback: "Lähetä palautetta",
    report_bug: "Ravista puhelinta ilmoittaaksesi virheestä",
    change_image: "Vaihda kuva",
    update_location: "Päivitä sijainti",
    about_the_app: "Tietoja sovelluksesta",
    update_label: "Päivittää",
    uploading: "Lataaminen",
    adding: "Lisälaitteen lisääminen",
    removing: "Listan poistaminen",
    updating: "Listan päivitys",
    uploaded_image: "Ladattu kuva:",
    image_storage_failed: "Kuvan tallentaminen epäonnistui:",
    product_updated: "Tuote päivitetty onnistuneesti",
    location_error: "Sijainti ei ole tallennettu, yritä uudelleen",
    product_removed: "Tuote on poistettu onnistuneesti",
    deleted_product: "Tämä tuote poistetaan",
    invalid_title: "Virheellinen otsikko, aseta otsikko uudelleen.",
    invalid_image: "Virheellinen kuvapolku, yritä lisätä kuva uudelleen.",
    invalid_price: "Virheellinen hinta, aseta hinta uudelleen.",
    invalid_location: "Virheellinen sijainti, aseta sijainti uudelleen.",
    invalid_category: "Virheellinen luokka, aseta luokka uudelleen.",
    invalid_condition: "Virheellinen tila, aseta ehto uudelleen.",
    removing_title: "Profiilikuvan poistaminen",
    image_not_saved: "Kuvan tallennus epäonnistui!",
    product_load_failed: "Ei tuotteita",
    take_photo: "Ota kuva",
    select_photo: "Valitse valokuva",
    product_title_hint: "Mikä se on? Nimi, brändi, malli jne.",
    delete_photo: "Poista kuva",
    product_title: "Otsikko",
    mark_as_sold: "Mark kuten myydään",
    product_share: "Jaa",
    product_make_offer: "Tehdä tarjous",
    product_cover: "Aseta kansikuvaksi",
    product_tags: "Tunnisteet",
    product_posted: "Lähetetty:",
    product_change: "Muuttaa",
    product_post: "Lähettää",
    product_selling_from: "Myynti sijainnista",
    product_select_location: "Valitse sijainti",
    product_map_approximate:
      "Kartta on likimääräinen pitämään myyjän sijainti yksityinen",
    product_terms:
      "Tappamalla viesti julkaisemaan tuotteen, hyväksyt <u> listattu lähelle minua palvelun käyttöehtoja. </ U>",
    condition_other: "Muu (ks. Kuvaus)",
    condition_for_parts: "Osille",
    condition_used: "Käytetty (normaali kuluminen)",
    condition_open_box: "Avaa laatikko (ei koskaan käytetty)",
    condition_reconditioned: "Kunnostettu / sertifioitu",
    condition_new: "Uusi (ei koskaan käytetty)",
    select_category: "Valitse kategoria",
    select_all_category: "Valitse kaikki",
    category_loading_error:
      "Ei voi päivittää luokkien luetteloa, yritä myöhemmin uudelleen.",
    category_vehicles: "Ajoneuvot",
    category_furniture: "Huonekalut",
    category_electronics: "Elektroniikka",
    category_appliances: "Koti &  Laitteet",
    category_fashion_accessories: "Muoti &  Lisätarvikkeet",
    category_baby_kids: "Vauva &  Lapset",
    category_antiques_collectibles: "Antiikki &  Keräilyesineet",
    category_auto_parts_tools_machinery: "Auton osat, Työkalut &  Koneisto",
    category_sports_outdoors: "Urheilu &  Ulkona",
    category_others: "Toiset",
    location_enter_zip_code: "Anna postinumero",
    location_get_current_location: "Hanki nykyinen sijainti",
    location_select_location: "Valitse sijainti",
    location_update_location: "Päivitä sijainti",
    location_new_location: "Uusi sijainti",
    search_filter_results: "Suodata tulokset",
    search_filter_min: "Suodata minimi",
    search_filter_at_least: "Vähintään",
    price_filter: "Hintasuodatin",
    product_name: "tuotteen nimi",
    english_language: "Englanti",
    arabic_language: "arabialainen",
    spanish_language: "Espanja",
    system_language: "Järjestelmä",
    share_link: "Jaa linkki",
    save: "Tallentaa",
    cancel: "Peruuttaa",
    loading: "Ladataan",
    yes: "Joo",
    no: "Ei",
    report: "Raportti",
    report_product: "Ilmoita tuote",
    report_user: "Ilmoita käyttäjä",
    block_user: "Estä käyttäjä",
    un_block_user: "Poista käyttäjän esto",
    why_product: "Miksi haluat ilmoittaa tämän kohteen?",
    why_user: "Miksi haluat ilmoittaa tämän käyttäjän?",
    block_user_confirm: "Haluatko estää tämän käyttäjän pysyvästi?",
    un_block_user_confirm: "Haluatko poistaa tämän käyttäjän pysyvästi?",
    prohibited: "Kielletty lueteltu lähellä minua",
    offensive: "Loukkaava tai sopimaton",
    duplicate: "Kaksoiskappale",
    wrong_category: "Väärä luokka",
    scam: "Näyttää huijaukselta",
    stolen: "Mielestäni se on varastettu",
    product_other: "Muut",
    product_is_sold: "Tämä tuote myytiin",
    missed_meeting: "He jäivät kokoukseen",
    low_offer: "Matala tarjous",
    rude: "Epäkohtelias tai sopimaton",
    items: "Ongelma kohteita",
    trouble_meetup: "Vaikeuksia tavata",
    messaging: "Viestien ongelmat",
    user_other: "Muut",
    new_version_available: "Uusi versio käytettävissä",
    please_update_app: "Päivitä sovellus uuteen versioon jatkaaksesi.",
    update: "Päivittää",
    no_thanks: "Ei kiitos",
    contact_support_confirmation:
      "Nykyinen vasteaika on 24-48 tuntia. Haluatko ottaa yhteyttä listattuna lähellä minua app chat tukea?",
    unboost_confirmation: "Haluatko varmasti poistaa tämän tuotteen?",
    no_used_products: "Sinulla ei ole vielä luetteloita",
    no_boosted_products: "Sinulla ei ole tehostettuja tuotteita",
    next: "Seuraava",
    previous: "Edellinen",
    skip: "Ohita",
    start: "alkaa",
    list_used: "Luettele käytetty tuote",
    buy_description: "Tutustu ja etsiä naapureiden tarjoamia tuotteita",
    sell_description: "Luettele tuotteet, joita et enää tarvitse myytävänä",
    list_used_description:
      "Luettele käytetty tuote myytävänä alle 20 sekunnissa",
    boost_product_option_1: "<b> Boost 1  nday </ b>  n  n <b> $ 0.99 </ b>",
    boost_product_option_2: "<b> Boost 3  Ndays </ b>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<b> Boost 7  ndays </ b>  n  n <b> 3,99 € </ b>",
    boost_product_description:
      "Hanki lisää näkymiä joka päivä. Kohde näkyy esillä olevissa paikoissa 30 parhaan osan osto- ja tuoteryhmässä. Edistetyt tuotteet pyörivät nimetyissä paikoissa, jotta jokainen kohde saa reilua altistumista.",
    boost_cta: "Myydä nopeammin",
    boost_terms:
      "Tappamalla boost, hyväksyt <u> listattu lähelle minua käyttöehtoja. </ U>",
    boost_best_value: "Paras arvo",
    already_boosted: "Tätä tuotetta tehostetaan",
    clicks: "Napsauttaa",
    impressions: "Näyttökerrat",
    end: "Loppu",
    transactions_empty_text:
      "Sinulla ei ole vielä vauhtia tapahtumia. Voit käydä myydä-välilehdessä ja aloittaa tuotteiden vahvistamisen.",
    transactions_loading_error:
      "Ei voi päivittää tapahtumien luetteloa, yritä myöhemmin uudelleen.",
    transactions_history_title: "Boost Transactions Historia",
    communicative_postive: "Kommunikaatio",
    communicative_negative: "Vähäpuheinen",
    ontime_postive: "Ajallaan",
    ontime_negative: "Myöhään",
    reliable_postive: "Luotettava",
    reliable_negative: "Epäluotettava",
    friendly_postive: "Ystävällinen",
    friendly_negative: "Epäkohtelias",
    itemasdescribed_postive: "Kohta kuvatulla tavalla",
    itemasdescribed_negative: "Tuote ei vastaa kuvausta",
    other: "Muut",
    submit: "Lähetä",
    adding_rating_reviews: "Lisäämällä luokitus ja arvostelut",
    no_internet_title: "Ei Internet-yhteyttä",
    no_internet_message:
      "Varmista, että olet yhteydessä Internetiin ja yritä uudelleen",
    retry: "Yrittää uudelleen",
    near_me: "Lähellä minua",
    newest_first: "Uusin ensin",
    miles: "kilometriä",
    km: "km",
    similar_products: "Samankaltaiset tuotteet",
    favorite_products: "Suosikkituotteet",
    items_for_sale: "Myytävänä olevat kohteet",
    joined: "Yhdistynyt",
    favorites_transactions_title: "Suosikit",
    boosted_products_transactions_history:
      "Tehostetut tuotteet Transactions Historia",
    views: "Näkymät",
    boost_graph_title: "Boost kaavio",
    no_favorite_products: "Sinulla ei ole suosikkituotteita",
    make_offer_buy: "haluaisin ostaa",
    make_offer_buy_for: "varten",
    notifications: "Ilmoitukset",
    push_notifications: "Työntää",
    emails_notifications: "Sähköposti",
    apply: "Käytä",
    email_messages: "Sähköpostiviestejä",
    email_new_products: "Sähköposti uusille tuotteille",
    push_day_only: "Push-ilmoitukset vain päivä",
    push_24_hours: "Työnnä ilmoitukset 24 tuntia",
    edit: "Muokata",
    map: "Kartta",
    camera: "Kamera",
    gallery: "Galleria",
    delete: "Poistaa",
    no_sell_items: "Myöhyy myytäviä kohteita",
    who_bought_question: "Kuka osti sen?",
    sold_elsewhere_question: "Myosti sen jonnekin muualla",
    confirm: "Vahvistaa",
    over_limit_camera: "Et voi lisätä enemmän kuin viisi kuvaa",
    boost_failed: "Boost epäonnistui. Yritä uudelleen myöhemmin",
    after_purchase: "Maksu onnistuu  NProduct lisäsi",
    pay_failed: "Maksu epäonnistui. Yritä uudelleen",
    done: "Tehty",
    not_now: "Ei nyt",
    boost: "Kasvaa",
    invalid_zip_code: "Väärä postinumero",
    invalid_user_name: "Virheellinen käyttäjätunnus",
    comments: "Kommentit",
    questions: "Kysymykset",
    bug_reports: "Virheilmoitukset",
    feature_request: "Ominaisuuspyyntö",
    feedback_type: "Palautetyyppi",
    feedback_description:
      "Haluaisimme kuulla ajatuksiasi tai palautetta siitä, miten voimme parantaa kokemustasi!",
    feedback: "Palaute",
    feedback_text: "Vastauksesi",
    suggestions: "Parannusehdotukset",
    delete_account: "Poista tili",
    new_message: "Uusi viesti",
    online: "Verkossa",
    km_50: "50 km",
    km_100: "100 km",
    km_200: "200 km",
    miles_30: "30 mailia",
    miles_60: "60 mailia",
    miles_120: "120 mailia",
    rate_app_question: "Entä luokitus App Storesta?",
    enjoying_question: "Nauttia listattuna lähellä minua?",
    not_enjoy: "Ei oikeastaan",
    feedback_question: "Haluatko antaa meille palautetta?",
    yes_sure: "OK toki",
    product_available_question: "Hei, onko tämä vielä käytettävissä?",
    buy_question: "Hei, haluan ostaa tämän",
    meet_question: "Hei, voitko tavata tänään?",
    follow: "Seurata",
    followers: "Seuraajat",
    following: "Seurata",
    feedback_thanks: "Kiitos palautteestasi",
    all_categories: "kaikki kategoriat",
    deleted_account: "Tämä tili poistetaan",
    delete_account_question: "Haluatko varmasti poistaa tämän tilin?",
    no_followings: "ei seuraa ketään",
    when_following: "kun",
    no_followings_subtitle: "Seuraa ihmisiä, näet ne täällä",
    no_followers: "ei ole seuraajia",
    no_followers_subtitle: "seuraa ihmisiä, näet ne täällä",
    distance: "Etäisyys",
    filter_method: "Suodatin menetelmä",
    see_listings: "Katso listat",
    sold: "Myydään",
    bought: "Ostettu",
    no_notifications: "Kun saat ilmoituksia, ne näkyvät täällä",
    items_title: "Tuotteet",
    new_listing_title: "Luo uusi listaus",
    dialog_year_title: "Vuosi",
    dialog_make_title: "Tehdä",
    dialog_model_title: "Malli",
    dialog_body_style_title: "Vartalo tyyli",
    dialog_exterior_color_title: "Ulkopuolinen väri",
    dialog_interior_color_title: "Sisäväri",
    dialog_transmission_title: "Tarttuminen",
    dialog_fuel_type_title: "Polttoainetyyppi",
    dialog_owners_num_title: "Omistajien määrä",
    dialog_vehicle_owed_money_title: "Onko tällä ajoneuvolla vieläkin velkaa?",
    automatic_transmission: "Automaattinen",
    manual_transmission: "Käsikirjoitus",
    not_sure: "Epävarma",
    wagon_hatchback: "Vaunu &  Viistoperä",
    convertible: "Vaihdettava",
    coupe: "Koira",
    sedan: "Sedan",
    black_color: "Musta",
    blue_color: "Sininen",
    brown_color: "Ruskea",
    gold_color: "Kulta",
    green_color: "Vihreä",
    grey_color: "Harmaa",
    pink_color: "Vaaleanpunainen",
    purple_color: "Violetti",
    red_color: "Punainen",
    silver_color: "Hopea",
    orange_color: "Oranssi",
    white_color: "Valkoinen",
    yellow_color: "Keltainen",
    charcol_color: "Charcol",
    fuel_diesel: "diesel-",
    fuel_electric: "Sähköinen",
    fuel_gasoline: "Bensiini",
    fuel_flex: "Taivuttaa",
    fuel_hybrid: "Hybridi",
    fuel_petrol: "Bensiini",
    fuel_plugin_hybrid: "Ladattava hybridi",
    truck: "Kuorma-auto",
    van_minivan: "Van &  Minivan",
    suv_crossover: "SUV &  Risteys",
    awd_4wd: "AWD / 4WD",
    fwd: "Fwd",
    rwd: "Rwd",
    off_white_color: "Pois valkoisesta",
    tan_color: "Ruskea",
    beige_color: "Beige",
    burgundy_color: "Burgundi",
    turquoise_color: "Turkoosi",
    title_status_clean: "Puhdas",
    title_status_rebuilt: "Rakentaa uudelleen",
    title_status_salvage: "Pelastaa",
    title_status_missing: "Puuttuu",
    title_status_lien: "Panttioikeus",
    title_status: "Otsikon tila",
    mileage: "Mittarilukema",
    dialog_drivetrain_title: "Drivestrain",
    model_warning: "Valitse ensin",
    required_field_warning: "Tämä kenttä pitää täyttää",
    vehicle_vin: "Vin",
    invalid_vin: "Virheellinen Vin, aseta Vin uudelleen.",
    invalid_mileage:
      "Virheellinen mittarilukema, aseta uudelleen mittarilukema uudelleen.",
    clean_description:
      "Useimmat ajoneuvot, jotka eivät ole olleet onnettomuudessa",
    rebuilt_description: "Pelastettu auto, joka on rakennettu uudelleen",
    salvage_description: "Pidetään onnettomuuden jälkeen",
    missing_description: "Tarvitsee uuden DMV-kysymyksen otsikon",
    lien_description: "Omistaa pankin tai tuomioistuimen ratkaisun",
    nearme: "Lähellä minua",
    newest: "Uusin",
    contact_support: "Yhteystiedot",
    create_home_title: "Kodit myytävänä tai vuokraa",
    for_sale: "Myytävänä",
    for_rent: "Vuokrattavana",
    property_type: "Omaisuuden tyyppi",
    apartment: "Huoneisto",
    house: "Talo",
    room_only: "Vain huone",
    townhouse: "Rivitalo",
    bedrooms: "Makuuhuoneet",
    bathrooms: "Kylpyhuoneet",
    property_address: "Omaisuuden osoite",
    price_per_month: "Hinta kuukaudessa",
    square_feet: "Neliömetriä",
    year_built: "Valmistusvuosi",
    year_renovated: "Vuosi Remontoitu",
    lot_size: "LOT-koko",
    laundry_type: "Pesula tyyppi",
    in_unit_laundry: "In-yksikön pesula",
    laundry_building: "Pesula rakennuksessa",
    laundry_available: "Pesula käytettävissä",
    none: "Ei mitään",
    parking_type: "Pysäköintityyppi",
    garage_parking: "Autotalli pysäköinti",
    street_parking: "Kadun pysäköinti",
    off_street_parking: "Off-Street Parking",
    available_parking: "Pysäköintipaikka",
    air_cond_type: "Ilmastointityyppi",
    ac_available: "AC käytettävissä",
    central_ac: "Keski-AC",
    heating_type: "Lämmitystyyppi",
    electric_heating: "Sähkölämmitys",
    gas_heating: "Kaasulämmitys",
    radiator_heating: "Jäähdyttimen lämmitys",
    available_heating: "Lämmitys",
    amenities: "Mukavuudet",
    date_available: "Päivä jolloin saatavilla",
    lease_length: "Vuokrasopimus",
    month_to_month: "Kuukaudesta kuukauteen",
    three_months: "3 kuukautta",
    six_months: "6 kuukautta",
    one_year: "1 vuosi",
    more_one_year: "1+ vuotta",
    cat_friendly: "Kissaystävällinen",
    dog_friendly: "Koiraystävällinen",
    balcony: "Parveke",
    basement: "Kellari",
    bike_parking: "Pyörän pysäköinti",
    cable_tv: "Kaapeli-tv",
    ceiling_fan: "Kattotuuletin",
    concierge: "Portinvartija",
    dishwasher: "Astianpesukone",
    doorman: "Ovenvartija",
    elevator: "Hissi",
    fireplace: "Takka",
    fitness_center: "Kuntokeskus",
    garbage_disposal: "Roskat hävittäminen",
    microwave: "Mikroaaltouuni",
    online_app: "Online-sovellus",
    oven: "Uuni",
    package_service: "Pakettipalvelu",
    patio: "Patio",
    pet_park: "Pet Park",
    refrigerator: "Jääkaappi",
    resident_lounge: "Resident Lounge",
    roof_deck: "Kattoterassi",
    secured_entry: "Turvattu merkintä",
    storage: "Varastointi",
    walk_in_closet: "Vaatehuone",
    swimming_pool: "Uima-allas",
    wheelchair_access: "Pääsy pyörätuolilla",
    central_heating: "Keskuslämmitys",
    invalid_bedrooms:
      "Virheelliset makuuhuoneet, aseta makuuhuoneet uudelleen.",
    invalid_bathrooms: "Virheelliset kylpyhuoneet, ota taas kylpyhuoneet.",
    chinese_simplified_language: "Yksinkertaistettu kiina",
    chinese_traditional_language: "Kiinalainen perinteinen",
    czech_language: "Tšekki",
    danish_language: "Tanskan kieli",
    dutch_language: "Hollannin kieli",
    finnish_language: "Suomalainen",
    french_language: "Ranskan kieli",
    german_language: "Saksan kieli",
    greek_language: "Kreikkalainen",
    hungarian_language: "Unkarin kieli",
    indonesian_language: "Indonesialainen",
    italian_language: "italialainen",
    japanese_language: "japanilainen",
    korean_language: "Korealainen",
    norwegian_language: "Norjan kieli",
    polish_language: "Kiillottaa",
    portuguese_language: "Portugalin kieli",
    portuguese_brazilian_language: "Portugali, Brasilian",
    romanian_language: "Romanialainen",
    russian_language: "Venäjän kieli",
    swedish_language: "Ruotsin kieli",
    turkish_language: "Turkkilainen",
    ukrainian_language: "Ukrainalainen",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "vietnam",
    category_home_sale_or_rent: "Koti myytävänä tai vuokraa",
    square_meter: "Neliömetri",
    copy_text: "Kopio",
    copyied_to_clipboard: "Kopioi leikepöydälle",
    inbox: "Postilaatikko",
    input_title_listening: "Kuuntelu ...",
    input_subtitle_listening: "Sano jotain",
    input_title_error: "Anteeksi, emme koskaan saaneet sitä.",
    input_subtitle_error: "Yritä toistaa pyyntösi.",
    input_hint_error: "Yritä uudelleen",
    price_less_than_or_equal: "Hinta vähemmän kuin tai yhtä suuri kuin",
    any_price: "Mikä tahansa hinta",
    any_condition: "Mikä tahansa tila",
    any_time: "Milloin vain",
    days_ago: "päiviä sitten",
    any_distance: "Mikä tahansa etäisyys",
    distance_within: "Etäisyys",
    new_notification: "Uusi ilmoitus",
    deleted: "Poistettu",
    processing_image: "Käsittely kuva",
    remove_dialog_message: "Haluatko todella poistaa tämän tuotteen?",
    deleted_thread: "Tämä viesti poistetaan",
    category_yard_sale_event: "Yard Myyntitapahtuma",
    yard_first_date: "Yard Myynti Ensimmäinen päivä",
    yard_second_date: "Yard Myynti Toinen päivä",
    yard_third_date: "Yard Myynti Kolmas päivä",
    yard_start_time: "Aloitusaika",
    yard_end_time: "Loppu aika",
    yard_end_timestamp: "Lopeta aikaleima",
    invalid_date1:
      "Virheellinen ensimmäinen päivämäärä, aseta ensimmäinen päivämäärä uudelleen",
    invalid_start_time: "Virheellinen alkamisaika, aseta alkamisaika uudelleen",
    invalid_end_time:
      "Virheellinen päättymisaika, aseta uudelleen lopetusaika uudelleen",
    yard_sale_title: "Pihakirppis",
    garage_tag: "autotalli",
    yard_tag: "piha",
    from: "Peräkkäin",
    to: "Jllek",
    block: "Lohko",
    un_block: "Esto",
    sign_email: "Kirjaudu sisään sähköpostitse",
    invalid_first_date:
      "Virheellinen ensimmäinen päivämäärä, varmista, että ensimmäinen päivä on ennen toista ja kolmasosaa",
    invalid_second_date:
      "Virheellinen toinen päivä, varmista, että toinen päivä on ennen kolmas päivä",
    invalid_start_time_value:
      "Virheellinen alkamisaika, varmista, että alkamisaika on ennen päättymistä",
    use_default_yard_photo: "Käytä oletuspihan myyntivalokuva",
    active_label: "Aktiivinen",
    enable_notifications: "Salli ilmoitukset",
    login: "Kirjaudu sisään",
    january: "tammikuu",
    february: "helmikuu",
    march: "Maaliskuu",
    april: "huhtikuu",
    may: "saattaa",
    june: "Kesäkuu",
    july: "heinäkuu",
    august: "elokuu",
    september: "syyskuu",
    october: "lokakuu",
    november: "marraskuu",
    december: "joulukuu",
    since: "Siitä asti kun",
    product_views: "Tuotteen näkymät",
    shop_views: "Kauppa näkymät",
    total_sales: "Kokonaismyynti",
    total_orders: "Tilaukset yhteensä",
    last_twelvth_months: "Viimeiset kaksivuotiset kuukaudet",
    last_nine_months: "Viimeiset yhdeksän kuukautta",
    last_six_months: "Viimeiset kuusi kuukautta",
    last_three_months: "Viimeiset kolme kuukautta",
    last_12_months: "Viimeiset 12 kuukautta",
    last_9_months: "Viimeiset 9 kuukautta",
    last_6_months: "Viimeiset 6 kuukautta",
    last_3_months: "Viimeiset 3 kuukautta",
    months: "Kuukaudet",
    open: "Avata",
    reset_password: "Nollaa salasana",
    create_new_shop: "Luo uusi kauppa",
    download_app: "Lataa sovellus",
    log_in: "Kirjaudu sisään",
    sign_up: "Kirjaudu",
    no_result: "Ei tulosta",
    max_price: "Max Hinta",
    max_distance: "Max Etäisyys",
    max_time: "Max-aika",
    posted_less_than: "Lähetetty vähemmän kuin",
    result: "Tulos",
    more: "Lisää",
    or: "TAI",
    password: "Salasana",
    forgot_password: "Unohtuiko salasana?",
    and: "ja",
    download_for: "Ladata",
    apple_ios: "Apple iOS",
    android: "Android",
    image: "Kuva",
    edit_image: "Muokkaa kuvaa",
    please_complete: "Täydennä",
    enter_your_offer: "Anna tarjouksesi",
    categories: "Luokat",
    upload_image: "Lataa kuva",
    upload_images: "Lataa kuvia",
    back: "Takaisin",
    see_more: "Katso lisää",
    add_product: "Lisää tuote",
    selected: "Valittu",
    create: "Luoda",
    rate_the_buyer: "Arvostele ostaja",
    delete_product: "Poista tuote",
    product: "Tuote",
    un_block_product: "Unblock tuote",
    share_your_product: "Jaa tuote",
    boost_details: "Boost Details",
    remove_all_products: "Poista kaikki tuotteet",
    remove_all: "Poista kaikki",
    add_vehicle: "Lisää ajoneuvo",
    edit_vehicle: "Muokkaa ajoneuvoa",
    upload_a_photo: "Lataa kuva",
    view_details: "Tarkemmat tiedot",
    add_yard_sale: "Lisää pihan myynti",
    edit_yard_sale: "Muokkaa pihan myyntiä",
    users: "Käyttäjät",
    users_details: "Käyttäjien tiedot",
    users_by_country: "Käyttäjät maittain",
    blocked_users: "Estetyt käyttäjät",
    products_cards: "Tuotteiden kortit",
    archived_products: "Arkistoituja tuotteita",
    blocked_products: "Estetyt tuotteet",
    products_by_country: "Tuotteet maittain",
    reports: "Raportti",
    reports_details: "Raporttitiedot",
    closed_reports: "Suljetut raportit",
    threads: "Langat",
    threads_details: "Kirjoitukset yksityiskohdat",
    chat_support: "Chat-tuki",
    actions: "Toiminnot",
    search_actions: "Hakutoiminnot",
    product_view_actions: "Tuote Näytä toiminnot",
    contact_seller_product: "Ota yhteyttä myyjän tuotteeseen",
    contact_owner_shop: "Ota yhteyttä omistajaan",
    ratings: "Luokitukset",
    reviews: "Arvostelut",
    products_all_countries: "Tuotteet Kaikki maat",
    edit_profile: "Muokkaa profiilia",
    my_profile: "Profiilini",
    profile_updated_successfully: "Profiili päivitetty onnistuneesti",
    are_you_sure: "Oletko varma",
    my_used_products: "Käytetyt tuotteet",
    my_shops: "Kaupat",
    my_boosted_products: "Korotetut tuotteet",
    messages_type_message_here: "Kirjoita viesti tähän",
    messages_product_sold: "Tämä tuote myydään tai poistetaan",
    seen: "Nähnyt",
    messages_never_miss_message: "Älä koskaan menetä viestiä",
    enable: "ota käyttöön",
    send_notify: "Lähetä ilmoitus",
    un_close: "Laiminlyönti",
    type_your_review: "Kirjoita arvosteluasi",
    again_question: "uudelleen?",
    ratings_already_submitted_review: "Olet jo lähettänyt tarkistuksen",
    set_product_category: "Aseta tuoteryhmä",
    auth_email_password_incorrect: "Sähköposti tai salasana on väärä",
    auth_insert_your_name: "Aseta nimesi",
    auth_email_address_badly: "Sähköpostiosoite on huonosti muotoiltu",
    auth_email_address_used: "Sähköpostiosoite on jo käytössä toisella tilillä",
    auth_invalid_password: "Salasanan pitäisi olla vähintään 6 merkkiä",
    auth_reset_email: "Anna sähköpostiosoitteesi salasanan palauttamiseksi",
    auth_check_email: "Tarkista sähköpostisi salasanan palauttamiseksi",
    auth_can_sign_in_google: "Voit kirjautua sisään Google-painikkeella",
    auth_do_not_have_account: "Eikö sinulla ole tiliä?",
    auth_have_account: "Onko sinulla tili?",
    log_terms_privacy_part1:
      "Kirjautumalla tai kirjautumalla sisään, hyväksyt luetellun lähellän",
    boost_this_product: "Boost tätä tuotetta?",
    product_successfully_boosted: "Tuote on onnistuneesti vahvistettu",
    product_failed_boost: "Tuote on epäonnistunut Boost",
    no_products_for_sale:
      "Tällä hetkellä sinulla ei ole myytävänä olevia tuotteita.",
    not_sold_listed_near_me: "En myy sitä listattu lähellä minua",
    agree_add_product:
      "Tappamalla postitse julkaista tuotteesi, hyväksyt luetellut lähellän ME: n käyttöehdot ja tietosuojakäytännöt.",
    click_to_boost: "Napsauta tuotetta, jos haluat lisätä sen",
    listed_terms_of_service: "Listattu lähelle minua käyttöehtoja",
    receive_emails_for_users: "Vastaanota sähköpostiviestejä käyttäjille",
    receive_emails_for_newly_posted:
      "Vastaanota sähköpostit äskettäin lähetettyihin tuotteisiin",
    disable_push_notifications: "Poista push-ilmoitukset käytöstä",
    sms_during_day: "Vastaanottaa tekstiviestiä päivän aikana",
    sms_24_hours: "SMS 24 tuntia",
    products: "Tuotteet",
    product_no_longer_available:
      "Valitettavasti tämä tuote ei ole enää käytettävissä",
    add_home: "Lisää kotiin",
    edit_home: "Muokkaa kotiin",
    fill_required_fields: "Täytä kaikki tarvittavat kentät",
    no_notification: "Ilmoituksia ei ole",
    orders_history: "Tilausten historia",
    privacy: "Yksityisyys",
    terms: "Ehdot",
    report_a_problem: "Ilmoita ongelmasta",
    approximation_protect_user_privacy:
      "Lähentäminen käyttäjän yksityisyyden suojaamiseen",
    do_not_have_products: "Sinulla ei ole tuotteita",
    emails: "Sähköpostiviestit",
    lead_deletion_products: "Tämä johtaa kaikkien tuotteiden poistamiseen",
    confirm_legal_message:
      "Olet yksin vastuussa kaikista tarvittavista varotoimenpiteistä vuorovaikutuksessa muiden kanssa, varsinkin kun tapaattiin henkilökohtaisesti muukalainen ensimmäistä kertaa. Tarkista lisätietoja palveluna.",
    push_notifications_notified_instantly:
      "Ota Push-ilmoituksia käyttöön ilmoittamaan välittömästi",
    rate_seller: "Arvostele myyjä",
    user_journey: "Käyttäjän matka",
    user: "Käyttäjä",
    user_id: "Käyttäjätunnus",
    action_id: "Toimintatunnus",
    select_model_car: "Valitse auton malli",
    boost_1_day: "Boost 1 päivä",
    boost_3_days: "Boost 3 päivää",
    boost_7_days: "Boost 7 päivää",
    agree_boost_terms: "Tappamalla Boost, hyväksyt",
    add: "Lisätä",
    add_tag: "Lisää tunniste",
    brand_title: "Brändi",
    category_mobiles: "Matkapuhelimet",
    category_tablets: "Tabletteja",
    screen_size: "Näytön koko",
    has_cellular_capability: "On solukkoominaisuus",
    default_internal_memory: "Sisäinen muisti",
    network_carrier: "Verkkokantaja",
    is_unlocked: "On lukittu",
    mobile_model_warning: "Valitse brändi ensin",
    missing_image: "Puuttuva kuva, yritä lisätä kuva uudelleen.",
    add_mobile: "Lisää mobiili",
    edit_mobile: "Muokkaa mobiilia",
    add_tablet: "Lisää tabletti",
    edit_tablet: "Muokkaa tablettia",
    keywords:
      "Ostokset, osta, myyvät, tekevät rahaa, kauppaa, paikallisia, naapureita, auto, ajoneuvoja",
    country: "Maa",
    phone_number: "Puhelinnumero",
    verification_code: "Vahvistuskoodi",
    error_occurred: "Tapahtui virhe, yritä myöhemmin uudelleen",
    invalid_state:
      "Virheellinen tila: Kirjautuminen soittopyyntö sai, mutta kirjautumispyyntö ei lähetetty.",
    sign_in: "Kirjaudu sisään",
    sign_in_apple: "Kirjaudu sisään Applen kanssa",
    sign_in_google: "Kirjaudu sisään Googlen kanssa",
    sign_in_phone: "Kirjaudu sisään puhelimitse",
    sign_in_facebook: "Kirjaudu Facebookiin",
    create_account: "Luo tili",
    email: "Sähköposti",
    invalid_field: "Täytä vaaditut kentät",
    code_sent: "SMS on lähetetty koodi",
    verify_number: "Tarkista puhelinnumero",
    tapping_verify_number:
      "Tappamalla (tarkista puhelinnumero), lähetetään tekstiviesti.",
    email_exists:
      "Tili on jo olemassa ja sinun täytyy käyttää sitä Google-painikkeella, Facebook-painikkeella tai Apple-painikkeella",
    ok: "Ok",
    sure_back: "Oletko varma?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "sitten",
    add_model: "Lisää malli",
    no_search_results_us:
      "Ei hakutuloksia lähelläsi 120 mailin sisällä. Yritä muuttaa hakasuodatin tai haku -avainsana.",
    no_search_results:
      "Ei hakutuloksia lähelläsi 200 km: n sisällä. Yritä muuttaa hakasuodatin tai haku -avainsana.",
    plan_date: "Suunnitelmapäivä",
    plan_time: "Suunnitelma -aika",
    invalid_plan_date:
      "Virheellinen suunnitelman päivämäärä, aseta suunnitelman päivämäärä uudelleen",
    invalid_plan_time:
      "Virheellinen suunnitelma -aika, aseta suunnitelma -aika uudelleen",
    plan_name: "Suunnitella",
    plan_title: "Suunnitelma",
    update_plan_name: "Päivityssuunnitelman nimi",
    delete_plan_question: "Haluatko varmasti poistaa tämän suunnitelman?",
    plan_reminder_message: "Sinua muistutetaan tuntia ennen",
    plan_dialog_title: "Kokoussuunnitelma",
    planners_title: "Suunnittelijat",
    unable_sending_messages:
      "He näkevät viestisi, kun he ovat palanneet verkkoon.",
    its_text: "Sen",
    for_your_text: "vastaanottimellesi.",
  },
  fr: {
    invalid_area: "Zone non valide, veuillez définir la zone à nouveau.",
    invalid_lot_size:
      "Taille du lot de propriété invalide, veuillez définir une taille de lot à nouveau.",
    property_area: "Zone immobilière",
    app_store_name:
      "Listé près de moi - achetez des articles d'occasion, vendez-vous pour de l'argent",
    app_store_short:
      "Un marché pour les vendeurs locaux. Énumérez un article à vendre et gagner de l'argent.",
    app_store_full:
      "La figure près de moi facilite la recherche de grandes offres sur les choses que vous voulez et gagnez de l'argent sur les choses que vous souhaitez vendre. C'est la meilleure façon d'acheter et de vendre dans votre communauté ou votre quartier avec des personnes en qui vous pouvez faire confiance. Comment ça marche: 1- Acheter ou vendre quoi que ce soit; Postez facilement vos articles à la vente en quelques secondes. 2- Trouvez d'excellentes offres et de réductions sur des vêtements, des meubles, des téléphones portables, des articles électroniques, des objets bébé et des enfants, des équipements de sport, des voitures d'occasion, des robes, des chaussures et des montres, des livres, des jouets d'occasion, des ordinateurs portables d'occasion, une voiture d'occasion et même réelle succession à vendre ou à louer. 3- Parcourir les articles locaux à vendre. 4- Acheteurs et vendeurs de messages de l'application. 5- Parcourir les éléments par image et trier par catégorie. Faits amusants sur la liste proche de moi: 1- avec répertorié près de moi, vous pouvez facilement vendre quelque chose, des vêtements aux voitures d'occasion à l'électronique. 2- La communication entre les acheteurs et les vendeurs arrive à travers l'application via la messagerie. 3- la figure près de moi est meilleure qu'une vente de garage; Trouvez tout ce que vous voulez à rabais, directement sur votre téléphone ou votre tablette.",
    app_store_release:
      "Établi près de moi - Commerce avec les habitants. Rejoignez le marché mobile pour les acheteurs et les vendeurs locaux!",
    app_name: "Listé près de moi",
    title_buy: "Acheter",
    title_messages: "messages",
    title_sell: "Vendre",
    title_profile_image: "Image de profil",
    title_account: "Compte",
    account_settings: "Paramètres du compte",
    settings: "Réglages",
    color_theme: "Thème de couleur",
    device_settings: "Réglages de l'appareil",
    public_profile: "Profil public",
    light_mode: "Mode lumière",
    dark_mode: "Mode sombre",
    title_sell_faster: "Vendre plus vite",
    send_button_label: "Envoyer",
    rate_message: "Notez moi...",
    already_rated: "Vous avez déjà soumis votre avis",
    rate_review_question: "Voulez-vous gérer",
    again: "encore?",
    action_logout: "Se déconnecter",
    action_category: "Catégorie",
    action_search: "Chercher",
    action_refer: "Référez un ami",
    dialog_choose_location: "Choisissez l'emplacement",
    dialog_change_username: "Changer le nom d'utilisateur",
    dialog_change_language: "Changer de langue",
    dialog_image_tags: "Tags d'image",
    dialog_emails_notifications: "Notifications de courriels",
    dialog_push_notifications: "Notifications push",
    fragment_product_detail: "Les détails du produit",
    fragment_message_details: "Détail des messages",
    fragment_sell: "Vendre",
    dialog_tags_title: "Mots clés",
    dialog_location_title: "Mettre à jour l'emplacement",
    dialog_username_title: "Changer le nom d'utilisateur",
    tab_photo: "photo",
    tab_details: "Des détails",
    tab_price: "Prix",
    tab_finish: "Finir",
    profile: "Profil",
    search: "Chercher",
    choose_product: "Choisir le produit",
    rating_review: "Note et examen",
    select_buyer: "Sélectionnez un acheteur",
    tab_my_used_products: "Mes produits",
    price_label: "Prix",
    text_savings: "Vous sauvegardez",
    search_hint: "Recherche de produits ...",
    empty_text:
      "Il n'y a pas de produits énumérés dans cette catégorie ou dans la distance sélectionnée.",
    filter_menu_text: "Filtre",
    error_contacting_seller: "Erreur de contacter le vendeur",
    edit_product: "Modifier le produit",
    contact_seller: "Contacter le vendeur",
    signup_to_contact_seller: "Inscrivez-vous pour contacter le vendeur",
    signup_to_make_offer: "Inscrivez-vous pour faire une offre",
    product_details: "Des détails",
    product_category: "Catégorie",
    product_condition: "État",
    product_description: "La description",
    product_location: "Emplacement du produit",
    product_location_approximate: "L'emplacement est approximatif",
    over_week_time_ago: "Il y a plus d'une semaine",
    boosted: "Boosté",
    threads_no_results: "Pas de messages",
    message_no_results: "Pas de messages",
    message_warning:
      "Vous êtes seul responsable de prendre toutes les précautions nécessaires lorsque vous interagissez avec les autres, en particulier lorsque vous rencontrez un étranger en personne pour la première fois. Veuillez ne partager aucune information personnelle, codes de vérification ou aucune information de paiement. Veuillez consulter les conditions d'utilisation pour plus de détails.",
    message_block:
      "Vous ne pouvez pas envoyer ou recevoir des messages pour le moment.",
    select_location: "Sélectionnez l'emplacement",
    location_permission_denied_message:
      "L'application nécessite une autorisation de localisation de fonctionner correctement.",
    signed_in: "Signé!",
    sign_in_canceller: "Connexion annulée",
    version: "Version",
    build: "Construire",
    name: "Nom",
    location: "Emplacement",
    language: "Langue",
    about_app: "À propos de la liste proche de moi",
    terms_of_service: "Conditions d'utilisation",
    privacy_policy: "Politique de confidentialité",
    report_feedback: "Envoyer des commentaires",
    report_bug: "Secouez le téléphone pour signaler un bug",
    change_image: "Changer l'image",
    update_location: "Mettre à jour l'emplacement",
    about_the_app: "À propos de l'application",
    update_label: "Mettre à jour",
    uploading: "Téléchargement",
    adding: "Ajout de la liste",
    removing: "Supprimer la liste",
    updating: "Mise à jour de la liste",
    uploaded_image: "Image téléchargée:",
    image_storage_failed: "Impossible de stocker l'image:",
    product_updated: "Produit mis à jour avec succès",
    location_error: "Emplacement non enregistré, veuillez réessayer",
    product_removed: "Produit retiré avec succès",
    deleted_product: "Ce produit est supprimé",
    invalid_title: "Titre invalide, veuillez définir à nouveau le titre.",
    invalid_image:
      "Chemin d'image non valide, essayez d'ajouter une image à nouveau.",
    invalid_price: "Prix ​​non valide, veuillez définir un prix à nouveau.",
    invalid_location:
      "Emplacement non valide, veuillez définir à nouveau l'emplacement.",
    invalid_category:
      "Catégorie non valide, veuillez définir la catégorie à nouveau.",
    invalid_condition:
      "Condition non valide, veuillez définir la condition à nouveau.",
    removing_title: "Suppression de l'image de profil",
    image_not_saved: "Image Enregistrer échoué!",
    product_load_failed: "Aucun produit",
    take_photo: "Prendre une photo",
    select_photo: "Sélectionner une photo",
    product_title_hint: "Qu'est-ce que c'est? Nom, marque, modèle, etc.",
    delete_photo: "Supprimer la photo",
    product_title: "Titre",
    mark_as_sold: "Marquer comme vendu",
    product_share: "Partager",
    product_make_offer: "Faire une offre",
    product_cover: "Définir comme image de couverture",
    product_tags: "Mots clés",
    product_posted: "Publié:",
    product_change: "Changer",
    product_post: "Poster",
    product_selling_from: "Vendre de l'emplacement",
    product_select_location: "Sélectionnez l'emplacement",
    product_map_approximate:
      "La carte est approximative pour garder l'emplacement du vendeur privé",
    product_terms:
      "En appuyant sur Publier pour publier votre produit, vous acceptez <U> listé près de moi Conditions d'utilisation. </ U>",
    condition_other: "Autre (voir description)",
    condition_for_parts: "Pour les pièces",
    condition_used: "Utilisé (usure normale)",
    condition_open_box: "Boîte ouverte (jamais utilisé)",
    condition_reconditioned: "Reconditionné / certifié",
    condition_new: "Nouveau (jamais utilisé)",
    select_category: "Choisir une catégorie",
    select_all_category: "Tout sélectionner",
    category_loading_error:
      "Impossible de mettre à jour la liste des catégories, veuillez réessayer ultérieurement.",
    category_vehicles: "Véhicules",
    category_furniture: "Meubles",
    category_electronics: "Électronique",
    category_appliances: "Maison et amplis; appareils électroménagers",
    category_fashion_accessories: "Mode et ampli; Accessoires",
    category_baby_kids: "Bébé et ampli; Enfants",
    category_antiques_collectibles:
      "Antiquités et amplis; Objets de collection",
    category_auto_parts_tools_machinery:
      "Pièces automobiles, outils et amplis; Machinerie",
    category_sports_outdoors: "Sports et amplis; En plein air",
    category_others: "Autres",
    location_enter_zip_code: "Entrer le code postal",
    location_get_current_location: "Obtenez l'emplacement actuel",
    location_select_location: "Sélectionnez l'emplacement",
    location_update_location: "Mettre à jour l'emplacement",
    location_new_location: "Nouvel emplacement",
    search_filter_results: "Filtrer les résultats",
    search_filter_min: "Filtre minimum",
    search_filter_at_least: "Au moins",
    price_filter: "Filtre de prix",
    product_name: "Nom du produit",
    english_language: "Anglais",
    arabic_language: "arabe",
    spanish_language: "Espagnol",
    system_language: "Système",
    share_link: "Lien de partage",
    save: "Sauvegarder",
    cancel: "Annuler",
    loading: "Chargement",
    yes: "Oui",
    no: "Non",
    report: "Reportage",
    report_product: "Produit de rapport",
    report_user: "Dénoncer un utilisateur",
    block_user: "Bloquer un utilisateur",
    un_block_user: "Débloquer l'utilisateur",
    why_product: "Pourquoi voulez-vous signaler cet article?",
    why_user: "Pourquoi voulez-vous signaler cet utilisateur?",
    block_user_confirm: "Voulez-vous bloquer définitivement cet utilisateur?",
    un_block_user_confirm:
      "Voulez-vous débloquer définitivement cet utilisateur?",
    prohibited: "Interdit sur la liste proche de moi",
    offensive: "Offensant ou inapproprié",
    duplicate: "Dupliquer Post",
    wrong_category: "Mauvaise catégorie",
    scam: "Ressemble à une arnaque",
    stolen: "Je pense que c'est volé",
    product_other: "Autre",
    product_is_sold: "Ce produit a été vendu",
    missed_meeting: "Ils ont manqué notre réunion",
    low_offer: "Fait une offre basse",
    rude: "Impoli ou inapproprié",
    items: "Problème d'articles",
    trouble_meetup: "Problème à la rencontre",
    messaging: "Problèmes de messagerie",
    user_other: "Autre",
    new_version_available: "Nouvelle version disponible",
    please_update_app:
      "Veuillez mettre à jour l'application vers une nouvelle version pour continuer.",
    update: "Mettre à jour",
    no_thanks: "Non merci",
    contact_support_confirmation:
      "Le temps de réponse actuel est de 24 à 48 heures. Voulez-vous vous contacter à proximité de la prise en charge du chat de l'application?",
    unboost_confirmation: "Êtes-vous sûr de vouloir déclencher ce produit?",
    no_used_products: "Vous n'avez pas encore d'annonces",
    no_boosted_products: "Vous n'avez pas de produits boostés",
    next: "Suivant",
    previous: "Précédent",
    skip: "Sauter",
    start: "Démarrer",
    list_used: "Énumérer un produit utilisé",
    buy_description:
      "Découvrez et recherchez des produits proposés par les voisins autour de vous",
    sell_description: "Liste des produits que vous n'avez plus besoin de vente",
    list_used_description:
      "Énumérez un produit utilisé à la vente en moins de 20 secondes",
    boost_product_option_1: "<b> boost 1  ndday </ b>  n  n <b> 0,99 $ </ b>",
    boost_product_option_2: "<b> boost 3  nddays </ b>  n  n <b> 1,99 $ </ b>",
    boost_product_option_3: "<b> boost 7  ndays </ b>  n  n <b> 3,99 $ </ b>",
    boost_product_description:
      "Obtenez plus de vues chaque jour. Votre article apparaîtra dans des positions en vedette dans les 30 principaux éléments de l'achat et de la catégorie. Les articles promus sont tournés parmi les taches désignées afin que chaque élément obtient une exposition équitable.",
    boost_cta: "Vendre plus vite",
    boost_terms:
      "En tapotant boost, vous acceptez <U> listé près de moi Conditions d'utilisation. </ U>",
    boost_best_value: "Meilleure valeur",
    already_boosted: "Ce produit est boosté",
    clicks: "Cliquetis",
    impressions: "Impressions",
    end: "Finir",
    transactions_empty_text:
      "Vous n'avez pas encore de transactions de boost. Vous pouvez visiter la vente d'onglet et commencer à augmenter vos produits.",
    transactions_loading_error:
      "Impossible de mettre à jour la liste des transactions, veuillez réessayer ultérieurement.",
    transactions_history_title: "Augmenter les transactions historique",
    communicative_postive: "Communicatif",
    communicative_negative: "Peu communicatif",
    ontime_postive: "À temps",
    ontime_negative: "En retard",
    reliable_postive: "Fiable",
    reliable_negative: "Non fiable",
    friendly_postive: "Amical",
    friendly_negative: "Impoli",
    itemasdescribed_postive: "Article conforme à la description",
    itemasdescribed_negative: "L'article ne correspond pas à la description",
    other: "Autre",
    submit: "Soumettre",
    adding_rating_reviews: "Ajout de la notation et des critiques",
    no_internet_title: "Pas de connexion Internet",
    no_internet_message:
      "Assurez-vous d'être connecté à Internet et essayez à nouveau",
    retry: "Retenter",
    near_me: "Proche de moi",
    newest_first: "Le plus récent d'abord",
    miles: "miles",
    km: "km",
    similar_products: "produits similaires",
    favorite_products: "Produits favoris",
    items_for_sale: "Articles à vendre",
    joined: "Rejoint",
    favorites_transactions_title: "Favoris",
    boosted_products_transactions_history:
      "Historique des transactions de produits boostés",
    views: "Vues",
    boost_graph_title: "Graphique de boost",
    no_favorite_products: "Vous n'avez pas de produits préférés",
    make_offer_buy: "je voudrais acheter",
    make_offer_buy_for: "pour",
    notifications: "Notifications",
    push_notifications: "Pousser",
    emails_notifications: "E-mail",
    apply: "Appliquer",
    email_messages: "Email pour les messages",
    email_new_products: "Email pour les nouveaux produits",
    push_day_only: "NOTIFICATIONS PUSH NOTIFICATIONS SEULEMENT",
    push_24_hours: "Notifications push 24 heures",
    edit: "Éditer",
    map: "Carte",
    camera: "Caméra",
    gallery: "Galerie",
    delete: "Supprimer",
    no_sell_items: "Aucun article à vendre",
    who_bought_question: "Qui l'a acheté?",
    sold_elsewhere_question: "Vendu quelque part ailleurs",
    confirm: "Confirmer",
    over_limit_camera: "Vous ne pouvez pas ajouter plus de cinq images",
    boost_failed: "Boost a échoué. Veuillez réessayer plus tard",
    after_purchase: "Paiement réussi  nproduct boosté",
    pay_failed: "Paiement échoué. Veuillez réessayer",
    done: "Fait",
    not_now: "Pas maintenant",
    boost: "Renforcer",
    invalid_zip_code: "Code postal invalide",
    invalid_user_name: "Nom d'utilisateur invalide",
    comments: "commentaires",
    questions: "Des questions",
    bug_reports: "Rapports de bogues",
    feature_request: "Demande de fonctionnalité",
    feedback_type: "type de commentaire",
    feedback_description:
      "Nous aimerions entendre vos pensées ou vos commentaires sur la façon dont nous pouvons améliorer votre expérience!",
    feedback: "Retour",
    feedback_text: "Votre Réponse",
    suggestions: "Suggestions d'amélioration",
    delete_account: "Supprimer le compte",
    new_message: "Nouveau message",
    online: "En ligne",
    km_50: "50 km",
    km_100: "100 km",
    km_200: "200 km",
    miles_30: "30 miles",
    miles_60: "60 miles",
    miles_120: "120 miles",
    rate_app_question: "Que diriez-vous d'une note sur l'App Store, alors?",
    enjoying_question: "Profiter de la liste proche de moi?",
    not_enjoy: "Pas vraiment",
    feedback_question:
      "Cela vous dérangerait-il de nous donner des commentaires?",
    yes_sure: "OK, bien sûr",
    product_available_question: "Salut, est-ce encore disponible?",
    buy_question: "Salut, je voudrais acheter ceci",
    meet_question: "Salut, pouvez-vous rencontrer aujourd'hui?",
    follow: "Suivre",
    followers: "Suiveurs",
    following: "Suivant",
    feedback_thanks: "Merci pour vos commentaires",
    all_categories: "toutes catégories",
    deleted_account: "Ce compte est supprimé",
    delete_account_question: "Êtes-vous sûr de vouloir supprimer ce compte?",
    no_followings: "ne veut pas quelqu'un",
    when_following: "lorsque",
    no_followings_subtitle: "suit les gens, vous les verrez ici",
    no_followers: "ne pas avoir de suiveurs",
    no_followers_subtitle: "suivi de personnes, vous les verrez ici",
    distance: "Distance",
    filter_method: "Méthode de filtrage",
    see_listings: "Voir les listes",
    sold: "Vendu",
    bought: "Acheté",
    no_notifications:
      "Lorsque vous recevez des notifications, ils apparaîtront ici",
    items_title: "Articles",
    new_listing_title: "Créer une nouvelle liste",
    dialog_year_title: "An",
    dialog_make_title: "Faire",
    dialog_model_title: "Modèle",
    dialog_body_style_title: "Style corporel",
    dialog_exterior_color_title: "Couleur extérieure",
    dialog_interior_color_title: "Couleur intérieure",
    dialog_transmission_title: "Transmission",
    dialog_fuel_type_title: "Type de carburant",
    dialog_owners_num_title: "Nombre de propriétaires",
    dialog_vehicle_owed_money_title:
      "Y a-t-il de l'argent toujours dû sur ce véhicule?",
    automatic_transmission: "Automatique",
    manual_transmission: "Manuel",
    not_sure: "Pas certain",
    wagon_hatchback: "Wagon &  Hayonnerie",
    convertible: "Convertible",
    coupe: "Coupé",
    sedan: "Sedan",
    black_color: "Noir",
    blue_color: "Bleu",
    brown_color: "brun",
    gold_color: "Or",
    green_color: "Vert",
    grey_color: "Gris",
    pink_color: "Rose",
    purple_color: "Mauve",
    red_color: "rouge",
    silver_color: "Argent",
    orange_color: "Orange",
    white_color: "blanc",
    yellow_color: "Jaune",
    charcol_color: "Charcol",
    fuel_diesel: "Diesel",
    fuel_electric: "Électrique",
    fuel_gasoline: "De l'essence",
    fuel_flex: "Fléchir",
    fuel_hybrid: "Hybride",
    fuel_petrol: "Essence",
    fuel_plugin_hybrid: "Hybride plug-in",
    truck: "Camion",
    van_minivan: "Van &  Miniban",
    suv_crossover: "SUV &  Croisé",
    awd_4wd: "AWD / 4WD",
    fwd: "Feux",
    rwd: "Rwd",
    off_white_color: "Blanc",
    tan_color: "bronzer",
    beige_color: "Beige",
    burgundy_color: "Bourgogne",
    turquoise_color: "Turquoise",
    title_status_clean: "Nettoyer",
    title_status_rebuilt: "Reconstruire",
    title_status_salvage: "Sauvetage",
    title_status_missing: "Manquant",
    title_status_lien: "Privilège",
    title_status: "Statut de titre",
    mileage: "Kilométrage",
    dialog_drivetrain_title: "Transmission",
    model_warning: "S'il vous plaît sélectionner faire d'abord",
    required_field_warning: "Ce champ est requis",
    vehicle_vin: "Vin",
    invalid_vin: "Vin invalide, veuillez définir à nouveau Vin.",
    invalid_mileage:
      "Kilométrage non valide, veuillez vous mettre à nouveau kilométrique.",
    clean_description:
      "La plupart des véhicules qui n'ont pas été dans un accident",
    rebuilt_description: "Une voiture récupérée qui a été reconstruite",
    salvage_description: "Est considéré comme totalisé après un accident",
    missing_description: "Aura besoin d'un nouveau titre DMV",
    lien_description: "Appartenant à une banque ou à un règlement judiciaire",
    nearme: "Proche de moi",
    newest: "Nouveau",
    contact_support: "Contactez le support",
    create_home_title: "Maisons à vendre ou à louer",
    for_sale: "À vendre",
    for_rent: "A louer",
    property_type: "Type de propriété",
    apartment: "Appartement",
    house: "loger",
    room_only: "Chambre seulement",
    townhouse: "Maison de ville",
    bedrooms: "Chambres à coucher",
    bathrooms: "Salles de bain",
    property_address: "Adresse de propriété",
    price_per_month: "Prix ​​par mois",
    square_feet: "Pieds carrés",
    year_built: "Année de construction",
    year_renovated: "Année rénovée",
    lot_size: "La taille du lot",
    laundry_type: "Type de blanchisserie",
    in_unit_laundry: "Blanchisserie en unité",
    laundry_building: "Blanchisserie dans la construction",
    laundry_available: "Blanchisserie disponible",
    none: "Rien",
    parking_type: "Type de stationnement",
    garage_parking: "Garage parking",
    street_parking: "Stationnement de rue",
    off_street_parking: "Stationnement hors rue",
    available_parking: "Parking disponible",
    air_cond_type: "Type de climatisation",
    ac_available: "AC disponible",
    central_ac: "AC central",
    heating_type: "Type de chauffage",
    electric_heating: "Chauffage électrique",
    gas_heating: "Chauffage au gaz",
    radiator_heating: "Radiateur",
    available_heating: "Chauffage disponible",
    amenities: "Agréments",
    date_available: "Date de disponibilité",
    lease_length: "Longueur de bail",
    month_to_month: "Mois après mois",
    three_months: "3 mois",
    six_months: "6 mois",
    one_year: "1 année",
    more_one_year: "1+ ans",
    cat_friendly: "Chat",
    dog_friendly: "Convivial",
    balcony: "Balcon",
    basement: "Sous-sol",
    bike_parking: "Stationnement de vélo",
    cable_tv: "Télévision par câble",
    ceiling_fan: "Ventilateur de plafond",
    concierge: "La conciergerie",
    dishwasher: "Lave-vaisselle",
    doorman: "Portier",
    elevator: "Ascenseur",
    fireplace: "Cheminée",
    fitness_center: "Centre Fitness",
    garbage_disposal: "Élimination des ordures",
    microwave: "Four micro onde",
    online_app: "Candidature en ligne",
    oven: "Four",
    package_service: "Service d'emballage",
    patio: "Patio",
    pet_park: "Animal de compagnie",
    refrigerator: "Réfrigérateur",
    resident_lounge: "Salon résident",
    roof_deck: "Toit-terrasse",
    secured_entry: "Entrée sécurisée",
    storage: "Stockage",
    walk_in_closet: "Placard",
    swimming_pool: "Piscine",
    wheelchair_access: "Accès en fauteuil roulant",
    central_heating: "Chauffage central",
    invalid_bedrooms:
      "Chambres non valides, placez à nouveau des chambres à coucher.",
    invalid_bathrooms:
      "Salles de bains non valides, placez à nouveau des salles de bains.",
    chinese_simplified_language: "Chinois simplifié",
    chinese_traditional_language: "Chinois (Traditionnel",
    czech_language: "tchèque",
    danish_language: "danois",
    dutch_language: "néerlandais",
    finnish_language: "finlandais",
    french_language: "français",
    german_language: "allemand",
    greek_language: "grec",
    hungarian_language: "hongrois",
    indonesian_language: "indonésien",
    italian_language: "italien",
    japanese_language: "Japonais",
    korean_language: "coréen",
    norwegian_language: "norvégien",
    polish_language: "polonais",
    portuguese_language: "Portugais",
    portuguese_brazilian_language: "Portugais, brésilien",
    romanian_language: "roumain",
    russian_language: "russe",
    swedish_language: "suédois",
    turkish_language: "turc",
    ukrainian_language: "ukrainien",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "vietnamien",
    category_home_sale_or_rent: "Maison à vendre ou à louer",
    square_meter: "Mètre carré",
    copy_text: "Copie",
    copyied_to_clipboard: "Copié dans le presse-papier",
    inbox: "Boîte de réception",
    input_title_listening: "Écoute…",
    input_subtitle_listening: "Dis quelquechose",
    input_title_error: "Désolé, nous n'avons pas vraiment compris ça.",
    input_subtitle_error: "Essayez de répéter votre demande.",
    input_hint_error: "Essayer à nouveau",
    price_less_than_or_equal: "Prix ​​inférieur ou égal à",
    any_price: "N'importe quel prix",
    any_condition: "Toute condition",
    any_time: "À toute heure",
    days_ago: "il y a quelques jours",
    any_distance: "N'importe quelle distance",
    distance_within: "Distance dans",
    new_notification: "Nouvelle notification",
    deleted: "Supprimé",
    processing_image: "Image de traitement",
    remove_dialog_message: "Voulez-vous vraiment supprimer ce produit?",
    deleted_thread: "Ce message est supprimé",
    category_yard_sale_event: "Événement de vente de jardin",
    yard_first_date: "Vente de la cour Première date",
    yard_second_date: "Vente de jardin Second Date",
    yard_third_date: "Vente de jardin troisième date",
    yard_start_time: "Heure de début",
    yard_end_time: "Heure de fin",
    yard_end_timestamp: "Terminal horodatage",
    invalid_date1:
      "Première date invalide, veuillez définir la première date à nouveau",
    invalid_start_time:
      "Heure de début non valide, veuillez définir à nouveau heure de début",
    invalid_end_time:
      "Heure de fin invalide, veuillez définir à nouveau l'heure de fin",
    yard_sale_title: "Vente de jardin",
    garage_tag: "garage",
    yard_tag: "Cour",
    from: "À partir de",
    to: "À",
    block: "Bloquer",
    un_block: "Débloquer",
    sign_email: "Connectez-vous avec email",
    invalid_first_date:
      "Première date invalide, veuillez vous assurer que la première date est avant la deuxième et troisième.",
    invalid_second_date:
      "Deuxième rendez-vous non valide, veuillez vous assurer que la deuxième date est avant la troisième date.",
    invalid_start_time_value:
      "Heure de début invalide, veuillez vous assurer que le temps de démarrage est avant la fin de la fin.",
    use_default_yard_photo: "Utiliser une photo de vente par défaut",
    active_label: "actif",
    enable_notifications: "Activer les notifications",
    login: "Connexion",
    january: "janvier",
    february: "février",
    march: "Mars",
    april: "avril",
    may: "Peut",
    june: "juin",
    july: "juillet",
    august: "août",
    september: "septembre",
    october: "octobre",
    november: "novembre",
    december: "décembre",
    since: "Puisque",
    product_views: "Vues sur le produit",
    shop_views: "Vues de la boutique",
    total_sales: "Ventes totales",
    total_orders: "Commandes totales",
    last_twelvth_months: "Derniers mois",
    last_nine_months: "Neuf derniers mois",
    last_six_months: "Six derniers mois",
    last_three_months: "Trois derniers mois",
    last_12_months: "12 derniers mois",
    last_9_months: "9 derniers mois",
    last_6_months: "6 derniers mois",
    last_3_months: "3 derniers mois",
    months: "Mois",
    open: "Ouvert",
    reset_password: "Réinitialiser le mot de passe",
    create_new_shop: "Créer un nouveau magasin",
    download_app: "Télécharger l'application",
    log_in: "Connexion",
    sign_up: "S'inscrire",
    no_result: "Pas de résultat",
    max_price: "Prix ​​max",
    max_distance: "Distance maximale",
    max_time: "Temps maximum",
    posted_less_than: "Publié moins que",
    result: "Résultat",
    more: "Suite",
    or: "OU",
    password: "Mot de passe",
    forgot_password: "Mot de passe oublié?",
    and: "et",
    download_for: "Télécharger pour",
    apple_ios: "Apple iOS",
    android: "Android",
    image: "Image",
    edit_image: "Éditer l'image",
    please_complete: "Veuillez compléter",
    enter_your_offer: "Entrez votre offre",
    categories: "Catégories",
    upload_image: "Télécharger une image",
    upload_images: "Importer des images",
    back: "Retour",
    see_more: "Voir plus",
    add_product: "Ajouter du produit",
    selected: "Choisi",
    create: "Créer",
    rate_the_buyer: "Évaluez l'acheteur",
    delete_product: "Supprimer le produit",
    product: "Produit",
    un_block_product: "Débloquer le produit",
    share_your_product: "Partagez votre produit",
    boost_details: "Booster les détails",
    remove_all_products: "Supprimer tous les produits",
    remove_all: "Enlever tout",
    add_vehicle: "Ajouter du véhicule",
    edit_vehicle: "Modifier le véhicule",
    upload_a_photo: "Télécharger une photo",
    view_details: "Voir les détails",
    add_yard_sale: "Ajouter une vente de jardin",
    edit_yard_sale: "Modifier la vente de la cour",
    users: "Utilisateurs",
    users_details: "Détails des utilisateurs",
    users_by_country: "Utilisateurs par pays",
    blocked_users: "Utilisateurs bloqués",
    products_cards: "Cartes de produits",
    archived_products: "Produits archivés",
    blocked_products: "Produits bloqués",
    products_by_country: "Produits par pays",
    reports: "Reportage",
    reports_details: "Détails des rapports",
    closed_reports: "Rapports fermés",
    threads: "Filetage",
    threads_details: "Détails des threads",
    chat_support: "Support de discussion",
    actions: "Actions",
    search_actions: "Actions de recherche",
    product_view_actions: "Afficher les actions",
    contact_seller_product: "Contacter le vendeur produit",
    contact_owner_shop: "Contacter Property Shop",
    ratings: "Notes",
    reviews: "Commentaires",
    products_all_countries: "Produits Tous les pays",
    edit_profile: "Editer le profil",
    my_profile: "Mon profil",
    profile_updated_successfully: "Mise à jour du profil réussie",
    are_you_sure: "Es-tu sûr",
    my_used_products: "Mes produits usagés",
    my_shops: "Mes magasins",
    my_boosted_products: "Mes produits boostés",
    messages_type_message_here: "tapez votre message ici",
    messages_product_sold: "Ce produit est vendu ou enlevé",
    seen: "Vu",
    messages_never_miss_message: "Ne manquez jamais un message",
    enable: "Activer",
    send_notify: "Envoyer des notifications",
    un_close: "Se dégager",
    type_your_review: "Tapez votre avis",
    again_question: "encore ?",
    ratings_already_submitted_review: "Vous avez déjà soumis votre avis",
    set_product_category: "Définir la catégorie de produits",
    auth_email_password_incorrect:
      "Votre e-mail ou votre mot de passe incorrect",
    auth_insert_your_name: "Veuillez insérer votre nom",
    auth_email_address_badly: "L'adresse e-mail est mal formatée",
    auth_email_address_used:
      "L'adresse e-mail est déjà utilisée par un autre compte",
    auth_invalid_password: "Le mot de passe doit avoir au moins 6 caractères",
    auth_reset_email:
      "Entrez votre e-mail pour réinitialiser votre mot de passe",
    auth_check_email:
      "Veuillez vérifier votre email pour réinitialiser le mot de passe",
    auth_can_sign_in_google: "Vous pouvez vous connecter avec le bouton Google",
    auth_do_not_have_account: "Vous n'avez pas de compte?",
    auth_have_account: "Avez-vous un compte?",
    log_terms_privacy_part1:
      "En vous inscrivant ou en vous connectant, vous acceptez le proche de moi",
    boost_this_product: "Augmenter ce produit?",
    product_successfully_boosted: "Le produit a été boosté avec succès",
    product_failed_boost: "Le produit a échoué à Boost",
    no_products_for_sale:
      "Vous n'avez actuellement aucun produit utilisé pour la vente.",
    not_sold_listed_near_me: "Je ne l'ai pas vendu sur la liste près de moi",
    agree_add_product:
      "En appuyant sur Publier pour publier votre produit, vous acceptez les conditions d'utilisation et de la politique de confidentialité énumérées.",
    click_to_boost: "Cliquez sur le produit pour la booster",
    listed_terms_of_service: "Listé près de moi Conditions d'utilisation",
    receive_emails_for_users:
      "Recevoir des courriels pour les messages d'utilisateurs",
    receive_emails_for_newly_posted:
      "Recevez des courriels pour vos produits nouvellement postés",
    disable_push_notifications: "Désactiver les notifications push",
    sms_during_day: "Recevoir des SMS pendant la journée",
    sms_24_hours: "Recevoir des SMS 24 heures",
    products: "Des produits",
    product_no_longer_available: "Désolé, ce produit n'est plus disponible",
    add_home: "Ajouter à la maison",
    edit_home: "Éditer la maison",
    fill_required_fields: "Remplir tous les champs obligatoires",
    no_notification: "Il n'y a pas de notifications",
    orders_history: "Commandes historique",
    privacy: "Vie privée",
    terms: "termes",
    report_a_problem: "Signaler un problème",
    approximation_protect_user_privacy:
      "Approximation pour protéger la vie privée de l'utilisateur",
    do_not_have_products: "Vous n'avez pas de produits",
    emails: "Courriels",
    lead_deletion_products:
      "Cela conduira à la suppression de tous vos produits",
    confirm_legal_message:
      "Vous êtes seul responsable de prendre toutes les précautions nécessaires lors de l'interaction avec d'autres, en particulier lors de la rencontre d'un étranger en personne pour la première fois. Veuillez examiner les conditions d'utilisation pour plus de détails.",
    push_notifications_notified_instantly:
      "Activer les notifications push à notifier instantanément",
    rate_seller: "Taux vendeur",
    user_journey: "Voyage de l'utilisateur",
    user: "Utilisateur",
    user_id: "Identifiant d'utilisateur",
    action_id: "Carte d'action",
    select_model_car: "Sélectionnez le modèle de voiture",
    boost_1_day: "Boost 1 jour",
    boost_3_days: "Boost 3 jours",
    boost_7_days: "Boost 7 jours",
    agree_boost_terms: "En tapotant boost, vous acceptez de",
    add: "Ajouter",
    add_tag: "Ajouter une étiquette",
    brand_title: "Marque",
    category_mobiles: "Mobiles",
    category_tablets: "Comprimés",
    screen_size: "Taille de l'écran",
    has_cellular_capability: "A une capacité cellulaire",
    default_internal_memory: "Mémoire interne",
    network_carrier: "Porteur de réseau",
    is_unlocked: "Est déverrouillé",
    mobile_model_warning: "Veuillez sélectionner la marque d'abord",
    missing_image: "Image manquante, essayez à nouveau d'ajouter une image.",
    add_mobile: "Ajouter mobile",
    edit_mobile: "Éditer mobile",
    add_tablet: "Ajouter une tablette",
    edit_tablet: "Modifier la tablette",
    keywords:
      "shopping, acheter, vendre, gagner de l'argent, commerce, locaux, voisins, auto, véhicules",
    country: "Pays",
    phone_number: "Numéro de téléphone",
    verification_code: "Code de vérification",
    error_occurred: "Une erreur est survenue, veuillez réessayer plus tard",
    invalid_state:
      "State non valide: Un rappel de connexion a été reçu, mais aucune demande de connexion n'a été envoyée.",
    sign_in: "S'identifier",
    sign_in_apple: "Connectez-vous avec Apple",
    sign_in_google: "Connectez-vous avec Google",
    sign_in_phone: "Connectez-vous avec téléphone",
    sign_in_facebook: "Connectez-vous avec Facebook",
    create_account: "Créer un compte",
    email: "E-mail",
    invalid_field: "S'il vous plaît remplir les champs obligatoires",
    code_sent: "Le code a été envoyé par SMS",
    verify_number: "Vérifier le numéro de téléphone",
    tapping_verify_number:
      "En tapotant (vérifiez le numéro de téléphone), un SMS doit être envoyé.",
    email_exists:
      "Le compte existe déjà et vous devez y accéder via le bouton Google, le bouton Facebook ou le bouton Apple",
    ok: "D'accord",
    sure_back: "Êtes-vous sûr de revenir?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "depuis",
    add_model: "Ajouter du modèle",
    no_search_results_us:
      "Aucun résultat de recherche près de chez vous à moins de 120 miles. Essayez de modifier le filtre de recherche ou le mot clé de recherche.",
    no_search_results:
      "Aucun résultat de recherche près de chez vous à moins de 200 km. Essayez de modifier le filtre de recherche ou le mot clé de recherche.",
    plan_date: "Date du plan",
    plan_time: "Planifier l'heure",
    invalid_plan_date:
      "Date du plan non valide, veuillez remettre la date du plan",
    invalid_plan_time:
      "Temps de plan non valide, veuillez refaire le temps du plan",
    plan_name: "Nom de plan",
    plan_title: "Planifier",
    update_plan_name: "Mettre à jour le nom du plan",
    delete_plan_question: "Êtes-vous sûr de vouloir supprimer ce plan?",
    plan_reminder_message: "Vous serez rappelé une heure avant",
    plan_dialog_title: "Plan de réunion",
    planners_title: "Planificateurs",
    unable_sending_messages:
      "Ils verront vos messages lorsqu'ils seront de retour en ligne.",
    its_text: "C'est",
    for_your_text: "pour votre récepteur.",
  },
  de: {
    invalid_area:
      "Ungültiger Bereich, bitte setzen Sie den Bereich erneut ein.",
    invalid_lot_size:
      "Ungültige Property-Lot-Größe, bitte geben Sie die Losgröße erneut ein.",
    property_area: "Immobilienbereich.",
    app_store_name:
      "In der Nähe von Me - Kaufen gebrauchte Gegenstände, Verkaufen Sie für Bargeld",
    app_store_short:
      "Ein Marktplatz für lokale Verkäufer. Listen Sie einen Artikel zum Verkauf auf und verdienen Sie Geld.",
    app_store_full:
      "In der Nähe von Me listet es sich leicht, gute Angebote für die Dinge zu finden, die Sie möchten, und Geld verdienen, um zu den Sachen zu verdienen, die Sie verkaufen möchten. Dies ist der beste Weg, um in Ihrer Gemeinde oder in der Nachbarschaft mit Menschen mit Menschen zu kaufen und zu verkaufen, denen Sie vertrauen können. Wie funktioniert es: 1- Kaufen oder verkaufen Sie alles; Veröffentlichen Sie einfach Ihre Artikel in Sekundenschnelle zum Verkauf. 2- Finden Sie tolle Angebote und Rabatte auf Kleidung, Möbel, Mobiltelefonen, Elektronik, Baby- und Kindergegenstände, Sportgeräte, Gebrauchtwagen, Kleider, Schuhe, und Uhren, Bücher, Gebrauchtwagen, gebrauchte Laptops, ein zweites Auto und sogar echt Immobilien zum Verkauf oder Miete. 3- Durchsuchen Sie die lokalen Artikel zum Verkauf. 4- Nachrichtenkäufer und Verkäufer aus der App. 5- Durchsuchen Sie die Elemente nach Bild und sortieren Sie nach Kategorie. Freude Fakten über aufgelistete in der Nähe von mir: 1- Mit der aufgelisteten in der Nähe von mir können Sie leicht etwas verkaufen, von der Kleidung bis hin zu den Gebrauchtwagen bis zur Elektronik. 2- Kommunikation zwischen Käufern und Verkäufern passiert über die App über Messaging. 3- Aufgelistet in meiner Nähe ist besser als ein Garagenverkauf; Finden Sie etwas, was Sie auf einem Rabatt wünschen, direkt auf Ihrem Telefon oder Tablet.",
    app_store_release:
      "In der Nähe von Me - Trade mit Einheimischen aufgeführt. Treten Sie dem mobilen Marktplatz für lokale Käufer und Verkäufer bei!",
    app_name: "In der Nähe von mir aufgeführt",
    title_buy: "Besorgen",
    title_messages: "Mitteilungen",
    title_sell: "Verkaufen",
    title_profile_image: "Profilbild",
    title_account: "Konto",
    account_settings: "Account Einstellungen",
    settings: "Einstellungen",
    color_theme: "Farbthema",
    device_settings: "Geräteeinstellungen",
    public_profile: "Öffentliches Profil",
    light_mode: "Lichtmodus",
    dark_mode: "Dunkler Modus",
    title_sell_faster: "Schneller verkaufen",
    send_button_label: "Senden",
    rate_message: "Bewerte mich...",
    already_rated: "Sie haben bereits Review übermittelt",
    rate_review_question: "Möchten Sie damit umgehen?",
    again: "wieder?",
    action_logout: "Ausloggen",
    action_category: "Kategorie",
    action_search: "Suche",
    action_refer: "Einen Freund verweisen",
    dialog_choose_location: "Ort wählen",
    dialog_change_username: "Benutzernamen ändern",
    dialog_change_language: "Sprache ändern",
    dialog_image_tags: "Bild-Tags.",
    dialog_emails_notifications: "E-Mail-Benachrichtigungen",
    dialog_push_notifications: "Mitteilungen",
    fragment_product_detail: "Produktdetail",
    fragment_message_details: "Nachrichten Details.",
    fragment_sell: "Verkaufen",
    dialog_tags_title: "Stichworte",
    dialog_location_title: "Standort aktualisieren.",
    dialog_username_title: "Benutzernamen ändern",
    tab_photo: "Foto",
    tab_details: "Einzelheiten",
    tab_price: "Preis",
    tab_finish: "Beenden",
    profile: "Profil",
    search: "Suche",
    choose_product: "Produkt auswählen",
    rating_review: "Bewertung und Bewertung.",
    select_buyer: "Einen Käufer auswählen",
    tab_my_used_products: "Meine produkte",
    price_label: "Preis",
    text_savings: "Du sparst",
    search_hint: "Suche nach Produkten ...",
    empty_text:
      "Es gibt keine in dieser Kategorie oder in der ausgewählten Entfernung aufgeführten Produkte.",
    filter_menu_text: "Filter",
    error_contacting_seller: "Fehler beim Verkäufer kontaktieren.",
    edit_product: "Produkt bearbeiten",
    contact_seller: "Verkäufer kontaktieren",
    signup_to_contact_seller:
      "Melden Sie sich an, um den Verkäufer zu kontaktieren",
    signup_to_make_offer: "Melden Sie sich an, um Angebot zu erstellen",
    product_details: "Einzelheiten",
    product_category: "Kategorie",
    product_condition: "Kondition",
    product_description: "Beschreibung",
    product_location: "Produktort",
    product_location_approximate: "Die Lage ist ungefähr",
    over_week_time_ago: "Über eine Woche her",
    boosted: "Verstärkt",
    threads_no_results: "Keine Nachrichten",
    message_no_results: "Keine Nachrichten",
    message_warning:
      "Sie sind ausschließlich dafür verantwortlich, alle erforderlichen Vorsichtsmaßnahmen zu treffen, wenn Sie mit anderen interagieren, insbesondere wenn Sie einen Fremden zum ersten Mal persönlich treffen. Bitte teilen Sie keine persönlichen Daten, Überprüfungscodes oder Zahlungsinformationen weiter. Bitte überprüfen Sie die Nutzungsbedingungen für weitere Informationen.",
    message_block:
      "Sie können zu diesem Zeitpunkt keine Nachrichten senden oder empfangen.",
    select_location: "Ort auswählen",
    location_permission_denied_message:
      "Die App erfordert die Erlaubnis des Standortens, ordnungsgemäß zu arbeiten.",
    signed_in: "Angemeldet!",
    sign_in_canceller: "Anmelden Anmelden",
    version: "Ausführung",
    build: "Bauen",
    name: "Name",
    location: "Ort",
    language: "Sprache",
    about_app: "Über mich in der Nähe von mir",
    terms_of_service: "Nutzungsbedingungen",
    privacy_policy: "Datenschutz-Bestimmungen",
    report_feedback: "Feedback schicken",
    report_bug: "SHACK TELEFON, um einen Fehler zu melden",
    change_image: "Bild ändern",
    update_location: "Standort aktualisieren.",
    about_the_app: "Über die App",
    update_label: "Aktualisieren",
    uploading: "Hochladen",
    adding: "Listing hinzufügen",
    removing: "Auflistung entfernen.",
    updating: "Auflistung aktualisieren.",
    uploaded_image: "Bild hochgeladen:",
    image_storage_failed: "Bild konnte nicht gespeichert werden:",
    product_updated: "Produkt erfolgreich aktualisiert",
    location_error: "Standort nicht gespeichert, bitte versuchen Sie es erneut",
    product_removed: "Produkt erfolgreich entfernt",
    deleted_product: "Dieses Produkt wird gelöscht",
    invalid_title: "Ungültiger Titel, bitte setzen Sie den Titel erneut ein.",
    invalid_image: "Ungültiger Bildpfad, versuchen Sie erneut ein Bild.",
    invalid_price: "Ungültiger Preis, bitte setzen Sie den Preis erneut ein.",
    invalid_location:
      "Ungültiger Ort, bitte setzen Sie den Speicherort erneut ein.",
    invalid_category:
      "Ungültige Kategorie, bitte setzen Sie die Kategorie erneut ein.",
    invalid_condition:
      "Ungültiger Zustand, bitte setzen Sie den Zustand erneut ein.",
    removing_title: "Profilbild entfernen",
    image_not_saved: "Bild Speichern fehlgeschlagen!",
    product_load_failed: "Keine Produkte",
    take_photo: "Foto machen",
    select_photo: "Foto auswählen.",
    product_title_hint: "Was ist es? Name, Marke, Modell usw.",
    delete_photo: "Foto löschen",
    product_title: "Titel",
    mark_as_sold: "Mark wie verkauft.",
    product_share: "Teilen",
    product_make_offer: "Angebot machen",
    product_cover: "Als Abdeckbild einstellen",
    product_tags: "Stichworte",
    product_posted: "Gesendet:",
    product_change: "Veränderung",
    product_post: "Post",
    product_selling_from: "Verkauf vom Standort",
    product_select_location: "Ort auswählen",
    product_map_approximate:
      "Die Karte ist ungefähr, um den Standort des Verkäufers privat zu halten",
    product_terms:
      "Durch das Tippen von POST, um Ihr Produkt zu veröffentlichen, stimmen Sie der in der Nähe von mir aufgelisteten Nutzungsbedingungen zu. </ U>",
    condition_other: "Sonstige (siehe Artikelbeschreibung)",
    condition_for_parts: "Für Teile",
    condition_used: "Verwendet (normaler Verschleiß)",
    condition_open_box: "Offene Box (nie benutzt)",
    condition_reconditioned: "Rekonditioniert / zertifiziert",
    condition_new: "Neu (nie benutzt)",
    select_category: "Kategorie wählen",
    select_all_category: "Wählen Sie Alle",
    category_loading_error:
      "Die Kategorienliste kann nicht aktualisiert werden. Bitte versuchen Sie es später erneut.",
    category_vehicles: "Fahrzeuge",
    category_furniture: "Möbel",
    category_electronics: "Elektronik",
    category_appliances: "Home &  Haushaltsgeräte",
    category_fashion_accessories: "Mode &  Zubehör",
    category_baby_kids: "Baby &  Kinder",
    category_antiques_collectibles: "Antiquitäten &  Sammlerstücke",
    category_auto_parts_tools_machinery: "Autoteile, Werkzeuge &  Maschinen",
    category_sports_outdoors: "Sport &  Draußen",
    category_others: "Andere",
    location_enter_zip_code: "Postleitzahl eingeben",
    location_get_current_location: "Aktueller Standort erhalten",
    location_select_location: "Ort auswählen",
    location_update_location: "Standort aktualisieren.",
    location_new_location: "Neuer Standort",
    search_filter_results: "Filter Ergebnisse",
    search_filter_min: "Minimum filtern.",
    search_filter_at_least: "Mindestens",
    price_filter: "Preisfilter.",
    product_name: "Produktname",
    english_language: "Englisch",
    arabic_language: "Arabisch",
    spanish_language: "Spanisch",
    system_language: "System",
    share_link: "Einen Link teilen",
    save: "Speichern",
    cancel: "Abbrechen",
    loading: "Wird geladen",
    yes: "ja",
    no: "Nein",
    report: "Prüfbericht",
    report_product: "Produkt melden.",
    report_user: "Benutzer melden",
    block_user: "Benutzer blockieren",
    un_block_user: "Nutzer entblockieren",
    why_product: "Warum möchten Sie diesen Artikel melden?",
    why_user: "Warum möchten Sie diesen Benutzer melden?",
    block_user_confirm: "Möchten Sie diesen Benutzer dauerhaft blockieren?",
    un_block_user_confirm: "Möchten Sie diesen Benutzer dauerhaft aufsperren?",
    prohibited: "Verboten an der aufgelisteten in meiner Nähe",
    offensive: "Beleidigend oder unangemessen",
    duplicate: "Duplicate Post.",
    wrong_category: "Falsche Kategorie",
    scam: "Sieht aus wie ein Betrug",
    stolen: "Ich denke es wird gestohlen",
    product_other: "Andere",
    product_is_sold: "Dieses Produkt wurde verkauft",
    missed_meeting: "Sie haben unser Treffen verpasst",
    low_offer: "Machte ein niedriges Angebot",
    rude: "Unhöflich oder unangemessen",
    items: "Problem mit den Gegenständen.",
    trouble_meetup: "Ärger beim Treffen",
    messaging: "Probleme von Messaging",
    user_other: "Andere",
    new_version_available: "Neue Version verfügbar",
    please_update_app:
      "Bitte aktualisieren Sie die App auf neue Version, um fortzufahren.",
    update: "Aktualisieren",
    no_thanks: "Nein Danke",
    contact_support_confirmation:
      "Die aktuelle Reaktionszeit beträgt 24-48 Stunden. Möchten Sie in der Nähe von ME-App-Chat-Support in Kontakt treten?",
    unboost_confirmation:
      "Sind Sie sicher, dass Sie dieses Produkt nicht kopieren möchten?",
    no_used_products: "Sie haben noch keine Angebote",
    no_boosted_products: "Sie haben keine verstärkten Produkte",
    next: "Nächste",
    previous: "Vorherige",
    skip: "Überspringen",
    start: "Anfang",
    list_used: "Listen Sie ein gebrauchtes Produkt auf",
    buy_description: "Entdecke und suche Produkte von Nachbarn um dich herum",
    sell_description:
      "Listenprodukte, die Sie nicht mehr zum Verkauf benötigen",
    list_used_description:
      "Listen Sie ein gebrauchtes Produkt in weniger als 20 Sekunden auf",
    boost_product_option_1: "<b> Boost 1  nday </ b>  n  n <b> $ 0.99 </ b>",
    boost_product_option_2:
      "<b> steigern 3  ndays </ b>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<b> Boost 7  ndays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "Holen Sie sich jeden Tag mehr Ansichten. Ihr Artikel erscheint in vorgestellten Positionen in den Top 30 Artikel in Kauf- und Kategorie. Geförderte Gegenstände werden unter den ausgewiesenen Stellen gedreht, sodass jeder Artikel faire Exposition erhält.",
    boost_cta: "Schneller verkaufen",
    boost_terms:
      "Durch das Tippen von Steigern stimmen Sie der in der Nähe von mir aufgelisteten Nutzungsbedingungen zu. </ U>",
    boost_best_value: "Bester Wert",
    already_boosted: "Dieses Produkt wird verstärkt",
    clicks: "Klicks",
    impressions: "Impressionen",
    end: "Ende",
    transactions_empty_text:
      "Sie haben noch keine Boost-Transaktionen. Sie können die SACE-Registerkarte besuchen und starten Sie Ihre Produkte.",
    transactions_loading_error:
      "Die Transaktionsliste kann nicht aktualisiert werden. Bitte versuchen Sie es später erneut.",
    transactions_history_title: "Steigern Sie die Transaktionsgeschichte",
    communicative_postive: "Gesprächig",
    communicative_negative: "Verschlossen",
    ontime_postive: "Pünktlich",
    ontime_negative: "Spät",
    reliable_postive: "Zuverlässig",
    reliable_negative: "Unzuverlässig",
    friendly_postive: "Freundlich",
    friendly_negative: "Unhöflich",
    itemasdescribed_postive: "Artikel wie beschrieben",
    itemasdescribed_negative: "Artikel entspricht nicht der Beschreibung",
    other: "Andere",
    submit: "einreichen",
    adding_rating_reviews: "Hinzufügen von Bewertung und Bewertungen",
    no_internet_title: "Keine Internetverbindung",
    no_internet_message:
      "Stellen Sie sicher, dass Sie mit dem Internet verbunden sind, versuchen Sie es erneut",
    retry: "Wiederholen",
    near_me: "In meiner Nähe",
    newest_first: "Das neuste zuerst",
    miles: "Meilen",
    km: "Km",
    similar_products: "Ähnliche Produkte",
    favorite_products: "Lieblingsprodukte",
    items_for_sale: "Dinge zum Verkauf",
    joined: "Beigetreten",
    favorites_transactions_title: "Favoriten",
    boosted_products_transactions_history:
      "Erhöhte Produkte Transaktionen Geschichte",
    views: "Ansichten",
    boost_graph_title: "Grafik steigern",
    no_favorite_products: "Sie haben keine Lieblingsprodukte",
    make_offer_buy: "ich würde gerne kaufen",
    make_offer_buy_for: "Pro",
    notifications: "Benachrichtigungen",
    push_notifications: "Drücken",
    emails_notifications: "Email",
    apply: "Sich bewerben",
    email_messages: "E-Mail für Nachrichten",
    email_new_products: "E-Mail für neue Produkte",
    push_day_only: "Nur Benachrichtigungen geben Tag",
    push_24_hours: "Push-Benachrichtigungen 24 Stunden",
    edit: "Bearbeiten",
    map: "Karte",
    camera: "Kamera",
    gallery: "Galerie",
    delete: "Löschen",
    no_sell_items: "Keine Artikel zum Verkauf",
    who_bought_question: "Wer hat es gekauft?",
    sold_elsewhere_question: "Verkauft es woanders",
    confirm: "Bestätigen Sie",
    over_limit_camera: "Sie können nicht mehr als fünf Bilder hinzufügen",
    boost_failed: "Boost fehlgeschlagen Bitte versuchen Sie es später erneut",
    after_purchase: "Zahlung erfolgreich  NProduct steigert",
    pay_failed: "Bezahlung fehlgeschlagen. Bitte versuche es erneut",
    done: "Fertig",
    not_now: "Nicht jetzt",
    boost: "Schub",
    invalid_zip_code: "Ungültige Postleitzahl",
    invalid_user_name: "Ungültiger Benutzername",
    comments: "Bemerkungen",
    questions: "Fragen",
    bug_reports: "Fehlerberichte",
    feature_request: "Featureanfrage",
    feedback_type: "Feedback-Art",
    feedback_description:
      "Wir würden gerne Ihre Gedanken oder Ihr Feedback hören, wie wir Ihre Erfahrungen verbessern können!",
    feedback: "Feedback",
    feedback_text: "Deine Antwort",
    suggestions: "Vorschläge zur Verbesserung",
    delete_account: "Konto löschen",
    new_message: "Neue Nachricht",
    online: "Online",
    km_50: "50 km",
    km_100: "100 km",
    km_200: "200 km",
    miles_30: "30 Meilen",
    miles_60: "60 Meilen",
    miles_120: "120 Meilen",
    rate_app_question: "Wie wäre es mit einer Bewertung im App Store, dann?",
    enjoying_question: "Genießen Sie in der Nähe von mir?",
    not_enjoy: "Nicht wirklich",
    feedback_question: "Möchten Sie etwas Feedback geben?",
    yes_sure: "OK sicher",
    product_available_question: "Hallo, ist das noch verfügbar?",
    buy_question: "Hallo, ich mag es, das zu kaufen",
    meet_question: "Hallo, kannst du heute treffen?",
    follow: "Folgen",
    followers: "Anhänger",
    following: "Folgen",
    feedback_thanks: "Vielen Dank für Ihre Rückmeldung",
    all_categories: "Alle Kategorien",
    deleted_account: "Dieses Konto wird gelöscht",
    delete_account_question:
      "Möchten Sie dieses Konto sicher, dass Sie dieses Konto löschen möchten?",
    no_followings: "Folge nicht niemandem",
    when_following: "Wenn",
    no_followings_subtitle: "Folgt den Menschen, du wirst hier sehen",
    no_followers: "Ich habe nicht Anhänger",
    no_followers_subtitle: "Anschließend von Menschen sehen Sie sie hier",
    distance: "Distanz",
    filter_method: "Filtermethode",
    see_listings: "Siehe Auflistungen.",
    sold: "Verkauft",
    bought: "Gekauft",
    no_notifications:
      "Wenn Sie Benachrichtigungen erhalten, werden sie hier angezeigt",
    items_title: "Produkte",
    new_listing_title: "Neue Auflistung erstellen.",
    dialog_year_title: "Jahr",
    dialog_make_title: "Machen",
    dialog_model_title: "Modell",
    dialog_body_style_title: "Körperstil",
    dialog_exterior_color_title: "Außenfarbe",
    dialog_interior_color_title: "Innenfarbe",
    dialog_transmission_title: "Übertragung",
    dialog_fuel_type_title: "Treibstoffart",
    dialog_owners_num_title: "Anzahl der Besitzer",
    dialog_vehicle_owed_money_title: "Gibt es noch Geld in diesem Fahrzeug?",
    automatic_transmission: "Automatisch",
    manual_transmission: "Handbuch",
    not_sure: "Nicht sicher",
    wagon_hatchback: "Wagen &  Hatchback",
    convertible: "Cabrio",
    coupe: "Coupe",
    sedan: "Limousine",
    black_color: "Schwarz",
    blue_color: "Blau",
    brown_color: "Braun",
    gold_color: "Gold",
    green_color: "Grün",
    grey_color: "Grau",
    pink_color: "Rosa",
    purple_color: "Violett",
    red_color: "rot",
    silver_color: "Silber",
    orange_color: "Orange",
    white_color: "Weiß",
    yellow_color: "Gelb",
    charcol_color: "Charkol",
    fuel_diesel: "Diesel",
    fuel_electric: "Elektrisch",
    fuel_gasoline: "Benzin",
    fuel_flex: "Biegen",
    fuel_hybrid: "Hybride",
    fuel_petrol: "Benzin",
    fuel_plugin_hybrid: "Plug-In-Hybrid",
    truck: "Lastwagen",
    van_minivan: "Van &  Minivan",
    suv_crossover: "Suv &  Überkreuzung",
    awd_4wd: "AWD / 4WD.",
    fwd: "Fwd.",
    rwd: "Rwd.",
    off_white_color: "Nicht-gerade weiss",
    tan_color: "Bräunen",
    beige_color: "Beige",
    burgundy_color: "Burgund",
    turquoise_color: "Türkis",
    title_status_clean: "Sauber",
    title_status_rebuilt: "Wieder aufgebaut",
    title_status_salvage: "Bergung",
    title_status_missing: "Fehlen",
    title_status_lien: "Pfandrecht",
    title_status: "Titelstatus.",
    mileage: "Kilometerstand",
    dialog_drivetrain_title: "Antriebsstrang",
    model_warning: "Bitte wählen Sie zuerst ein",
    required_field_warning: "Dieses Feld ist erforderlich",
    vehicle_vin: "Vingelt",
    invalid_vin: "Ungültige VIN, bitte setzen Sie die VIN erneut ein.",
    invalid_mileage:
      "Ungültige Kilometerstand, bitte setzen Sie den Kilometerstand erneut ein.",
    clean_description: "Die meisten Fahrzeuge, die nicht in einem Unfall waren",
    rebuilt_description: "Ein gerettetes Auto, das umgebaut wurde",
    salvage_description: "Wird nach einem Unfall betrachtet",
    missing_description: "Braucht einen neuen DMV-Problemtitel",
    lien_description:
      "Im Besitz einer Bank oder einer gerichtlichen Besiedlung",
    nearme: "In meiner Nähe",
    newest: "Neueste",
    contact_support: "Kontaktieren Sie Support",
    create_home_title: "Häuser zum Verkauf oder Miete",
    for_sale: "Zu verkaufen",
    for_rent: "Zu vermieten",
    property_type: "Art der Immobilie",
    apartment: "Wohnung",
    house: "Haus",
    room_only: "Nur Zimmer",
    townhouse: "Stadthaus",
    bedrooms: "Schlafzimmer",
    bathrooms: "Badezimmer",
    property_address: "Immobilien-Adresse",
    price_per_month: "Preis pro Monat",
    square_feet: "Quadratfuß",
    year_built: "Baujahr",
    year_renovated: "Jahr renoviert",
    lot_size: "Losgröße",
    laundry_type: "Wäscherei-Typ.",
    in_unit_laundry: "Wäsche in der Einheit",
    laundry_building: "Wäsche im Gebäude.",
    laundry_available: "Wäscherei verfügbar",
    none: "Keiner",
    parking_type: "Parkart",
    garage_parking: "Garage Parkplatz.",
    street_parking: "Parkplatz der Straße.",
    off_street_parking: "Parken abseits der Straße",
    available_parking: "Parkplatz verfügbar.",
    air_cond_type: "Klimatisierungstyp.",
    ac_available: "AC verfügbar",
    central_ac: "Central AC.",
    heating_type: "Heizungsart",
    electric_heating: "Elektroheizung",
    gas_heating: "Gasheizung",
    radiator_heating: "Heizkörperheizung.",
    available_heating: "Heizung verfügbar",
    amenities: "Annehmlichkeiten",
    date_available: "Datum verfügbar",
    lease_length: "Leasinglänge",
    month_to_month: "Von Monat zu Monat",
    three_months: "3 Monate",
    six_months: "6 Monate",
    one_year: "1 Jahr",
    more_one_year: "1+ Jahre alt.",
    cat_friendly: "Katzenfreundlich",
    dog_friendly: "Hundefreundlich",
    balcony: "Balkon",
    basement: "Untergeschoss",
    bike_parking: "Fahrradparken",
    cable_tv: "Kabelfernsehen",
    ceiling_fan: "Deckenventilator",
    concierge: "Portier",
    dishwasher: "Geschirrspüler",
    doorman: "Türsteher",
    elevator: "Aufzug",
    fireplace: "Kamin",
    fitness_center: "Fitness Center",
    garbage_disposal: "Müllentsorgung",
    microwave: "Mikrowelle",
    online_app: "Online-Bewerbung",
    oven: "Ofen",
    package_service: "Paketdienst",
    patio: "Terrasse",
    pet_park: "Haustierpark",
    refrigerator: "Kühlschrank",
    resident_lounge: "Resident Lounge.",
    roof_deck: "Dachterrasse",
    secured_entry: "Gesicherter Einstieg.",
    storage: "Lager",
    walk_in_closet: "Begehbarer Kleiderschrank",
    swimming_pool: "Schwimmbad",
    wheelchair_access: "Rollstuhlzugang",
    central_heating: "Zentralheizung",
    invalid_bedrooms:
      "Ungültige Schlafzimmer, bitte setze die Schlafzimmer wieder ein.",
    invalid_bathrooms:
      "Ungültige Badezimmer, bitte setze bitte wieder Bäder ein.",
    chinese_simplified_language: "Vereinfachtes Chinesisch",
    chinese_traditional_language: "Chinesische Tradition",
    czech_language: "Tschechisch",
    danish_language: "dänisch",
    dutch_language: "Niederländisch",
    finnish_language: "finnisch",
    french_language: "Französisch",
    german_language: "Deutsch",
    greek_language: "griechisch",
    hungarian_language: "ungarisch",
    indonesian_language: "Indonesisch",
    italian_language: "Italienisch",
    japanese_language: "japanisch",
    korean_language: "Koreanisch",
    norwegian_language: "norwegisch",
    polish_language: "Polieren",
    portuguese_language: "Portugiesisch",
    portuguese_brazilian_language: "Portugiesisch, Brasilianer",
    romanian_language: "rumänisch",
    russian_language: "Russisch",
    swedish_language: "Schwedisch",
    turkish_language: "Türkisch",
    ukrainian_language: "ukrainisch",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "Vietnamesisch",
    category_home_sale_or_rent: "Zuhause zum Verkauf oder Miete",
    square_meter: "Quadratmeter",
    copy_text: "Kopieren",
    copyied_to_clipboard: "In die Zwischenablage kopiert",
    inbox: "Inbox",
    input_title_listening: "Hören…",
    input_subtitle_listening: "Sag etwas",
    input_title_error: "Entschuldigung, wir haben das nicht ganz bekommen.",
    input_subtitle_error: "Wiederholen Sie Ihre Anfrage.",
    input_hint_error: "Versuch es noch einmal",
    price_less_than_or_equal: "Preis weniger als oder gleich",
    any_price: "Jeder Preis",
    any_condition: "Jeder Zustand.",
    any_time: "Jederzeit",
    days_ago: "Vor Tagen",
    any_distance: "Jede Entfernung",
    distance_within: "Entfernung innerhalb",
    new_notification: "Neue Benachrichtigung",
    deleted: "Gelöscht",
    processing_image: "Bearbeitung des Bildes",
    remove_dialog_message: "Möchten Sie dieses Produkt wirklich entfernen?",
    deleted_thread: "Diese Nachricht wird gelöscht",
    category_yard_sale_event: "Hofverkaufsereignis",
    yard_first_date: "Yard Sale First Datum",
    yard_second_date: "Gartenverkauf zweiter Datum",
    yard_third_date: "Gartenverkauf drittes Datum",
    yard_start_time: "Startzeit",
    yard_end_time: "Endzeit.",
    yard_end_timestamp: "Endzeitstempel",
    invalid_date1: "Ungültiger Datum, bitte wieder einstellen",
    invalid_start_time:
      "Ungültige Startzeit, bitte starten Sie die Startzeit erneut ein",
    invalid_end_time: "Ungültige Endzeit, bitte die Endzeit wieder einstellen",
    yard_sale_title: "YARD SALE.",
    garage_tag: "Garage",
    yard_tag: "Garten",
    from: "Von",
    to: "Zu",
    block: "Block",
    un_block: "Aufheben",
    sign_email: "Melden Sie sich mit E-Mail an",
    invalid_first_date:
      "Ungültiges Datum, bitte stellen Sie sicher, dass das erste Datum vor zweiter und dritter ist",
    invalid_second_date:
      "Ungültiges zweites Datum, bitte stellen Sie sicher, dass das zweite Datum vor dem dritten Datum ist",
    invalid_start_time_value:
      "Ungültige Startzeit, bitte stellen Sie sicher, dass die Startzeit vor der Endzeit ist",
    use_default_yard_photo: "Verwenden Sie Standard-Yard-Sale-Foto",
    active_label: "Aktiv",
    enable_notifications: "Benachrichtigungen aktivieren",
    login: "Anmeldung",
    january: "Januar",
    february: "Februar",
    march: "Marsch",
    april: "April",
    may: "Kann",
    june: "Juni",
    july: "Juli",
    august: "August",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Dezember",
    since: "Seit",
    product_views: "Produktansichten.",
    shop_views: "Shop-Ansichten.",
    total_sales: "Gesamtumsatz",
    total_orders: "Gesamtaufträge",
    last_twelvth_months: "Letzte zwölzte Monate",
    last_nine_months: "Letzte neun Monate",
    last_six_months: "Letzte sechs Monate",
    last_three_months: "Letzte drei Monate",
    last_12_months: "Letzte 12 Monate",
    last_9_months: "Letzte 9 Monate",
    last_6_months: "Letzte 6 Monate",
    last_3_months: "Letzte 3 Monate",
    months: "Monate",
    open: "Offen",
    reset_password: "Passwort zurücksetzen",
    create_new_shop: "Neuer shop erstellen.",
    download_app: "Lade App herunter",
    log_in: "Einloggen",
    sign_up: "Anmelden",
    no_result: "Kein Ergebnis",
    max_price: "Max. Preis",
    max_distance: "maximale Entfernung",
    max_time: "Maximale Zeit.",
    posted_less_than: "Geringer als weniger als",
    result: "Ergebnis",
    more: "Mehr",
    or: "ODER",
    password: "Passwort",
    forgot_password: "Passwort vergessen?",
    and: "und",
    download_for: "Herunterladen für",
    apple_ios: "Apple ios.",
    android: "Android",
    image: "Bild",
    edit_image: "Bild bearbeiten",
    please_complete: "Bitte vervollständigen",
    enter_your_offer: "Geben Sie Ihr Angebot ein",
    categories: "Kategorien",
    upload_image: "Bild hochladen",
    upload_images: "Bilder hochladen",
    back: "Zurück",
    see_more: "Mehr sehen",
    add_product: "Produkt hinzufügen",
    selected: "Ausgewählt",
    create: "Erstellen",
    rate_the_buyer: "Den Käufer bewerten.",
    delete_product: "Produkt löschen",
    product: "Produkt",
    un_block_product: "Produkt freigeben",
    share_your_product: "Teilen Sie Ihr Produkt",
    boost_details: "Details erhöhen",
    remove_all_products: "Alle Produkte entfernen.",
    remove_all: "Alles entfernen",
    add_vehicle: "Fahrzeug hinzufügen",
    edit_vehicle: "Fahrzeug bearbeiten",
    upload_a_photo: "Lade ein Foto hoch",
    view_details: "Details anzeigen",
    add_yard_sale: "Yard Sale hinzufügen",
    edit_yard_sale: "Yard Sale bearbeiten.",
    users: "Benutzer",
    users_details: "Benutzerdetails",
    users_by_country: "Benutzer nach Land.",
    blocked_users: "Blockierte Benutzer",
    products_cards: "Produkte Karten",
    archived_products: "Archivierte Produkte",
    blocked_products: "Blockierte Produkte",
    products_by_country: "Produkte nach Land.",
    reports: "Prüfbericht",
    reports_details: "Berichte Details",
    closed_reports: "Geschlossene Berichte.",
    threads: "Fäden",
    threads_details: "Threads Details.",
    chat_support: "Chat-Unterstützung",
    actions: "Aktionen",
    search_actions: "Aktionen suchen",
    product_view_actions: "Produktansicht Aktionen.",
    contact_seller_product: "Verkäufer kontaktieren Produkt.",
    contact_owner_shop: "Kontakt Eigentümershop.",
    ratings: "Ratings",
    reviews: "Rezensionen",
    products_all_countries: "Produkte Alle Länder",
    edit_profile: "Profil bearbeiten",
    my_profile: "Mein Profil",
    profile_updated_successfully: "Profil erfolgreich aktualisiert",
    are_you_sure: "Bist du sicher",
    my_used_products: "Meine gebrauchten Produkte",
    my_shops: "Meine Geschäfte",
    my_boosted_products: "Meine verstärkten Produkte",
    messages_type_message_here: "Schreiben Sie ihre Nachricht hier",
    messages_product_sold: "Dieses Produkt wird verkauft oder entfernt",
    seen: "Gesehen",
    messages_never_miss_message: "Verpassen Sie niemals eine Nachricht",
    enable: "Ermöglichen",
    send_notify: "Benachrichtigen senden",
    un_close: "Entkleiden",
    type_your_review: "Geben Sie Ihre Bewertung ein",
    again_question: "wieder ?",
    ratings_already_submitted_review: "Sie haben bereits Review übermittelt",
    set_product_category: "Produktkategorie einstellen",
    auth_email_password_incorrect: "Ihr E-Mail oder Ihr Passwort falsch",
    auth_insert_your_name: "Bitte geben Sie Ihren Namen ein",
    auth_email_address_badly: "Die E-Mail-Adresse ist schlecht formatiert",
    auth_email_address_used:
      "Die E-Mail-Adresse ist bereits von einem anderen Konto verwendet",
    auth_invalid_password: "Das Passwort sollte mindestens 6 Zeichen lang sein",
    auth_reset_email:
      "Geben Sie Ihre E-Mail ein, um Ihr Passwort zurückzusetzen",
    auth_check_email:
      "Bitte überprüfen Sie Ihre E-Mail, um das Passwort zurückzusetzen",
    auth_can_sign_in_google: "Sie können sich mit der Google-Taste anmelden",
    auth_do_not_have_account: "Hast du kein Konto?",
    auth_have_account: "Hast du einen Account?",
    log_terms_privacy_part1:
      "Indem Sie sich anmelden oder anmelden, stimmen Sie dem aufgelisteten in der Nähe von mir zu",
    boost_this_product: "Steigern Sie dieses Produkt?",
    product_successfully_boosted: "Das Produkt wurde erfolgreich verstärkt",
    product_failed_boost: "Das Produkt wurde im Schub ausgefallen",
    no_products_for_sale:
      "Sie haben derzeit keine gebrauchten Produkte, die zum Verkauf aufgeführt sind.",
    not_sold_listed_near_me: "Ich habe es nicht in der Nähe von mir verkaufen",
    agree_add_product:
      "Indem Sie den Beitrag zum Veröffentlichen Ihres Produkts tippen, stimmen Sie dem in der Nähe von ME-Nutzungsbedingungen und Datenschutzrichtlinien einverstanden.",
    click_to_boost: "Klicken Sie auf das Produkt, um es zu stärken",
    listed_terms_of_service:
      "In der Nähe von ME-Nutzungsbedingungen aufgeführt",
    receive_emails_for_users: "Erhalten Sie E-Mails für Benutzermeldungen",
    receive_emails_for_newly_posted:
      "Erhalten Sie E-Mails für Ihre neu geposteten Produkte",
    disable_push_notifications: "Push-Benachrichtigungen deaktivieren.",
    sms_during_day: "SMS während des Tages erhalten",
    sms_24_hours: "SMS 24 Stunden erhalten",
    products: "Produkte",
    product_no_longer_available:
      "Sorry, dieses Produkt ist nicht mehr verfügbar",
    add_home: "Nach Hause hinzufügen",
    edit_home: "Haus bearbeiten",
    fill_required_fields: "Füllen Sie alle erforderlichen Felder aus",
    no_notification: "Es gibt keine Benachrichtigungen",
    orders_history: "Geschichte der Bestellungen",
    privacy: "Privatsphäre",
    terms: "Bedingungen",
    report_a_problem: "Ein Problem melden",
    approximation_protect_user_privacy:
      "Annäherung an die Privatsphäre des Benutzers",
    do_not_have_products: "Sie haben keine Produkte",
    emails: "E-Mails",
    lead_deletion_products: "Dies führt zur Löschung aller Ihrer Produkte",
    confirm_legal_message:
      "Sie sind allein dafür verantwortlich, alle notwendigen Vorsichtsmaßnahmen zu ergreifen, wenn Sie mit anderen interagieren, insbesondere wenn Sie zum ersten Mal einen Fremden persönlich treffen. Bitte überprüfen Sie die Nutzungsbedingungen für weitere Details.",
    push_notifications_notified_instantly:
      "Aktivieren Sie, dass Push-Benachrichtigungen sofort mitgeteilt werden sollen",
    rate_seller: "Den Verkäufer bewerten",
    user_journey: "Benutzerreise.",
    user: "Nutzer",
    user_id: "Benutzeridentifikation",
    action_id: "Aktions-ID.",
    select_model_car: "Wählen Sie das Modell des Autos aus",
    boost_1_day: "1 Tag steigern",
    boost_3_days: "3 Tage steigern",
    boost_7_days: "Boost 7 Tage",
    agree_boost_terms: "Indem Sie den Steigung klopfen, stimmen Sie zu",
    add: "Hinzufügen",
    add_tag: "Tag hinzufügen",
    brand_title: "Marke",
    category_mobiles: "Handys.",
    category_tablets: "Tablets",
    screen_size: "Bildschirmgröße",
    has_cellular_capability: "Hat zelluläre Fähigkeit",
    default_internal_memory: "Interner Speicher",
    network_carrier: "Mobilfunkanbieter",
    is_unlocked: "Ist freigeschaltet",
    mobile_model_warning: "Bitte wählen Sie zuerst Marke",
    missing_image: "Fehlendes Bild, versuchen Sie erneut ein Bild.",
    add_mobile: "Mobile hinzufügen",
    edit_mobile: "Mobile bearbeiten",
    add_tablet: "Tablet hinzufügen",
    edit_tablet: "Tablet bearbeiten.",
    keywords:
      "Einkaufen, kaufen, verkaufen, Geld verdienen, Handel, Einheimische, Nachbarn, Auto, Fahrzeuge",
    country: "Land",
    phone_number: "Telefonnummer",
    verification_code: "Bestätigungs-Code",
    error_occurred:
      "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut",
    invalid_state:
      "Ungültiger Zustand: Ein Anmeldeabruf wurde empfangen, wurde jedoch keine Anmeldeanforderung gesendet.",
    sign_in: "Anmelden",
    sign_in_apple: "Melden Sie sich mit Apple an",
    sign_in_google: "Anmeldung mit Google",
    sign_in_phone: "Melden Sie sich mit dem Telefon an",
    sign_in_facebook: "Mit Facebook anmelden",
    create_account: "Ein Konto erstellen",
    email: "Email",
    invalid_field: "Bitte fülle die notwendigen Felder aus",
    code_sent: "Der Code wurde von SMS gesendet",
    verify_number: "Überprüfen Sie die Telefonnummer",
    tapping_verify_number:
      "Durch das Tippen (Überprüfen der Telefonnummer) werden ein SMS gesendet.",
    email_exists:
      "Das Konto ist bereits vorhanden und Sie müssen über Google-Schaltfläche, Facebook-Taste oder Apple-Taste auf ihn zugreifen",
    ok: "In Ordnung",
    sure_back: "Bist du sicher zurück?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "vor",
    add_model: "Modell hinzufügen",
    no_search_results_us:
      "Keine Suchergebnisse in Ihrer Nähe innerhalb von 120 Meilen. Versuchen Sie, das Suchfilter oder das Suchschlüsselwort zu ändern.",
    no_search_results:
      "Keine Suchergebnisse in Ihrer Nähe innerhalb von 200 km. Versuchen Sie, das Suchfilter oder das Suchschlüsselwort zu ändern.",
    plan_date: "Plandatum",
    plan_time: "Zeit planen",
    invalid_plan_date:
      "Ungültiges Plandatum, bitte das Plandatum erneut festlegen",
    invalid_plan_time:
      "Ungültige Planzeit, bitte stellen Sie die Planzeit erneut fest",
    plan_name: "Planname",
    plan_title: "Planen",
    update_plan_name: "Planungsname aktualisieren",
    delete_plan_question:
      "Sind Sie sicher, dass Sie diesen Plan löschen möchten?",
    plan_reminder_message: "Sie werden eine Stunde zuvor erinnert",
    plan_dialog_title: "Besprechungsplan",
    planners_title: "Planer",
    unable_sending_messages:
      "Sie werden Ihre Nachrichten sehen, wenn sie wieder online sind.",
    its_text: "Es ist",
    for_your_text: "Für Ihren Empfänger.",
  },
  el: {
    invalid_area:
      "Μη έγκυρη περιοχή, παρακαλείστε να ρυθμίσετε ξανά την περιοχή.",
    invalid_lot_size:
      "Μη έγκυρο μέγεθος παρτίδας ιδιοκτησίας, ρυθμίστε ξανά το μέγεθος της παρτίδας.",
    property_area: "Περιοχή ακινήτου",
    app_store_name:
      "Που αναφέρονται κοντά μου - αγοράστε μεταχειρισμένα αντικείμενα, πωλούν για μετρητά",
    app_store_short:
      "Μια αγορά για τους τοπικούς πωλητές. Καταγράψτε ένα στοιχείο προς πώληση και κερδίστε χρήματα.",
    app_store_full:
      "Καταχωρημένο κοντά μου καθιστά εύκολη την εύρεση μεγάλων προσφορών για τα πράγματα που θέλετε και κερδίστε χρήματα στα πράγματα που θέλετε να πουλήσετε. Αυτός είναι ο καλύτερος τρόπος να αγοράσετε και να πουλήσετε στην κοινότητά σας ή τη γειτονιά σας με τους ανθρώπους που μπορείτε να εμπιστευτείτε. Πώς λειτουργεί: 1- Αγορά ή πώληση οτιδήποτε? Δημοσιεύστε εύκολα τα αντικείμενά σας προς πώληση σε δευτερόλεπτα. 2- Βρείτε μεγάλες προσφορές και εκπτώσεις σε ρούχα, έπιπλα, κινητά τηλέφωνα, ηλεκτρονικά, είδη μωρών και παιδιών, αθλητικό εξοπλισμό, μεταχειρισμένα αυτοκίνητα, φορέματα, παπούτσια και ρολόγια, σε βιβλία, μεταχειρισμένα παιχνίδια, μεταχειρισμένα φορητούς υπολογιστές, ένα μεταχειρισμένο αυτοκίνητο και ακόμη και πραγματικό Estate προς πώληση ή ενοικίαση. 3- Περιηγηθείτε στα τοπικά αντικείμενα προς πώληση. 4- Μήνυμα αγοραστές και πωλητές από την εφαρμογή. 5 - Περιηγηθείτε σε στοιχεία ανά εικόνα και ταξινομήστε ανά κατηγορία. Διασκεδαστικά γεγονότα σχετικά με την αναφερόμενη κοντά μου: 1- Με την εγγραφή κοντά μου μπορείτε εύκολα να πουλήσετε οτιδήποτε, από τα ρούχα στα μεταχειρισμένα αυτοκίνητα σε ηλεκτρονικά. 2- Επικοινωνία μεταξύ αγοραστών και πωλητών συμβαίνει μέσω της εφαρμογής μέσω μηνυμάτων. 3- που αναφέρεται κοντά μου είναι καλύτερη από μια πώληση γκαράζ. Βρείτε οτιδήποτε θέλετε με έκπτωση, ακριβώς στο τηλέφωνο ή το tablet σας.",
    app_store_release:
      "Που αναφέρονται κοντά μου - εμπόριο με τους ντόπιους. Συμμετοχή στην αγορά κινητής τηλεφωνίας για τους τοπικούς αγοραστές και τους πωλητές!",
    app_name: "Που αναφέρονται κοντά μου",
    title_buy: "Αγορά",
    title_messages: "Μηνύματα",
    title_sell: "Πουλώ",
    title_profile_image: "Εικόνα προφίλ",
    title_account: "λογαριασμός",
    account_settings: "Ρυθμίσεις λογαριασμού",
    settings: "Ρυθμίσεις",
    color_theme: "Χρώμα θέμα",
    device_settings: "Ρυθμίσεις συσκευής",
    public_profile: "Δημόσιο προφίλ",
    light_mode: "Λειτουργία φωτός",
    dark_mode: "Σκοτεινή λειτουργία",
    title_sell_faster: "Πωλούν ταχύτερα",
    send_button_label: "Στείλετε",
    rate_message: "Αξιολογήστε με...",
    already_rated: "Έχετε ήδη υποβάλει αναθεώρηση",
    rate_review_question: "Θα θέλατε να το αντιμετωπίσετε",
    again: "πάλι?",
    action_logout: "Αποσύνδεση",
    action_category: "Κατηγορία",
    action_search: "Αναζήτηση",
    action_refer: "Ανατρέξτε σε έναν φίλο",
    dialog_choose_location: "Επιλέξτε τοποθεσία",
    dialog_change_username: "Αλλάξτε το όνομα χρήστη",
    dialog_change_language: "Αλλαξε γλώσσα",
    dialog_image_tags: "Ετικέτες εικόνας",
    dialog_emails_notifications: "Ειδοποιήσεις ηλεκτρονικού ταχυδρομείου",
    dialog_push_notifications: "Σπρώξτε τις ειδοποιήσεις",
    fragment_product_detail: "Λεπτομέρεια προϊόντος",
    fragment_message_details: "Λεπτομέρειες μηνυμάτων",
    fragment_sell: "Πουλώ",
    dialog_tags_title: "Ετικέτες",
    dialog_location_title: "Ενημέρωση τοποθεσίας",
    dialog_username_title: "Αλλάξτε το όνομα χρήστη",
    tab_photo: "φωτογραφία",
    tab_details: "Λεπτομέριες",
    tab_price: "Τιμή",
    tab_finish: "Φινίρισμα",
    profile: "Προφίλ",
    search: "Αναζήτηση",
    choose_product: "Επιλέξτε προϊόν",
    rating_review: "Βαθμολογία και κριτική",
    select_buyer: "Επιλέξτε έναν αγοραστή",
    tab_my_used_products: "Τα προϊόντα μου",
    price_label: "Τιμή",
    text_savings: "Αποθηκεύετε",
    search_hint: "Αναζήτηση προϊόντων ...",
    empty_text:
      "Δεν υπάρχουν προϊόντα που αναφέρονται στην κατηγορία αυτή ή εντός της επιλεγμένης απόστασης.",
    filter_menu_text: "Φίλτρο",
    error_contacting_seller: "Σφάλμα επικοινωνίας με τον πωλητή",
    edit_product: "Επεξεργασία προϊόντος",
    contact_seller: "Επικοινωνία με τον πωλητή",
    signup_to_contact_seller: "Εγγραφείτε για να επικοινωνήσετε με τον πωλητή",
    signup_to_make_offer: "Εγγραφείτε για να κάνετε την προσφορά",
    product_details: "Λεπτομέριες",
    product_category: "Κατηγορία",
    product_condition: "Κατάσταση",
    product_description: "Περιγραφή",
    product_location: "Τοποθεσία προϊόντος",
    product_location_approximate: "Η τοποθεσία είναι κατά προσέγγιση",
    over_week_time_ago: "Πριν από μια εβδομάδα",
    boosted: "Ενισχυμένος",
    threads_no_results: "Δεν υπάρχουν μηνύματα",
    message_no_results: "Δεν υπάρχουν μηνύματα",
    message_warning:
      "Είστε αποκλειστικά υπεύθυνοι για τη λήψη όλων των απαραίτητων προφυλάξεων κατά την αλληλεπίδραση με άλλους, ιδιαίτερα όταν συναντάτε έναν ξένο προσωπικά για πρώτη φορά. Μην μοιράζεστε προσωπικά στοιχεία, κωδικούς επαλήθευσης ή στοιχεία πληρωμής. Ελέγξτε τους Όρους Παροχής Υπηρεσιών για περισσότερες λεπτομέρειες.",
    message_block:
      "Δεν μπορείτε να στείλετε ή να λάβετε μηνύματα αυτή τη στιγμή.",
    select_location: "Επιλέξτε τοποθεσία",
    location_permission_denied_message:
      "Η εφαρμογή απαιτεί άδεια θέσης να λειτουργεί σωστά.",
    signed_in: "Συνδεδεμένος!",
    sign_in_canceller: "Συνδεθείτε ακυρωμένα",
    version: "Εκδοχή",
    build: "Χτίζω",
    name: "Ονομα",
    location: "Τοποθεσία",
    language: "Γλώσσα",
    about_app: "Σχετικά με την αναφερόμενη κοντά μου",
    terms_of_service: "Όροι χρήσης",
    privacy_policy: "Πολιτική απορρήτου",
    report_feedback: "Στείλετε τα σχόλιά σας",
    report_bug: "Ανακινήστε το τηλέφωνο για να αναφέρετε ένα σφάλμα",
    change_image: "Αλλαγή εικόνας",
    update_location: "Ενημέρωση τοποθεσίας",
    about_the_app: "Σχετικά με την εφαρμογή",
    update_label: "Εκσυγχρονίζω",
    uploading: "Μεταφόρτωση",
    adding: "Προσθήκη λίστα",
    removing: "Κατάργηση της λίστα",
    updating: "Ενημέρωση της λίστας",
    uploaded_image: "Μεταφόρτωση εικόνας:",
    image_storage_failed: "Αποτυχία αποθήκευσης εικόνας:",
    product_updated: "Το προϊόν ενημερώνεται με επιτυχία",
    location_error: "Η τοποθεσία δεν αποθηκεύτηκε, δοκιμάστε ξανά",
    product_removed: "Το προϊόν αφαιρείται με επιτυχία",
    deleted_product: "Αυτό το προϊόν διαγράφεται",
    invalid_title: "Μη έγκυρος τίτλος, ρυθμίστε ξανά τον τίτλο.",
    invalid_image:
      "Μη έγκυρη διαδρομή εικόνας, δοκιμάστε ξανά την προσθήκη εικόνας.",
    invalid_price: "Μη έγκυρη τιμή, παρακαλείστε να ρυθμίσετε ξανά την τιμή.",
    invalid_location: "Μη έγκυρη τοποθεσία, ρυθμίστε ξανά την τοποθεσία.",
    invalid_category: "Μη έγκυρη κατηγορία, ρυθμίστε ξανά την κατηγορία.",
    invalid_condition: "Μη έγκυρη κατάσταση, ρυθμίστε ξανά την κατάσταση.",
    removing_title: "Αφαίρεση εικόνας προφίλ",
    image_not_saved: "Αποθήκευση εικόνας απέτυχε!",
    product_load_failed: "Δεν υπάρχουν προϊόντα",
    take_photo: "Βγάλε φωτογραφία",
    select_photo: "Επιλέξτε φωτογραφία",
    product_title_hint: "Τι είναι αυτό? Όνομα, μάρκα, μοντέλο κλπ.",
    delete_photo: "Διαγράψτε τη φωτογραφία",
    product_title: "Τίτλος",
    mark_as_sold: "Mark όπως πωλείται",
    product_share: "Μερίδιο",
    product_make_offer: "Κάνετε την προσφορά",
    product_cover: "Ορίστε ως εικόνα κάλυψης",
    product_tags: "Ετικέτες",
    product_posted: "Δημοσιεύτηκε:",
    product_change: "Αλλαγή",
    product_post: "Θέση",
    product_selling_from: "Πώληση από την τοποθεσία",
    product_select_location: "Επιλέξτε τοποθεσία",
    product_map_approximate:
      "Ο χάρτης είναι κατά προσέγγιση για να διατηρήσετε την τοποθεσία του πωλητή ιδιωτική",
    product_terms:
      "Πατώντας τη θέση για να δημοσιεύσετε το προϊόν σας, συμφωνείτε με το <u> που αναφέρονται κοντά μου Όροι Παροχής Υπηρεσιών. </ U>",
    condition_other: "Άλλο (βλ. Περιγραφή)",
    condition_for_parts: "Για μέρη",
    condition_used: "Χρησιμοποιείται (κανονική φθορά)",
    condition_open_box: "Ανοιχτό πλαίσιο (ποτέ δεν χρησιμοποιείται)",
    condition_reconditioned: "Ανακατασκευασμένο / πιστοποιημένο",
    condition_new: "Νέο (που δεν χρησιμοποιείται ποτέ)",
    select_category: "Επιλέξτε Κατηγορία",
    select_all_category: "Επιλογή όλων",
    category_loading_error:
      "Δεν είναι δυνατή η ενημέρωση των καταλόγων κατηγοριών, δοκιμάστε ξανά αργότερα.",
    category_vehicles: "Οχήματα",
    category_furniture: "Επιπλα",
    category_electronics: "ΗΛΕΚΤΡΟΝΙΚΑ ΕΙΔΗ",
    category_appliances: "Αρχική &  Συσκευές",
    category_fashion_accessories: "Μόδα &  αξεσουάρ",
    category_baby_kids: "Baby &  Παιδιά",
    category_antiques_collectibles: "Αντίκες &  Συλλεκτικά",
    category_auto_parts_tools_machinery:
      "Εξαρτήματα αυτοκινήτων, εργαλεία και  Μηχανήματα",
    category_sports_outdoors: "Αθλητισμός &  Σε εξωτερικό χώρο",
    category_others: "Οι υπολοιποι",
    location_enter_zip_code: "Εισάγετε τον ταχυδρομικό κώδικα",
    location_get_current_location: "Λάβετε την τρέχουσα τοποθεσία",
    location_select_location: "Επιλέξτε τοποθεσία",
    location_update_location: "Ενημέρωση τοποθεσίας",
    location_new_location: "Νέα τοποθεσία",
    search_filter_results: "Αποτελέσματα φίλτρου",
    search_filter_min: "Φίλτρο ελάχιστο",
    search_filter_at_least: "Τουλάχιστον",
    price_filter: "Φίλτρο τιμών",
    product_name: "Ονομασία προϊόντος",
    english_language: "Αγγλικά",
    arabic_language: "αραβικός",
    spanish_language: "Ισπανικά",
    system_language: "Σύστημα",
    share_link: "Μοιράζομαι ένα σύνδεσμο",
    save: "Σώσει",
    cancel: "Ματαίωση",
    loading: "Φόρτωση",
    yes: "Ναί",
    no: "Οχι",
    report: "Κανω ΑΝΑΦΟΡΑ",
    report_product: "Αναφορά προϊόντος",
    report_user: "Αναφορά χρήστη",
    block_user: "Αποκλεισμός χρήστη",
    un_block_user: "Ξεμπλοκάρισμα χρήστη",
    why_product: "Γιατί θέλετε να αναφέρετε αυτό το στοιχείο;",
    why_user: "Γιατί θέλετε να αναφέρετε αυτόν τον χρήστη;",
    block_user_confirm: "Θέλετε να μπλοκάρετε μόνιμα αυτόν τον χρήστη;",
    un_block_user_confirm: "Θέλετε να ξεμπλοκάρετε μόνιμα αυτόν τον χρήστη;",
    prohibited: "Απαγορεύεται στην εγγραφή κοντά μου",
    offensive: "Προσβλητικό ή ακατάλληλο",
    duplicate: "Διπλή θέση",
    wrong_category: "Λάθος κατηγορία",
    scam: "Μοιάζει με απάτη",
    stolen: "Νομίζω ότι κλαπεί",
    product_other: "Αλλα",
    product_is_sold: "Αυτό το προϊόν πωλήθηκε",
    missed_meeting: "Έχασαν τη συνάντησή μας",
    low_offer: "Έκανε μια χαμηλή προσφορά",
    rude: "Αγενής ή ακατάλληλη",
    items: "Πρόβλημα με τα στοιχεία",
    trouble_meetup: "Πρόβλημα κατά τη συνάντηση",
    messaging: "Προβλήματα μηνυμάτων",
    user_other: "Αλλα",
    new_version_available: "Νέα έκδοση διαθέσιμη",
    please_update_app:
      "Παρακαλώ, ενημερώστε την εφαρμογή σε νέα έκδοση για να συνεχίσετε.",
    update: "Εκσυγχρονίζω",
    no_thanks: "Οχι ευχαριστώ",
    contact_support_confirmation:
      "Ο τρέχων χρόνος απόκρισης είναι 24-48 ώρες. Θέλετε να επικοινωνήσετε με την αναταραχή κοντά μου App Chat υποστήριξης;",
    unboost_confirmation: "Είστε βέβαιοι ότι θέλετε να unboost αυτό το προϊόν;",
    no_used_products: "Δεν έχετε ακόμα καταχωρίσεις",
    no_boosted_products: "Δεν έχετε κανένα ενισχυμένο προϊόντα",
    next: "Επόμενο",
    previous: "Προηγούμενος",
    skip: "Παραλείπω",
    start: "Αρχή",
    list_used: "Καταγράψτε ένα προϊόν που χρησιμοποιείται",
    buy_description:
      "Ανακαλύψτε και αναζητήστε προϊόντα που προσφέρονται από γείτονες γύρω σας",
    sell_description: "Προϊόντα λίστας που δεν χρειάζεστε πλέον προς πώληση",
    list_used_description:
      "Καταγράψτε ένα προϊόν που χρησιμοποιείται προς πώληση σε λιγότερο από 20 δευτερόλεπτα",
    boost_product_option_1: "<b> Boost 1  nday </ b>  n  n <b> $ 0.99 </ b>",
    boost_product_option_2: "<b> Boost 3  ndays </ b>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<b> Boost 7  ndays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "Πάρτε περισσότερες προβολές κάθε μέρα. Το στοιχείο σας θα εμφανιστεί στις επιλεγμένες θέσεις μέσα στα κορυφαία 30 στοιχεία στην αγορά και κατηγορία. Προωθημένα αντικείμενα περιστρέφονται μεταξύ των καθορισμένων κηλίδων, έτσι ώστε κάθε στοιχείο να κάνει δίκαιη έκθεση.",
    boost_cta: "Πωλούν ταχύτερα",
    boost_terms:
      "Με την ταυτοποίηση της ώθησης, συμφωνείτε με το <U> που αναφέρονται κοντά μου Όροι Παροχής Υπηρεσιών. </ U>",
    boost_best_value: "Η καλύτερη αξία",
    already_boosted: "Αυτό το προϊόν ενισχύεται",
    clicks: "Κλικ",
    impressions: "Εντυπώσεις",
    end: "Τέλος",
    transactions_empty_text:
      "Δεν έχετε ακόμα συναλλαγές ώθησης. Μπορείτε να επισκεφθείτε την καρτέλα Πουλήστε και να αρχίσετε να ενισχύετε τα προϊόντα σας.",
    transactions_loading_error:
      "Δεν μπορείτε να ενημερώσετε τη λίστα συναλλαγών, δοκιμάστε ξανά αργότερα.",
    transactions_history_title: "Ενισχύστε το ιστορικό συναλλαγών",
    communicative_postive: "Ομιλητικός",
    communicative_negative: "Επιφυλακτικός",
    ontime_postive: "Στην ώρα",
    ontime_negative: "αργά",
    reliable_postive: "Αξιόπιστος",
    reliable_negative: "Αναξιόπιστος",
    friendly_postive: "Φιλικός",
    friendly_negative: "Αγενής",
    itemasdescribed_postive: "Στοιχείο όπως περιγράφεται",
    itemasdescribed_negative: "Το αντικείμενο δεν είναι όπως περιγράφτηκε",
    other: "Αλλα",
    submit: "υποβάλλουν",
    adding_rating_reviews: "Προσθήκη αξιολόγησης και αξιολογήσεις",
    no_internet_title: "Δεν υπάρχει σύνδεση στο διαδίκτυο",
    no_internet_message:
      "Βεβαιωθείτε ότι είστε συνδεδεμένοι στο Internet και δοκιμάστε ξανά",
    retry: "Ξαναδοκιμάσετε",
    near_me: "Κοντά μου",
    newest_first: "Νεώτερα πρώτα",
    miles: "μίλια",
    km: "χλμ",
    similar_products: "παρόμοια προϊόντα",
    favorite_products: "Αγαπημένα προϊόντα",
    items_for_sale: "Αντικείμενα προς πώληση",
    joined: "Εντάχθηκαν",
    favorites_transactions_title: "Αγαπημένα",
    boosted_products_transactions_history:
      "Ενισχυμένο ιστορικό συναλλαγών προϊόντων",
    views: "Προβολές",
    boost_graph_title: "Γράφημα",
    no_favorite_products: "Δεν έχετε αγαπημένα προϊόντα",
    make_offer_buy: "θα ήθελα να αγοράσω",
    make_offer_buy_for: "Για",
    notifications: "Ειδοποιήσεις",
    push_notifications: "Σπρώξτε",
    emails_notifications: "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ",
    apply: "Ισχύουν",
    email_messages: "Email για μηνύματα",
    email_new_products: "Email για νέα προϊόντα",
    push_day_only: "Μόνο ημέρα ειδοποιήσεων",
    push_24_hours: "Σπρώξτε ειδοποιήσεις 24 ώρες",
    edit: "Επεξεργασία",
    map: "Χάρτης",
    camera: "ΦΩΤΟΓΡΑΦΙΚΗ ΜΗΧΑΝΗ",
    gallery: "Εκθεσιακός χώρος",
    delete: "Διαγράφω",
    no_sell_items: "Δεν υπάρχουν στοιχεία προς πώληση",
    who_bought_question: "Ποιος το αγόρασε;",
    sold_elsewhere_question: "Το πωλούσε κάπου αλλού",
    confirm: "Επιβεβαιώνω",
    over_limit_camera:
      "Δεν μπορείτε να προσθέσετε περισσότερες από πέντε εικόνες",
    boost_failed: "Η ώθηση απέτυχε. Παρακαλώ προσπάθησε ξανά αργότερα",
    after_purchase: "Πληρωμή επιτυχημένη  nproduct ενισχυμένη",
    pay_failed: "Η πληρωμή απέτυχε. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα",
    done: "Ολοκληρώθηκε",
    not_now: "Οχι τώρα",
    boost: "Ωθηση",
    invalid_zip_code: "Λανθασμένος ταχυδρομικός κώδικας",
    invalid_user_name: "Μη έγκυρο όνομα χρήστη",
    comments: "Σχόλια",
    questions: "Ερωτήματα",
    bug_reports: "Αναφορές σφαλμάτων",
    feature_request: "Αίτημα χαρακτηριστικών",
    feedback_type: "Τύπος ανατροφοδότησης",
    feedback_description:
      "Θα θέλαμε να ακούσουμε τις σκέψεις σας ή τα σχόλιά σας σχετικά με το πώς μπορούμε να βελτιώσουμε την εμπειρία σας!",
    feedback: "Ανατροφοδότηση",
    feedback_text: "Η απάντησή σου",
    suggestions: "Προτάσεις βελτίωσης",
    delete_account: "Διαγραφή λογαριασμού",
    new_message: "Νέο μήνυμα",
    online: "Σε σύνδεση",
    km_50: "50 χλμ",
    km_100: "100 χλμ",
    km_200: "200 χλμ",
    miles_30: "30 μίλια",
    miles_60: "60 μίλια",
    miles_120: "120 μίλια",
    rate_app_question: "Τι γίνεται με μια βαθμολογία στο App Store, τότε;",
    enjoying_question: "Απολαμβάνοντας την εγγραφή κοντά μου;",
    not_enjoy: "Όχι πραγματικά",
    feedback_question: "Θα σας πειράξει να μας δώσετε κάποια σχόλια;",
    yes_sure: "ΕΝΤΑΞΕΙ σίγουρα",
    product_available_question: "Γεια σου, είναι ακόμα διαθέσιμο;",
    buy_question: "Γεια σου, θα ήθελα να το αγοράσω",
    meet_question: "Γεια σου, μπορείτε να συναντήσετε σήμερα;",
    follow: "Ακολουθηστε",
    followers: "Οπαδοί",
    following: "ΕΠΟΜΕΝΟ",
    feedback_thanks: "Ευχαριστούμε για την ανταπόκριση σας",
    all_categories: "Όλες οι κατηγορίες",
    deleted_account: "Αυτός ο λογαριασμός διαγράφεται",
    delete_account_question:
      "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτόν τον λογαριασμό;",
    no_followings: "δεν ακολουθεί κανέναν",
    when_following: "πότε",
    no_followings_subtitle: "ακολουθεί τους ανθρώπους, θα τα δείτε εδώ",
    no_followers: "δεν έχει οπαδούς",
    no_followers_subtitle: "ακολουθούμενη από ανθρώπους, θα τα δείτε εδώ",
    distance: "Απόσταση",
    filter_method: "Μέθοδος φίλτρου",
    see_listings: "Δείτε τις καταχωρήσεις",
    sold: "Πωληθεί",
    bought: "Αγορασμένος",
    no_notifications: "Όταν λαμβάνετε ειδοποιήσεις, θα εμφανιστούν εδώ",
    items_title: "Αντικείμενα",
    new_listing_title: "Δημιουργία νέας λίστας",
    dialog_year_title: "Ετος",
    dialog_make_title: "Φτιαχνω, κανω",
    dialog_model_title: "Μοντέλο",
    dialog_body_style_title: "Τύπος σώματος",
    dialog_exterior_color_title: "Εξωτερικό χρώμα",
    dialog_interior_color_title: "Εσωτερικό χρώμα",
    dialog_transmission_title: "Μετάδοση",
    dialog_fuel_type_title: "Τύπος καυσίμου",
    dialog_owners_num_title: "Αριθμός ιδιοκτητών",
    dialog_vehicle_owed_money_title:
      "Υπάρχουν χρήματα που οφείλονται σε αυτό το όχημα;",
    automatic_transmission: "Αυτόματο",
    manual_transmission: "Εγχειρίδιο",
    not_sure: "Δεν είμαι σίγουρος",
    wagon_hatchback: "Wagon &  Hatchback",
    convertible: "Μετατρέψιμος",
    coupe: "Κουπέ",
    sedan: "Φορείο",
    black_color: "Μαύρος",
    blue_color: "Μπλε",
    brown_color: "καφέ",
    gold_color: "Χρυσός",
    green_color: "Πράσινος",
    grey_color: "Γκρί",
    pink_color: "Ροζ",
    purple_color: "Μωβ",
    red_color: "το κόκκινο",
    silver_color: "Ασήμι",
    orange_color: "Πορτοκάλι",
    white_color: "άσπρο",
    yellow_color: "Κίτρινος",
    charcol_color: "Τσουκόλ",
    fuel_diesel: "Ντίζελ",
    fuel_electric: "Ηλεκτρικός",
    fuel_gasoline: "Βενζίνη",
    fuel_flex: "Καλώδιο",
    fuel_hybrid: "Υβρίδιο",
    fuel_petrol: "Βενζίνη",
    fuel_plugin_hybrid: "Plug-in υβρίδιο",
    truck: "Φορτηγό",
    van_minivan: "Van &  Μιβαβάν",
    suv_crossover: "SUV &  Διασταύρωση",
    awd_4wd: "AWD / 4WD",
    fwd: "Fwd",
    rwd: "Rwd",
    off_white_color: "Υπόλευκο",
    tan_color: "Ηλιοκαμένος",
    beige_color: "Μπεζ",
    burgundy_color: "Βουργουνδία",
    turquoise_color: "Τουρκουάζ",
    title_status_clean: "ΚΑΘΑΡΗ",
    title_status_rebuilt: "Τελείως διορθωμένος",
    title_status_salvage: "Διάσωση",
    title_status_missing: "Λείπει",
    title_status_lien: "Επίσχεση",
    title_status: "Κατάσταση τίτλου",
    mileage: "Απόσταση σε μίλια",
    dialog_drivetrain_title: "Διατραπεύω",
    model_warning: "Επιλέξτε να κάνετε πρώτα",
    required_field_warning: "Αυτό το πεδίο απαιτείται",
    vehicle_vin: "Δειλός",
    invalid_vin: "Μη έγκυρος VIN, ρυθμίστε ξανά το VIN.",
    invalid_mileage:
      "Μη έγκυρο χιλιόμετρα, παρακαλούμε να ρυθμίσετε ξανά το χιλιόμετρο.",
    clean_description: "Τα περισσότερα οχήματα που δεν έχουν ατύχημα",
    rebuilt_description: "Ένα σαλιγκάρι που έχει ξαναχτιστεί",
    salvage_description: "Θεωρείται συνολικά μετά από ένα ατύχημα",
    missing_description: "Θα χρειαστεί ένα νέο τίτλο θέματος DMV",
    lien_description: "Που ανήκει σε τράπεζα ή διακανονισμό δικαστηρίου",
    nearme: "Κοντά μου",
    newest: "Νεότερος",
    contact_support: "Επικοινωνήστε με την υποστήριξη",
    create_home_title: "Σπίτια προς πώληση ή ενοικίαση",
    for_sale: "Προς πώληση",
    for_rent: "Προς ενοικίαση",
    property_type: "Τύπος ιδιοκτησίας",
    apartment: "Διαμέρισμα",
    house: "σπίτι",
    room_only: "ΔΩΜΑΤΙΟ ΜΟΝΟ",
    townhouse: "Αρχοντικό",
    bedrooms: "Υπνοδωμάτια",
    bathrooms: "Μπάνια",
    property_address: "Διεύθυνση ακινήτου",
    price_per_month: "Τιμή ανά μήνα",
    square_feet: "Τετραγωνικά πόδια",
    year_built: "Ετος κατασκευής",
    year_renovated: "Ανακαινισμένο έτος",
    lot_size: "Μέγεθος παρτίδας",
    laundry_type: "Τύπος πλυντηρίου",
    in_unit_laundry: "Πλυντήριο ρούχων",
    laundry_building: "Πλυντήριο σε κτίριο",
    laundry_available: "Διαθέσιμο πλυντήριο",
    none: "Κανένας",
    parking_type: "Τύπος στάθμευσης",
    garage_parking: "Γκαράζ πάρκινγκ",
    street_parking: "Οδός στάθμευσης",
    off_street_parking: "Παρκάρισμα εκτός δρόμου",
    available_parking: "Διατίθεται χώρος στάθμευσης",
    air_cond_type: "Τύπος κλιματισμού",
    ac_available: "AC διαθέσιμο",
    central_ac: "Κεντρικό ac",
    heating_type: "Τύπος θέρμανσης",
    electric_heating: "Ηλεκτρική θέρμανση",
    gas_heating: "Θέρμανση αερίου",
    radiator_heating: "Θέρμανση καλοριφέρ",
    available_heating: "Διαθέσιμο θέρμανση",
    amenities: "Ανεσεις",
    date_available: "ΗΜΕΡΟΜΗΝΙΑ διαθεσιμη",
    lease_length: "Μήκος μίσθωσης",
    month_to_month: "Μήνα σε μήνα",
    three_months: "3 μήνες",
    six_months: "6 μήνες",
    one_year: "1 χρόνος",
    more_one_year: "1+ χρόνια",
    cat_friendly: "Φιλικός γάτα",
    dog_friendly: "Φιλικός σκύλος",
    balcony: "Μπαλκόνι",
    basement: "Υπόγειο",
    bike_parking: "Πάρκινγκ ποδηλάτου",
    cable_tv: "Καλωδιακή τηλεόραση",
    ceiling_fan: "Ανεμιστήρας οροφής",
    concierge: "Θυρωρός",
    dishwasher: "Πλυντήριο πιάτων",
    doorman: "Θυρωρός",
    elevator: "Ανελκυστήρας",
    fireplace: "Τζάκι",
    fitness_center: "Γυμναστήριο",
    garbage_disposal: "Αποκομιδή απορριμμάτων",
    microwave: "ΦΟΥΡΝΟΣ ΜΙΚΡΟΚΥΜΑΤΩΝ",
    online_app: "Online εφαρμογή",
    oven: "Φούρνος",
    package_service: "Υπηρεσία πακέτου",
    patio: "Πλακόστρωτη εσωτερική αυλή",
    pet_park: "Πάρκο κατοικίδιων ζώων",
    refrigerator: "Ψυγείο",
    resident_lounge: "Σαλόνι",
    roof_deck: "Κατάστρωμα οροφής",
    secured_entry: "Εξασφαλισμένη είσοδο",
    storage: "Αποθήκευση",
    walk_in_closet: "Ντουλάπα",
    swimming_pool: "Πισίνα",
    wheelchair_access: "Πρόσβαση με αναπηρικά καροτσάκια",
    central_heating: "Κεντρική θέρμανση",
    invalid_bedrooms: "Μη έγκυρα υπνοδωμάτια, ρυθμίστε ξανά τα υπνοδωμάτια.",
    invalid_bathrooms: "Μη έγκυρα μπάνια, ρυθμίστε ξανά τα μπάνια.",
    chinese_simplified_language: "Απλοποιημένα Κινέζικα",
    chinese_traditional_language: "Παραδοσιακά κινέζικα",
    czech_language: "Τσέχος",
    danish_language: "δανικός",
    dutch_language: "Ολλανδός",
    finnish_language: "φινλανδικός",
    french_language: "γαλλική γλώσσα",
    german_language: "Γερμανός",
    greek_language: "Ελληνικά",
    hungarian_language: "ουγγρικός",
    indonesian_language: "Ινδονησιακός",
    italian_language: "ιταλικός",
    japanese_language: "Ιαπωνικά",
    korean_language: "κορεάτης",
    norwegian_language: "Νορβηγός",
    polish_language: "Στίλβωση",
    portuguese_language: "Πορτογαλικά",
    portuguese_brazilian_language: "Πορτογαλικά, Βραζιλίας",
    romanian_language: "ρουμανικός",
    russian_language: "Ρωσική",
    swedish_language: "Σουηδικά",
    turkish_language: "τούρκικος",
    ukrainian_language: "Ουκρανός",
    urdu_pakistan_language: "Ουρντού (Πακιστάν)",
    vietnamese_language: "Βιετναμέζος",
    category_home_sale_or_rent: "Αρχική σελίδα προς πώληση ή ενοικίαση",
    square_meter: "Τετραγωνικό μέτρο",
    copy_text: "αντίγραφο",
    copyied_to_clipboard: "Αντιγραφή στο πρόχειρο",
    inbox: "Inbox",
    input_title_listening: "Ακούγοντας ...",
    input_subtitle_listening: "Πες κάτι",
    input_title_error: "Συγνώμη, δεν το παίρνουμε αρκετά.",
    input_subtitle_error: "Δοκιμάστε να επαναλάβετε το αίτημά σας.",
    input_hint_error: "Προσπάθησε ξανά",
    price_less_than_or_equal: "Τιμή μικρότερη ή ίση με",
    any_price: "Οποιαδήποτε τιμή",
    any_condition: "Οποιαδήποτε προϋπόθεση",
    any_time: "Οποτεδήποτε",
    days_ago: "μέρες πριν",
    any_distance: "Οποιαδήποτε απόσταση",
    distance_within: "Απόσταση μέσα",
    new_notification: "Νέα ειδοποίηση",
    deleted: "Διαγράφηκε",
    processing_image: "Επεξεργασία εικόνας",
    remove_dialog_message: "Θέλετε πραγματικά να καταργήσετε αυτό το προϊόν;",
    deleted_thread: "Αυτό το μήνυμα διαγράφεται",
    category_yard_sale_event: "Πώληση αυλή",
    yard_first_date: "ΠΩΛΗΣΗ ΠΩΛΗΣΗΣ",
    yard_second_date: "ΠΩΛΗΣΗ ΝΕΑΤΡΙΑΣ ΔΕΥΤΕΡΗ ΗΜΕΡΟΜΗΝΙΑ",
    yard_third_date: "Πώληση αυλή τρίτη ημερομηνία",
    yard_start_time: "Ωρα έναρξης",
    yard_end_time: "Τέλος χρόνου",
    yard_end_timestamp: "Τέλος Timestamp",
    invalid_date1:
      "Μη έγκυρη πρώτη ημερομηνία, ρυθμίστε ξανά την ημερομηνία πρώτης ημερομηνίας",
    invalid_start_time:
      "Μη έγκυρος χρόνος εκκίνησης, ρυθμίστε ξανά το χρόνο εκκίνησης",
    invalid_end_time:
      "Μη έγκυρη ώρα λήξης, ρυθμίστε ξανά το τέλος του χρόνου λήξης",
    yard_sale_title: "Πώληση αυλής",
    garage_tag: "γκαράζ",
    yard_tag: "αυλή",
    from: "Από",
    to: "Προς το",
    block: "ΟΙΚΟΔΟΜΙΚΟ ΤΕΤΡΑΓΩΝΟ",
    un_block: "Ξεβουλώνω",
    sign_email: "Συνδεθείτε με email",
    invalid_first_date:
      "Μη έγκυρη πρώτη ημερομηνία, βεβαιωθείτε ότι η πρώτη ημερομηνία είναι πριν από το δεύτερο και το τρίτο",
    invalid_second_date:
      "Μη έγκυρη δεύτερη ημερομηνία, βεβαιωθείτε ότι η δεύτερη ημερομηνία είναι πριν από την τρίτη ημερομηνία",
    invalid_start_time_value:
      "Μη έγκυρη ώρα έναρξης, βεβαιωθείτε ότι ο χρόνος έναρξης είναι πριν από το τέλος του χρόνου",
    use_default_yard_photo:
      "Χρησιμοποιήστε την προεπιλεγμένη φωτογραφία πώλησης ναυπηγείων",
    active_label: "Ενεργός",
    enable_notifications: "Ενεργοποίηση ειδοποιήσεων",
    login: "Σύνδεση",
    january: "Ιανουάριος",
    february: "Φεβρουάριος",
    march: "Μάρτιος",
    april: "Απρίλιος",
    may: "Ενδέχεται",
    june: "Ιούνιος",
    july: "Ιούλιος",
    august: "Αύγουστος",
    september: "Σεπτέμβριος",
    october: "Οκτώβριος",
    november: "Νοέμβριος",
    december: "Δεκέμβριος",
    since: "Από",
    product_views: "Προβολές προϊόντων",
    shop_views: "Κατάστημα",
    total_sales: "Συνολικές πωλήσεις",
    total_orders: "Συνολικές παραγγελίες",
    last_twelvth_months: "Τελευταία δώδεκα μήνες",
    last_nine_months: "Τελευταίοι εννέα μήνες",
    last_six_months: "Τους τελευταίους έξι μήνες",
    last_three_months: "Τους τελευταίους τρεις μήνες",
    last_12_months: "Τους τελευταίους 12 μήνες",
    last_9_months: "Τους τελευταίους 9 μήνες",
    last_6_months: "Τους τελευταίους 6 μήνες",
    last_3_months: "Τους τελευταίους 3 μήνες",
    months: "Μήνες",
    open: "Ανοιξε",
    reset_password: "Επαναφέρετε τον κωδικό πρόσβασης",
    create_new_shop: "Δημιουργία νέου καταστήματος",
    download_app: "Λήψη εφαρμογής",
    log_in: "Σύνδεση",
    sign_up: "Εγγραφείτε",
    no_result: "Κανένα αποτέλεσμα",
    max_price: "Μέγιστη τιμή",
    max_distance: "Μέγιστη απόσταση",
    max_time: "Μέγιστη ώρα",
    posted_less_than: "Δημοσιεύτηκε λιγότερο από",
    result: "Αποτέλεσμα",
    more: "Περισσότερο",
    or: "Ή",
    password: "Κωδικός πρόσβασης",
    forgot_password: "Ξεχάσατε τον κωδικό?",
    and: "και",
    download_for: "Κατεβάστε για",
    apple_ios: "Μήλο Ίος",
    android: "Ανδροειδής",
    image: "Εικόνα",
    edit_image: "Επεξεργασία εικόνας",
    please_complete: "Παρακαλώ συμπληρώστε",
    enter_your_offer: "Εισάγετε την προσφορά σας",
    categories: "Κατηγορία",
    upload_image: "Μεταφόρτωση εικόνας",
    upload_images: "Μεταφόρτωση εικόνων",
    back: "Πίσω",
    see_more: "Δείτε περισσότερα",
    add_product: "Προσθήκη προϊόντος",
    selected: "Επιλεγμένος",
    create: "Δημιουργώ",
    rate_the_buyer: "Αξιολογήστε τον αγοραστή",
    delete_product: "Διαγραφή προϊόντος",
    product: "Προϊόν",
    un_block_product: "Ξεμπλοκάρισμα προϊόντος",
    share_your_product: "Μοιραστείτε το προϊόν σας",
    boost_details: "Λεπτομέρειες",
    remove_all_products: "Αφαιρέστε όλα τα προϊόντα",
    remove_all: "Αφαίρεση όλων",
    add_vehicle: "Προσθέστε το όχημα",
    edit_vehicle: "Επεξεργασία οχήματος",
    upload_a_photo: "Ανέβασε μια φωτογραφία",
    view_details: "Δείτε λεπτομέρειες",
    add_yard_sale: "Προσθέστε την πώληση αυλής",
    edit_yard_sale: "Επεξεργασία πώλησης αυλής",
    users: "Χρήστες",
    users_details: "Λεπτομέρειες χρηστών",
    users_by_country: "Χρήστες ανά χώρα",
    blocked_users: "Αποκλεισμένοι χρήστες",
    products_cards: "Κάρτες προϊόντων",
    archived_products: "Αρχειοθετημένα προϊόντα",
    blocked_products: "Αποκλεισμένα προϊόντα",
    products_by_country: "Προϊόντα ανά χώρα",
    reports: "Κανω ΑΝΑΦΟΡΑ",
    reports_details: "Αναφορές Λεπτομέρειες",
    closed_reports: "Κλεισμένες αναφορές",
    threads: "Νήματα",
    threads_details: "Λεπτομέρειες θέσεων",
    chat_support: "Υποστήριξη συνομιλίας",
    actions: "Ενέργειες",
    search_actions: "Ενέργειες αναζήτησης",
    product_view_actions: "Προβολή προϊόντων Ενέργειες",
    contact_seller_product: "Επικοινωνήστε με το προϊόν πωλητή",
    contact_owner_shop: "Επικοινωνήστε με το κατάστημα ιδιοκτησίας",
    ratings: "Ακροαματικότητα",
    reviews: "Σχόλια",
    products_all_countries: "Προϊόντα Όλες οι χώρες",
    edit_profile: "Επεξεργασία προφίλ",
    my_profile: "Το ΠΡΟΦΙΛ μου",
    profile_updated_successfully: "Το προφίλ ενημερώθηκε με επιτυχία",
    are_you_sure: "Είσαι σίγουρος",
    my_used_products: "Τα χρησιμοποιημένα προϊόντα μου",
    my_shops: "Τα καταστήματά μου",
    my_boosted_products: "Τα ενισχυμένα προϊόντα μου",
    messages_type_message_here: "Πληκτρολογήστε το μήνυμά σας εδώ",
    messages_product_sold: "Αυτό το προϊόν πωλείται ή αφαιρείται",
    seen: "Δει",
    messages_never_miss_message: "Ποτέ μην χάσετε ένα μήνυμα",
    enable: "επιτρέπω",
    send_notify: "Αποστολή ειδοποίησης",
    un_close: "Ανοίγω",
    type_your_review: "Πληκτρολογήστε την αναθεώρησή σας",
    again_question: "πάλι ?",
    ratings_already_submitted_review: "Έχετε ήδη υποβάλει αναθεώρηση",
    set_product_category: "Ορίστε την κατηγορία προϊόντων",
    auth_email_password_incorrect:
      "Το ηλεκτρονικό σας ταχυδρομείο ή ο κωδικός πρόσβασης εσφαλμένους",
    auth_insert_your_name: "Εισαγάγετε το όνομά σας",
    auth_email_address_badly:
      "Η διεύθυνση ηλεκτρονικού ταχυδρομείου έχει διαμορφωθεί άσχημα",
    auth_email_address_used:
      "Η διεύθυνση ηλεκτρονικού ταχυδρομείου χρησιμοποιείται ήδη από άλλο λογαριασμό",
    auth_invalid_password:
      "Ο κωδικός πρόσβασης πρέπει να είναι τουλάχιστον 6 χαρακτήρες",
    auth_reset_email:
      "Συμπληρώστε το email σας για να επαναφέρετε τον κωδικό πρόσβασής σας",
    auth_check_email:
      "Ελέγξτε το email σας για να επαναφέρετε τον κωδικό πρόσβασης",
    auth_can_sign_in_google: "Μπορείτε να συνδεθείτε με το κουμπί Google",
    auth_do_not_have_account: "Δεν έχετε λογαριασμό;",
    auth_have_account: "Έχετε λογαριασμό;",
    log_terms_privacy_part1:
      "Με την εγγραφή ή τη σύνδεση, συμφωνείτε με το εισηγμένο κοντά μου",
    boost_this_product: "Ενισχύστε αυτό το προϊόν;",
    product_successfully_boosted: "Το προϊόν ενισχύθηκε με επιτυχία",
    product_failed_boost: "Το προϊόν έχει αποτύχει στην Boost",
    no_products_for_sale:
      "Επί του παρόντος, δεν έχετε καμία μεταχειρισμένη προϊόντα που αναφέρονται προς πώληση.",
    not_sold_listed_near_me: "Δεν το αγόρασα στο εισηγμένο κοντά μου",
    agree_add_product:
      "Με την πατώντας το POST για να δημοσιεύσετε το προϊόν σας, συμφωνείτε με τις αναφερόμενες πληροφορίες σχετικά με τους Όρους Παροχής Υπηρεσιών και την Πολιτική Απορρήτου.",
    click_to_boost: "Κάντε κλικ στο προϊόν για να το ενισχύσετε",
    listed_terms_of_service: "Που αναφέρονται κοντά μου Όροι Παροχής Υπηρεσιών",
    receive_emails_for_users:
      "Λάβετε μηνύματα ηλεκτρονικού ταχυδρομείου για μηνύματα χρηστών",
    receive_emails_for_newly_posted:
      "Λάβετε μηνύματα ηλεκτρονικού ταχυδρομείου για τα πρόσφατα δημοσιευμένα προϊόντα σας",
    disable_push_notifications: "Απενεργοποιήστε τις ειδοποιήσεις ώθησης",
    sms_during_day: "Λάβετε SMS κατά τη διάρκεια της ημέρας",
    sms_24_hours: "Λάβετε SMS 24 ώρες",
    products: "Προϊόντα",
    product_no_longer_available:
      "Συγγνώμη, αυτό το προϊόν δεν είναι πλέον διαθέσιμο",
    add_home: "Προσθέστε το σπίτι",
    edit_home: "Επεξεργασία στο σπίτι",
    fill_required_fields: "Συμπληρώστε όλα τα απαιτούμενα πεδία",
    no_notification: "Δεν υπάρχουν ειδοποιήσεις",
    orders_history: "Ιστορικό παραγγελιών",
    privacy: "Μυστικότητα",
    terms: "Οροι",
    report_a_problem: "Αναφέρω ένα πρόβλημα",
    approximation_protect_user_privacy:
      "Προσέγγιση για την προστασία της ιδιωτικής ζωής του χρήστη",
    do_not_have_products: "Δεν έχετε προϊόντα",
    emails: "Μηνύματα ηλεκτρονικού ταχυδρομείου",
    lead_deletion_products:
      "Αυτό θα οδηγήσει στη διαγραφή όλων των προϊόντων σας",
    confirm_legal_message:
      "Είστε αποκλειστικά υπεύθυνοι για τη λήψη όλων των απαραίτητων προφυλάξεων όταν αλληλεπιδράστε με άλλους, ιδιαίτερα όταν συναντήσετε έναν ξένο προσωπικό για πρώτη φορά. Ανατρέξτε στους Όρους Παροχής Υπηρεσιών για περισσότερες λεπτομέρειες.",
    push_notifications_notified_instantly:
      "Ενεργοποιήστε τις ειδοποιήσεις ώθησης να ενημερώνονται άμεσα",
    rate_seller: "Πωλητής Πωλητής",
    user_journey: "Ταξίδι χρήστη",
    user: "Χρήστης",
    user_id: "Ταυτότητα χρήστη",
    action_id: "Id δράσης",
    select_model_car: "Επιλέξτε μοντέλο αυτοκινήτου",
    boost_1_day: "Ενισχύστε 1 ημέρα",
    boost_3_days: "Ενισχύστε 3 ημέρες",
    boost_7_days: "Ενισχύστε 7 ημέρες",
    agree_boost_terms: "Με την κτύπημα της ώθησης, συμφωνείτε να",
    add: "Προσθήκη",
    add_tag: "Προσθήκη ετικέτας",
    brand_title: "Μάρκα",
    category_mobiles: "Κινητά",
    category_tablets: "Δισκία",
    screen_size: "Μέγεθος οθόνης",
    has_cellular_capability: "Έχει κυτταρική ικανότητα",
    default_internal_memory: "Εσωτερική μνήμη",
    network_carrier: "Μεταφορέας δικτύου",
    is_unlocked: "Είναι ξεκλείδωτη",
    mobile_model_warning: "Επιλέξτε πρώτα το εμπορικό σήμα",
    missing_image: "Λείπει η εικόνα, δοκιμάστε να προσθέσετε ξανά την εικόνα.",
    add_mobile: "Προσθέστε κινητό",
    edit_mobile: "Επεξεργασία κινητού",
    add_tablet: "Προσθέστε tablet",
    edit_tablet: "Επεξεργασία δισκίου",
    keywords:
      "Αγορές, αγοράστε, πωλούν, κερδίστε χρήματα, εμπόριο, ντόπιοι, γείτονες, αυτόματα, οχήματα",
    country: "Χώρα",
    phone_number: "Τηλεφωνικό νούμερο",
    verification_code: "Κωδικός επαλήθευσης",
    error_occurred: "Προκλήθηκε σφάλμα. Παρακαλώ προσπαθήστε ξανά αργότερα",
    invalid_state:
      "Μη έγκυρη κατάσταση: λήψη κλήσης σύνδεσης, αλλά δεν αποστέλλεται αίτημα σύνδεσης.",
    sign_in: "Συνδεθείτε",
    sign_in_apple: "Συνδεθείτε με την Apple",
    sign_in_google: "Σύνδεση με το Google",
    sign_in_phone: "Συνδεθείτε με το τηλέφωνο",
    sign_in_facebook: "Σύνδεση με Facebook",
    create_account: "Δημιουργία λογαριασμού",
    email: "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ",
    invalid_field: "Συμπληρώστε τα απαιτούμενα πεδία",
    code_sent: "Ο κώδικας έχει σταλεί από SMS",
    verify_number: "Επαληθεύστε τον αριθμό τηλεφώνου",
    tapping_verify_number:
      "Πατώντας (επαληθεύστε τον αριθμό τηλεφώνου), αποστέλλονται ένα SMS.",
    email_exists:
      "Ο λογαριασμός υπάρχει ήδη και πρέπει να έχετε πρόσβαση μέσω του κουμπιού Google, το κουμπί Facebook ή το κουμπί της Apple",
    ok: "Εντάξει",
    sure_back: "Είστε σίγουροι να επιστρέψετε;",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "πριν",
    add_model: "Προσθήκη μοντέλου",
    no_search_results_us:
      "Δεν υπάρχουν αποτελέσματα αναζήτησης κοντά σας σε απόσταση 120 μιλίων. Προσπαθήστε να αλλάξετε το φίλτρο αναζήτησης ή τη λέξη -κλειδί αναζήτησης.",
    no_search_results:
      "Δεν υπάρχουν αποτελέσματα αναζήτησης κοντά σας σε απόσταση 200 χλμ. Προσπαθήστε να αλλάξετε το φίλτρο αναζήτησης ή τη λέξη -κλειδί αναζήτησης.",
    plan_date: "Ημερομηνία σχεδίου",
    plan_time: "Χρόνος προγραμματισμού",
    invalid_plan_date:
      "Μη έγκυρη ημερομηνία σχεδίου, Ρυθμίστε ξανά την ημερομηνία του σχεδίου",
    invalid_plan_time:
      "Μη έγκυρος χρόνος σχεδίου, Ρυθμίστε ξανά το σχέδιο του σχεδίου",
    plan_name: "Όνομα σχεδίου",
    plan_title: "Σχέδιο",
    update_plan_name: "Όνομα σχεδίου ενημέρωσης",
    delete_plan_question:
      "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το σχέδιο;",
    plan_reminder_message: "Θα σας υπενθυμίσουμε μια ώρα πριν",
    plan_dialog_title: "Σχέδιο συνάντησης",
    planners_title: "Σχεδιαστές",
    unable_sending_messages:
      "Θα δουν τα μηνύματά σας όταν επιστρέφουν στο διαδίκτυο.",
    its_text: "Του",
    for_your_text: "για τον δέκτη σας.",
  },
  hu: {
    invalid_area: "Érvénytelen terület, kérjük, állítsa be a területet.",
    invalid_lot_size:
      "Érvénytelen tulajdonságok tételmérete, kérjük, állítsa be a sok méretet.",
    property_area: "Ingatlanterület",
    app_store_name:
      "Közelében szerepel - vásároljon használt termékeket, eladó készpénzt",
    app_store_short:
      "A helyi eladók piacát. Soroljon meg egy eladási elemet és pénzt.",
    app_store_full:
      "A közeljövőben felsorolva könnyű megtalálni a nagyszerű ajánlatokat a kívánt dolgokat, és pénzt keres az eladni kívánt dolgokra. Ez a legjobb módja annak, hogy vásároljon és eladjon a közösségben vagy a környéken, akikkel bízhatsz. Hogyan működik: 1 - Vásároljon vagy adjon el semmit; Könnyen írja be az elemeket az eladásra másodpercenként. 2- Nagyszerű ajánlatokat talál és kedvezményekkel ruhák, bútorok, mobiltelefonok, elektronika, baba és gyerek elemeket, sporteszköz, használt autók, ruhák, cipők, és órák, könyvek, használt játékok, használt laptopok, egy használt autót, és még igazi ingatlan eladó vagy bérleti díj. 3- Tallózás helyi elemek eladása. 4- Üzenetvásárlók és eladók az alkalmazáson belül. 5 - Böngésszen az elemeket képzel és rendezés szerint. Szórakoztató tények a közeljövőben felsoroltak: 1- A közeljövőben felsorolt, könnyen eladhatsz semmit, a ruhától az autók elektronikára. 2- A vevők és az eladók közötti kommunikáció az alkalmazáson keresztül történik az alkalmazáson keresztül. 3- A közeljövőben felsorolt, mint egy garázs értékesítés; Keresse meg mindent, amit szeretne kedvezményen, közvetlenül a telefonján vagy a táblagépen.",
    app_store_release:
      "A közelben szerepel - kereskedelem a helyiekkel. Csatlakozzon a helyi vásárlók és eladók mobil piacán!",
    app_name: "A közeljövőben szerepel",
    title_buy: "megvesz",
    title_messages: "üzenetek",
    title_sell: "Elad",
    title_profile_image: "Profilkép",
    title_account: "Számla",
    account_settings: "Fiók beállítások",
    settings: "Beállítások",
    color_theme: "Színes téma",
    device_settings: "Eszköz beállítások",
    public_profile: "Nyilvános profil",
    light_mode: "Könnyű mód",
    dark_mode: "Sötét mód",
    title_sell_faster: "Gyorsabban értékesít",
    send_button_label: "Küld",
    rate_message: "Szavazz rám...",
    already_rated: "Ön már benyújtotta az áttekintést",
    rate_review_question: "Szeretne foglalkozni",
    again: "újra?",
    action_logout: "Kijelentkezés",
    action_category: "Kategória",
    action_search: "Keresés",
    action_refer: "Hivatkozzon egy barátra",
    dialog_choose_location: "Válassza ki a helyet",
    dialog_change_username: "A felhasználónév módosítása",
    dialog_change_language: "Válts nyelvet",
    dialog_image_tags: "Képcímkék",
    dialog_emails_notifications: "E-mailes értesítések",
    dialog_push_notifications: "Értesítések",
    fragment_product_detail: "Termék leírás",
    fragment_message_details: "Üzenetek részletei",
    fragment_sell: "Elad",
    dialog_tags_title: "Címkék",
    dialog_location_title: "Frissítés helye",
    dialog_username_title: "A felhasználónév módosítása",
    tab_photo: "Fénykép",
    tab_details: "Részletek",
    tab_price: "Ár",
    tab_finish: "Befejez",
    profile: "Profil",
    search: "Keresés",
    choose_product: "Válassza ki a terméket",
    rating_review: "Értékelés és felülvizsgálat",
    select_buyer: "Válasszon egy vevőt",
    tab_my_used_products: "Termékeim",
    price_label: "Ár",
    text_savings: "Mentés",
    search_hint: "Termékek keresése ...",
    empty_text:
      "A kategóriában vagy a kiválasztott távolságon belül nincsenek felsorolva.",
    filter_menu_text: "Szűrő",
    error_contacting_seller: "Hiba lépjen kapcsolatba az eladóval",
    edit_product: "Termék szerkesztése",
    contact_seller: "Kapcsolatfelvétel az eladóval",
    signup_to_contact_seller: "Iratkozzon fel az eladóra",
    signup_to_make_offer: "Iratkozzon fel az ajánlatra",
    product_details: "Részletek",
    product_category: "Kategória",
    product_condition: "Feltétel",
    product_description: "Leírás",
    product_location: "Termékhely",
    product_location_approximate: "A helyszín hozzávetőleges",
    over_week_time_ago: "Több mint egy héttel ezelőtt",
    boosted: "Megnövelt",
    threads_no_results: "Nincs üzenet",
    message_no_results: "Nincs üzenet",
    message_warning:
      "Ön kizárólag a felelős az összes szükséges óvintézkedés megtételéért, amikor másokkal kapcsolatba lép, különösen akkor, ha első alkalommal személyesen találkozik egy idegennel. Kérjük, ne ossza meg személyes információkat, ellenőrzési kódokat vagy fizetési információkat. Kérjük, olvassa el a szolgáltatási feltételeket további részletekért.",
    message_block: "Ebben az időben nem tud üzeneteket küldeni vagy fogadni.",
    select_location: "Válassza ki a helyet",
    location_permission_denied_message:
      "Az alkalmazásnak helye engedélyt igényel a megfelelő működéshez.",
    signed_in: "Bejelentkezett!",
    sign_in_canceller: "Bejelentkezés törölt",
    version: "Változat",
    build: "Épít",
    name: "Név",
    location: "Elhelyezkedés",
    language: "Nyelv",
    about_app: "A közelben szerepel",
    terms_of_service: "Szolgáltatás feltételei",
    privacy_policy: "Adatvédelmi irányelvek",
    report_feedback: "Visszajelzés küldése",
    report_bug: "Rázza a telefont, hogy jelentse a hibát",
    change_image: "Kép módosítása",
    update_location: "Frissítés helye",
    about_the_app: "Az alkalmazásról",
    update_label: "Frissítés",
    uploading: "Feltöltés",
    adding: "Listázás hozzáadása",
    removing: "A lista eltávolítása",
    updating: "Lista frissítése",
    uploaded_image: "Feltöltött kép:",
    image_storage_failed: "Nem sikerült tárolni a képet:",
    product_updated: "A termék sikeresen frissül",
    location_error: "A helyszín nem mentett, próbálkozzon újra",
    product_removed: "A termék sikeresen eltávolított",
    deleted_product: "Ez a termék törlődik",
    invalid_title: "Érvénytelen cím, kérjük, állítsa újra a címet.",
    invalid_image: "Érvénytelen képút, próbálja meg újra a képet.",
    invalid_price: "Érvénytelen ár, kérjük, állítsa újra az árat.",
    invalid_location: "Érvénytelen hely, kérjük, állítsa be a helyet.",
    invalid_category:
      "Érvénytelen kategória, kérjük, állítsa újra a kategóriát.",
    invalid_condition:
      "Érvénytelen állapot, kérjük, állítsa újra az állapotot.",
    removing_title: "A profilkép eltávolítása",
    image_not_saved: "A kép mentése sikertelen!",
    product_load_failed: "Nincs termék",
    take_photo: "Fotót készíteni",
    select_photo: "Válasszon fotót",
    product_title_hint: "Mi az? Név, márka, modell stb.",
    delete_photo: "Fotó törlése",
    product_title: "Cím",
    mark_as_sold: "Mark, ahogy eladott",
    product_share: "Részvény",
    product_make_offer: "Ajánlatot tenni",
    product_cover: "Állítsa be a fedőlapként",
    product_tags: "Címkék",
    product_posted: "Posted:",
    product_change: "változás",
    product_post: "Posta",
    product_selling_from: "Eladás a helyről",
    product_select_location: "Válassza ki a helyet",
    product_map_approximate:
      "A térkép hozzávetőleges, hogy megtartsa az eladó helyét",
    product_terms:
      "Ha megérinti az üzenetet, hogy közzétegye a terméket, egyetért azzal, hogy <u> felsorolja a szolgáltatási feltételeket. </ U>",
    condition_other: "Egyéb (lásd Leírás)",
    condition_for_parts: "Részekre",
    condition_used: "Használt (normál kopás)",
    condition_open_box: "Nyitott doboz (soha nem használt)",
    condition_reconditioned: "Felújított / tanúsított",
    condition_new: "Új (soha nem használt)",
    select_category: "Válassz kategóriát",
    select_all_category: "Mindet kiválaszt",
    category_loading_error:
      "Nem tudja frissíteni a kategóriák listáját, próbálkozzon újra később.",
    category_vehicles: "Járművek",
    category_furniture: "Bútor",
    category_electronics: "Elektronika",
    category_appliances: "Otthon &  Készülékek",
    category_fashion_accessories: "Divat &  kiegészítők",
    category_baby_kids: "Baba &  Gyerekek",
    category_antiques_collectibles: "Antiques &  Kollekció",
    category_auto_parts_tools_machinery: "Autóalkatrészek, eszközök &  Gépezet",
    category_sports_outdoors: "Sport &  Szabadban",
    category_others: "Mások",
    location_enter_zip_code: "Adja meg az irányítószámot",
    location_get_current_location: "Az aktuális hely megszerzése",
    location_select_location: "Válassza ki a helyet",
    location_update_location: "Frissítés helye",
    location_new_location: "Új hely",
    search_filter_results: "Szűrés eredményei",
    search_filter_min: "Minimális szűrés",
    search_filter_at_least: "Legalább",
    price_filter: "Árszűrő",
    product_name: "termék név",
    english_language: "angol",
    arabic_language: "arab",
    spanish_language: "spanyol",
    system_language: "Rendszer",
    share_link: "Hivatkozás megosztása",
    save: "Megment",
    cancel: "Megszünteti",
    loading: "Betöltés",
    yes: "Igen",
    no: "Nem",
    report: "Jelentés",
    report_product: "Jelentés",
    report_user: "Felhasználó bejelentése",
    block_user: "Felhasználó letiltása",
    un_block_user: "Felhasználó feloldása",
    why_product: "Miért szeretné jelenteni ezt az elemet?",
    why_user: "Miért szeretné jelenteni ezt a felhasználót?",
    block_user_confirm: "Szeretné véglegesen blokkolni ezt a felhasználót?",
    un_block_user_confirm: "Szeretné véglegesen feloldani ezt a felhasználót?",
    prohibited: "Tiltott a közeljövőben",
    offensive: "Sértő vagy nem megfelelő",
    duplicate: "Duplicate Post",
    wrong_category: "Rossz kategória",
    scam: "Úgy néz ki, mint egy átverés",
    stolen: "Azt hiszem, ellopják",
    product_other: "Egyéb",
    product_is_sold: "Ezt a terméket értékesítették",
    missed_meeting: "Hiányozták a találkozót",
    low_offer: "Alacsony ajánlatot tett",
    rude: "Durva vagy nem megfelelő",
    items: "Probléma elemekkel",
    trouble_meetup: "Bajban van",
    messaging: "Üzenetek problémái",
    user_other: "Egyéb",
    new_version_available: "Új verzió elérhető",
    please_update_app:
      "Kérjük, frissítse az alkalmazást az új verzióra a folytatáshoz.",
    update: "Frissítés",
    no_thanks: "Nem köszönöm",
    contact_support_confirmation:
      "Az aktuális válaszidő 24-48 óra. Szeretne kapcsolatba lépni a közeljövőben az App Chat támogatása?",
    unboost_confirmation:
      "Biztos benne, hogy el akarja használni ezt a terméket?",
    no_used_products: "Még nincsenek listája",
    no_boosted_products: "Nincs erősített terméke",
    next: "Következő",
    previous: "Előző",
    skip: "Ugrik",
    start: "Rajt",
    list_used: "Soroljon fel egy használt terméket",
    buy_description:
      "Fedezze fel és keressen a szomszédok által kínált termékeket",
    sell_description:
      "Sorolja fel azokat a termékeket, amelyeket már nem kell eladni",
    list_used_description:
      "Soroljon fel egy használt terméket eladása kevesebb, mint 20 másodperc alatt",
    boost_product_option_1: "<b> 1 Nday </ Nday </ b>  n  n <b> $ 0.99 </ b>",
    boost_product_option_2: "<b> Boost 3  NDays </ b>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<b> Boost 7 Ndays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "Minden nap további nézetet kap. Az elem megjelenik a kiemelt pozíciókban a vásárlási és kategóriában található legjobb 30 tételben. A támogatott elemeket a kijelölt foltok között forgatják, így minden tétel tisztességes expozíciót kap.",
    boost_cta: "Gyorsabban értékesít",
    boost_terms:
      "A Boost megérintésével egyetért azzal, hogy <u> a Szolgáltatási feltételek közé tartozik. </ U>",
    boost_best_value: "Legjobb ár-érték",
    already_boosted: "Ez a termék növekszik",
    clicks: "Kattintás",
    impressions: "Benyomások",
    end: "Vége",
    transactions_empty_text:
      "Még nincsenek fellendülési tranzakciók. Látogasson el az eladási lapot, és elkezdheti növelni a termékeit.",
    transactions_loading_error:
      "Nem tudja frissíteni a tranzakciók listáját, kérjük, próbálja újra később.",
    transactions_history_title: "Boost tranzakciók története",
    communicative_postive: "Kommunikációs",
    communicative_negative: "Zárkózott",
    ontime_postive: "Időben",
    ontime_negative: "Késő",
    reliable_postive: "Megbízható",
    reliable_negative: "Megbízhatatlan",
    friendly_postive: "Barátságos",
    friendly_negative: "Udvariatlan",
    itemasdescribed_postive: "Leírás szerinti áru",
    itemasdescribed_negative: "Az elem nem a leírtak szerint",
    other: "Egyéb",
    submit: "Beküldés",
    adding_rating_reviews: "Értékelések és vélemények hozzáadása",
    no_internet_title: "Nincs internetkapcsolat",
    no_internet_message:
      "Győződjön meg róla, hogy csatlakozik az internethez, és próbálja újra",
    retry: "Próbálja újra",
    near_me: "Közel hozzám",
    newest_first: "Legújabb",
    miles: "mérföld",
    km: "KM",
    similar_products: "Hasonló termékek",
    favorite_products: "Kedvenc termékek",
    items_for_sale: "eladó dolgok",
    joined: "Csatlakozott",
    favorites_transactions_title: "Kedvencek",
    boosted_products_transactions_history:
      "Növelt termékek tranzakciók története",
    views: "Nézetek",
    boost_graph_title: "Boost Graph",
    no_favorite_products: "Nincs kedvenc terméke",
    make_offer_buy: "szeretnék venni",
    make_offer_buy_for: "mert",
    notifications: "Értesítések",
    push_notifications: "Nyom",
    emails_notifications: "Email",
    apply: "Alkalmaz",
    email_messages: "E-mail üzenetek",
    email_new_products: "E-mail az új termékekhez",
    push_day_only: "Csak az értesítések napja",
    push_24_hours: "Nyomja meg az értesítéseket 24 órán keresztül",
    edit: "Szerkesztés",
    map: "Térkép",
    camera: "Kamera",
    gallery: "Képtár",
    delete: "Töröl",
    no_sell_items: "Nincs eladási tétel",
    who_bought_question: "Ki vásárolta meg?",
    sold_elsewhere_question: "Valahol eladta máshol",
    confirm: "megerősít",
    over_limit_camera: "Nem lehet hozzáadni több mint öt képet",
    boost_failed: "Boost sikertelen. Kérlek, próbáld újra később",
    after_purchase: "Fizetés sikeres  nproduct boosted",
    pay_failed: "Fizetés meghiúsult. Kérlek próbáld újra",
    done: "Kész",
    not_now: "Nem most",
    boost: "Lendület",
    invalid_zip_code: "Érvénytelen irányítószám",
    invalid_user_name: "Érvénytelen felhasználónév",
    comments: "Hozzászólások",
    questions: "Kérdések",
    bug_reports: "Hibajelentések",
    feature_request: "Szolgáltatáskérés",
    feedback_type: "Visszajelzés típus",
    feedback_description:
      "Szeretnénk hallani a gondolataidat vagy visszajelzést arról, hogy hogyan javíthatjuk tapasztalatait!",
    feedback: "Visszacsatolás",
    feedback_text: "A válaszod",
    suggestions: "Javaslatok javításra",
    delete_account: "Fiók törlése",
    new_message: "Új üzenet",
    online: "Online",
    km_50: "50 km",
    km_100: "100 km",
    km_200: "200 km",
    miles_30: "30 mérföld",
    miles_60: "60 mérföld",
    miles_120: "120 mérföld",
    rate_app_question: "Mit szólnál egy minősítés az App Store-ban?",
    enjoying_question: "Élvezi a közeljövőben?",
    not_enjoy: "Nem igazán",
    feedback_question: "Bánná, hogy visszajelzést ad nekünk?",
    yes_sure: "Oké, rendben",
    product_available_question: "Szia, ez még mindig elérhető?",
    buy_question: "Szia, szeretném megvenni ezt",
    meet_question: "Szia, ma találkozhatsz ma?",
    follow: "Kövesse",
    followers: "Követő",
    following: "Következő",
    feedback_thanks: "Köszönjük a visszajelzését",
    all_categories: "Minden kategória",
    deleted_account: "Ez a fiók törlődik",
    delete_account_question: "Biztosan törölni szeretné ezt a fiókot?",
    no_followings: "nem követi senkit",
    when_following: "mikor",
    no_followings_subtitle: "az embereket követi, itt fogod látni őket",
    no_followers: "nem lesz követői",
    no_followers_subtitle: "ezt követi az emberek, akkor látni fogod őket itt",
    distance: "Távolság",
    filter_method: "Szűrő módszer",
    see_listings: "Lásd a listákat",
    sold: "Eladott",
    bought: "Megvásárolt",
    no_notifications: "Amikor értesítéseket kapsz, itt jelennek meg",
    items_title: "Elemek",
    new_listing_title: "Új lista létrehozása",
    dialog_year_title: "Év",
    dialog_make_title: "Készít",
    dialog_model_title: "Modell",
    dialog_body_style_title: "Teststílus",
    dialog_exterior_color_title: "Külső szín",
    dialog_interior_color_title: "Belső szín",
    dialog_transmission_title: "Terjedés",
    dialog_fuel_type_title: "Üzemanyagtípus",
    dialog_owners_num_title: "A tulajdonosok száma",
    dialog_vehicle_owed_money_title: "Van-e pénz még mindig ezen a járműben?",
    automatic_transmission: "Automatikus",
    manual_transmission: "Kézikönyv",
    not_sure: "Nem biztos",
    wagon_hatchback: "Kocsi és  Hatándulás",
    convertible: "Átváltható",
    coupe: "Kupé",
    sedan: "Szedán",
    black_color: "Fekete",
    blue_color: "Kék",
    brown_color: "Barna",
    gold_color: "Arany",
    green_color: "Zöld",
    grey_color: "Szürke",
    pink_color: "Rózsaszín",
    purple_color: "Lila",
    red_color: "Piros",
    silver_color: "Ezüst",
    orange_color: "narancs",
    white_color: "fehér",
    yellow_color: "Sárga",
    charcol_color: "Káros",
    fuel_diesel: "Dízel",
    fuel_electric: "Elektromos",
    fuel_gasoline: "Benzin",
    fuel_flex: "Flex",
    fuel_hybrid: "Hibrid",
    fuel_petrol: "Benzin",
    fuel_plugin_hybrid: "Plug-in hibrid",
    truck: "Kamion",
    van_minivan: "Van &  Minivan",
    suv_crossover: "SUV &  Crossover",
    awd_4wd: "AWD / 4WD",
    fwd: "Fwd",
    rwd: "Rwd",
    off_white_color: "Fehér",
    tan_color: "Cser",
    beige_color: "Bézs",
    burgundy_color: "Burgundia",
    turquoise_color: "Türkiz",
    title_status_clean: "Tiszta",
    title_status_rebuilt: "Újjáépített",
    title_status_salvage: "Mentés",
    title_status_missing: "Hiányzó",
    title_status_lien: "Zálogjog",
    title_status: "Címállapot",
    mileage: "Kilométer",
    dialog_drivetrain_title: "Drivetrain",
    model_warning: "Kérjük, válassza az Először",
    required_field_warning: "Ez a mező kötelező",
    vehicle_vin: "Vin",
    invalid_vin: "Érvénytelen Vin, kérjük, állítsa újra a VIN-t.",
    invalid_mileage:
      "Érvénytelen kilométer, kérjük, állítsa újra a futásteljesítményt.",
    clean_description: "A legtöbb olyan jármű, amely nem volt balesetben",
    rebuilt_description: "Egy megmentett autó, amelyet átépítettek",
    salvage_description: "Baleset után összpontosították",
    missing_description: "Szüksége lesz egy új DMV kérdésre",
    lien_description: "Bank vagy bírósági elszámolás tulajdonosa",
    nearme: "Közel hozzám",
    newest: "Legújabb",
    contact_support: "Kapcsolatfelvétel",
    create_home_title: "Eladó lakások vagy bérleti díj",
    for_sale: "Eladó",
    for_rent: "Kiadó",
    property_type: "Tulajdonságtípus",
    apartment: "Lakás",
    house: "Ház",
    room_only: "Csak szoba",
    townhouse: "Városház",
    bedrooms: "Hálószobák",
    bathrooms: "Fürdőszoba",
    property_address: "Ingatlancím",
    price_per_month: "Ár havonta",
    square_feet: "Négyzetméter",
    year_built: "Építés éve",
    year_renovated: "Felújított év",
    lot_size: "Telekméret",
    laundry_type: "Mosoda típus",
    in_unit_laundry: "Egységnyi mosoda",
    laundry_building: "Mosoda az épületben",
    laundry_available: "Mosoda áll rendelkezésre",
    none: "Egyik sem",
    parking_type: "Parkolás típusa",
    garage_parking: "Garázs parkoló",
    street_parking: "Utcai parkolás",
    off_street_parking: "Nem utcán parkolás",
    available_parking: "Parkolás elérhető",
    air_cond_type: "Légkondicionáló típusa",
    ac_available: "AC áll rendelkezésre",
    central_ac: "Központi AC",
    heating_type: "Fűtési típusa",
    electric_heating: "Elektromos fűtés",
    gas_heating: "Gázmelegítés",
    radiator_heating: "Radiátorfűtés",
    available_heating: "Fűtés rendelkezésre áll",
    amenities: "Felszerelés",
    date_available: "Elérhető időpont",
    lease_length: "Lízinghossz",
    month_to_month: "Hónapról hónapra",
    three_months: "3 hónap",
    six_months: "6 hónap",
    one_year: "1 év",
    more_one_year: "1+ év",
    cat_friendly: "Macskabarát",
    dog_friendly: "Kutyabarát",
    balcony: "Erkély",
    basement: "Pince",
    bike_parking: "Kerékpáros parkoló",
    cable_tv: "Kábel TV",
    ceiling_fan: "Mennyezeti ventilátor",
    concierge: "Portás",
    dishwasher: "Mosogatógép",
    doorman: "Portás",
    elevator: "Lift",
    fireplace: "Kandalló",
    fitness_center: "Edzőterem",
    garbage_disposal: "Hulladék megsemmisítés",
    microwave: "mikrohullámú sütő",
    online_app: "Online alkalmazás",
    oven: "Sütő",
    package_service: "Csomagszolgáltatás",
    patio: "Terasz",
    pet_park: "Kisállatpark",
    refrigerator: "Hűtőszekrény",
    resident_lounge: "Rezidens társalgó",
    roof_deck: "Tetőterasz",
    secured_entry: "Biztosított bejárat",
    storage: "Tárolás",
    walk_in_closet: "Gardróbszoba",
    swimming_pool: "Úszómedence",
    wheelchair_access: "Kerekesszékkel közlekedők számára is hozzáférhető",
    central_heating: "Központi fűtés",
    invalid_bedrooms:
      "Érvénytelen hálószobák, kérjük, állítsa be a hálószobákat.",
    invalid_bathrooms:
      "Érvénytelen fürdőszobák, kérjük, állítsa be újra a fürdőszobákat.",
    chinese_simplified_language: "Kínai egyszerűsített",
    chinese_traditional_language: "Kínai (hagyományos",
    czech_language: "cseh",
    danish_language: "dán",
    dutch_language: "holland",
    finnish_language: "finn",
    french_language: "Francia",
    german_language: "német",
    greek_language: "görög",
    hungarian_language: "Magyar",
    indonesian_language: "indonéz",
    italian_language: "olasz",
    japanese_language: "japán",
    korean_language: "koreai",
    norwegian_language: "norvég",
    polish_language: "fényesít",
    portuguese_language: "portugál",
    portuguese_brazilian_language: "Portugál, brazil",
    romanian_language: "román",
    russian_language: "orosz",
    swedish_language: "svéd",
    turkish_language: "török",
    ukrainian_language: "ukrán",
    urdu_pakistan_language: "Urdu (Pakisztán)",
    vietnamese_language: "vietnami",
    category_home_sale_or_rent: "Eladó vagy bérleti díj",
    square_meter: "Négyzetméter",
    copy_text: "Másolat",
    copyied_to_clipboard: "A vágólapra másolt",
    inbox: "Postafiók",
    input_title_listening: "Hallgatás ...",
    input_subtitle_listening: "Mondj valamit",
    input_title_error: "Sajnáljuk, nem kaptuk meg.",
    input_subtitle_error: "Próbálja meg megismételni a kérését.",
    input_hint_error: "Próbáld újra",
    price_less_than_or_equal: "Az ár kevesebb vagy egyenlő",
    any_price: "Bármilyen ár",
    any_condition: "Bármilyen feltétel",
    any_time: "Bármikor",
    days_ago: "napja",
    any_distance: "Bármilyen távolság",
    distance_within: "Távolság",
    new_notification: "Új értesítés",
    deleted: "Törölve",
    processing_image: "Feldolgozó kép",
    remove_dialog_message: "Tényleg eltávolítani szeretné ezt a terméket?",
    deleted_thread: "Ez az üzenet törlődik",
    category_yard_sale_event: "Yard Sale Event",
    yard_first_date: "Udvari eladás első dátuma",
    yard_second_date: "Yard Sale második dátum",
    yard_third_date: "Udvari eladás harmadik dátuma",
    yard_start_time: "Kezdési idő",
    yard_end_time: "Idő vége",
    yard_end_timestamp: "Végső időbélyeg",
    invalid_date1:
      "Érvénytelen első dátum, kérjük, állítsa újra az első dátumot",
    invalid_start_time:
      "Érvénytelen kezdési idő, kérjük, állítsa újra a kezdési időt",
    invalid_end_time:
      "Érvénytelen befejezési idő, kérjük, állítsa újra a végidőt",
    yard_sale_title: "Hajógyár eladás",
    garage_tag: "garázs",
    yard_tag: "udvar",
    from: "Tól től",
    to: "Nak nek",
    block: "Blokk",
    un_block: "Feloldás",
    sign_email: "Jelentkezzen be e-mailben",
    invalid_first_date:
      "Érvénytelen első dátum, kérjük, győződjön meg róla, hogy az első dátum második és harmadik",
    invalid_second_date:
      "Érvénytelen második dátum, kérjük, győződjön meg róla, hogy a második dátum harmadik dátum előtt van",
    invalid_start_time_value:
      "Érvénytelen kezdési idő, kérjük, győződjön meg róla, hogy a kezdő idő az idő előtt van",
    use_default_yard_photo: "Használja az alapértelmezett udvar eladási fotót",
    active_label: "Aktív",
    enable_notifications: "Értesítések engedélyezése",
    login: "Belépés",
    january: "január",
    february: "február",
    march: "március",
    april: "április",
    may: "Lehet",
    june: "június",
    july: "július",
    august: "augusztus",
    september: "szeptember",
    october: "október",
    november: "november",
    december: "december",
    since: "Mivel",
    product_views: "Terméknézet",
    shop_views: "Shop nézetek",
    total_sales: "Teljes értékesítés",
    total_orders: "Összes megrendelés",
    last_twelvth_months: "Utolsó Twelvth hónap",
    last_nine_months: "Az elmúlt kilenc hónap",
    last_six_months: "Az elmúlt hat hónapban",
    last_three_months: "Az elmúlt három hónapban",
    last_12_months: "Utolsó 12 hónap",
    last_9_months: "Utolsó 9 hónap",
    last_6_months: "Utolsó 6 hónap",
    last_3_months: "Utolsó 3 hónap",
    months: "Hónapok",
    open: "Nyisd ki",
    reset_password: "Jelszó visszaállítása",
    create_new_shop: "Új bolt létrehozása",
    download_app: "Letöltési alkalmazás",
    log_in: "Belépés",
    sign_up: "Regisztrálj",
    no_result: "Nincs eredmény",
    max_price: "Maximális ár",
    max_distance: "Maximális távolság",
    max_time: "Maximális idő",
    posted_less_than: "Kevesebb, mint",
    result: "Eredmény",
    more: "Több",
    or: "VAGY",
    password: "Jelszó",
    forgot_password: "Elfelejtett jelszó?",
    and: "és",
    download_for: "Letölthető",
    apple_ios: "Apple iOS",
    android: "Android",
    image: "Kép",
    edit_image: "Kép szerkesztése",
    please_complete: "Kérem, egészítse ki",
    enter_your_offer: "Adja meg ajánlatát",
    categories: "Kategóriák",
    upload_image: "Kép feltöltése",
    upload_images: "Képek feltöltése",
    back: "Vissza",
    see_more: "Többet látni",
    add_product: "Termék hozzáadása",
    selected: "Kiválasztott",
    create: "Teremt",
    rate_the_buyer: "Értékelje a vevőt",
    delete_product: "Törölje a terméket",
    product: "Termék",
    un_block_product: "Feloldja a terméket",
    share_your_product: "Ossza meg termékét",
    boost_details: "Boost részletek",
    remove_all_products: "Távolítsa el az összes terméket",
    remove_all: "Összes eltávolítása",
    add_vehicle: "Jármű hozzáadása",
    edit_vehicle: "A jármű szerkesztése",
    upload_a_photo: "Tölts fel egy fotót",
    view_details: "Részletek megtekintése",
    add_yard_sale: "Udvar eladás hozzáadása",
    edit_yard_sale: "Udvari eladás szerkesztése",
    users: "Felhasználók",
    users_details: "A felhasználók részletei",
    users_by_country: "A felhasználók országonként",
    blocked_users: "Letiltott felhasználók",
    products_cards: "Termékkártyák",
    archived_products: "Archivált termékek",
    blocked_products: "Blokkolt termékek",
    products_by_country: "Termékek országonként",
    reports: "Jelentés",
    reports_details: "Jelentések részletei",
    closed_reports: "Zárt jelentések",
    threads: "Szálak",
    threads_details: "Szálak részletei",
    chat_support: "Csevegési támogatás",
    actions: "Cselekvések",
    search_actions: "Keresési műveletek",
    product_view_actions: "Terméknézet műveletek",
    contact_seller_product: "Kapcsolatfelvétel az eladó termékkel",
    contact_owner_shop: "Kapcsolatfelvételi üzlet",
    ratings: "Értékelések",
    reviews: "Vélemény",
    products_all_countries: "Termékek Minden ország",
    edit_profile: "Profil szerkesztése",
    my_profile: "A profilom",
    profile_updated_successfully: "A profil sikeresen frissül",
    are_you_sure: "Biztos vagy ebben",
    my_used_products: "Saját termékek",
    my_shops: "A boltjaim",
    my_boosted_products: "Az én növelt termékeim",
    messages_type_message_here: "Írja be az üzenetet itt",
    messages_product_sold: "Ezt a terméket eladják vagy eltávolítják",
    seen: "Látott",
    messages_never_miss_message: "Soha ne hagyj ki egy üzenetet",
    enable: "Engedélyezze",
    send_notify: "Értesítés küldése",
    un_close: "Felnyit",
    type_your_review: "Írja be a felülvizsgálatot",
    again_question: "újra ?",
    ratings_already_submitted_review: "Ön már benyújtotta az áttekintést",
    set_product_category: "Termékkategória beállítása",
    auth_email_password_incorrect: "Az e-mail vagy a jelszó helytelen",
    auth_insert_your_name: "Kérjük, illessze be a nevét",
    auth_email_address_badly: "Az e-mail cím rosszul formázott",
    auth_email_address_used:
      "Az e-mail cím már használatban van egy másik fiók",
    auth_invalid_password: "A jelszónak legalább 6 karakternek kell lennie",
    auth_reset_email: "Adja meg e-mailjeit a jelszó visszaállításához",
    auth_check_email:
      "Kérjük, ellenőrizze e-mailjeit a jelszó visszaállításához",
    auth_can_sign_in_google: "Bejelentkezhet a Google gombjával",
    auth_do_not_have_account: "Nincs fiókod?",
    auth_have_account: "Van fiókja?",
    log_terms_privacy_part1:
      "A bejelentkezéssel vagy bejelentkezéssel elfogadja a közeljövőben felsorolt ​​listát",
    boost_this_product: "Növelje ezt a terméket?",
    product_successfully_boosted: "A termék sikeresen növelte",
    product_failed_boost: "A termék nem sikerült a Boost-ban",
    no_products_for_sale:
      "Jelenleg nincs olyan használt terméke, amelyet felsoroltak.",
    not_sold_listed_near_me: "Nem adtam el a közeljövőben",
    agree_add_product:
      "A termék közzétételére szolgáló hozzászólás megérintésével Ön elfogadja a közölt szolgáltatási és adatvédelmi irányelvek közzétételét.",
    click_to_boost: "Kattintson a termékre, hogy növelje",
    listed_terms_of_service: "A szolgáltatási feltételek közé tartozik",
    receive_emails_for_users: "E-mailek fogadása a felhasználók üzeneteihez",
    receive_emails_for_newly_posted:
      "E-mailek fogadása az újonnan írt termékekre",
    disable_push_notifications: "A push értesítések letiltása",
    sms_during_day: "SMS-t kap a nap folyamán",
    sms_24_hours: "SMS-t kap 24 óra",
    products: "Termékek",
    product_no_longer_available: "Sajnáljuk, ez a termék már nem elérhető",
    add_home: "Hozzászólás",
    edit_home: "Haza szerkesztése",
    fill_required_fields: "Töltse ki az összes szükséges mezőt",
    no_notification: "Nincs értesítés",
    orders_history: "Megrendelés története",
    privacy: "Magánélet",
    terms: "Feltételek",
    report_a_problem: "Jelentem a problémát",
    approximation_protect_user_privacy:
      "A felhasználó magánélet védelme érdekében közelítés",
    do_not_have_products: "Nincsenek termékei",
    emails: "E-mailek",
    lead_deletion_products: "Ez az összes termék törléséhez vezet",
    confirm_legal_message:
      "Ön kizárólag felelős azért, hogy minden szükséges óvintézkedést megteszi, amikor kölcsönhatásba lép, különösen akkor, ha első alkalommal találkoznak egy idegen személyesen. További részletekért tekintse át a szolgáltatási feltételeket.",
    push_notifications_notified_instantly:
      "Engedélyezze a push értesítések azonnali értesítését",
    rate_seller: "Rate eladó",
    user_journey: "Felhasználói utazás",
    user: "Felhasználó",
    user_id: "Felhasználói azonosító",
    action_id: "Akcióazonosító",
    select_model_car: "Válassza ki az autómintát",
    boost_1_day: "Boost 1 nap",
    boost_3_days: "Boost 3 nap",
    boost_7_days: "Boost 7 nap",
    agree_boost_terms: "A Boost megérintésével elfogadja",
    add: "Add",
    add_tag: "Címke hozzáadása",
    brand_title: "Márka",
    category_mobiles: "Mobilok",
    category_tablets: "Tabletek",
    screen_size: "Kijelzo méret",
    has_cellular_capability: "Celluláris képességgel rendelkezik",
    default_internal_memory: "Belső memória",
    network_carrier: "Hálózati hordozó",
    is_unlocked: "Kinyit",
    mobile_model_warning: "Kérjük, válasszon először a Brand-t",
    missing_image: "Hiányzó kép, próbálja meg újra a képet.",
    add_mobile: "Mobil hozzáadása",
    edit_mobile: "Mobil szerkesztése",
    add_tablet: "Tabletta hozzáadása",
    edit_tablet: "Tabletta szerkesztése",
    keywords:
      "vásárlás, vásárlás, eladás, pénz, kereskedelem, helyiek, szomszédok, auto, járművek",
    country: "Ország",
    phone_number: "Telefonszám",
    verification_code: "Ellenőrző kód",
    error_occurred: "Hiba történt. Próbálja újra később",
    invalid_state:
      "Érvénytelen állapot: A bejelentkezési visszahívás érkezett, de nem küldték el a bejelentkezési kérelmet.",
    sign_in: "Bejelentkezés",
    sign_in_apple: "Jelentkezzen be az Apple-vel",
    sign_in_google: "Jelentkezzen be a Google-lal",
    sign_in_phone: "Jelentkezzen be telefonnal",
    sign_in_facebook: "Jelentkezzen be a Facebookon",
    create_account: "Hozzon létre egy fiókot",
    email: "Email",
    invalid_field: "Kérjük, töltse ki a szükséges mezőket",
    code_sent: "A kódot SMS küldte",
    verify_number: "Ellenőrizze a telefonszámot",
    tapping_verify_number: "A telefonszám megérintésével SMS-t küldünk.",
    email_exists:
      "A fiók már létezik, és a Google gombon, a Facebook gombon vagy az Apple gombon keresztül kell hozzáférnie",
    ok: "Rendben",
    sure_back: "Biztos, hogy vissza?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "ezelőtt",
    add_model: "Modell hozzáadása",
    no_search_results_us:
      "Nincsenek keresési eredmények a közelben 120 mérföldön belül. Próbálja meg megváltoztatni a keresési szűrőt vagy a keresési kulcsszót.",
    no_search_results:
      "A közelben nincs keresési eredmény 200 km -en belül. Próbálja meg megváltoztatni a keresési szűrőt vagy a keresési kulcsszót.",
    plan_date: "Terv dátuma",
    plan_time: "Tervezési idő",
    invalid_plan_date:
      "Érvénytelen terv dátuma, kérjük, állítsa be újra a terv dátumát",
    invalid_plan_time:
      "Érvénytelen tervidő, kérjük, állítsa be újra a terv időt",
    plan_name: "Tervnév",
    plan_title: "Terv",
    update_plan_name: "Frissítse a terv nevét",
    delete_plan_question: "Biztos benne, hogy törölni akarja ezt a tervet?",
    plan_reminder_message: "Egy órával korábban emlékeztetni fognak",
    plan_dialog_title: "Találkozási terv",
    planners_title: "Tervezők",
    unable_sending_messages:
      "Látni fogják az üzeneteket, amikor visszatérnek online.",
    its_text: "Az",
    for_your_text: "a vevőjéhez.",
  },
  in: {
    invalid_area: "Area tidak valid, silakan atur area lagi.",
    invalid_lot_size:
      "Ukuran lot properti tidak valid, harap setel lot ukuran lagi.",
    property_area: "Area properti",
    app_store_name:
      "Tercantum di dekat saya - beli barang bekas, jual untuk uang tunai",
    app_store_short:
      "Pasar untuk penjual lokal. Buat daftar item untuk dijual dan menghasilkan uang.",
    app_store_full:
      "Tercantum di dekat saya membuatnya mudah untuk menemukan penawaran hebat pada hal-hal yang Anda inginkan dan menghasilkan uang pada hal-hal yang ingin Anda jual. Ini adalah cara terbaik untuk membeli dan menjual di komunitas atau lingkungan Anda dengan orang-orang yang dapat Anda percayai. Cara kerjanya: 1- Beli atau jual apa saja; Mudah memposting barang Anda untuk dijual dalam hitungan detik. 2- Temukan penawaran hebat dan diskon untuk pakaian, furnitur, ponsel, barang elektronik, barang-barang bayi dan anak-anak, peralatan olahraga, mobil bekas, gaun, sepatu, dan jam tangan, ke buku, mainan bekas, mobil bekas dan bahkan nyata Perkebunan untuk dijual atau disewa. 3- Telusuri barang-barang lokal untuk dijual. 4- Pesan pembeli dan penjual dari dalam aplikasi. 5- Jelajahi item dengan gambar dan urutkan berdasarkan kategori. Fakta menyenangkan tentang yang terdaftar di dekat saya: 1- dengan yang terdaftar di dekat saya Anda dapat dengan mudah menjual apa pun, dari pakaian ke mobil bekas ke elektronik. 2- Komunikasi antara pembeli dan penjual terjadi melalui aplikasi melalui pesan. 3- Terdaftar di dekat saya lebih baik daripada penjualan garasi; Temukan apa pun yang Anda inginkan dengan diskon, tepat di ponsel atau tablet Anda.",
    app_store_release:
      "Tercantum di dekat saya - berdagang dengan penduduk setempat. Bergabunglah dengan Pasar Seluler untuk Pembeli dan Penjual Lokal!",
    app_name: "Terdaftar di dekat saya",
    title_buy: "Membeli",
    title_messages: "Pesan",
    title_sell: "Menjual",
    title_profile_image: "Gambar profil",
    title_account: "Akun",
    account_settings: "Pengaturan akun",
    settings: "Pengaturan",
    color_theme: "Tema warna",
    device_settings: "Pengaturan alat",
    public_profile: "Profil Publik",
    light_mode: "Mode ringan",
    dark_mode: "Mode gelap.",
    title_sell_faster: "Jual lebih cepat",
    send_button_label: "Mengirim",
    rate_message: "Menilai saya...",
    already_rated: "Anda sudah mengirimkan ulasan",
    rate_review_question: "Apakah Anda ingin berurusan dengan",
    again: "lagi?",
    action_logout: "Keluar",
    action_category: "Kategori",
    action_search: "Mencari",
    action_refer: "Menunjuk teman",
    dialog_choose_location: "Pilih Lokasi",
    dialog_change_username: "Ubah nama pengguna",
    dialog_change_language: "Ganti BAHASA",
    dialog_image_tags: "Tag gambar.",
    dialog_emails_notifications: "Pemberitahuan email",
    dialog_push_notifications: "Pemberitahuan push.",
    fragment_product_detail: "Rincian produk",
    fragment_message_details: "Detail Pesan",
    fragment_sell: "Menjual",
    dialog_tags_title: "Tag",
    dialog_location_title: "Perbarui lokasi",
    dialog_username_title: "Ubah nama pengguna",
    tab_photo: "Foto",
    tab_details: "Detail.",
    tab_price: "Harga",
    tab_finish: "Menyelesaikan",
    profile: "Profil",
    search: "Mencari",
    choose_product: "Pilih Produk",
    rating_review: "Peringkat dan ulasan",
    select_buyer: "Pilih pembeli",
    tab_my_used_products: "Produk saya",
    price_label: "Harga",
    text_savings: "Kamu simpan",
    search_hint: "Cari produk ...",
    empty_text:
      "Tidak ada produk yang tercantum dalam kategori ini atau dalam jarak yang dipilih.",
    filter_menu_text: "Saring",
    error_contacting_seller: "Kesalahan Menerima Penjual",
    edit_product: "Edit Produk",
    contact_seller: "Hubungi penjual",
    signup_to_contact_seller: "Daftar untuk menghubungi penjual",
    signup_to_make_offer: "Daftar untuk Membuat Penawaran",
    product_details: "Detail.",
    product_category: "Kategori",
    product_condition: "Kondisi",
    product_description: "Keterangan",
    product_location: "Lokasi Produk",
    product_location_approximate: "Lokasi adalah perkiraan",
    over_week_time_ago: "Lebih dari seminggu yang lalu",
    boosted: "Boosted.",
    threads_no_results: "Tidak ada pesan",
    message_no_results: "Tidak ada pesan",
    message_warning:
      "Anda bertanggung jawab penuh untuk mengambil semua tindakan pencegahan yang diperlukan saat berinteraksi dengan orang lain, terutama ketika bertemu orang asing secara langsung untuk pertama kalinya. Harap jangan membagikan informasi pribadi, kode verifikasi atau informasi pembayaran apa pun. Harap tinjau Ketentuan Layanan untuk lebih jelasnya.",
    message_block: "Anda tidak dapat mengirim atau menerima pesan saat ini.",
    select_location: "Pilih lokasi",
    location_permission_denied_message:
      "Aplikasi ini membutuhkan izin lokasi untuk bekerja dengan baik.",
    signed_in: "Masuk!",
    sign_in_canceller: "Masuk Dibatalkan",
    version: "Versi: kapan",
    build: "Membangun",
    name: "Nama",
    location: "Lokasi",
    language: "Bahasa",
    about_app: "Tentang terdaftar di dekat saya",
    terms_of_service: "Ketentuan Layanan",
    privacy_policy: "Rahasia pribadi",
    report_feedback: "Kirim umpan balik",
    report_bug: "Goyang telepon untuk melaporkan bug",
    change_image: "Ganti gambar",
    update_location: "Perbarui lokasi",
    about_the_app: "Tentang aplikasi",
    update_label: "Memperbarui",
    uploading: "Mengunggah",
    adding: "Menambahkan daftar",
    removing: "Menghapus daftar",
    updating: "Memperbarui daftar",
    uploaded_image: "Gambar yang diunggah:",
    image_storage_failed: "Gagal menyimpan gambar:",
    product_updated: "Produk diperbarui dengan sukses",
    location_error: "Lokasi tidak disimpan, silakan coba lagi",
    product_removed: "Produk berhasil dihapus",
    deleted_product: "Produk ini dihapus",
    invalid_title: "Judul tidak valid, harap atur judul lagi.",
    invalid_image: "Jalur gambar tidak valid, coba tambahkan gambar lagi.",
    invalid_price: "Harga tidak valid, harap atur harga lagi.",
    invalid_location: "Lokasi tidak valid, silakan atur lokasi lagi.",
    invalid_category: "Kategori tidak valid, harap set kategori lagi.",
    invalid_condition: "Kondisi tidak valid, harap setel lagi.",
    removing_title: "Menghapus gambar profil",
    image_not_saved: "Simpan gambar gagal!",
    product_load_failed: "Tidak ada produk.",
    take_photo: "Memotret",
    select_photo: "Pilih Foto",
    product_title_hint: "Apa itu? Nama, merek, model, dll.",
    delete_photo: "Menghapus foto",
    product_title: "Judul",
    mark_as_sold: "Tandai seperti yang dijual",
    product_share: "Membagikan",
    product_make_offer: "Membuat penawaran",
    product_cover: "Tetapkan sebagai gambar penutup",
    product_tags: "Tag",
    product_posted: "Diposting:",
    product_change: "Mengubah",
    product_post: "Pos",
    product_selling_from: "Jual dari Lokasi",
    product_select_location: "Pilih lokasi",
    product_map_approximate:
      "Peta diperkirakan untuk menjaga lokasi penjual pribadi",
    product_terms:
      "Dengan mengetuk posting untuk mempublikasikan produk Anda, Anda setuju untuk <U> terdaftar di dekat saya ketentuan layanan. </ U>",
    condition_other: "Lainnya (lihat deskripsi)",
    condition_for_parts: "Untuk bagian",
    condition_used: "Digunakan (keausan normal)",
    condition_open_box: "Buka kotak (tidak pernah digunakan)",
    condition_reconditioned: "Rekondisi / bersertifikat",
    condition_new: "Baru (tidak pernah digunakan)",
    select_category: "Pilih Kategori",
    select_all_category: "Pilih Semua",
    category_loading_error:
      "Tidak dapat memperbarui daftar kategori, silakan coba lagi nanti.",
    category_vehicles: "Kendaraan",
    category_furniture: "Mebel",
    category_electronics: "Elektronik",
    category_appliances: "Rumah &  Peralatan.",
    category_fashion_accessories: "Mode &  Aksesori",
    category_baby_kids: "Baby &  Anak-anak",
    category_antiques_collectibles: "Barang antik &  Koleksi",
    category_auto_parts_tools_machinery: "Suku Cadang Mobil, Alat &  Mesin.",
    category_sports_outdoors: "Olahraga &  Di luar rumah",
    category_others: "Yang lain",
    location_enter_zip_code: "Masukkan Kode ZIP.",
    location_get_current_location: "Dapatkan lokasi saat ini",
    location_select_location: "Pilih lokasi",
    location_update_location: "Perbarui lokasi",
    location_new_location: "Lokasi baru",
    search_filter_results: "Filter hasilnya",
    search_filter_min: "Saring minimum",
    search_filter_at_least: "Paling sedikit",
    price_filter: "Filter Harga",
    product_name: "Nama Produk",
    english_language: "bahasa Inggris",
    arabic_language: "Arab",
    spanish_language: "Orang Spanyol",
    system_language: "Sistem",
    share_link: "Membagikan tautan",
    save: "Menyimpan",
    cancel: "Membatalkan",
    loading: "Memuat",
    yes: "Ya",
    no: "Tidak",
    report: "Laporan",
    report_product: "Laporkan Produk",
    report_user: "Laporan pengguna",
    block_user: "Blokir Pengguna",
    un_block_user: "Buka blokir Pengguna",
    why_product: "Mengapa Anda ingin melaporkan item ini?",
    why_user: "Mengapa Anda ingin melaporkan pengguna ini?",
    block_user_confirm:
      "Apakah Anda ingin memblokir pengguna ini secara permanen?",
    un_block_user_confirm:
      "Apakah Anda ingin membuka blokir pengguna ini secara permanen?",
    prohibited: "Dilarang di dekat saya",
    offensive: "Ofensif atau tidak pantas",
    duplicate: "Pos Duplikat.",
    wrong_category: "Kategori yang salah",
    scam: "Terlihat seperti penipuan",
    stolen: "Saya pikir itu dicuri",
    product_other: "Lainnya",
    product_is_sold: "Produk ini dijual",
    missed_meeting: "Mereka melewatkan pertemuan kami",
    low_offer: "Membuat penawaran rendah",
    rude: "Kasar atau tidak pantas",
    items: "Masalah dengan item",
    trouble_meetup: "Masalah saat bertemu",
    messaging: "Masalah perpesanan",
    user_other: "Lainnya",
    new_version_available: "Versi baru tersedia",
    please_update_app:
      "Silakan, perbarui aplikasi ke versi baru untuk melanjutkan.",
    update: "Memperbarui",
    no_thanks: "Tidak, terima kasih",
    contact_support_confirmation:
      "Waktu respons saat ini adalah 24-48 jam. Apakah Anda ingin menghubungi yang terdaftar di dekat Me App Chat Support?",
    unboost_confirmation: "Apakah Anda yakin ingin membuka booting produk ini?",
    no_used_products: "Anda belum memiliki daftar",
    no_boosted_products: "Anda tidak memiliki produk yang didorong",
    next: "Berikutnya",
    previous: "Sebelumnya",
    skip: "Melewati",
    start: "Awal",
    list_used: "Daftar produk bekas",
    buy_description:
      "Temukan dan cari produk yang ditawarkan oleh tetangga di sekitar Anda",
    sell_description:
      "Daftar produk yang tidak lagi Anda butuhkan untuk dijual",
    list_used_description:
      "Daftar produk bekas untuk dijual dalam waktu kurang dari 20 detik",
    boost_product_option_1: "<b> Boost 1  n Hay </ b>  n  n <b> $ 0,99 </ b>",
    boost_product_option_2: "<b> Boost 3  n hari </ b>  n  n <b> $ 1,99 </ b>",
    boost_product_option_3: "<b> Boost 7  Ndays </ b>  n  n <b> $ 3,99 </ b>",
    boost_product_description:
      "Dapatkan lebih banyak tampilan setiap hari. Barang Anda akan muncul di posisi unggulan dalam 30 item teratas dalam BELI dan kategori. Item yang dipromosikan diputar di antara titik-titik yang ditunjuk sehingga setiap item mendapat paparan yang adil.",
    boost_cta: "Jual lebih cepat",
    boost_terms:
      "Dengan mengetuk boost, Anda setuju untuk <U> terdaftar di dekat saya ketentuan layanan. </ U>",
    boost_best_value: "Nilai terbaik",
    already_boosted: "Produk ini didorong",
    clicks: "Klik",
    impressions: "Tayangan",
    end: "Akhir",
    transactions_empty_text:
      "Anda belum memiliki transaksi dorongan. Anda dapat mengunjungi tab Jual dan mulai meningkatkan produk Anda.",
    transactions_loading_error:
      "Tidak dapat memperbarui daftar transaksi, silakan coba lagi nanti.",
    transactions_history_title: "Boost Transaksi Sejarah",
    communicative_postive: "Komunikatif",
    communicative_negative: "Tidak berkomunikasi",
    ontime_postive: "Tepat waktu",
    ontime_negative: "Terlambat",
    reliable_postive: "Dapat diandalkan",
    reliable_negative: "Tidak bisa diandalkan",
    friendly_postive: "Ramah",
    friendly_negative: "Tidak sopan",
    itemasdescribed_postive: "seperti barang yang di jelaskan",
    itemasdescribed_negative: "Item tidak seperti yang dijelaskan",
    other: "Lainnya",
    submit: "Kirim",
    adding_rating_reviews: "Menambah peringkat dan ulasan",
    no_internet_title: "Tidak ada koneksi internet",
    no_internet_message: "Pastikan Anda terhubung ke Internet dan coba lagi",
    retry: "Mencoba kembali",
    near_me: "Dekat saya",
    newest_first: "Pertama Terbaru",
    miles: "mil.",
    km: "Km.",
    similar_products: "produk sejenis",
    favorite_products: "Produk favorit.",
    items_for_sale: "barang dijual",
    joined: "Bergabung",
    favorites_transactions_title: "Favorit",
    boosted_products_transactions_history: "Sejarah Transaksi Produk Boosted",
    views: "Tampilan",
    boost_graph_title: "Boost Graph.",
    no_favorite_products: "Anda tidak memiliki produk favorit",
    make_offer_buy: "Saya ingin membeli",
    make_offer_buy_for: "untuk",
    notifications: "Pemberitahuan",
    push_notifications: "Dorongan",
    emails_notifications: "Surel",
    apply: "Menerapkan",
    email_messages: "Email untuk pesan",
    email_new_products: "Email untuk Produk Baru",
    push_day_only: "Hanya Pemberitahuan Push",
    push_24_hours: "Pemberitahuan push 24 jam",
    edit: "Edit",
    map: "Peta",
    camera: "Kamera",
    gallery: "Galeri",
    delete: "Menghapus",
    no_sell_items: "Tidak ada barang untuk dijual",
    who_bought_question: "Siapa yang membelinya?",
    sold_elsewhere_question: "Menjualnya di tempat lain",
    confirm: "Mengonfirmasi",
    over_limit_camera: "Anda tidak dapat menambahkan lebih dari lima gambar",
    boost_failed: "Boost gagal. Silakan coba lagi nanti",
    after_purchase: "Pembayaran berhasil  NPRODUCT",
    pay_failed: "Pembayaran gagal. Silakan coba lagi",
    done: "Selesai",
    not_now: "Tidak sekarang",
    boost: "Mendorong",
    invalid_zip_code: "Kode ZIP tidak valid.",
    invalid_user_name: "Nama pengguna tidak valid",
    comments: "Komentar",
    questions: "Pertanyaan",
    bug_reports: "Laporan bug",
    feature_request: "Permintaan fitur",
    feedback_type: "jenis umpan balik",
    feedback_description:
      "Kami akan senang mendengar pikiran atau umpan balik Anda tentang bagaimana kami dapat meningkatkan pengalaman Anda!",
    feedback: "Masukan",
    feedback_text: "Jawaban Anda",
    suggestions: "Saran untuk peningkatan",
    delete_account: "Hapus akun",
    new_message: "Pesan baru",
    online: "On line",
    km_50: "50 Km",
    km_100: "100 km",
    km_200: "200 Km.",
    miles_30: "30 mil",
    miles_60: "60 mil.",
    miles_120: "120 mil.",
    rate_app_question: "Bagaimana dengan peringkat pada App Store, lalu?",
    enjoying_question: "Menikmati yang terdaftar di dekat saya?",
    not_enjoy: "Tidak juga",
    feedback_question: "Maukah Anda memberi kami umpan balik?",
    yes_sure: "Oke",
    product_available_question: "Hai, apakah ini masih tersedia?",
    buy_question: "Hai, saya ingin membeli ini",
    meet_question: "Hai, bisakah kamu bertemu hari ini?",
    follow: "Mengikuti",
    followers: "Pengikut",
    following: "Mengikuti",
    feedback_thanks: "Terima kasih atas tanggapan Anda",
    all_categories: "semua Kategori",
    deleted_account: "Akun ini dihapus",
    delete_account_question: "Apakah Anda yakin ingin menghapus akun ini?",
    no_followings: "tidak mengikuti siapa pun",
    when_following: "Kapan",
    no_followings_subtitle:
      "mengikuti orang-orang, Anda akan melihat mereka di sini",
    no_followers: "tidak punya pengikut",
    no_followers_subtitle:
      "diikuti oleh orang-orang, Anda akan melihatnya di sini",
    distance: "Jarak",
    filter_method: "Metode Filter",
    see_listings: "Lihat daftar",
    sold: "Terjual",
    bought: "Dibeli",
    no_notifications:
      "Ketika Anda menerima notifikasi, mereka akan muncul di sini",
    items_title: "Item",
    new_listing_title: "Buat daftar baru",
    dialog_year_title: "Tahun",
    dialog_make_title: "Membuat",
    dialog_model_title: "Model",
    dialog_body_style_title: "Gaya tubuh",
    dialog_exterior_color_title: "Warna eksterior",
    dialog_interior_color_title: "Warna interior.",
    dialog_transmission_title: "Penularan",
    dialog_fuel_type_title: "Jenis bahan bakar",
    dialog_owners_num_title: "Jumlah pemiliknya",
    dialog_vehicle_owed_money_title:
      "Apakah ada uang yang masih terutang pada kendaraan ini?",
    automatic_transmission: "Otomatis",
    manual_transmission: "Manual.",
    not_sure: "Tidak yakin",
    wagon_hatchback: "Gerobak &  Hatchback.",
    convertible: "Mobil atap terbuka",
    coupe: "Coupe.",
    sedan: "Sedan",
    black_color: "Hitam",
    blue_color: "Biru",
    brown_color: "cokelat",
    gold_color: "Emas",
    green_color: "Hijau",
    grey_color: "Abu-abu",
    pink_color: "Merah Jambu",
    purple_color: "Ungu",
    red_color: "merah",
    silver_color: "Perak",
    orange_color: "jeruk",
    white_color: "putih",
    yellow_color: "Kuning",
    charcol_color: "Charcol.",
    fuel_diesel: "Diesel.",
    fuel_electric: "Listrik",
    fuel_gasoline: "Bensin",
    fuel_flex: "Melenturkan",
    fuel_hybrid: "Hibrida",
    fuel_petrol: "Bensin",
    fuel_plugin_hybrid: "Plug-in hybrid",
    truck: "Truk",
    van_minivan: "Van &  Minivan.",
    suv_crossover: "SUV &  Crossover.",
    awd_4wd: "AWD / 4WD",
    fwd: "FWD.",
    rwd: "Rwd.",
    off_white_color: "Putih pucat",
    tan_color: "Tan.",
    beige_color: "Krem",
    burgundy_color: "Burjundy.",
    turquoise_color: "Pirus",
    title_status_clean: "Membersihkan",
    title_status_rebuilt: "Dibangun kembali",
    title_status_salvage: "Menyelamatkan",
    title_status_missing: "Hilang",
    title_status_lien: "Hak gadai",
    title_status: "Status Judul",
    mileage: "Jarak tempuh",
    dialog_drivetrain_title: "Rantai penggerak",
    model_warning: "Silakan pilih Buat dulu",
    required_field_warning: "Bagian ini diperlukan",
    vehicle_vin: "Vin",
    invalid_vin: "Vin tidak valid, harap atur lagi.",
    invalid_mileage: "MILEAGE INVALID, tolong setel jarak tempuh lagi.",
    clean_description:
      "Sebagian besar kendaraan yang belum mengalami kecelakaan",
    rebuilt_description: "Mobil yang diselamatkan yang telah dibangun kembali",
    salvage_description: "Dianggap berjumlah setelah kecelakaan",
    missing_description: "Akan membutuhkan judul masalah DMV baru",
    lien_description: "Dimiliki oleh bank atau penyelesaian pengadilan",
    nearme: "Dekat saya",
    newest: "Terbaru",
    contact_support: "Dukungan kontak",
    create_home_title: "Rumah untuk dijual atau disewa",
    for_sale: "Dijual",
    for_rent: "Disewakan",
    property_type: "Jenis properti",
    apartment: "Apartemen",
    house: "rumah",
    room_only: "Hanya kamar",
    townhouse: "Townhouse.",
    bedrooms: "Kamar tidur",
    bathrooms: "Kamar mandi",
    property_address: "Alamat properti",
    price_per_month: "Harga per bulan",
    square_feet: "Kaki",
    year_built: "Tahun dibangun",
    year_renovated: "Tahun direnovasi.",
    lot_size: "Banyak ukuran",
    laundry_type: "Tipe Laundry.",
    in_unit_laundry: "Cucian dalam unit",
    laundry_building: "Binatu dalam membangun",
    laundry_available: "Binatu tersedia",
    none: "Tidak ada",
    parking_type: "Tipe parkir.",
    garage_parking: "Parkir garasi",
    street_parking: "Parkir jalanan",
    off_street_parking: "Parkir di luar jalan",
    available_parking: "Parkir tersedia",
    air_cond_type: "Jenis AC",
    ac_available: "AC tersedia",
    central_ac: "AC pusat",
    heating_type: "Tipe pemanas",
    electric_heating: "Pemanas listrik",
    gas_heating: "Pemanasan gas",
    radiator_heating: "Pemanasan radiator",
    available_heating: "Pemanasan tersedia",
    amenities: "Fasilitas",
    date_available: "Tanggal tersedia",
    lease_length: "Panjang sewa",
    month_to_month: "Bulan ke bulan.",
    three_months: "3 bulan",
    six_months: "6 bulan",
    one_year: "1 tahun",
    more_one_year: "1+ tahun",
    cat_friendly: "Ramah kucing",
    dog_friendly: "Ramah anjing",
    balcony: "Balkon",
    basement: "Basement.",
    bike_parking: "Parkir sepeda",
    cable_tv: "TV kabel",
    ceiling_fan: "Kipas langit-langit",
    concierge: "Ruang serbaguna",
    dishwasher: "Pencuci piring",
    doorman: "Penjaga pintu",
    elevator: "Tangga berjalan",
    fireplace: "Perapian",
    fitness_center: "Pusat kebugaran",
    garbage_disposal: "Pembuangan sampah",
    microwave: "Microwave.",
    online_app: "Aplikasi online",
    oven: "Oven",
    package_service: "Paket Layanan",
    patio: "Patio.",
    pet_park: "Pet Park.",
    refrigerator: "Kulkas",
    resident_lounge: "Resident Lounge",
    roof_deck: "Dek atap",
    secured_entry: "Entri yang diamankan",
    storage: "Penyimpanan",
    walk_in_closet: "Lemari pakaian",
    swimming_pool: "Kolam renang",
    wheelchair_access: "Akses kursi roda",
    central_heating: "Pemanasan pusat",
    invalid_bedrooms: "Kamar tidur tidak valid, silakan atur kamar tidur lagi.",
    invalid_bathrooms:
      "Kamar mandi tidak valid, silakan atur kamar mandi lagi.",
    chinese_simplified_language: "Bahasa Tiongkok yang disederhanakan",
    chinese_traditional_language: "Cina tradisional",
    czech_language: "Ceko",
    danish_language: "Orang Denmark",
    dutch_language: "Belanda",
    finnish_language: "Finlandia",
    french_language: "Perancis",
    german_language: "Jerman",
    greek_language: "orang Yunani",
    hungarian_language: "Hongaria",
    indonesian_language: "bahasa Indonesia",
    italian_language: "Italia",
    japanese_language: "Jepang",
    korean_language: "Korea",
    norwegian_language: "Norwegia",
    polish_language: "Polandia",
    portuguese_language: "Portugis",
    portuguese_brazilian_language: "Portugis, Brasil",
    romanian_language: "Rumania",
    russian_language: "Rusia",
    swedish_language: "Orang Swedia",
    turkish_language: "Turki",
    ukrainian_language: "Orang Ukraina",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "Orang Vietnam",
    category_home_sale_or_rent: "Rumah untuk dijual atau disewa",
    square_meter: "Meter persegi",
    copy_text: "Salinan",
    copyied_to_clipboard: "Disalin ke Clipboard",
    inbox: "Inbox.",
    input_title_listening: "Mendengarkan…",
    input_subtitle_listening: "Katakan sesuatu",
    input_title_error: "Maaf, kami tidak mengerti.",
    input_subtitle_error: "Coba ulangi permintaan Anda.",
    input_hint_error: "Coba lagi",
    price_less_than_or_equal: "Harga kurang dari atau sama dengan",
    any_price: "Berapa harga",
    any_condition: "Kondisi apa pun",
    any_time: "Kapan pun",
    days_ago: "beberapa hari yang lalu",
    any_distance: "Jarak apa pun",
    distance_within: "Jarak dalam",
    new_notification: "PEMBERITAHUAN BARU",
    deleted: "Dihapus.",
    processing_image: "Memproses gambar",
    remove_dialog_message:
      "Apakah Anda benar-benar ingin menghapus produk ini?",
    deleted_thread: "Pesan ini dihapus",
    category_yard_sale_event: "Acara penjualan halaman",
    yard_first_date: "Penjualan Halaman Tanggal Pertama",
    yard_second_date: "Penjualan halaman tanggal kedua",
    yard_third_date: "Penjualan Halaman Tanggal Ketiga",
    yard_start_time: "Waktu mulai",
    yard_end_time: "Akhir waktu",
    yard_end_timestamp: "End timestamp.",
    invalid_date1:
      "Tanggal Pertama Tidak Valid, Harap Tetapkan Tanggal Pertama Lagi",
    invalid_start_time: "Waktu mulai tidak valid, harap atur waktu mulai lagi",
    invalid_end_time:
      "Waktu akhir yang tidak valid, silakan atur lagi waktu lagi",
    yard_sale_title: "Penjualan halaman",
    garage_tag: "garasi",
    yard_tag: "halaman",
    from: "Dari",
    to: "Ke",
    block: "Memblokir",
    un_block: "Buka blokir",
    sign_email: "Masuk melalui email",
    invalid_first_date:
      "Tanggal Pertama Tidak Valid, Pastikan Tanggal Pertama Sebelum Kedua Dan Ketiga",
    invalid_second_date:
      "Tanggal kedua tidak valid, pastikan tanggal kedua sebelum tanggal ketiga",
    invalid_start_time_value:
      "Waktu mulai tidak valid, pastikan waktu mulai sebelum waktu akhir",
    use_default_yard_photo: "Gunakan foto penjualan halaman default",
    active_label: "Aktif",
    enable_notifications: "Aktifkan pemberitahuan",
    login: "Gabung",
    january: "Januari",
    february: "Februari",
    march: "berbaris",
    april: "April",
    may: "Boleh",
    june: "Juni",
    july: "Juli",
    august: "Agustus",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Desember",
    since: "Sejak",
    product_views: "Tampilan Produk",
    shop_views: "Toko dilihat",
    total_sales: "Total penjualan",
    total_orders: "Total pesanan",
    last_twelvth_months: "Twelvth terakhir bulan.",
    last_nine_months: "Sembilan bulan terakhir",
    last_six_months: "Enam bulan terakhir",
    last_three_months: "Tiga bulan terakhir",
    last_12_months: "12 bulan terakhir",
    last_9_months: "9 bulan terakhir",
    last_6_months: "6 bulan terakhir",
    last_3_months: "3 bulan terakhir",
    months: "Bulan",
    open: "Membuka",
    reset_password: "Setel ulang kata sandi",
    create_new_shop: "Buat toko baru",
    download_app: "Unduh aplikasi",
    log_in: "Gabung",
    sign_up: "Daftar",
    no_result: "Tidak ada hasil",
    max_price: "Max Price.",
    max_distance: "Jarak Maks",
    max_time: "Max Time.",
    posted_less_than: "Diposting kurang dari",
    result: "Hasil",
    more: "Lagi",
    or: "ATAU",
    password: "Kata sandi",
    forgot_password: "Tidak ingat kata sandi?",
    and: "dan",
    download_for: "Unduh untuk.",
    apple_ios: "Apple iOS.",
    android: "Android.",
    image: "Gambar",
    edit_image: "Edit Gambar",
    please_complete: "Silakan lengkapi",
    enter_your_offer: "Masukkan tawaran Anda",
    categories: "Kategori",
    upload_image: "Unggah Gambar",
    upload_images: "Unggah gambar",
    back: "Kembali",
    see_more: "Lihat lebih lanjut",
    add_product: "Tambahkan Produk",
    selected: "Terpilih",
    create: "Membuat",
    rate_the_buyer: "Nilai pembeli",
    delete_product: "Hapus Produk",
    product: "Produk",
    un_block_product: "Buka blokir produk",
    share_your_product: "Bagikan produk Anda",
    boost_details: "Boost detail",
    remove_all_products: "Hapus semua produk",
    remove_all: "Menghapus semua",
    add_vehicle: "Tambahkan Kendaraan",
    edit_vehicle: "Edit Kendaraan",
    upload_a_photo: "Mengunggah foto",
    view_details: "Melihat rincian",
    add_yard_sale: "Tambahkan Halaman Penjualan",
    edit_yard_sale: "Edit penjualan halaman",
    users: "Pengguna.",
    users_details: "Detail pengguna",
    users_by_country: "Pengguna berdasarkan negara",
    blocked_users: "Pengguna diblokir",
    products_cards: "Kartu produk",
    archived_products: "Produk yang diarsipkan",
    blocked_products: "Produk yang diblokir",
    products_by_country: "Produk oleh negara",
    reports: "Laporan",
    reports_details: "Rincian laporan",
    closed_reports: "Laporan Tertutup",
    threads: "Utas",
    threads_details: "Threads Details.",
    chat_support: "Dukungan obrolan",
    actions: "Tindakan",
    search_actions: "Tindakan pencarian",
    product_view_actions: "Tindakan tampilan produk",
    contact_seller_product: "Hubungi penjual Produk",
    contact_owner_shop: "Hubungi pemilik toko",
    ratings: "Peringkat.",
    reviews: "Ulasan",
    products_all_countries: "Produk semua negara",
    edit_profile: "Sunting profil",
    my_profile: "Profil saya",
    profile_updated_successfully: "Profil berhasil diperbarui",
    are_you_sure: "Apa kamu yakin",
    my_used_products: "Produk bekas saya",
    my_shops: "Tokukku",
    my_boosted_products: "Produk saya yang didorong",
    messages_type_message_here: "Ketikkan pesan Anda di sini",
    messages_product_sold: "Produk ini dijual atau dihapus",
    seen: "Terlihat",
    messages_never_miss_message: "Jangan pernah melewatkan pesan",
    enable: "Memungkinkan",
    send_notify: "Kirim Beritahu",
    un_close: "Unclose.",
    type_your_review: "Ketikkan ulasan Anda",
    again_question: "lagi ?",
    ratings_already_submitted_review: "Anda sudah mengirimkan ulasan",
    set_product_category: "Atur kategori produk",
    auth_email_password_incorrect: "E-mail atau kata sandi Anda salah",
    auth_insert_your_name: "Silakan masukkan nama Anda",
    auth_email_address_badly: "Alamat email diformat dengan buruk",
    auth_email_address_used: "Alamat email sudah digunakan oleh akun lain",
    auth_invalid_password: "Kata sandi harus minimal 6 karakter",
    auth_reset_email:
      "Masukkan email Anda untuk mengatur ulang kata sandi Anda",
    auth_check_email:
      "Silakan, periksa email Anda untuk mengatur ulang kata sandi",
    auth_can_sign_in_google: "Anda dapat masuk dengan tombol google",
    auth_do_not_have_account: "Apakah kamu tidak punya akun?",
    auth_have_account: "Apakah kamu punya akun?",
    log_terms_privacy_part1:
      "Dengan mendaftar atau masuk, Anda setuju dengan yang terdaftar di dekat saya",
    boost_this_product: "Tingkatkan produk ini?",
    product_successfully_boosted: "Produk telah berhasil ditingkatkan",
    product_failed_boost: "Produk telah gagal dalam dorongan",
    no_products_for_sale:
      "Saat ini Anda tidak memiliki produk bekas yang tercantum untuk dijual.",
    not_sold_listed_near_me: "Saya tidak menjualnya di dekat saya",
    agree_add_product:
      "Dengan mengetuk posting untuk mempublikasikan produk Anda, Anda menyetujui Ketentuan Layanan dan Kebijakan Privasi yang terdaftar di dekat saya.",
    click_to_boost: "Klik pada produk untuk meningkatkannya",
    listed_terms_of_service: "Tercantum di dekat saya Ketentuan Layanan",
    receive_emails_for_users: "Terima email untuk pesan pengguna",
    receive_emails_for_newly_posted:
      "Terima email untuk produk Anda yang baru diposting",
    disable_push_notifications: "Nonaktifkan pemberitahuan push.",
    sms_during_day: "Menerima SMS pada siang hari",
    sms_24_hours: "Terima SMS 24 jam",
    products: "Produk.",
    product_no_longer_available: "Maaf, produk ini tidak lagi tersedia",
    add_home: "Tambahkan rumah",
    edit_home: "Edit rumah",
    fill_required_fields: "Isi semua bidang yang diperlukan",
    no_notification: "Tidak ada notifikasi",
    orders_history: "Pesanan Sejarah",
    privacy: "Pribadi",
    terms: "Ketentuan",
    report_a_problem: "Laporkan masalah",
    approximation_protect_user_privacy:
      "Perkiraan untuk melindungi privasi pengguna",
    do_not_have_products: "Anda tidak memiliki produk",
    emails: "Email.",
    lead_deletion_products:
      "Ini akan mengarah pada penghapusan semua produk Anda",
    confirm_legal_message:
      "Anda sepenuhnya bertanggung jawab untuk mengambil semua tindakan pencegahan yang diperlukan saat berinteraksi dengan orang lain, terutama ketika bertemu dengan orang asing secara langsung. Harap tinjau ketentuan layanan untuk detail lebih lanjut.",
    push_notifications_notified_instantly:
      "Aktifkan pemberitahuan push untuk diberitahukan secara instan",
    rate_seller: "Nilai penjual",
    user_journey: "Perjalanan Pengguna",
    user: "Pengguna",
    user_id: "Identitas pengguna",
    action_id: "ID Aksi",
    select_model_car: "Pilih model mobil",
    boost_1_day: "Boost 1 hari",
    boost_3_days: "Boost 3 hari",
    boost_7_days: "Boost 7 hari",
    agree_boost_terms: "Dengan mengetuk boost, Anda setuju",
    add: "Menambahkan",
    add_tag: "Tambahkan Tag.",
    brand_title: "Merek",
    category_mobiles: "Ponsel.",
    category_tablets: "Tablet.",
    screen_size: "Ukuran layar",
    has_cellular_capability: "Memiliki kemampuan seluler",
    default_internal_memory: "Memori internal",
    network_carrier: "Jaringan Carrier.",
    is_unlocked: "Tidak terkunci",
    mobile_model_warning: "Silakan pilih merek terlebih dahulu",
    missing_image: "Gambar yang hilang, coba tambahkan gambar lagi.",
    add_mobile: "Tambahkan Ponsel.",
    edit_mobile: "Edit Mobile.",
    add_tablet: "Tambahkan Tablet.",
    edit_tablet: "Edit Tablet",
    keywords:
      "Belanja, beli, jual, menghasilkan uang, perdagangan, penduduk setempat, tetangga, otomatis, kendaraan",
    country: "Negara",
    phone_number: "Nomor telepon",
    verification_code: "Kode verifikasi",
    error_occurred: "Terjadi kesalahan, coba lagi nanti",
    invalid_state:
      "Negara tidak valid: Panggilan balik login diterima, tetapi tidak ada permintaan login yang dikirim.",
    sign_in: "Masuk",
    sign_in_apple: "Masuk dengan Apple",
    sign_in_google: "Masuk dengan Google",
    sign_in_phone: "Masuk dengan telepon",
    sign_in_facebook: "Masuk dengan Facebook",
    create_account: "Buat sebuah akun",
    email: "Surel",
    invalid_field: "Silakan isi bidang yang diperlukan",
    code_sent: "Kode telah dikirim melalui SMS",
    verify_number: "Verifikasi nomor telepon",
    tapping_verify_number:
      "Dengan mengetuk (verifikasi nomor telepon), SMS dikirim.",
    email_exists:
      "Akun sudah ada dan Anda perlu mengaksesnya melalui tombol google, tombol Facebook atau tombol Apple",
    ok: "Oke",
    sure_back: "Apakah Anda yakin akan kembali?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "yang lalu",
    add_model: "Tambahkan Model.",
    no_search_results_us:
      "Tidak ada hasil pencarian di dekat Anda dalam jarak 120 mil. Coba ubah filter pencarian atau kata kunci pencarian.",
    no_search_results:
      "Tidak ada hasil pencarian di dekat Anda dalam jarak 200 km. Coba ubah filter pencarian atau kata kunci pencarian.",
    plan_date: "Tanggal rencana",
    plan_time: "Waktu rencana",
    invalid_plan_date:
      "Tanggal Rencana Tidak Valid, Harap Tetapkan Tanggal Rencana Lagi",
    invalid_plan_time:
      "Waktu rencana yang tidak valid, harap atur waktu rencana lagi",
    plan_name: "Nama rencana",
    plan_title: "Rencana",
    update_plan_name: "Perbarui nama rencana",
    delete_plan_question: "Apakah Anda yakin ingin menghapus rencana ini?",
    plan_reminder_message: "Anda akan diingatkan satu jam sebelumnya",
    plan_dialog_title: "Rencana pertemuan",
    planners_title: "Perencana",
    unable_sending_messages:
      "Mereka akan melihat pesan Anda ketika mereka kembali online.",
    its_text: "Dia",
    for_your_text: "untuk penerima Anda.",
  },
  it: {
    invalid_area: "Area non valida, imposta l'area di nuovo.",
    invalid_lot_size:
      "Dimensione del lotto di proprietà non valida, imposta di nuovo la dimensione del lotto.",
    property_area: "Area di proprietà",
    app_store_name:
      "Elencato Vicino a Me - Acquista articoli usati, Vendi in contanti",
    app_store_short:
      "Un mercato per i venditori locali. Metti un oggetto in vendita e guadagna.",
    app_store_full:
      "Elencato Vicino a Me rende facile sia trovare grandi offerte sulle cose che desideri, sia guadagnare sulle cose che vuoi vendere. Questo è il modo migliore di comprare e vendere nella tua comunità o quartiere con persone di cui ti puoi fidare. Come funziona: 1- compra o vendi qualsiasi cosa; Pubblica facilmente in pochi secondi i tuoi articoli in vendita. 2- Trova grandi offerte e sconti su vestiti, mobili, cellulari, elettronica, articoli per bambini, attrezzatura sportiva, attrezzatura per macchine, auto usate, abiti, scarpe e orologi, fino ai libri, giocattoli usati, computer portatili usati, macchine di seconda mano e persino immobili in vendita o in affitto. 3- Sfoglia gli articoli locali in vendita. 4- Contatta acquirenti e venditori tramite l'app. 5- Sfoglia gli elementi per immagine e ordina per categoria. Fatti divertenti su Elencato Vicino a Me: 1- Con Elencato Vicino a Me puoi facilmente vendere qualsiasi cosa, dai vestiti alle auto usate e l’elettronica. 2- La comunicazione tra acquirenti e venditori avviene attraverso l'app tramite messaggistica. 3- Elencato Vicino a Me è meglio di un mercatino d’usato; trova tutto ciò che vuoi con lo sconto direttamente sul tuo cellulare o tablet.",
    app_store_release:
      "Elencato vicino a me - fai affari con la gente del posto. Unisciti al mercato mobile per gli acquirenti e i venditori locali!",
    app_name: "Elencato vicino a me",
    title_buy: "Acquista",
    title_messages: "Messaggi",
    title_sell: "Vendi",
    title_profile_image: "Immagine del profilo",
    title_account: "Account",
    account_settings: "Impostazioni dell'account",
    settings: "Impostazioni",
    color_theme: "Tema del colore",
    device_settings: "Impostazioni del dispositivo",
    public_profile: "Profilo pubblico",
    light_mode: "Modalità chiara",
    dark_mode: "Modalità scura",
    title_sell_faster: "Vendi più velocemente",
    send_button_label: "Spedisci",
    rate_message: "Valutami…",
    already_rated: "Hai già inviato una recensione",
    rate_review_question: "Ti piacerebbe affrontare",
    again: "Di nuovo?",
    action_logout: "Disconnettiti",
    action_category: "Categoria",
    action_search: "Ricerca",
    action_refer: "Fai riferimento ad un amico",
    dialog_choose_location: "Scegli la posizione",
    dialog_change_username: "Cambia il nome dell'utente",
    dialog_change_language: "Cambia lingua",
    dialog_image_tags: "Tag dell'immagine",
    dialog_emails_notifications: "Notifiche email",
    dialog_push_notifications: "Notifiche push",
    fragment_product_detail: "Dettagli del prodotto",
    fragment_message_details: "Dettagli dei messaggi",
    fragment_sell: "Vendi",
    dialog_tags_title: "I Tag",
    dialog_location_title: "Aggiorna la posizione",
    dialog_username_title: "Cambia il nome dell'utente",
    tab_photo: "Foto",
    tab_details: "Dettagli",
    tab_price: "Prezzo",
    tab_finish: "Termina",
    profile: "Profilo",
    search: "Ricerca",
    choose_product: "Scegli il prodotto.",
    rating_review: "Valutazione e recensione",
    select_buyer: "Seleziona un acquirente",
    tab_my_used_products: "I miei prodotti",
    price_label: "Prezzo",
    text_savings: "Risparmi",
    search_hint: "Cerca dei prodotti…",
    empty_text:
      "Non ci sono dei prodotti elencati in questa categoria oppure a distanza selezionata.",
    filter_menu_text: "Filtro",
    error_contacting_seller:
      "Errore durante la prova di mettersi in contatto con il venditore",
    edit_product: "Modifica il prodotto",
    contact_seller: "Contatta il venditore",
    signup_to_contact_seller: "Iscriviti per contattare il venditore",
    signup_to_make_offer: "Iscriviti per fare un'offerta",
    product_details: "Dettagli",
    product_category: "Categoria",
    product_condition: "Condizione",
    product_description: "Descrizione",
    product_location: "Posizione del prodotto",
    product_location_approximate: "La posizione è approssimativa",
    over_week_time_ago: "Più di una settimana fa",
    boosted: "Con Boost",
    threads_no_results: "Nessun messaggio",
    message_no_results: "Nessun messaggio",
    message_warning:
      "Sei l'unico responsabile di prendere tutte le precauzioni necessarie quando interagisci con gli altri, in particolare quando si incontra uno sconosciuto di persona per la prima volta. Si prega di non condividere informazioni personali, codici di verifica o informazioni di pagamento. Si prega di rivedere i termini di servizio per maggiori dettagli.",
    message_block:
      "Non è possibile inviare o ricevere messaggi in questo momento.",
    select_location: "Seleziona la posizione",
    location_permission_denied_message:
      "L'app richiede il permesso di localizzazione per poter funzionare correttamente.",
    signed_in: "Accesso effettuato!",
    sign_in_canceller: "Accesso annullato",
    version: "Versione",
    build: "Costruisci",
    name: "Nome",
    location: "Posizione",
    language: "Lingua",
    about_app: "Informazioni su Elencato Vicino a Me",
    terms_of_service: "Termini di servizio",
    privacy_policy: "politica sulla riservatezza",
    report_feedback: "Invia feedback.",
    report_bug: "Scuoti il cellulare per segnalare un bug",
    change_image: "Cambia l'immagine",
    update_location: "Aggiorna la posizione",
    about_the_app: "Informazioni sull'app.",
    update_label: "Aggiornamento",
    uploading: "Caricamento in corso",
    adding: "Aggiunta dell'Elenco in corso",
    removing: "Rimozione dell'Elenco in corso",
    updating: "Aggiornamento dell'Elenco in corso",
    uploaded_image: "L'immagine caricata:",
    image_storage_failed: "Impossibile memorizzare l'immagine:",
    product_updated: "Prodotto aggiornato con successo",
    location_error: "Posizione non salvata, riprova per favore",
    product_removed: "Prodotto rimosso con successo",
    deleted_product: "Questo prodotto è stato soppresso",
    invalid_title: "Titolo non valido, per favore imposta il titolo di nuovo.",
    invalid_image:
      "Percorso immagine non valido, prova ad aggiungere l'immagine di nuovo.",
    invalid_price:
      "Prezzo non valido, si prega di impostare nuovamente il prezzo.",
    invalid_location:
      "Posizione non valida, si prega di impostare nuovamente la posizione.",
    invalid_category:
      "Categoria non valida, si prega di impostare nuovamente la categoria.",
    invalid_condition:
      "Condizione non valida, si prega di impostare nuovamente la condizione.",
    removing_title: "Rimozione dell'immagine del profilo in corso",
    image_not_saved: "Impossibile salvare l'immagine!",
    product_load_failed: "Nessun prodotto",
    take_photo: "Fai una foto",
    select_photo: "Seleziona una foto",
    product_title_hint: "Che cos'è? Nome, marchio, modello, ecc.",
    delete_photo: "Elimina foto",
    product_title: "Titolo",
    mark_as_sold: "Segna come venduto",
    product_share: "Condividi",
    product_make_offer: "Fai un'offerta",
    product_cover: "Imposta come l'immagine di copertina",
    product_tags: "I tag",
    product_posted: "Pubblicato:",
    product_change: "Modifica",
    product_post: "Pubblica",
    product_selling_from: "Vendita dalla posizione",
    product_select_location: "Seleziona la posizione",
    product_map_approximate:
      "La mappa è approssimativa per mantenere la posizione del venditore privata",
    product_terms:
      "Pubblicando il tuo prodotto accetti <U> i Termini di Servizio di Elencato Vicino a Me.</ U>",
    condition_other: "Altro (vedi descrizione)",
    condition_for_parts: "Per parti",
    condition_used: "Usato (usura normale)",
    condition_open_box: "La scatola aperta (mai usato)",
    condition_reconditioned: "Ricondizionato / certificato",
    condition_new: "Nuovo (mai usato)",
    select_category: "Seleziona categoria",
    select_all_category: "Seleziona tutto",
    category_loading_error:
      "Impossibile aggiornare l'elenco delle categorie, riprova più tardi.",
    category_vehicles: "Veicoli",
    category_furniture: "Arredamento",
    category_electronics: "Elettronica",
    category_appliances: "Casa & Elettrodomestici",
    category_fashion_accessories: "Moda & Accessori",
    category_baby_kids: "Bimbo & Bambini",
    category_antiques_collectibles:
      "Oggetti d'antiquariato & Oggetti da collezione",
    category_auto_parts_tools_machinery: "Ricambi auto, Attrezzi & Macchinari",
    category_sports_outdoors: "Sport & All'aperto",
    category_others: "Altri",
    location_enter_zip_code: "Inserisci il codice postale",
    location_get_current_location: "Ottieni la posizione corrente",
    location_select_location: "Seleziona la posizione",
    location_update_location: "Aggiorna la posizione",
    location_new_location: "Nuova posizione",
    search_filter_results: "Risultati dei filtri",
    search_filter_min: "Filtro minimo",
    search_filter_at_least: "Almeno",
    price_filter: "Filtro dei prezzi",
    product_name: "nome del prodotto",
    english_language: "inglese",
    arabic_language: "Arabo",
    spanish_language: "spagnolo",
    system_language: "Sistema",
    share_link: "Condividi il link",
    save: "Salva",
    cancel: "Annulla",
    loading: "Caricamento in corso",
    yes: "sì",
    no: "No",
    report: "Segnala",
    report_product: "Segnalare il prodotto",
    report_user: "Segnala l'utente",
    block_user: "Blocca l'utente",
    un_block_user: "Sblocca l'utente",
    why_product: "Perché vuoi segnalare questo oggetto?",
    why_user: "Perché vuoi segnalare questo utente?",
    block_user_confirm: "Vuoi bloccare in modo permanente questo utente?",
    un_block_user_confirm: "Vuoi sbloccare in modo permanente questo utente?",
    prohibited: "Vietato su Elencato VIcino a Me",
    offensive: "Offensivo o inappropriato",
    duplicate: "Post duplicato",
    wrong_category: "Categoria sbagliata",
    scam: "Sembra una truffa",
    stolen: "Penso che sia rubato",
    product_other: "Altro",
    product_is_sold: "Questo prodotto è stato venduto",
    missed_meeting: "Hanno perso il nostro incontro",
    low_offer: "Fatto un'offerta bassa",
    rude: "Maleducato o inappropriato",
    items: "Problema con gli articoli",
    trouble_meetup: "Problema durante l'incontro",
    messaging: "Problemi di messaggistica",
    user_other: "Altro",
    new_version_available: "Nuova versione disponibile",
    please_update_app:
      "Si prega di aggiornare l'app alla nuova versione per continuare.",
    update: "Aggiorna",
    no_thanks: "No grazie",
    contact_support_confirmation:
      "L'attuale tempo di risposta è di 24-48 ore. Vuoi contattare il chat di assistenza dell'app Elencato Vicino a Me?",
    unboost_confirmation:
      "Sei sicuro di voler togliere Boost a questo prodotto?",
    no_used_products: "Non hai ancora nessun annuncio",
    no_boosted_products: "Non hai nessun prodotto con Boost",
    next: "Prossimo",
    previous: "Precedente",
    skip: "Salta",
    start: "Comincia",
    list_used: "Elenca un prodotto usato",
    buy_description:
      "Scopri e cerca dei prodotti offerti dai vicini intorno a te",
    sell_description:
      "Elenca i prodotti che non ti servono più e mettili in vendita",
    list_used_description:
      "Metti in vendita un prodotto usato in meno di 20 secondi",
    boost_product_option_1: "<b>Boost 1\ngiorno </b>\n\n<b>$0.99</b>",
    boost_product_option_2: "<b>Boost 3\ngiorni</b>\n\n<b>$1.99</b>",
    boost_product_option_3: "<b>Boost 7\ngiorni</b>\n\n<b>$3.99</b>",
    boost_product_description:
      "Ottieni più visualizzazioni ogni giorno. Il tuo articolo occuperà la posizione in primo piano tra i primi 30 elementi negli elenchi Acquisto e Categoria. Gli articoli promossi vengono ruotati attorno ai punti designati in modo tale che ogni articolo ottenga una giusta esposizione.",
    boost_cta: "Vendi più velocemente",
    boost_terms:
      "Premendo su boost confermi di essere d'accordo con i <u>Termini di Servizio di Elencato Vicino a Me.</u>",
    boost_best_value: "Miglior valore",
    already_boosted: "A questo prodotto è stato messo Boost",
    clicks: "I click",
    impressions: "Impressioni",
    end: "Fine",
    transactions_empty_text:
      "Non hai ancora nessuna transazione di Boost. Puoi visitare la scheda Vendi e iniziare a potenziare i tuoi prodotti con il Boost",
    transactions_loading_error:
      "Non è possibile aggiornare l'elenco delle transazioni, riprova più tardi.",
    transactions_history_title: "Soria delle transazioni di Boost",
    communicative_postive: "Comunicativo",
    communicative_negative: "Poco comunicativo",
    ontime_postive: "In tempo",
    ontime_negative: "Tardi",
    reliable_postive: "Affidabile",
    reliable_negative: "Inaffidabile",
    friendly_postive: "Amichevole",
    friendly_negative: "Scortese",
    itemasdescribed_postive: "oggetto come descritto",
    itemasdescribed_negative: "Oggetto non è come descritto",
    other: "Altro",
    submit: "Invia",
    adding_rating_reviews: "Aggiunta di valutazione e recensioni",
    no_internet_title: "Nessuna connessione internet",
    no_internet_message: "Assicurati di essere connesso a Internet e riprova",
    retry: "Riprova",
    near_me: "Vicino a me",
    newest_first: "Prima i più recenti",
    miles: "miglia",
    km: "km",
    similar_products: "Prodotti Simili",
    favorite_products: "Prodotti preferiti",
    items_for_sale: "I prodotti in vendita",
    joined: "Si è unito",
    favorites_transactions_title: "Preferiti",
    boosted_products_transactions_history:
      "Storia delle transazioni dei prodotti con il Boost",
    views: "Visualizzazioni",
    boost_graph_title: "Grafico Boost",
    no_favorite_products: "Non hai nessun prodotto preferito",
    make_offer_buy: "vorrei comprare",
    make_offer_buy_for: "per",
    notifications: "Notifiche",
    push_notifications: "Spingi",
    emails_notifications: "E-mail",
    apply: "Applica",
    email_messages: "Email per messaggi",
    email_new_products: "Email per nuovi prodotti",
    push_day_only: "Le notifiche push solo durante il giorno",
    push_24_hours: "Notifiche push 24 ore",
    edit: "Modifica",
    map: "Mappa",
    camera: "Telecamera",
    gallery: "Galleria",
    delete: "Elimina",
    no_sell_items: "Nessun articolo in vendita",
    who_bought_question: "Chi lo ha comprato?",
    sold_elsewhere_question: "Venduto da qualche altra parte",
    confirm: "Conferma",
    over_limit_camera: "Non puoi aggiungere più di cinque immagini",
    boost_failed: "Boost fallito. Per favore riprova più tardi",
    after_purchase:
      "Pagamento avvenuto con successo\nBoost applicato per questo prodotto",
    pay_failed: "Pagamento fallito. Per favore riprova",
    done: "Fatto",
    not_now: "Non adesso",
    boost: "Boost",
    invalid_zip_code: "Codice postale errato",
    invalid_user_name: "Nome utente non valido",
    comments: "Commenti",
    questions: "Domande",
    bug_reports: "Segnalazioni dei bug",
    feature_request: "Richiesta di funzionalità",
    feedback_type: "Tipo di feedback",
    feedback_description:
      "Ci piacerebbe sentire i tuoi pensieri o il tuo feedback su come possiamo migliorare la tua esperienza!",
    feedback: "Risposta",
    feedback_text: "La tua risposta",
    suggestions: "Suggerimenti per un miglioramento",
    delete_account: "Elimina l'account",
    new_message: "Nuovo messaggio",
    online: "Online",
    km_50: "50 km",
    km_100: "100 km",
    km_200: "200 km",
    miles_30: "30 miglia",
    miles_60: "60 miglia.",
    miles_120: "120 miglia.",
    rate_app_question: "Allora che ne dici di una valutazione sull'App Store?",
    enjoying_question: "Ti sta piacendo Elencato Vicino a Me?",
    not_enjoy: "Non tanto",
    feedback_question: "Ti dispiacerebbe darci qualche feedback?",
    yes_sure: "Ok, certo",
    product_available_question: "Ciao, questo articolo è ancora disponibile?",
    buy_question: "Ciao, vorrei comprarlo",
    meet_question: "Ciao, sei disponibile per un incontro oggi?",
    follow: "Segui",
    followers: "Seguaci",
    following: "Stai seguendo",
    feedback_thanks: "Grazie per il tuo feedback",
    all_categories: "tutte le categorie",
    deleted_account: "Questo account è stato cancellato",
    delete_account_question: "Sei sicuro di voler cancellare questo account?",
    no_followings: "non segue nessuno",
    when_following: "quando",
    no_followings_subtitle: "segue le persone, le vedrai qui",
    no_followers: "non ha dei follower",
    no_followers_subtitle: "seguito dalle persone, le vedrai qui",
    distance: "Distanza",
    filter_method: "Metodo di filtro",
    see_listings: "Vedi elenchi",
    sold: "Venduto",
    bought: "Comprato",
    no_notifications: "Quando ricevi le notifiche, appariranno qui",
    items_title: "Altri oggetti",
    new_listing_title: "Crea un nuovo elenco",
    dialog_year_title: "Anno",
    dialog_make_title: "Fai",
    dialog_model_title: "Modello",
    dialog_body_style_title: "Stile corporeo",
    dialog_exterior_color_title: "Colore esterno",
    dialog_interior_color_title: "Colore interno",
    dialog_transmission_title: "Trasmissione",
    dialog_fuel_type_title: "Tipo di carburante",
    dialog_owners_num_title: "Numero di proprietari",
    dialog_vehicle_owed_money_title:
      "C'è denaro ancora dovuto su questo veicolo?",
    automatic_transmission: "Automatico",
    manual_transmission: "Manuale",
    not_sure: "Non sono sicuro",
    wagon_hatchback: "Carro & Hatchback",
    convertible: "Convertibile",
    coupe: "Coupé",
    sedan: "Berlina",
    black_color: "Nero",
    blue_color: "Blu",
    brown_color: "Marrone",
    gold_color: "Oro",
    green_color: "Verde",
    grey_color: "Grigio",
    pink_color: "Rosa",
    purple_color: "Viola",
    red_color: "rosso",
    silver_color: "Argento",
    orange_color: "Arancione",
    white_color: "bianco",
    yellow_color: "Giallo",
    charcol_color: "Carbone",
    fuel_diesel: "diesel",
    fuel_electric: "Elettrico",
    fuel_gasoline: "Benzina",
    fuel_flex: "Flessibile",
    fuel_hybrid: "Ibrido",
    fuel_petrol: "Benzina",
    fuel_plugin_hybrid: "Ibrido plug-in",
    truck: "Camion",
    van_minivan: "Van &  Minivan.",
    suv_crossover: "SUV &  Crossover.",
    awd_4wd: "AWD / 4WD.",
    fwd: "Fwd.",
    rwd: "Rwd.",
    off_white_color: "Bianco sporco",
    tan_color: "Abbronzatura",
    beige_color: "Beige",
    burgundy_color: "Borgogna",
    turquoise_color: "Turchese",
    title_status_clean: "Pulito",
    title_status_rebuilt: "Ricostruito",
    title_status_salvage: "Recuperato",
    title_status_missing: "Mancante",
    title_status_lien: "Pegno",
    title_status: "Stato del titolo",
    mileage: "Chilometraggio",
    dialog_drivetrain_title: "Trasmissione",
    model_warning: "Si prega di selezionare Fai prima",
    required_field_warning: "Questo campo è obbligatorio",
    vehicle_vin: "Vin.",
    invalid_vin: "Vin non valido, si prega di impostare nuovamente il vin.",
    invalid_mileage:
      "Chilometraggio non valido, si prega di impostare nuovamente il chilometraggio.",
    clean_description:
      "La maggior parte dei veicoli che non sono stati in un incidente",
    rebuilt_description: "Un'auto recuperata che è stata ricostruita",
    salvage_description: "È considerato totalizzato dopo un incidente",
    missing_description: "Avrà bisogno di un nuovo titolo di problemi DMV",
    lien_description: "Di proprietà di una banca o di un accordo giudiziario",
    nearme: "Vicino a me",
    newest: "Più recente",
    contact_support: "Contatta il supporto",
    create_home_title: "Case in vendita o affitto",
    for_sale: "In vendita",
    for_rent: "In affitto",
    property_type: "Tipo di proprietà",
    apartment: "Appartamento",
    house: "casa",
    room_only: "Solo una stanza",
    townhouse: "Casa a schiera",
    bedrooms: "Camere da letto",
    bathrooms: "Bagni",
    property_address: "Indirizzo di proprietà",
    price_per_month: "Prezzo al mese",
    square_feet: "Piedi quadrati",
    year_built: "Anno di costruzione",
    year_renovated: "Anno di ristrutturazione",
    lot_size: "Dimensione del lotto",
    laundry_type: "Tipo di lavanderia",
    in_unit_laundry: "Lavanderia interna",
    laundry_building: "Lavanderia nell'edificio",
    laundry_available: "Lavanderia disponibile",
    none: "Nessuno",
    parking_type: "Tipo di parcheggio",
    garage_parking: "Parcheggio in garage",
    street_parking: "Parcheggio in strada",
    off_street_parking: "Parcheggio fuori strada",
    available_parking: "Parcheggio disponibile",
    air_cond_type: "Tipo di climatizzazione",
    ac_available: "AC Disponibile",
    central_ac: "AC centrale",
    heating_type: "Tipo di riscaldamento",
    electric_heating: "Riscaldamento elettrico",
    gas_heating: "Riscaldamento a gas",
    radiator_heating: "Riscaldamento a radiatori",
    available_heating: "Riscaldamento disponibile",
    amenities: "Servizi",
    date_available: "Data Disponibile",
    lease_length: "Durata del contratto di locazione",
    month_to_month: "Di mese in mese",
    three_months: "3 mesi",
    six_months: "6 mesi",
    one_year: "1 anno",
    more_one_year: "1+ anni",
    cat_friendly: "A misura di gatto",
    dog_friendly: "A misura di cane",
    balcony: "Balcone",
    basement: "Seminterrato",
    bike_parking: "Parcheggio bici",
    cable_tv: "Tv via cavo",
    ceiling_fan: "Ventilatore",
    concierge: "Concierge",
    dishwasher: "Lavastoviglie",
    doorman: "Portiere",
    elevator: "Ascensore",
    fireplace: "Il camino",
    fitness_center: "Centro fitness",
    garbage_disposal: "Smaltimento dei rifiuti",
    microwave: "Microonde",
    online_app: "Applicazione online",
    oven: "Forno",
    package_service: "Servizio a pacchetto",
    patio: "Terrazza",
    pet_park: "Parco per animali domestici",
    refrigerator: "Frigorifero",
    resident_lounge: "Salotto per i residenti",
    roof_deck: "Terrazza sul tetto",
    secured_entry: "Ingresso protetto",
    storage: "Deposito",
    walk_in_closet: "Cabina armadio",
    swimming_pool: "Piscina",
    wheelchair_access: "Accesso per sedia a rotelle",
    central_heating: "Riscaldamento centralizzato",
    invalid_bedrooms:
      "Camere da letto non valide, si prega di impostare nuovamente le camere da letto.",
    invalid_bathrooms:
      "Bagni non validi, si prega di impostare di nuovo i bagni.",
    chinese_simplified_language: "Cinese semplificato",
    chinese_traditional_language: "Cinese tradizionale",
    czech_language: "ceco",
    danish_language: "danese",
    dutch_language: "olandese",
    finnish_language: "finlandese",
    french_language: "francese",
    german_language: "Tedesco",
    greek_language: "greco",
    hungarian_language: "ungherese",
    indonesian_language: "indonesiano",
    italian_language: "italiano",
    japanese_language: "giapponese",
    korean_language: "coreano",
    norwegian_language: "norvegese",
    polish_language: "polacco",
    portuguese_language: "portoghese",
    portuguese_brazilian_language: "Portoghese, brasiliano.",
    romanian_language: "rumeno",
    russian_language: "russo",
    swedish_language: "svedese",
    turkish_language: "Turco",
    ukrainian_language: "ucraino",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "vietnamita",
    category_home_sale_or_rent: "Casa in vendita o affitto",
    square_meter: "Metro quadro",
    copy_text: "copia",
    copyied_to_clipboard: "Copiato negli Appunti",
    inbox: "Posta in arrivo",
    input_title_listening: "Sto ascoltando…",
    input_subtitle_listening: "Dì qualcosa",
    input_title_error: "Siamo spiacenti, non l'abbiamo capito.",
    input_subtitle_error: "Prova a ripetere la tua richiesta.",
    input_hint_error: "Riprova",
    price_less_than_or_equal: "Prezzo inferiore o uguale a",
    any_price: "Qualsiasi prezzo",
    any_condition: "Qualsiasi condizione",
    any_time: "In qualsiasi momento",
    days_ago: "giorni fa",
    any_distance: "Qualsiasi distanza",
    distance_within: "Distanza fino a",
    new_notification: "Nuova notifica",
    deleted: "Cancellato",
    processing_image: "Immagine in fase di elaborazione",
    remove_dialog_message: "Sei sicuro di voler rimuovere questo prodotto?",
    deleted_thread: "Questo messaggio è stato soppresso",
    category_yard_sale_event: "Evento di svendita in giardino",
    yard_first_date: "La prima data di svendita in giardino",
    yard_second_date: "La seconda data di svendita in giardino",
    yard_third_date: "La terza data di svendita in giardino",
    yard_start_time: "Ora di inizio",
    yard_end_time: "Ora di fine",
    yard_end_timestamp: "Termina Timestamp",
    invalid_date1:
      "Prima data non valida, si prega di impostare nuovamente la prima data",
    invalid_start_time:
      "Ora di inizio non valida, si prega di impostare nuovamente l'ora di inizio",
    invalid_end_time:
      "Ora di fine non valida, si prega di impostare nuovamente l'ora di fine",
    yard_sale_title: "Svendita in giardino",
    garage_tag: "Garage",
    yard_tag: "cortile",
    from: "Da",
    to: "a",
    block: "Blocca",
    un_block: "ASblocca",
    sign_email: "Accedi con e-mail",
    invalid_first_date:
      "Prima data non valida, assicurati che la prima data sia prima di quella seconda e di quella terza",
    invalid_second_date:
      "Seconda data non valida, assicurati che la seconda data sia prima della terza data",
    invalid_start_time_value:
      "Ora di inizio non valida, assicurati che l'ora di inizio sia prima dell'ora di fine",
    use_default_yard_photo: "Usa la foto predefinita di svendita in giardino",
    active_label: "Attivo",
    enable_notifications: "Attiva le notifiche",
    login: "Login",
    january: "gennaio",
    february: "febbraio",
    march: "marzo",
    april: "aprile",
    may: "maggio",
    june: "giugno",
    july: "luglio",
    august: "agosto",
    september: "settembre",
    october: "ottobre",
    november: "novembre",
    december: "dicembre",
    since: "Da",
    product_views: "Visualizzazioni del prodotto",
    shop_views: "Visualizzazioni del negozio",
    total_sales: "Totale di vendite",
    total_orders: "Totale degli ordini",
    last_twelvth_months: "Ultimi dodici mesi",
    last_nine_months: "Ultimi nove mesi",
    last_six_months: "Ultimi sei mesi",
    last_three_months: "Ultimi tre mesi",
    last_12_months: "Ultimi 12 mesi",
    last_9_months: "Ultimi 9 mesi",
    last_6_months: "Ultimi 6 mesi",
    last_3_months: "Ultimi 3 mesi",
    months: "Mesi",
    open: "Apri",
    reset_password: "Resetta la password",
    create_new_shop: "Crea un nuovo negozio",
    download_app: "Scarica l'app",
    log_in: "Accedi",
    sign_up: "Iscriviti",
    no_result: "Nessun risultato",
    max_price: "Prezzo massimo",
    max_distance: "Distanza massima",
    max_time: "Tempo massimo",
    posted_less_than: "Pubblicato meno di",
    result: "Risultato",
    more: "Di più",
    or: "O",
    password: "Parola d'ordine",
    forgot_password: "Hai dimenticato la parola d'ordine?",
    and: "e",
    download_for: "Scarica per",
    apple_ios: "Apple IOS",
    android: "Android",
    image: "Immagine",
    edit_image: "Modifica immagine",
    please_complete: "Completa, per favore",
    enter_your_offer: "Inserisci la tua offerta",
    categories: "Categorie",
    upload_image: "Carica immagine",
    upload_images: "Carica immagini",
    back: "Indietro",
    see_more: "Vedi altro",
    add_product: "Aggiungi prodotto",
    selected: "Selezionato",
    create: "Crea",
    rate_the_buyer: "Valuta l'acquirente",
    delete_product: "Elimina prodotto",
    product: "Prodotto",
    un_block_product: "Sblocca il prodotto",
    share_your_product: "Condividi il tuo prodotto",
    boost_details: "Dettagli di Boost",
    remove_all_products: "Rimuovi tutti i prodotti",
    remove_all: "Rimuovi tutto",
    add_vehicle: "Aggiungi veicolo",
    edit_vehicle: "Modifica il veicolo",
    upload_a_photo: "Carica una foto",
    view_details: "Visualizza dettagli",
    add_yard_sale: "Aggiungi una svendita in giardino",
    edit_yard_sale: "Modifica la svendita in giardino",
    users: "Utenti",
    users_details: "Dettagli degli utenti",
    users_by_country: "Utenti per paese",
    blocked_users: "Utenti bloccati",
    products_cards: "Carte dei prodotti",
    archived_products: "Prodotti archiviati",
    blocked_products: "Prodotti bloccati",
    products_by_country: "Prodotti per paese",
    reports: "Rapporto",
    reports_details: "Dettagli dei rapporti",
    closed_reports: "Rapporti chiusi.",
    threads: "Fili",
    threads_details: "Dettagli dei fili",
    chat_support: "Supporto via chat",
    actions: "Azioni",
    search_actions: "Ricerca azioni",
    product_view_actions: "Visualizza le azioni per il prodotto",
    contact_seller_product: "Contatta il venditore del prodotto",
    contact_owner_shop: "Contatta il proprietario del negozio",
    ratings: "Valutazioni",
    reviews: "Recensioni",
    products_all_countries: "Prodotti Tutti i paesi",
    edit_profile: "Modifica Profilo",
    my_profile: "Il mio profilo",
    profile_updated_successfully: "Profilo aggiornato con successo",
    are_you_sure: "Sei sicuro",
    my_used_products: "I miei prodotti usati",
    my_shops: "I miei negozi",
    my_boosted_products: "I miei prodotti con Boost",
    messages_type_message_here: "Scrivi qui il tuo messaggio",
    messages_product_sold: "Questo prodotto è stato venduto o rimosso",
    seen: "Visto",
    messages_never_miss_message: "Non perdere mai un messaggio",
    enable: "Abilita",
    send_notify: "Invia notifica",
    un_close: "Svela",
    type_your_review: "Scrivi la tua recensione",
    again_question: "di nuovo?",
    ratings_already_submitted_review: "Hai già inviato una recensione",
    set_product_category: "Imposta la categoria del prodotto",
    auth_email_password_incorrect: "La tua e-mail oppure la password è errata",
    auth_insert_your_name: "Inserisci il tuo nome, per favore",
    auth_email_address_badly: "L'indirizzo email è stato formattato male",
    auth_email_address_used:
      "L'indirizzo email è già in uso da un altro account",
    auth_invalid_password: "La password dovrebbe essere di almeno 6 caratteri",
    auth_reset_email: "Inserisci la tua email per reimpostare la password",
    auth_check_email:
      "Per favore, controlla la tua email per ripristinare la password",
    auth_can_sign_in_google: "Puoi accedere con il pulsante di Google",
    auth_do_not_have_account: "Non hai un account?",
    auth_have_account: "Hai un account?",
    log_terms_privacy_part1:
      "Iscrivendoti o effettuando l'accesso accetti l'Elencato Vicino a Me",
    boost_this_product: "Vuoi mettere un Boost a questo prodotto?",
    product_successfully_boosted:
      "Boost messo con successo per questo prodotto",
    product_failed_boost:
      "L'operazione di mettere un Boost a questo prodotto fallita",
    no_products_for_sale:
      "Al momento non hai nessun prodotto usato in vendita.",
    not_sold_listed_near_me: "Non l'ho venduto su Elencato Vicino a Me",
    agree_add_product:
      "Premendo sul bottone per pubblicare il tuo prodotto accetti i Termini di Servizio e la Politica di Privacy di Elencato Vicino a Me.",
    click_to_boost: "Clicca sul prodotto per mettere un Boost",
    listed_terms_of_service: "Termini di Servizio di Elencato Vicino a Me",
    receive_emails_for_users: "Ricevi i messaggi degli utenti tramite e-mail",
    receive_emails_for_newly_posted:
      "Ricevi e-mail in risposta ai tuoi prodotti appena pubblicati",
    disable_push_notifications: "Disabilita le notifiche push",
    sms_during_day: "Ricevi SMS durante il giorno",
    sms_24_hours: "Ricevi SMS 24 ore",
    products: "Prodotti",
    product_no_longer_available:
      "Siamo spiacenti, questo prodotto non è più disponibile",
    add_home: "Aggiungi casa",
    edit_home: "Modifica casa",
    fill_required_fields: "Compila tutti i campi obbligatori",
    no_notification: "Non ci sono notifiche",
    orders_history: "Storia degli ordini",
    privacy: "Privacy",
    terms: "Termini",
    report_a_problem: "Segnala un problema",
    approximation_protect_user_privacy:
      "Approssimazione per proteggere la privacy dell'utente",
    do_not_have_products: "Non hai nessun prodotto",
    emails: "Email",
    lead_deletion_products:
      "Questo porterà alla cancellazione di tutti i tuoi prodotti",
    confirm_legal_message:
      "Sei l’unico responsabile di prendere tutte le precauzioni necessarie quando interagisci con gli altri, in particolare quando incontri uno sconosciuto di persona per la prima volta. Si prega di rivedere i Termini di Servizio per maggiori dettagli.",
    push_notifications_notified_instantly:
      "Abilita le notifiche push per essere avvisato immediatamente",
    rate_seller: "Valuta il venditore",
    user_journey: "Viaggio dell'utente",
    user: "Utente",
    user_id: "ID utente",
    action_id: "ID AZIONE",
    select_model_car: "Seleziona il modello di auto",
    boost_1_day: "Boost per 1 giorno",
    boost_3_days: "Boost per 3 giorni",
    boost_7_days: "Boost per 7 giorni",
    agree_boost_terms: "Premendo su Boost accetti",
    add: "Aggiungi",
    add_tag: "Aggiungi Tag",
    brand_title: "Marca",
    category_mobiles: "Cellulari",
    category_tablets: "Tablet",
    screen_size: "Grandezza dello schermo",
    has_cellular_capability: "Ha capacità cellulare",
    default_internal_memory: "Memoria interna",
    network_carrier: "Vettore di rete",
    is_unlocked: "È sbloccato",
    mobile_model_warning: "Per favore seleziona prima il marchio",
    missing_image: "Immagine mancante, prova ad aggiungere l'immagine di nuovo",
    add_mobile: "Aggiungi cellulare",
    edit_mobile: "Modifica cellulare",
    add_tablet: "Aggiungi Tablet",
    edit_tablet: "Modifica Tablet",
    keywords:
      "shopping, comprare, vendere, fare soldi, commercio, gente del posto, vicini, auto, veicoli",
    country: "Paese",
    phone_number: "Numero di telefono",
    verification_code: "Codice di verifica",
    error_occurred: "Si è verificato un errore, per favore riprova più tardi",
    invalid_state:
      "Stato non valido: è stata ricevuta una richiamata di accesso, ma non è stata inviata alcuna richiesta di accesso.",
    sign_in: "Registrazione",
    sign_in_apple: "Accedi con Apple",
    sign_in_google: "Accedi con Google",
    sign_in_phone: "Accedi con il telefono",
    sign_in_facebook: "Accedi con Facebook",
    create_account: "Creare un account",
    email: "E-mail",
    invalid_field: "Per favore riempi i campi richiesti",
    code_sent: "Il codice è stato inviato da SMS",
    verify_number: "Verifica il numero di telefono",
    tapping_verify_number:
      "Toccando (verificare il numero di telefono), viene inviato un SMS.",
    email_exists:
      "L'account esiste già e devi accedervi tramite il pulsante Google, pulsante Facebook o pulsante Apple",
    ok: "Ok",
    sure_back: "Sei sicuro di tornare?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "fa",
    add_model: "Aggiungi modello.",
    no_search_results_us:
      "Nessun risultato di ricerca vicino a te entro 120 miglia. Prova a modificare il filtro di ricerca o la parola chiave di ricerca.",
    no_search_results:
      "Nessun risultato di ricerca vicino a te entro 200 km. Prova a modificare il filtro di ricerca o la parola chiave di ricerca.",
    plan_date: "Data del piano",
    plan_time: "Tempo di pianificazione",
    invalid_plan_date:
      "Data del piano non valido, impostare nuovamente la data del piano",
    invalid_plan_time:
      "Tempo di piano non valido, si prega di fissare il tempo del piano",
    plan_name: "Nome del piano",
    plan_title: "Piano",
    update_plan_name: "Aggiorna il nome del piano",
    delete_plan_question: "Sei sicuro di voler eliminare questo piano?",
    plan_reminder_message: "Ti verrà ricordato un'ora prima",
    plan_dialog_title: "Piano di incontro",
    planners_title: "Pianificatori",
    unable_sending_messages:
      "Vedranno i tuoi messaggi quando torneranno online.",
    its_text: "È",
    for_your_text: "per il tuo ricevitore.",
  },
  ja: {
    invalid_area: "無効なエリア、再度エリアを設定してください。",
    invalid_lot_size:
      "プロパティロットサイズが無効です。ロットサイズをもう一度設定してください。",
    property_area: "財産地域",
    app_store_name: "私の近くにリストされています - 中古品の購入、現金で売る",
    app_store_short:
      "地元の売り手のマーケットプレイス。販売の項目をリストしてお金を稼ぐ。",
    app_store_full:
      "私の近くに上場しているのは、あなたが望むものを見つけて、あなたが売りたいものにお金を稼ぐことを簡単に見つけることができます。これはあなたのコミュニティや近所であなたが信頼できる人々と共に売買するための最良の方法です。それがどのように機能するか：1  - 何も購入または売ってください。数秒であなたの商品を簡単に投稿してください。 2-服、家具、携帯電話、エレクトロニクス、赤ちゃんや子供のアイテム、スポーツ用品、中古車、ドレス、靴、腕時計、靴、中古のラップトップ、中古車、中古車など販売または家賃のための不動産。 3-販売のための地元の商品を閲覧する。 4-アプリ内からの購入者と売り手。 5-画像でアイテムを閲覧し、カテゴリ別に並べ替えます。私の近くに上場されているのは楽しい事実：1-私の近くにリストされているとあなたは簡単に服から中古車への電子機器まで、何か簡単に売ることができます。 2-バイヤーと売り手の間のコミュニケーションは、メッセージングを介してアプリを介して行われます。 3  - 私の近くにリストされているガレージセールよりも優れています。あなたがあなたの携帯電話やタブレットの上の割引で欲しいものを見つけてください。",
    app_store_release:
      "私の近くにリストされています - 地元の人々との取引。地元のバイヤーと売り手のためのモバイルマーケットプレイスに参加しよう！",
    app_name: "私の近くに上場",
    title_buy: "買う",
    title_messages: "メッセージ",
    title_sell: "売る",
    title_profile_image: "プロフィール画像",
    title_account: "アカウント",
    account_settings: "アカウント設定",
    settings: "設定",
    color_theme: "カラーテーマ",
    device_settings: "デバイスの設定",
    public_profile: "公共プロファイル",
    light_mode: "光モード",
    dark_mode: "暗いモード",
    title_sell_faster: "早く売る",
    send_button_label: "送信",
    rate_message: "私を評価...",
    already_rated: "あなたはすでに審査を受けた",
    rate_review_question: "対処したいですか",
    again: "また？",
    action_logout: "ログアウト",
    action_category: "カテゴリー",
    action_search: "検索",
    action_refer: "友達を参照してください",
    dialog_choose_location: "場所を選択してください",
    dialog_change_username: "ユーザー名を変更してください",
    dialog_change_language: "言語を変えてください",
    dialog_image_tags: "画像タグ",
    dialog_emails_notifications: "通知をメールで送信します",
    dialog_push_notifications: "プッシュ通知",
    fragment_product_detail: "製品の詳細",
    fragment_message_details: "メッセージの詳細",
    fragment_sell: "売る",
    dialog_tags_title: "タグ",
    dialog_location_title: "場所を更新します",
    dialog_username_title: "ユーザー名を変更してください",
    tab_photo: "写真",
    tab_details: "詳細",
    tab_price: "価格",
    tab_finish: "終了",
    profile: "プロフィール",
    search: "検索",
    choose_product: "商品を選択してください",
    rating_review: "評価とレビュー",
    select_buyer: "買い手を選択してください",
    tab_my_used_products: "私の製品",
    price_label: "価格",
    text_savings: "保存します",
    search_hint: "製品を検索する...",
    empty_text:
      "このカテゴリにリストされている製品はなく、または選択した距離内にありません。",
    filter_menu_text: "フィルター",
    error_contacting_seller: "販売者に連絡してください",
    edit_product: "商品を編集する",
    contact_seller: "販売者に連絡してください",
    signup_to_contact_seller: "販売元に連絡するために登録してください",
    signup_to_make_offer: "申し出をするためにサインアップしてください",
    product_details: "詳細",
    product_category: "カテゴリー",
    product_condition: "調子",
    product_description: "説明",
    product_location: "製品の場所",
    product_location_approximate: "場所はおよそです",
    over_week_time_ago: "1週間前に",
    boosted: "ブースト",
    threads_no_results: "メッセージなし",
    message_no_results: "メッセージなし",
    message_warning:
      "特に初めて見知らぬ人と直接会うとき、他の人とやり取りするときに必要なすべての予防措置を講じることにあなたは単独で責任を負います。個人情報、検証コード、または支払い情報を共有しないでください。詳細については、利用規約を確認してください。",
    message_block: "現時点でメッセージを送受信できません。",
    select_location: "場所を選択してください",
    location_permission_denied_message:
      "アプリは位置決め許可を正しく機能させる必要があります。",
    signed_in: "サインインしました！",
    sign_in_canceller: "キャンセルしました",
    version: "バージョン",
    build: "建てる",
    name: "名前",
    location: "位置",
    language: "言語",
    about_app: "私の近くにリストされている",
    terms_of_service: "利用規約",
    privacy_policy: "プライバシーポリシー",
    report_feedback: "フィードバックを送る",
    report_bug: "バグを報告するために電話を振る",
    change_image: "画像を変更する",
    update_location: "場所を更新します",
    about_the_app: "アプリについて",
    update_label: "アップデート",
    uploading: "アップロード",
    adding: "リストを追加する",
    removing: "リストを削除します",
    updating: "リストの更新",
    uploaded_image: "アップロードされたイメージ：",
    image_storage_failed: "画像を保存できませんでした：",
    product_updated: "製品が正常に更新されました",
    location_error: "保存されていない場所、もう一度やり直してください",
    product_removed: "製品が正常に削除されました",
    deleted_product: "この商品は削除されています",
    invalid_title: "無効なタイトル、もう一度タイトルを設定してください。",
    invalid_image: "無効な画像パスをもう一度追加してください。",
    invalid_price: "価格が無効な場合は、再度価格を設定してください。",
    invalid_location: "無効な場所、もう一度場所を設定してください。",
    invalid_category: "無効なカテゴリ、もう一度カテゴリを設定してください。",
    invalid_condition: "無効な状態、もう一度状態を設定してください。",
    removing_title: "プロファイル画像の削除",
    image_not_saved: "イメージ保存に失敗しました！",
    product_load_failed: "製品なし",
    take_photo: "写真を撮る",
    select_photo: "写真を選択してください",
    product_title_hint: "それは何ですか？名前、ブランド、モデルなど",
    delete_photo: "写真を削除します",
    product_title: "タイトル",
    mark_as_sold: "販売されているマーク",
    product_share: "シェア",
    product_make_offer: "申し出をする",
    product_cover: "カバー画像として設定します",
    product_tags: "タグ",
    product_posted: "投稿：",
    product_change: "変化する",
    product_post: "役職",
    product_selling_from: "場所からの販売",
    product_select_location: "場所を選択してください",
    product_map_approximate:
      "マップは売り手の場所をプライベートに保つための概算です",
    product_terms:
      "あなたの製品を公開するために投稿をタップすることによって、あなたは私のサービス条件の近くにリストされています。</ u>",
    condition_other: "その他（説明を参照）",
    condition_for_parts: "部品用",
    condition_used: "使用（通常の摩耗）",
    condition_open_box: "開くボックス（未使用）",
    condition_reconditioned: "再調整/認定",
    condition_new: "新しい（未使用）",
    select_category: "カテゴリを選んでください",
    select_all_category: "すべて選択",
    category_loading_error:
      "カテゴリ一覧を更新できませんので、後でもう一度やり直してください。",
    category_vehicles: "車両",
    category_furniture: "家具",
    category_electronics: "エレクトロニクス",
    category_appliances: "ホーム＆アンプ。電化製品",
    category_fashion_accessories: "ファッション＆アンプ付属品",
    category_baby_kids: "赤ちゃんとアンプ。子供たち",
    category_antiques_collectibles: "アンティーク＆アンプ。グッズ",
    category_auto_parts_tools_machinery: "自動車部品、ツール＆アンプ。機械",
    category_sports_outdoors: "スポーツ＆アンプ。屋外",
    category_others: "他人",
    location_enter_zip_code: "郵便番号を入力",
    location_get_current_location: "現在の場所を入手してください",
    location_select_location: "場所を選択してください",
    location_update_location: "場所を更新します",
    location_new_location: "新しい場所",
    search_filter_results: "結果を絞り込む",
    search_filter_min: "最小値をフィルタリングします",
    search_filter_at_least: "少なくとも",
    price_filter: "価格フィルター",
    product_name: "商品名",
    english_language: "英語",
    arabic_language: "アラビア語",
    spanish_language: "スペイン語",
    system_language: "システム",
    share_link: "共有リンク",
    save: "保存する",
    cancel: "キャンセル",
    loading: "ロード",
    yes: "はい",
    no: "番号",
    report: "報告する",
    report_product: "商品を報告する",
    report_user: "レポートユーザー",
    block_user: "ユーザをブロックする",
    un_block_user: "ユーザーをブロック解除します",
    why_product: "なぜあなたはこのアイテムを報告したいのですか？",
    why_user: "なぜあなたはこのユーザーを報告したいのですか？",
    block_user_confirm: "このユーザーを恒久的にブロックしたいですか？",
    un_block_user_confirm:
      "あなたはこのユーザーを恒久的にブロック解除しますか？",
    prohibited: "私の近くに上場されているのは禁止されています",
    offensive: "攻撃的または不適切なもの",
    duplicate: "郵便を複製します",
    wrong_category: "間違ったカテゴリー",
    scam: "詐欺のように見えます",
    stolen: "盗まれていると思います",
    product_other: "他の",
    product_is_sold: "この商品は販売されました",
    missed_meeting: "彼らは私たちの会議を逃しました",
    low_offer: "低いオファーをしました",
    rude: "失礼や不適切な",
    items: "アイテムの問題",
    trouble_meetup: "出会いのトラブル",
    messaging: "メッセージングの問題",
    user_other: "他の",
    new_version_available: "利用可能な新しいバージョン",
    please_update_app:
      "続行するには、新しいバージョンにアプリを更新してください。",
    update: "アップデート",
    no_thanks: "結構です",
    contact_support_confirmation:
      "現在の応答時間は24~48時間です。あなたは私の近くにリストされているアプリチャットサポートに連絡したいですか？",
    unboost_confirmation:
      "あなたはこの製品を解体しないように確信していますか？",
    no_used_products: "あなたはまだリストを持っていません",
    no_boosted_products: "あなたはブーストされた製品を持っていません",
    next: "次",
    previous: "前",
    skip: "スキップ",
    start: "始める",
    list_used: "中古製品を一覧表示します",
    buy_description:
      "あなたの周りの隣人によって提供される製品を発見して検索する",
    sell_description: "あなたがもはやSaleを必要としない製品をリストします",
    list_used_description: "20秒未満での販売のための中古品をリストする",
    boost_product_option_1: "<B> Boost 1  Nday </ B>  N  N <B> $ 0.99 </ B>",
    boost_product_option_2: "<B> Boost 3  Ndays </ B>  N  N <B> $ 1.99 </ B>",
    boost_product_option_3: "<B> Boost 7  Ndays </ B>  N  N <B> $ 3.99 </ B>",
    boost_product_description:
      "毎日より多くの景色を眺めることができます。あなたのアイテムは、購入とカテゴリの上位30のアイテム内の特徴的なポジションに表示されます。すべてのアイテムが公正な露出を受けるため、宣伝されたアイテムが指定されたスポットの間で回転します。",
    boost_cta: "早く売る",
    boost_terms:
      "ブーストをタップすることによって、あなたは私のサービス条件の近くにリストされていることに同意します。</ u>",
    boost_best_value: "お買い得",
    already_boosted: "この商品はブーストされています",
    clicks: "クリック",
    impressions: "im im",
    end: "終わり",
    transactions_empty_text:
      "ブーストトランザクションはまだありません。あなたは販売タブを訪問してあなたの製品を後押しし始めることができます。",
    transactions_loading_error:
      "トランザクションリストを更新できませんので、後でもう一度やり直してください。",
    transactions_history_title: "トランザクションの履歴を追加しました",
    communicative_postive: "コミュニケーション",
    communicative_negative: "un un",
    ontime_postive: "定刻",
    ontime_negative: "遅い",
    reliable_postive: "信頼性のある",
    reliable_negative: "信頼できない",
    friendly_postive: "フレンドリー",
    friendly_negative: "imp imp",
    itemasdescribed_postive: "記載されているようなアイテム",
    itemasdescribed_negative: "記載されていない項目",
    other: "他の",
    submit: "送信",
    adding_rating_reviews: "評価とレビューを追加する",
    no_internet_title: "インターネット接続はありません",
    no_internet_message:
      "あなたがインターネットに接続されていることを確認してもう一度やり直してください",
    retry: "リトライ",
    near_me: "私の近く",
    newest_first: "最新の指",
    miles: "マイル",
    km: "km",
    similar_products: "同様の商品",
    favorite_products: "好きな製品",
    items_for_sale: "販売商品",
    joined: "結合しました",
    favorites_transactions_title: "favor favor",
    boosted_products_transactions_history: "ブースト製品トランザクションの履歴",
    views: "ビュー",
    boost_graph_title: "ブーストグラフ",
    no_favorite_products: "あなたは好きな製品を持っていません",
    make_offer_buy: "私は買いたいです",
    make_offer_buy_for: "にとって",
    notifications: "通知",
    push_notifications: "押す",
    emails_notifications: "Eメール",
    apply: "申し込み",
    email_messages: "メッセージの電子メール",
    email_new_products: "新製品の電子メール",
    push_day_only: "通知のみをプッシュするだけです",
    push_24_hours: "24時間のプッシュ通知",
    edit: "編集",
    map: "地図",
    camera: "カメラ",
    gallery: "ギャラリー",
    delete: "消去",
    no_sell_items: "商品はありません",
    who_bought_question: "誰がそれを買ったのですか？",
    sold_elsewhere_question: "他の場所に売った",
    confirm: "確認",
    over_limit_camera: "5つ以上の画像を追加することはできません",
    boost_failed: "ブーストに失敗しました。後でもう一度やり直してください",
    after_purchase: "支払い成功 NProductブースト",
    pay_failed: "支払いに失敗しました。もう一度やり直してください",
    done: "終わり",
    not_now: "今はやめろ",
    boost: "ブースト",
    invalid_zip_code: "無効な郵便番号",
    invalid_user_name: "無効なユーザー名",
    comments: "コメント",
    questions: "質問",
    bug_reports: "バグレポート",
    feature_request: "機能リクエスト",
    feedback_type: "フィードバックタイプ",
    feedback_description:
      "私たちはあなたの考えやフィードバックを聞きたいのですが、私たちがあなたの経験を改善できる方法について！",
    feedback: "フィードバック",
    feedback_text: "あなたの答え",
    suggestions: "改善のための提案",
    delete_account: "アカウントを削除する",
    new_message: "新しいメッセージ",
    online: "オンライン",
    km_50: "50キロ",
    km_100: "100キロ",
    km_200: "200 km",
    miles_30: "30マイル",
    miles_60: "60マイル",
    miles_120: "120マイル",
    rate_app_question: "App Storeに対する評価はどうですか、それから？",
    enjoying_question: "私の近くにリストされていますか？",
    not_enjoy: "あまり",
    feedback_question:
      "あなたは私たちにいくらかのフィードバックを与えてくれませんか？",
    yes_sure: "わかりました",
    product_available_question: "こんにちは、これはまだ利用可能ですか？",
    buy_question: "こんにちは、私はこれを買うのが好きです",
    meet_question: "こんにちは、あなたは今日会えますか？",
    follow: "従う",
    followers: "フォロワー",
    following: "続く",
    feedback_thanks: "ご意見ありがとうございます",
    all_categories: "すべてのカテゴリ",
    deleted_account: "このアカウントは削除されます",
    delete_account_question: "このアカウントを削除してよろしいですか？",
    no_followings: "誰にも従わなかった",
    when_following: "いつ",
    no_followings_subtitle:
      "人々に従います、あなたはそれらをここに見るでしょう",
    no_followers: "フォロワーを持っていません",
    no_followers_subtitle: "その後に、あなたはここにそれらを見るでしょう",
    distance: "距離",
    filter_method: "フィルタ法",
    see_listings: "リストを見てください",
    sold: "販売された",
    bought: "買った",
    no_notifications: "通知を受け取ったら、ここに表示されます",
    items_title: "アイテム",
    new_listing_title: "新しいリストを作成します",
    dialog_year_title: "年",
    dialog_make_title: "作る",
    dialog_model_title: "モデル",
    dialog_body_style_title: "ボディスタイル",
    dialog_exterior_color_title: "外装",
    dialog_interior_color_title: "内部の色",
    dialog_transmission_title: "伝染;感染",
    dialog_fuel_type_title: "燃料のタイプ",
    dialog_owners_num_title: "所有者の数",
    dialog_vehicle_owed_money_title:
      "まだこの車両に残っているお金はありますか？",
    automatic_transmission: "自動的に",
    manual_transmission: "マニュアル",
    not_sure: "わからない",
    wagon_hatchback: "ワゴン＆アンプ。ハッチバック",
    convertible: "convert convert",
    coupe: "クーペ",
    sedan: "セダン",
    black_color: "黒",
    blue_color: "青い",
    brown_color: "茶色",
    gold_color: "ゴールド",
    green_color: "緑",
    grey_color: "グレー",
    pink_color: "ピンク",
    purple_color: "紫の",
    red_color: "赤",
    silver_color: "銀",
    orange_color: "オレンジ",
    white_color: "白い",
    yellow_color: "黄色",
    charcol_color: "カーコール",
    fuel_diesel: "ディーゼル",
    fuel_electric: "電気の",
    fuel_gasoline: "ガソリン",
    fuel_flex: "フレックス",
    fuel_hybrid: "ハイブリッド",
    fuel_petrol: "ガソリン",
    fuel_plugin_hybrid: "プラグインハイブリッド",
    truck: "トラック",
    van_minivan: "バン＆アンプ。ミニバン",
    suv_crossover: "SUV＆ cross cross",
    awd_4wd: "awd / 4wd",
    fwd: "f",
    rwd: "RWD.",
    off_white_color: "オフホワイト",
    tan_color: "焼け",
    beige_color: "ベージュ",
    burgundy_color: "ブルゴーニュ",
    turquoise_color: "ターコイズ",
    title_status_clean: "綺麗",
    title_status_rebuilt: "再建しました",
    title_status_salvage: "引き上げ",
    title_status_missing: "ない",
    title_status_lien: "先生の",
    title_status: "タイトルのステータス",
    mileage: "マイレージ",
    dialog_drivetrain_title: "ドライブトレイン",
    model_warning: "命を選択してください",
    required_field_warning: "この項目は必須です",
    vehicle_vin: "v",
    invalid_vin: "無効なVIN、もう一度VINを設定してください。",
    invalid_mileage: "無効なマイレージ、もう一度マイレージを設定してください。",
    clean_description: "偶然に行っていないほとんどの車両",
    rebuilt_description: "再建された救済車",
    salvage_description: "偶然の後に合計されたと見なされます",
    missing_description: "新しいDMVの問題のタイトルが必要です",
    lien_description: "銀行または裁判所の和解によって所有されています",
    nearme: "私の近く",
    newest: "最新",
    contact_support: "サポート問い合わせ先",
    create_home_title: "販売または家賃のための家",
    for_sale: "売り上げ",
    for_rent: "賃貸用",
    property_type: "プロパティタイプ",
    apartment: "アパート",
    house: "家",
    room_only: "部屋のみ",
    townhouse: "タウンハウス",
    bedrooms: "寝室",
    bathrooms: "バスルーム",
    property_address: "プロパティアドレス",
    price_per_month: "1ヶ月あたりの価格",
    square_feet: "平方フィート",
    year_built: "年生産",
    year_renovated: "年の改装されました",
    lot_size: "ロットサイズ",
    laundry_type: "ランドリータイプ",
    in_unit_laundry: "ユニット洗濯物",
    laundry_building: "建物の洗濯物",
    laundry_available: "利用可能なランドリー",
    none: "なし",
    parking_type: "駐車場",
    garage_parking: "ガレージパーキング",
    street_parking: "街駐車場",
    off_street_parking: "道路外駐車",
    available_parking: "利用可能な駐車場",
    air_cond_type: "エアコンタイプ",
    ac_available: "AC ATAV",
    central_ac: "中央AC.",
    heating_type: "暖房タイプ",
    electric_heating: "電気加熱",
    gas_heating: "ガス加熱",
    radiator_heating: "ラジエーター加熱",
    available_heating: "利用可能な暖房",
    amenities: "アメニティ",
    date_available: "利用可能な日付",
    lease_length: "リースの長さ",
    month_to_month: "月から月まで",
    three_months: "3ヶ月",
    six_months: "6ヵ月",
    one_year: "1年",
    more_one_year: "1年以上",
    cat_friendly: "キャットフレンドリー",
    dog_friendly: "犬にやさしい",
    balcony: "バルコニー",
    basement: "地下",
    bike_parking: "バイクパーキング",
    cable_tv: "ケーブルテレビ",
    ceiling_fan: "天井ファン",
    concierge: "コンシェルジュ",
    dishwasher: "食器洗い機",
    doorman: "ドアマン",
    elevator: "エレベーター",
    fireplace: "暖炉",
    fitness_center: "フィットネスセンター",
    garbage_disposal: "生ごみ処理機",
    microwave: "電子レンジ",
    online_app: "オンラインアプリケーション",
    oven: "オーブン",
    package_service: "パッケージサービス",
    patio: "パティオ",
    pet_park: "ペットパーク",
    refrigerator: "冷蔵庫",
    resident_lounge: "居住者ラウンジ",
    roof_deck: "屋根デッキ",
    secured_entry: "保護されたエントリー",
    storage: "ストレージ",
    walk_in_closet: "ウォークインクローゼット",
    swimming_pool: "スイミングプール",
    wheelchair_access: "車椅子アクセス",
    central_heating: "セントラルヒーティング",
    invalid_bedrooms: "無効な寝室、もう一度寝室を設定してください。",
    invalid_bathrooms:
      "無効なバスルーム、バスルームをもう一度設定してください。",
    chinese_simplified_language: "中国語（簡体字",
    chinese_traditional_language: "中国の伝統的な",
    czech_language: "チェコ",
    danish_language: "デンマーク人",
    dutch_language: "オランダの",
    finnish_language: "フィンランド語",
    french_language: "フランス語",
    german_language: "ドイツ人",
    greek_language: "ギリシャ語",
    hungarian_language: "ハンガリー語",
    indonesian_language: "インドネシア語",
    italian_language: "イタリア語",
    japanese_language: "日本",
    korean_language: "韓国語",
    norwegian_language: "ノルウェー語",
    polish_language: "研磨",
    portuguese_language: "ポルトガル語",
    portuguese_brazilian_language: "ポルトガル語、ブラジル人",
    romanian_language: "ルーマニア語",
    russian_language: "ロシア",
    swedish_language: "スウェーデンの",
    turkish_language: "トルコ語",
    ukrainian_language: "ウクライナの",
    urdu_pakistan_language: "ウルドゥー（パキスタン）",
    vietnamese_language: "ベトナム人",
    category_home_sale_or_rent: "販売または賃貸のための家",
    square_meter: "平方メートル",
    copy_text: "コピー",
    copyied_to_clipboard: "クリップボードにコピーされました",
    inbox: "受話器",
    input_title_listening: "聞いている…",
    input_subtitle_listening: "何か言って",
    input_title_error: "申し訳ありませんが、私たちはそれをかなり得なかった。",
    input_subtitle_error: "あなたの要求を繰り返してみてください。",
    input_hint_error: "再試行",
    price_less_than_or_equal: "価格以下",
    any_price: "あらゆる価格",
    any_condition: "任意の条件",
    any_time: "いつでも",
    days_ago: "数日前",
    any_distance: "距離",
    distance_within: "内の距離",
    new_notification: "新しい通知",
    deleted: "削除されました",
    processing_image: "処理画像の処理",
    remove_dialog_message: "あなたは本当にこの製品を取り除きたいですか？",
    deleted_thread: "このメッセージは削除されます",
    category_yard_sale_event: "ヤードセールイベント",
    yard_first_date: "ヤードセール初日",
    yard_second_date: "ヤードセール2日日",
    yard_third_date: "ヤードセール3日日曜日",
    yard_start_time: "始まる時間",
    yard_end_time: "終了時間",
    yard_end_timestamp: "終了タイムスタンプ",
    invalid_date1: "無効な最初の日付、最初の日付をもう一度設定してください",
    invalid_start_time:
      "開始時刻が無効な場合は、開始時刻をもう一度設定してください",
    invalid_end_time: "無効な終了時間、もう一度終了時刻を設定してください",
    yard_sale_title: "ヤードセール",
    garage_tag: "ガレージ",
    yard_tag: "ヤード",
    from: "から",
    to: "に",
    block: "ブロック",
    un_block: "戴く",
    sign_email: "電子メールでサインインします",
    invalid_first_date:
      "無効な最初の日付は、最初の日付が2番目と3番目の前にあることを確認してください",
    invalid_second_date:
      "2回目の日付は2日目以前の日付が3日前にあることを確認してください",
    invalid_start_time_value:
      "開始時刻が無効な場合は、開始時刻が終了する前に必ず確認してください",
    use_default_yard_photo: "デフォルトのヤードセール写真を使用してください",
    active_label: "アクティブ",
    enable_notifications: "通知を有効にします",
    login: "ログイン",
    january: "1月",
    february: "2月",
    march: "行進",
    april: "4月",
    may: "5月",
    june: "六月",
    july: "j",
    august: "aug.",
    september: "9月",
    october: "10月",
    november: "11月",
    december: "12月",
    since: "以来",
    product_views: "製品の閲覧",
    shop_views: "ショップビュー",
    total_sales: "総売上高",
    total_orders: "総順序",
    last_twelvth_months: "最後の12ヶ月",
    last_nine_months: "最後の9ヶ月",
    last_six_months: "過去6ヶ月",
    last_three_months: "過去3ヶ月",
    last_12_months: "過去12ヶ月",
    last_9_months: "過去9ヶ月",
    last_6_months: "過去6ヶ月",
    last_3_months: "過去3ヶ月",
    months: "月",
    open: "開ける",
    reset_password: "パスワードを再設定する",
    create_new_shop: "新しい店を作成します",
    download_app: "アプリをダウンロードする",
    log_in: "ログイン",
    sign_up: "サインアップ",
    no_result: "検索結果はありません",
    max_price: "最高価格",
    max_distance: "最大距離",
    max_time: "最大時間",
    posted_less_than: "より少ない投稿",
    result: "結果",
    more: "もっと",
    or: "また",
    password: "パスワード",
    forgot_password: "パスワードをお忘れですか？",
    and: "と",
    download_for: "フォードをダウンロード",
    apple_ios: "アップルios.",
    android: "アンドロイド",
    image: "画像",
    edit_image: "画像を編集します",
    please_complete: "完了してください",
    enter_your_offer: "あなたの申し出を入力してください",
    categories: "カテゴリー",
    upload_image: "画像をアップロードしてください",
    upload_images: "画像をアップロードする",
    back: "戻る",
    see_more: "続きを見る",
    add_product: "商品を追加してください",
    selected: "selected",
    create: "作成",
    rate_the_buyer: "買い手を評価します",
    delete_product: "商品を削除します",
    product: "製品",
    un_block_product: "商品をブロック解除します",
    share_your_product: "あなたの商品を共有してください",
    boost_details: "ブースト詳細",
    remove_all_products: "すべての製品を削除してください",
    remove_all: "すべて削除する",
    add_vehicle: "車を追加してください",
    edit_vehicle: "車を編集する",
    upload_a_photo: "写真をアップロードしてください",
    view_details: "詳細を見る",
    add_yard_sale: "ヤードセールを追加してください",
    edit_yard_sale: "ヤードを編集する",
    users: "ユーザー",
    users_details: "ユーザーの詳細",
    users_by_country: "国によるユーザー",
    blocked_users: "ブロックされたユーザー",
    products_cards: "製品カード",
    archived_products: "アーカイブ製品",
    blocked_products: "ブロックされた製品",
    products_by_country: "国による製品",
    reports: "報告する",
    reports_details: "詳細を報告します",
    closed_reports: "クローズドレポート",
    threads: "スレッド",
    threads_details: "スレッドの詳細",
    chat_support: "チャットサポート",
    actions: "行動",
    search_actions: "検索アクション",
    product_view_actions: "製品ビューアクション",
    contact_seller_product: "売り手の製品に連絡してください",
    contact_owner_shop: "所有者店にお問い合わせください",
    ratings: "評価",
    reviews: "レビュー",
    products_all_countries: "製品すべての国",
    edit_profile: "プロファイル編集",
    my_profile: "私のプロフィール",
    profile_updated_successfully: "プロファイルは正常に更新されました",
    are_you_sure: "本気ですか",
    my_used_products: "私の中古品",
    my_shops: "私の店",
    my_boosted_products: "私のブーストされた製品",
    messages_type_message_here: "ここにあなたのメッセージを入力してください",
    messages_product_sold: "この製品は販売または削除されています",
    seen: "seen",
    messages_never_miss_message: "メッセージを見逃すことはありません",
    enable: "有効",
    send_notify: "通知を送ります",
    un_close: "閉じ込める",
    type_your_review: "レビューを入力してください",
    again_question: "また ？",
    ratings_already_submitted_review: "あなたはすでに審査を受けた",
    set_product_category: "製品カテゴリーを設定します",
    auth_email_password_incorrect:
      "あなたの電子メールまたはパスワードが間違っています",
    auth_insert_your_name: "あなたの名前を挿入してください",
    auth_email_address_badly:
      "電子メールアドレスはひどくフォーマットされています",
    auth_email_address_used:
      "電子メールアドレスはすでに別のアカウントで使用されています",
    auth_invalid_password: "パスワードは少なくとも6文字になる必要があります",
    auth_reset_email: "パスワードをリセットするためにEメールを入力してください",
    auth_check_email:
      "パスワードをリセットするためにあなたのEメールをチェックしてください",
    auth_can_sign_in_google: "Googleボタンでサインインできます",
    auth_do_not_have_account: "アカウントがありませんか？",
    auth_have_account: "あなたはアカウントを持っていますか？",
    log_terms_privacy_part1:
      "サインアップまたはログインすることによって、あなたは私の近くの上場に同意します",
    boost_this_product: "この商品を後押ししますか？",
    product_successfully_boosted: "製品は正常にブーストされました",
    product_failed_boost: "製品はブーストに失敗しました",
    no_products_for_sale:
      "あなたは現在販売のためにリストされている中古製品を持っていません。",
    not_sold_listed_near_me:
      "私は私の近くにリストされているので売っていませんでした",
    agree_add_product:
      "あなたの製品を公開するために投稿をタップすることによって、あなたは私のサービス条件とプライバシーポリシーの条件に近いと同意します。",
    click_to_boost: "製品をクリックしてそれを後押ししました",
    listed_terms_of_service: "私のサービス条件に近い",
    receive_emails_for_users: "ユーザーのメッセージの電子メールを受信します",
    receive_emails_for_newly_posted:
      "新しく投稿された商品のためのEメールを受信する",
    disable_push_notifications: "プッシュ通知を無効にします",
    sms_during_day: "日中にSMSを受け取る",
    sms_24_hours: "SMS 24時間を受け取る",
    products: "製品",
    product_no_longer_available:
      "申し訳ありませんが、この商品はもう利用できません",
    add_home: "家を追加する",
    edit_home: "在宅勤務",
    fill_required_fields: "必要なすべてのフィールドを記入してください",
    no_notification: "通知はありません",
    orders_history: "推移を注文する",
    privacy: "プライバシー",
    terms: "条項",
    report_a_problem: "問題を報告します",
    approximation_protect_user_privacy:
      "ユーザーのプライバシーを保護するための近似",
    do_not_have_products: "あなたは製品を持っていません",
    emails: "電子メール",
    lead_deletion_products:
      "これはあなたのすべての製品の削除につながるでしょう",
    confirm_legal_message:
      "あなたは、特に人に初めて見知らぬ人を満たすとき、あなたは他の人と対話するときに必要なすべての予防措置を講じることを担当しています。詳細については、利用規約を確認してください。",
    push_notifications_notified_instantly:
      "プッシュ通知を即座に通知することを可能にします",
    rate_seller: "料金販売者",
    user_journey: "ユーザーの旅",
    user: "ユーザー",
    user_id: "ユーザーID",
    action_id: "アクションID",
    select_model_car: "車のモデルを選択してください",
    boost_1_day: "1日1日",
    boost_3_days: "3日後",
    boost_7_days: "ブースト7日",
    agree_boost_terms: "ブーストをタップすることで、あなたはに同意します",
    add: "追加",
    add_tag: "タグ付けする",
    brand_title: "ブランド",
    category_mobiles: "携帯電話",
    category_tablets: "錠剤",
    screen_size: "画面サイズ",
    has_cellular_capability: "細胞機能を持っています",
    default_internal_memory: "内部メモリ",
    network_carrier: "ネットワークキャリア",
    is_unlocked: "ロックが解除されています",
    mobile_model_warning: "第一にブランドを選択してください",
    missing_image: "画像が足りなく、画像をもう一度追加してみてください。",
    add_mobile: "携帯を追加します",
    edit_mobile: "携帯電話を編集します",
    add_tablet: "タブレットを追加してください",
    edit_tablet: "タブレットを編集します",
    keywords:
      "ショッピング、購入、売る、お金、貿易、地元の人々、隣人、自動車、車両",
    country: "国",
    phone_number: "電話番号",
    verification_code: "検証コード",
    error_occurred: "エラーが発生しました。後でもう一度やり直してください",
    invalid_state:
      "無効な状態：ログインコールバックが受信されましたが、ログイン要求は送信されませんでした。",
    sign_in: "サインイン",
    sign_in_apple: "アップルでサインインします",
    sign_in_google: "Googleでサインインします",
    sign_in_phone: "電話でサインインします",
    sign_in_facebook: "Facebookでサインインします",
    create_account: "アカウントを作成する",
    email: "Eメール",
    invalid_field: "必要なフィールドに記入してください",
    code_sent: "コードはSMSによって送信されました",
    verify_number: "電話番号を確認してください",
    tapping_verify_number:
      "タップ（電話番号を確認する）で、SMSが送信されます。",
    email_exists:
      "アカウントはすでに存在し、Googleボタン、Facebookボタンまたはアップルボタンを介してアクセスする必要があります。",
    ok: "Ok",
    sure_back: "あなたは確かに戻っていますか？",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "前",
    add_model: "モデルを追加してください",
    no_search_results_us:
      "120マイル以内にあなたの近くに検索結果はありません。検索フィルターを変更するか、キーワードを検索してみてください。",
    no_search_results:
      "200 km以内にお近くの検索結果はありません。検索フィルターを変更するか、キーワードを検索してみてください。",
    plan_date: "計画日",
    plan_time: "計画時間",
    invalid_plan_date: "プランの無効な日付、計画日をもう一度設定してください",
    invalid_plan_time: "無効な計画時間、計画時間をもう一度設定してください",
    plan_name: "計画名",
    plan_title: "プラン",
    update_plan_name: "プラン名を更新します",
    delete_plan_question: "この計画を削除したいですか？",
    plan_reminder_message: "1時間前に思い出されるでしょう",
    plan_dialog_title: "会議計画",
    planners_title: "プランナー",
    unable_sending_messages:
      "彼らはオンラインに戻ったときにあなたのメッセージを見るでしょう。",
    its_text: "これは",
    for_your_text: "レシーバー用。",
  },
  ko: {
    invalid_area: "잘못된 영역, 영역을 다시 설정하십시오.",
    invalid_lot_size:
      "속성 로트 크기가 잘못되었으므로 많은 크기를 다시 설정하십시오.",
    property_area: "속성 영역",
    app_store_name: "Me 근처에 나열된 - 중고 품목 구매, 현금 판매",
    app_store_short:
      "현지 판매자를위한 시장. 판매를위한 항목을 나열하고 돈을 벌 수 있습니다.",
    app_store_full:
      "가까이에 나열된 것들이 원하는 것들에 대해 많은 것을 쉽게 찾고 당신이 판매하고자하는 것에 돈을 벌 수 있습니다. 이것은 당신이 신뢰할 수있는 사람들이있는 지역 사회 나 이웃에서 사고 판매하는 가장 좋은 방법입니다. 그것이 어떻게 작동하는지 : 1- 물건을 사거나 판매하십시오; 쉽게 물건을 쉽게 게시 할 수 있습니다. 2- 옷, 가구, 휴대 전화, 전자, 아기 및 키즈 아이템, 스포츠 장비, 중고차, 드레스, 신발, 시계, 중고 장난감, 중고 노트북, 간접 차량 및 진짜로 할인 할 수 있습니다. 부동산 판매 또는 임대. 3 - 판매 중 로컬 항목을 찾습니다. 4- 메시지 구매자와 판매자가 앱 내에서. 5- 이미지별로 항목을 탐색하고 카테고리별로 정렬합니다. 근처에 나열된 재미있는 사실 : 1 - 가까이에 나열된 것들로 옷에서 전자 공학으로의 중고차로 옷을 쉽게 판매 할 수 있습니다. 2- 구매자와 판매자 간의 통신은 메시징을 통해 앱을 통해 발생합니다. 3- 근처에 나열된 내장은 차고 판매보다 낫습니다. 휴대 전화 또는 태블릿에서 할인 할인 원하는 것을 찾으십시오.",
    app_store_release:
      "근처에 나열된 - 현지인과의 무역. 현지 구매자와 판매자를 위해 모바일 시장에 가입하십시오!",
    app_name: "나에게 나열된 것",
    title_buy: "구입",
    title_messages: "메시지",
    title_sell: "팔다",
    title_profile_image: "프로필 이미지",
    title_account: "계정",
    account_settings: "계정 설정",
    settings: "설정",
    color_theme: "색상 테마",
    device_settings: "기기 설정",
    public_profile: "공개 프로필",
    light_mode: "조명 모드",
    dark_mode: "어두운 모드",
    title_sell_faster: "더 빨리 판매",
    send_button_label: "보내다",
    rate_message: "나를 평가...",
    already_rated: "당신은 이미 검토를 제출했습니다",
    rate_review_question: "당신은 당신이 거래하고 싶습니까?",
    again: "다시?",
    action_logout: "로그 아웃",
    action_category: "범주",
    action_search: "찾다",
    action_refer: "친구를 추천하십시오",
    dialog_choose_location: "위치를 선택하십시오",
    dialog_change_username: "사용자 이름 변경",
    dialog_change_language: "언어 변경",
    dialog_image_tags: "이미지 태그",
    dialog_emails_notifications: "이메일 알림",
    dialog_push_notifications: "푸시 알림",
    fragment_product_detail: "제품 상세 정보",
    fragment_message_details: "메시지 세부 사항",
    fragment_sell: "팔다",
    dialog_tags_title: "태그",
    dialog_location_title: "업데이트 위치",
    dialog_username_title: "사용자 이름 변경",
    tab_photo: "사진",
    tab_details: "세부",
    tab_price: "가격",
    tab_finish: "마치다",
    profile: "프로필",
    search: "찾다",
    choose_product: "제품을 선택하십시오",
    rating_review: "등급 및 검토",
    select_buyer: "구매자를 선택하십시오",
    tab_my_used_products: "내 제품",
    price_label: "가격",
    text_savings: "당신은 저장합니다",
    search_hint: "제품 검색 ...",
    empty_text:
      "이 카테고리 또는 선택한 거리 내에있는 제품이 나열되어 있지 않습니다.",
    filter_menu_text: "필터",
    error_contacting_seller: "판매자에게 연락하는 오류",
    edit_product: "제품 편집",
    contact_seller: "판매자에게 연락",
    signup_to_contact_seller: "판매자에게 연락 하시려면 가입하십시오",
    signup_to_make_offer: "제안을하기 위해 가입하십시오",
    product_details: "세부",
    product_category: "범주",
    product_condition: "질환",
    product_description: "설명",
    product_location: "제품 위치",
    product_location_approximate: "위치는 근사치입니다",
    over_week_time_ago: "1 주일 전에",
    boosted: "부스트 됨",
    threads_no_results: "메시지 없음",
    message_no_results: "메시지 없음",
    message_warning:
      "당신은 다른 사람들과 상호 작용할 때, 특히 처음으로 낯선 사람을 만날 때 필요한 모든 예방 조치를 취할 책임이 있습니다. 개인 정보, 확인 코드 또는 지불 정보를 공유하지 마십시오. 자세한 내용은 서비스 약관을 검토하십시오.",
    message_block: "현재 메시지를 보내거나받을 수 없습니다.",
    select_location: "위치를 선택하십시오",
    location_permission_denied_message:
      "앱에는 올바르게 작동 할 수있는 위치가 필요합니다.",
    signed_in: "로그인!",
    sign_in_canceller: "로그인 취소되었습니다",
    version: "버전",
    build: "짓다",
    name: "이름",
    location: "위치",
    language: "언어",
    about_app: "내 근처에 나열된 것에 대해",
    terms_of_service: "서비스 약관",
    privacy_policy: "개인 정보 정책",
    report_feedback: "의견 보내기",
    report_bug: "버그를보고하기 위해 전화를 흔들어 라",
    change_image: "이미지 변경",
    update_location: "업데이트 위치",
    about_the_app: "앱 정보",
    update_label: "업데이트",
    uploading: "업로드",
    adding: "목록 추가",
    removing: "목록 제거",
    updating: "Listing.",
    uploaded_image: "업로드 된 이미지 :",
    image_storage_failed: "이미지를 저장하지 못했습니다.",
    product_updated: "제품이 성공적으로 업데이트되었습니다",
    location_error: "위치가 저장되지 않았습니다. 다시 시도하십시오",
    product_removed: "제품이 성공적으로 제거되었습니다",
    deleted_product: "이 제품은 삭제됩니다",
    invalid_title: "제목이 잘못되었습니다. 제목을 다시 설정하십시오.",
    invalid_image: "잘못된 이미지 경로, 이미지를 다시 추가하십시오.",
    invalid_price: "잘못된 가격, 가격을 다시 설정하십시오.",
    invalid_location: "위치가 잘못되었으므로 위치를 다시 설정하십시오.",
    invalid_category: "범주가 잘못되었습니다. 카테고리를 다시 설정하십시오.",
    invalid_condition: "유효하지 않은 상태, 조건을 다시 설정하십시오.",
    removing_title: "프로필 이미지 제거",
    image_not_saved: "이미지 저장 실패!",
    product_load_failed: "아니오 제품 없음",
    take_photo: "사진을 찍다",
    select_photo: "사진을 선택하십시오",
    product_title_hint: "그게 뭐야? 이름, 브랜드, 모델 등",
    delete_photo: "사진 삭제",
    product_title: "제목",
    mark_as_sold: "판매로 표시합니다",
    product_share: "공유하다",
    product_make_offer: "제안을",
    product_cover: "표지로 설정하십시오",
    product_tags: "태그",
    product_posted: "게시 :",
    product_change: "변화",
    product_post: "게시하다",
    product_selling_from: "위치에서 판매",
    product_select_location: "위치를 선택하십시오",
    product_map_approximate:
      "지도는 판매자의 위치를 ​​비공개로 유지하는 데 근사적입니다.",
    product_terms: "게시물을 눌러 제품을 게시하기 위해 <u>에 동의합니다. </ u>",
    condition_other: "기타 (설명 참조)",
    condition_for_parts: "부품의 경우",
    condition_used: "사용 (보통 마모)",
    condition_open_box: "열린 상자 (절대 사용되지 않음)",
    condition_reconditioned: "재조정 / 인증",
    condition_new: "새로운 (절대 사용되지 않음)",
    select_category: "카테고리를 선택하십시오",
    select_all_category: "모두 선택하십시오",
    category_loading_error:
      "카테고리 목록을 업데이트 할 수 없으면 나중에 다시 시도하십시오.",
    category_vehicles: "차량",
    category_furniture: "가구",
    category_electronics: "전자 제품",
    category_appliances: "홈 &  가전 ​​제품",
    category_fashion_accessories: "패션 &  부속품",
    category_baby_kids: "아기 &  어린이",
    category_antiques_collectibles: "골동품 및  수집품",
    category_auto_parts_tools_machinery: "자동차 부품, 도구 및 앰프; 기계",
    category_sports_outdoors: "스포츠 &  옥외",
    category_others: "기타",
    location_enter_zip_code: "우편 번호를 입력하세요",
    location_get_current_location: "현재 위치를 가져옵니다",
    location_select_location: "위치를 선택하십시오",
    location_update_location: "업데이트 위치",
    location_new_location: "새로운 위치",
    search_filter_results: "필터 결과",
    search_filter_min: "최소 필터",
    search_filter_at_least: "적어도",
    price_filter: "가격 필터",
    product_name: "상품명",
    english_language: "영어",
    arabic_language: "아라비아 말",
    spanish_language: "스페인의",
    system_language: "체계",
    share_link: "공유 링크",
    save: "구하다",
    cancel: "취소",
    loading: "적재",
    yes: "네",
    no: "아니",
    report: "보고서",
    report_product: "제품 보고서",
    report_user: "보고서 사용자",
    block_user: "사용자를 차단합니다",
    un_block_user: "사용자의 차단 해제",
    why_product: "왜이 항목을보고 하시겠습니까?",
    why_user: "왜이 사용자를보고 하시겠습니까?",
    block_user_confirm: "이 사용자를 영구적으로 차단 하시겠습니까?",
    un_block_user_confirm: "이 사용자를 영구히 차단 해제하고 싶습니까?",
    prohibited: "내 근처에 나열된 금지",
    offensive: "공격적이거나 부적절한 것",
    duplicate: "중복 된 게시물",
    wrong_category: "잘못된 카테고리",
    scam: "사기처럼 보입니다",
    stolen: "나는 그것이 도난당한 것 같아",
    product_other: "다른",
    product_is_sold: "이 제품은 판매되었습니다",
    missed_meeting: "그들은 우리의 회의를 놓쳤습니다",
    low_offer: "낮은 제안을했다",
    rude: "무례하거나 부적절합니다",
    items: "항목의 문제",
    trouble_meetup: "만나는 문제",
    messaging: "메시징 문제",
    user_other: "다른",
    new_version_available: "새 버전을 사용할 수 있습니다",
    please_update_app:
      "계속하려면 응용 프로그램을 새 버전으로 업데이트하십시오.",
    update: "업데이트",
    no_thanks: "고맙지 만 사양 할게",
    contact_support_confirmation:
      "현재 응답 시간은 24-48 시간입니다. ME 앱 채팅 지원 근처에 나열된 연락을 원하십니까?",
    unboost_confirmation: "이 제품을 부착하지 않으시겠습니까?",
    no_used_products: "아직 목록이 없습니다",
    no_boosted_products: "당신은 부스트 ​​된 제품이 없습니다",
    next: "다음",
    previous: "이전의",
    skip: "건너 뛰다",
    start: "시작",
    list_used: "사용 된 제품을 나열하십시오",
    buy_description: "주변의 이웃들이 제공하는 제품을 발견하고 검색하십시오.",
    sell_description: "더 이상 판매 할 필요가없는 제품을 나열하십시오",
    list_used_description: "20 초 이내에 판매용 중고 제품을 나열하십시오.",
    boost_product_option_1: "<b> 부스트 1  nday </ b>  n  n <b> $ 0.99 </ b>",
    boost_product_option_2: "<b> 부스트 3  ndays </ b>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<b> 부스트 7  ndays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "매일 더 많은 조회를하십시오. 귀하의 품목은 구매 및 카테고리의 상위 30 개 항목 내의 추천 위치에 나타납니다. 홍보 된 품목은 지정된 장소에서 회전하여 모든 품목이 공정한 노출을 얻습니다.",
    boost_cta: "더 빨리 판매",
    boost_terms: "부스트를 탭하면 <u>에 동의합니다. </ u> </ u>",
    boost_best_value: "최고의 가치",
    already_boosted: "이 제품이 향상되었습니다",
    clicks: "클릭하십시오",
    impressions: "인상",
    end: "끝",
    transactions_empty_text:
      "아직 거래를 부스트하지 않습니다. 판매 탭을 방문하여 제품을 향상시킬 수 있습니다.",
    transactions_loading_error:
      "트랜잭션 목록을 업데이트 할 수 없으면 나중에 다시 시도하십시오.",
    transactions_history_title: "거래력을 향상시킵니다",
    communicative_postive: "의사 소통의",
    communicative_negative: "억제하지 않는 것",
    ontime_postive: "시간에",
    ontime_negative: "늦은",
    reliable_postive: "믿을 수있는",
    reliable_negative: "신뢰할 수 없는",
    friendly_postive: "친숙한",
    friendly_negative: "무례한",
    itemasdescribed_postive: "설명 된 항목",
    itemasdescribed_negative: "명세되지 않은 물건",
    other: "다른",
    submit: "제출하다",
    adding_rating_reviews: "등급 및 리뷰 추가하기",
    no_internet_title: "인터넷에 연결되지 않음",
    no_internet_message: "인터넷에 연결되어 있는지 확인하고 다시 시도하십시오.",
    retry: "다시 해 보다",
    near_me: "내 근처에",
    newest_first: "최신 첫 번째",
    miles: "마일",
    km: "km.",
    similar_products: "비슷한 제품",
    favorite_products: "좋아하는 제품",
    items_for_sale: "판매 품목",
    joined: "가입했다",
    favorites_transactions_title: "즐겨 찾기",
    boosted_products_transactions_history: "부스트 된 제품 트랜잭션 기록",
    views: "견해",
    boost_graph_title: "증가 그래프",
    no_favorite_products: "좋아하는 제품이 없습니다",
    make_offer_buy: "사고 싶다",
    make_offer_buy_for: "~을위한",
    notifications: "알림",
    push_notifications: "푸시",
    emails_notifications: "이메일",
    apply: "적용하다",
    email_messages: "메시지 이메일",
    email_new_products: "신제품 이메일",
    push_day_only: "푸시 알림 일뿐입니다",
    push_24_hours: "푸시 알림 24 시간",
    edit: "편집하다",
    map: "지도",
    camera: "카메라",
    gallery: "갤러리",
    delete: "삭제",
    no_sell_items: "판매를위한 항목 없음",
    who_bought_question: "누가 그것을 샀는가?",
    sold_elsewhere_question: "다른 곳에서 팔았습니다",
    confirm: "확인하다",
    over_limit_camera: "5 개 이상의 이미지를 추가 할 수 없습니다",
    boost_failed: "부스트가 실패했습니다. 나중에 다시 시도 해주십시오",
    after_purchase: "지불 성공적인  NProduct가 부스트되었습니다",
    pay_failed: "결제 실패. 다시 시도하십시오",
    done: "완료",
    not_now: "지금은 아닙니다",
    boost: "후원",
    invalid_zip_code: "우편 번호가 잘못되었습니다",
    invalid_user_name: "잘못된 사용자 이름",
    comments: "코멘트",
    questions: "질문",
    bug_reports: "버그 보고서",
    feature_request: "기능 요청",
    feedback_type: "피드백 유형",
    feedback_description:
      "우리는 당신의 생각이나 당신의 경험을 어떻게 향상시킬 수 있는지에 대한 당신의 생각이나 의견을 듣고 싶습니다!",
    feedback: "피드백",
    feedback_text: "너의 답",
    suggestions: "개선을위한 제안",
    delete_account: "계정 삭제",
    new_message: "새로운 메시지",
    online: "온라인으로",
    km_50: "50km.",
    km_100: "100km.",
    km_200: "200km",
    miles_30: "30 마일",
    miles_60: "60 마일",
    miles_120: "120 마일",
    rate_app_question: "앱 스토어에서 등급은 어떻습니까?",
    enjoying_question: "근처에 나열된 즐기기?",
    not_enjoy: "설마",
    feedback_question: "우리에게 몇 가지 피드백을 주시겠습니까?",
    yes_sure: "좋아, 확실한",
    product_available_question: "안녕하세요, 이것은 아직도 사용할 수 있습니까?",
    buy_question: "안녕하세요, 나는 이것을 사고 싶습니다.",
    meet_question: "안녕하세요, 오늘 만날 수 있습니까?",
    follow: "따르다",
    followers: "추종자들",
    following: "수행원",
    feedback_thanks: "의견을 보내 주셔서 감사합니다",
    all_categories: "모든 카테고리",
    deleted_account: "이 계정이 삭제됩니다",
    delete_account_question: "이 계정을 삭제 하시겠습니까?",
    no_followings: "아무에게도 따르지 않습니다",
    when_following: "언제",
    no_followings_subtitle: "사람들을 따르면 여기에서 볼 수 있습니다",
    no_followers: "추종자가있다",
    no_followers_subtitle: "사람들이 뒤 따르면 여기에서 그들을 볼 것입니다",
    distance: "거리",
    filter_method: "필터 방법",
    see_listings: "목록을 참조하십시오",
    sold: "판매 된",
    bought: "구입했다",
    no_notifications: "알림을 받으면 여기에 나타납니다",
    items_title: "항목",
    new_listing_title: "새 목록 만들기",
    dialog_year_title: "년도",
    dialog_make_title: "만들다",
    dialog_model_title: "모델",
    dialog_body_style_title: "본문 스타일",
    dialog_exterior_color_title: "외관 색상",
    dialog_interior_color_title: "내부 색상",
    dialog_transmission_title: "전염",
    dialog_fuel_type_title: "연료 종류",
    dialog_owners_num_title: "주인 수",
    dialog_vehicle_owed_money_title: "이 차량에서 아직도 빚진 돈이 있습니까?",
    automatic_transmission: "자동적 인",
    manual_transmission: "수동",
    not_sure: "확실하지 않다",
    wagon_hatchback: "왜건 &  해치백",
    convertible: "바꿀 수 있는",
    coupe: "쿠페",
    sedan: "의자 가마",
    black_color: "검은 색",
    blue_color: "푸른",
    brown_color: "갈색",
    gold_color: "금",
    green_color: "녹색",
    grey_color: "회색",
    pink_color: "분홍",
    purple_color: "보라",
    red_color: "빨간색",
    silver_color: "은",
    orange_color: "오렌지",
    white_color: "하얀색",
    yellow_color: "노랑",
    charcol_color: "charcol.",
    fuel_diesel: "디젤",
    fuel_electric: "전기 같은",
    fuel_gasoline: "가솔린",
    fuel_flex: "몸을 풀다",
    fuel_hybrid: "잡종",
    fuel_petrol: "가솔린",
    fuel_plugin_hybrid: "플러그인 하이브리드",
    truck: "트럭",
    van_minivan: "밴 &  미니 밴",
    suv_crossover: "SUV &  크로스 오버",
    awd_4wd: "awd / 4wd.",
    fwd: "흥분",
    rwd: "rwd.",
    off_white_color: "끄기 화이트",
    tan_color: "탠 껍질",
    beige_color: "베이지 색",
    burgundy_color: "부르고뉴",
    turquoise_color: "터키 옥",
    title_status_clean: "깨끗한",
    title_status_rebuilt: "재건축하다",
    title_status_salvage: "구제",
    title_status_missing: "없어진",
    title_status_lien: "선취 특권",
    title_status: "제목 상태",
    mileage: "사용량",
    dialog_drivetrain_title: "DriveTrain",
    model_warning: "먼저 선택하십시오",
    required_field_warning: "이 필드는 필요합니다",
    vehicle_vin: "vin.",
    invalid_vin: "VIN이 잘못되었으므로 VIN을 다시 설정하십시오.",
    invalid_mileage: "잘못된 마일리지, 마일리지를 다시 설정하십시오.",
    clean_description: "대부분의 차량은 사고가 없었습니다",
    rebuilt_description: "재건 된 일종의 차가",
    salvage_description: "사고 후에 합계 된 것으로 간주됩니다",
    missing_description: "새로운 DMV 문제 제목이 필요합니다",
    lien_description: "은행이나 법원 정착소가 소유하고 있습니다",
    nearme: "내 근처에",
    newest: "최신",
    contact_support: "연락처 지원",
    create_home_title: "판매 또는 임대 주택",
    for_sale: "판매",
    for_rent: "임대료",
    property_type: "속성 유형",
    apartment: "아파트",
    house: "집",
    room_only: "방 전용",
    townhouse: "타운 하우스",
    bedrooms: "침실",
    bathrooms: "욕실",
    property_address: "부동산 주소",
    price_per_month: "매월 가격",
    square_feet: "평방 피트",
    year_built: "연도 제작",
    year_renovated: "연도 개조",
    lot_size: "로트 크기",
    laundry_type: "세탁 유형",
    in_unit_laundry: "단위 세탁물",
    laundry_building: "세탁 건물",
    laundry_available: "세탁 가능",
    none: "없음",
    parking_type: "주차 유형",
    garage_parking: "차고 주차장",
    street_parking: "거리 주차장",
    off_street_parking: "노상 주차",
    available_parking: "주차 가능",
    air_cond_type: "에어컨 유형",
    ac_available: "AC 가능",
    central_ac: "중앙 AC.",
    heating_type: "난방 유형",
    electric_heating: "전기 가열",
    gas_heating: "가스 가열",
    radiator_heating: "라디에이터 가열",
    available_heating: "가열 가능",
    amenities: "예의",
    date_available: "날짜",
    lease_length: "임대 길이",
    month_to_month: "달에서 월까지",
    three_months: "3 개월",
    six_months: "6 개월",
    one_year: "일년",
    more_one_year: "1 년 이상",
    cat_friendly: "고양이 친절한",
    dog_friendly: "개 친절한",
    balcony: "발코니",
    basement: "최하부",
    bike_parking: "자전거 주차장",
    cable_tv: "케이블 TV.",
    ceiling_fan: "천장 선풍기",
    concierge: "관리인",
    dishwasher: "식기 세척기",
    doorman: "도어맨",
    elevator: "엘리베이터",
    fireplace: "난로",
    fitness_center: "피트니스 센터",
    garbage_disposal: "쓰레기 처리",
    microwave: "마이크로파",
    online_app: "온라인 응용 프로그램",
    oven: "오븐",
    package_service: "패키지 서비스",
    patio: "안마당",
    pet_park: "애완 동물 공원",
    refrigerator: "냉장고",
    resident_lounge: "주민 라운지",
    roof_deck: "지붕 데크",
    secured_entry: "보안 항목",
    storage: "저장",
    walk_in_closet: "옷장에 걸어",
    swimming_pool: "수영장",
    wheelchair_access: "휠체어 접근 가능",
    central_heating: "중앙 난방",
    invalid_bedrooms: "잘못된 침실, 침실을 다시 설정하십시오.",
    invalid_bathrooms: "잘못된 욕실이 욕실을 다시 설정하십시오.",
    chinese_simplified_language: "중국어 (간체",
    chinese_traditional_language: "중국 전통",
    czech_language: "체코 사람",
    danish_language: "덴마크 말",
    dutch_language: "네덜란드 사람",
    finnish_language: "핀란드어",
    french_language: "프랑스 국민",
    german_language: "독일 사람",
    greek_language: "그리스 어",
    hungarian_language: "헝가리 인",
    indonesian_language: "인도네시아 인",
    italian_language: "이탈리아 사람",
    japanese_language: "일본어",
    korean_language: "한국인",
    norwegian_language: "노르웨이 인",
    polish_language: "광택",
    portuguese_language: "포르투갈 인",
    portuguese_brazilian_language: "포르투갈어, 브라질",
    romanian_language: "루마니아 사람",
    russian_language: "러시아인",
    swedish_language: "스웨덴어",
    turkish_language: "터키어",
    ukrainian_language: "우크라이나 인",
    urdu_pakistan_language: "우르두 (파키스탄)",
    vietnamese_language: "베트남어",
    category_home_sale_or_rent: "판매 또는 임대료 홈",
    square_meter: "평방 미터",
    copy_text: "복사",
    copyied_to_clipboard: "클립 보드에 복사",
    inbox: "받은 편지함",
    input_title_listening: "청취…",
    input_subtitle_listening: "뭔가를 말하십시오",
    input_title_error: "죄송합니다, 우리는 그것을 아주 많이 얻었습니다.",
    input_subtitle_error: "귀하의 요청을 반복 해보십시오.",
    input_hint_error: "다시 시도하십시오",
    price_less_than_or_equal: "가격 이하 또는 그보다 같음",
    any_price: "모든 가격",
    any_condition: "모든 조건",
    any_time: "언제든지",
    days_ago: "며칠 전에",
    any_distance: "모든 거리",
    distance_within: "내의 거리",
    new_notification: "새로운 알림",
    deleted: "삭제됨",
    processing_image: "이미지 처리",
    remove_dialog_message: "이 제품을 정말로 제거하고 싶습니까?",
    deleted_thread: "이 메시지는 삭제됩니다",
    category_yard_sale_event: "야드 판매 이벤트",
    yard_first_date: "마당 판매 첫 번째 날짜",
    yard_second_date: "마당 판매 2 일",
    yard_third_date: "마당 판매 제 3 일",
    yard_start_time: "시작 시간",
    yard_end_time: "끝 시간",
    yard_end_timestamp: "종료 타임 스탬프",
    invalid_date1:
      "첫 번째 날짜가 잘못되었습니다. 첫 번째 날짜를 다시 설정하십시오",
    invalid_start_time:
      "시작 시간이 잘못되었습니다. 시작 시간을 다시 설정하십시오",
    invalid_end_time: "잘못된 종료 시간, 다시 종료 시간을 설정하십시오",
    yard_sale_title: "마당 판매",
    garage_tag: "차고",
    yard_tag: "마당",
    from: "에서",
    to: "에게",
    block: "블록",
    un_block: "차단 해제",
    sign_email: "이메일로 로그인하십시오",
    invalid_first_date:
      "첫 번째 날짜가 잘못되었습니다. 첫 번째 날짜가 두 번째와 세 번째로 표시되는지 확인하십시오.",
    invalid_second_date:
      "잘못된 두 번째 날짜, 두 번째 날짜가 세 번째 날짜 이전에 있는지 확인하십시오.",
    invalid_start_time_value:
      "잘못된 시작 시간, 시작 시간이 종료되기 전에 확인하십시오.",
    use_default_yard_photo: "기본 야드 판매 사진을 사용하십시오",
    active_label: "활동적인",
    enable_notifications: "알림 사용",
    login: "로그인",
    january: "1 월",
    february: "2 월",
    march: "3 월",
    april: "4 월",
    may: "할 수있다",
    june: "6 월",
    july: "칠월",
    august: "팔월",
    september: "구월",
    october: "십월",
    november: "십일월",
    december: "12 월",
    since: "부터",
    product_views: "제품보기",
    shop_views: "쇼핑보기",
    total_sales: "총 매출",
    total_orders: "총 주문",
    last_twelvth_months: "지난 12 개월",
    last_nine_months: "지난 9 개월",
    last_six_months: "지난 6 개월",
    last_three_months: "지난 3 개월",
    last_12_months: "지난 12 개월",
    last_9_months: "지난 9 개월",
    last_6_months: "지난 6 개월",
    last_3_months: "지난 3 개월",
    months: "개월",
    open: "열려있는",
    reset_password: "암호를 재설정",
    create_new_shop: "새로운 상점을 만드십시오",
    download_app: "앱 다운로드",
    log_in: "로그인",
    sign_up: "가입하기",
    no_result: "결과가 없다",
    max_price: "최대 가격",
    max_distance: "최대 거리",
    max_time: "최대 시간",
    posted_less_than: "게시 됨",
    result: "결과",
    more: "더",
    or: "또는",
    password: "비밀번호",
    forgot_password: "비밀번호를 잊으 셨나요?",
    and: "그리고",
    download_for: "위해 다운로드",
    apple_ios: "Apple iOS.",
    android: "기계적 인조 인간",
    image: "영상",
    edit_image: "이미지 편집",
    please_complete: "완료하십시오",
    enter_your_offer: "제안을 입력하십시오",
    categories: "카테고리",
    upload_image: "이미지 업로드",
    upload_images: "이미지 업로드",
    back: "뒤",
    see_more: "더보기",
    add_product: "제품 추가",
    selected: "선택된",
    create: "만들다",
    rate_the_buyer: "구매자를 평가하십시오",
    delete_product: "제품 삭제",
    product: "제품",
    un_block_product: "제품 차단 해제",
    share_your_product: "제품을 공유하십시오",
    boost_details: "세부 사항 부스트",
    remove_all_products: "모든 제품을 제거하십시오",
    remove_all: "모두 제거",
    add_vehicle: "차량을 추가하십시오",
    edit_vehicle: "차량 편집",
    upload_a_photo: "사진 업로드",
    view_details: "세부 정보보기",
    add_yard_sale: "마당 판매를 추가하십시오",
    edit_yard_sale: "마당 판매 편집",
    users: "사용자",
    users_details: "사용자 세부 정보",
    users_by_country: "국가 별 사용자",
    blocked_users: "차단 된 사용자",
    products_cards: "제품 카드",
    archived_products: "아카이브 된 제품",
    blocked_products: "차단 된 제품",
    products_by_country: "국가 별 제품",
    reports: "보고서",
    reports_details: "보고서를보고합니다",
    closed_reports: "닫힌 보고서",
    threads: "스레드",
    threads_details: "스레드 세부 사항",
    chat_support: "채팅 지원",
    actions: "행위",
    search_actions: "검색 조치",
    product_view_actions: "제품보기 조치",
    contact_seller_product: "판매자 제품에 문의하십시오",
    contact_owner_shop: "연락처 소유자 가게",
    ratings: "등급의 등급",
    reviews: "리뷰",
    products_all_countries: "제품 모든 국가",
    edit_profile: "프로필 편집",
    my_profile: "내 프로필",
    profile_updated_successfully: "프로필이 성공적으로 업데이트되었습니다",
    are_you_sure: "확실합니까",
    my_used_products: "내 사용 된 제품",
    my_shops: "나의 가게",
    my_boosted_products: "내 부스트 제품",
    messages_type_message_here: "여기에 메시지를 입력하세요",
    messages_product_sold: "이 제품은 판매되거나 제거됩니다",
    seen: "봤다",
    messages_never_miss_message: "결코 메시지를 놓치지 마십시오",
    enable: "할 수있게하다",
    send_notify: "알림 보내기",
    un_close: "열다",
    type_your_review: "검토를 입력하십시오",
    again_question: "다시 ?",
    ratings_already_submitted_review: "당신은 이미 검토를 제출했습니다",
    set_product_category: "제품 카테고리를 설정하십시오",
    auth_email_password_incorrect:
      "귀하의 전자 메일 또는 비밀번호가 잘못되었습니다",
    auth_insert_your_name: "이름을 삽입하십시오",
    auth_email_address_badly: "이메일 주소는 나쁘게 포맷됩니다",
    auth_email_address_used: "이메일 주소는 이미 다른 계정에서 사용 중입니다.",
    auth_invalid_password: "암호는 6 자 이상이어야합니다",
    auth_reset_email: "암호를 재설정하려면 이메일을 입력하십시오",
    auth_check_email: "암호를 재설정하려면 이메일을 확인하십시오",
    auth_can_sign_in_google: "Google 버튼으로 로그인 할 수 있습니다",
    auth_do_not_have_account: "계정이 없습니까?",
    auth_have_account: "계정이 있습니까?",
    log_terms_privacy_part1:
      "가입하거나 로그인하여, 당신은 나에게 가까운 곳에 동의합니다.",
    boost_this_product: "이 제품을 향상 시키시겠습니까?",
    product_successfully_boosted: "제품이 성공적으로 향상되었습니다",
    product_failed_boost: "제품이 실패했습니다",
    no_products_for_sale: "현재 판매용으로 사용되는 제품이 없습니다.",
    not_sold_listed_near_me: "나는 그 근처에 나열된 것에 그것을 팔지 않았다",
    agree_add_product:
      "POST를 눌러 제품을 게시하기 위해 귀하는 귀하의 실적이 가까운 서비스 및 개인 정보 보호 정책에 동의합니다.",
    click_to_boost: "제품을 클릭하여 증가 시켰습니다",
    listed_terms_of_service: "ME 근처에 나와 있습니다",
    receive_emails_for_users: "사용자 메시지에 대한 이메일을받습니다",
    receive_emails_for_newly_posted:
      "새로 게시 된 제품에 대한 이메일을 받으십시오",
    disable_push_notifications: "푸시 알림을 비활성화합니다",
    sms_during_day: "낮에는 SMS를받습니다",
    sms_24_hours: "SMS 24 시간을 받으십시오",
    products: "제품",
    product_no_longer_available:
      "죄송합니다.이 제품은 더 이상 사용할 수 없습니다",
    add_home: "집에 추가하십시오",
    edit_home: "편집하십시오",
    fill_required_fields: "필요한 모든 필드를 채우십시오",
    no_notification: "알림이 없습니다",
    orders_history: "주문 기록",
    privacy: "은둔",
    terms: "자귀",
    report_a_problem: "문제를 신고하십시오",
    approximation_protect_user_privacy:
      "사용자의 개인 정보를 보호하기위한 근사치",
    do_not_have_products: "당신은 제품이 없습니다",
    emails: "이메일",
    lead_deletion_products: "이것은 모든 제품의 삭제로 이어질 것입니다.",
    confirm_legal_message:
      "다른 사람들과 상호 작용할 때, 특히 낯선 사람을 처음으로 만날 때 필요한 모든 예방 조치를 취할 책임이 있습니다. 자세한 내용은 서비스 약관을 검토하십시오.",
    push_notifications_notified_instantly:
      "푸시 알림을 즉시 통지 할 수 있습니다",
    rate_seller: "판매자를 평가하십시오",
    user_journey: "사용자 여행",
    user: "사용자",
    user_id: "사용자 ID.",
    action_id: "조치 ID.",
    select_model_car: "자동차 모델을 선택하십시오",
    boost_1_day: "부스트 1 일 부스트",
    boost_3_days: "3 일 부스트",
    boost_7_days: "7 일 부스트",
    agree_boost_terms: "부스트를 두드리면 동의합니다",
    add: "추가하다",
    add_tag: "태그를 추가하십시오",
    brand_title: "상표",
    category_mobiles: "휴대 전화",
    category_tablets: "태블릿",
    screen_size: "화면 크기",
    has_cellular_capability: "셀룰러 능력이 있습니다",
    default_internal_memory: "내부 저장소",
    network_carrier: "네트워크 캐리어",
    is_unlocked: "잠금 해제되어 있습니다",
    mobile_model_warning: "먼저 브랜드를 선택하십시오",
    missing_image: "누락 된 이미지, 이미지를 다시 추가하십시오.",
    add_mobile: "모바일을 추가하십시오",
    edit_mobile: "모바일 편집",
    add_tablet: "태블릿을 추가하십시오",
    edit_tablet: "편집 태블릿",
    keywords: "쇼핑, 구매, 판매, 돈, 무역, 지역 주민, 이웃, 자동차, 차량",
    country: "국가",
    phone_number: "전화 번호",
    verification_code: "확인 코드",
    error_occurred: "오류가 발생했습니다. 잠시 후 다시 시도 해주세요",
    invalid_state:
      "잘못된 상태 : 로그인 콜백이 수신되었지만 로그인 요청이 전송되지 않았습니다.",
    sign_in: "로그인",
    sign_in_apple: "사과와 함께 로그인하십시오",
    sign_in_google: "Google으로 로그인하십시오",
    sign_in_phone: "전화로 로그인하십시오",
    sign_in_facebook: "Facebook으로 로그인하십시오",
    create_account: "계정을 만드십시오",
    email: "이메일",
    invalid_field: "필수 입력란을 기입하십시오",
    code_sent: "이 코드는 SMS에서 전송되었습니다",
    verify_number: "전화 번호 확인",
    tapping_verify_number: "(전화 번호 확인), SMS를 탭하면 SMS를 보냅니다.",
    email_exists:
      "계정이 이미 있고 Google 버튼, Facebook 버튼 또는 Apple 버튼을 통해 액세스해야합니다.",
    ok: "확인",
    sure_back: "당신은 확실히 돌아갈 수 있습니까?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "~ 전에",
    add_model: "모델을 추가하십시오",
    no_search_results_us:
      "120 마일 이내에 가까운 검색 결과가 없습니다. 검색 필터 또는 검색 키워드를 변경하십시오.",
    no_search_results:
      "200km 이내에 가까운 검색 결과가 없습니다. 검색 필터 또는 검색 키워드를 변경하십시오.",
    plan_date: "계획 날짜",
    plan_time: "계획 시간",
    invalid_plan_date: "잘못된 계획 날짜, 계획 날짜를 다시 설정하십시오",
    invalid_plan_time: "잘못된 계획 시간, 계획 시간을 다시 설정하십시오",
    plan_name: "계획 이름",
    plan_title: "계획",
    update_plan_name: "업데이트 계획 이름",
    delete_plan_question: "이 계획을 삭제 하시겠습니까?",
    plan_reminder_message: "당신은 한 시간 전에 상기시킬 것입니다",
    plan_dialog_title: "회의 계획",
    planners_title: "플래너",
    unable_sending_messages:
      "그들은 온라인으로 돌아올 때 메시지를 볼 것입니다.",
    its_text: "이것의",
    for_your_text: "수신기를 위해.",
  },
  no: {
    invalid_area: "Ugyldig område, vennligst sett området igjen.",
    invalid_lot_size:
      "Ugyldig eiendom mye størrelse, vennligst sett mye størrelse igjen.",
    property_area: "Eiendomsområde",
    app_store_name:
      "Oppført i nærheten av Me - Kjøp Brukte varer, Salg for kontanter",
    app_store_short:
      "En markedsplass for lokale selgere. Liste en vare til salgs og tjene penger.",
    app_store_full:
      "Oppført i nærheten av meg gjør det enkelt å finne gode tilbud på de tingene du vil ha, og tjene penger på de tingene du vil selge. Dette er den beste måten å kjøpe og selge i samfunnet eller nabolaget med folk du kan stole på. Hvordan fungerer det: 1- Kjøp eller selg noe; Legg enkelt dine varer til salgs i løpet av sekunder. 2- Finn gode tilbud og rabatter på klær, møbler, mobiltelefoner, elektronikk, baby- og barnartikler, sportsutstyr, brukte biler, kjoler, sko og klokker, til bøker, brukte leker, brukte bærbare datamaskiner, en annenhånds bil og til og med ekte eiendom til salgs eller leie. 3- Søk lokale varer til salgs. 4- Meldingskjøpere og selgere fra appen. 5- Søk varer etter bilde og sorter etter kategori. Morsomme fakta om oppført i nærheten av meg: 1- Med listet nær meg kan du enkelt selge noe, fra klær til brukte biler til elektronikk. 2- Kommunikasjon mellom kjøpere og selgere skjer gjennom appen via meldinger. 3-listet i nærheten av meg er bedre enn et garasjesalg; Finn alt du vil ha til en rabatt, rett på telefonen eller nettbrettet.",
    app_store_release:
      "Oppført i nærheten av meg - handel med lokalbefolkningen. Bli med på mobilmarkedet for lokale kjøpere og selgere!",
    app_name: "Oppført i nærheten av meg",
    title_buy: "Kjøpe",
    title_messages: "Meldinger",
    title_sell: "Selge",
    title_profile_image: "Profilbilde",
    title_account: "Regnskap",
    account_settings: "Kontoinnstillinger",
    settings: "Innstillinger",
    color_theme: "Farge tema",
    device_settings: "Enhetsinnstillinger",
    public_profile: "Offentlig profil.",
    light_mode: "Lys modus",
    dark_mode: "Mørk modus",
    title_sell_faster: "Selg raskere",
    send_button_label: "Sende",
    rate_message: "Vurder meg ...",
    already_rated: "Du har allerede sendt inn gjennomgang",
    rate_review_question: "Ønsker du å håndtere",
    again: "en gang til?",
    action_logout: "Logg ut",
    action_category: "Kategori",
    action_search: "Søk",
    action_refer: "Se en venn",
    dialog_choose_location: "Velg sted",
    dialog_change_username: "Endre brukernavn",
    dialog_change_language: "Skifte språk",
    dialog_image_tags: "Image Tags.",
    dialog_emails_notifications: "E-postvarsler",
    dialog_push_notifications: "Push Notifications.",
    fragment_product_detail: "Produkt detalj",
    fragment_message_details: "Meldingsdetaljer",
    fragment_sell: "Selge",
    dialog_tags_title: "Tags.",
    dialog_location_title: "Oppdater plassering",
    dialog_username_title: "Endre brukernavn",
    tab_photo: "Foto",
    tab_details: "Detaljer",
    tab_price: "Pris",
    tab_finish: "Bli ferdig",
    profile: "Profil",
    search: "Søk",
    choose_product: "Velg produkt",
    rating_review: "Vurdering og gjennomgang",
    select_buyer: "Velg en kjøper",
    tab_my_used_products: "Mine produkter",
    price_label: "Pris",
    text_savings: "Du sparer",
    search_hint: "Søk etter produkter ...",
    empty_text:
      "Det er ingen produkter som er oppført i denne kategorien eller i den valgte avstanden.",
    filter_menu_text: "Filter",
    error_contacting_seller: "Feil ved å kontakte selger",
    edit_product: "Rediger produkt",
    contact_seller: "Kontakt selger",
    signup_to_contact_seller: "Registrer deg på Kontakt selger",
    signup_to_make_offer: "Registrer deg for å gjøre tilbud",
    product_details: "Detaljer",
    product_category: "Kategori",
    product_condition: "Tilstand",
    product_description: "Beskrivelse",
    product_location: "Produktplassering",
    product_location_approximate: "Plasseringen er omtrentlig",
    over_week_time_ago: "Over en uke siden",
    boosted: "Økt",
    threads_no_results: "Ingen meldinger",
    message_no_results: "Ingen meldinger",
    message_warning:
      "Du er alene ansvarlig for å ta alle nødvendige forholdsregler når du samhandler med andre, spesielt når du møter en fremmed personlig for første gang. Ikke del personlig informasjon, bekreftelseskoder eller betalingsinformasjon. Vennligst gjennomgå servicevilkår for mer informasjon.",
    message_block:
      "Du kan ikke sende eller motta meldinger på dette tidspunktet.",
    select_location: "Velg sted",
    location_permission_denied_message:
      "Appen krever plasseringstillatelse til å fungere skikkelig.",
    signed_in: "Logget inn!",
    sign_in_canceller: "Logg inn kansellert",
    version: "Versjon",
    build: "Bygge",
    name: "Navn",
    location: "plassering",
    language: "Språk",
    about_app: "Om oppført i nærheten av meg",
    terms_of_service: "Vilkår for bruk",
    privacy_policy: "Personvernregler",
    report_feedback: "Send tilbakemelding",
    report_bug: "Rist telefonen for å rapportere en feil",
    change_image: "Endre bilde",
    update_location: "Oppdater plassering",
    about_the_app: "Om appen",
    update_label: "Oppdater",
    uploading: "Opplasting",
    adding: "Legge til liste",
    removing: "Fjerning av oppføring",
    updating: "Oppdatering av notering",
    uploaded_image: "Lastet opp bilde:",
    image_storage_failed: "Kunne ikke lagre bilde:",
    product_updated: "Produktet oppdateres vellykket",
    location_error: "Plassering ikke lagret, vennligst prøv igjen",
    product_removed: "Produkt fjernet vellykket",
    deleted_product: "Dette produktet er slettet",
    invalid_title: "Ugyldig tittel, vennligst sett tittelen på nytt.",
    invalid_image: "Ugyldig bildebane, prøv å legge til bilde igjen.",
    invalid_price: "Ugyldig pris, vennligst sett pris igjen.",
    invalid_location: "Ugyldig sted, vennligst angi plasseringen på nytt.",
    invalid_category: "Ugyldig kategori, vennligst sett kategori igjen.",
    invalid_condition: "Ugyldig tilstand, vennligst sett tilstanden igjen.",
    removing_title: "Fjerner profilbilde",
    image_not_saved: "Bilde Lagre mislyktes!",
    product_load_failed: "Ingen produkter",
    take_photo: "Ta bilde",
    select_photo: "Velg bilde",
    product_title_hint: "Hva er det? Navn, merke, modell, etc.",
    delete_photo: "Slett bilde",
    product_title: "Tittel",
    mark_as_sold: "Merk som solgt",
    product_share: "Dele",
    product_make_offer: "Gjøre tilbudet",
    product_cover: "Sett som dekselbilde",
    product_tags: "Tags.",
    product_posted: "Lagt ut:",
    product_change: "Endring",
    product_post: "Post",
    product_selling_from: "Selger fra beliggenhet",
    product_select_location: "Velg sted",
    product_map_approximate:
      "Kartet er omtrentlig for å holde selgerens plassering privat",
    product_terms:
      "Ved å tappe innlegget for å publisere produktet ditt, godtar du at <U> Listed i nærheten av meg vilkår for bruk. </ U>",
    condition_other: "Annet (se beskrivelse)",
    condition_for_parts: "For deler",
    condition_used: "Brukt (normal slitasje)",
    condition_open_box: "Åpne boks (aldri brukt)",
    condition_reconditioned: "REConditioned / Certified.",
    condition_new: "Ny (aldri brukt)",
    select_category: "Velg kategori",
    select_all_category: "Velg alle",
    category_loading_error:
      "Kan ikke oppdatere kategorier listen, vennligst prøv igjen senere.",
    category_vehicles: "Kjøretøy",
    category_furniture: "Møbler",
    category_electronics: "Elektronikk",
    category_appliances: "Hjem &  Apparater",
    category_fashion_accessories: "Mote og  Tilbehør",
    category_baby_kids: "Baby &  Barn",
    category_antiques_collectibles: "Antikviteter & amp Samleobjekter",
    category_auto_parts_tools_machinery: "Auto deler, verktøy og  Maskineri",
    category_sports_outdoors: "Sport og amp Utendørs",
    category_others: "Andre",
    location_enter_zip_code: "Legg inn postnummer",
    location_get_current_location: "Få nåværende beliggenhet",
    location_select_location: "Velg sted",
    location_update_location: "Oppdater plassering",
    location_new_location: "Ny plassering",
    search_filter_results: "Filtrer resultater",
    search_filter_min: "Filter minimum",
    search_filter_at_least: "I det minste",
    price_filter: "Prisfilter",
    product_name: "Produktnavn",
    english_language: "Engelsk",
    arabic_language: "Arabisk",
    spanish_language: "Spansk",
    system_language: "System",
    share_link: "Dele lenke",
    save: "Lagre",
    cancel: "Avbryt",
    loading: "Lasting",
    yes: "Ja",
    no: "Nei",
    report: "Rapportere",
    report_product: "Rapporter produkt",
    report_user: "Rapporter bruker",
    block_user: "Blokker bruker",
    un_block_user: "Unblock bruker",
    why_product: "Hvorfor vil du rapportere dette elementet?",
    why_user: "Hvorfor vil du rapportere denne brukeren?",
    block_user_confirm: "Vil du permanent blokkere denne brukeren?",
    un_block_user_confirm: "Vil du permanent blokkere denne brukeren?",
    prohibited: "Forbudt på listet i nærheten av meg",
    offensive: "Støtende eller upassende",
    duplicate: "Dupliserende post",
    wrong_category: "Feil kategori",
    scam: "Ser ut som en svindel",
    stolen: "Jeg tror det er stjålet",
    product_other: "Annen",
    product_is_sold: "Dette produktet ble solgt",
    missed_meeting: "De savnet vårt møte",
    low_offer: "Gjorde et lavt tilbud",
    rude: "Uhøflig eller upassende",
    items: "Problem med elementer",
    trouble_meetup: "Problemer med å møte opp",
    messaging: "Meldinger problemer",
    user_other: "Annen",
    new_version_available: "Ny versjon tilgjengelig",
    please_update_app: "Vennligst oppdater App til ny versjon for å fortsette.",
    update: "Oppdater",
    no_thanks: "Nei takk",
    contact_support_confirmation:
      "Den nåværende responstiden er 24-48 timer. Ønsker du å kontakte Listed Nær Me App Chat Support?",
    unboost_confirmation: "Er du sikker på at du vil unboost dette produktet?",
    no_used_products: "Du har ikke noen oppføringer ennå",
    no_boosted_products: "Du har ingen økte produkter",
    next: "NESTE",
    previous: "Tidligere",
    skip: "Hopp over det",
    start: "Start",
    list_used: "Oppgi et brukt produkt",
    buy_description:
      "Oppdag og søk etter produkter som tilbys av naboer rundt deg",
    sell_description: "Liste produkter du ikke lenger trenger for salg",
    list_used_description:
      "Oppgi et brukt produkt til salgs på mindre enn 20 sekunder",
    boost_product_option_1: "<b> Boost 1  nday </ b>  n  n <b> $ 0,99 </ b>",
    boost_product_option_2: "<b> Boost 3  ndays </ b>  n  n <b> $ 1,99 </ b>",
    boost_product_option_3: "<b> Boost 7  ndays </ b>  n  n <b> $ 3,99 </ b>",
    boost_product_description:
      "Få flere visninger hver dag. Elementet ditt vises i Utvalgte stillinger i de 30 beste produktene i kjøp og kategori. Fremmede elementer roteres blant de angitte stedene, slik at hvert element får rettferdig eksponering.",
    boost_cta: "Selg raskere",
    boost_terms:
      "Ved å trykke på Boost, godtar du at <u> listet i nærheten av meg vilkår for bruk. </ U>",
    boost_best_value: "Beste verdi",
    already_boosted: "Dette produktet er forsterket",
    clicks: "Klikk",
    impressions: "Inntrykk",
    end: "Slutt",
    transactions_empty_text:
      "Du har ingen økt transaksjoner ennå. Du kan besøke SELL TAB og begynne å øke produktene dine.",
    transactions_loading_error:
      "Kan ikke oppdatere transaksjonslisten, vennligst prøv igjen senere.",
    transactions_history_title: "Øke transaksjonshistorien",
    communicative_postive: "Kommunikativ",
    communicative_negative: "Uncommunicative.",
    ontime_postive: "På tide",
    ontime_negative: "Sent",
    reliable_postive: "Pålitelig",
    reliable_negative: "Upålitelig",
    friendly_postive: "Vennlig",
    friendly_negative: "Uhøflig",
    itemasdescribed_postive: "produkt som beskrevet",
    itemasdescribed_negative: "Element ikke som beskrevet",
    other: "Annen",
    submit: "Sende inn",
    adding_rating_reviews: "Legger til vurdering og vurderinger",
    no_internet_title: "Ingen Internett-tilkobling",
    no_internet_message: "Pass på at du er koblet til Internett og prøv igjen",
    retry: "Prøv på nytt",
    near_me: "Nær meg",
    newest_first: "Nyeste først",
    miles: "miles",
    km: "km.",
    similar_products: "Lignende produkter",
    favorite_products: "Favorittprodukter",
    items_for_sale: "ting til salgs",
    joined: "Ble med",
    favorites_transactions_title: "Favoritter",
    boosted_products_transactions_history:
      "Økte produkter transaksjonshistorie",
    views: "Visninger",
    boost_graph_title: "Øke grafen",
    no_favorite_products: "Du har ingen favorittprodukter",
    make_offer_buy: "jeg vil gjerne kjøpe",
    make_offer_buy_for: "til",
    notifications: "Varsler",
    push_notifications: "Trykk",
    emails_notifications: "E-post",
    apply: "Søke om",
    email_messages: "E-post for meldinger",
    email_new_products: "E-post for nye produkter",
    push_day_only: "Push Notifications Day bare",
    push_24_hours: "Push Notifications 24 timer",
    edit: "Redigere",
    map: "Kart",
    camera: "Kamera",
    gallery: "Galleri",
    delete: "Slett",
    no_sell_items: "Ingen varer til salgs",
    who_bought_question: "Hvem kjøpte den?",
    sold_elsewhere_question: "Solgte det et annet sted",
    confirm: "Bekrefte",
    over_limit_camera: "Du kan ikke legge til flere enn fem bilder",
    boost_failed: "Boost mislyktes. Prøv igjen senere",
    after_purchase: "Betaling vellykket  nproduct forsterket",
    pay_failed: "Betalingen feilet. Vær så snill, prøv på nytt",
    done: "Gjort",
    not_now: "Ikke nå",
    boost: "Øke",
    invalid_zip_code: "Ugyldig postnummer",
    invalid_user_name: "Ugyldig brukernavn",
    comments: "Kommentarer",
    questions: "Spørsmål",
    bug_reports: "Feilrapporter",
    feature_request: "Funksjonsforespørsel",
    feedback_type: "Tilbakemeldingstype",
    feedback_description:
      "Vi vil gjerne høre dine tanker eller tilbakemelding på hvordan vi kan forbedre din erfaring!",
    feedback: "Tilbakemelding",
    feedback_text: "Ditt svar",
    suggestions: "Forslag til forbedring",
    delete_account: "Slett konto",
    new_message: "Ny melding",
    online: "på nett",
    km_50: "50 km",
    km_100: "100 km",
    km_200: "200 km.",
    miles_30: "30 miles",
    miles_60: "60 miles",
    miles_120: "120 miles",
    rate_app_question: "Hva med en vurdering på App Store, da?",
    enjoying_question: "Nyter oppført i nærheten av meg?",
    not_enjoy: "Ikke egentlig",
    feedback_question: "Har du noe imot å gi oss litt tilbakemelding?",
    yes_sure: "Ok sikkert",
    product_available_question: "Hei, er dette fortsatt tilgjengelig?",
    buy_question: "Hei, jeg vil gjerne kjøpe dette",
    meet_question: "Hei, kan du møte i dag?",
    follow: "Følg",
    followers: "Følgere",
    following: "Følgende",
    feedback_thanks: "takk for din tilbakemelding",
    all_categories: "Alle Kategorier",
    deleted_account: "Denne kontoen er slettet",
    delete_account_question: "Er du sikker på at du vil slette denne kontoen?",
    no_followings: "følger ikke noen",
    when_following: "når",
    no_followings_subtitle: "følger folk, vil du se dem her",
    no_followers: "har ikke tilhengere",
    no_followers_subtitle: "etterfulgt av folk, vil du se dem her",
    distance: "Avstand",
    filter_method: "Filtermetode",
    see_listings: "Se oppføringer",
    sold: "Solgt",
    bought: "Kjøpt",
    no_notifications: "Når du mottar varsler, vises de her",
    items_title: "Elementer",
    new_listing_title: "Opprett ny liste",
    dialog_year_title: "År",
    dialog_make_title: "Gjøre",
    dialog_model_title: "Modell",
    dialog_body_style_title: "Kroppsstil",
    dialog_exterior_color_title: "Utvendig farge",
    dialog_interior_color_title: "Interiørfarge",
    dialog_transmission_title: "Overføring",
    dialog_fuel_type_title: "Drivstoff type",
    dialog_owners_num_title: "Antall eiere",
    dialog_vehicle_owed_money_title:
      "Er det penger som fortsatt skyldes dette kjøretøyet?",
    automatic_transmission: "Automatisk",
    manual_transmission: "Håndbok",
    not_sure: "Ikke sikker",
    wagon_hatchback: "Wagon &  Hatchback.",
    convertible: "Konvertible",
    coupe: "Coupe.",
    sedan: "Sedan",
    black_color: "Svart",
    blue_color: "Blå",
    brown_color: "brun",
    gold_color: "Gull",
    green_color: "Grønn",
    grey_color: "Grå",
    pink_color: "Rosa",
    purple_color: "Lilla",
    red_color: "rød",
    silver_color: "Sølv",
    orange_color: "oransje",
    white_color: "Hvit",
    yellow_color: "Gul",
    charcol_color: "Charcol.",
    fuel_diesel: "Diesel",
    fuel_electric: "Elektrisk",
    fuel_gasoline: "Bensin",
    fuel_flex: "Flex.",
    fuel_hybrid: "Hybrid",
    fuel_petrol: "Bensin",
    fuel_plugin_hybrid: "Plug-in hybrid",
    truck: "Lastebil",
    van_minivan: "Van &  Minivan",
    suv_crossover: "SUV &  Crossover.",
    awd_4wd: "AWD / 4WD.",
    fwd: "Fwd.",
    rwd: "RWD.",
    off_white_color: "Av hvit",
    tan_color: "Tan.",
    beige_color: "Beige",
    burgundy_color: "burgunder",
    turquoise_color: "Turkis.",
    title_status_clean: "Ren",
    title_status_rebuilt: "Gjenoppbygget",
    title_status_salvage: "Salvage.",
    title_status_missing: "Savnet",
    title_status_lien: "Lien",
    title_status: "Tittel Status",
    mileage: "Kjørelengde",
    dialog_drivetrain_title: "Drivetrain.",
    model_warning: "Vennligst velg Lag først",
    required_field_warning: "Dette feltet er obligatorisk",
    vehicle_vin: "Vin.",
    invalid_vin: "Ugyldig VIN, vennligst sett VIN igjen.",
    invalid_mileage: "Ugyldig kjørelengde, vennligst sett kjørelengde igjen.",
    clean_description: "De fleste kjøretøy som ikke har vært i en ulykke",
    rebuilt_description: "En reddet bil som har blitt gjenoppbygget",
    salvage_description: "Vurderes totalt etter en ulykke",
    missing_description: "Vil trenge en ny DMV-problemer tittel",
    lien_description: "Eid av en bank eller domstolsoppgjør",
    nearme: "Nær meg",
    newest: "Nyeste",
    contact_support: "Kontaktstøtte",
    create_home_title: "Hjem til salgs eller leie",
    for_sale: "Til salgs",
    for_rent: "Til leie",
    property_type: "Eiendomstype",
    apartment: "Leilighet",
    house: "Hus",
    room_only: "Kun rom",
    townhouse: "Townhouse.",
    bedrooms: "Soverom",
    bathrooms: "Badene",
    property_address: "Eiendomsadresse",
    price_per_month: "Pris per måned",
    square_feet: "Kvadratfot",
    year_built: "År bygget",
    year_renovated: "Året renovert",
    lot_size: "Mye størrelse",
    laundry_type: "Klesvask type",
    in_unit_laundry: "I-Unit Klesvask",
    laundry_building: "Klesvask i bygningen",
    laundry_available: "Klesvask tilgjengelig",
    none: "Ingen",
    parking_type: "Parkering Type",
    garage_parking: "Garage parkering",
    street_parking: "Gateparkering",
    off_street_parking: "Off-street parkering",
    available_parking: "Parkering tilgjengelig",
    air_cond_type: "Luftkondisjoneringstype",
    ac_available: "AC tilgjengelig",
    central_ac: "Sentral AC.",
    heating_type: "Oppvarmingstype",
    electric_heating: "Elektrisk oppvarming",
    gas_heating: "Gass oppvarming",
    radiator_heating: "Radiatoroppvarming",
    available_heating: "Oppvarming tilgjengelig",
    amenities: "Fasiliteter",
    date_available: "Datoen er ledig",
    lease_length: "Leie lengde",
    month_to_month: "Måned til måned",
    three_months: "3 måneder",
    six_months: "6 måneder",
    one_year: "1 år",
    more_one_year: "1+ år",
    cat_friendly: "Katt vennlig",
    dog_friendly: "Hundevennlig",
    balcony: "Balkong",
    basement: "Kjeller",
    bike_parking: "Sykkel parkering",
    cable_tv: "Kabel-TV",
    ceiling_fan: "Takvifte",
    concierge: "Concierge",
    dishwasher: "Oppvaskmaskin",
    doorman: "Dørvakt",
    elevator: "Heis",
    fireplace: "Peis",
    fitness_center: "Treningssenter",
    garbage_disposal: "Søppeltømming",
    microwave: "Mikrobølgeovn",
    online_app: "Online søknad",
    oven: "Stekeovn",
    package_service: "Pakke service",
    patio: "Patio.",
    pet_park: "Pet Park.",
    refrigerator: "Kjøleskap",
    resident_lounge: "Resident stue",
    roof_deck: "Takdekk",
    secured_entry: "Sikret oppføring",
    storage: "Oppbevaring",
    walk_in_closet: "Walk-in closet",
    swimming_pool: "Svømmebasseng",
    wheelchair_access: "Rullestoltilgjengelighet",
    central_heating: "Sentralvarme",
    invalid_bedrooms: "Ugyldige soverom, vennligst sett soverom igjen.",
    invalid_bathrooms: "Ugyldige bad, vennligst sett bad igjen.",
    chinese_simplified_language: "Forenklet kinesisk",
    chinese_traditional_language: "Tradisjonell kinesisk",
    czech_language: "Tsjekkia",
    danish_language: "dansk",
    dutch_language: "nederlandsk",
    finnish_language: "Finsk.",
    french_language: "fransk",
    german_language: "tysk",
    greek_language: "gresk",
    hungarian_language: "Ungarsk.",
    indonesian_language: "Indonesisk",
    italian_language: "Italiensk.",
    japanese_language: "Japansk",
    korean_language: "Korean",
    norwegian_language: "norsk",
    polish_language: "Pusse",
    portuguese_language: "Portugisisk",
    portuguese_brazilian_language: "Portugisisk, brasiliansk",
    romanian_language: "Rumensk.",
    russian_language: "Russisk",
    swedish_language: "svensk",
    turkish_language: "Tyrkisk",
    ukrainian_language: "Ukrainsk.",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "Vietnamesisk",
    category_home_sale_or_rent: "Hjem til salgs eller leie",
    square_meter: "Kvadratmeter",
    copy_text: "Kopiere",
    copyied_to_clipboard: "Kopiert til utklippstavlen",
    inbox: "Innboks",
    input_title_listening: "Lytte ...",
    input_subtitle_listening: "Si noe",
    input_title_error: "Beklager, vi fikk ikke det.",
    input_subtitle_error: "Prøv å gjenta forespørselen din.",
    input_hint_error: "Prøv igjen",
    price_less_than_or_equal: "Pris mindre enn eller lik",
    any_price: "Enhver pris",
    any_condition: "Enhver tilstand",
    any_time: "Hver gang",
    days_ago: "dager siden",
    any_distance: "Noen avstand",
    distance_within: "Avstand innenfor.",
    new_notification: "Ny melding",
    deleted: "Slettet",
    processing_image: "Behandling av bilde",
    remove_dialog_message: "Vil du virkelig fjerne dette produktet?",
    deleted_thread: "Denne meldingen er slettet",
    category_yard_sale_event: "Yard Sale Event.",
    yard_first_date: "Yard Sale Første Date",
    yard_second_date: "Yard Sale Second Date",
    yard_third_date: "Yard Sale Tredje Date",
    yard_start_time: "Starttid",
    yard_end_time: "Sluttid",
    yard_end_timestamp: "Slutt tidsstempel",
    invalid_date1: "Ugyldig Første Date, vennligst sett Første Dato igjen",
    invalid_start_time: "Ugyldig starttid, vennligst sett starttid på nytt",
    invalid_end_time: "Ugyldig sluttid, vennligst sett sluttidspunktet igjen",
    yard_sale_title: "Hagesalg",
    garage_tag: "garasje",
    yard_tag: "Yard.",
    from: "Fra",
    to: "Til",
    block: "Blokkere",
    un_block: "Unblock.",
    sign_email: "Logg på med e-post",
    invalid_first_date:
      "Ugyldig Første Date, vær så snill å sørge for at første dato er før andre og tredje",
    invalid_second_date:
      "Ugyldig annen dato, vær sikker på at andre dato er før tredje dato",
    invalid_start_time_value:
      "Ugyldig starttid, vær så snill å sørge for at starttidspunktet er før sluttidspunktet",
    use_default_yard_photo: "Bruk standard Yard Sale Photo",
    active_label: "Aktiv",
    enable_notifications: "Aktiver varsler",
    login: "Logg Inn",
    january: "januar",
    february: "februar",
    march: "mars",
    april: "april",
    may: "Kan",
    june: "juni",
    july: "juli",
    august: "august",
    september: "september",
    october: "oktober",
    november: "november",
    december: "desember",
    since: "Siden",
    product_views: "Produktvisninger",
    shop_views: "Butikkvisninger",
    total_sales: "Totale salg",
    total_orders: "Totalt antall ordrer",
    last_twelvth_months: "Siste twelvth måneder",
    last_nine_months: "Siste ni måneder",
    last_six_months: "Siste seks måneder",
    last_three_months: "Siste tre måneder",
    last_12_months: "Siste 12 måneder",
    last_9_months: "Siste 9 måneder",
    last_6_months: "Siste 6 måneder",
    last_3_months: "Siste 3 måneder",
    months: "Måneder",
    open: "Åpen",
    reset_password: "tilbakestille passord",
    create_new_shop: "Opprett ny butikk",
    download_app: "Last ned App.",
    log_in: "Logg Inn",
    sign_up: "Melde deg på",
    no_result: "Inget resultat",
    max_price: "Maks pris",
    max_distance: "Maks avstand",
    max_time: "Maks tid",
    posted_less_than: "Postet mindre enn",
    result: "Resultat",
    more: "Mer",
    or: "ELLER",
    password: "Passord",
    forgot_password: "Glemt passord?",
    and: "og",
    download_for: "Last ned for",
    apple_ios: "Apple ios",
    android: "Android.",
    image: "Bilde",
    edit_image: "Rediger bilde",
    please_complete: "Vennligst fullfør",
    enter_your_offer: "Skriv inn tilbudet ditt",
    categories: "Kategorier",
    upload_image: "Last opp bilde",
    upload_images: "Last opp bilder",
    back: "Tilbake",
    see_more: "Se mer",
    add_product: "Legg til produkt",
    selected: "Valgt",
    create: "Skape",
    rate_the_buyer: "Vurder kjøperen",
    delete_product: "Slett produktet",
    product: "Produkt",
    un_block_product: "Unblock produktet",
    share_your_product: "Del ditt produkt",
    boost_details: "Øke detaljer",
    remove_all_products: "Fjern alle produktene",
    remove_all: "Fjern alle",
    add_vehicle: "Legg til kjøretøy",
    edit_vehicle: "Rediger kjøretøy",
    upload_a_photo: "Last opp et foto",
    view_details: "Vis detaljer",
    add_yard_sale: "Legg til Yard Sale.",
    edit_yard_sale: "Rediger Yard Sale.",
    users: "Brukere",
    users_details: "Brukere detaljer",
    users_by_country: "Brukere etter land",
    blocked_users: "Blokkerte brukere",
    products_cards: "Produkter kort",
    archived_products: "Arkiverte produkter",
    blocked_products: "Blokkerte produkter",
    products_by_country: "Produkter etter land.",
    reports: "Rapportere",
    reports_details: "Rapporter detaljer",
    closed_reports: "Lukkede rapporter",
    threads: "Tråder",
    threads_details: "Tråderdetaljer",
    chat_support: "Chat-støtte",
    actions: "Handlinger",
    search_actions: "Søke handlinger",
    product_view_actions: "Produktvisning Handlinger",
    contact_seller_product: "Kontakt selgerprodukt",
    contact_owner_shop: "Kontakt eierbutikk",
    ratings: "Rangeringer",
    reviews: "Vurderinger.",
    products_all_countries: "Produkter alle land",
    edit_profile: "Rediger profil",
    my_profile: "Min profil",
    profile_updated_successfully: "Profil oppdatert vellykket",
    are_you_sure: "Er du sikker",
    my_used_products: "Mine brukte produkter",
    my_shops: "Mine butikker",
    my_boosted_products: "Mine økte produkter",
    messages_type_message_here: "Skriv meldingen din her",
    messages_product_sold: "Dette produktet selges eller fjernes",
    seen: "Sett",
    messages_never_miss_message: "Aldri savner en melding",
    enable: "Muliggjøre",
    send_notify: "Send varsle",
    un_close: "Unclose.",
    type_your_review: "Skriv inn anmeldelsen",
    again_question: "en gang til ?",
    ratings_already_submitted_review: "Du har allerede sendt inn gjennomgang",
    set_product_category: "Sett produktkategori",
    auth_email_password_incorrect: "Din e-post eller passord er feil",
    auth_insert_your_name: "Vennligst sett inn navnet ditt",
    auth_email_address_badly: "E-postadressen er dårlig formatert",
    auth_email_address_used:
      "E-postadressen er allerede i bruk av en annen konto",
    auth_invalid_password: "Passordet skal være minst 6 tegn",
    auth_reset_email:
      "Skriv inn e-posten din for å tilbakestille passordet ditt",
    auth_check_email:
      "Vennligst sjekk e-posten din for å tilbakestille passordet",
    auth_can_sign_in_google: "Du kan logge på med Google-knappen",
    auth_do_not_have_account: "Har du ikke en konto?",
    auth_have_account: "Har du en konto?",
    log_terms_privacy_part1:
      "Ved å registrere deg eller logge inn, godtar du det som er oppført i nærheten av meg",
    boost_this_product: "Øk dette produktet?",
    product_successfully_boosted: "Produktet har blitt forsterket",
    product_failed_boost: "Produktet har blitt mislyktes i boost",
    no_products_for_sale:
      "Du har for øyeblikket ikke brukte produkter som er oppført for salg.",
    not_sold_listed_near_me: "Jeg solgte det ikke på oppført i nærheten av meg",
    agree_add_product:
      "Ved å tappe innlegget for å publisere produktet ditt, godtar du det som er oppført i nærheten av meg vilkår for service og personvernregler.",
    click_to_boost: "Klikk på produktet for å øke det",
    listed_terms_of_service: "Oppført i nærheten av meg Vilkår for bruk",
    receive_emails_for_users: "Motta e-post til brukere meldinger",
    receive_emails_for_newly_posted:
      "Motta e-post til dine nypostede produkter",
    disable_push_notifications: "Deaktiver pushvarsler",
    sms_during_day: "Motta SMS i løpet av dagen",
    sms_24_hours: "Motta SMS 24 timer",
    products: "Produkter",
    product_no_longer_available:
      "Beklager, dette produktet er ikke lenger tilgjengelig",
    add_home: "Legg til hjem",
    edit_home: "Rediger hjem",
    fill_required_fields: "Fyll alle de obligatoriske feltene",
    no_notification: "Det er ingen varsler",
    orders_history: "Bestillinger historie",
    privacy: "Personvern",
    terms: "Vilkårene",
    report_a_problem: "Rapporter et problem",
    approximation_protect_user_privacy:
      "Tilnærming for å beskytte brukerens personvern",
    do_not_have_products: "Du har ikke produkter",
    emails: "E-post",
    lead_deletion_products:
      "Dette vil føre til sletting av alle produktene dine",
    confirm_legal_message:
      "Du er eneansvarlig for å ta alle nødvendige forholdsregler når du samhandler med andre, spesielt når man møter en fremmed i person for første gang. Vennligst se på Vilkår for å få mer informasjon.",
    push_notifications_notified_instantly:
      "Aktiver push-varsler som skal varsles umiddelbart",
    rate_seller: "Vurder selger",
    user_journey: "Bruker reise",
    user: "Bruker",
    user_id: "Bruker-ID",
    action_id: "Action ID.",
    select_model_car: "Velg modell av bil",
    boost_1_day: "Øke 1 dag",
    boost_3_days: "Øke 3 dager",
    boost_7_days: "Øke 7 dager",
    agree_boost_terms: "Ved å tappe boost, godtar du",
    add: "Legg til",
    add_tag: "Legg til tag",
    brand_title: "Merke",
    category_mobiles: "Mobiler",
    category_tablets: "Tabletter",
    screen_size: "Skjerm størrelse",
    has_cellular_capability: "Har cellulær evne",
    default_internal_memory: "Internt minne",
    network_carrier: "Network Carrier.",
    is_unlocked: "Er ulåst",
    mobile_model_warning: "Vennligst velg Brand først",
    missing_image: "Manglende bilde, prøv å legge til bilde på nytt.",
    add_mobile: "Legg til Mobile.",
    edit_mobile: "Rediger mobil",
    add_tablet: "Legg til tablett",
    edit_tablet: "Rediger tablett",
    keywords:
      "Shopping, Kjøp, Selg, Tjen penger, Handel, Lokalbefolkningen, Naboer, Auto, Kjøretøy",
    country: "Land",
    phone_number: "Telefonnummer",
    verification_code: "Bekreftelseskode",
    error_occurred: "En feil oppstod. Vennligst prøv igjen senere",
    invalid_state:
      "Ugyldig tilstand: En innloggingsoppringing ble mottatt, men ingen innloggingsforespørsel ble sendt.",
    sign_in: "Logg inn",
    sign_in_apple: "Logg på med Apple",
    sign_in_google: "Logg på med Google",
    sign_in_phone: "Logg inn med telefonen",
    sign_in_facebook: "Logg inn med Facebook",
    create_account: "Opprett en konto",
    email: "E-post",
    invalid_field: "Vennligst fyll ut de obligatoriske feltene",
    code_sent: "Koden er sendt via SMS",
    verify_number: "Bekreft telefonnummer",
    tapping_verify_number:
      "Ved å tappe (bekreft telefonnummer), sendes en SMS.",
    email_exists:
      "Kontoen eksisterer allerede, og du må få tilgang til den via Google-knappen, Facebook-knappen eller Apple-knappen",
    ok: "OK",
    sure_back: "Er du sikker på å komme tilbake?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "siden",
    add_model: "Legg til modell",
    no_search_results_us:
      "Ingen søkeresultater i nærheten av deg innen 120 miles. Forsøk å endre søkefilteret eller søkeordet.",
    no_search_results:
      "Ingen søkeresultater i nærheten av deg innen 200 km. Forsøk å endre søkefilteret eller søkeordet.",
    plan_date: "Plandato",
    plan_time: "Planetid",
    invalid_plan_date: "Ugyldig plandato, vennligst angi plandato igjen",
    invalid_plan_time: "Ugyldig planetid, vennligst angi plan tid igjen",
    plan_name: "Plannavn",
    plan_title: "Plan",
    update_plan_name: "Oppdater plannavn",
    delete_plan_question: "Er du sikker på at du vil slette denne planen?",
    plan_reminder_message: "Du blir påminnet en time før",
    plan_dialog_title: "Møteplan",
    planners_title: "Planleggere",
    unable_sending_messages:
      "De vil se meldingene dine når de er tilbake på nettet.",
    its_text: "Det er",
    for_your_text: "for mottakeren din.",
  },
  pl: {
    invalid_area: "Nieprawidłowy obszar, proszę ustawić obszar ponownie.",
    invalid_lot_size:
      "Nieprawidłowy rozmiar partii właściwości, proszę ponownie ustawić rozmiar.",
    property_area: "Nieruchomość",
    app_store_name:
      "Wymienione w pobliżu Me - Kup używane przedmioty, sprzedaj za gotówkę",
    app_store_short:
      "Rynek lokalnych sprzedawców. Wymień przedmiot na sprzedaż i zarabiaj pieniądze.",
    app_store_full:
      "Wymienione w pobliżu mnie ułatwia znalezienie wspaniałych ofert na temat rzeczy, które chcesz i zarabiaj na rzeczy, które chcesz sprzedać. Jest to najlepszy sposób na zakup i sprzedaż w swojej społeczności lub sąsiedztwie z ludźmi, którym możesz zaufać. Jak to działa: 1- kupuj lub sprzedaj wszystko; Łatwo opublikuj swoje przedmioty na sprzedaż w kilka sekund. 2- Znajdź świetne oferty i zniżki na ubrania, meble, telefony komórkowe, elektronikę, przedmioty dla dzieci i dziecięce, sprzęt do dzieci, używane samochody, sukienki, buty i zegarki, do książek, używane zabawki, używane laptopy, sekwensny samochód, a nawet prawdziwy nieruchomość na sprzedaż lub czynsz. 3- Przeglądaj lokalne przedmioty na sprzedaż. 4- wiadomość nabywców i sprzedawców z aplikacji. 5- Przeglądaj przedmioty według obrazu i sortuj według kategorii. Fun fakty o wymienionych w pobliżu mnie: 1- Z wymienionym w pobliżu mnie można łatwo sprzedać wszystko, z ubrań do używanych samochodów do elektroniki. 2-Komunikacja między nabywcami a sprzedawcami dzieje się przez aplikację poprzez przesyłanie wiadomości. 3 - wymienione w pobliżu mnie jest lepsze niż sprzedaż garażu; Znajdź wszystko, co chcesz z rabatem, na telefonie lub tablecie.",
    app_store_release:
      "Wymienione w pobliżu mnie - Handel z mieszkańcami. Dołącz do Mobile Marketplace dla lokalnych nabywców i sprzedawców!",
    app_name: "Wymienione w pobliżu Me.",
    title_buy: "Kup",
    title_messages: "Wiadomości",
    title_sell: "Sprzedać",
    title_profile_image: "Zdjęcie profilowe",
    title_account: "Rachunek",
    account_settings: "Ustawienia konta",
    settings: "Ustawienia",
    color_theme: "Motyw koloru",
    device_settings: "Ustawienia urządzenia",
    public_profile: "Profil publiczny",
    light_mode: "Tryb świetlny",
    dark_mode: "Ciemny tryb",
    title_sell_faster: "Sprzedaj szybciej",
    send_button_label: "Wysłać",
    rate_message: "Oceń mnie...",
    already_rated: "Już przesłałeś recenzję",
    rate_review_question: "Chciałbyś sobie poradzić",
    again: "Ponownie?",
    action_logout: "Wyloguj",
    action_category: "Kategoria",
    action_search: "Szukaj",
    action_refer: "Skieruj znajomego",
    dialog_choose_location: "Wybierz lokacje",
    dialog_change_username: "Zmień nazwę użytkownika",
    dialog_change_language: "Zmień język",
    dialog_image_tags: "Tagi obrazów",
    dialog_emails_notifications: "Powiadomienia e-mail",
    dialog_push_notifications: "Powiadomienia push",
    fragment_product_detail: "Szczegóły produktu",
    fragment_message_details: "Szczegóły wiadomości",
    fragment_sell: "Sprzedać",
    dialog_tags_title: "Tagi.",
    dialog_location_title: "Zaktualizuj lokalizację",
    dialog_username_title: "Zmień nazwę użytkownika",
    tab_photo: "Zdjęcie",
    tab_details: "Detale",
    tab_price: "Cena £",
    tab_finish: "Skończyć",
    profile: "Profil",
    search: "Szukaj",
    choose_product: "Wybierz produkt",
    rating_review: "Ocena i przegląd",
    select_buyer: "Wybierz kupujący",
    tab_my_used_products: "Moje produkty",
    price_label: "Cena £",
    text_savings: "Oszczędzasz",
    search_hint: "Szukaj produktów ...",
    empty_text:
      "Nie ma żadnych produktów w tej kategorii ani w wybranej odległości.",
    filter_menu_text: "Filtr",
    error_contacting_seller: "Błąd kontaktowany ze sprzedawcą",
    edit_product: "Edytuj produkt",
    contact_seller: "Skontaktuj się ze sprzedawcą",
    signup_to_contact_seller:
      "Zarejestruj się, aby skontaktować się ze sprzedawcą",
    signup_to_make_offer: "Zarejestruj się, aby złożyć ofertę",
    product_details: "Detale",
    product_category: "Kategoria",
    product_condition: "Stan: schorzenie",
    product_description: "Opis",
    product_location: "Lokalizacja produktu",
    product_location_approximate: "Lokalizacja jest przybliżona",
    over_week_time_ago: "Ponad tydzień temu",
    boosted: "Wzmocniony",
    threads_no_results: "Brak wiadomości",
    message_no_results: "Brak wiadomości",
    message_warning:
      "Jesteś wyłącznie odpowiedzialny za podejmowanie wszystkich niezbędnych środków ostrożności podczas interakcji z innymi, szczególnie podczas spotkania z nieznajomym po raz pierwszy. Nie udostępniaj żadnych danych osobowych, kodów weryfikacyjnych ani żadnych informacji o płatności. Więcej informacji należy przejrzeć warunki usługi.",
    message_block: "W tej chwili nie możesz wysyłać ani odbierać wiadomości.",
    select_location: "Wybierz lokalizację",
    location_permission_denied_message:
      "Aplikacja wymaga prawidłowego działania uprawnień lokalizacji.",
    signed_in: "Zapisany!",
    sign_in_canceller: "Zaloguj się anulowany",
    version: "Wersja",
    build: "Zbudować",
    name: "Nazwa",
    location: "Lokalizacja",
    language: "Język",
    about_app: "O wymienionych w pobliżu mnie",
    terms_of_service: "Warunki usługi",
    privacy_policy: "Polityka prywatności",
    report_feedback: "Wyślij opinię",
    report_bug: "Potrząśnij telefonem, aby zgłosić błąd",
    change_image: "Zmień obraz",
    update_location: "Zaktualizuj lokalizację",
    about_the_app: "O aplikacji.",
    update_label: "Aktualizacja",
    uploading: "Przesyłanie",
    adding: "Dodawanie aukcji.",
    removing: "Wyjmowanie aukcji",
    updating: "Aktualizacja aukcji",
    uploaded_image: "Przesłany obraz:",
    image_storage_failed: "Nie można przechowywać obrazu:",
    product_updated: "Produkt został pomyślnie zaktualizowany",
    location_error: "Lokalizacja nie zapisana, spróbuj ponownie",
    product_removed: "Produkt usunięty pomyślnie",
    deleted_product: "Ten produkt jest usuwany",
    invalid_title: "Nieprawidłowy tytuł, ponownie ustaw tytuł.",
    invalid_image:
      "Nieprawidłowa ścieżka obrazu, spróbuj ponownie dodać obraz.",
    invalid_price: "Nieprawidłowa cena, proszę ustawić cenę ponownie.",
    invalid_location:
      "Nieprawidłowa lokalizacja, proszę ponownie ustawić lokalizację.",
    invalid_category: "Nieprawidłowa kategoria, ponownie ustawić kategorię.",
    invalid_condition: "Nieprawidłowy stan, proszę ustawić stan ponownie.",
    removing_title: "Usuwanie obrazu profilu.",
    image_not_saved: "Zapisz obraz nie powiodło się!",
    product_load_failed: "Brak produktów",
    take_photo: "Zrobić zdjęcie",
    select_photo: "Wybierz zdjęcie",
    product_title_hint: "Co to jest? Nazwa, marka, model itp.",
    delete_photo: "Usuń zdjęcie",
    product_title: "Tytuł",
    mark_as_sold: "Zaznacz jako sprzedany",
    product_share: "Udział",
    product_make_offer: "Złóż ofertę",
    product_cover: "Ustaw jako obraz okładki",
    product_tags: "Tagi.",
    product_posted: "Wysłany:",
    product_change: "Zmiana",
    product_post: "Poczta",
    product_selling_from: "Sprzedaż od lokalizacji",
    product_select_location: "Wybierz lokalizację",
    product_map_approximate:
      "Mapa jest przybliżona, aby utrzymać prywatny sprzedawca",
    product_terms:
      "Tapping Post, aby opublikować swój produkt, zgadzasz się na <U> wymienione w pobliżu Warunki korzystania z usługi. </ U>",
    condition_other: "Inne (patrz opis)",
    condition_for_parts: "Na części",
    condition_used: "Używane (normalne zużycie)",
    condition_open_box: "Otwórz pudełko (nigdy nie używane)",
    condition_reconditioned: "Odnowiony / certyfikowany",
    condition_new: "Nowy (nigdy nie używany)",
    select_category: "Wybierz kategorię",
    select_all_category: "Zaznacz wszystko",
    category_loading_error:
      "Nie można aktualizować listy kategorii, spróbuj ponownie później.",
    category_vehicles: "Pojazdy",
    category_furniture: "Meble",
    category_electronics: "Elektronika",
    category_appliances: "Home &  Urządzenia",
    category_fashion_accessories: "Moda i  Akcesoria",
    category_baby_kids: "Dziecko i  Dzieci",
    category_antiques_collectibles:
      "Antyki i wzmacniacz; Artykuły kolekcjonerskie",
    category_auto_parts_tools_machinery:
      "Części samochodowe, narzędzia i wzmacniacz; Maszyneria",
    category_sports_outdoors: "Sport i  Na dworze",
    category_others: "Inni",
    location_enter_zip_code: "Wprowadź kod pocztowy",
    location_get_current_location: "Uzyskaj bieżącą lokalizację",
    location_select_location: "Wybierz lokalizację",
    location_update_location: "Zaktualizuj lokalizację",
    location_new_location: "Nowa lokalizacja",
    search_filter_results: "Filtruj wyniki",
    search_filter_min: "Filtrowaj minimum.",
    search_filter_at_least: "Przynajmniej",
    price_filter: "Filtr Cena",
    product_name: "Nazwa produktu",
    english_language: "język angielski",
    arabic_language: "arabski",
    spanish_language: "hiszpański",
    system_language: "System",
    share_link: "Udostępnij link",
    save: "Zapisać",
    cancel: "Anuluj",
    loading: "Ładowanie",
    yes: "tak",
    no: "Nie",
    report: "Raport",
    report_product: "Zgłoś produkt",
    report_user: "Zgłoś użytkownika",
    block_user: "Zablokować użytkownika",
    un_block_user: "Odblokuj użytkownika",
    why_product: "Dlaczego chcesz zgłosić ten przedmiot?",
    why_user: "Dlaczego chcesz zgłosić tego użytkownika?",
    block_user_confirm: "Czy chcesz trwale zablokować tego użytkownika?",
    un_block_user_confirm: "Czy chcesz trwale odblokować tego użytkownika?",
    prohibited: "Zabronione na liście w pobliżu mnie",
    offensive: "Obraźliwy lub nieodpowiedni",
    duplicate: "Duplikat post.",
    wrong_category: "Zła kategoria",
    scam: "Wygląda jak oszustwo",
    stolen: "Myślę, że jest skradziony",
    product_other: "Inny",
    product_is_sold: "Ten produkt został sprzedany",
    missed_meeting: "Tęsknili za naszym spotkaniem",
    low_offer: "Dokonał niskiej oferty",
    rude: "Niegrzeczny lub nieodpowiedni",
    items: "Problem z przedmiotami",
    trouble_meetup: "Kłopoty na spotkaniu",
    messaging: "Problemy z wiadomościami",
    user_other: "Inny",
    new_version_available: "Nowa wersja dostępna",
    please_update_app: "Poproś aplikację do nowej wersji, aby kontynuować.",
    update: "Aktualizacja",
    no_thanks: "Nie, dziękuję",
    contact_support_confirmation:
      "Aktualny czas odpowiedzi wynosi 24-48 godzin. Chcesz skontaktować się z wymienionymi w pobliżu Me App Chat Support?",
    unboost_confirmation: "Czy na pewno chcesz uniknąć tego produktu?",
    no_used_products: "Nie masz jeszcze żadnych ofert",
    no_boosted_products: "Nie masz żadnych pobudzonych produktów",
    next: "Następny",
    previous: "Poprzedni",
    skip: "Pomijać",
    start: "Początek",
    list_used: "Wymień używany produkt",
    buy_description:
      "Odkryj i wyszukaj produkty oferowane przez sąsiedzi wokół ciebie",
    sell_description: "Lista produktów Nie potrzebujesz już na sprzedaż",
    list_used_description:
      "Wymień używany produkt na sprzedaż w mniej niż 20 sekund",
    boost_product_option_1: "<b> Zwiększ 1 nda </ b> n <b> 0,99 USD </ b>",
    boost_product_option_2: "<b> Zwiększenie 3 Nday </ b> n <b> 1,99 USD </ b>",
    boost_product_option_3: "<b> Boost 7 Nday </ b> n <b> 3,99 USD </ b>",
    boost_product_description:
      "Uzyskaj więcej widoków każdego dnia. Twój przedmiot pojawi się w wybranych pozycjach w 30 najlepszych przedmiotach w Kupie i kategorii. Promowane przedmioty są obracane wśród wyznaczonych miejsc, dzięki czemu każdy przedmiot jest sprawiedliwy.",
    boost_cta: "Sprzedaj szybciej",
    boost_terms:
      "Stukając zwiększenie, zgadzasz się na <u> wymienione w pobliżu Warunki korzystania z usługi. </ U>",
    boost_best_value: "Najlepsza wartość",
    already_boosted: "Ten produkt jest wzmocniony",
    clicks: "Kliknięcia.",
    impressions: "Wrażenia",
    end: "Kończyć się",
    transactions_empty_text:
      "Nie masz jeszcze żadnych transakcji do zwiększenia. Możesz odwiedzić zakładkę Spotkania i zacząć zwiększać swoje produkty.",
    transactions_loading_error:
      "Nie można zaktualizować listy transakcji, spróbuj ponownie później.",
    transactions_history_title: "Historia transakcji zwiększenia",
    communicative_postive: "Rozmowny",
    communicative_negative: "Małomówny",
    ontime_postive: "Na czas",
    ontime_negative: "Późno",
    reliable_postive: "Wiarygodny",
    reliable_negative: "Niewiarygodne",
    friendly_postive: "Przyjazny",
    friendly_negative: "Nieuprzejmy",
    itemasdescribed_postive: "rzecz jak w opisie",
    itemasdescribed_negative: "Element nie zgodnie z opisem",
    other: "Inny",
    submit: "Składać",
    adding_rating_reviews: "Dodawanie oceny i opinie",
    no_internet_title: "Brak połączenia z internetem",
    no_internet_message:
      "Upewnij się, że jesteś połączony z Internetem i spróbuj ponownie",
    retry: "Spróbować ponownie",
    near_me: "Blisko mnie",
    newest_first: "Najnowszy pierwszy",
    miles: "mil",
    km: "KM.",
    similar_products: "podobne produkty",
    favorite_products: "Ulubione produkty",
    items_for_sale: "rzeczy na sprzedaż",
    joined: "Dołączył",
    favorites_transactions_title: "Ulubione",
    boosted_products_transactions_history:
      "Historia transakcji pobudził produkty",
    views: "Wyświetlenia",
    boost_graph_title: "Wykres",
    no_favorite_products: "Nie masz żadnych ulubionych produktów",
    make_offer_buy: "chciałbym kupić",
    make_offer_buy_for: "dla",
    notifications: "Powiadomienia",
    push_notifications: "Naciskać",
    emails_notifications: "E-mail",
    apply: "Zastosować",
    email_messages: "E-mail na wiadomości",
    email_new_products: "E-mail na nowe produkty",
    push_day_only: "Tylko dzień powiadomień push",
    push_24_hours: "Powiadomienia push 24 godziny",
    edit: "Edytować",
    map: "Mapa",
    camera: "Aparat fotograficzny",
    gallery: "Galeria",
    delete: "Kasować",
    no_sell_items: "Brak przedmiotów na sprzedaż",
    who_bought_question: "Kto go kupił?",
    sold_elsewhere_question: "Sprzedałem to gdzie indziej",
    confirm: "Potwierdzać",
    over_limit_camera: "Nie możesz dodać więcej niż pięciu zdjęć",
    boost_failed: "Boost nie powiódł się. Spróbuj ponownie później",
    after_purchase: "Płatność udana nomproduct zwiększona",
    pay_failed: "Płatność nie powiodła się. Proszę spróbuj ponownie",
    done: "Gotowe",
    not_now: "Nie teraz",
    boost: "Zwiększyć",
    invalid_zip_code: "Niepoprawny kod pocztowy",
    invalid_user_name: "Zła nazwa użytkownika",
    comments: "Uwagi",
    questions: "pytania",
    bug_reports: "Zgłaszanie błędów",
    feature_request: "Żądanie funkcji.",
    feedback_type: "Typ sprzężenia zwrotnego",
    feedback_description:
      "Chcielibyśmy usłyszeć twoje myśli lub informacje zwrotne, jak możemy poprawić swoje doświadczenia!",
    feedback: "Sprzężenie zwrotne",
    feedback_text: "Twoja odpowiedź",
    suggestions: "Sugestie dotyczące poprawy",
    delete_account: "Usuń konto",
    new_message: "Nowa wiadomość",
    online: "online",
    km_50: "50 km.",
    km_100: "100 km",
    km_200: "200 km.",
    miles_30: "30 mil",
    miles_60: "60 mil",
    miles_120: "120 mil",
    rate_app_question: "Co powiesz na rating w App Store?",
    enjoying_question: "Ciesz się wiściem w pobliżu?",
    not_enjoy: "Nie całkiem",
    feedback_question: "Czy mógłbyś dać nam pewną opinię?",
    yes_sure: "Dobrze, jasne",
    product_available_question: "Cześć, czy jest to nadal dostępny?",
    buy_question: "Cześć, lubię to kupić",
    meet_question: "Cześć, możesz dzisiaj spotkać?",
    follow: "Podążać",
    followers: "Obserwujący",
    following: "Następny",
    feedback_thanks: "Dziekuję za odpowiedź",
    all_categories: "Wszystkie kategorie",
    deleted_account: "To konto jest usuwane",
    delete_account_question: "Czy jesteś pewien, że chcesz usunąć to konto?",
    no_followings: "nie śledzi nikogo",
    when_following: "Kiedy",
    no_followings_subtitle: "podąża za ludźmi, zobaczysz je tutaj",
    no_followers: "nie ma zwolenników",
    no_followers_subtitle: "następnie ludzie, zobaczysz je tutaj",
    distance: "Dystans",
    filter_method: "Metoda filtra",
    see_listings: "Patrz aukcje",
    sold: "Sprzedany",
    bought: "Kupił",
    no_notifications: "Po otrzymaniu powiadomień pojawią się tutaj",
    items_title: "Przedmiotów",
    new_listing_title: "Utwórz nową listę",
    dialog_year_title: "Rok",
    dialog_make_title: "Robić",
    dialog_model_title: "Model",
    dialog_body_style_title: "Budowa ciała",
    dialog_exterior_color_title: "Kolor zewnętrzny",
    dialog_interior_color_title: "Kolor wnętrza",
    dialog_transmission_title: "Transmisja",
    dialog_fuel_type_title: "Typ paliwa",
    dialog_owners_num_title: "Liczba właścicieli",
    dialog_vehicle_owed_money_title:
      "Czy są tam pieniądze wciąż należne w tym pojeździe?",
    automatic_transmission: "Automatyczny",
    manual_transmission: "podręcznik",
    not_sure: "Niepewny",
    wagon_hatchback: "Wagon i wzmacniacz; Hatchback.",
    convertible: "Zamienny",
    coupe: "Coupe.",
    sedan: "Sedan.",
    black_color: "Czarny",
    blue_color: "Niebieski",
    brown_color: "brązowy",
    gold_color: "Złoto",
    green_color: "Zielony",
    grey_color: "Szary",
    pink_color: "Różowy",
    purple_color: "Fioletowy",
    red_color: "czerwony",
    silver_color: "Srebro",
    orange_color: "Pomarańczowy",
    white_color: "biały",
    yellow_color: "Żółty",
    charcol_color: "Charcol.",
    fuel_diesel: "Diesel",
    fuel_electric: "Elektryczny",
    fuel_gasoline: "Benzyna",
    fuel_flex: "Przewód",
    fuel_hybrid: "Hybrydowy",
    fuel_petrol: "Benzyna",
    fuel_plugin_hybrid: "Hybrydowy",
    truck: "Ciężarówka",
    van_minivan: "Van &  Minivan.",
    suv_crossover: "SUV &  Krzyżowanie",
    awd_4wd: "AWD / 4WD.",
    fwd: "Fwd.",
    rwd: "Rwd.",
    off_white_color: "Off White.",
    tan_color: "Dębnik",
    beige_color: "Beżowy",
    burgundy_color: "Burgundia",
    turquoise_color: "Turkus",
    title_status_clean: "Czysty",
    title_status_rebuilt: "Odbudowany",
    title_status_salvage: "Odzysk",
    title_status_missing: "Zaginiony",
    title_status_lien: "Zastaw",
    title_status: "Status tytułu",
    mileage: "Przebieg",
    dialog_drivetrain_title: "Drivetrain.",
    model_warning: "Wybierz pierwsze",
    required_field_warning: "To pole jest wymagane",
    vehicle_vin: "Vin.",
    invalid_vin: "Nieprawidłowy VIN, ponownie ustawić VIN.",
    invalid_mileage: "Nieprawidłowy przebieg, ponownie ustawić przebieg.",
    clean_description: "Większość pojazdów, które nie były w wypadku",
    rebuilt_description: "Odzyskany samochód, który został odbudowany",
    salvage_description: "Jest uważany za wyniosłą po wypadku",
    missing_description: "Będzie potrzebować nowego tytułu problemów DMV",
    lien_description: "Należący do osiedla bankowego lub sądowego",
    nearme: "Blisko mnie",
    newest: "Najnowszy",
    contact_support: "Skontaktuj się z obsługą",
    create_home_title: "Domy na sprzedaż lub czynsz",
    for_sale: "Na sprzedaż",
    for_rent: "Do wynajęcia",
    property_type: "Typ nieruchomości",
    apartment: "Apartament",
    house: "Dom",
    room_only: "Tylko pokój",
    townhouse: "Kamienica",
    bedrooms: "Sypialnie",
    bathrooms: "Łazienki",
    property_address: "Adres nieruchomości",
    price_per_month: "Cena za miesiąc",
    square_feet: "Stóp kwadratowych",
    year_built: "Rok wybudowany",
    year_renovated: "Wyremontowany rok",
    lot_size: "Wielkość partii",
    laundry_type: "Typ prania",
    in_unit_laundry: "Pranie w jednostce",
    laundry_building: "Pralnia w budynku",
    laundry_available: "Dostępne do prania.",
    none: "Nic",
    parking_type: "Typ parkingowy",
    garage_parking: "Parking garażowy.",
    street_parking: "Parking uliczny.",
    off_street_parking: "Parkowanie poza ulicą",
    available_parking: "Parking dostępny",
    air_cond_type: "Typ klimatyzacji",
    ac_available: "AC Dostępny",
    central_ac: "Centralny AC.",
    heating_type: "Typ ogrzewania",
    electric_heating: "Ogrzewanie elektryczne",
    gas_heating: "Ogrzewanie gazowe.",
    radiator_heating: "Ogrzewanie grzejnikowe",
    available_heating: "Dostępne ogrzewanie",
    amenities: "Udogodnienia",
    date_available: "Data dostępna",
    lease_length: "Długość dzierżawy",
    month_to_month: "Od miesiąca do miesiąca",
    three_months: "3 miesiące",
    six_months: "6 miesięcy",
    one_year: "1 rok",
    more_one_year: "1+ lata.",
    cat_friendly: "Przyjazny kot",
    dog_friendly: "Pies przyjazny",
    balcony: "Balkon",
    basement: "Piwnica",
    bike_parking: "Parking rowerowy",
    cable_tv: "Telewizja kablowa",
    ceiling_fan: "Wentylator sufitowy",
    concierge: "Concierge",
    dishwasher: "Zmywarka",
    doorman: "Portier",
    elevator: "Winda",
    fireplace: "Kominek",
    fitness_center: "Centrum fitness",
    garbage_disposal: "Wywóz śmieci",
    microwave: "kuchenka mikrofalowa",
    online_app: "Aplikacja online",
    oven: "Piekarnik",
    package_service: "Usługa pakietu.",
    patio: "Patio",
    pet_park: "Park",
    refrigerator: "Lodówka",
    resident_lounge: "Salon rezydenta",
    roof_deck: "Taras na dachu",
    secured_entry: "Zabezpieczony wpis",
    storage: "Przechowywanie",
    walk_in_closet: "Garderoba",
    swimming_pool: "Basen",
    wheelchair_access: "Dostęp dla wózków inwalidzkich",
    central_heating: "Centralne ogrzewanie",
    invalid_bedrooms:
      "Nieprawidłowe sypialnie, proszę ponownie ustawić sypialnie.",
    invalid_bathrooms:
      "Nieprawidłowe łazienki, proszę ponownie ustawić łazienki.",
    chinese_simplified_language: "Uproszczony chiński",
    chinese_traditional_language: "Chiński tradycyjny",
    czech_language: "Czech",
    danish_language: "duński",
    dutch_language: "holenderski",
    finnish_language: "fiński",
    french_language: "Francuski",
    german_language: "Niemiecki",
    greek_language: "grecki",
    hungarian_language: "język węgierski",
    indonesian_language: "indonezyjski",
    italian_language: "Włoski",
    japanese_language: "język japoński",
    korean_language: "koreański",
    norwegian_language: "norweski",
    polish_language: "Polskie",
    portuguese_language: "portugalski",
    portuguese_brazilian_language: "Portugalski, brazylijski",
    romanian_language: "rumuński",
    russian_language: "Rosyjski",
    swedish_language: "szwedzki",
    turkish_language: "turecki",
    ukrainian_language: "ukraiński",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "wietnamski",
    category_home_sale_or_rent: "Dom na sprzedaż lub czynsz",
    square_meter: "Metr kwadratowy",
    copy_text: "Kopiuj",
    copyied_to_clipboard: "Skopiowane do schowka",
    inbox: "W pudełku",
    input_title_listening: "Słuchający…",
    input_subtitle_listening: "Powiedz coś",
    input_title_error: "Przepraszamy, nie daj nam to zrobić.",
    input_subtitle_error: "Spróbuj powtórzyć żądanie.",
    input_hint_error: "Spróbuj ponownie",
    price_less_than_or_equal: "Cena mniejsza lub równa",
    any_price: "Każda cena",
    any_condition: "Dowolny stan",
    any_time: "W dowolnym momencie",
    days_ago: "kilka dni temu",
    any_distance: "Dowolna odległość",
    distance_within: "Odległość w środku",
    new_notification: "Nowe powiadomienie",
    deleted: "Usunięty",
    processing_image: "Obraz przetwarzania",
    remove_dialog_message: "Czy naprawdę chcesz usunąć ten produkt?",
    deleted_thread: "Ta wiadomość zostanie usunięta",
    category_yard_sale_event: "Wydarzenie na sprzedaż Yard.",
    yard_first_date: "Pierwsza data sprzedaży",
    yard_second_date: "Druga data sprzedaży",
    yard_third_date: "Trzecia data sprzedaży",
    yard_start_time: "Czas rozpoczęcia",
    yard_end_time: "Koniec czasu",
    yard_end_timestamp: "Koniec znacznika czasu",
    invalid_date1:
      "Nieprawidłowa pierwsza data, ponownie ustawić pierwszą randkę",
    invalid_start_time:
      "Nieprawidłowy czas rozpoczęcia, ponownie ustawić czas rozpoczęcia",
    invalid_end_time:
      "Nieprawidłowy czas zakończenia, proszę ponownie ustawić czas",
    yard_sale_title: "Sprzedaż jardów.",
    garage_tag: "garaż",
    yard_tag: "dziedziniec",
    from: "Z",
    to: "Do",
    block: "Blok",
    un_block: "Odblokować",
    sign_email: "Zaloguj się za pomocą wiadomości e-mail",
    invalid_first_date:
      "Nieprawidłowa pierwsza data, upewnij się, że pierwsza data jest przed drugą i trzecim",
    invalid_second_date:
      "Nieprawidłowa druga data, upewnij się, że druga data jest przed trzecią datą",
    invalid_start_time_value:
      "Nieprawidłowy czas rozpoczęcia, upewnij się, że czas rozpoczęcia jest przed zakończeniem czasu",
    use_default_yard_photo: "Użyj domyślnej stoczni",
    active_label: "Aktywny",
    enable_notifications: "Włącz powiadomienia",
    login: "Zaloguj sie",
    january: "Styczeń",
    february: "luty",
    march: "Marsz",
    april: "kwiecień",
    may: "Móc",
    june: "czerwiec",
    july: "lipiec",
    august: "sierpień",
    september: "wrzesień",
    october: "październik",
    november: "listopad",
    december: "grudzień",
    since: "Odkąd",
    product_views: "Widoki na produkty.",
    shop_views: "Widoki na zakupy.",
    total_sales: "Całkowita sprzedaż",
    total_orders: "Łączne zamówienia",
    last_twelvth_months: "Ostatnie miesiące dwunastego",
    last_nine_months: "Ostatnie dziewięć miesięcy",
    last_six_months: "Ostatnie sześć miesięcy",
    last_three_months: "Ostatnie trzy miesiące",
    last_12_months: "Ostatnie 12 miesięcy",
    last_9_months: "Ostatnie 9 miesięcy",
    last_6_months: "Ostatnie 6 miesięcy",
    last_3_months: "Ostatnie 3 miesiące",
    months: "Miesiące",
    open: "otwarty",
    reset_password: "Zresetuj hasło",
    create_new_shop: "Utwórz nowy sklep",
    download_app: "Pobierz aplikację",
    log_in: "Zaloguj sie",
    sign_up: "Zapisz się",
    no_result: "Brak wyników",
    max_price: "Maksymalna cena",
    max_distance: "Max odległość",
    max_time: "Max",
    posted_less_than: "Wysłany mniej niż",
    result: "Wynik",
    more: "Jeszcze",
    or: "LUB",
    password: "Hasło",
    forgot_password: "Zapomniałeś hasła?",
    and: "oraz",
    download_for: "Pobierz",
    apple_ios: "Jabłko ios.",
    android: "Android",
    image: "Obraz",
    edit_image: "Edytuj obrazek",
    please_complete: "Proszę wypełnić",
    enter_your_offer: "Wpisz swoją ofertę",
    categories: "Kategorie",
    upload_image: "Załaduj obrazek",
    upload_images: "Wgrywać obrazy",
    back: "Plecy",
    see_more: "Zobacz więcej",
    add_product: "Dodaj produkt",
    selected: "Wybrany",
    create: "Tworzyć",
    rate_the_buyer: "Oceń kupującego",
    delete_product: "Usuń produkt",
    product: "Produkt",
    un_block_product: "Odblokuj produkt",
    share_your_product: "Udostępnij swój produkt",
    boost_details: "Zwiększyć szczegóły",
    remove_all_products: "Usuń wszystkie produkty",
    remove_all: "Usuń wszystko",
    add_vehicle: "Dodaj pojazd",
    edit_vehicle: "Edytuj pojazd",
    upload_a_photo: "Załaduj zdjęcie",
    view_details: "Pokaż szczegóły",
    add_yard_sale: "Dodaj sprzedaż stoczni.",
    edit_yard_sale: "Edytuj sprzedaż stoczni.",
    users: "Użytkownicy.",
    users_details: "Szczegóły użytkowników.",
    users_by_country: "Użytkownicy według kraju.",
    blocked_users: "Zablokowani użytkownicy",
    products_cards: "Karty produktów",
    archived_products: "Zarchiwizowane produkty",
    blocked_products: "Zablokowane produkty",
    products_by_country: "Produkty według kraju.",
    reports: "Raport",
    reports_details: "Raporty szczegóły",
    closed_reports: "Zamknięte raporty",
    threads: "Nici",
    threads_details: "Szczegóły wątków",
    chat_support: "Wsparcie czatu.",
    actions: "działania",
    search_actions: "Wyszukaj akcje.",
    product_view_actions: "Widok produktu Akcje",
    contact_seller_product: "Skontaktuj się ze sprzedawcą sprzedawcy",
    contact_owner_shop: "Skontaktuj się ze sklepem właściciela",
    ratings: "Oceny",
    reviews: "Recenzje",
    products_all_countries: "Produkty Wszystkie kraje",
    edit_profile: "Edytuj profil",
    my_profile: "Mój profil",
    profile_updated_successfully: "Profil zaktualizowany pomyślnie",
    are_you_sure: "Jesteś pewny",
    my_used_products: "Moje używane produkty",
    my_shops: "Moje sklepy",
    my_boosted_products: "Moje pobudzone produkty",
    messages_type_message_here: "tutaj wpisz swoją wiadomosć",
    messages_product_sold: "Ten produkt jest sprzedawany lub usunięty",
    seen: "Widziany",
    messages_never_miss_message: "Nigdy nie przegap wiadomości",
    enable: "Włączyć",
    send_notify: "Wyślij powiadomienie",
    un_close: "Unclose.",
    type_your_review: "Wpisz swoją recenzję",
    again_question: "Ponownie ?",
    ratings_already_submitted_review: "Już przesłałeś recenzję",
    set_product_category: "Ustaw kategorię produktu",
    auth_email_password_incorrect: "Twój e-mail lub nieprawidłowe hasło",
    auth_insert_your_name: "Proszę wstaw swoje imię",
    auth_email_address_badly: "Adres e-mail jest źle sformatowany",
    auth_email_address_used: "Adres e-mail jest już używany przez inne konto",
    auth_invalid_password: "Hasło powinno mieć co najmniej 6 znaków",
    auth_reset_email: "Wpisz swój adres e-mail, aby zresetować hasło",
    auth_check_email: "Sprawdź swój adres e-mail, aby zresetować hasło",
    auth_can_sign_in_google: "Możesz zalogować się za pomocą przycisku Google",
    auth_do_not_have_account: "Nie masz konta?",
    auth_have_account: "Czy masz konto?",
    log_terms_privacy_part1:
      "Rejestrując się lub zaloguj się, zgadzasz się na wymienione w pobliżu mnie",
    boost_this_product: "Zwiększ ten produkt?",
    product_successfully_boosted: "Produkt został pomyślnie zwiększony",
    product_failed_boost: "Produkt został nie powiódł się w zwiększeniu",
    no_products_for_sale:
      "Obecnie nie masz żadnych używanych produktów na sprzedaż.",
    not_sold_listed_near_me: "Nie sprzedałem go na wymienionych w pobliżu mnie",
    agree_add_product:
      "Wyszukiwanie postów, aby opublikować swój produkt, zgadzasz się na wymienione w pobliżu Warunki świadczenia usług i polityki prywatności.",
    click_to_boost: "Kliknij produkt, aby go wzmocnić",
    listed_terms_of_service:
      "Wymienione w pobliżu Warunki korzystania z usługi",
    receive_emails_for_users: "Otrzymuj e-maile dla wiadomości użytkowników",
    receive_emails_for_newly_posted:
      "Otrzymuj wiadomości e-mail dla nowo opublikowanych produktów",
    disable_push_notifications: "Wyłącz powiadomienia push.",
    sms_during_day: "Odbierz SMS w ciągu dnia",
    sms_24_hours: "Otrzymuj SMS 24 godziny",
    products: "Produkty",
    product_no_longer_available:
      "Przepraszamy, ten produkt nie jest już dostępny",
    add_home: "Dodaj do domu",
    edit_home: "Edytuj dom.",
    fill_required_fields: "Wypełnij wszystkie wymagane pola",
    no_notification: "Nie ma powiadomień",
    orders_history: "Historia zamówień",
    privacy: "Prywatność",
    terms: "Semestry",
    report_a_problem: "Zgłoś problem",
    approximation_protect_user_privacy:
      "Przybliżenie w celu ochrony prywatności użytkownika",
    do_not_have_products: "Nie masz produktów",
    emails: "E-maile.",
    lead_deletion_products:
      "Doprowadzi to do usunięcia wszystkich twoich produktów",
    confirm_legal_message:
      "Jesteś wyłącznie odpowiedzialny za podjęcie wszystkich niezbędnych środków ostrożności podczas interakcji z innymi, szczególnie podczas spotykania nieznajomego osobiście po raz pierwszy. Aby uzyskać więcej informacji, przejrzyj Warunki korzystania z usług.",
    push_notifications_notified_instantly:
      "Włącz powiadomienia push natychmiast notyfikowane",
    rate_seller: "Oceń sprzedawcę",
    user_journey: "Podróż użytkownika",
    user: "Użytkownik",
    user_id: "Identyfikator użytkownika",
    action_id: "Identyfikator działania",
    select_model_car: "Wybierz model samochodu",
    boost_1_day: "Zwiększ 1 dzień",
    boost_3_days: "Zwiększ 3 dni",
    boost_7_days: "Zwiększ 7 dni",
    agree_boost_terms: "Stukając zwiększenie, zgadzasz się na",
    add: "Dodać",
    add_tag: "Dodaj Tag.",
    brand_title: "Marka",
    category_mobiles: "Mobili",
    category_tablets: "Tabletki",
    screen_size: "Rozmiar ekranu",
    has_cellular_capability: "Ma zdolność komórkową",
    default_internal_memory: "Pamięć wewnętrzna",
    network_carrier: "Nośnik sieciowy.",
    is_unlocked: "Jest odblokowany",
    mobile_model_warning: "Wybierz markę",
    missing_image: "Brakujący obraz, spróbuj ponownie dodać obraz.",
    add_mobile: "Dodaj komórkę",
    edit_mobile: "Edytuj komórkę",
    add_tablet: "Dodaj tabletkę",
    edit_tablet: "Edytuj tablet.",
    keywords:
      "Zakupy, Kupię, Sprzedam, Zarabiaj, Handel, Miejscowi, Sąsiedzi, Auto, Pojazdy",
    country: "Kraj",
    phone_number: "Numer telefonu",
    verification_code: "Kod weryfikacyjny",
    error_occurred: "Wystąpił błąd. Proszę spróbować później",
    invalid_state:
      "Nieprawidłowy stan: odebrano wywołanie zwrotnego logowania, ale nie wysłano żądania logowania.",
    sign_in: "Zaloguj się",
    sign_in_apple: "Zaloguj się z jabłkiem",
    sign_in_google: "Zaloguj się z Google",
    sign_in_phone: "Zaloguj się za pomocą telefonu",
    sign_in_facebook: "Zaloguj się przez Facebook",
    create_account: "Utwórz konto",
    email: "E-mail",
    invalid_field: "Proszę wypełnić wymagane pola",
    code_sent: "Kod został wysłany przez SMS",
    verify_number: "Sprawdź numer telefonu",
    tapping_verify_number:
      "Tapping (zweryfikuj numer telefonu), zostanie wysłany SMS.",
    email_exists:
      "Konto już istnieje i musisz uzyskać dostęp do niego przez przycisk Google, przycisk na Facebooku lub przycisk Apple",
    ok: "Ok",
    sure_back: "Czy na pewno wróciłeś?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "temu",
    add_model: "Dodaj model.",
    no_search_results_us:
      "Brak wyników wyszukiwania w pobliżu 120 mil. Spróbuj zmienić filtr wyszukiwania lub słowo kluczowe wyszukiwania.",
    no_search_results:
      "Brak wyników wyszukiwania w pobliżu w odległości 200 km. Spróbuj zmienić filtr wyszukiwania lub słowo kluczowe wyszukiwania.",
    plan_date: "Data planu",
    plan_time: "Plan planowania",
    invalid_plan_date:
      "Niepoprawna data planu, prosimy o ponownie ustawić datę planu",
    invalid_plan_time:
      "Nieprawidłowy czas planu, prosimy o ponowne ustawienie czasu",
    plan_name: "Nazwa planu",
    plan_title: "Plan",
    update_plan_name: "Nazwa planu aktualizacji",
    delete_plan_question: "Czy na pewno chcesz usunąć ten plan?",
    plan_reminder_message: "Przypomina ci się godzinę wcześniej",
    plan_dialog_title: "Plan spotkań",
    planners_title: "Planiści",
    unable_sending_messages:
      "Zobaczą twoje wiadomości, gdy wrócą do Internetu.",
    its_text: "Jego",
    for_your_text: "dla twojego odbiornika.",
  },
  "pt-PT": {
    invalid_area: "Área inválida, por favor defina a área novamente.",
    invalid_lot_size:
      "Tamanho do lote de propriedade inválido, por favor, defina o tamanho do lote novamente.",
    property_area: "Área de propriedade.",
    app_store_name:
      "Listado perto de mim - comprar itens usados, vender por dinheiro",
    app_store_short:
      "Um mercado para vendedores locais. Listar um item para venda e ganhar dinheiro.",
    app_store_full:
      "Listado perto de mim torna fácil encontrar grandes ofertas nas coisas que você quer e ganhar dinheiro nas coisas que você quer vender. Esta é a melhor maneira de comprar e vender em sua comunidade ou bairro com pessoas que você pode confiar. Como funciona: 1- Compre ou venda qualquer coisa; Facilmente postar seus itens à venda em segundos. 2- Encontre ótimas ofertas e descontos em roupas, móveis, telefones celulares, eletrônicos, bebê e crianças, equipamentos esportivos, carros usados, vestidos, sapatos e relógios, para livros, brinquedos usados, laptops usados, um carro de segunda mão e até mesmo real propriedade para venda ou aluguel. 3- Navegue pelos itens locais para venda. 4- Compradores e vendedores de mensagens de dentro do aplicativo. 5- Navegue pelos itens por imagem e classifique por categoria. Fatos divertidos sobre listados perto de mim: 1- Com listado perto de mim você pode facilmente vender qualquer coisa, de roupas para carros usados ​​para eletrônica. 2- Comunicação entre compradores e vendedores acontece através do aplicativo via mensagens. 3 - listado perto de mim é melhor que uma venda de garagem; Encontre qualquer coisa que você quiser com desconto, diretamente no seu telefone ou tablet.",
    app_store_release:
      "Listado perto de mim - comércio com moradores. Junte-se ao mercado móvel para compradores e vendedores locais!",
    app_name: "Listado perto de mim",
    title_buy: "Comprar",
    title_messages: "Mensagens",
    title_sell: "Vender",
    title_profile_image: "Imagem de perfil",
    title_account: "Conta",
    account_settings: "Configurações de Conta",
    settings: "Configurações",
    color_theme: "Tema de cor",
    device_settings: "Configurações do dispositivo",
    public_profile: "Perfil público",
    light_mode: "Modo de luz",
    dark_mode: "Modo escuro",
    title_sell_faster: "Vender mais rápido",
    send_button_label: "Mandar",
    rate_message: "Me avalie...",
    already_rated: "Você já enviou revisão",
    rate_review_question: "Você gostaria de lidar com",
    again: "novamente?",
    action_logout: "Sair",
    action_category: "Categoria",
    action_search: "Procurar",
    action_refer: "Indique um Amigo",
    dialog_choose_location: "Escolha a localização",
    dialog_change_username: "Mudar nome de usuário",
    dialog_change_language: "Mudar idioma",
    dialog_image_tags: "Etiquetas de imagem.",
    dialog_emails_notifications: "Notificações de e-mails.",
    dialog_push_notifications: "Notificações via push",
    fragment_product_detail: "Detalhes do produto",
    fragment_message_details: "Detalhe de mensagens",
    fragment_sell: "Vender",
    dialog_tags_title: "Tag",
    dialog_location_title: "Atualizar localização",
    dialog_username_title: "Mudar nome de usuário",
    tab_photo: "foto",
    tab_details: "Detalhes",
    tab_price: "Preço",
    tab_finish: "Terminar",
    profile: "Perfil",
    search: "Procurar",
    choose_product: "Escolha o produto",
    rating_review: "Avaliação e revisão",
    select_buyer: "Selecione um comprador",
    tab_my_used_products: "Meus produtos",
    price_label: "Preço",
    text_savings: "Você salva",
    search_hint: "Pesquisar por produtos ...",
    empty_text:
      "Não há produtos listados nesta categoria ou dentro da distância selecionada.",
    filter_menu_text: "Filtro",
    error_contacting_seller: "Erro ao entrar em contato com o vendedor",
    edit_product: "Editar produto",
    contact_seller: "Entre em contato com o vendedor",
    signup_to_contact_seller:
      "Inscreva-se para entrar em contato com o vendedor",
    signup_to_make_offer: "Inscreva-se para fazer oferta",
    product_details: "Detalhes",
    product_category: "Categoria",
    product_condition: "Doença",
    product_description: "Descrição",
    product_location: "Localização do produto",
    product_location_approximate: "Localização é aproximada",
    over_week_time_ago: "Mais de uma semana atras",
    boosted: "Impulsionado",
    threads_no_results: "Sem mensagens",
    message_no_results: "Sem mensagens",
    message_warning:
      "Você é o único responsável por tomar todas as precauções necessárias ao interagir com outras pessoas, principalmente ao encontrar um estranho pessoalmente pela primeira vez. Não compartilhe nenhuma informação pessoal, códigos de verificação ou informações de pagamento. Revise os termos de serviço para obter mais detalhes.",
    message_block: "Você não pode enviar ou receber mensagens neste momento.",
    select_location: "Selecione Localização",
    location_permission_denied_message:
      "O aplicativo requer permissão de localização para funcionar corretamente.",
    signed_in: "Assinado!",
    sign_in_canceller: "Entrar cancelado",
    version: "Versão",
    build: "Construir",
    name: "Nome",
    location: "Localização",
    language: "Língua",
    about_app: "Sobre listado perto de mim",
    terms_of_service: "Termos de serviço",
    privacy_policy: "Política de Privacidade",
    report_feedback: "Enviar comentários",
    report_bug: "Agite o telefone para relatar um bug",
    change_image: "Mude a imagem.",
    update_location: "Atualizar localização",
    about_the_app: "Sobre o aplicativo",
    update_label: "Atualizar",
    uploading: "Enviando",
    adding: "Adicionando listagem",
    removing: "Removendo listagem",
    updating: "Atualizando a listagem",
    uploaded_image: "Imagem carregada:",
    image_storage_failed: "Falha ao armazenar imagem:",
    product_updated: "Produto atualizado com sucesso",
    location_error: "Localização não salva, por favor tente novamente",
    product_removed: "Produto removido com sucesso",
    deleted_product: "Este produto é excluído",
    invalid_title: "Título inválido, por favor, defina o título novamente.",
    invalid_image:
      "Caminho de imagem inválido, tente adicionar imagem novamente.",
    invalid_price: "Preço inválido, por favor defina o preço novamente.",
    invalid_location: "Local inválido, por favor, defina o local novamente.",
    invalid_category:
      "Categoria inválida, por favor, defina categoria novamente.",
    invalid_condition:
      "Condição inválida, por favor, defina a condição novamente.",
    removing_title: "Removendo a imagem do perfil.",
    image_not_saved: "Salvar imagem falhou!",
    product_load_failed: "Sem produtos",
    take_photo: "Tirar fotos",
    select_photo: "Selecione foto.",
    product_title_hint: "O que é isso? Nome, marca, modelo, etc.",
    delete_photo: "Deletar foto",
    product_title: "Título",
    mark_as_sold: "Marque como vendido",
    product_share: "Compartilhado",
    product_make_offer: "Faça oferta",
    product_cover: "Definido como imagem de capa",
    product_tags: "Tag",
    product_posted: "Publicado:",
    product_change: "Mudar",
    product_post: "Publicar",
    product_selling_from: "Vendendo do local",
    product_select_location: "Selecione Localização",
    product_map_approximate:
      "O mapa é aproximado para manter a localização do vendedor privada",
    product_terms:
      "Ao tocar em postar para publicar seu produto, você concorda em <u> listado perto de mim termos de serviço. </ U>",
    condition_other: "Outro (veja a descrição)",
    condition_for_parts: "Para partes",
    condition_used: "Usado (desgaste normal)",
    condition_open_box: "Caixa aberta (nunca usada)",
    condition_reconditioned: "Recondicionado / certificado",
    condition_new: "Novo (nunca usado)",
    select_category: "Selecione a Categoria",
    select_all_category: "Selecionar tudo",
    category_loading_error:
      "Não é possível atualizar a lista de categorias, tente novamente mais tarde.",
    category_vehicles: "Veículos",
    category_furniture: "Mobília",
    category_electronics: "Eletrônicos",
    category_appliances: "Home &  Eletrodomésticos.",
    category_fashion_accessories: "Fashion &  Acessórios",
    category_baby_kids: "Baby &  Crianças",
    category_antiques_collectibles: "Antiguidades e  Colecionáveis",
    category_auto_parts_tools_machinery: "Auto Peças, Ferramentas e  Máquinas",
    category_sports_outdoors: "Esportes e  Ao ar livre",
    category_others: "Outras",
    location_enter_zip_code: "Digite o código postal",
    location_get_current_location: "Obtenha a localização atual",
    location_select_location: "Selecione Localização",
    location_update_location: "Atualizar localização",
    location_new_location: "Nova localização",
    search_filter_results: "Filtrar resultados",
    search_filter_min: "Filtro no mínimo",
    search_filter_at_least: "Pelo menos",
    price_filter: "Filtro de preço",
    product_name: "Nome do Produto",
    english_language: "inglês",
    arabic_language: "árabe",
    spanish_language: "espanhol",
    system_language: "Sistema",
    share_link: "Compartilhar link",
    save: "Salve ",
    cancel: "Cancelar",
    loading: "Carregando",
    yes: "sim",
    no: "Não",
    report: "Relatório",
    report_product: "Relatório Produto",
    report_user: "Reportar usuário",
    block_user: "Bloquear usuário",
    un_block_user: "Desbloquear o usuário",
    why_product: "Por que você quer denunciar este item?",
    why_user: "Por que você quer denunciar este usuário?",
    block_user_confirm: "Você quer bloquear permanentemente este usuário?",
    un_block_user_confirm:
      "Você quer desbloquear permanentemente este usuário?",
    prohibited: "Proibido em listado perto de mim",
    offensive: "Ofensivo ou inadequado",
    duplicate: "Postagem duplicada",
    wrong_category: "Categoria errada",
    scam: "Parece um golpe",
    stolen: "Eu acho que é roubado",
    product_other: "De outros",
    product_is_sold: "Este produto foi vendido",
    missed_meeting: "Eles perderam nossa reunião",
    low_offer: "Fez uma oferta baixa",
    rude: "Rude ou inadequado.",
    items: "Problema com itens",
    trouble_meetup: "Problema em se encontrar",
    messaging: "Problemas de mensagens",
    user_other: "De outros",
    new_version_available: "Nova versão disponível",
    please_update_app:
      "Por favor, atualize o aplicativo para nova versão para continuar.",
    update: "Atualizar",
    no_thanks: "Não, obrigado",
    contact_support_confirmation:
      "O tempo de resposta atual é de 24 a 48 horas. Você quer entrar em contato listado perto de Mim App Bate-papo Suporte?",
    unboost_confirmation: "Tem certeza de que quer descansar este produto?",
    no_used_products: "Você ainda não tem listagens",
    no_boosted_products: "Você não tem nenhum produto impulsionado",
    next: "Próximo",
    previous: "Anterior",
    skip: "Pular",
    start: "Começar",
    list_used: "Listar um produto usado",
    buy_description:
      "Descubra e procure por produtos oferecidos por vizinhos ao seu redor",
    sell_description: "Listar produtos que você não precisa mais para venda",
    list_used_description:
      "Listar um produto usado para venda em menos de 20 segundos",
    boost_product_option_1: "<b> Boost 1  Nday </ b>  n  n <b> $ 0,99 </ b>",
    boost_product_option_2: "<b> Boost 3  NDays </ b>  n  n <b> $ 1,99 </ b>",
    boost_product_option_3: "<b> Boost 7  NDays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "Obtenha mais vistas a cada dia. Seu item aparecerá em posições em destaque nos 30 melhores itens na compra e categoria. Itens promovidos são girados entre os pontos designados para que cada item recebe exposição justa.",
    boost_cta: "Vender mais rápido",
    boost_terms:
      "Ao bater o impulso, você concorda em <u> listado perto de mim termos de serviço. </ U>",
    boost_best_value: "Melhor valor",
    already_boosted: "Este produto é impulsionado",
    clicks: "Cliques.",
    impressions: "Impressões",
    end: "Fim",
    transactions_empty_text:
      "Você ainda não possui transações de impulso. Você pode visitar a guia Vender e começar a aumentar seus produtos.",
    transactions_loading_error:
      "Não é possível atualizar a lista de transações, tente novamente mais tarde.",
    transactions_history_title: "Aumentar o histórico de transações",
    communicative_postive: "Comunicativo",
    communicative_negative: "Incomum",
    ontime_postive: "Na hora",
    ontime_negative: "Atrasado",
    reliable_postive: "Confiável",
    reliable_negative: "Não confiável",
    friendly_postive: "Amigáveis",
    friendly_negative: "Indelicado",
    itemasdescribed_postive: "item como descrito",
    itemasdescribed_negative: "Item não conforme descrito",
    other: "De outros",
    submit: "Enviar",
    adding_rating_reviews: "Adicionando classificação e comentários",
    no_internet_title: "Nenhuma conexão com a Internet",
    no_internet_message:
      "Certifique-se de que você está conectado à Internet e tente novamente",
    retry: "Repetir",
    near_me: "Perto de mim",
    newest_first: "Os mais novos primeiro",
    miles: "milhas",
    km: "km.",
    similar_products: "Produtos Similares",
    favorite_products: "Produtos favoritos",
    items_for_sale: "itens à venda",
    joined: "Ingressou",
    favorites_transactions_title: "Favoritos",
    boosted_products_transactions_history:
      "Histórico de transações de produtos impulsionados",
    views: "Visualizações",
    boost_graph_title: "Impulsionar o gráfico",
    no_favorite_products: "Você não tem nenhum produto favorito",
    make_offer_buy: "eu gostaria de comprar",
    make_offer_buy_for: "por",
    notifications: "Notificações",
    push_notifications: "Empurre",
    emails_notifications: "E-mail",
    apply: "Aplicar",
    email_messages: "E-mail para mensagens",
    email_new_products: "E-mail para novos produtos",
    push_day_only: "Push notificações dia apenas",
    push_24_hours: "Push notificações 24 horas",
    edit: "Editar",
    map: "Mapa",
    camera: "Câmera",
    gallery: "Galeria",
    delete: "Excluir",
    no_sell_items: "Sem itens à venda",
    who_bought_question: "Quem comprou?",
    sold_elsewhere_question: "Vendeu em outro lugar",
    confirm: "confirme",
    over_limit_camera: "Você não pode adicionar mais de cinco imagens",
    boost_failed: "Boost falhou. Por favor, tente novamente mais tarde",
    after_purchase: "Pagamento bem sucedido  Nproduto impulsionado",
    pay_failed: "Pagamento falhou. Por favor, tente novamente",
    done: "Feito",
    not_now: "Agora não",
    boost: "Impulsionar",
    invalid_zip_code: "CEP inválido",
    invalid_user_name: "Nome de usuário Inválido",
    comments: "Comentários",
    questions: "Perguntas",
    bug_reports: "Relatório de erros",
    feature_request: "Solicitação de recurso",
    feedback_type: "Tipo de feedback.",
    feedback_description:
      "Nós gostaríamos de ouvir seus pensamentos ou feedback sobre como podemos melhorar sua experiência!",
    feedback: "Comentários",
    feedback_text: "Sua resposta",
    suggestions: "Sugestões para melhorar",
    delete_account: "Deletar conta",
    new_message: "Nova mensagem",
    online: "Conectados",
    km_50: "50 km.",
    km_100: "100 km",
    km_200: "200 km.",
    miles_30: "30 milhas",
    miles_60: "60 milhas",
    miles_120: "120 milhas",
    rate_app_question: "Como sobre uma classificação na App Store, então?",
    enjoying_question: "Desfrutando listado perto de mim?",
    not_enjoy: "Na verdade, não",
    feedback_question: "Você se importaria de nos dar algum feedback?",
    yes_sure: "OK, claro",
    product_available_question: "Oi, isso ainda está disponível?",
    buy_question: "Oi eu gostaria de comprar isso",
    meet_question: "Oi, você pode se encontrar hoje?",
    follow: "Seguir",
    followers: "Seguidores",
    following: "Segue",
    feedback_thanks: "Obrigado pelo seu feedback",
    all_categories: "todas as categorias",
    deleted_account: "Esta conta é excluída",
    delete_account_question: "Tem certeza de que deseja excluir esta conta?",
    no_followings: "Não siga ninguém",
    when_following: "quando",
    no_followings_subtitle: "segue as pessoas, você vai vê-los aqui",
    no_followers: "não tem seguidores",
    no_followers_subtitle: "seguido de pessoas, você vai vê-los aqui",
    distance: "Distância",
    filter_method: "Método de filtro",
    see_listings: "Veja listagens",
    sold: "Vendido",
    bought: "Comprou",
    no_notifications: "Quando você recebe notificações, eles aparecerão aqui",
    items_title: "Itens",
    new_listing_title: "Crie nova listagem",
    dialog_year_title: "Ano",
    dialog_make_title: "Faça",
    dialog_model_title: "Modelo",
    dialog_body_style_title: "Estilo corpo",
    dialog_exterior_color_title: "Cor exterior",
    dialog_interior_color_title: "Cor interior",
    dialog_transmission_title: "Transmissão",
    dialog_fuel_type_title: "Tipo de combustível",
    dialog_owners_num_title: "Número de proprietários",
    dialog_vehicle_owed_money_title: "Há dinheiro ainda devido a este veículo?",
    automatic_transmission: "Automático",
    manual_transmission: "Manual",
    not_sure: "Não tenho certeza",
    wagon_hatchback: "Vagão e  Hatchback.",
    convertible: "Conversível",
    coupe: "Cupê.",
    sedan: "Sedan",
    black_color: "Preto",
    blue_color: "Azul",
    brown_color: "marrom",
    gold_color: "Ouro",
    green_color: "Verde",
    grey_color: "Cinza",
    pink_color: "Cor de rosa",
    purple_color: "Roxa",
    red_color: "vermelho",
    silver_color: "Prata",
    orange_color: "laranja",
    white_color: "Branco",
    yellow_color: "Amarelo",
    charcol_color: "Charcol.",
    fuel_diesel: "Diesel",
    fuel_electric: "Elétrico",
    fuel_gasoline: "Gasolina",
    fuel_flex: "Flex.",
    fuel_hybrid: "Híbrido",
    fuel_petrol: "Gasolina",
    fuel_plugin_hybrid: "Híbrido plug-in",
    truck: "Caminhão",
    van_minivan: "Van &  Minivan",
    suv_crossover: "Suv &  Crossover",
    awd_4wd: "AWD / 4WD.",
    fwd: "Fwd.",
    rwd: "Rwd.",
    off_white_color: "Off white",
    tan_color: "bronzeado",
    beige_color: "Bege",
    burgundy_color: "Borgonha",
    turquoise_color: "Turquesa",
    title_status_clean: "Limpar",
    title_status_rebuilt: "Reconstruído",
    title_status_salvage: "Salvamento",
    title_status_missing: "Ausente",
    title_status_lien: "Penhor",
    title_status: "Status do título.",
    mileage: "Quilometragem",
    dialog_drivetrain_title: "Drivetrain",
    model_warning: "Por favor, selecione Fazer primeiro",
    required_field_warning: "Este campo é obrigatório",
    vehicle_vin: "Vin.",
    invalid_vin: "VIN inválido, por favor, defina VIN novamente.",
    invalid_mileage:
      "Quilometragem inválida, por favor, defina a milhagem novamente.",
    clean_description: "A maioria dos veículos que não foram em um acidente",
    rebuilt_description: "Um carro recuperado que foi reconstruído",
    salvage_description: "É considerado totalizado após um acidente",
    missing_description: "Precisará de um novo título de problemas DMV",
    lien_description: "De propriedade de um banco ou liquidação judicial",
    nearme: "Perto de mim",
    newest: "O mais novo",
    contact_support: "Suporte de contato.",
    create_home_title: "Casas para venda ou aluguel",
    for_sale: "À venda",
    for_rent: "Para alugar",
    property_type: "Tipo de Propriedade",
    apartment: "Apartamento",
    house: "lar",
    room_only: "Somente sala",
    townhouse: "Townhouse",
    bedrooms: "Quartos de dormir",
    bathrooms: "Banheiros",
    property_address: "Endereço da propriedade",
    price_per_month: "Preço por mês",
    square_feet: "Pés quadrados",
    year_built: "Ano construído",
    year_renovated: "Ano renovado",
    lot_size: "Tamanho do lote",
    laundry_type: "Tipo de lavanderia",
    in_unit_laundry: "Lavanderia In-Unit",
    laundry_building: "Lavanderia no prédio",
    laundry_available: "Lavanderia disponível",
    none: "Nenhum",
    parking_type: "Tipo de estacionamento",
    garage_parking: "Estacionamento da garagem",
    street_parking: "Estacionamento da rua.",
    off_street_parking: "Estacionamento fora da rua",
    available_parking: "Estacionamento disponível",
    air_cond_type: "Tipo de ar condicionado",
    ac_available: "AC disponível",
    central_ac: "Central AC.",
    heating_type: "Tipo de aquecimento",
    electric_heating: "Aquecimento elétrico",
    gas_heating: "Aquecimento a gás",
    radiator_heating: "Aquecimento do radiador",
    available_heating: "Aquecimento disponível",
    amenities: "Facilidades",
    date_available: "Data Disponível",
    lease_length: "Comprimento de arrendamento",
    month_to_month: "Mês a mês",
    three_months: "3 meses",
    six_months: "6 meses",
    one_year: "1 ano",
    more_one_year: "1+ anos",
    cat_friendly: "Gato amigável",
    dog_friendly: "Cão amigável",
    balcony: "Sacada",
    basement: "Porão",
    bike_parking: "Estacionamento de bicicleta.",
    cable_tv: "TV a cabo",
    ceiling_fan: "Ventilador de teto",
    concierge: "Porteiro",
    dishwasher: "Lava-louças",
    doorman: "Porteiro",
    elevator: "Elevador",
    fireplace: "Lareira",
    fitness_center: "Academia",
    garbage_disposal: "Eliminação de lixo",
    microwave: "Microondas",
    online_app: "Aplicação online",
    oven: "Forno",
    package_service: "Serviço de pacote",
    patio: "Pátio",
    pet_park: "Pet Park",
    refrigerator: "Frigorífico",
    resident_lounge: "Lounge residente",
    roof_deck: "Plataforma do telhado",
    secured_entry: "Entrada segura",
    storage: "Armazenar",
    walk_in_closet: "Armário",
    swimming_pool: "Piscina",
    wheelchair_access: "Acesso para cadeira de rodas",
    central_heating: "Aquecimento central",
    invalid_bedrooms: "Quartos inválidos, por favor, defina quartos novamente.",
    invalid_bathrooms:
      "Banheiros inválidos, por favor, defina banheiros novamente.",
    chinese_simplified_language: "Chinês simplificado",
    chinese_traditional_language: "Chinês tradicional",
    czech_language: "Checo",
    danish_language: "dinamarquês",
    dutch_language: "holandês",
    finnish_language: "finlandês",
    french_language: "francês",
    german_language: "alemão",
    greek_language: "grego",
    hungarian_language: "húngaro",
    indonesian_language: "indonésio",
    italian_language: "italiano",
    japanese_language: "japonês",
    korean_language: "coreano",
    norwegian_language: "norueguês",
    polish_language: "polonês",
    portuguese_language: "Português",
    portuguese_brazilian_language: "Português, brasileiro",
    romanian_language: "romena",
    russian_language: "russo",
    swedish_language: "sueco",
    turkish_language: "turco",
    ukrainian_language: "ucraniano",
    urdu_pakistan_language: "Urdu (Paquistão)",
    vietnamese_language: "vietnamita",
    category_home_sale_or_rent: "Casa para venda ou aluguel",
    square_meter: "Metro quadrado",
    copy_text: "cópia de",
    copyied_to_clipboard: "Copiado para a área de transferência",
    inbox: "Caixa de entrada",
    input_title_listening: "Audição…",
    input_subtitle_listening: "Diga algo",
    input_title_error: "Desculpe, nós não conseguimos isso.",
    input_subtitle_error: "Tente repetir sua solicitação.",
    input_hint_error: "Tente novamente",
    price_less_than_or_equal: "Preço menor ou igual a",
    any_price: "Qualquer preço",
    any_condition: "Qualquer condição",
    any_time: "A qualquer momento",
    days_ago: "dias atrás",
    any_distance: "Qualquer distância",
    distance_within: "Distância dentro de.",
    new_notification: "Nova notificação",
    deleted: "Excluído",
    processing_image: "Imagem de processamento",
    remove_dialog_message: "Você realmente quer remover este produto?",
    deleted_thread: "Esta mensagem é excluída",
    category_yard_sale_event: "Evento de venda de jarda",
    yard_first_date: "Primeira data de venda de jardim",
    yard_second_date: "Venda de jardim Segunda data",
    yard_third_date: "Terceira data de venda de jardim",
    yard_start_time: "Hora de início",
    yard_end_time: "Fim do tempo",
    yard_end_timestamp: "Timestamp final",
    invalid_date1:
      "Primeira data inválida, por favor, defina a primeira data novamente",
    invalid_start_time:
      "Hora inicial inválida, por favor, defina a hora de início novamente",
    invalid_end_time:
      "Hora final inválida, por favor, defina a hora final novamente",
    yard_sale_title: "Venda de garagem",
    garage_tag: "garagem",
    yard_tag: "Jardim",
    from: "A partir de",
    to: "Para",
    block: "Quadra",
    un_block: "Desbloquear",
    sign_email: "Entre com email",
    invalid_first_date:
      "Primeira data inválida, por favor, certifique-se da primeira data é antes do segundo e terceiro",
    invalid_second_date:
      "Segunda data inválida, por favor, certifique-se de que a segunda data é antes da terceira data",
    invalid_start_time_value:
      "Hora inicial inválida, por favor, certifique-se de que a hora de início é antes da hora da extremidade",
    use_default_yard_photo: "Usar foto padrão de venda de jardim",
    active_label: "Ativo",
    enable_notifications: "Ativar notificações",
    login: "Conecte-se",
    january: "Janeiro",
    february: "fevereiro",
    march: "marchar",
    april: "abril",
    may: "Poderia",
    june: "junho",
    july: "Julho",
    august: "agosto",
    september: "setembro",
    october: "Outubro",
    november: "novembro",
    december: "dezembro",
    since: "Desde a",
    product_views: "Visualizações de produto",
    shop_views: "Visualizações da loja",
    total_sales: "Vendas totais",
    total_orders: "Ordens totais",
    last_twelvth_months: "Últimos dois meses",
    last_nine_months: "Últimos nove meses",
    last_six_months: "Últimos seis meses",
    last_three_months: "Últimos três meses",
    last_12_months: "Últimos 12 meses",
    last_9_months: "Últimos 9 meses",
    last_6_months: "Últimos 6 meses",
    last_3_months: "Últimos 3 meses",
    months: "Meses",
    open: "Aberto",
    reset_password: "Redefinir senha",
    create_new_shop: "Crie nova loja",
    download_app: "Baixar aplicativo",
    log_in: "Conecte-se",
    sign_up: "Inscrever-se",
    no_result: "Sem resultado",
    max_price: "Preço máximo",
    max_distance: "Distância máxima.",
    max_time: "Tempo máximo.",
    posted_less_than: "Postado menos de",
    result: "Resultado",
    more: "Mais",
    or: "OU",
    password: "Senha",
    forgot_password: "Esqueceu a senha?",
    and: "e",
    download_for: "Download para",
    apple_ios: "Apple iOS.",
    android: "Android",
    image: "Imagem",
    edit_image: "Editar imagem",
    please_complete: "Por favor complete",
    enter_your_offer: "Digite sua oferta",
    categories: "Categorias",
    upload_image: "Enviar Imagem",
    upload_images: "Enviar imagens",
    back: "Costas",
    see_more: "Ver mais",
    add_product: "Adicionar produto",
    selected: "Selecionado",
    create: "Crio",
    rate_the_buyer: "Avalie o comprador",
    delete_product: "Excluir produto",
    product: "produtos",
    un_block_product: "Desbloquear produto",
    share_your_product: "Compartilhe seu produto",
    boost_details: "Reforçar detalhes.",
    remove_all_products: "Remova todos os produtos",
    remove_all: "Deletar tudo",
    add_vehicle: "Adicionar veículo",
    edit_vehicle: "Editar veículo",
    upload_a_photo: "Carregar uma foto",
    view_details: "Ver detalhes",
    add_yard_sale: "Adicionar venda de jardim",
    edit_yard_sale: "Editar venda de jardim",
    users: "Comercial",
    users_details: "Detalhes dos usuários.",
    users_by_country: "Usuários por país",
    blocked_users: "Usuários bloqueados",
    products_cards: "Cartões de produtos",
    archived_products: "Produtos arquivados.",
    blocked_products: "Produtos bloqueados",
    products_by_country: "Produtos por país",
    reports: "Relatório",
    reports_details: "Detalhes relatórios",
    closed_reports: "Relatórios fechados",
    threads: "Tópicos",
    threads_details: "Detalhes dos tópicos",
    chat_support: "Suporte de bate-papo",
    actions: "Ações",
    search_actions: "Ações de busca",
    product_view_actions: "Ações de visualização de produto",
    contact_seller_product: "Entre em contato com o Vendedor Produto",
    contact_owner_shop: "Contate o Loja do proprietário.",
    ratings: "Classificações",
    reviews: "Avaliações",
    products_all_countries: "Produtos todos os países",
    edit_profile: "Editar Perfil",
    my_profile: "Meu perfil",
    profile_updated_successfully: "Perfil atualizado com sucesso",
    are_you_sure: "Tem certeza",
    my_used_products: "Meus produtos usados",
    my_shops: "Minhas compras",
    my_boosted_products: "Meus produtos impulsionados",
    messages_type_message_here: "Digite sua mensagem aqui",
    messages_product_sold: "Este produto é vendido ou removido",
    seen: "Visto",
    messages_never_miss_message: "Nunca perca uma mensagem",
    enable: "Habilitar",
    send_notify: "Enviar notify.",
    un_close: "Descasionar",
    type_your_review: "Digite sua revisão",
    again_question: "novamente ?",
    ratings_already_submitted_review: "Você já enviou revisão",
    set_product_category: "Definir categoria de produto",
    auth_email_password_incorrect: "Seu e-mail ou senha incorreta",
    auth_insert_your_name: "Por favor, insira seu nome",
    auth_email_address_badly: "O endereço de e-mail é mal formatado",
    auth_email_address_used:
      "O endereço de e-mail já está em uso por outra conta",
    auth_invalid_password: "A senha deve ter pelo menos 6 caracteres",
    auth_reset_email: "Insira seu e-mail para redefinir sua senha",
    auth_check_email: "Por favor, verifique seu e-mail para redefinir a senha",
    auth_can_sign_in_google: "Você pode entrar com o botão do Google",
    auth_do_not_have_account: "Você não tem uma conta?",
    auth_have_account: "Você tem uma conta?",
    log_terms_privacy_part1:
      "Ao se inscrever ou fazer login, você concorda com o listado perto de mim",
    boost_this_product: "Impulsionar este produto?",
    product_successfully_boosted: "O produto foi impulsionado com sucesso",
    product_failed_boost: "O produto foi falhado em impulso",
    no_products_for_sale:
      "Você atualmente não tem nenhum produto usado para venda.",
    not_sold_listed_near_me: "Eu não vendi na listada perto de mim",
    agree_add_product:
      "Ao tocar em postar para publicar seu produto, você concorda com os próximos Termos de Serviço e Política de Privacidade.",
    click_to_boost: "Clique no produto para impulsionado",
    listed_terms_of_service: "Listado perto de mim termos de serviço",
    receive_emails_for_users: "Receba e-mails para mensagens de usuários",
    receive_emails_for_newly_posted:
      "Receba e-mails para seus produtos recém-postados",
    disable_push_notifications: "Desativar notificações push",
    sms_during_day: "Receba SMS durante o dia",
    sms_24_hours: "Receba SMS 24 horas",
    products: "Produtos",
    product_no_longer_available:
      "Desculpe, este produto não está mais disponível",
    add_home: "Adicionar casa",
    edit_home: "Editar casa",
    fill_required_fields: "Preencha todos os campos obrigatórios",
    no_notification: "Não há notificações",
    orders_history: "Ordens History.",
    privacy: "Privacidade",
    terms: "Termos.",
    report_a_problem: "Reportar um problema",
    approximation_protect_user_privacy:
      "Aproximação para proteger a privacidade do usuário",
    do_not_have_products: "Você não tem produtos",
    emails: "E-mails.",
    lead_deletion_products: "Isso levará à exclusão de todos os seus produtos",
    confirm_legal_message:
      "Você é o único responsável por tomar todas as precauções necessárias ao interagir com os outros, particularmente quando se encontra um estranho em pessoa pela primeira vez. Por favor, reveja os Termos de Serviço para mais detalhes.",
    push_notifications_notified_instantly:
      "Ativar notificações push para ser notificado instantaneamente",
    rate_seller: "Classifique o vendedor",
    user_journey: "Viagem do usuário",
    user: "Do utilizador",
    user_id: "ID do usuário",
    action_id: "ID de ação",
    select_model_car: "Selecione o modelo de carro",
    boost_1_day: "Impulso 1 dia",
    boost_3_days: "Impulsionar 3 dias",
    boost_7_days: "Impulsionar 7 dias",
    agree_boost_terms: "Ao bater o impulso, você concorda em",
    add: "Adicionar",
    add_tag: "Adicionar etiqueta",
    brand_title: "Marca",
    category_mobiles: "Mobiles.",
    category_tablets: "Comprimidos",
    screen_size: "Tamanho da tela",
    has_cellular_capability: "Tem capacidade celular",
    default_internal_memory: "Memória interna",
    network_carrier: "Operadora de rede",
    is_unlocked: "Está desbloqueado",
    mobile_model_warning: "Por favor, selecione a marca primeiro",
    missing_image: "Imagem ausente, tente adicionar imagem novamente.",
    add_mobile: "Adicionar celular",
    edit_mobile: "Editar celular",
    add_tablet: "Adicionar tablet.",
    edit_tablet: "Editar tablet.",
    keywords:
      "compras, comprar, vender, ganhar dinheiro, comércio, moradores locais, vizinhos, automático, veículos",
    country: "País",
    phone_number: "Número de telefone",
    verification_code: "Código de verificação",
    error_occurred: "Ocorreu um erro. Por favor tente novamente mais tarde",
    invalid_state:
      "Estado inválido: Um retorno de chamada de login foi recebido, mas nenhuma solicitação de login foi enviada.",
    sign_in: "Entrar",
    sign_in_apple: "Entre com a Apple",
    sign_in_google: "Faça login no Google",
    sign_in_phone: "Entrar com o telefone",
    sign_in_facebook: "Entre com o Facebook",
    create_account: "Crie a sua conta aqui",
    email: "E-mail",
    invalid_field: "Por favor, preencha os campos obrigatórios",
    code_sent: "O código foi enviado por SMS",
    verify_number: "Verifique o número de telefone",
    tapping_verify_number:
      "Ao tocar (verifique o número de telefone), um SMS seja enviado.",
    email_exists:
      "A conta já existe e você precisa acessá-lo através do botão do Google, botão do Facebook ou botão da Apple",
    ok: "OK",
    sure_back: "Você tem certeza de voltar?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "atrás",
    add_model: "Adicionar modelo",
    no_search_results_us:
      "Nenhum resultado de pesquisa perto de você dentro de 120 milhas. Tente alterar o filtro de pesquisa ou pesquisar palavras -chave.",
    no_search_results:
      "Nenhum resultado de pesquisa perto de você a 200 km. Tente alterar o filtro de pesquisa ou pesquisar palavras -chave.",
    plan_date: "Data do plano",
    plan_time: "Planejar tempo",
    invalid_plan_date:
      "Data do plano inválido, defina a data do plano novamente",
    invalid_plan_time:
      "Tempo de plano inválido, defina o tempo do plano novamente",
    plan_name: "Nome do plano",
    plan_title: "Plano",
    update_plan_name: "Atualizar o nome do plano",
    delete_plan_question: "Tem certeza de que deseja excluir este plano?",
    plan_reminder_message: "Você será lembrado uma hora antes",
    plan_dialog_title: "Plano de reunião",
    planners_title: "Planejadores",
    unable_sending_messages:
      "Eles verão suas mensagens quando estiverem novamente online.",
    its_text: "Isso é",
    for_your_text: "para o seu receptor.",
  },
  "pt-BR": {
    invalid_area: "Área inválida, por favor defina a área novamente.",
    invalid_lot_size:
      "Tamanho do lote de propriedade inválido, por favor, defina o tamanho do lote novamente.",
    property_area: "Área de propriedade.",
    app_store_name:
      "Listado perto de mim - comprar itens usados, vender por dinheiro",
    app_store_short:
      "Um mercado para vendedores locais. Listar um item para venda e ganhar dinheiro.",
    app_store_full:
      "Listado perto de mim torna fácil encontrar grandes ofertas nas coisas que você quer e ganhar dinheiro nas coisas que você quer vender. Esta é a melhor maneira de comprar e vender em sua comunidade ou bairro com pessoas que você pode confiar. Como funciona: 1- Compre ou venda qualquer coisa; Facilmente postar seus itens à venda em segundos. 2- Encontre ótimas ofertas e descontos em roupas, móveis, telefones celulares, eletrônicos, bebê e crianças, equipamentos esportivos, carros usados, vestidos, sapatos e relógios, para livros, brinquedos usados, laptops usados, um carro de segunda mão e até mesmo real propriedade para venda ou aluguel. 3- Navegue pelos itens locais para venda. 4- Compradores e vendedores de mensagens de dentro do aplicativo. 5- Navegue pelos itens por imagem e classifique por categoria. Fatos divertidos sobre listados perto de mim: 1- Com listado perto de mim você pode facilmente vender qualquer coisa, de roupas para carros usados ​​para eletrônica. 2- Comunicação entre compradores e vendedores acontece através do aplicativo via mensagens. 3 - listado perto de mim é melhor que uma venda de garagem; Encontre qualquer coisa que você quiser com desconto, diretamente no seu telefone ou tablet.",
    app_store_release:
      "Listado perto de mim - comércio com moradores. Junte-se ao mercado móvel para compradores e vendedores locais!",
    app_name: "Listado perto de mim",
    title_buy: "Comprar",
    title_messages: "Mensagens",
    title_sell: "Vender",
    title_profile_image: "Imagem de perfil",
    title_account: "Conta",
    account_settings: "Configurações de Conta",
    settings: "Configurações",
    color_theme: "Tema de cor",
    device_settings: "Configurações do dispositivo",
    public_profile: "Perfil público",
    light_mode: "Modo de luz",
    dark_mode: "Modo escuro",
    title_sell_faster: "Vender mais rápido",
    send_button_label: "Mandar",
    rate_message: "Me avalie...",
    already_rated: "Você já enviou revisão",
    rate_review_question: "Você gostaria de lidar com",
    again: "novamente?",
    action_logout: "Sair",
    action_category: "Categoria",
    action_search: "Procurar",
    action_refer: "Indique um Amigo",
    dialog_choose_location: "Escolha a localização",
    dialog_change_username: "Mudar nome de usuário",
    dialog_change_language: "Mudar idioma",
    dialog_image_tags: "Etiquetas de imagem.",
    dialog_emails_notifications: "Notificações de e-mails.",
    dialog_push_notifications: "Notificações via push",
    fragment_product_detail: "Detalhes do produto",
    fragment_message_details: "Detalhe de mensagens",
    fragment_sell: "Vender",
    dialog_tags_title: "Tag",
    dialog_location_title: "Atualizar localização",
    dialog_username_title: "Mudar nome de usuário",
    tab_photo: "foto",
    tab_details: "Detalhes",
    tab_price: "Preço",
    tab_finish: "Terminar",
    profile: "Perfil",
    search: "Procurar",
    choose_product: "Escolha o produto",
    rating_review: "Avaliação e revisão",
    select_buyer: "Selecione um comprador",
    tab_my_used_products: "Meus produtos",
    price_label: "Preço",
    text_savings: "Você salva",
    search_hint: "Pesquisar por produtos ...",
    empty_text:
      "Não há produtos listados nesta categoria ou dentro da distância selecionada.",
    filter_menu_text: "Filtro",
    error_contacting_seller: "Erro ao entrar em contato com o vendedor",
    edit_product: "Editar produto",
    contact_seller: "Entre em contato com o vendedor",
    signup_to_contact_seller:
      "Inscreva-se para entrar em contato com o vendedor",
    signup_to_make_offer: "Inscreva-se para fazer oferta",
    product_details: "Detalhes",
    product_category: "Categoria",
    product_condition: "Doença",
    product_description: "Descrição",
    product_location: "Localização do produto",
    product_location_approximate: "Localização é aproximada",
    over_week_time_ago: "Mais de uma semana atras",
    boosted: "Impulsionado",
    threads_no_results: "Sem mensagens",
    message_no_results: "Sem mensagens",
    message_warning:
      "Você é o único responsável por tomar todas as precauções necessárias ao interagir com outras pessoas, principalmente ao encontrar um estranho pessoalmente pela primeira vez. Não compartilhe nenhuma informação pessoal, códigos de verificação ou informações de pagamento. Revise os termos de serviço para obter mais detalhes.",
    message_block: "Você não pode enviar ou receber mensagens neste momento.",
    select_location: "Selecione Localização",
    location_permission_denied_message:
      "O aplicativo requer permissão de localização para funcionar corretamente.",
    signed_in: "Assinado!",
    sign_in_canceller: "Entrar cancelado",
    version: "Versão",
    build: "Construir",
    name: "Nome",
    location: "Localização",
    language: "Língua",
    about_app: "Sobre listado perto de mim",
    terms_of_service: "Termos de serviço",
    privacy_policy: "Política de Privacidade",
    report_feedback: "Enviar comentários",
    report_bug: "Agite o telefone para relatar um bug",
    change_image: "Mude a imagem.",
    update_location: "Atualizar localização",
    about_the_app: "Sobre o aplicativo",
    update_label: "Atualizar",
    uploading: "Enviando",
    adding: "Adicionando listagem",
    removing: "Removendo listagem",
    updating: "Atualizando a listagem",
    uploaded_image: "Imagem carregada:",
    image_storage_failed: "Falha ao armazenar imagem:",
    product_updated: "Produto atualizado com sucesso",
    location_error: "Localização não salva, por favor tente novamente",
    product_removed: "Produto removido com sucesso",
    deleted_product: "Este produto é excluído",
    invalid_title: "Título inválido, por favor, defina o título novamente.",
    invalid_image:
      "Caminho de imagem inválido, tente adicionar imagem novamente.",
    invalid_price: "Preço inválido, por favor defina o preço novamente.",
    invalid_location: "Local inválido, por favor, defina o local novamente.",
    invalid_category:
      "Categoria inválida, por favor, defina categoria novamente.",
    invalid_condition:
      "Condição inválida, por favor, defina a condição novamente.",
    removing_title: "Removendo a imagem do perfil.",
    image_not_saved: "Salvar imagem falhou!",
    product_load_failed: "Sem produtos",
    take_photo: "Tirar fotos",
    select_photo: "Selecione foto.",
    product_title_hint: "O que é isso? Nome, marca, modelo, etc.",
    delete_photo: "Deletar foto",
    product_title: "Título",
    mark_as_sold: "Marque como vendido",
    product_share: "Compartilhado",
    product_make_offer: "Faça oferta",
    product_cover: "Definido como imagem de capa",
    product_tags: "Tag",
    product_posted: "Publicado:",
    product_change: "Mudar",
    product_post: "Publicar",
    product_selling_from: "Vendendo do local",
    product_select_location: "Selecione Localização",
    product_map_approximate:
      "O mapa é aproximado para manter a localização do vendedor privada",
    product_terms:
      "Ao tocar em postar para publicar seu produto, você concorda em <u> listado perto de mim termos de serviço. </ U>",
    condition_other: "Outro (veja a descrição)",
    condition_for_parts: "Para partes",
    condition_used: "Usado (desgaste normal)",
    condition_open_box: "Caixa aberta (nunca usada)",
    condition_reconditioned: "Recondicionado / certificado",
    condition_new: "Novo (nunca usado)",
    select_category: "Selecione a Categoria",
    select_all_category: "Selecionar tudo",
    category_loading_error:
      "Não é possível atualizar a lista de categorias, tente novamente mais tarde.",
    category_vehicles: "Veículos",
    category_furniture: "Mobília",
    category_electronics: "Eletrônicos",
    category_appliances: "Home &  Eletrodomésticos.",
    category_fashion_accessories: "Fashion &  Acessórios",
    category_baby_kids: "Baby &  Crianças",
    category_antiques_collectibles: "Antiguidades e  Colecionáveis",
    category_auto_parts_tools_machinery: "Auto Peças, Ferramentas e  Máquinas",
    category_sports_outdoors: "Esportes e  Ao ar livre",
    category_others: "Outras",
    location_enter_zip_code: "Digite o código postal",
    location_get_current_location: "Obtenha a localização atual",
    location_select_location: "Selecione Localização",
    location_update_location: "Atualizar localização",
    location_new_location: "Nova localização",
    search_filter_results: "Filtrar resultados",
    search_filter_min: "Filtro no mínimo",
    search_filter_at_least: "Pelo menos",
    price_filter: "Filtro de preço",
    product_name: "Nome do Produto",
    english_language: "inglês",
    arabic_language: "árabe",
    spanish_language: "espanhol",
    system_language: "Sistema",
    share_link: "Compartilhar link",
    save: "Salve ",
    cancel: "Cancelar",
    loading: "Carregando",
    yes: "sim",
    no: "Não",
    report: "Relatório",
    report_product: "Relatório Produto",
    report_user: "Reportar usuário",
    block_user: "Bloquear usuário",
    un_block_user: "Desbloquear o usuário",
    why_product: "Por que você quer denunciar este item?",
    why_user: "Por que você quer denunciar este usuário?",
    block_user_confirm: "Você quer bloquear permanentemente este usuário?",
    un_block_user_confirm:
      "Você quer desbloquear permanentemente este usuário?",
    prohibited: "Proibido em listado perto de mim",
    offensive: "Ofensivo ou inadequado",
    duplicate: "Postagem duplicada",
    wrong_category: "Categoria errada",
    scam: "Parece um golpe",
    stolen: "Eu acho que é roubado",
    product_other: "De outros",
    product_is_sold: "Este produto foi vendido",
    missed_meeting: "Eles perderam nossa reunião",
    low_offer: "Fez uma oferta baixa",
    rude: "Rude ou inadequado.",
    items: "Problema com itens",
    trouble_meetup: "Problema em se encontrar",
    messaging: "Problemas de mensagens",
    user_other: "De outros",
    new_version_available: "Nova versão disponível",
    please_update_app:
      "Por favor, atualize o aplicativo para nova versão para continuar.",
    update: "Atualizar",
    no_thanks: "Não, obrigado",
    contact_support_confirmation:
      "O tempo de resposta atual é de 24 a 48 horas. Você quer entrar em contato listado perto de Mim App Bate-papo Suporte?",
    unboost_confirmation: "Tem certeza de que quer descansar este produto?",
    no_used_products: "Você ainda não tem listagens",
    no_boosted_products: "Você não tem nenhum produto impulsionado",
    next: "Próximo",
    previous: "Anterior",
    skip: "Pular",
    start: "Começar",
    list_used: "Listar um produto usado",
    buy_description:
      "Descubra e procure por produtos oferecidos por vizinhos ao seu redor",
    sell_description: "Listar produtos que você não precisa mais para venda",
    list_used_description:
      "Listar um produto usado para venda em menos de 20 segundos",
    boost_product_option_1: "<b> Boost 1  Nday </ b>  n  n <b> $ 0,99 </ b>",
    boost_product_option_2: "<b> Boost 3  NDays </ b>  n  n <b> $ 1,99 </ b>",
    boost_product_option_3: "<b> Boost 7  NDays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "Obtenha mais vistas a cada dia. Seu item aparecerá em posições em destaque nos 30 melhores itens na compra e categoria. Itens promovidos são girados entre os pontos designados para que cada item recebe exposição justa.",
    boost_cta: "Vender mais rápido",
    boost_terms:
      "Ao bater o impulso, você concorda em <u> listado perto de mim termos de serviço. </ U>",
    boost_best_value: "Melhor valor",
    already_boosted: "Este produto é impulsionado",
    clicks: "Cliques.",
    impressions: "Impressões",
    end: "Fim",
    transactions_empty_text:
      "Você ainda não possui transações de impulso. Você pode visitar a guia Vender e começar a aumentar seus produtos.",
    transactions_loading_error:
      "Não é possível atualizar a lista de transações, tente novamente mais tarde.",
    transactions_history_title: "Aumentar o histórico de transações",
    communicative_postive: "Comunicativo",
    communicative_negative: "Incomum",
    ontime_postive: "Na hora",
    ontime_negative: "Atrasado",
    reliable_postive: "Confiável",
    reliable_negative: "Não confiável",
    friendly_postive: "Amigáveis",
    friendly_negative: "Indelicado",
    itemasdescribed_postive: "item como descrito",
    itemasdescribed_negative: "Item não conforme descrito",
    other: "De outros",
    submit: "Enviar",
    adding_rating_reviews: "Adicionando classificação e comentários",
    no_internet_title: "Nenhuma conexão com a Internet",
    no_internet_message:
      "Certifique-se de que você está conectado à Internet e tente novamente",
    retry: "Repetir",
    near_me: "Perto de mim",
    newest_first: "Os mais novos primeiro",
    miles: "milhas",
    km: "km.",
    similar_products: "Produtos Similares",
    favorite_products: "Produtos favoritos",
    items_for_sale: "itens à venda",
    joined: "Ingressou",
    favorites_transactions_title: "Favoritos",
    boosted_products_transactions_history:
      "Histórico de transações de produtos impulsionados",
    views: "Visualizações",
    boost_graph_title: "Impulsionar o gráfico",
    no_favorite_products: "Você não tem nenhum produto favorito",
    make_offer_buy: "eu gostaria de comprar",
    make_offer_buy_for: "por",
    notifications: "Notificações",
    push_notifications: "Empurre",
    emails_notifications: "E-mail",
    apply: "Aplicar",
    email_messages: "E-mail para mensagens",
    email_new_products: "E-mail para novos produtos",
    push_day_only: "Push notificações dia apenas",
    push_24_hours: "Push notificações 24 horas",
    edit: "Editar",
    map: "Mapa",
    camera: "Câmera",
    gallery: "Galeria",
    delete: "Excluir",
    no_sell_items: "Sem itens à venda",
    who_bought_question: "Quem comprou?",
    sold_elsewhere_question: "Vendeu em outro lugar",
    confirm: "confirme",
    over_limit_camera: "Você não pode adicionar mais de cinco imagens",
    boost_failed: "Boost falhou. Por favor, tente novamente mais tarde",
    after_purchase: "Pagamento bem sucedido  Nproduto impulsionado",
    pay_failed: "Pagamento falhou. Por favor, tente novamente",
    done: "Feito",
    not_now: "Agora não",
    boost: "Impulsionar",
    invalid_zip_code: "CEP inválido",
    invalid_user_name: "Nome de usuário Inválido",
    comments: "Comentários",
    questions: "Perguntas",
    bug_reports: "Relatório de erros",
    feature_request: "Solicitação de recurso",
    feedback_type: "Tipo de feedback.",
    feedback_description:
      "Nós gostaríamos de ouvir seus pensamentos ou feedback sobre como podemos melhorar sua experiência!",
    feedback: "Comentários",
    feedback_text: "Sua resposta",
    suggestions: "Sugestões para melhorar",
    delete_account: "Deletar conta",
    new_message: "Nova mensagem",
    online: "Conectados",
    km_50: "50 km.",
    km_100: "100 km",
    km_200: "200 km.",
    miles_30: "30 milhas",
    miles_60: "60 milhas",
    miles_120: "120 milhas",
    rate_app_question: "Como sobre uma classificação na App Store, então?",
    enjoying_question: "Desfrutando listado perto de mim?",
    not_enjoy: "Na verdade, não",
    feedback_question: "Você se importaria de nos dar algum feedback?",
    yes_sure: "OK, claro",
    product_available_question: "Oi, isso ainda está disponível?",
    buy_question: "Oi eu gostaria de comprar isso",
    meet_question: "Oi, você pode se encontrar hoje?",
    follow: "Seguir",
    followers: "Seguidores",
    following: "Segue",
    feedback_thanks: "Obrigado pelo seu feedback",
    all_categories: "todas as categorias",
    deleted_account: "Esta conta é excluída",
    delete_account_question: "Tem certeza de que deseja excluir esta conta?",
    no_followings: "Não siga ninguém",
    when_following: "quando",
    no_followings_subtitle: "segue as pessoas, você vai vê-los aqui",
    no_followers: "não tem seguidores",
    no_followers_subtitle: "seguido de pessoas, você vai vê-los aqui",
    distance: "Distância",
    filter_method: "Método de filtro",
    see_listings: "Veja listagens",
    sold: "Vendido",
    bought: "Comprou",
    no_notifications: "Quando você recebe notificações, eles aparecerão aqui",
    items_title: "Itens",
    new_listing_title: "Crie nova listagem",
    dialog_year_title: "Ano",
    dialog_make_title: "Faça",
    dialog_model_title: "Modelo",
    dialog_body_style_title: "Estilo corpo",
    dialog_exterior_color_title: "Cor exterior",
    dialog_interior_color_title: "Cor interior",
    dialog_transmission_title: "Transmissão",
    dialog_fuel_type_title: "Tipo de combustível",
    dialog_owners_num_title: "Número de proprietários",
    dialog_vehicle_owed_money_title: "Há dinheiro ainda devido a este veículo?",
    automatic_transmission: "Automático",
    manual_transmission: "Manual",
    not_sure: "Não tenho certeza",
    wagon_hatchback: "Vagão e  Hatchback.",
    convertible: "Conversível",
    coupe: "Cupê.",
    sedan: "Sedan",
    black_color: "Preto",
    blue_color: "Azul",
    brown_color: "marrom",
    gold_color: "Ouro",
    green_color: "Verde",
    grey_color: "Cinza",
    pink_color: "Cor de rosa",
    purple_color: "Roxa",
    red_color: "vermelho",
    silver_color: "Prata",
    orange_color: "laranja",
    white_color: "Branco",
    yellow_color: "Amarelo",
    charcol_color: "Charcol.",
    fuel_diesel: "Diesel",
    fuel_electric: "Elétrico",
    fuel_gasoline: "Gasolina",
    fuel_flex: "Flex.",
    fuel_hybrid: "Híbrido",
    fuel_petrol: "Gasolina",
    fuel_plugin_hybrid: "Híbrido plug-in",
    truck: "Caminhão",
    van_minivan: "Van &  Minivan",
    suv_crossover: "Suv &  Crossover",
    awd_4wd: "AWD / 4WD.",
    fwd: "Fwd.",
    rwd: "Rwd.",
    off_white_color: "Off white",
    tan_color: "bronzeado",
    beige_color: "Bege",
    burgundy_color: "Borgonha",
    turquoise_color: "Turquesa",
    title_status_clean: "Limpar",
    title_status_rebuilt: "Reconstruído",
    title_status_salvage: "Salvamento",
    title_status_missing: "Ausente",
    title_status_lien: "Penhor",
    title_status: "Status do título.",
    mileage: "Quilometragem",
    dialog_drivetrain_title: "Drivetrain",
    model_warning: "Por favor, selecione Fazer primeiro",
    required_field_warning: "Este campo é obrigatório",
    vehicle_vin: "Vin.",
    invalid_vin: "VIN inválido, por favor, defina VIN novamente.",
    invalid_mileage:
      "Quilometragem inválida, por favor, defina a milhagem novamente.",
    clean_description: "A maioria dos veículos que não foram em um acidente",
    rebuilt_description: "Um carro recuperado que foi reconstruído",
    salvage_description: "É considerado totalizado após um acidente",
    missing_description: "Precisará de um novo título de problemas DMV",
    lien_description: "De propriedade de um banco ou liquidação judicial",
    nearme: "Perto de mim",
    newest: "O mais novo",
    contact_support: "Suporte de contato.",
    create_home_title: "Casas para venda ou aluguel",
    for_sale: "À venda",
    for_rent: "Para alugar",
    property_type: "Tipo de Propriedade",
    apartment: "Apartamento",
    house: "lar",
    room_only: "Somente sala",
    townhouse: "Townhouse",
    bedrooms: "Quartos de dormir",
    bathrooms: "Banheiros",
    property_address: "Endereço da propriedade",
    price_per_month: "Preço por mês",
    square_feet: "Pés quadrados",
    year_built: "Ano construído",
    year_renovated: "Ano renovado",
    lot_size: "Tamanho do lote",
    laundry_type: "Tipo de lavanderia",
    in_unit_laundry: "Lavanderia In-Unit",
    laundry_building: "Lavanderia no prédio",
    laundry_available: "Lavanderia disponível",
    none: "Nenhum",
    parking_type: "Tipo de estacionamento",
    garage_parking: "Estacionamento da garagem",
    street_parking: "Estacionamento da rua.",
    off_street_parking: "Estacionamento fora da rua",
    available_parking: "Estacionamento disponível",
    air_cond_type: "Tipo de ar condicionado",
    ac_available: "AC disponível",
    central_ac: "Central AC.",
    heating_type: "Tipo de aquecimento",
    electric_heating: "Aquecimento elétrico",
    gas_heating: "Aquecimento a gás",
    radiator_heating: "Aquecimento do radiador",
    available_heating: "Aquecimento disponível",
    amenities: "Facilidades",
    date_available: "Data Disponível",
    lease_length: "Comprimento de arrendamento",
    month_to_month: "Mês a mês",
    three_months: "3 meses",
    six_months: "6 meses",
    one_year: "1 ano",
    more_one_year: "1+ anos",
    cat_friendly: "Gato amigável",
    dog_friendly: "Cão amigável",
    balcony: "Sacada",
    basement: "Porão",
    bike_parking: "Estacionamento de bicicleta.",
    cable_tv: "TV a cabo",
    ceiling_fan: "Ventilador de teto",
    concierge: "Porteiro",
    dishwasher: "Lava-louças",
    doorman: "Porteiro",
    elevator: "Elevador",
    fireplace: "Lareira",
    fitness_center: "Academia",
    garbage_disposal: "Eliminação de lixo",
    microwave: "Microondas",
    online_app: "Aplicação online",
    oven: "Forno",
    package_service: "Serviço de pacote",
    patio: "Pátio",
    pet_park: "Pet Park",
    refrigerator: "Frigorífico",
    resident_lounge: "Lounge residente",
    roof_deck: "Plataforma do telhado",
    secured_entry: "Entrada segura",
    storage: "Armazenar",
    walk_in_closet: "Armário",
    swimming_pool: "Piscina",
    wheelchair_access: "Acesso para cadeira de rodas",
    central_heating: "Aquecimento central",
    invalid_bedrooms: "Quartos inválidos, por favor, defina quartos novamente.",
    invalid_bathrooms:
      "Banheiros inválidos, por favor, defina banheiros novamente.",
    chinese_simplified_language: "Chinês simplificado",
    chinese_traditional_language: "Chinês tradicional",
    czech_language: "Checo",
    danish_language: "dinamarquês",
    dutch_language: "holandês",
    finnish_language: "finlandês",
    french_language: "francês",
    german_language: "alemão",
    greek_language: "grego",
    hungarian_language: "húngaro",
    indonesian_language: "indonésio",
    italian_language: "italiano",
    japanese_language: "japonês",
    korean_language: "coreano",
    norwegian_language: "norueguês",
    polish_language: "polonês",
    portuguese_language: "Português",
    portuguese_brazilian_language: "Português, brasileiro",
    romanian_language: "romena",
    russian_language: "russo",
    swedish_language: "sueco",
    turkish_language: "turco",
    ukrainian_language: "ucraniano",
    urdu_pakistan_language: "Urdu (Paquistão)",
    vietnamese_language: "vietnamita",
    category_home_sale_or_rent: "Casa para venda ou aluguel",
    square_meter: "Metro quadrado",
    copy_text: "cópia de",
    copyied_to_clipboard: "Copiado para a área de transferência",
    inbox: "Caixa de entrada",
    input_title_listening: "Audição…",
    input_subtitle_listening: "Diga algo",
    input_title_error: "Desculpe, nós não conseguimos isso.",
    input_subtitle_error: "Tente repetir sua solicitação.",
    input_hint_error: "Tente novamente",
    price_less_than_or_equal: "Preço menor ou igual a",
    any_price: "Qualquer preço",
    any_condition: "Qualquer condição",
    any_time: "A qualquer momento",
    days_ago: "dias atrás",
    any_distance: "Qualquer distância",
    distance_within: "Distância dentro de.",
    new_notification: "Nova notificação",
    deleted: "Excluído",
    processing_image: "Imagem de processamento",
    remove_dialog_message: "Você realmente quer remover este produto?",
    deleted_thread: "Esta mensagem é excluída",
    category_yard_sale_event: "Evento de venda de jarda",
    yard_first_date: "Primeira data de venda de jardim",
    yard_second_date: "Venda de jardim Segunda data",
    yard_third_date: "Terceira data de venda de jardim",
    yard_start_time: "Hora de início",
    yard_end_time: "Fim do tempo",
    yard_end_timestamp: "Timestamp final",
    invalid_date1:
      "Primeira data inválida, por favor, defina a primeira data novamente",
    invalid_start_time:
      "Hora inicial inválida, por favor, defina a hora de início novamente",
    invalid_end_time:
      "Hora final inválida, por favor, defina a hora final novamente",
    yard_sale_title: "Venda de garagem",
    garage_tag: "garagem",
    yard_tag: "Jardim",
    from: "A partir de",
    to: "Para",
    block: "Quadra",
    un_block: "Desbloquear",
    sign_email: "Entre com email",
    invalid_first_date:
      "Primeira data inválida, por favor, certifique-se da primeira data é antes do segundo e terceiro",
    invalid_second_date:
      "Segunda data inválida, por favor, certifique-se de que a segunda data é antes da terceira data",
    invalid_start_time_value:
      "Hora inicial inválida, por favor, certifique-se de que a hora de início é antes da hora da extremidade",
    use_default_yard_photo: "Usar foto padrão de venda de jardim",
    active_label: "Ativo",
    enable_notifications: "Ativar notificações",
    login: "Conecte-se",
    january: "Janeiro",
    february: "fevereiro",
    march: "marchar",
    april: "abril",
    may: "Poderia",
    june: "junho",
    july: "Julho",
    august: "agosto",
    september: "setembro",
    october: "Outubro",
    november: "novembro",
    december: "dezembro",
    since: "Desde a",
    product_views: "Visualizações de produto",
    shop_views: "Visualizações da loja",
    total_sales: "Vendas totais",
    total_orders: "Ordens totais",
    last_twelvth_months: "Últimos dois meses",
    last_nine_months: "Últimos nove meses",
    last_six_months: "Últimos seis meses",
    last_three_months: "Últimos três meses",
    last_12_months: "Últimos 12 meses",
    last_9_months: "Últimos 9 meses",
    last_6_months: "Últimos 6 meses",
    last_3_months: "Últimos 3 meses",
    months: "Meses",
    open: "Aberto",
    reset_password: "Redefinir senha",
    create_new_shop: "Crie nova loja",
    download_app: "Baixar aplicativo",
    log_in: "Conecte-se",
    sign_up: "Inscrever-se",
    no_result: "Sem resultado",
    max_price: "Preço máximo",
    max_distance: "Distância máxima.",
    max_time: "Tempo máximo.",
    posted_less_than: "Postado menos de",
    result: "Resultado",
    more: "Mais",
    or: "OU",
    password: "Senha",
    forgot_password: "Esqueceu a senha?",
    and: "e",
    download_for: "Download para",
    apple_ios: "Apple iOS.",
    android: "Android",
    image: "Imagem",
    edit_image: "Editar imagem",
    please_complete: "Por favor complete",
    enter_your_offer: "Digite sua oferta",
    categories: "Categorias",
    upload_image: "Enviar Imagem",
    upload_images: "Enviar imagens",
    back: "Costas",
    see_more: "Ver mais",
    add_product: "Adicionar produto",
    selected: "Selecionado",
    create: "Crio",
    rate_the_buyer: "Avalie o comprador",
    delete_product: "Excluir produto",
    product: "produtos",
    un_block_product: "Desbloquear produto",
    share_your_product: "Compartilhe seu produto",
    boost_details: "Reforçar detalhes.",
    remove_all_products: "Remova todos os produtos",
    remove_all: "Deletar tudo",
    add_vehicle: "Adicionar veículo",
    edit_vehicle: "Editar veículo",
    upload_a_photo: "Carregar uma foto",
    view_details: "Ver detalhes",
    add_yard_sale: "Adicionar venda de jardim",
    edit_yard_sale: "Editar venda de jardim",
    users: "Comercial",
    users_details: "Detalhes dos usuários.",
    users_by_country: "Usuários por país",
    blocked_users: "Usuários bloqueados",
    products_cards: "Cartões de produtos",
    archived_products: "Produtos arquivados.",
    blocked_products: "Produtos bloqueados",
    products_by_country: "Produtos por país",
    reports: "Relatório",
    reports_details: "Detalhes relatórios",
    closed_reports: "Relatórios fechados",
    threads: "Tópicos",
    threads_details: "Detalhes dos tópicos",
    chat_support: "Suporte de bate-papo",
    actions: "Ações",
    search_actions: "Ações de busca",
    product_view_actions: "Ações de visualização de produto",
    contact_seller_product: "Entre em contato com o Vendedor Produto",
    contact_owner_shop: "Contate o Loja do proprietário.",
    ratings: "Classificações",
    reviews: "Avaliações",
    products_all_countries: "Produtos todos os países",
    edit_profile: "Editar Perfil",
    my_profile: "Meu perfil",
    profile_updated_successfully: "Perfil atualizado com sucesso",
    are_you_sure: "Tem certeza",
    my_used_products: "Meus produtos usados",
    my_shops: "Minhas compras",
    my_boosted_products: "Meus produtos impulsionados",
    messages_type_message_here: "Digite sua mensagem aqui",
    messages_product_sold: "Este produto é vendido ou removido",
    seen: "Visto",
    messages_never_miss_message: "Nunca perca uma mensagem",
    enable: "Habilitar",
    send_notify: "Enviar notify.",
    un_close: "Descasionar",
    type_your_review: "Digite sua revisão",
    again_question: "novamente ?",
    ratings_already_submitted_review: "Você já enviou revisão",
    set_product_category: "Definir categoria de produto",
    auth_email_password_incorrect: "Seu e-mail ou senha incorreta",
    auth_insert_your_name: "Por favor, insira seu nome",
    auth_email_address_badly: "O endereço de e-mail é mal formatado",
    auth_email_address_used:
      "O endereço de e-mail já está em uso por outra conta",
    auth_invalid_password: "A senha deve ter pelo menos 6 caracteres",
    auth_reset_email: "Insira seu e-mail para redefinir sua senha",
    auth_check_email: "Por favor, verifique seu e-mail para redefinir a senha",
    auth_can_sign_in_google: "Você pode entrar com o botão do Google",
    auth_do_not_have_account: "Você não tem uma conta?",
    auth_have_account: "Você tem uma conta?",
    log_terms_privacy_part1:
      "Ao se inscrever ou fazer login, você concorda com o listado perto de mim",
    boost_this_product: "Impulsionar este produto?",
    product_successfully_boosted: "O produto foi impulsionado com sucesso",
    product_failed_boost: "O produto foi falhado em impulso",
    no_products_for_sale:
      "Você atualmente não tem nenhum produto usado para venda.",
    not_sold_listed_near_me: "Eu não vendi na listada perto de mim",
    agree_add_product:
      "Ao tocar em postar para publicar seu produto, você concorda com os próximos Termos de Serviço e Política de Privacidade.",
    click_to_boost: "Clique no produto para impulsionado",
    listed_terms_of_service: "Listado perto de mim termos de serviço",
    receive_emails_for_users: "Receba e-mails para mensagens de usuários",
    receive_emails_for_newly_posted:
      "Receba e-mails para seus produtos recém-postados",
    disable_push_notifications: "Desativar notificações push",
    sms_during_day: "Receba SMS durante o dia",
    sms_24_hours: "Receba SMS 24 horas",
    products: "Produtos",
    product_no_longer_available:
      "Desculpe, este produto não está mais disponível",
    add_home: "Adicionar casa",
    edit_home: "Editar casa",
    fill_required_fields: "Preencha todos os campos obrigatórios",
    no_notification: "Não há notificações",
    orders_history: "Ordens History.",
    privacy: "Privacidade",
    terms: "Termos.",
    report_a_problem: "Reportar um problema",
    approximation_protect_user_privacy:
      "Aproximação para proteger a privacidade do usuário",
    do_not_have_products: "Você não tem produtos",
    emails: "E-mails.",
    lead_deletion_products: "Isso levará à exclusão de todos os seus produtos",
    confirm_legal_message:
      "Você é o único responsável por tomar todas as precauções necessárias ao interagir com os outros, particularmente quando se encontra um estranho em pessoa pela primeira vez. Por favor, reveja os Termos de Serviço para mais detalhes.",
    push_notifications_notified_instantly:
      "Ativar notificações push para ser notificado instantaneamente",
    rate_seller: "Classifique o vendedor",
    user_journey: "Viagem do usuário",
    user: "Do utilizador",
    user_id: "ID do usuário",
    action_id: "ID de ação",
    select_model_car: "Selecione o modelo de carro",
    boost_1_day: "Impulso 1 dia",
    boost_3_days: "Impulsionar 3 dias",
    boost_7_days: "Impulsionar 7 dias",
    agree_boost_terms: "Ao bater o impulso, você concorda em",
    add: "Adicionar",
    add_tag: "Adicionar etiqueta",
    brand_title: "Marca",
    category_mobiles: "Mobiles.",
    category_tablets: "Comprimidos",
    screen_size: "Tamanho da tela",
    has_cellular_capability: "Tem capacidade celular",
    default_internal_memory: "Memória interna",
    network_carrier: "Operadora de rede",
    is_unlocked: "Está desbloqueado",
    mobile_model_warning: "Por favor, selecione a marca primeiro",
    missing_image: "Imagem ausente, tente adicionar imagem novamente.",
    add_mobile: "Adicionar celular",
    edit_mobile: "Editar celular",
    add_tablet: "Adicionar tablet.",
    edit_tablet: "Editar tablet.",
    keywords:
      "compras, comprar, vender, ganhar dinheiro, comércio, moradores locais, vizinhos, automático, veículos",
    country: "País",
    phone_number: "Número de telefone",
    verification_code: "Código de verificação",
    error_occurred: "Ocorreu um erro. Por favor tente novamente mais tarde",
    invalid_state:
      "Estado inválido: Um retorno de chamada de login foi recebido, mas nenhuma solicitação de login foi enviada.",
    sign_in: "Entrar",
    sign_in_apple: "Entre com a Apple",
    sign_in_google: "Faça login no Google",
    sign_in_phone: "Entrar com o telefone",
    sign_in_facebook: "Entre com o Facebook",
    create_account: "Crie a sua conta aqui",
    email: "E-mail",
    invalid_field: "Por favor, preencha os campos obrigatórios",
    code_sent: "O código foi enviado por SMS",
    verify_number: "Verifique o número de telefone",
    tapping_verify_number:
      "Ao tocar (verifique o número de telefone), um SMS seja enviado.",
    email_exists:
      "A conta já existe e você precisa acessá-lo através do botão do Google, botão do Facebook ou botão da Apple",
    ok: "OK",
    sure_back: "Você tem certeza de voltar?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "atrás",
    add_model: "Adicionar modelo",
    no_search_results_us:
      "Nenhum resultado de pesquisa perto de você dentro de 120 milhas. Tente alterar o filtro de pesquisa ou pesquisar palavras -chave.",
    no_search_results:
      "Nenhum resultado de pesquisa perto de você a 200 km. Tente alterar o filtro de pesquisa ou pesquisar palavras -chave.",
    plan_date: "Data do plano",
    plan_time: "Planejar tempo",
    invalid_plan_date:
      "Data do plano inválido, defina a data do plano novamente",
    invalid_plan_time:
      "Tempo de plano inválido, defina o tempo do plano novamente",
    plan_name: "Nome do plano",
    plan_title: "Plano",
    update_plan_name: "Atualizar o nome do plano",
    delete_plan_question: "Tem certeza de que deseja excluir este plano?",
    plan_reminder_message: "Você será lembrado uma hora antes",
    plan_dialog_title: "Plano de reunião",
    planners_title: "Planejadores",
    unable_sending_messages:
      "Eles verão suas mensagens quando estiverem novamente online.",
    its_text: "Isso é",
    for_your_text: "para o seu receptor.",
  },
  ro: {
    invalid_area: "Zona nevalidă, vă rugăm să setați din nou zona.",
    invalid_lot_size:
      "Proprietate nevalidă Dimensiune lot, vă rugăm să setați din nou dimensiunea mult.",
    property_area: "Domeniul imobilier.",
    app_store_name:
      "Enumerate lângă mine - cumpărați articole folosite, vinde pentru bani",
    app_store_short:
      "O piață pentru vânzătorii locali. Listează un articol de vânzare și a face bani.",
    app_store_full:
      "Listați lângă mine ușurează găsirea unor oferte minunate despre lucrurile pe care le doriți și faceți bani pe lucrurile pe care doriți să le vindeți. Aceasta este cea mai bună modalitate de a cumpăra și de a vinde în comunitatea dvs. sau cartier cu persoane în care puteți avea încredere. Cum funcționează: 1- Cumpărați sau vindeți ceva; Postați cu ușurință articolele de vânzare în câteva secunde. 2- Găsiți oferte și reduceri excelente pentru haine, mobilier, telefoane mobile, articole electronice, copii și copii, echipamente sportive, mașini, rochii, pantofi și ceasuri, cărți, jucării folosite, laptop-uri folosite, o mașină second-hand și chiar real Estate de vânzare sau de închiriat. 3 - Răsfoiți articolele locale de vânzare. 4- Cumpărători și vânzători de mesaje din cadrul aplicației. 5- Răsfoiți articole după imagine și sortare după categorie. Focuri distractive despre enumerate lângă mine: 1 - Cu enumerate lângă mine, puteți vinde cu ușurință ceva, de la haine la mașini folosite la electronică. 2 - Comunicarea între cumpărători și vânzători se întâmplă prin aplicație prin intermediul mesajelor. 3-enumerate lângă mine este mai bună decât o vânzare de garaj; Găsiți tot ce doriți la o reducere, chiar pe telefon sau tabletă.",
    app_store_release:
      "Enumerate lângă mine - comerț cu localnici. Alăturați-vă pieței mobile pentru cumpărătorii și vânzătorii locali!",
    app_name: "Enumerate lângă mine",
    title_buy: "Cumpără",
    title_messages: "Mesaje",
    title_sell: "Vinde",
    title_profile_image: "Imagine de profil",
    title_account: "Cont",
    account_settings: "Setările contului",
    settings: "Setări.",
    color_theme: "Tema de culoare",
    device_settings: "Setări dispozitiv",
    public_profile: "Profil public.",
    light_mode: "Modul Light.",
    dark_mode: "Modul întunecat.",
    title_sell_faster: "Vindem mai repede",
    send_button_label: "Trimite",
    rate_message: "Evaluează-mă...",
    already_rated: "Ați trimis deja revizuirea",
    rate_review_question: "Doriți să vă ocupați",
    again: "din nou?",
    action_logout: "Logout",
    action_category: "Categorie",
    action_search: "Căutare",
    action_refer: "Consultați un prieten",
    dialog_choose_location: "Alegeți locația",
    dialog_change_username: "Schimbă numele",
    dialog_change_language: "Schimba limba.",
    dialog_image_tags: "Tag-uri de imagine",
    dialog_emails_notifications: "E-mailuri Notificări",
    dialog_push_notifications: "Notificări",
    fragment_product_detail: "Detaliile produsului",
    fragment_message_details: "Detaliile mesajelor",
    fragment_sell: "Vinde",
    dialog_tags_title: "Etichete",
    dialog_location_title: "Actualizați locația",
    dialog_username_title: "Schimbă numele",
    tab_photo: "Fotografie",
    tab_details: "Detalii",
    tab_price: "Preț",
    tab_finish: "finalizarea",
    profile: "Profil",
    search: "Căutare",
    choose_product: "Alegeți produsul",
    rating_review: "Evaluare și recenzie.",
    select_buyer: "Selectați un cumpărător",
    tab_my_used_products: "Produsele mele",
    price_label: "Preț",
    text_savings: "Salvați",
    search_hint: "Căutați produse ...",
    empty_text:
      "Nu există produse listate în această categorie sau în cadrul distanței selectate.",
    filter_menu_text: "Filtru",
    error_contacting_seller: "Eroare la contactarea vânzătorului",
    edit_product: "Editați produsul",
    contact_seller: "Contacteaza vanzatorul",
    signup_to_contact_seller: "Înscrieți-vă pentru a contacta vânzătorul",
    signup_to_make_offer: "Înscrieți-vă pentru a face ofertă",
    product_details: "Detalii",
    product_category: "Categorie",
    product_condition: "Condiție",
    product_description: "Descriere",
    product_location: "Locația produsului",
    product_location_approximate: "Locația este aproximată",
    over_week_time_ago: "În urmă cu mai mult de o săptămână",
    boosted: "Amplificat",
    threads_no_results: "Nu există mesaje",
    message_no_results: "Nu există mesaje",
    message_warning:
      "Sunteți singurul responsabil pentru a lua toate precauțiile necesare atunci când interacționați cu ceilalți, în special atunci când întâlniți un străin în persoană pentru prima dată. Vă rugăm să nu partajați informații personale, coduri de verificare sau informații de plată. Vă rugăm să examinați Termenii de serviciu pentru mai multe detalii.",
    message_block: "Nu puteți trimite sau primi mesaje în acest moment.",
    select_location: "Selectați locația",
    location_permission_denied_message:
      "Aplicația necesită permisiunea de locație să funcționeze corect.",
    signed_in: "Inscris!",
    sign_in_canceller: "Conectați-vă anulată",
    version: "Versiune",
    build: "Construi",
    name: "Nume",
    location: "Locație",
    language: "Limba",
    about_app: "Despre enumerate lângă mine",
    terms_of_service: "Termenii serviciului",
    privacy_policy: "Politica de Confidențialitate",
    report_feedback: "Trimite feedback",
    report_bug: "Agitați telefonul pentru a raporta un bug",
    change_image: "Schimbați imaginea",
    update_location: "Actualizați locația",
    about_the_app: "Despre aplicație",
    update_label: "Actualizați",
    uploading: "Încărcarea",
    adding: "Adăugarea listei.",
    removing: "Eliminarea listei",
    updating: "Actualizarea listei.",
    uploaded_image: "Imagine încărcată:",
    image_storage_failed: "Nu a reușit să stocheze imaginea:",
    product_updated: "Produsul actualizat cu succes",
    location_error: "Locația nu este salvată, încercați din nou",
    product_removed: "Produsul a fost eliminat cu succes",
    deleted_product: "Acest produs este șters",
    invalid_title: "Titlu nevalid, vă rugăm să setați din nou titlul.",
    invalid_image:
      "Calea de imagine nevalidă, încercați să adăugați din nou imaginea.",
    invalid_price: "Preț nevalid, vă rugăm să setați din nou prețul.",
    invalid_location: "Locație nevalidă, vă rugăm să setați din nou locația.",
    invalid_category:
      "Categoria nevalidă, vă rugăm să setați din nou categoria.",
    invalid_condition: "Starea nevalidă, vă rugăm să setați din nou condiția.",
    removing_title: "Eliminarea imaginii profilului",
    image_not_saved: "Salvarea imaginii a eșuat!",
    product_load_failed: "Nu există produse",
    take_photo: "Fa o poza",
    select_photo: "Selectați Photo.",
    product_title_hint: "Ce este? Numele, marca, modelul etc.",
    delete_photo: "Ștergeți fotografia",
    product_title: "Titlu",
    mark_as_sold: "Marcat ca vandut",
    product_share: "Acțiune",
    product_make_offer: "A face o ofertă",
    product_cover: "Setați ca imagine de acoperire",
    product_tags: "Etichete",
    product_posted: "Postat:",
    product_change: "Schimbare",
    product_post: "Post",
    product_selling_from: "Vânzarea de la locație",
    product_select_location: "Selectați locația",
    product_map_approximate:
      "Harta este aproximativă pentru a păstra locația vânzătorului privat",
    product_terms:
      "Prin atingerea postului pentru a publica produsul dvs., sunteți de acord cu <U> enumerate lângă mine Termeni de utilizare. </ U>",
    condition_other: "Altele (vezi descrierea)",
    condition_for_parts: "Pentru părți",
    condition_used: "Utilizate (uzură normală)",
    condition_open_box: "Caseta deschisă (niciodată folosită)",
    condition_reconditioned: "Recondiționată / certificată",
    condition_new: "Nou (nu a fost folosit niciodată)",
    select_category: "selecteaza categoria",
    select_all_category: "Selectează tot",
    category_loading_error:
      "Nu pot actualiza lista de categorii, încercați din nou mai târziu.",
    category_vehicles: "Vehicule",
    category_furniture: "Mobila",
    category_electronics: "Electronică",
    category_appliances: "Acasă &  Aparate",
    category_fashion_accessories: "Fashion &  Accesorii",
    category_baby_kids: "Baby &  Copiii",
    category_antiques_collectibles: "Antichități &  Colectibiles.",
    category_auto_parts_tools_machinery: "Piese auto, unelte &  Mașini",
    category_sports_outdoors: "Sport &  În aer liber",
    category_others: "Alții",
    location_enter_zip_code: "Introduceti codul postal",
    location_get_current_location: "Obțineți locația curentă",
    location_select_location: "Selectați locația",
    location_update_location: "Actualizați locația",
    location_new_location: "Locație nouă",
    search_filter_results: "Filtreaza rezultate",
    search_filter_min: "Minimul de filtrare",
    search_filter_at_least: "Macar",
    price_filter: "Filtru de prețuri",
    product_name: "numele produsului",
    english_language: "Engleză",
    arabic_language: "arabic",
    spanish_language: "Spaniolă",
    system_language: "Sistem",
    share_link: "Imparte link-ul",
    save: "salva",
    cancel: "Anulare",
    loading: "Se încarcă",
    yes: "da",
    no: "Nu",
    report: "Raport",
    report_product: "Raportați produsul",
    report_user: "Raportați utilizatorul",
    block_user: "Blocați utilizatorul",
    un_block_user: "Deblochează utilizator",
    why_product: "De ce doriți să raportați acest articol?",
    why_user: "De ce doriți să raportați acest utilizator?",
    block_user_confirm: "Doriți să blocați permanent acest utilizator?",
    un_block_user_confirm: "Doriți să deblocați permanent acest utilizator?",
    prohibited: "Interzis pe listate lângă mine",
    offensive: "Ofensator sau inadecvat",
    duplicate: "Duplicat post.",
    wrong_category: "Categorie greșită",
    scam: "Arata ca o înșelătorie",
    stolen: "Cred că este furat",
    product_other: "Alte",
    product_is_sold: "Acest produs a fost vândut",
    missed_meeting: "Au ratat întâlnirea noastră",
    low_offer: "A făcut o ofertă scăzută",
    rude: "Nepoliticos sau inadecvat",
    items: "Problemă cu elementele",
    trouble_meetup: "Probleme la întâlnirea",
    messaging: "Probleme de mesagerie",
    user_other: "Alte",
    new_version_available: "Noua versiune disponibilă",
    please_update_app:
      "Vă rugăm să actualizați aplicația la noua versiune pentru a continua.",
    update: "Actualizați",
    no_thanks: "Nu, mulțumesc",
    contact_support_confirmation:
      "Timpul de răspuns curent este de 24-48 de ore. Doriți să contactați listat lângă mediul de asistență pentru chat aplicație?",
    unboost_confirmation: "Sigur doriți să dezactivați acest produs?",
    no_used_products: "Nu aveți încă listări",
    no_boosted_products: "Nu aveți produse sporite",
    next: "Următorul",
    previous: "Anterior",
    skip: "Ocolire",
    start: "start",
    list_used: "Listează un produs utilizat",
    buy_description:
      "Descoperiți și căutați produse oferite de vecinii din jurul dvs.",
    sell_description: "Listează produse pe care nu mai aveți nevoie de vânzare",
    list_used_description:
      "Listează un produs utilizat de vânzare în mai puțin de 20 de secunde",
    boost_product_option_1: "<b> Boost 1  nday </ b>  n  n <b> $ 0.99 </ b>",
    boost_product_option_2: "<b> Boost 3  ndays </ b>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<b> Boost 7  ndays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "Obțineți mai multe viziuni în fiecare zi. Elementul dvs. va apărea în poziții recomandate în primele 30 de articole din Buy and Categorie. Elementele promovate sunt rotite între punctele desemnate, astfel încât fiecare element primește o expunere corectă.",
    boost_cta: "Vindem mai repede",
    boost_terms:
      "Prin atingerea impulsului, sunteți de acord cu <U> enumerate în apropierea ME Termeni de utilizare. </ U>",
    boost_best_value: "Cel mai bun pret",
    already_boosted: "Acest produs este amplificat",
    clicks: "Clicks.",
    impressions: "Impresii",
    end: "Sfârșit",
    transactions_empty_text:
      "Încă nu aveți tranzacții de stimulare. Puteți vizita fila Vindem și puteți începe să vă stimulați produsele.",
    transactions_loading_error:
      "Nu se poate actualiza lista de tranzacții, încercați din nou mai târziu.",
    transactions_history_title: "Îmbunătățiți istoricul tranzacțiilor",
    communicative_postive: "Comunicativ",
    communicative_negative: "Necomunicativ",
    ontime_postive: "La timp",
    ontime_negative: "Târziu",
    reliable_postive: "De încredere",
    reliable_negative: "Nesigure",
    friendly_postive: "Prietenos",
    friendly_negative: "Nepoliticos",
    itemasdescribed_postive: "item conform descrierii",
    itemasdescribed_negative: "Elementul nu este așa cum este descris",
    other: "Alte",
    submit: "Trimite",
    adding_rating_reviews: "Adăugarea de rating și recenzii",
    no_internet_title: "Fără conexiune internet",
    no_internet_message:
      "Asigurați-vă că sunteți conectat la Internet și încercați din nou",
    retry: "Reîncercați",
    near_me: "Lângă mine",
    newest_first: "Cele mai noi în primul rând",
    miles: "Miles.",
    km: "km",
    similar_products: "produse similare",
    favorite_products: "Produse preferate",
    items_for_sale: "Articole de vânzare",
    joined: "S-au alăturat",
    favorites_transactions_title: "Favorite",
    boosted_products_transactions_history:
      "PRODUSE TRANZACȚII ALE TRANZACȚIILOR",
    views: "Vizualizări",
    boost_graph_title: "Boost grafic",
    no_favorite_products: "Nu aveți produse preferate",
    make_offer_buy: "Aș dori să cumpăr",
    make_offer_buy_for: "pentru",
    notifications: "Notificări",
    push_notifications: "Apăsați",
    emails_notifications: "E-mail",
    apply: "aplica",
    email_messages: "E-mail pentru mesaje",
    email_new_products: "E-mail pentru produse noi",
    push_day_only: "Împingeți numai Ziua Notificărilor",
    push_24_hours: "Push Notificări 24 de ore",
    edit: "Editați | ×",
    map: "Hartă",
    camera: "aparat foto",
    gallery: "Galerie",
    delete: "Șterge",
    no_sell_items: "Nu există elemente de vânzare",
    who_bought_question: "Cine a cumpărat-o?",
    sold_elsewhere_question: "A vândut-o în altă parte",
    confirm: "A confirma",
    over_limit_camera: "Nu puteți adăuga mai mult de cinci imagini",
    boost_failed: "Boost a eșuat. Vă rugăm să încercați din nou mai târziu",
    after_purchase: "Plata de succes  nProduct sporit",
    pay_failed: "Plata esuata. Vă rugăm să încercați din nou",
    done: "Terminat",
    not_now: "Nu acum",
    boost: "Boost.",
    invalid_zip_code: "Cod poștal incorect",
    invalid_user_name: "Nume de utilizator invalid",
    comments: "Comentarii",
    questions: "Întrebări",
    bug_reports: "BUG Rapoarte",
    feature_request: "Cerere de caracteristică",
    feedback_type: "Tipul de feedback",
    feedback_description:
      "Ne-ar plăcea să vă auzim gândurile sau feedback cu privire la modul în care vă putem îmbunătăți experiența!",
    feedback: "Părere",
    feedback_text: "Raspunsul tau",
    suggestions: "Sugestii pentru îmbunătățire",
    delete_account: "Șterge cont",
    new_message: "Mesaj nou",
    online: "Pe net",
    km_50: "50 km.",
    km_100: "100 km.",
    km_200: "200 km.",
    miles_30: "30 de mile",
    miles_60: "60 de mile",
    miles_120: "120 de mile",
    rate_app_question:
      "Ce zici de un rating pe magazinul de aplicații, atunci?",
    enjoying_question: "Se bucură de listate lângă mine?",
    not_enjoy: "Nu chiar",
    feedback_question: "Vrei să ne dai niște feedback?",
    yes_sure: "OK sigur",
    product_available_question: "Bună, este încă disponibil?",
    buy_question: "Bună, aș vrea să cumpăr acest lucru",
    meet_question: "Bună, te poți întâlni astăzi?",
    follow: "Urma",
    followers: "Urmașii",
    following: "Ca urmare a",
    feedback_thanks: "Vă mulțumim pentru feedback-ul dumneavoastră",
    all_categories: "toate categoriile",
    deleted_account: "Acest cont este șters",
    delete_account_question: "Sigur doriți să ștergeți acest cont?",
    no_followings: "nu urmează pe nimeni",
    when_following: "când",
    no_followings_subtitle: "Urmează oamenii, îi vei vedea aici",
    no_followers: "nu au adepți",
    no_followers_subtitle: "urmată de oameni, le veți vedea aici",
    distance: "Distanţă",
    filter_method: "Metoda de filtrare",
    see_listings: "Vedeți înregistrările",
    sold: "Vândut",
    bought: "Cumparat",
    no_notifications: "Când primiți notificări, vor apărea aici",
    items_title: "Articole",
    new_listing_title: "Creați o listă nouă",
    dialog_year_title: "An",
    dialog_make_title: "Face",
    dialog_model_title: "Model",
    dialog_body_style_title: "Stilul corpului",
    dialog_exterior_color_title: "Culoare exterioară",
    dialog_interior_color_title: "Culoare interioară",
    dialog_transmission_title: "Transmitere",
    dialog_fuel_type_title: "Tipul combustibilului",
    dialog_owners_num_title: "Numărul de proprietari",
    dialog_vehicle_owed_money_title:
      "Există bani încă datorate pe acest vehicul?",
    automatic_transmission: "Automat",
    manual_transmission: "Manual",
    not_sure: "Nu sunt sigur",
    wagon_hatchback: "Vagon &  Hatchback.",
    convertible: "Convertible",
    coupe: "Coupe.",
    sedan: "Sedan.",
    black_color: "Negru",
    blue_color: "Albastru",
    brown_color: "Maro",
    gold_color: "Aur",
    green_color: "Verde",
    grey_color: "Gri",
    pink_color: "Roz",
    purple_color: "Violet",
    red_color: "roșu",
    silver_color: "Argint",
    orange_color: "portocale",
    white_color: "alb",
    yellow_color: "Galben",
    charcol_color: "Charcol.",
    fuel_diesel: "Motorină",
    fuel_electric: "Electric",
    fuel_gasoline: "Benzină",
    fuel_flex: "Contracta",
    fuel_hybrid: "Hibrid",
    fuel_petrol: "Benzină",
    fuel_plugin_hybrid: "Plug-in hibrid",
    truck: "Camion",
    van_minivan: "Van &  Dubita",
    suv_crossover: "SUV &  Crossover.",
    awd_4wd: "AWD / 4WD.",
    fwd: "Fwd.",
    rwd: "RWD.",
    off_white_color: "Aproape alb",
    tan_color: "Bronz",
    beige_color: "Bej",
    burgundy_color: "Burgundia",
    turquoise_color: "Turcoaz",
    title_status_clean: "Curat",
    title_status_rebuilt: "Reconstruită",
    title_status_salvage: "Salvare",
    title_status_missing: "Dispărut",
    title_status_lien: "Lien.",
    title_status: "Statutul titlului.",
    mileage: "Kilometraj",
    dialog_drivetrain_title: "Drivetrain",
    model_warning: "Selectați mai întâi",
    required_field_warning: "Acest câmp este obligatoriu",
    vehicle_vin: "Vin.",
    invalid_vin: "Vin invalid, vă rugăm să setați din nou VIN.",
    invalid_mileage:
      "Kilometraj nevalid, vă rugăm să setați din nou kilometrajul.",
    clean_description:
      "Cele mai multe vehicule care nu au fost într-un accident",
    rebuilt_description: "O mașină salvată care a fost reconstruită",
    salvage_description: "Este considerat totală după un accident",
    missing_description: "Va avea nevoie de un nou titlu de probleme DMV",
    lien_description: "Deținută de o bancă sau o decontare instanței",
    nearme: "Lângă mine",
    newest: "Cel mai nou",
    contact_support: "Contact asistență",
    create_home_title: "Case de vânzare sau de închiriat",
    for_sale: "De vânzare",
    for_rent: "De inchiriat",
    property_type: "Tipul de proprietate",
    apartment: "Apartament",
    house: "Casă",
    room_only: "Doar camera",
    townhouse: "Townhouse.",
    bedrooms: "Dormitoare",
    bathrooms: "Băi",
    property_address: "Adresa de proprietate",
    price_per_month: "Preț pe lună",
    square_feet: "Metri pătrați",
    year_built: "An de fabricatie",
    year_renovated: "Anul renovat",
    lot_size: "Mărimea lotului",
    laundry_type: "Tipul de rufe",
    in_unit_laundry: "Spălătorie în unitate",
    laundry_building: "Spălătorie în clădire",
    laundry_available: "Spălătorie disponibilă",
    none: "Nici unul",
    parking_type: "Tip de parcare",
    garage_parking: "Parcare de garaj",
    street_parking: "Stradă parcare",
    off_street_parking: "Off-Street Parcare",
    available_parking: "Parcare disponibilă",
    air_cond_type: "Tip de aer condiționat",
    ac_available: "AC disponibilă",
    central_ac: "Central AC.",
    heating_type: "Tip de încălzire",
    electric_heating: "Încălzire electrică",
    gas_heating: "Încălzire cu gaz",
    radiator_heating: "Încălzirea radiatorului",
    available_heating: "Încălzire disponibilă",
    amenities: "Facilități",
    date_available: "Dată disponibil",
    lease_length: "Lungimea de închiriere",
    month_to_month: "Luna de luna",
    three_months: "3 luni",
    six_months: "6 luni",
    one_year: "1 an",
    more_one_year: "1+ ani",
    cat_friendly: "Cat prietenos cu pisica",
    dog_friendly: "Câine prietenos",
    balcony: "Balcon",
    basement: "subsol",
    bike_parking: "Bike Parcare",
    cable_tv: "Televiziune prin cablu",
    ceiling_fan: "Ventilator",
    concierge: "Concierge",
    dishwasher: "Spalator de vase",
    doorman: "Portar",
    elevator: "Lift",
    fireplace: "Vatră",
    fitness_center: "Sală de fitness",
    garbage_disposal: "Aruncarea gunoiului",
    microwave: "Cuptor cu microunde",
    online_app: "Aplicație online",
    oven: "Cuptor",
    package_service: "Serviciul de pachete",
    patio: "Patio",
    pet_park: "Parcul de companie",
    refrigerator: "Frigider",
    resident_lounge: "Lounge rezident.",
    roof_deck: "Puntea acoperișului",
    secured_entry: "Intrarea securizată",
    storage: "Depozitare",
    walk_in_closet: "Walk-in dulap",
    swimming_pool: "Piscina",
    wheelchair_access: "Acces pentru scaun cu rotile",
    central_heating: "Încălzire centrală",
    invalid_bedrooms:
      "Dormitoare nevalide, vă rugăm să setați din nou dormitoarele.",
    invalid_bathrooms: "Băi nevalide, vă rugăm să setați băi din nou.",
    chinese_simplified_language: "Chineză simplificată",
    chinese_traditional_language: "Tradițional chinezesc",
    czech_language: "ceh",
    danish_language: "danez",
    dutch_language: "Olandeză",
    finnish_language: "finlandeză",
    french_language: "limba franceza",
    german_language: "limba germana",
    greek_language: "Grec",
    hungarian_language: "Maghiar",
    indonesian_language: "Indoneziană",
    italian_language: "Italiană",
    japanese_language: "japonez",
    korean_language: "coreeană",
    norwegian_language: "norvegian",
    polish_language: "Lustrui",
    portuguese_language: "Portugheză.",
    portuguese_brazilian_language: "Portugheză, braziliană",
    romanian_language: "Română",
    russian_language: "Rusă",
    swedish_language: "suedez",
    turkish_language: "turc",
    ukrainian_language: "ucrainean",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "Vietnameză",
    category_home_sale_or_rent: "Acasă de vânzare sau de închiriat",
    square_meter: "Metru patrat",
    copy_text: "Copie",
    copyied_to_clipboard: "Copiat în clipboard.",
    inbox: "Inbox",
    input_title_listening: "Ascultare…",
    input_subtitle_listening: "Spune ceva",
    input_title_error: "Îmi pare rău, nu am făcut asta.",
    input_subtitle_error: "Încercați să repetați solicitarea dvs.",
    input_hint_error: "Încearcă din nou",
    price_less_than_or_equal: "Preț mai mic sau egal cu",
    any_price: "Orice preț",
    any_condition: "Orice condiție",
    any_time: "Orice moment",
    days_ago: "zile în urmă",
    any_distance: "Orice distanță",
    distance_within: "Distanța în interiorul",
    new_notification: "Noua notificare",
    deleted: "Șters",
    processing_image: "Procesarea imaginii",
    remove_dialog_message: "Chiar vrei să elimini acest produs?",
    deleted_thread: "Acest mesaj este șters",
    category_yard_sale_event: "Eveniment de vânzare în curte",
    yard_first_date: "Vânzarea curții primei date",
    yard_second_date: "Vânzarea curților a doua dată",
    yard_third_date: "Vânzarea la curte a treia dată",
    yard_start_time: "Timpul de începere",
    yard_end_time: "Sfârșitul timpului",
    yard_end_timestamp: "End Timestamp.",
    invalid_date1: "Prima dată nevalidă, vă rugăm să setați din nou prima dată",
    invalid_start_time:
      "Ora de începere nevalidă, vă rugăm să setați din nou ora de începere",
    invalid_end_time:
      "Timpul de sfârșit nevalid, vă rugăm să setați din nou ora",
    yard_sale_title: "Vânzare în curte",
    garage_tag: "garaj",
    yard_tag: "curte",
    from: "Din",
    to: "La",
    block: "bloc",
    un_block: "Deblocați.",
    sign_email: "Conectați-vă cu e-mail",
    invalid_first_date:
      "Prima dată nevalidă, vă rugăm să vă asigurați că prima dată este înainte de a doua și a treia",
    invalid_second_date:
      "A doua dată nevalidă, vă rugăm să vă asigurați că a doua dată este înainte de a treia dată",
    invalid_start_time_value:
      "Ora de începere nevalidă, vă rugăm să vă asigurați că timpul de pornire este înainte de sfârșitul timpului",
    use_default_yard_photo:
      "Utilizați fotografia de vânzare a curții implicite",
    active_label: "Activ",
    enable_notifications: "Activați notificările",
    login: "Autentificare",
    january: "ianuarie",
    february: "februarie",
    march: "Martie",
    april: "Aprilie",
    may: "Mai",
    june: "iunie",
    july: "iulie",
    august: "August",
    september: "Septembrie",
    october: "octombrie",
    november: "noiembrie",
    december: "decembrie",
    since: "De cand",
    product_views: "Vizionări la produs",
    shop_views: "Vizualizări ale magazinelor",
    total_sales: "Vanzari totale",
    total_orders: "Comenzi totale",
    last_twelvth_months: "Ultimele douăsprezece luni",
    last_nine_months: "Ultimele nouă luni",
    last_six_months: "Ultimele șase luni",
    last_three_months: "Ultimele trei luni",
    last_12_months: "Ultimele 12 luni",
    last_9_months: "Ultimele 9 luni",
    last_6_months: "Ultimele 6 luni",
    last_3_months: "Ultimele 3 luni",
    months: "Luni",
    open: "Deschis",
    reset_password: "Reseteaza parola",
    create_new_shop: "Creați un magazin nou",
    download_app: "Descărcați aplicația",
    log_in: "Autentificare",
    sign_up: "Inscrie-te",
    no_result: "Nici un rezultat",
    max_price: "Prețul maxim",
    max_distance: "Maximă distanță",
    max_time: "Timpul maxim",
    posted_less_than: "Postat mai puțin decât",
    result: "Rezultat",
    more: "Mai mult",
    or: "SAU",
    password: "Parola",
    forgot_password: "Ați uitat parola?",
    and: "și",
    download_for: "Descărcați pentru",
    apple_ios: "Apple ios.",
    android: "Android",
    image: "Imagine",
    edit_image: "Editați imaginea",
    please_complete: "Completeaza te rog",
    enter_your_offer: "Introduceți oferta dvs.",
    categories: "Categorii",
    upload_image: "Incarca imaginea",
    upload_images: "Incarca Imagini",
    back: "Înapoi",
    see_more: "Vezi mai mult",
    add_product: "Adăugați produsul",
    selected: "Selectat",
    create: "Crea",
    rate_the_buyer: "Evaluați cumpărătorul",
    delete_product: "Ștergeți produsul",
    product: "Produs",
    un_block_product: "Deblocați produsul",
    share_your_product: "Distribuiți-vă produsul",
    boost_details: "Îmbunătățiți detaliile",
    remove_all_products: "Îndepărtați toate produsele",
    remove_all: "Inlătură tot",
    add_vehicle: "Adăugați vehiculul",
    edit_vehicle: "Editați vehiculul",
    upload_a_photo: "Încarcă o poză",
    view_details: "Vezi detalii",
    add_yard_sale: "Adăugați vânzarea de yard",
    edit_yard_sale: "Editați vânzarea curte",
    users: "Utilizatorii",
    users_details: "Utilizatori detaliază",
    users_by_country: "Utilizatori după țară",
    blocked_users: "Utilizatori blocati",
    products_cards: "Cartele de produse",
    archived_products: "Produse arhivate",
    blocked_products: "Produse blocate",
    products_by_country: "Produse pe țări",
    reports: "Raport",
    reports_details: "Rapoarte detaliate",
    closed_reports: "Rapoarte închise",
    threads: "Fire",
    threads_details: "Detalii fire",
    chat_support: "Suport pentru chat.",
    actions: "Acțiuni",
    search_actions: "Acțiuni de căutare",
    product_view_actions: "Vizualizarea produsului",
    contact_seller_product: "Contactați produsul vânzătorului",
    contact_owner_shop: "Contactați magazinul de proprietari",
    ratings: "Evaluări.",
    reviews: "Recenzii",
    products_all_countries: "Produse Toate țările",
    edit_profile: "Editează profilul",
    my_profile: "Profilul meu",
    profile_updated_successfully: "Profil actualizat cu succes",
    are_you_sure: "Esti sigur",
    my_used_products: "Produsele mele folosite",
    my_shops: "Magazinele mele",
    my_boosted_products: "Produsele mele luminate",
    messages_type_message_here: "scrie-ti mesajul aici",
    messages_product_sold: "Acest produs este vândut sau eliminat",
    seen: "Văzut",
    messages_never_miss_message: "Nu pierdeți niciodată un mesaj",
    enable: "Permite",
    send_notify: "Trimiteți notificare",
    un_close: "Declanșează",
    type_your_review: "Introduceți recenzia dvs.",
    again_question: "Din nou?",
    ratings_already_submitted_review: "Ați trimis deja revizuirea",
    set_product_category: "Setați categoria de produse",
    auth_email_password_incorrect: "E-mailul sau parola dvs. sunt incorecte",
    auth_insert_your_name: "Introduceți numele dvs.",
    auth_email_address_badly: "Adresa de e-mail este formatată prost",
    auth_email_address_used:
      "Adresa de e-mail este deja utilizată de un alt cont",
    auth_invalid_password: "Parola ar trebui să fie de cel puțin 6 caractere",
    auth_reset_email:
      "Introduceți adresa dvs. de e-mail pentru a reseta parola",
    auth_check_email:
      "Vă rugăm să verificați adresa de e-mail pentru a reseta parola",
    auth_can_sign_in_google: "Puteți să vă conectați cu butonul Google",
    auth_do_not_have_account: "Nu aveți un cont?",
    auth_have_account: "Aveți un cont?",
    log_terms_privacy_part1:
      "Prin înscrierea sau conectarea, sunteți de acord cu listat de mine",
    boost_this_product: "Îmbunătățiți acest produs?",
    product_successfully_boosted: "Produsul a fost amplificat cu succes",
    product_failed_boost: "Produsul a fost eșuat în creștere",
    no_products_for_sale:
      "În prezent, nu aveți produse utilizate pentru vânzare.",
    not_sold_listed_near_me: "Nu l-am vândut pe listate lângă mine",
    agree_add_product:
      "Prin atingerea postului pentru a vă publica produsul, sunteți de acord cu listați Termeni de utilizare și politica de confidențialitate.",
    click_to_boost: "Faceți clic pe produs pentru ao sporia",
    listed_terms_of_service: "Enumerate în apropierea mea Termeni de utilizare",
    receive_emails_for_users:
      "Primiți e-mailuri pentru mesajele utilizatorilor",
    receive_emails_for_newly_posted:
      "Primiți e-mailuri pentru produsele dvs. noi postate",
    disable_push_notifications: "Dezactivați notificările Push",
    sms_during_day: "Primiți SMS în timpul zilei",
    sms_24_hours: "Primiți SMS 24 de ore",
    products: "Produse",
    product_no_longer_available:
      "Ne pare rău, acest produs nu mai este disponibil",
    add_home: "Adăugați acasă",
    edit_home: "Editați acasă",
    fill_required_fields: "Completați toate câmpurile obligatorii",
    no_notification: "Nu există notificări",
    orders_history: "Obligă Istoric",
    privacy: "Confidențialitate",
    terms: "Termeni",
    report_a_problem: "Raporteaza o problema",
    approximation_protect_user_privacy:
      "Aproximare pentru a proteja confidențialitatea utilizatorului",
    do_not_have_products: "Nu aveți produse",
    emails: "E-mailuri",
    lead_deletion_products:
      "Acest lucru va duce la ștergerea tuturor produselor dvs.",
    confirm_legal_message:
      "Sunteți singurul responsabil pentru luarea tuturor precauțiilor necesare atunci când interacționați cu ceilalți, în special atunci când întâlniți un străin personal pentru prima dată. Vă rugăm să revizuiți termenii de utilizare pentru mai multe detalii.",
    push_notifications_notified_instantly:
      "Activați notificările push pentru a fi notificate instantaneu",
    rate_seller: "Evaluați vânzătorul",
    user_journey: "Călătoria utilizatorului",
    user: "Utilizator",
    user_id: "ID-ul de utilizator",
    action_id: "ID-ul de acțiune",
    select_model_car: "Selectați modelul mașinii",
    boost_1_day: "Boost 1 zi",
    boost_3_days: "BOOST 3 zile",
    boost_7_days: "Boost 7 zile",
    agree_boost_terms: "Prin atingerea impulsului, sunteți de acord",
    add: "Adăuga",
    add_tag: "Adaugă etichetă",
    brand_title: "Marca",
    category_mobiles: "Mobiles.",
    category_tablets: "Tablete",
    screen_size: "Marimea ecranului",
    has_cellular_capability: "Are capacitatea celulară",
    default_internal_memory: "Memorie interna",
    network_carrier: "Carrier de rețea",
    is_unlocked: "Este deblocată",
    mobile_model_warning: "Selectați mai întâi marca",
    missing_image: "Imaginea lipsă, încercați să adăugați din nou imaginea.",
    add_mobile: "Adăugați mobilul",
    edit_mobile: "Editați mobilul",
    add_tablet: "Adăugați tabletă",
    edit_tablet: "Editați comprimatul",
    keywords:
      "Cumpărături, cumpărare, vânzare, face bani, comerț, localnici, vecini, auto, vehicule",
    country: "Țară",
    phone_number: "Numar de telefon",
    verification_code: "Cod de verificare",
    error_occurred: "A apărut o eroare, încercați din nou mai târziu",
    invalid_state:
      "Starea nevalidă: a fost primit un apel de conectare, dar nu a fost trimisă nicio cerere de autentificare.",
    sign_in: "Loghează-te",
    sign_in_apple: "Conectați-vă cu Apple",
    sign_in_google: "Conectați-vă cu Google",
    sign_in_phone: "Conectați-vă cu telefonul",
    sign_in_facebook: "Logheaza-te cu Facebook",
    create_account: "Creează un cont",
    email: "E-mail",
    invalid_field: "Completați câmpurile obligatorii",
    code_sent: "Codul a fost trimis prin SMS",
    verify_number: "Verificați numărul de telefon",
    tapping_verify_number:
      "Prin atingerea (verificați numărul de telefon), este trimis un SMS.",
    email_exists:
      "Contul există deja și trebuie să îl accesați prin intermediul butonului Google, butonul Facebook sau butonul Apple",
    ok: "Bine",
    sure_back: "Ești sigur că te întorci?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "în urmă",
    add_model: "Adăugați un model",
    no_search_results_us:
      "Fără rezultate de căutare lângă tine la 120 de mile. Încercați să schimbați filtrul de căutare sau cuvântul cheie de căutare.",
    no_search_results:
      "Nu există rezultate de căutare în apropierea dvs. la 200 km. Încercați să schimbați filtrul de căutare sau cuvântul cheie de căutare.",
    plan_date: "Data planului",
    plan_time: "Timpul planului",
    invalid_plan_date:
      "Data planului nevalid, vă rugăm să setați din nou data planului",
    invalid_plan_time:
      "Timp de plan nevalid, vă rugăm să setați din nou planul",
    plan_name: "Numele planului",
    plan_title: "Plan",
    update_plan_name: "Actualizați numele planului",
    delete_plan_question: "Ești sigur că vrei să ștergi acest plan?",
    plan_reminder_message: "Vi se va reaminti cu o oră înainte",
    plan_dialog_title: "Plan de întâlnire",
    planners_title: "Planificatori",
    unable_sending_messages: "Îți vor vedea mesajele când vor reveni online.",
    its_text: "este",
    for_your_text: "pentru receptorul tău.",
  },
  ru: {
    invalid_area: "Неверная область, пожалуйста, установите область снова.",
    invalid_lot_size:
      "Неверный размер свойств, пожалуйста, установите размер лота снова.",
    property_area: "Область недвижимости",
    app_store_name:
      "Перечисленные рядом со мной - купите использованные предметы, продайте за наличные",
    app_store_short:
      "Рынок для местных продавцов. Перечислите товар на продажу и зарабатывайте деньги.",
    app_store_full:
      "Перечисленные рядом со мной позволяют легко найти большие предложения по тому, что вы хотите, и зарабатывайте деньги на вещах, которые вы хотите продать. Это лучший способ покупать и продавать в вашем сообществе или районе с людьми, которых вы можете доверять. Как это работает: 1- купить или продать что-нибудь; Легко размещать свои товары на продажу в считанные секунды. 2- Найдите отличные скидки и скидки на одежду, мебель, сотовые телефоны, электроника, детские и детские товары, спортивное оборудование, подержанные автомобили, платья, обувь и часы, в книги, использованные игрушки, использованные ноутбуки, подержанный автомобиль и даже реальный недвижимость на продажу или аренду. 3- Просматривайте местные предметы на продажу. 4- Сообщения покупатели и продавцы из приложения. 5- просматривать предметы по изображению и сортируйте по категориям. Веселые факты о перечисленных рядом со мной: 1- С перечисленными рядом со мной вы можете легко продать, от одежды на подержанные автомобили к электронике. 2- Связь между покупателями и продавцами происходит через приложение через обмен сообщениями. 3- перечисленные рядом со мной лучше, чем продажа гаража; Найдите все, что вы хотите со скидкой, прямо на вашем телефоне или планшете.",
    app_store_release:
      "Перечислены рядом со мной - торговля с местными жителями. Присоединяйтесь к мобильному рынку для местных покупателей и продавцов!",
    app_name: "Перечислены рядом со мной",
    title_buy: "Купить",
    title_messages: "Сообщения",
    title_sell: "Продавать",
    title_profile_image: "Изображение профиля",
    title_account: "Счет",
    account_settings: "Настройки аккаунта",
    settings: "Настройки",
    color_theme: "Цветная тема",
    device_settings: "Настройки устройства",
    public_profile: "Общедоступный профиль",
    light_mode: "Световой режим",
    dark_mode: "Темный режим",
    title_sell_faster: "Продавать быстрее",
    send_button_label: "Отправлять",
    rate_message: "Оцени меня...",
    already_rated: "Вы уже отправили отзыв",
    rate_review_question: "Хотели бы вы иметь дело с",
    again: "снова?",
    action_logout: "Выйти",
    action_category: "Категория",
    action_search: "Поиск",
    action_refer: "Приведи друга",
    dialog_choose_location: "Выберите местоположение",
    dialog_change_username: "Изменение имени пользователя",
    dialog_change_language: "Изменить язык",
    dialog_image_tags: "Теги изображения",
    dialog_emails_notifications: "Письма уведомления",
    dialog_push_notifications: "Всплывающие напоминания",
    fragment_product_detail: "Информация о продукте",
    fragment_message_details: "Сообщения детали",
    fragment_sell: "Продавать",
    dialog_tags_title: "Теги",
    dialog_location_title: "Обновить местоположение",
    dialog_username_title: "Изменение имени пользователя",
    tab_photo: "Фото",
    tab_details: "Подробности",
    tab_price: "Цена",
    tab_finish: "Заканчивать",
    profile: "Профиль",
    search: "Поиск",
    choose_product: "Выберите продукт",
    rating_review: "Рейтинг и обзор",
    select_buyer: "Выберите покупателю",
    tab_my_used_products: "Мои продукты",
    price_label: "Цена",
    text_savings: "Вы сэкономите",
    search_hint: "Поиск продуктов ...",
    empty_text:
      "В этой категории нет продуктов, указанных в этой категории или на выбранном расстоянии.",
    filter_menu_text: "Фильтр",
    error_contacting_seller: "Ошибка, связаться с продавцом",
    edit_product: "Редактировать продукт",
    contact_seller: "Связаться с продавцом",
    signup_to_contact_seller: "Чтобы связаться с продавцом",
    signup_to_make_offer: "Зарегистрируйтесь, чтобы сделать предложение",
    product_details: "Подробности",
    product_category: "Категория",
    product_condition: "Состояние",
    product_description: "Описание",
    product_location: "Местоположение продукта",
    product_location_approximate: "Расположение приблизительно",
    over_week_time_ago: "Более недели назад",
    boosted: "Повыситься",
    threads_no_results: "Нет сообщений",
    message_no_results: "Нет сообщений",
    message_warning:
      "Вы несете единоличную ответственность за принятие всех необходимых мер предосторожности при взаимодействии с другими, особенно при первом встрече с незнакомцем. Пожалуйста, не делитесь какой -либо личной информацией, кодами проверки или какой -либо платежной информации. Пожалуйста, просмотрите условия обслуживания для получения более подробной информации.",
    message_block:
      "Вы не можете отправлять или получать сообщения в это время.",
    select_location: "Выберите местоположение",
    location_permission_denied_message:
      "Приложение требует разрешения на местоположение на работу правильно.",
    signed_in: "Зарегистрирован!",
    sign_in_canceller: "Войти в отмену",
    version: "Версия",
    build: "Строить",
    name: "Имя",
    location: "Место расположения",
    language: "Язык",
    about_app: "О перечисленных рядом со мной",
    terms_of_service: "Условия использования",
    privacy_policy: "Политика конфиденциальности",
    report_feedback: "Отправить отзыв",
    report_bug: "Встряхните телефон, чтобы сообщить об ошибке",
    change_image: "Изменить изображение",
    update_location: "Обновить местоположение",
    about_the_app: "О приложении",
    update_label: "Обновлять",
    uploading: "Загрузка",
    adding: "Добавление листинга",
    removing: "Удаление листинга",
    updating: "Обновление листинга",
    uploaded_image: "Загруженное изображение:",
    image_storage_failed: "Не удалось хранить изображение:",
    product_updated: "Продукт обновлен успешно",
    location_error: "Расположение не сохранено, пожалуйста, попробуйте еще раз",
    product_removed: "Продукт удален успешно",
    deleted_product: "Этот продукт удален",
    invalid_title:
      "Неверный заголовок, пожалуйста, установите заголовок снова.",
    invalid_image:
      "Неверный путь изображения, попробуйте добавить изображение снова.",
    invalid_price: "Неверная цена, пожалуйста, установите цену снова.",
    invalid_location:
      "Недопустимое местоположение, пожалуйста, установите местоположение снова.",
    invalid_category:
      "Недопустимая категория, пожалуйста, установите категорию снова.",
    invalid_condition:
      "Неверное состояние, пожалуйста, устанавливайте состояние снова.",
    removing_title: "Удаление изображения профиля",
    image_not_saved: "СОХРАНЕНИЕ ИЗОБРАЖЕНИЯ Не удалось!",
    product_load_failed: "Нет продуктов",
    take_photo: "Сфотографировать",
    select_photo: "Выберите фото",
    product_title_hint: "Что это? Имя, бренд, модель и др.",
    delete_photo: "Удалить фото",
    product_title: "Заголовок",
    mark_as_sold: "Марк как продал",
    product_share: "доля",
    product_make_offer: "Делать предложение",
    product_cover: "Установить как изображение крышки",
    product_tags: "Теги",
    product_posted: "Опубликовано:",
    product_change: "Изменять",
    product_post: "Почта",
    product_selling_from: "Продавать из места местоположения",
    product_select_location: "Выберите местоположение",
    product_map_approximate:
      "Карта - приблизительна для хранения местоположения продавца",
    product_terms:
      "Нажав сообщение для публикации вашего продукта, вы соглашаетесь на <u> перечислены рядом со мной Условия обслуживания. </ U>",
    condition_other: "Другое (см. Описание)",
    condition_for_parts: "На запчасти",
    condition_used: "Используется (нормальный износ)",
    condition_open_box: "Открытая коробка (никогда не используется)",
    condition_reconditioned: "Ремонт / сертифицирован",
    condition_new: "Новый (никогда не используется)",
    select_category: "выбрать категорию",
    select_all_category: "Выбрать все",
    category_loading_error:
      "Не могу обновить список категорий, пожалуйста, попробуйте позже.",
    category_vehicles: "Транспортные средства",
    category_furniture: "Мебель",
    category_electronics: "Электроника",
    category_appliances: "Домашний  Техника",
    category_fashion_accessories: "Мода &  Аксессуары",
    category_baby_kids: "Baby &  Дети",
    category_antiques_collectibles: "Antiques &  Коллекционирование",
    category_auto_parts_tools_machinery:
      "Автозапчасти, инструменты и  Машинное оборудование",
    category_sports_outdoors: "Спорт &  На открытом воздухе",
    category_others: "Другие",
    location_enter_zip_code: "Введите почтовый индекс",
    location_get_current_location: "Получить текущее местоположение",
    location_select_location: "Выберите местоположение",
    location_update_location: "Обновить местоположение",
    location_new_location: "Новое место",
    search_filter_results: "Фильтр результатов",
    search_filter_min: "Фильтр минимум",
    search_filter_at_least: "Как минимум",
    price_filter: "Цена фильтра",
    product_name: "наименование товара",
    english_language: "английский",
    arabic_language: "арабский",
    spanish_language: "испанский язык",
    system_language: "Система",
    share_link: "Поделиться ссылкой",
    save: "Сохранять",
    cancel: "Отмена",
    loading: "Загрузка",
    yes: "да",
    no: "Нет",
    report: "Отчет",
    report_product: "Отчет продукта",
    report_user: "Пожаловаться на пользователя",
    block_user: "Заблокировать пользователя",
    un_block_user: "Разблокировать пользователя",
    why_product: "Почему вы хотите сообщить об этом пункте?",
    why_user: "Почему вы хотите сообщить об этом пользователю?",
    block_user_confirm: "Вы хотите навсегда заблокировать этот пользователь?",
    un_block_user_confirm:
      "Вы хотите навсегда разблокировать этот пользователь?",
    prohibited: "Запрещено в перечисленные рядом со мной",
    offensive: "Оскорбительный или неуместный",
    duplicate: "Дублируйте пост",
    wrong_category: "Неправильная категория",
    scam: "Выглядит как мошенничество",
    stolen: "Я думаю, что это украдено",
    product_other: "Другой",
    product_is_sold: "Этот продукт был продан",
    missed_meeting: "Они пропустили нашу встречу",
    low_offer: "Сделал низкое предложение",
    rude: "Грубый или неуместный",
    items: "Проблема с предметами",
    trouble_meetup: "Беда на встрече",
    messaging: "Проблемы обмена сообщениями",
    user_other: "Другой",
    new_version_available: "Новая версия доступна",
    please_update_app:
      "Пожалуйста, обновите приложение к новой версии, чтобы продолжить.",
    update: "Обновлять",
    no_thanks: "Нет, спасибо",
    contact_support_confirmation:
      "Текущее время отклика составляет 24-48 часов. Вы хотите связаться с перечисленным рядом со мной App Chat Chat?",
    unboost_confirmation: "Вы уверены, что хотите безбусть этот продукт?",
    no_used_products: "У вас еще нет списков",
    no_boosted_products: "У вас нет повышенных продуктов",
    next: "Следующий",
    previous: "Предыдущий",
    skip: "Пропускать",
    start: "Начинать",
    list_used: "Перечислите подержанный продукт",
    buy_description:
      "Откройте для себя и поиск продуктов, предлагаемых соседями вокруг вас",
    sell_description:
      "Список продуктов, которые вам больше не нуждаются в продаже",
    list_used_description:
      "Перечислите подержанный продукт на продажу менее чем за 20 секунд",
    boost_product_option_1: "<b> BOOST 1  N9 </ B>  N  N <B> $ 0,99 </ b>",
    boost_product_option_2: "<B> BOOST 3  N9SS </ B>  N  N <B> $ 1.99 </ B>",
    boost_product_option_3: "<B> BOOST 7  N9SS </ B>  N  N <B> $ 3.99 </ B>",
    boost_product_description:
      "Получите больше просмотров каждый день. Ваш товар появится в представленных позициях в течение 30 лучших предметов в Купить и категории. Продвигаемые предметы вращаются среди обозначенных пятен, поэтому каждый элемент получает честную экспозицию.",
    boost_cta: "Продавать быстрее",
    boost_terms:
      "Нажав повышение, вы соглашаетесь на <u> перечислены рядом со мной Условия обслуживания. </ U>",
    boost_best_value: "Лучшее значение",
    already_boosted: "Этот продукт повышен",
    clicks: "Щелчок",
    impressions: "Впечатления",
    end: "Конец",
    transactions_empty_text:
      "У вас еще нет транзакций Boost. Вы можете посетить вкладку «Продам» и начните повысить ваши продукты.",
    transactions_loading_error:
      "Не могу обновить список транзакций, пожалуйста, попробуйте позже.",
    transactions_history_title: "Повышать историю транзакций",
    communicative_postive: "Коммуникативный",
    communicative_negative: "Нерешительный",
    ontime_postive: "Вовремя",
    ontime_negative: "Поздно",
    reliable_postive: "Надежный",
    reliable_negative: "Ненадежный",
    friendly_postive: "Дружелюбно",
    friendly_negative: "Неразрешительный",
    itemasdescribed_postive: "Деталь как описано",
    itemasdescribed_negative: "Предмет не как в описании",
    other: "Другой",
    submit: "Представлять на рассмотрение",
    adding_rating_reviews: "Добавление рейтинга и отзывов",
    no_internet_title: "Нет соединения с интернетом",
    no_internet_message:
      "Убедитесь, что вы подключены к Интернету и попробуйте снова",
    retry: "Повторение",
    near_me: "Рядом со мной",
    newest_first: "Новички вперед",
    miles: "мили",
    km: "км",
    similar_products: "Похожие продукты",
    favorite_products: "Любимые продукты",
    items_for_sale: "вещи на продажу",
    joined: "Присоединился",
    favorites_transactions_title: "Фавориты",
    boosted_products_transactions_history:
      "Усилившиеся продукты История транзакций",
    views: "Взгляды",
    boost_graph_title: "Повышать график",
    no_favorite_products: "У вас нет любимых продуктов",
    make_offer_buy: "Я бы хотел купить",
    make_offer_buy_for: "за",
    notifications: "Уверенность",
    push_notifications: "Толкать",
    emails_notifications: "Электронное письмо",
    apply: "Применять",
    email_messages: "Электронная почта для сообщений",
    email_new_products: "Электронная почта для новых продуктов",
    push_day_only: "Только выходные уведомления",
    push_24_hours: "Push-уведомления 24 часа",
    edit: "Редактировать",
    map: "карта",
    camera: "Камера",
    gallery: "Галерея",
    delete: "Удалить",
    no_sell_items: "Не продается",
    who_bought_question: "Кто купил это?",
    sold_elsewhere_question: "Продал его где-то еще",
    confirm: "Подтверждать",
    over_limit_camera: "Вы не можете добавить более пяти изображений",
    boost_failed: "Boost не удалось. Пожалуйста, повторите попытку позже",
    after_purchase: "Оплата успешной  nproduct усилил",
    pay_failed: "Платеж не прошел. Пожалуйста, попробуйте еще раз",
    done: "Сделанный",
    not_now: "Не сейчас",
    boost: "Способствовать росту",
    invalid_zip_code: "Неверный почтовый индекс",
    invalid_user_name: "Неверное имя пользователя",
    comments: "Комментарии",
    questions: "Вопросы",
    bug_reports: "Отчеты об ошибках",
    feature_request: "Запрос на функцию",
    feedback_type: "Тип обратной связи",
    feedback_description:
      "Мы хотели бы услышать ваши мысли или отзывы о том, как мы можем улучшить свой опыт!",
    feedback: "Обратная связь",
    feedback_text: "Ваш ответ",
    suggestions: "Предложения для улучшения",
    delete_account: "Удалить аккаунт",
    new_message: "Новое сообщение",
    online: "онлайн",
    km_50: "50 км",
    km_100: "100 км",
    km_200: "200 км",
    miles_30: "30 миль",
    miles_60: "60 миль",
    miles_120: "120 миль",
    rate_app_question: "Как насчет рейтинга в App Store, затем?",
    enjoying_question: "Наслаждаться перечисленным рядом со мной?",
    not_enjoy: "Не совсем",
    feedback_question: "Не могли бы вы дать нам некоторые отзывы?",
    yes_sure: "Да конечно",
    product_available_question: "Привет, это все еще доступно?",
    buy_question: "Привет, я хотел бы купить это",
    meet_question: "Привет, ты можешь встретиться сегодня?",
    follow: "Следовать",
    followers: "Подписчики",
    following: "Следующий",
    feedback_thanks: "Спасибо за ваш отзыв",
    all_categories: "Все категории",
    deleted_account: "Эта учетная запись удаляется",
    delete_account_question:
      "Вы уверены, что хотите удалить эту учетную запись?",
    no_followings: "не следит за кем-либо",
    when_following: "когда",
    no_followings_subtitle: "следует людям, вы увидите их здесь",
    no_followers: "не имеет последователей",
    no_followers_subtitle: "сопровождаемый людьми, вы увидите их здесь",
    distance: "Расстояние",
    filter_method: "Метод фильтра",
    see_listings: "Смотрите списки",
    sold: "Продал",
    bought: "Купила",
    no_notifications: "Когда вы получаете уведомления, они появятся здесь",
    items_title: "Предметы",
    new_listing_title: "Создать новый список",
    dialog_year_title: "Год",
    dialog_make_title: "Сделать",
    dialog_model_title: "Модель",
    dialog_body_style_title: "Тип кузова",
    dialog_exterior_color_title: "Внешний цвет",
    dialog_interior_color_title: "Цвет интерьера",
    dialog_transmission_title: "Передача инфекции",
    dialog_fuel_type_title: "Тип топлива",
    dialog_owners_num_title: "Количество владельцев",
    dialog_vehicle_owed_money_title:
      "Есть ли деньги все еще обязаны на этом автомобиле?",
    automatic_transmission: "Автоматический",
    manual_transmission: "Руководство",
    not_sure: "Точно сказать не могу",
    wagon_hatchback: "Wagon &  Хэтчбек",
    convertible: "Конвертируемый",
    coupe: "Купе",
    sedan: "Седан",
    black_color: "Чернить",
    blue_color: "Синий",
    brown_color: "коричневый",
    gold_color: "Золото",
    green_color: "Зеленый",
    grey_color: "Серый",
    pink_color: "Розовый",
    purple_color: "Фиолетовый",
    red_color: "красный",
    silver_color: "Серебряный",
    orange_color: "апельсин",
    white_color: "белый",
    yellow_color: "Желтый",
    charcol_color: "Каферот",
    fuel_diesel: "Дизель",
    fuel_electric: "Электрический",
    fuel_gasoline: "Бензин",
    fuel_flex: "Сгибаться",
    fuel_hybrid: "Гибридный",
    fuel_petrol: "Бензин",
    fuel_plugin_hybrid: "Плагин гибридный",
    truck: "Грузовик",
    van_minivan: "Van &  Minivan",
    suv_crossover: "SUV &  Кроссовер",
    awd_4wd: "AWD / 4WD",
    fwd: "Фуд",
    rwd: "Rwd.",
    off_white_color: "Белый с оттенком",
    tan_color: "Загар",
    beige_color: "Бежевый",
    burgundy_color: "Бургундия",
    turquoise_color: "Бирюзовый",
    title_status_clean: "Чистый",
    title_status_rebuilt: "Перестроить",
    title_status_salvage: "Спасение",
    title_status_missing: "Отсутствует",
    title_status_lien: "Лиен",
    title_status: "Заголовок состояния",
    mileage: "Пробег",
    dialog_drivetrain_title: "Трансмиссия",
    model_warning: "Пожалуйста, выберите «Сделать сначала»",
    required_field_warning: "Это поле обязательно к заполнению",
    vehicle_vin: "Вин",
    invalid_vin: "Неверный VIN, пожалуйста, снова установите VIN.",
    invalid_mileage: "Неверный пробег, пожалуйста, поставите пробег снова.",
    clean_description:
      "Большинство транспортных средств, которые не были в аварии",
    rebuilt_description: "Спасенная машина, которая была восстановлена",
    salvage_description: "Считается в составе после аварии",
    missing_description: "Понадобится новый заголовок вопросов DMV",
    lien_description: "Принадлежит банку или урегулированию суда",
    nearme: "Рядом со мной",
    newest: "Новейший",
    contact_support: "Контактная поддержка",
    create_home_title: "Дома для продажи или аренды",
    for_sale: "Продается",
    for_rent: "В аренду",
    property_type: "Тип недвижимости",
    apartment: "Квартира",
    house: "дом",
    room_only: "Только номер",
    townhouse: "Таунхаус",
    bedrooms: "Спальни",
    bathrooms: "Ванные комнаты",
    property_address: "Адрес недвижимости",
    price_per_month: "Цена за месяц",
    square_feet: "Квадратный фут",
    year_built: "Год постройки",
    year_renovated: "Год отремонтирован",
    lot_size: "Объем партии",
    laundry_type: "Прачечная типа",
    in_unit_laundry: "В единицу белья",
    laundry_building: "Прачечная в здании",
    laundry_available: "Доступна прачечная",
    none: "Никто",
    parking_type: "Тип парковки",
    garage_parking: "Гаражная парковка",
    street_parking: "Уличная парковка",
    off_street_parking: "Парковка без улицы",
    available_parking: "Парковка доступна",
    air_cond_type: "Тип кондиционера",
    ac_available: "Доступный доступ",
    central_ac: "Центральный AC.",
    heating_type: "Тип нагрева",
    electric_heating: "Электрическое отопление",
    gas_heating: "Газовое отопление",
    radiator_heating: "Радиатор отопление",
    available_heating: "Доступно нагревание",
    amenities: "Удобства",
    date_available: "Доступная дата",
    lease_length: "Длина аренды",
    month_to_month: "Месяц до месяца",
    three_months: "3 месяца",
    six_months: "6 месяцев",
    one_year: "1 год",
    more_one_year: "1+ лет",
    cat_friendly: "Кот дружелюбный",
    dog_friendly: "Собака дружелюбна",
    balcony: "Балкон",
    basement: "Подвал",
    bike_parking: "Парковка на велосипеде",
    cable_tv: "Кабельное ТВ",
    ceiling_fan: "Потолочный вентилятор",
    concierge: "Консьерж",
    dishwasher: "Посудомоечная машина",
    doorman: "Швейцар",
    elevator: "Лифт",
    fireplace: "Камин",
    fitness_center: "Фитнес-центр",
    garbage_disposal: "Вывоз мусора",
    microwave: "Микроволновая печь",
    online_app: "Онлайн-заявка",
    oven: "Духовой шкаф",
    package_service: "Пакетная служба",
    patio: "Внутренний дворик",
    pet_park: "Pet Park",
    refrigerator: "Холодильник",
    resident_lounge: "Жительский лаундж",
    roof_deck: "Колода крыши",
    secured_entry: "Защищенная запись",
    storage: "Место хранения",
    walk_in_closet: "Гардеробная",
    swimming_pool: "Плавательный бассейн",
    wheelchair_access: "Аксес для инвалидных колясок",
    central_heating: "Центральное отопление",
    invalid_bedrooms:
      "Недопустимые спальни, пожалуйста, установите спальни снова.",
    invalid_bathrooms:
      "Недопустимые ванные комнаты, пожалуйста, установите ванные комнаты снова.",
    chinese_simplified_language: "Китайский упрощенный",
    chinese_traditional_language: "Китайский традиционный",
    czech_language: "чешский язык",
    danish_language: "Датский",
    dutch_language: "нидерландский язык",
    finnish_language: "Финский",
    french_language: "Французский",
    german_language: "Немецкий",
    greek_language: "Греческий",
    hungarian_language: "Венгерский",
    indonesian_language: "индонезийский",
    italian_language: "Итальянский",
    japanese_language: "японский язык",
    korean_language: "корейский язык",
    norwegian_language: "Норвежский",
    polish_language: "Польский",
    portuguese_language: "португальский",
    portuguese_brazilian_language: "Португальский, бразильский",
    romanian_language: "румынский",
    russian_language: "русский",
    swedish_language: "Шведский язык",
    turkish_language: "турецкий",
    ukrainian_language: "украинец",
    urdu_pakistan_language: "Урду (Пакистан)",
    vietnamese_language: "вьетнамский",
    category_home_sale_or_rent: "Домой на продажу или аренду",
    square_meter: "Квадратный метр",
    copy_text: "Скопировать",
    copyied_to_clipboard: "Скопирован в буфер обмена",
    inbox: "Входящие",
    input_title_listening: "Слушать ...",
    input_subtitle_listening: "Скажите что-то",
    input_title_error: "Извините, мы не совсем не получили этого.",
    input_subtitle_error: "Попробуйте повторить ваш запрос.",
    input_hint_error: "Попробуй снова",
    price_less_than_or_equal: "Цена меньше или равна",
    any_price: "Любая цена",
    any_condition: "Любое состояние",
    any_time: "В любой момент",
    days_ago: "дней назад",
    any_distance: "Любое расстояние",
    distance_within: "Расстояние внутри",
    new_notification: "Новое уведомление",
    deleted: "Удаленный",
    processing_image: "Обработка изображения",
    remove_dialog_message: "Вы действительно хотите удалить этот продукт?",
    deleted_thread: "Это сообщение удалено",
    category_yard_sale_event: "Событие продажи двора",
    yard_first_date: "Двор продажи первого свидания",
    yard_second_date: "Двор продажи второго свидания",
    yard_third_date: "Двор продажи третьего свидания",
    yard_start_time: "Начальное время",
    yard_end_time: "Время окончания",
    yard_end_timestamp: "Конец времени",
    invalid_date1:
      "Неверная первая дата, пожалуйста, установите первый день снова",
    invalid_start_time:
      "Неверное время начала, пожалуйста, установите время начала снова",
    invalid_end_time:
      "Неверное время окончания, пожалуйста, установите время окончания",
    yard_sale_title: "Распродажа домашнего имущества",
    garage_tag: "гараж",
    yard_tag: "площадка",
    from: "От",
    to: "К",
    block: "Блокировать",
    un_block: "Разблокировать",
    sign_email: "Войти с электронной почтой",
    invalid_first_date:
      "Неверная первая дата, пожалуйста, убедитесь, что первая дата до секунды и третьего",
    invalid_second_date:
      "Неверная вторая дата, пожалуйста, убедитесь, что вторая дата до третьего свидания",
    invalid_start_time_value:
      "Неверное время начала, пожалуйста, убедитесь, что время начала до окончания времени",
    use_default_yard_photo: "Используйте по умолчанию двор продажи фото",
    active_label: "Активный",
    enable_notifications: "Включить уведомления",
    login: "Авторизоваться",
    january: "Январь",
    february: "Февраль",
    march: "марш",
    april: "апрель",
    may: "Мая",
    june: "июнь",
    july: "июль",
    august: "август",
    september: "сентябрь",
    october: "Октябрь",
    november: "Ноябрь",
    december: "Декабрь",
    since: "С",
    product_views: "Просмотры продукта",
    shop_views: "Магазин просмотров",
    total_sales: "Тотальная распродажа",
    total_orders: "Общие заказы",
    last_twelvth_months: "Последние двенадцатые месяцы",
    last_nine_months: "Последние девять месяцев",
    last_six_months: "Последние шесть месяцев",
    last_three_months: "Последние три месяца",
    last_12_months: "Последние 12 месяцев",
    last_9_months: "Последние 9 месяцев",
    last_6_months: "Последние 6 месяцев",
    last_3_months: "Последние 3 месяца",
    months: "Месяцы",
    open: "Открытым",
    reset_password: "Сброс пароля",
    create_new_shop: "Создать новый магазин",
    download_app: "Скачать приложение",
    log_in: "Авторизоваться",
    sign_up: "Зарегистрироваться",
    no_result: "Безрезультатно",
    max_price: "Макс цена",
    max_distance: "Максимальное расстояние",
    max_time: "Максимальное время",
    posted_less_than: "Размещены меньше",
    result: "Результат",
    more: "Более",
    or: "ИЛИ",
    password: "Пароль",
    forgot_password: "Забыли пароль?",
    and: "и",
    download_for: "Загрузка",
    apple_ios: "Apple IOS.",
    android: "Андроид",
    image: "Изображение",
    edit_image: "Редактировать изображение",
    please_complete: "Пожалуйста завершите",
    enter_your_offer: "Введите ваше предложение",
    categories: "Категории",
    upload_image: "Загрузить изображение",
    upload_images: "Загрузить изображения",
    back: "Назад",
    see_more: "Узнать больше",
    add_product: "Добавить товар",
    selected: "Выбранный",
    create: "Создавать",
    rate_the_buyer: "Оцените покупателя",
    delete_product: "Удалить продукт",
    product: "Продукт",
    un_block_product: "Разблокировать продукт",
    share_your_product: "Поделитесь своим продуктом",
    boost_details: "Подробнее",
    remove_all_products: "Удалить все продукты",
    remove_all: "Убрать все",
    add_vehicle: "Добавить автомобиль",
    edit_vehicle: "Редактировать автомобиль",
    upload_a_photo: "Загрузить фото",
    view_details: "Посмотреть детали",
    add_yard_sale: "Добавить дворов продажи",
    edit_yard_sale: "Редактировать Двор продажи",
    users: "Пользователи",
    users_details: "Подробности пользователей",
    users_by_country: "Пользователи по стране",
    blocked_users: "Заблокированные пользователи",
    products_cards: "Карты продуктов",
    archived_products: "Архивная продукция",
    blocked_products: "Заблокированные продукты",
    products_by_country: "Продукты по стране",
    reports: "Отчет",
    reports_details: "Детали сообщений",
    closed_reports: "Закрытые отчеты",
    threads: "Потоки",
    threads_details: "Подробности потоков",
    chat_support: "Поддержка чата",
    actions: "Действия",
    search_actions: "Поиск действий",
    product_view_actions: "Просмотр продукта Действия",
    contact_seller_product: "Связаться с продавцом Продукт",
    contact_owner_shop: "Как связаться с владельцем магазина",
    ratings: "Рейтинги",
    reviews: "Отзывы",
    products_all_countries: "Продукты Все страны",
    edit_profile: "Редактировать профиль",
    my_profile: "Мой профайл",
    profile_updated_successfully: "Профиль обновлен успешно",
    are_you_sure: "Уверены ли вы",
    my_used_products: "Мои подержанные продукты",
    my_shops: "Мои магазины",
    my_boosted_products: "Мои усиленные продукты",
    messages_type_message_here: "Пишите ваше сообщение здесь",
    messages_product_sold: "Этот продукт продан или удален",
    seen: "Видимый",
    messages_never_miss_message: "Никогда не пропустите сообщение",
    enable: "Давать возможность",
    send_notify: "Отправить уведомление",
    un_close: "Неловко",
    type_your_review: "Введите свой отзыв",
    again_question: "снова ?",
    ratings_already_submitted_review: "Вы уже отправили отзыв",
    set_product_category: "Установить категорию продукта",
    auth_email_password_incorrect:
      "Ваше электронное письмо или пароль неверный",
    auth_insert_your_name: "Пожалуйста, введите свое имя",
    auth_email_address_badly: "Адрес электронной почты плохо отформатирован",
    auth_email_address_used:
      "Адрес электронной почты уже используется другой учетной записью",
    auth_invalid_password: "Пароль должен быть не менее 6 символов",
    auth_reset_email: "Введите Ваш электронный адрес, чтобы сбросить пароль",
    auth_check_email:
      "Пожалуйста, проверьте свою электронную почту, чтобы сбросить пароль",
    auth_can_sign_in_google:
      "Вы можете войти в систему с помощью кнопки Google",
    auth_do_not_have_account: "У вас нет учетной записи?",
    auth_have_account: "У тебя есть аккаунт?",
    log_terms_privacy_part1:
      "Подписываясь или войдете в систему, вы соглашаетесь на перечисленные рядом со мной",
    boost_this_product: "Повысить этот продукт?",
    product_successfully_boosted: "Продукт был успешно усилен",
    product_failed_boost: "Продукт был неудачным в повышении",
    no_products_for_sale:
      "В настоящее время у вас нет используемых продуктов, перечисленных на продажу.",
    not_sold_listed_near_me: "Я не продал его в перечисленные рядом со мной",
    agree_add_product:
      "Нажав сообщение для публикации вашего продукта, вы соглашаетесь с указанным рядом со мной Условия обслуживания и Политика конфиденциальности.",
    click_to_boost: "Нажмите на продукт, чтобы увеличить его",
    listed_terms_of_service: "Перечислены рядом со мной Условия обслуживания",
    receive_emails_for_users: "Получить электронные письма для пользователей",
    receive_emails_for_newly_posted:
      "Получить электронные письма для ваших недавно опубликованных продуктов",
    disable_push_notifications: "Отключить Push-уведомления",
    sms_during_day: "Получать смс в течение дня",
    sms_24_hours: "Получать SMS 24 часа",
    products: "Продукты",
    product_no_longer_available: "Извините, этот продукт больше недоступен",
    add_home: "Добавить домой",
    edit_home: "Редактировать домой",
    fill_required_fields: "Заполните все необходимые поля",
    no_notification: "Нет уведомлений",
    orders_history: "История заказов",
    privacy: "Конфиденциальность",
    terms: "Условия",
    report_a_problem: "Сообщить о проблеме",
    approximation_protect_user_privacy:
      "Приближение для защиты конфиденциальности пользователя",
    do_not_have_products: "У вас нет продуктов",
    emails: "Электронные письма",
    lead_deletion_products: "Это приведет к удалению всех ваших продуктов",
    confirm_legal_message:
      "Вы несете исключительно за принятие всех необходимых мер предосторожности при взаимодействии с другими, особенно при встрече с незнакомцем лично. Пожалуйста, просмотрите Условия обслуживания для более подробной информации.",
    push_notifications_notified_instantly:
      "Включите толкающие уведомления, которые будут уведомлены мгновенно",
    rate_seller: "Оценить Продавец",
    user_journey: "Пользовательское путешествие",
    user: "Пользователь",
    user_id: "Идентификатор пользователя",
    action_id: "Действие ID.",
    select_model_car: "Выберите модель автомобиля",
    boost_1_day: "Повысить 1 день",
    boost_3_days: "Повысить 3 дня",
    boost_7_days: "Повысить 7 дней",
    agree_boost_terms: "Нажав повышение, вы соглашаетесь",
    add: "Добавлять",
    add_tag: "Добавить метку",
    brand_title: "Марка",
    category_mobiles: "Мобильные телефоны",
    category_tablets: "Таблетки",
    screen_size: "Размер экрана",
    has_cellular_capability: "Имеет клеточную способность",
    default_internal_memory: "Внутренняя память",
    network_carrier: "Сетевой перевозчик",
    is_unlocked: "Разблокирован",
    mobile_model_warning: "Пожалуйста, выберите бренд первым",
    missing_image:
      "Отсутствующее изображение, попробуйте добавить изображение снова.",
    add_mobile: "Добавить мобильный",
    edit_mobile: "Редактировать мобильный",
    add_tablet: "Добавить планшет",
    edit_tablet: "Редактировать планшет",
    keywords:
      "покупки, покупка, продавать, зарабатывать деньги, торговля, местные жители, соседи, авто, транспортные средства",
    country: "Страна",
    phone_number: "Телефонный номер",
    verification_code: "Проверочный код",
    error_occurred: "Произошла ошибка. Пожалуйста, повторите попытку позже",
    invalid_state:
      "Неверное состояние: был получен обратный вызов входа, но запрос входа не был отправлен.",
    sign_in: "Войти",
    sign_in_apple: "Войдите с Apple",
    sign_in_google: "Войти с Google",
    sign_in_phone: "Войдите с телефоном",
    sign_in_facebook: "Авторизоваться с помощью Фэйсбука",
    create_account: "Завести аккаунт",
    email: "Эл. адрес",
    invalid_field: "Пожалуйста, заполните обязательные поля",
    code_sent: "Код был отправлен SMS",
    verify_number: "Проверьте номер телефона",
    tapping_verify_number:
      "Нажав (проверяйте номер телефона), будут отправлены смс.",
    email_exists:
      "Учетная запись уже существует, и вам нужно получить доступ через кнопку Google, кнопку Facebook или кнопку Apple",
    ok: "В порядке",
    sure_back: "Вы уверены, что вернусь?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "тому назад",
    add_model: "Добавить модель",
    no_search_results_us:
      "Нет результатов поиска рядом с вами в течение 120 миль. Попробуйте изменить фильтр поиска или поиск ключевого слова.",
    no_search_results:
      "Нет результатов поиска рядом с вами в пределах 200 км. Попробуйте изменить фильтр поиска или поиск ключевого слова.",
    plan_date: "Планируйте дату",
    plan_time: "Время планирования",
    invalid_plan_date:
      "Неверная дата плана, пожалуйста, установите дату плана еще раз",
    invalid_plan_time:
      "Неверное время плана, пожалуйста, установите время плана снова",
    plan_name: "Планируйте имя",
    plan_title: "План",
    update_plan_name: "Обновите имя плана",
    delete_plan_question: "Вы уверены, что хотите удалить этот план?",
    plan_reminder_message: "Вам напомнит за час до",
    plan_dialog_title: "План встречи",
    planners_title: "Планировщики",
    unable_sending_messages:
      "Они увидят ваши сообщения, когда вернутся в Интернет.",
    its_text: "Это",
    for_your_text: "для вашего приемника.",
  },
  "sv-SE": {
    invalid_area: "Ogiltigt område, vänligen sätt igen.",
    invalid_lot_size: "Ogiltig egendomsresor, vänligen sätt in mycket storlek.",
    property_area: "Fastighetsområde",
    app_store_name:
      "Listad nära mig - Köp begagnade föremål, sälja för kontanter",
    app_store_short:
      "En marknadsplats för lokala säljare. Lista ett föremål till salu och tjäna pengar.",
    app_store_full:
      "Listad nära mig gör det enkelt att hitta bra erbjudanden på de saker du vill ha och tjäna pengar på de saker du vill sälja. Detta är det bästa sättet att köpa och sälja i ditt samhälle eller grannskap med personer du kan lita på. Hur det fungerar: 1- Köp eller sälja någonting; Skriv enkelt dina föremål till salu på några sekunder. 2- hitta bra erbjudanden och rabatter på kläder, möbler, mobiltelefoner, elektronik, bebis och barn, sportutrustning, begagnade bilar, klänningar, skor och klockor, till böcker, begagnade leksaker, begagnade bärbara datorer, en begagnad bil och till och med riktigt Estate till salu eller hyra. 3- Bläddra lokala föremål till salu. 4- Meddelande köpare och säljare från appen. 5- Bläddra på objekt med bild och sortera efter kategori. Roliga fakta om listade nära mig: 1- Med listade nära mig kan du enkelt sälja någonting, från kläder till begagnade bilar till elektronik. 2- Kommunikation mellan köpare och säljare sker genom appen via meddelanden. 3- Listad nära mig är bättre än en garageförsäljning; Hitta allt du vill ha i rabatt, precis på din telefon eller surfplatta.",
    app_store_release:
      "Listad nära mig - handel med lokalbefolkningen. Gå med i mobilmarknaden för lokala köpare och säljare!",
    app_name: "Listad nära mig",
    title_buy: "köpa",
    title_messages: "Meddelanden",
    title_sell: "Sälja",
    title_profile_image: "Profilbild",
    title_account: "konto",
    account_settings: "Kontoinställningar",
    settings: "inställningar",
    color_theme: "Färgtema",
    device_settings: "Enhetsinställningar",
    public_profile: "Allmän profil",
    light_mode: "Ljusläge",
    dark_mode: "Mörkt läge",
    title_sell_faster: "Sälja snabbare",
    send_button_label: "Skicka",
    rate_message: "Betygsätt mig...",
    already_rated: "Du har redan lämnat in Recension",
    rate_review_question: "Vill du hantera",
    again: "om igen?",
    action_logout: "Logga ut",
    action_category: "Kategori",
    action_search: "Sök",
    action_refer: "Hänvisa till en vän",
    dialog_choose_location: "Välj plats",
    dialog_change_username: "Ändra användarnamn",
    dialog_change_language: "Ändra språk",
    dialog_image_tags: "Bildetiketter",
    dialog_emails_notifications: "E-postmeddelanden",
    dialog_push_notifications: "Pushmeddelanden",
    fragment_product_detail: "Produktdetalj",
    fragment_message_details: "Meddelanden Detalj",
    fragment_sell: "Sälja",
    dialog_tags_title: "Tagg",
    dialog_location_title: "Uppdatera plats",
    dialog_username_title: "Ändra användarnamn",
    tab_photo: "Foto",
    tab_details: "Detaljer",
    tab_price: "Pris",
    tab_finish: "Avsluta",
    profile: "Profil",
    search: "Sök",
    choose_product: "Välj produkt",
    rating_review: "Betygsättning och recension",
    select_buyer: "Välj en köpare",
    tab_my_used_products: "Mina produkter",
    price_label: "Pris",
    text_savings: "Du sparar",
    search_hint: "Sök efter produkter ...",
    empty_text:
      "Det finns inga produkter som anges i den här kategorin eller inom det valda avståndet.",
    filter_menu_text: "Filtrera",
    error_contacting_seller: "Fel på kontakt med säljaren",
    edit_product: "Redigera produkt",
    contact_seller: "Kontakta säljaren",
    signup_to_contact_seller: "Registrera dig för att kontakta säljaren",
    signup_to_make_offer: "Registrera dig för att göra erbjudande",
    product_details: "Detaljer",
    product_category: "Kategori",
    product_condition: "Skick",
    product_description: "Beskrivning",
    product_location: "Produktplats",
    product_location_approximate: "Platsen är ungefärlig",
    over_week_time_ago: "Över en vecka sedan",
    boosted: "Ökad",
    threads_no_results: "Inga meddelanden",
    message_no_results: "Inga meddelanden",
    message_warning:
      "Du är ensam ansvarig för att vidta alla nödvändiga försiktighetsåtgärder när du interagerar med andra, särskilt när du möter en främling personligen för första gången. Dela inte någon personlig information, verifieringskoder eller någon betalningsinformation. Vänligen granska användarvillkoren för mer information.",
    message_block: "Du kan inte skicka eller ta emot meddelanden just nu.",
    select_location: "Välj plats",
    location_permission_denied_message:
      "Appen kräver platsbehörighet att fungera korrekt.",
    signed_in: "Inloggad!",
    sign_in_canceller: "Logga in avbruten",
    version: "Version",
    build: "Bygga",
    name: "namn",
    location: "Plats",
    language: "Språk",
    about_app: "Om listade nära mig",
    terms_of_service: "Användarvillkor",
    privacy_policy: "Integritetspolicy",
    report_feedback: "Skicka synpunkter",
    report_bug: "Skaka telefon för att rapportera en bugg",
    change_image: "Ändra bild",
    update_location: "Uppdatera plats",
    about_the_app: "Om appen",
    update_label: "Uppdatering",
    uploading: "Uppladdning",
    adding: "Lägga till listning",
    removing: "Ta bort listning",
    updating: "Uppdatering av notering",
    uploaded_image: "Uppladdad bild:",
    image_storage_failed: "Misslyckades med att lagra bild:",
    product_updated: "Produkt uppdaterad framgångsrikt",
    location_error: "Platsen sparad, försök igen",
    product_removed: "Produkten togs bort framgångsrikt",
    deleted_product: "Denna produkt raderas",
    invalid_title: "Ogiltig titel, vänligen ange titel igen.",
    invalid_image: "Ogiltig bildväg, försök Lägg till bild igen.",
    invalid_price: "Ogiltigt pris, vänligen sätt igen.",
    invalid_location: "Ogiltig plats, vänligen ställ in plats igen.",
    invalid_category: "Ogiltig kategori, vänligen ange kategori igen.",
    invalid_condition: "Ogiltigt skick, vänligen sätt villkor igen.",
    removing_title: "Ta bort profilbild",
    image_not_saved: "Bild Spara misslyckades!",
    product_load_failed: "Inga produkter",
    take_photo: "Ta ett foto",
    select_photo: "Välj foto",
    product_title_hint: "Vad är det? Namn, varumärke, modell, etc.",
    delete_photo: "Radera foto",
    product_title: "Titel",
    mark_as_sold: "Markera som såld",
    product_share: "Dela med sig",
    product_make_offer: "Gör erbjudande",
    product_cover: "Ange som omslagsbild",
    product_tags: "Tagg",
    product_posted: "Postad:",
    product_change: "Förändra",
    product_post: "Posta",
    product_selling_from: "Försäljning från plats",
    product_select_location: "Välj plats",
    product_map_approximate:
      "Kartan är ungefärlig för att hålla säljaren  's plats privat",
    product_terms:
      "Genom att tappa inlägget för att publicera din produkt, godkänner du <u> som är listad nära användarvillkor. </ U>",
    condition_other: "Annat (se beskrivning)",
    condition_for_parts: "För delar",
    condition_used: "Används (normalt slitage)",
    condition_open_box: "Öppna lådan (aldrig använt)",
    condition_reconditioned: "Reconditioned / Certified",
    condition_new: "Ny (aldrig använt)",
    select_category: "Välj kategori",
    select_all_category: "Välj alla",
    category_loading_error:
      "Kan inte uppdatera kategorier lista, försök igen senare.",
    category_vehicles: "Fordon",
    category_furniture: "möbel",
    category_electronics: "Elektronik",
    category_appliances: "Hem &  Apparater",
    category_fashion_accessories: "Mode &  Tillbehör",
    category_baby_kids: "Baby &  Barn",
    category_antiques_collectibles: "Antikviteter &  Samlarobjekt",
    category_auto_parts_tools_machinery: "Auto delar, verktyg och  Maskineri",
    category_sports_outdoors: "Sport &  Utomhus",
    category_others: "Andra",
    location_enter_zip_code: "Ange postnummer",
    location_get_current_location: "Få aktuell plats",
    location_select_location: "Välj plats",
    location_update_location: "Uppdatera plats",
    location_new_location: "Ny plats",
    search_filter_results: "Filterresultat",
    search_filter_min: "Filterminimum",
    search_filter_at_least: "Åtminstone",
    price_filter: "Prisfilter",
    product_name: "produktnamn",
    english_language: "engelsk",
    arabic_language: "Arabiska",
    spanish_language: "Spanska",
    system_language: "Systemet",
    share_link: "Dela länk",
    save: "Spara",
    cancel: "Annullera",
    loading: "Läser in",
    yes: "Ja",
    no: "Nej",
    report: "Rapportera",
    report_product: "Rapportera produkt",
    report_user: "Rapportera användare",
    block_user: "Blockera användare",
    un_block_user: "Avblockera användare",
    why_product: "Varför vill du anmäla det här objektet?",
    why_user: "Varför vill du rapportera den här användaren?",
    block_user_confirm: "Vill du permanent blockera den här användaren?",
    un_block_user_confirm:
      "Vill du permanent avblockera den här användaren permanent?",
    prohibited: "Förbjudet på listade nära mig",
    offensive: "Offensiv eller olämplig",
    duplicate: "Duplikat post",
    wrong_category: "Felkategori",
    scam: "Ser ut som en bluff",
    stolen: "Jag tycker att det är stulen",
    product_other: "Övrig",
    product_is_sold: "Denna produkt såldes",
    missed_meeting: "De saknade vårt möte",
    low_offer: "Gjorde ett lågt erbjudande",
    rude: "Oförskämd eller olämplig",
    items: "Problem med föremål",
    trouble_meetup: "Problem vid mötet",
    messaging: "Meddelandeproblem",
    user_other: "Övrig",
    new_version_available: "Ny version tillgänglig",
    please_update_app:
      "Vänligen uppdatera appen till ny version för att fortsätta.",
    update: "Uppdatering",
    no_thanks: "Nej tack",
    contact_support_confirmation:
      "Den aktuella svarstiden är 24-48 timmar. Vill du kontakta listad Nära mig App Chat Support?",
    unboost_confirmation:
      "Är du säker på att du vill unboost den här produkten?",
    no_used_products: "Du har inga listor än",
    no_boosted_products: "Du har inga förstärkta produkter",
    next: "Nästa",
    previous: "Tidigare",
    skip: "Hoppa",
    start: "Start",
    list_used: "Lista en begagnad produkt",
    buy_description:
      "Upptäck och sök efter produkter som erbjuds av grannar runt dig",
    sell_description: "Lista produkter du behöver inte längre till salu",
    list_used_description:
      "Lista en begagnad produkt till salu på mindre än 20 sekunder",
    boost_product_option_1: "<b> boost 1  nday </ b>  n  n <b> $ 0.99 </ b>",
    boost_product_option_2: "<b> boost 3  ndays </ b>  n  n <b> $ 1,99 </ b>",
    boost_product_option_3: "<b> boost 7  ndays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "Få mer visningar varje dag. Ditt objekt visas i Utvalda positioner inom de 30 bästa objekten i Köp och Kategori. Promoterade objekt roteras bland de angivna fläckarna så att varje objekt får rättvis exponering.",
    boost_cta: "Sälja snabbare",
    boost_terms:
      "Genom att tappa boost accepterar du <u> listad nära mig användarvillkor. </ U>",
    boost_best_value: "Bästa värde",
    already_boosted: "Denna produkt ökar",
    clicks: "Klick",
    impressions: "Intryck",
    end: "Slutet",
    transactions_empty_text:
      "Du har inga boosttransaktioner än. Du kan besöka fliken Sälj och börja boostera dina produkter.",
    transactions_loading_error:
      "Kan inte uppdatera transaktionslistan, försök igen senare.",
    transactions_history_title: "BOOST TRANSACTIONS History",
    communicative_postive: "Kommunikativ",
    communicative_negative: "Obetänksam",
    ontime_postive: "I tid",
    ontime_negative: "Sent",
    reliable_postive: "Pålitlig",
    reliable_negative: "Opålitliga",
    friendly_postive: "Vänlig",
    friendly_negative: "Oartig",
    itemasdescribed_postive: "objekt som beskrivet",
    itemasdescribed_negative: "Artikel inte som beskrivet",
    other: "Övrig",
    submit: "Skicka in",
    adding_rating_reviews: "Lägger till betyg och recensioner",
    no_internet_title: "Ingen internetanslutning",
    no_internet_message:
      "Se till att du är ansluten till Internet och försök igen",
    retry: "Försök igen",
    near_me: "Nära mig",
    newest_first: "Nyast först",
    miles: "miles",
    km: "kilometer",
    similar_products: "Liknande Produkter",
    favorite_products: "Favoritprodukter",
    items_for_sale: "föremål till salu",
    joined: "Förenad",
    favorites_transactions_title: "Favoriter",
    boosted_products_transactions_history:
      "Boosted Products Transactions History",
    views: "Åsikter",
    boost_graph_title: "Boostgraf",
    no_favorite_products: "Du har inga favoritprodukter",
    make_offer_buy: "jag skulle vilja köpa",
    make_offer_buy_for: "för",
    notifications: "Anmälningar",
    push_notifications: "Tryck",
    emails_notifications: "E-post",
    apply: "Tillämpa",
    email_messages: "E-post för meddelanden",
    email_new_products: "E-post för nya produkter",
    push_day_only: "Tryck endast på meddelanden",
    push_24_hours: "Tryck på meddelanden 24 timmar",
    edit: "Redigera",
    map: "Karta",
    camera: "Kamera",
    gallery: "Galleri",
    delete: "Radera",
    no_sell_items: "Inga föremål till salu",
    who_bought_question: "Vem köpte den?",
    sold_elsewhere_question: "Sålde det någon annanstans",
    confirm: "Bekräfta",
    over_limit_camera: "Du kan inte lägga till mer än fem bilder",
    boost_failed: "Boost misslyckades. Vänligen försök igen senare",
    after_purchase: "Betalning framgångsrik  Nproduct boosted",
    pay_failed: "Betalning misslyckades. Var god försök igen",
    done: "Gjort",
    not_now: "Inte nu",
    boost: "Lyft",
    invalid_zip_code: "Ogiltigt postnummer",
    invalid_user_name: "Ogiltigt användarnamn",
    comments: "Kommentarer",
    questions: "Frågor",
    bug_reports: "Felrapporter",
    feature_request: "Funktionsförfrågan",
    feedback_type: "Återkopplingstyp",
    feedback_description:
      "Vi skulle gärna höra dina tankar eller feedback om hur vi kan förbättra din upplevelse!",
    feedback: "Respons",
    feedback_text: "Ditt svar",
    suggestions: "Förslag till förbättring",
    delete_account: "Radera konto",
    new_message: "Nytt meddelande",
    online: "Uppkopplad",
    km_50: "50 km",
    km_100: "100 km",
    km_200: "200 km",
    miles_30: "30 miles",
    miles_60: "60 miles",
    miles_120: "120 miles",
    rate_app_question: "Vad sägs om ett betyg på App Store, då?",
    enjoying_question: "Njuter listade nära mig?",
    not_enjoy: "Inte riktigt",
    feedback_question: "Vill du ge oss lite feedback?",
    yes_sure: "Ok, säkert",
    product_available_question: "Hej, är detta fortfarande tillgängligt?",
    buy_question: "Hej, jag vill köpa det här",
    meet_question: "Hej, kan du träffas idag?",
    follow: "Följ",
    followers: "Anhängare",
    following: "Följande",
    feedback_thanks: "Tack för din feedback",
    all_categories: "alla kategorier",
    deleted_account: "Detta konto raderas",
    delete_account_question:
      "Är du säker på att du vill radera det här kontot?",
    no_followings: "Följer inte någon",
    when_following: "när",
    no_followings_subtitle: "följer människor, du kommer att se dem här",
    no_followers: "har inte anhängare",
    no_followers_subtitle: "följt av människor, kommer du att se dem här",
    distance: "Distans",
    filter_method: "Filtermetod",
    see_listings: "Se listor",
    sold: "Såld",
    bought: "Köpt",
    no_notifications: "När du får meddelanden, kommer de att visas här",
    items_title: "Objekt",
    new_listing_title: "Skapa ny lista",
    dialog_year_title: "År",
    dialog_make_title: "Göra",
    dialog_model_title: "Modell",
    dialog_body_style_title: "Kroppsstil",
    dialog_exterior_color_title: "Yttre färg",
    dialog_interior_color_title: "Inre färg",
    dialog_transmission_title: "Överföring",
    dialog_fuel_type_title: "Bränsletyp",
    dialog_owners_num_title: "Antal ägare",
    dialog_vehicle_owed_money_title:
      "Finns det pengar som fortfarande är skyldig på detta fordon?",
    automatic_transmission: "Automatisk",
    manual_transmission: "Manuell",
    not_sure: "Vet inte",
    wagon_hatchback: "Vagn och  Halvkombi",
    convertible: "Konvertibel",
    coupe: "Kupé",
    sedan: "Sedan",
    black_color: "Svart",
    blue_color: "Blå",
    brown_color: "Brun",
    gold_color: "Guld",
    green_color: "Grön",
    grey_color: "Grå",
    pink_color: "Rosa",
    purple_color: "Lila",
    red_color: "Röd",
    silver_color: "Silver",
    orange_color: "Orange",
    white_color: "Vit",
    yellow_color: "Gul",
    charcol_color: "Charcol",
    fuel_diesel: "Diesel",
    fuel_electric: "Elektrisk",
    fuel_gasoline: "Bensin",
    fuel_flex: "Böja",
    fuel_hybrid: "Hybrid",
    fuel_petrol: "Bensin",
    fuel_plugin_hybrid: "Plug-in hybrid",
    truck: "Lastbil",
    van_minivan: "Van &  Minibuss",
    suv_crossover: "SUV &  Crossover",
    awd_4wd: "AWD / 4WD",
    fwd: "Fwd",
    rwd: "Rwd",
    off_white_color: "Av vit",
    tan_color: "Solbränna",
    beige_color: "Beige",
    burgundy_color: "Burgundy",
    turquoise_color: "Turkos",
    title_status_clean: "Rena",
    title_status_rebuilt: "Ombyggd",
    title_status_salvage: "Rädda",
    title_status_missing: "Saknas",
    title_status_lien: "Lien",
    title_status: "Titelstatus",
    mileage: "Miltal",
    dialog_drivetrain_title: "Drilla",
    model_warning: "Vänligen välj Gör först",
    required_field_warning: "Detta fält är obligatoriskt",
    vehicle_vin: "Vin",
    invalid_vin: "Ogiltig VIN, vänligen sätt Vin igen.",
    invalid_mileage: "Ogiltig körsträcka, vänligen sätt i körsträcka igen.",
    clean_description: "De flesta fordon som inte har varit i en olycka",
    rebuilt_description: "En rädd bil som har byggts om",
    salvage_description: "Anses vara uppgått efter en olycka",
    missing_description: "Behöver en ny DMV-problem",
    lien_description: "Ägs av en bank eller domstolsuppgörelse",
    nearme: "Nära mig",
    newest: "Nyaste",
    contact_support: "Kontakta supporten",
    create_home_title: "Bostäder till salu eller hyra",
    for_sale: "Till salu",
    for_rent: "För uthyrning",
    property_type: "Fastighetstyp",
    apartment: "Lägenhet",
    house: "Hus",
    room_only: "Endast rum",
    townhouse: "Radhus",
    bedrooms: "Sovrum",
    bathrooms: "Badrum",
    property_address: "Fastighetsadress",
    price_per_month: "Pris per månad",
    square_feet: "Kvadratfot",
    year_built: "År byggt",
    year_renovated: "År renoverat",
    lot_size: "Partistorlek",
    laundry_type: "Tvättstyp",
    in_unit_laundry: "In-enhet tvättstuga",
    laundry_building: "Tvättservice i byggnaden",
    laundry_available: "Tvättservice",
    none: "Ingen",
    parking_type: "Parkeringstyp",
    garage_parking: "Garage parkering",
    street_parking: "Gatparkering",
    off_street_parking: "Off-street parkering",
    available_parking: "Parkering tillgänglig",
    air_cond_type: "Luftkonditioneringstyp",
    ac_available: "AC tillgänglig",
    central_ac: "Central AC",
    heating_type: "Uppvärmningstyp",
    electric_heating: "Eluppvärmning",
    gas_heating: "Gasvärme",
    radiator_heating: "Radiatorvärme",
    available_heating: "Uppvärmning tillgänglig",
    amenities: "Bekvämligheter",
    date_available: "Datum Tillgängligt",
    lease_length: "Leaselängd",
    month_to_month: "Månad till månad",
    three_months: "3 månader",
    six_months: "6 månader",
    one_year: "1 år",
    more_one_year: "1+ år",
    cat_friendly: "Kattvänlig",
    dog_friendly: "Hundvänlig",
    balcony: "Balkong",
    basement: "Källare",
    bike_parking: "Cykelparkering",
    cable_tv: "Kabel tv",
    ceiling_fan: "Takfläkt",
    concierge: "Concierge",
    dishwasher: "Diskmaskin",
    doorman: "Dörrvakt",
    elevator: "Hiss",
    fireplace: "Öppen spis",
    fitness_center: "Gym",
    garbage_disposal: "Sophantering",
    microwave: "Mikrovågsugn",
    online_app: "Online-ansökan",
    oven: "Ugn",
    package_service: "Paketstjänst",
    patio: "Uteplats",
    pet_park: "Husdjurspark",
    refrigerator: "Kylskåp",
    resident_lounge: "Bosatt lounge",
    roof_deck: "Takvåning",
    secured_entry: "Säkrad post",
    storage: "Lagring",
    walk_in_closet: "Klädkammare",
    swimming_pool: "Simbassäng",
    wheelchair_access: "Rullstolsanpassat",
    central_heating: "Centralvärme",
    invalid_bedrooms: "Ogiltiga sovrum, vänligen sätt tillbaka sovrummen igen.",
    invalid_bathrooms: "Ogiltiga badrum, vänligen sätt badrum igen.",
    chinese_simplified_language: "Förenklad kinesiska",
    chinese_traditional_language: "Traditionell Kinesisk",
    czech_language: "Tjeckisk",
    danish_language: "Danska",
    dutch_language: "Holländska",
    finnish_language: "Finska",
    french_language: "Franska",
    german_language: "tysk",
    greek_language: "grekisk",
    hungarian_language: "Ungerska",
    indonesian_language: "Indonesisk",
    italian_language: "Italiensk",
    japanese_language: "Japansk",
    korean_language: "Koreansk",
    norwegian_language: "Norska",
    polish_language: "putsa",
    portuguese_language: "Portugisisk",
    portuguese_brazilian_language: "Portugisiska, brasilianska",
    romanian_language: "Rumänska",
    russian_language: "Rysk",
    swedish_language: "svenska",
    turkish_language: "Turkisk",
    ukrainian_language: "Ukrainsk",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "Vietnamesisk",
    category_home_sale_or_rent: "Hem till salu eller hyra",
    square_meter: "Kvadratmeter",
    copy_text: "Kopiera",
    copyied_to_clipboard: "Kopieras till urklipp",
    inbox: "Inkorg",
    input_title_listening: "Lyssnande…",
    input_subtitle_listening: "Säg något",
    input_title_error: "Tyvärr, vi fick inte det.",
    input_subtitle_error: "Försök att upprepa din förfrågan.",
    input_hint_error: "Försök igen",
    price_less_than_or_equal: "Pris mindre än eller lika med",
    any_price: "Vilket pris som helst",
    any_condition: "Vilket villkor som helst",
    any_time: "När som helst",
    days_ago: "dagar sedan",
    any_distance: "Vilket avstånd som helst",
    distance_within: "Avstånd inom",
    new_notification: "Ny anmälan",
    deleted: "raderade",
    processing_image: "Bearbetningsbild",
    remove_dialog_message: "Vill du verkligen ta bort den här produkten?",
    deleted_thread: "Detta meddelande raderas",
    category_yard_sale_event: "Yard Sale Event",
    yard_first_date: "YARD SALE FIRST DATE",
    yard_second_date: "YARD SALE Andra datumet",
    yard_third_date: "YARD SALE TREDJE DATUM",
    yard_start_time: "Starttid",
    yard_end_time: "Sluttid",
    yard_end_timestamp: "Sluttidsstämpel",
    invalid_date1: "Ogiltigt första datum, vänligen ange första datum igen",
    invalid_start_time: "Ogiltig starttid, vänligen ange starttid igen",
    invalid_end_time: "Ogiltig sluttid, vänligen ange sluttid igen",
    yard_sale_title: "Loppmarknad",
    garage_tag: "garage",
    yard_tag: "gård",
    from: "Från",
    to: "Till",
    block: "Blockera",
    un_block: "Avblockera",
    sign_email: "Logga in med e-post",
    invalid_first_date:
      "Ogiltigt första datum, var god och se till att första datumet är före andra och tredje",
    invalid_second_date:
      "Ogiltigt andra datum, se till att andra datum är före tredje datum",
    invalid_start_time_value:
      "Ogiltig starttid, var vänlig och se till att starttiden är före sluttid",
    use_default_yard_photo: "Använd standard yard försäljning foto",
    active_label: "Aktiva",
    enable_notifications: "Aktivera meddelanden",
    login: "Logga in",
    january: "Januari",
    february: "Februari",
    march: "Mars",
    april: "April",
    may: "Maj",
    june: "Juni",
    july: "Juli",
    august: "Augusti",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "December",
    since: "Eftersom",
    product_views: "Produktvisningar",
    shop_views: "Butiksutsikt",
    total_sales: "Total rea",
    total_orders: "Totala order",
    last_twelvth_months: "Sista twelvth månader",
    last_nine_months: "Sista nio månader",
    last_six_months: "Senaste sex månaderna",
    last_three_months: "Sista tre månaderna",
    last_12_months: "Senaste 12 månaderna",
    last_9_months: "Sista 9 månader",
    last_6_months: "Sista 6 månader",
    last_3_months: "Senaste 3 månaderna",
    months: "Månader",
    open: "Öppen",
    reset_password: "Återställ lösenord",
    create_new_shop: "Skapa ny butik",
    download_app: "Ladda ner app",
    log_in: "Logga in",
    sign_up: "Bli Medlem",
    no_result: "Inget resultat",
    max_price: "Max pris",
    max_distance: "Max avstånd",
    max_time: "Max tid",
    posted_less_than: "Postat mindre än",
    result: "Resultat",
    more: "Mer",
    or: "ELLER",
    password: "Lösenord",
    forgot_password: "Glömt ditt lösenord?",
    and: "och",
    download_for: "Nedladdning för",
    apple_ios: "Apple iOS",
    android: "Android",
    image: "Bild",
    edit_image: "Redigera bilden",
    please_complete: "Var god slutför",
    enter_your_offer: "Ange ditt erbjudande",
    categories: "Kategorier",
    upload_image: "Ladda upp bild",
    upload_images: "Ladda upp bilder",
    back: "Tillbaka",
    see_more: "Se mer",
    add_product: "Lägg till produkt",
    selected: "Vald",
    create: "Skapa",
    rate_the_buyer: "Betygsätt köparen",
    delete_product: "Radera produkt",
    product: "Produkt",
    un_block_product: "Unblock produkt",
    share_your_product: "Dela din produkt",
    boost_details: "Boost detaljer",
    remove_all_products: "Ta bort alla produkter",
    remove_all: "Ta bort alla",
    add_vehicle: "Lägga till fordon",
    edit_vehicle: "Redigera fordon",
    upload_a_photo: "Ladda upp ett foto",
    view_details: "Visa detaljer",
    add_yard_sale: "Lägg till gårdsal",
    edit_yard_sale: "Redigera yard försäljning",
    users: "Användare",
    users_details: "Användaruppgifter",
    users_by_country: "Användare per land",
    blocked_users: "Blockerade användare",
    products_cards: "Produkter kort",
    archived_products: "Arkiverade produkter",
    blocked_products: "Blockerade produkter",
    products_by_country: "Produkter per land",
    reports: "Rapportera",
    reports_details: "Rapportersuppgifter",
    closed_reports: "Stängda rapporter",
    threads: "Trådar",
    threads_details: "Trådsdetaljer",
    chat_support: "Chattstöd",
    actions: "Handlingar",
    search_actions: "Sök åtgärder",
    product_view_actions: "Produktvisning Åtgärder",
    contact_seller_product: "Kontakta säljaren Produkt",
    contact_owner_shop: "Kontakta ägaren butik",
    ratings: "Betyg",
    reviews: "Recensioner",
    products_all_countries: "Produkter Alla länder",
    edit_profile: "Redigera profil",
    my_profile: "Min profil",
    profile_updated_successfully: "Profil uppdaterad framgångsrikt",
    are_you_sure: "Är du säker",
    my_used_products: "Mina begagnade produkter",
    my_shops: "Mina affärer",
    my_boosted_products: "Mina förstärkta produkter",
    messages_type_message_here: "Skriv ditt meddelande här",
    messages_product_sold: "Denna produkt säljs eller tas bort",
    seen: "Sett",
    messages_never_miss_message: "Aldrig missar ett meddelande",
    enable: "Gör det möjligt",
    send_notify: "Skicka meddela",
    un_close: "Stänga av",
    type_your_review: "Skriv din recension",
    again_question: "om igen ?",
    ratings_already_submitted_review: "Du har redan lämnat in Recension",
    set_product_category: "Ange produktkategori",
    auth_email_password_incorrect:
      "Ditt e-postmeddelande eller lösenord är felaktigt",
    auth_insert_your_name: "Vänligen sätt in ditt namn",
    auth_email_address_badly: "E-postadressen är dåligt formaterad",
    auth_email_address_used:
      "E-postadressen är redan i bruk av ett annat konto",
    auth_invalid_password: "Lösenordet ska vara minst 6 tecken",
    auth_reset_email: "Ange ditt mail för att återställa ditt lösenord",
    auth_check_email: "Vänligen kolla ditt mail för att återställa lösenordet",
    auth_can_sign_in_google: "Du kan logga in med Google-knappen",
    auth_do_not_have_account: "Har du inte ett konto?",
    auth_have_account: "Har du ett konto?",
    log_terms_privacy_part1:
      "Genom att anmäla dig eller logga in, godkänner du de listade närheten till mig",
    boost_this_product: "Boost den här produkten?",
    product_successfully_boosted: "Produkten har framgångsrikt ökat",
    product_failed_boost: "Produkten har misslyckats i ökningen",
    no_products_for_sale:
      "Du har för närvarande inga använda produkter som anges för försäljning.",
    not_sold_listed_near_me: "Jag sålde inte den på listad nära mig",
    agree_add_product:
      "Genom att tappa inlägget för att publicera din produkt, godkänner du de listade när det gäller användarvillkor och sekretesspolicy.",
    click_to_boost: "Klicka på produkten för att öka den",
    listed_terms_of_service: "Listad nära mig Användarvillkor",
    receive_emails_for_users: "Ta emot e-post för användare",
    receive_emails_for_newly_posted:
      "Ta emot e-post för dina nyupplagda produkter",
    disable_push_notifications: "Inaktivera tryckmeddelanden",
    sms_during_day: "Ta emot SMS under dagen",
    sms_24_hours: "Ta emot SMS 24 timmar",
    products: "Produkter",
    product_no_longer_available:
      "Tyvärr, den här produkten är inte längre tillgänglig",
    add_home: "Lägga hem",
    edit_home: "Redigera hem",
    fill_required_fields: "Fyll i alla nödvändiga fält",
    no_notification: "Det finns inga meddelanden",
    orders_history: "Orders historia",
    privacy: "Integritet",
    terms: "Villkor",
    report_a_problem: "Rapportera ett problem",
    approximation_protect_user_privacy:
      "Approximation för att skydda användarens integritet",
    do_not_have_products: "Du har inte produkter",
    emails: "E-post",
    lead_deletion_products:
      "Detta kommer att leda till att alla dina produkter raderas",
    confirm_legal_message:
      "Du är ensam ansvarig för att vidta alla nödvändiga försiktighetsåtgärder när du interagerar med andra, särskilt när man möter en främling personligen för första gången. Läs omdömen om användarvillkor för mer information.",
    push_notifications_notified_instantly:
      "Aktivera tryckmeddelanden som ska meddelas omedelbart",
    rate_seller: "Ränta",
    user_journey: "Användarresa",
    user: "Användare",
    user_id: "Användar ID",
    action_id: "Action id",
    select_model_car: "Välj modell av bil",
    boost_1_day: "Boost 1 dag",
    boost_3_days: "Boost 3 dagar",
    boost_7_days: "Boost 7 dagar",
    agree_boost_terms: "Genom att tappa boost godkänner du",
    add: "Lägg till",
    add_tag: "Lägg till tagg",
    brand_title: "varumärke",
    category_mobiles: "Mobiler",
    category_tablets: "Tabletter",
    screen_size: "Skärmstorlek",
    has_cellular_capability: "Har cellfunktion",
    default_internal_memory: "Internminne",
    network_carrier: "Nätverksoperatör",
    is_unlocked: "Är olåst",
    mobile_model_warning: "Vänligen välj Brand First",
    missing_image: "Saknad bild, försök Lägg till bild igen.",
    add_mobile: "Lägga mobil",
    edit_mobile: "Redigera mobilen",
    add_tablet: "Lägg till tablett",
    edit_tablet: "Redigera tablett",
    keywords:
      "shopping, köp, sälja, tjäna pengar, handel, lokalbefolkningen, grannar, auto, fordon",
    country: "Land",
    phone_number: "Telefonnummer",
    verification_code: "Verifierings kod",
    error_occurred: "Ett fel har inträffat. Vänligen försök igen senare",
    invalid_state:
      "Ogiltigt tillstånd: En inloggning återuppringning mottogs, men ingen inloggningsförfrågan skickades.",
    sign_in: "Logga in",
    sign_in_apple: "Logga in med äpple",
    sign_in_google: "Logga in med Google",
    sign_in_phone: "Logga in med telefon",
    sign_in_facebook: "Logga in med Facebook",
    create_account: "Skapa ett konto",
    email: "E-post",
    invalid_field: "Vänligen fyll i de obligatoriska fälten",
    code_sent: "Koden har skickats via SMS",
    verify_number: "Verifiera telefonnummer",
    tapping_verify_number:
      "Genom att tappa (verifiera telefonnummer) skickas ett SMS.",
    email_exists:
      "Kontot finns redan och du måste komma åt den via Google-knappen, Facebook-knappen eller Apple-knappen",
    ok: "Ok",
    sure_back: "Är du säker på att backa?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "sedan",
    add_model: "Lägg till modell",
    no_search_results_us:
      "Inga sökresultat nära dig inom 120 mil. Försök att ändra sökfiltret eller sökordet.",
    no_search_results:
      "Inga sökresultat nära dig inom 200 km. Försök att ändra sökfiltret eller sökordet.",
    plan_date: "Plandatum",
    plan_time: "Plantid",
    invalid_plan_date: "Ogiltigt plandatum, ange plandatum igen",
    invalid_plan_time: "Ogiltig plantid, ställ in plantiden igen",
    plan_name: "Plannamn",
    plan_title: "Planen",
    update_plan_name: "Uppdatera plannamn",
    delete_plan_question: "Är du säker på att du vill ta bort den här planen?",
    plan_reminder_message: "Du kommer att påminnas en timme innan",
    plan_dialog_title: "Mötesplan",
    planners_title: "Planerare",
    unable_sending_messages:
      "De kommer att se dina meddelanden när de är tillbaka online.",
    its_text: "Dess",
    for_your_text: "för din mottagare.",
  },
  tr: {
    invalid_area: "Geçersiz alan, lütfen alanı tekrar ayarlayın.",
    invalid_lot_size:
      "Geçersiz özellik lot boyutu, lütfen tekrar lot boyutunu ayarlayın.",
    property_area: "Mülk alanı",
    app_store_name:
      "Bana yakın listelendi - Kullanılmış eşyaları satın alın, Nakit için Satın",
    app_store_short:
      "Yerel satıcılar için bir pazar. Satılık bir öğeyi listeleyin ve para kazanın.",
    app_store_full:
      "Yakınımda listelenen, istediğiniz şeyler hakkında harika fırsatlar bulmayı ve satmak istediğiniz şeylere para kazanmayı kolaylaştırır. Bu, topluluğunuzda veya mahallenizde güvenebileceğiniz insanlarla satın almanın ve satmanın en iyi yoludur. Nasıl çalışır: 1- Bir şey satın alın veya satmak; Öğelerinizi satılık saniyeler içinde kolayca gönderin. 2- Giysi, mobilya, cep telefonları, elektronik, bebek ve çocuk eşyaları, spor malzemeleri, kullanılmış arabalar, elbiseler, ayakkabılar ve saatler, kitaplara, kullanılmış oyuncaklar, kullanılmış dizüstü bilgisayarlar, ikinci el araba ve hatta gerçek bulmak için harika fırsatlar ve indirimler bulun. satılık ya da kira emlak. 3- Satılık yerel eşyalara göz atın. 4- Mesaj alıcılar ve satıcılar uygulamadan. 5- Öğeleri görüntüle göz atın ve kategoriye göre sıralayın. Yakınımın yakınında listelenen hakkında eğlenceli gerçekler: 1- Yanımda listelenenlerle, kıyafetlerden kullanılmış arabalara elektroniklere kadar her şeyi kolayca satabilirsiniz. 2- Alıcılar ve satıcılar arasındaki iletişim, mesajlaşma yoluyla uygulamada olur. 3- Yakınımdaki listelenen bir garaj satışıdan daha iyidir; Bir indirimde istediğiniz her şeyi, telefonunuzda veya tabletinizde bulun.",
    app_store_release:
      "Yanımda listelenen - yerlilerle ticaret. Yerel alıcılar ve satıcılar için mobil pazarlara katılın!",
    app_name: "Yanımda listelenen",
    title_buy: "Satın almak",
    title_messages: "Mesaj",
    title_sell: "Satmak",
    title_profile_image: "Profil resmi",
    title_account: "Hesap",
    account_settings: "Hesap ayarları",
    settings: "Ayarlar",
    color_theme: "Renk teması",
    device_settings: "Cihaz ayarları",
    public_profile: "Halka açık profil",
    light_mode: "Işık modu",
    dark_mode: "Karanlık mod",
    title_sell_faster: "Daha hızlı satmak",
    send_button_label: "Göndermek",
    rate_message: "Beni oyla...",
    already_rated: "Zaten inceleme yaptınız",
    rate_review_question: "Başa çıkmak ister misiniz",
    again: "yine?",
    action_logout: "Çıkış Yap",
    action_category: "Kategori",
    action_search: "Aramak",
    action_refer: "Bir arkadaşına bakın",
    dialog_choose_location: "Konum seç",
    dialog_change_username: "Kullanıcı adını değiştir",
    dialog_change_language: "Dili değiştir",
    dialog_image_tags: "Görüntü etiketleri",
    dialog_emails_notifications: "E-posta Bildirimleri",
    dialog_push_notifications: "Push bildirimleri",
    fragment_product_detail: "Ürün ayrıntısı",
    fragment_message_details: "Mesajlar Detay",
    fragment_sell: "Satmak",
    dialog_tags_title: "Etiketler",
    dialog_location_title: "Güncelleme yeri",
    dialog_username_title: "Kullanıcı adını değiştir",
    tab_photo: "Fotoğraf",
    tab_details: "Detaylar",
    tab_price: "Fiyat",
    tab_finish: "Sona ermek",
    profile: "Profil",
    search: "Aramak",
    choose_product: "Ürün seç",
    rating_review: "Derecelendirme ve İnceleme",
    select_buyer: "Bir alıcı seçin",
    tab_my_used_products: "Ürünlerim",
    price_label: "Fiyat",
    text_savings: "Kazanıyorsun",
    search_hint: "Ürünleri ara ...",
    empty_text: "Bu kategoride veya seçilen mesafede listelenen ürün yoktur.",
    filter_menu_text: "Filtrelemek",
    error_contacting_seller: "Satıcı ile iletişim kurma hatası",
    edit_product: "Ürün Düzenle",
    contact_seller: "Satıcıyla iletişime geç",
    signup_to_contact_seller: "Satıcıyla iletişime geçmek için",
    signup_to_make_offer: "Teklif yapmak için kaydolun",
    product_details: "Detaylar",
    product_category: "Kategori",
    product_condition: "Şart",
    product_description: "Açıklama",
    product_location: "Ürün Konumu",
    product_location_approximate: "Yer yaklaşık",
    over_week_time_ago: "Bir hafta önce",
    boosted: "Artırmak",
    threads_no_results: "Mesaj yok",
    message_no_results: "Mesaj yok",
    message_warning:
      "Başkalarıyla etkileşime girerken, özellikle de ilk kez bir yabancıyla tanışırken, gerekli tüm önlemleri almaktan yalnızca siz sorumlusunuz. Lütfen kişisel bilgileri, doğrulama kodlarını veya ödeme bilgilerini paylaşmayın. Daha fazla ayrıntı için lütfen Hizmet Şartlarını inceleyin.",
    message_block: "Şu anda mesaj gönderemez veya gönderemezsiniz.",
    select_location: "Yer seç",
    location_permission_denied_message:
      "Uygulamanın düzgün çalışması için yer izni gerektirir.",
    signed_in: "Giriş yapıldı!",
    sign_in_canceller: "Giriş Yap İptal Edildi",
    version: "Sürüm",
    build: "Yapı",
    name: "İsim",
    location: "Konum",
    language: "Dilim",
    about_app: "Yanımda listelenen hakkında",
    terms_of_service: "Kullanım Şartları",
    privacy_policy: "Gizlilik Politikası",
    report_feedback: "Geribildirim yolla",
    report_bug: "Bir böcek bildirmek için telefonu sallayın",
    change_image: "Resmi değiştir",
    update_location: "Güncelleme yeri",
    about_the_app: "Uygulama hakkında",
    update_label: "Güncelleme",
    uploading: "Yükleme",
    adding: "Liste ekleme",
    removing: "Listeyi kaldırma",
    updating: "Liste güncelleme",
    uploaded_image: "Yüklenen resim:",
    image_storage_failed: "Görüntü depolamadı:",
    product_updated: "Ürün başarıyla güncellendi",
    location_error: "Konum kaydedilmedi, lütfen tekrar deneyin",
    product_removed: "Ürün başarıyla kaldırıldı",
    deleted_product: "Bu ürün silindi",
    invalid_title: "Geçersiz başlık, lütfen başlığı tekrar ayarlayın.",
    invalid_image: "Geçersiz görüntü yolu, tekrar resim ekle.",
    invalid_price: "Geçersiz fiyat, lütfen tekrar fiyat ayarlayın.",
    invalid_location: "Geçersiz konum, lütfen tekrar konum ayarlayın.",
    invalid_category: "Geçersiz kategori, lütfen kategoriyi tekrar ayarlayın.",
    invalid_condition: "Geçersiz durum, lütfen tekrar durumu ayarlayın.",
    removing_title: "Profil Resminin Çıkarılması",
    image_not_saved: "Görüntü kaydetme başarısız oldu!",
    product_load_failed: "Ürün yok",
    take_photo: "Fotoğraf çek",
    select_photo: "Fotoğraf Seç",
    product_title_hint: "Bu ne? İsim, marka, model vb.",
    delete_photo: "Fotoğrafı sil",
    product_title: "Başlık",
    mark_as_sold: "Satılan olarak işaret",
    product_share: "Paylaş",
    product_make_offer: "Teklif yap",
    product_cover: "Kapak görüntüsü olarak ayarlayın",
    product_tags: "Etiketler",
    product_posted: "Gönderildi:",
    product_change: "Değişiklik",
    product_post: "Postalamak",
    product_selling_from: "Yerden Satış",
    product_select_location: "Yer seç",
    product_map_approximate:
      "Harita, satıcının konumunu özel tutmak için yaklaşık",
    product_terms:
      "Ürününüzü yayınlamak için Mesaj'a dokunarak, bana yakınımın yakınında listelenenleri kabul edersiniz. </ U>",
    condition_other: "Diğer (tanıma bakınız)",
    condition_for_parts: "Parçalar için",
    condition_used: "Kullanılan (normal aşınma)",
    condition_open_box: "Aç Kutusu (hiç kullanılmadı)",
    condition_reconditioned: "Yenilenmiş / Sertifikalı",
    condition_new: "Yeni (hiç kullanılmamış)",
    select_category: "Kategori seç",
    select_all_category: "Hepsini seç",
    category_loading_error:
      "Kategoriler listesini güncelleyemiyor, lütfen daha sonra tekrar deneyin.",
    category_vehicles: "Araçlar",
    category_furniture: "Mobilya",
    category_electronics: "Elektronik",
    category_appliances: "Ev ve  Aletler",
    category_fashion_accessories: "Moda ve  Aksesuarlar",
    category_baby_kids: "Bebek ve  Çocuk",
    category_antiques_collectibles: "Antikalar ve  Koleksiyon",
    category_auto_parts_tools_machinery:
      "Otomobil parçaları, araçlar ve  Makine",
    category_sports_outdoors: "Spor ve  Açık havada",
    category_others: "Diğerleri",
    location_enter_zip_code: "Posta kodu gir",
    location_get_current_location: "Geçerli konum alın",
    location_select_location: "Yer seç",
    location_update_location: "Güncelleme yeri",
    location_new_location: "Yeni konum",
    search_filter_results: "Sonuçları filtrele",
    search_filter_min: "Minimum filtre",
    search_filter_at_least: "En azından",
    price_filter: "Fiyat filtresi",
    product_name: "Ürün adı",
    english_language: "ingilizce",
    arabic_language: "Arapça",
    spanish_language: "İspanyol",
    system_language: "Sistem",
    share_link: "Linki paylaş",
    save: "Kayıt etmek",
    cancel: "İptal etmek",
    loading: "Yükleniyor",
    yes: "Evet",
    no: "Numara",
    report: "Bildiri",
    report_product: "Rapor Ürün",
    report_user: "Kullanıcıyı bildir",
    block_user: "Kullanıcıyı engelle",
    un_block_user: "Kullanıcının engelini kaldır",
    why_product: "Neden bu maddeyi bildirmek istiyorsun?",
    why_user: "Neden bu kullanıcıyı rapor etmek istiyorsun?",
    block_user_confirm:
      "Bu kullanıcıyı kalıcı olarak engellemek ister misiniz?",
    un_block_user_confirm:
      "Bu kullanıcının kalıcı olarak kaldırmak ister misiniz?",
    prohibited: "Yanımda listelenen yasak",
    offensive: "Saldırgan veya uygunsuz",
    duplicate: "Yinelenen posta",
    wrong_category: "Yanlış kategori",
    scam: "Bir aldatmaca gibi görünüyor",
    stolen: "Bence çalındı",
    product_other: "Diğer",
    product_is_sold: "Bu ürün satıldı",
    missed_meeting: "Toplantımızı özlediler",
    low_offer: "Düşük bir teklif yaptı",
    rude: "Kaba ya da uygunsuz",
    items: "Öğelerle ilgili sorun",
    trouble_meetup: "Buluşma konusunda sorun",
    messaging: "Mesajlaşma Sorunları",
    user_other: "Diğer",
    new_version_available: "Yeni sürüm mevcut",
    please_update_app:
      "Lütfen, devam etmek için uygulamayı yeni sürümle güncelleyin.",
    update: "Güncelleme",
    no_thanks: "Hayır teşekkürler",
    contact_support_confirmation:
      "Mevcut yanıt süresi 24-48 saattir. APP Sohbet Desteği yakınında listelenen listelenmek ister misiniz?",
    unboost_confirmation: "Bu ürünü kaldırmak istediğinize emin misiniz?",
    no_used_products: "Henüz herhangi bir ilan yok",
    no_boosted_products: "Büçlü herhangi bir ürününüz yok",
    next: "Sonraki",
    previous: "Öncesi",
    skip: "Atlamak",
    start: "Başlangıç",
    list_used: "Kullanılmış bir ürünü listele",
    buy_description:
      "Etrafınızdaki komşuların sunduğu ürünleri keşfedin ve arayın",
    sell_description: "Satışa artık ihtiyaç duymadığınız ürünleri listeleyin",
    list_used_description:
      "20 saniyeden daha az satılık ikinci el ürün listesi",
    boost_product_option_1: "<b> 1  nday </ b>  n  n <b> 0,99 $ </ b>",
    boost_product_option_2: "<b> 3  n gün </ b>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<b> 7  ndays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "Her gün daha fazla manzaraya sahip olun. Ürününüz, satın alma ve kategorideki en iyi 30 öğe dahilinde öne çıkan pozisyonlarda görünecektir. Terfi edilen ürünler, belirlenmiş noktalar arasında döndürülür, böylece her öğe adil maruz kalır.",
    boost_cta: "Daha hızlı satmak",
    boost_terms:
      "Boost'a dokunarak, bana yakınımın yakınında listelenenleri kabul edersiniz. </ U>",
    boost_best_value: "En iyi değeri",
    already_boosted: "Bu ürün artırıldı",
    clicks: "Tıklar",
    impressions: "İzlenimler",
    end: "Son",
    transactions_empty_text:
      "Henüz bir artırma işleminiz yok. Satış sekmesini ziyaret edebilir ve ürünlerinizi artırmaya başlayabilirsiniz.",
    transactions_loading_error:
      "İşlemler listesini güncelleyemiyor, lütfen daha sonra tekrar deneyin.",
    transactions_history_title: "İşlem geçmişini artırın",
    communicative_postive: "İletişimsel",
    communicative_negative: "Çekici olmayan",
    ontime_postive: "Zamanında",
    ontime_negative: "Geç",
    reliable_postive: "Dürüst",
    reliable_negative: "Güvenilmez",
    friendly_postive: "Arkadaşça",
    friendly_negative: "Kaba",
    itemasdescribed_postive: "Ürün tarif edildiği gibi",
    itemasdescribed_negative: "Öğe açıklandığı gibi değil",
    other: "Diğer",
    submit: "Göndermek",
    adding_rating_reviews: "Derecelendirme ve yorumlar ekleme",
    no_internet_title: "İnternet bağlantısı yok",
    no_internet_message:
      "İnternete bağlı olduğunuzdan ve tekrar deneyin olduğunuzdan emin olun.",
    retry: "Yeniden denemek",
    near_me: "Bana yakın",
    newest_first: "En yeni ilk",
    miles: "mil",
    km: "Km",
    similar_products: "benzer ürünler",
    favorite_products: "Favori Ürünler",
    items_for_sale: "satılık eşyalar",
    joined: "Katılmış",
    favorites_transactions_title: "Favoriler",
    boosted_products_transactions_history: "Ürünler İşlem Tarihi Artırdı",
    views: "Görüntüleme",
    boost_graph_title: "Grafiği artırmak",
    no_favorite_products: "Favori Ürünleriniz yok",
    make_offer_buy: "satın almak istiyorum",
    make_offer_buy_for: "için",
    notifications: "Bildirimler",
    push_notifications: "İtmek",
    emails_notifications: "E-posta",
    apply: "Uygulamak",
    email_messages: "Mesajlar için e-posta",
    email_new_products: "Yeni ürünler için e-posta",
    push_day_only: "Bildirimler SADECE GÜNLÜK İPTİ",
    push_24_hours: "24 saat push bildirimleri",
    edit: "Düzenlemek",
    map: "Harita",
    camera: "Kamera",
    gallery: "Galeri",
    delete: "Silmek",
    no_sell_items: "Satılık ürün yok",
    who_bought_question: "Kim aldı?",
    sold_elsewhere_question: "Başka bir yere satıldı",
    confirm: "Teyit etmek",
    over_limit_camera: "Beşten fazla resim ekleyemezsiniz",
    boost_failed: "Boost başarısız oldu. Lütfen daha sonra tekrar deneyiniz",
    after_purchase: "Ödeme başarılı  nproduct artırdı",
    pay_failed: "Ödeme başarısız. Lütfen tekrar deneyin",
    done: "Tamamlandı",
    not_now: "Şimdi değil",
    boost: "Artırmak",
    invalid_zip_code: "Geçersiz zip kodu",
    invalid_user_name: "Geçersiz kullanıcı adı",
    comments: "Yorumlar",
    questions: "Sorular",
    bug_reports: "Hata raporları",
    feature_request: "Özellik isteği",
    feedback_type: "geri bildirim türü",
    feedback_description:
      "Deneyiminizi nasıl geliştirebileceğimiz düşüncelerinizi veya geri bildiriminizi duymayı çok isteriz!",
    feedback: "Geri bildirim",
    feedback_text: "Senin cevabın",
    suggestions: "İyileştirme için öneri",
    delete_account: "Hesabı sil",
    new_message: "Yeni Mesaj",
    online: "İnternet üzerinden",
    km_50: "50 km",
    km_100: "100 km",
    km_200: "200 km",
    miles_30: "30 mil",
    miles_60: "60 mil",
    miles_120: "120 mil",
    rate_app_question: "App Store'da bir derecelendirme, o zaman?",
    enjoying_question: "Yakınımda listelenen zevk mi?",
    not_enjoy: "Pek sayılmaz",
    feedback_question: "Bize biraz geri bildirim vermek ister misiniz?",
    yes_sure: "Tabii olur",
    product_available_question: "Merhaba, bu hala mevcut mu?",
    buy_question: "Merhaba, bunu satın almak istiyorum",
    meet_question: "Merhaba, bugün buluşabilir misin?",
    follow: "Takip et",
    followers: "Takipçiler",
    following: "Takip etme",
    feedback_thanks: "geri bildiriminiz için teşekkürler",
    all_categories: "Tüm Kategoriler",
    deleted_account: "Bu hesap silindi",
    delete_account_question: "Bu hesabı silmek istediğinize emin misiniz?",
    no_followings: "kimseyi takip etmez",
    when_following: "ne zaman",
    no_followings_subtitle: "İnsanları takip et, onları burada göreceksin",
    no_followers: "takipçileri yok",
    no_followers_subtitle: "ardından insanlar, onları burada göreceksiniz",
    distance: "Mesafe",
    filter_method: "Filtre yöntemi",
    see_listings: "Listelere bakın",
    sold: "Satıldı",
    bought: "Satın alınmış",
    no_notifications: "Bildirimleri aldığınızda, burada görünecekler",
    items_title: "Öğeler",
    new_listing_title: "Yeni liste oluştur",
    dialog_year_title: "Yıl",
    dialog_make_title: "Yapmak",
    dialog_model_title: "Model",
    dialog_body_style_title: "Vücut sitili",
    dialog_exterior_color_title: "Dış rengi",
    dialog_interior_color_title: "İç renk",
    dialog_transmission_title: "Bulaşma",
    dialog_fuel_type_title: "Yakıt tipi",
    dialog_owners_num_title: "Sahip Sayısı",
    dialog_vehicle_owed_money_title: "Bu araca hala borçlu var mı?",
    automatic_transmission: "Otomatik",
    manual_transmission: "Manuel",
    not_sure: "Emin değil",
    wagon_hatchback: "Vagon ve  Hatchback",
    convertible: "Çevrilebilir",
    coupe: "Coupe",
    sedan: "Sedan",
    black_color: "Siyah",
    blue_color: "Mavi",
    brown_color: "kahverengi",
    gold_color: "Altın",
    green_color: "Yeşil",
    grey_color: "Gri",
    pink_color: "Pembe",
    purple_color: "Mor",
    red_color: "kırmızı",
    silver_color: "Gümüş rengi",
    orange_color: "Portakal",
    white_color: "Beyaz",
    yellow_color: "Sarı",
    charcol_color: "Çiğnemek",
    fuel_diesel: "Dizel",
    fuel_electric: "Elektrik",
    fuel_gasoline: "Benzin",
    fuel_flex: "Esnek",
    fuel_hybrid: "Hibrit",
    fuel_petrol: "Benzin",
    fuel_plugin_hybrid: "Eklenti hibrit",
    truck: "Kamyon",
    van_minivan: "Van &  Minibüs",
    suv_crossover: "SUV &  Karşıdan karşıya geçmek",
    awd_4wd: "AWD / 4WD",
    fwd: "Fwd",
    rwd: "Rwd",
    off_white_color: "Kırık beyaz",
    tan_color: "Bronzlaşmak",
    beige_color: "Bej",
    burgundy_color: "Bordo",
    turquoise_color: "Turkuaz",
    title_status_clean: "Temiz",
    title_status_rebuilt: "Yeniden inşa etmek",
    title_status_salvage: "Kurtarma",
    title_status_missing: "Eksik",
    title_status_lien: "Haciz etmek",
    title_status: "Başlık Durumu",
    mileage: "Kilometre",
    dialog_drivetrain_title: "Drivetrain",
    model_warning: "Lütfen önce yap",
    required_field_warning: "Bu alan gereklidir",
    vehicle_vin: "Vin",
    invalid_vin: "Geçersiz Vin, lütfen tekrar Vin'i ayarlayın.",
    invalid_mileage: "Geçersiz kilometre, lütfen tekrar kilometre ayarlayın.",
    clean_description: "Kaza içinde olmayan çoğu araç",
    rebuilt_description: "Yeniden inşa edilen kurtarılmış bir araba",
    salvage_description: "Bir kazadan sonra toplam kabul edilir",
    missing_description: "Yeni bir DMV konularına ihtiyacım olacak",
    lien_description: "Bir banka veya mahkeme yerleşimine ait",
    nearme: "Bana yakın",
    newest: "En yeni",
    contact_support: "İletişim desteği",
    create_home_title: "Satılık veya Kiralık Evler",
    for_sale: "Satılık",
    for_rent: "Kiralık",
    property_type: "Emlak Tipi",
    apartment: "Apartman",
    house: "ev",
    room_only: "Sadece oda",
    townhouse: "Şehir evi",
    bedrooms: "Yatak odası",
    bathrooms: "Banyolar",
    property_address: "Özellik adresi",
    price_per_month: "Aylık fiyat",
    square_feet: "Kare ayak",
    year_built: "Kuruluş yılı",
    year_renovated: "Yenilenmiş yıl",
    lot_size: "Lot büyüklüğü",
    laundry_type: "Çamaşır tipi",
    in_unit_laundry: "Birim İçi Çamaşırhane",
    laundry_building: "Binada Çamaşırhane",
    laundry_available: "Çamaşırhane mevcut",
    none: "Hiçbiri",
    parking_type: "Park türü",
    garage_parking: "Garaj otoparkı",
    street_parking: "Sokak otoparkı",
    off_street_parking: "Sokak dışı park yeri",
    available_parking: "Otopark mevcut",
    air_cond_type: "Klima Tipi",
    ac_available: "AC Mevcut",
    central_ac: "Merkez ac",
    heating_type: "Isıtma Tipi",
    electric_heating: "Elektrikli ısıtma",
    gas_heating: "Gaz ısıtma",
    radiator_heating: "Radyatör ısıtma",
    available_heating: "Isıtma mevcut",
    amenities: "Kolaylıklar",
    date_available: "Tarih Uygun",
    lease_length: "Kiralama uzunluğu",
    month_to_month: "Aydan aya",
    three_months: "3 ay",
    six_months: "6 ay",
    one_year: "1 yıl",
    more_one_year: "1+ yıl",
    cat_friendly: "Kedi dostu",
    dog_friendly: "Köpek dostu",
    balcony: "Balkon",
    basement: "Bodrum kat",
    bike_parking: "Bisiklet park yeri",
    cable_tv: "Kablo TV",
    ceiling_fan: "Tavan pervanesi",
    concierge: "Kapıcı",
    dishwasher: "Bulaşık makinesi",
    doorman: "Kapıcı",
    elevator: "Asansör",
    fireplace: "Şömine",
    fitness_center: "Spor Merkezi",
    garbage_disposal: "Çöp öğütücü",
    microwave: "Mikrodalga",
    online_app: "Çevrimiçi uygulama",
    oven: "Fırın",
    package_service: "Paket servisi",
    patio: "Veranda",
    pet_park: "Evcil park",
    refrigerator: "Buzdolabı",
    resident_lounge: "Yerleşik lounge",
    roof_deck: "Çatı güvertesi",
    secured_entry: "Güvenli giriş",
    storage: "Depolamak",
    walk_in_closet: "Gömme dolap",
    swimming_pool: "Yüzme havuzu",
    wheelchair_access: "Tekerlekli sandalye girişi",
    central_heating: "Merkezi ısıtma",
    invalid_bedrooms:
      "Geçersiz yatak odaları, lütfen yatak odalarını tekrar ayarlayın.",
    invalid_bathrooms: "Geçersiz banyolar, lütfen tekrar banyoları ayarlayın.",
    chinese_simplified_language: "Basitleştirilmiş Çince",
    chinese_traditional_language: "Çin geleneği",
    czech_language: "Çek",
    danish_language: "Danimarkalı",
    dutch_language: "Flemenkçe",
    finnish_language: "Fince",
    french_language: "Fransızca",
    german_language: "Almanca",
    greek_language: "Yunan",
    hungarian_language: "Macarca",
    indonesian_language: "Endonezyacı",
    italian_language: "İtalyan",
    japanese_language: "Japonca",
    korean_language: "Koreli",
    norwegian_language: "Norveççe",
    polish_language: "Lehçe",
    portuguese_language: "Portekizce",
    portuguese_brazilian_language: "Portekizce, Brezilya",
    romanian_language: "Romence",
    russian_language: "Rusça",
    swedish_language: "İsveççe",
    turkish_language: "Türkçe",
    ukrainian_language: "Ukrayna",
    urdu_pakistan_language: "Urduca (Pakistan)",
    vietnamese_language: "Vietnam",
    category_home_sale_or_rent: "Satılık ya da kiralık ev",
    square_meter: "Metrekare",
    copy_text: "Kopya",
    copyied_to_clipboard: "Panoya kopyalandı",
    inbox: "Gelen kutusu",
    input_title_listening: "Dinleme…",
    input_subtitle_listening: "Bir şey söyle",
    input_title_error: "Üzgünüz, bunu gerçekten almadık.",
    input_subtitle_error: "İsteğinizi tekrarlamayı deneyin.",
    input_hint_error: "Tekrar deneyin",
    price_less_than_or_equal: "Fiyatı daha az veya eşit",
    any_price: "Herhangi bir fiyat",
    any_condition: "Herhangi bir koşul",
    any_time: "İstediğin zaman",
    days_ago: "günler önce",
    any_distance: "Herhangi bir mesafe",
    distance_within: "İçindeki mesafe",
    new_notification: "Yeni Bildirim",
    deleted: "silindi",
    processing_image: "İşleme imajı",
    remove_dialog_message: "Bu ürünü gerçekten kaldırmak istiyor musun?",
    deleted_thread: "Bu mesaj silindi",
    category_yard_sale_event: "Yard Sale Etkinliği",
    yard_first_date: "Bahçe satış ilk buluşma",
    yard_second_date: "Bahçe Satışı İkinci Tarih",
    yard_third_date: "Bahçe satışı üçüncü tarih",
    yard_start_time: "Başlangıç ​​saati",
    yard_end_time: "Bitiş zamanı",
    yard_end_timestamp: "Son zaman damgası",
    invalid_date1: "Geçersiz ilk buluşma, lütfen ilk tarihi tekrar ayarlayın",
    invalid_start_time:
      "Geçersiz Başlangıç ​​Saati, lütfen başlangıç ​​saatini tekrar ayarlayın",
    invalid_end_time:
      "Geçersiz bitiş zamanı, lütfen son zamanını tekrar ayarlayın",
    yard_sale_title: "Depo satışı",
    garage_tag: "garaj",
    yard_tag: "avlu",
    from: "İtibaren",
    to: "İle",
    block: "Engellemek",
    un_block: "engeli kaldırmak",
    sign_email: "E-posta ile giriş yapın",
    invalid_first_date:
      "Geçersiz ilk buluşma, lütfen ilk tarihin ikinci ve üçüncü olduğundan emin olun.",
    invalid_second_date:
      "Geçersiz ikinci tarih, lütfen ikinci tarihin üçüncü tarihten önce olduğundan emin olun",
    invalid_start_time_value:
      "Geçersiz başlangıç ​​saati, lütfen başlangıç ​​saatinin bitmeden önce olduğundan emin olun",
    use_default_yard_photo: "Varsayılan bahçe satış fotoğrafını kullanın",
    active_label: "Aktif",
    enable_notifications: "Bildirimleri etkinleştir",
    login: "Giriş yapmak",
    january: "Ocak ayı",
    february: "Şubat",
    march: "Mart",
    april: "Nisan",
    may: "Mayıs ayı",
    june: "Haziran",
    july: "Temmuz",
    august: "Ağustos",
    september: "Eylül",
    october: "Ekim",
    november: "Kasım",
    december: "ARALIK AYI",
    since: "Dan beri",
    product_views: "Ürün Görünümleri",
    shop_views: "Dükkan manzarası",
    total_sales: "Toplam satış",
    total_orders: "Toplam Siparişler",
    last_twelvth_months: "Son on iki ay",
    last_nine_months: "Son dokuz ay",
    last_six_months: "Son altı ay",
    last_three_months: "Son üç ay",
    last_12_months: "Son 12 ay",
    last_9_months: "Son 9 ay",
    last_6_months: "Son 6 ay",
    last_3_months: "Son 3 ay",
    months: "Aylar",
    open: "Açık",
    reset_password: "Şifreyi yenile",
    create_new_shop: "Yeni dükkan yarat",
    download_app: "İndir uygulaması",
    log_in: "Giriş yapmak",
    sign_up: "Üye olmak",
    no_result: "Sonuç yok",
    max_price: "Maksimum Fiyat",
    max_distance: "Maksimum uzaklık",
    max_time: "Maksimum zaman",
    posted_less_than: "Daha az gönderildi",
    result: "Sonuç",
    more: "Daha",
    or: "VEYA",
    password: "Parola",
    forgot_password: "Parolanızı mı unuttunuz?",
    and: "ve",
    download_for: "İçin indir",
    apple_ios: "Elma ios",
    android: "Android",
    image: "Görüntü",
    edit_image: "Resmi Düzenle",
    please_complete: "Lütfen tamamla",
    enter_your_offer: "Teklifinizi girin",
    categories: "Kategoriler",
    upload_image: "Fotoğraf yükleniyor",
    upload_images: "Görüntüleri yükle",
    back: "Geri",
    see_more: "Daha fazla gör",
    add_product: "Ürün ekle",
    selected: "Seçilmiş",
    create: "Yaratmak",
    rate_the_buyer: "Alıcıyı değerlendir",
    delete_product: "Ürünü Sil",
    product: "Ürün",
    un_block_product: "Ürünün Engelini kaldır",
    share_your_product: "Ürününüzü paylaşın",
    boost_details: "Ayrıntıları Boost",
    remove_all_products: "Tüm Ürünleri Kaldır Ürünler",
    remove_all: "Hepsini kaldır",
    add_vehicle: "Araç ekle",
    edit_vehicle: "Aracın düzenle",
    upload_a_photo: "Bir fotoğraf yükle",
    view_details: "Detayları göster",
    add_yard_sale: "Bahçede satış ekle",
    edit_yard_sale: "YARD Satış Düzenle",
    users: "Kullanıcılar",
    users_details: "Kullanıcılar detayları",
    users_by_country: "Ülkeye göre kullanıcılar",
    blocked_users: "Engellenmiş kullanıcılar",
    products_cards: "Ürün Kartları",
    archived_products: "Arşivlenmiş Ürünler",
    blocked_products: "Engellenen ürünler",
    products_by_country: "Ülkeye göre ürünler",
    reports: "Bildiri",
    reports_details: "Detayları bildirir",
    closed_reports: "Kapalı raporlar",
    threads: "İş Parçacığı",
    threads_details: "Konular Detaylar",
    chat_support: "Sohbet desteği",
    actions: "Hareketler",
    search_actions: "Arama Eylemleri",
    product_view_actions: "Ürün Görünümü Eylemleri",
    contact_seller_product: "Satıcı Ürün ile iletişime geçin",
    contact_owner_shop: "İLETİŞİM ORTAK MAĞAZASI",
    ratings: "Derecelendirme",
    reviews: "Yorumlar",
    products_all_countries: "Ürünler Bütün ülkeler",
    edit_profile: "Profili Düzenle",
    my_profile: "Benim profilim",
    profile_updated_successfully: "Profil başarıyla güncellendi",
    are_you_sure: "Emin misin",
    my_used_products: "Kullanılmış ürünlerim",
    my_shops: "Benim dükkanlarım",
    my_boosted_products: "Artırılmış ürünlerim",
    messages_type_message_here: "Mesajınızı buraya yazın",
    messages_product_sold: "Bu ürün satıldı veya kaldırıldı",
    seen: "Görülen",
    messages_never_miss_message: "Bir mesajı asla kaçırmayın",
    enable: "Olanak vermek",
    send_notify: "Bildirmek",
    un_close: "Takas etmek",
    type_your_review: "Yorumunuzu yazın",
    again_question: "yine ?",
    ratings_already_submitted_review: "Zaten inceleme yaptınız",
    set_product_category: "Ürün kategorisini ayarla",
    auth_email_password_incorrect: "E-postanız veya şifreniz yanlış",
    auth_insert_your_name: "Lütfen adınızı ekleyin",
    auth_email_address_badly: "E-posta adresi kötü biçimlendirilmiş",
    auth_email_address_used:
      "E-posta adresi zaten başka bir hesap tarafından kullanılıyor",
    auth_invalid_password: "Şifre en az 6 karakter olmalıdır",
    auth_reset_email: "Şifrenizi sıfırlamak için e-postanızı girin",
    auth_check_email:
      "Lütfen şifreyi sıfırlamak için e-postanızı kontrol edin.",
    auth_can_sign_in_google: "Google düğmesiyle giriş yapabilirsiniz",
    auth_do_not_have_account: "Hesabın yok mu?",
    auth_have_account: "Hesabın var mı?",
    log_terms_privacy_part1:
      "Kaydolarak veya giriş yaparak, yanımda listelenenleri kabul edersiniz.",
    boost_this_product: "Bu ürünü artırmak?",
    product_successfully_boosted: "Ürün başarıyla artırıldı",
    product_failed_boost: "Ürün Boost'ta başarısız oldu",
    no_products_for_sale: "Şu anda satılık herhangi bir kullanılmış ürün yok.",
    not_sold_listed_near_me: "Yanımda listelenen satmadım",
    agree_add_product:
      "Ürününüzü yayınlamak için Gönder'e dokunarak, yanımda listelenen hizmet şartları ve Gizlilik Politikası'na katılıyorsunuz.",
    click_to_boost: "Artırmak için Ürüne Tıklayın",
    listed_terms_of_service: "Bana yakın hizmet şartları",
    receive_emails_for_users: "Kullanıcılar mesajları için e-posta alın",
    receive_emails_for_newly_posted:
      "Yeni yayınlanan ürünleriniz için e-posta alın",
    disable_push_notifications: "Push bildirimlerini devre dışı bırak",
    sms_during_day: "Gün boyunca SMS almak",
    sms_24_hours: "24 saat SMS al",
    products: "Ürün:% s",
    product_no_longer_available: "Üzgünüz, bu ürün artık mevcut değil",
    add_home: "Ev eklemek",
    edit_home: "Ev düzenlemek",
    fill_required_fields: "Gerekli tüm alanları doldurun",
    no_notification: "Bildirim yok",
    orders_history: "Sipariş geçmişi",
    privacy: "Mahremiyet",
    terms: "Terimler",
    report_a_problem: "Sorun bildir",
    approximation_protect_user_privacy:
      "Kullanıcının gizliliğini korumak için yaklaşım",
    do_not_have_products: "Ürünün yok",
    emails: "E-postalar",
    lead_deletion_products: "Bu, tüm ürünlerinizin silinmesine yol açacaktır.",
    confirm_legal_message:
      "Özellikle ilk kez şahsen bir yabancıyı karşılarken, diğerleriyle etkileşime girerken gerekli tüm önlemleri almaktan yalnızca sorumludur. Lütfen daha fazla ayrıntı için Hizmet Koşullarını gözden geçirin.",
    push_notifications_notified_instantly:
      "Anında bildirilmek üzere push bildirimlerini etkinleştirin",
    rate_seller: "Puan Satıcısı",
    user_journey: "Kullanıcı yolculuğu",
    user: "Kullanıcı",
    user_id: "Kullanıcı kimliği",
    action_id: "Eylem kimliği",
    select_model_car: "Araba modeli seçin",
    boost_1_day: "1 gün artırın",
    boost_3_days: "3 gün artırdı",
    boost_7_days: "7 gün artırmak",
    agree_boost_terms: "Boost'a dokunarak kabul edersiniz",
    add: "Eklemek",
    add_tag: "Etiket ekle",
    brand_title: "Marka",
    category_mobiles: "Cep telefonu",
    category_tablets: "Tabletler",
    screen_size: "Ekran boyutu",
    has_cellular_capability: "Hücresel yeteneğe sahiptir",
    default_internal_memory: "Dahili bellek",
    network_carrier: "Ağ taşıyıcısı",
    is_unlocked: "Kilidi açıldı",
    mobile_model_warning: "Lütfen önce markayı seçin",
    missing_image: "Eksik görüntü, tekrar resim ekle.",
    add_mobile: "Mobil ekle",
    edit_mobile: "Mobile düzenle",
    add_tablet: "Tablet ekle",
    edit_tablet: "Tableti düzenle",
    keywords:
      "alışveriş, satın almak, satmak, para kazanmak, ticaret, yerliler, komşular, otomobil, araçlar",
    country: "Ülke",
    phone_number: "Telefon numarası",
    verification_code: "Doğrulama kodu",
    error_occurred: "Bir hata oluştu, daha sonra tekrar deneyin",
    invalid_state:
      "Geçersiz Durum: Bir giriş geri çağrısı alındı, ancak giriş isteği gönderilmedi.",
    sign_in: "Kayıt olmak",
    sign_in_apple: "Apple ile giriş yapın",
    sign_in_google: "Google ile giriş yap",
    sign_in_phone: "Telefonla giriş yapın",
    sign_in_facebook: "Facebook ile giriş",
    create_account: "Hesap oluştur",
    email: "E-posta",
    invalid_field: "Lütfen gerekli alanları doldurunuz",
    code_sent: "Kod SMS tarafından gönderildi",
    verify_number: "Telefon numarasını doğrula",
    tapping_verify_number:
      "Dokunarak (telefon numarasını doğrulayın), bir SMS gönderilir.",
    email_exists:
      "Hesap zaten var ve Google düğmesi, Facebook düğmesi veya Apple düğmesi ile erişmeniz gerekir.",
    ok: "Tamam",
    sure_back: "Geri döndün mü?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "evvel",
    add_model: "Model ekle",
    no_search_results_us:
      "Yakınınızda 120 mil içinde arama sonucu yok. Arama filtresini değiştirmeye veya anahtar kelimesini arama.",
    no_search_results:
      "Yakınınızda 200 km içinde arama sonucu yok. Arama filtresini değiştirmeye veya anahtar kelimesini arama.",
    plan_date: "Plan tarihi",
    plan_time: "Plan zamanı",
    invalid_plan_date:
      "Geçersiz plan tarihi, lütfen plan tarihini tekrar ayarlayın",
    invalid_plan_time:
      "Geçersiz plan zamanı, lütfen plan zamanını tekrar ayarlayın",
    plan_name: "Plan Adı",
    plan_title: "Plan",
    update_plan_name: "Güncelleme Planı Adı",
    delete_plan_question: "Bu planı silmek istediğinizden emin misiniz?",
    plan_reminder_message: "Bir saat önce hatırlatılacaksın",
    plan_dialog_title: "Toplantı planı",
    planners_title: "Planlar",
    unable_sending_messages: "Mesajlarınızı çevrimiçi olduklarında görecekler.",
    its_text: "Onun",
    for_your_text: "alıcınız için.",
  },
  uk: {
    invalid_area: "Недійсна область, будь ласка, встановіть область знову.",
    invalid_lot_size:
      "Недійсний розмір власності, будь ласка, встановіть розмір лота.",
    property_area: "Площа нерухомості",
    app_store_name:
      "Перераховані поруч зі мною - Купуйте товари, продають за готівку",
    app_store_short:
      "Ринок для місцевих продавців. Перерахуйте товар для продажу та заробляйте гроші.",
    app_store_full:
      "Перераховані поруч зі мною полегшує пошук чудових пропозицій на те, що ви хочете, і заробляйте гроші на те, що ви хочете продати. Це найкращий спосіб купити та продавати у вашій громаді або околиці з людьми, яким ви можете довіряти. Як це працює: 1 - Купуйте або продавайте що-небудь; Легко розміщувати свої товари для продажу в секундах. 2 - Знайти великі угоди та знижки на одяг, меблі, стільникові телефони, електроніки, дитячі та дитячі предмети, спортивне обладнання, уживані автомобілі, сукні, взуття та годинники, до книг, іграшки, уживані ноутбуки, автомобільний автомобіль і навіть реальні Матеріал для продажу або оренди. 3- Переглянути місцеві товари для продажу. 4 - Повідомлення Покупці та продавці з-під час програми. 5 - Перегляньте елементи за зображенням та сортування за категоріями. Забавні факти про перелічені біля мене: 1- з переліченим поруч зі мною ви можете легко продати що-небудь, з одягу для використання автомобілів до електроніки. 2-комунікація між покупцями та продавцями відбувається через додаток через повідомлення. 3 - перераховані поруч зі мною краще, ніж продаж гаража; Знайдіть все, що ви хочете зі знижкою, прямо на телефоні або планшеті.",
    app_store_release:
      "Перераховані поруч зі мною - торгівля з місцевими жителями. Приєднуйтесь до мобільного ринку для місцевих покупців та продавців!",
    app_name: "Перераховані поруч зі мною",
    title_buy: "Купувати",
    title_messages: "Повідомлень",
    title_sell: "Продавати",
    title_profile_image: "Зображення профілю",
    title_account: "Обліковий запис",
    account_settings: "Налаштування аккаунта",
    settings: "Налаштування",
    color_theme: "Кольорова тема",
    device_settings: "Налаштування пристрою",
    public_profile: "Публічний профіль",
    light_mode: "Легкий режим",
    dark_mode: "Темний режим",
    title_sell_faster: "Продавати швидше",
    send_button_label: "Надсилати",
    rate_message: "Оцініть мене...",
    already_rated: "Ви вже подали огляд",
    rate_review_question: "Ви хотіли б мати справу",
    again: "знову?",
    action_logout: "Вийти",
    action_category: "Категорія",
    action_search: "Пошук",
    action_refer: "Зверніться до друга",
    dialog_choose_location: "Виберіть місцеположення",
    dialog_change_username: "Змінити ім'я користувача",
    dialog_change_language: "Змінити мову",
    dialog_image_tags: "Теги зображень",
    dialog_emails_notifications: "Повідомлення електронної пошти",
    dialog_push_notifications: "Повідомлення",
    fragment_product_detail: "Деталі продукту",
    fragment_message_details: "Повідомлення деталей",
    fragment_sell: "Продавати",
    dialog_tags_title: "Теги",
    dialog_location_title: "Розташування місцезнаходження",
    dialog_username_title: "Змінити ім'я користувача",
    tab_photo: "Фотографія",
    tab_details: "Деталі",
    tab_price: "Ціна",
    tab_finish: "Закінчити",
    profile: "Профіль",
    search: "Пошук",
    choose_product: "Виберіть продукт",
    rating_review: "Рейтинг та огляд",
    select_buyer: "Виберіть покупця",
    tab_my_used_products: "Мої продукти",
    price_label: "Ціна",
    text_savings: "Ви економите",
    search_hint: "Пошук продуктів ...",
    empty_text:
      "Немає жодних продуктів, перелічених у цій категорії або на вибраній відстані.",
    filter_menu_text: "Фільтрувати",
    error_contacting_seller: "Помилка Зв'язок з продавцем",
    edit_product: "Редагувати продукт",
    contact_seller: "Зв'язатися з продавцем",
    signup_to_contact_seller: "Зареєструватися, щоб зв'язатися з продавцем",
    signup_to_make_offer: "Зареєструйтеся, щоб зробити пропозицію",
    product_details: "Деталі",
    product_category: "Категорія",
    product_condition: "Хвороба",
    product_description: "Опис",
    product_location: "Розташування продукту",
    product_location_approximate: "Розташування є приблизним",
    over_week_time_ago: "Більше тижня тому",
    boosted: "Збільшений",
    threads_no_results: "Немає повідомлень",
    message_no_results: "Немає повідомлень",
    message_warning:
      "Ви несете повну відповідальність за вживання всіх необхідних запобіжних заходів під час взаємодії з іншими, особливо, коли вперше зустрічаються з незнайомцем. Будь ласка, не діліться будь -якою особистою інформацією, кодами перевірки чи будь -якою платіжною інформацією. Будь ласка, перегляньте умови послуги для отримання більш детальної інформації.",
    message_block:
      "Ви не можете надсилати або отримувати повідомлення в цей час.",
    select_location: "Виберіть місце розташування",
    location_permission_denied_message:
      "Додаток вимагає правильного дозволу на місце розташування.",
    signed_in: "Вхід!",
    sign_in_canceller: "Вхід скасовано",
    version: "Версія",
    build: "Будувати",
    name: "Назва",
    location: "Місцезнаходження",
    language: "Мову",
    about_app: "Про перелічені біля мене",
    terms_of_service: "Умови обслуговування",
    privacy_policy: "Політика конфіденційності",
    report_feedback: "Надіслати відгук",
    report_bug: "Потисніть телефон, щоб повідомити про помилку",
    change_image: "Змінити зображення",
    update_location: "Розташування місцезнаходження",
    about_the_app: "Про додаток",
    update_label: "Оновлення",
    uploading: "Завантаження",
    adding: "Додавання списку",
    removing: "Видалення списку",
    updating: "Оновлення списку",
    uploaded_image: "Завантажене зображення:",
    image_storage_failed: "Не вдалося зберегти зображення:",
    product_updated: "Продукт успішно оновлюється",
    location_error: "Розташування не збережено, спробуйте ще раз",
    product_removed: "Продукт успішно видаляється",
    deleted_product: "Цей продукт видаляється",
    invalid_title: "Недійсний заголовок, будь ласка, встановіть назву знову.",
    invalid_image:
      "Неправильний шлях зображення, спробуйте додати зображення знову.",
    invalid_price: "Недійсна ціна, будь ласка, встановіть ціну ще раз.",
    invalid_location:
      "Недійсне розташування, будь ласка, встановіть місце знову.",
    invalid_category:
      "Недійсна категорія, будь ласка, встановіть категорію знову.",
    invalid_condition: "Недійсний стан, будь ласка, встановіть стан знову.",
    removing_title: "Видалення зображення профілю",
    image_not_saved: "Image Зберегти не вдалося!",
    product_load_failed: "Немає продуктів",
    take_photo: "Сфотографувати",
    select_photo: "Виберіть фотографію",
    product_title_hint: "Що це? Назва, марка, модель та ін",
    delete_photo: "Видалити фото",
    product_title: "Заголовок",
    mark_as_sold: "Позначка як продається",
    product_share: "Частка",
    product_make_offer: "Зробити пропозицію",
    product_cover: "Встановити як обкладинка",
    product_tags: "Теги",
    product_posted: "Опубліковано:",
    product_change: "Зміна",
    product_post: "Пост",
    product_selling_from: "Продаж з місця розташування",
    product_select_location: "Виберіть місце розташування",
    product_map_approximate:
      "Карта є приблизною, щоб зберегти місцеположення продавця",
    product_terms:
      "Натиснувши пост, щоб опублікувати свій продукт, ви погоджуєтеся з <u>, перерахованим поруч зі мною. </ U>",
    condition_other: "Інше (див. Опис)",
    condition_for_parts: "Для деталей",
    condition_used: "Використовується (нормальний знос)",
    condition_open_box: "Відкрийте вікно (ніколи не використовується)",
    condition_reconditioned: "Реконструйований / сертифікований",
    condition_new: "Новий (ніколи не використовується)",
    select_category: "Виберіть категорію",
    select_all_category: "Вибрати все",
    category_loading_error:
      "Неможливо оновити список категорій, спробуйте пізніше.",
    category_vehicles: "Транспортні засоби",
    category_furniture: "Меблі",
    category_electronics: "Електроніка",
    category_appliances: "Головна &  Прилади",
    category_fashion_accessories: "Fashion &  Аксесуари",
    category_baby_kids: "Дитина &  Діти",
    category_antiques_collectibles: "Антикваріат &  Колекціонування",
    category_auto_parts_tools_machinery:
      "Автозапчастини, інструменти &  Машини",
    category_sports_outdoors: "Спорт &  На відкритому повітрі",
    category_others: "Інше",
    location_enter_zip_code: "Введіть поштовий індекс",
    location_get_current_location: "Отримати поточне місцезнаходження",
    location_select_location: "Виберіть місце розташування",
    location_update_location: "Розташування місцезнаходження",
    location_new_location: "Нове місце розташування",
    search_filter_results: "Результати фільтрації",
    search_filter_min: "Маленький фільтр",
    search_filter_at_least: "Принаймні",
    price_filter: "Фільтр цін",
    product_name: "Назва продукту",
    english_language: "Англійська мова",
    arabic_language: "Арабський",
    spanish_language: "Іспанський",
    system_language: "Система",
    share_link: "Розповсюдити посилання",
    save: "Урятувати",
    cancel: "Скасувати",
    loading: "Навантаження",
    yes: "Так",
    no: "Немає",
    report: "Доповідь",
    report_product: "Продукт звіту",
    report_user: "Користувач звіту",
    block_user: "Заблокувати користувача",
    un_block_user: "Розблокувати користувача",
    why_product: "Чому ви хочете повідомити цей елемент?",
    why_user: "Чому ви хочете повідомити цьому користувачеві?",
    block_user_confirm: "Ви хочете постійно заблокувати цей користувач?",
    un_block_user_confirm: "Ви хочете постійно розблокувати цей користувач?",
    prohibited: "Заборонено перераховано поруч зі мною",
    offensive: "Образливий або недоречний",
    duplicate: "Дублікати",
    wrong_category: "Неправильна категорія",
    scam: "Виглядає як шахрая",
    stolen: "Я думаю, що це вкрадено",
    product_other: "Інший",
    product_is_sold: "Цей продукт був проданий",
    missed_meeting: "Вони пропустили нашу зустріч",
    low_offer: "Зробив низьку пропозицію",
    rude: "Грубий або недоречний",
    items: "Проблема з елементами",
    trouble_meetup: "Проблема на зустрічі",
    messaging: "Проблеми обміну повідомленнями",
    user_other: "Інший",
    new_version_available: "Нова версія доступна",
    please_update_app:
      "Будь ласка, оновіть програму до нової версії, щоб продовжити.",
    update: "Оновлення",
    no_thanks: "Ні, дякую",
    contact_support_confirmation:
      "Час поточного відгуку становить 24-48 годин. Хочете зв'язатися з переліком поблизу мене підтримати чат програми?",
    unboost_confirmation: "Ви впевнені, що хочете, щоб unboost цей продукт?",
    no_used_products: "У вас ще немає списків",
    no_boosted_products: "У вас немає прийомів продуктів",
    next: "Наступний",
    previous: "Попередній",
    skip: "Пропускати",
    start: "Почати",
    list_used: "Перерахуйте використаний продукт",
    buy_description:
      "Відкрийте та шукати продукти, що пропонуються сусідами навколо вас",
    sell_description:
      "Перелічіть продукти, які ви більше не потребуєте для продажу",
    list_used_description:
      "Перерахуйте використаний продукт для продажу менш ніж за 20 секунд",
    boost_product_option_1: "<b> boost 1  t </ b>  n  n <b> $ 0.99 </ b>",
    boost_product_option_2: "<b> boost 3  n'tdays </ b>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<b> boost 7  n'tdays </ b>  n  n <b> $ 3.99 </ b>",
    boost_product_description:
      "Отримайте більше переглядів кожен день. Ваш товар буде відображатися в популярних позиціях у верхній частині 30 елементів у покупці та категорії. Пропоновані елементи обертаються серед призначених місць, тому кожен елемент отримує справедливе вирахування.",
    boost_cta: "Продавати швидше",
    boost_terms:
      "Натиснувшись, ви погоджуєтеся з наданням послуг <u>, перераховано поблизу мене. </ U>",
    boost_best_value: "Найкраща ціна",
    already_boosted: "Цей продукт посилюється",
    clicks: "Кліки",
    impressions: "Враження",
    end: "Кінець",
    transactions_empty_text:
      'У вас ще немає ніяких підсилювальних операцій. Ви можете відвідати вкладку "Продавати" та почати посилити свої продукти.',
    transactions_loading_error:
      "Неможливо оновити список транзакцій, спробуйте пізніше.",
    transactions_history_title: "Збільшення історії транзакцій",
    communicative_postive: "Комунікативний",
    communicative_negative: "Некомпунівний",
    ontime_postive: "Вчасно",
    ontime_negative: "Пізно",
    reliable_postive: "Надійний",
    reliable_negative: "Ненадійний",
    friendly_postive: "Дружній",
    friendly_negative: "Неввічливий",
    itemasdescribed_postive: "Пункт, як описано",
    itemasdescribed_negative: "Пункт не описаний",
    other: "Інший",
    submit: "Подавати",
    adding_rating_reviews: "Додавання рейтингу та відгуків",
    no_internet_title: "Немає підключення до Інтернету",
    no_internet_message:
      "Переконайтеся, що ви підключені до Інтернету та повторіть спробу",
    retry: "Повторити",
    near_me: "Коло мене",
    newest_first: "Новітні перші",
    miles: "милі",
    km: "км",
    similar_products: "Подібні товари",
    favorite_products: "Улюблені продукти",
    items_for_sale: "Елементи для продажу",
    joined: "Приєднаний",
    favorites_transactions_title: "Фаворит",
    boosted_products_transactions_history: "Збільшена історія транзакцій",
    views: "Вигляд",
    boost_graph_title: "Підвищення графіка",
    no_favorite_products: "У вас немає жодних улюблених продуктів",
    make_offer_buy: "Я хотів би купити",
    make_offer_buy_for: "за",
    notifications: "Сповіщення",
    push_notifications: "Штовхати",
    emails_notifications: "Електронна пошта",
    apply: "Застосовувати",
    email_messages: "Електронна пошта для повідомлень",
    email_new_products: "Електронна пошта для нових продуктів",
    push_day_only: "Тільки день сповіщень",
    push_24_hours: "Push Notifications 24 години",
    edit: "Редагувати",
    map: "Карта",
    camera: "Камеру",
    gallery: "Галерея",
    delete: "Видаляти",
    no_sell_items: "Немає елементів для продажу",
    who_bought_question: "Хто його купив?",
    sold_elsewhere_question: "Продано його де-небудь ще",
    confirm: "Підтверджувати",
    over_limit_camera: "Ви не можете додати більше п'яти зображень",
    boost_failed: "Postost не вдалося. Будь-ласка спробуйте пізніше",
    after_purchase: "Оплата успішного  nпродукт",
    pay_failed: "Не вдалося оплатити. Будь ласка спробуйте ще раз",
    done: "Зроблений",
    not_now: "Не зараз",
    boost: "Підсилювач",
    invalid_zip_code: "Недійсний поштовий індекс",
    invalid_user_name: "Невірне ім'я користувача",
    comments: "Коментарі",
    questions: "Запитання",
    bug_reports: "Звіти про помилки",
    feature_request: "Запит на функцію",
    feedback_type: "Тип зворотного зв'язку",
    feedback_description:
      "Ми хотіли б почути ваші думки або відгуки про те, як ми можемо покращити свій досвід!",
    feedback: "Зворотний зв'язок",
    feedback_text: "Ваша відповідь",
    suggestions: "Пропозиції щодо вдосконалення",
    delete_account: "Видалити аккаунт",
    new_message: "Нове повідомлення",
    online: "Онлайн",
    km_50: "50 км",
    km_100: "100 км",
    km_200: "200 км",
    miles_30: "30 миль",
    miles_60: "60 миль",
    miles_120: "120 миль",
    rate_app_question: "Як щодо рейтингу в App Store, то?",
    enjoying_question: "Насолоджуючись переліком поруч зі мною?",
    not_enjoy: "Не зовсім",
    feedback_question: "Чи не могли б ви дати нам деякий відгук?",
    yes_sure: "Так, звісно",
    product_available_question: "Привіт, це все ще доступне?",
    buy_question: "Привіт, я хотів би купити це",
    meet_question: "Привіт, ви можете зустрітися сьогодні?",
    follow: "Слідувати",
    followers: "Послідовники",
    following: "Наступний",
    feedback_thanks: "Дякуємо за ваш відгук",
    all_categories: "всі категорії",
    deleted_account: "Цей обліковий запис видалено",
    delete_account_question:
      "Ви впевнені, що хочете видалити цей обліковий запис?",
    no_followings: "не слідувати нікому",
    when_following: "коли",
    no_followings_subtitle: "слідує за людьми, ви побачите їх тут",
    no_followers: "не має послідовників",
    no_followers_subtitle: "слідом за людьми, ви побачите їх тут",
    distance: "Відстань",
    filter_method: "Метод фільтра",
    see_listings: "Див",
    sold: "Проданий",
    bought: "Куплений",
    no_notifications: "Коли ви отримуєте сповіщення, вони з'являться тут",
    items_title: "Предмети",
    new_listing_title: "Створити новий список",
    dialog_year_title: "Рік",
    dialog_make_title: "Робити",
    dialog_model_title: "Модель",
    dialog_body_style_title: "Стиль тіла",
    dialog_exterior_color_title: "Зовнішній колір",
    dialog_interior_color_title: "Інтер'єр кольору",
    dialog_transmission_title: "Спосіб передавання",
    dialog_fuel_type_title: "Тип палива",
    dialog_owners_num_title: "Кількість власників",
    dialog_vehicle_owed_money_title: "Чи є гроші на цьому автомобілі?",
    automatic_transmission: "Автоматичний",
    manual_transmission: "Посібник",
    not_sure: "Не впевнений",
    wagon_hatchback: "Wagon &  Хетчбек",
    convertible: "Конвертований",
    coupe: "Купе",
    sedan: "Седан",
    black_color: "Чорний",
    blue_color: "Синій",
    brown_color: "Коричневий",
    gold_color: "Золото",
    green_color: "Зелений",
    grey_color: "Сірий",
    pink_color: "Рожевий",
    purple_color: "Пурпурний",
    red_color: "Червоний",
    silver_color: "Срібло",
    orange_color: "Помаранчевий",
    white_color: "Білий",
    yellow_color: "Жовтий",
    charcol_color: "Чагарник",
    fuel_diesel: "Дизель",
    fuel_electric: "Електричний",
    fuel_gasoline: "Бензин",
    fuel_flex: "Гнучкий",
    fuel_hybrid: "Гібрид",
    fuel_petrol: "Бензин",
    fuel_plugin_hybrid: "Гібрид плагін",
    truck: "Вантажівка",
    van_minivan: "Van &  Мініверський",
    suv_crossover: "Suv &  Кросовер",
    awd_4wd: "AWD / 4WD",
    fwd: "Відбиток",
    rwd: "Вигодовувати",
    off_white_color: "З білого кольору",
    tan_color: "Засмаг",
    beige_color: "Бежевий",
    burgundy_color: "Бургундський",
    turquoise_color: "Бірюзовий",
    title_status_clean: "Чистий",
    title_status_rebuilt: "Перебудований",
    title_status_salvage: "Порятунок",
    title_status_missing: "Відсутній",
    title_status_lien: "Застава",
    title_status: "Статус назви",
    mileage: "Пробіг",
    dialog_drivetrain_title: "Примикання",
    model_warning: "Виберіть перший",
    required_field_warning: "Це поле є обов'язковим",
    vehicle_vin: "Віч",
    invalid_vin: "Недійсний VIN, будь ласка, встановіть Vin знову.",
    invalid_mileage: "Недійсний пробіг, будь ласка, встановіть пробіг знову.",
    clean_description: "Більшість транспортних засобів, які не були в аварії",
    rebuilt_description: "Врятований автомобіль, який був перебудований",
    salvage_description: "Вважається загальним після аварії",
    missing_description: "Потребуватиме нового титулу видань DMV",
    lien_description: "Володіє поселенням банку або суду",
    nearme: "Коло мене",
    newest: "Новітній",
    contact_support: "Контактна підтримка",
    create_home_title: "Будинки для продажу або оренди",
    for_sale: "На продаж",
    for_rent: "В оренду",
    property_type: "Тип нерухомості",
    apartment: "Квартира",
    house: "Будинок",
    room_only: "Тільки номер",
    townhouse: "Таунхаус",
    bedrooms: "Спальні",
    bathrooms: "Ванні кімнати",
    property_address: "Адреса нерухомості",
    price_per_month: "Ціна за місяць",
    square_feet: "Квадратних футів",
    year_built: "Побудований рік",
    year_renovated: "Рік відреставрований",
    lot_size: "Розмір лоту",
    laundry_type: "Пральня",
    in_unit_laundry: "У одиночній білизні",
    laundry_building: "Пральня в будівництві",
    laundry_available: "Пральня доступна",
    none: "Ніякий",
    parking_type: "Тип паркування",
    garage_parking: "Гараж Парковка",
    street_parking: "Вулична стоянка",
    off_street_parking: "Парковка поза вулицею",
    available_parking: "Доступно парковка",
    air_cond_type: "Тип кондиціонування",
    ac_available: "AC доступний",
    central_ac: "Центральний змін",
    heating_type: "Тип опалення",
    electric_heating: "Електричне опалення",
    gas_heating: "Газове опалення",
    radiator_heating: "Опалення радіатора",
    available_heating: "Опалення",
    amenities: "Зручності",
    date_available: "Доступна дата",
    lease_length: "Довжина лізингу",
    month_to_month: "Місяць до місяця",
    three_months: "3 місяці",
    six_months: "6 місяців",
    one_year: "1 рік",
    more_one_year: "1+ років",
    cat_friendly: "Котячий",
    dog_friendly: "Дружній собака",
    balcony: "Балкон",
    basement: "Підвал",
    bike_parking: "Велосипед паркування",
    cable_tv: "Кабельне телебачення",
    ceiling_fan: "Вентилятор на стелі",
    concierge: "Консьєрж",
    dishwasher: "Посудомийна машина",
    doorman: "Доріг",
    elevator: "Ліфт",
    fireplace: "Камін",
    fitness_center: "Фітнес-центр",
    garbage_disposal: "Вивіз сміття",
    microwave: "Мікрохвильова піч",
    online_app: "Онлайн-заявка",
    oven: "Духовка",
    package_service: "Пакет",
    patio: "Патіо",
    pet_park: "Парк",
    refrigerator: "Холодильник",
    resident_lounge: "Резидентський лаунж",
    roof_deck: "Дах",
    secured_entry: "Захищений запис",
    storage: "Зберігання",
    walk_in_closet: "Ходити в туалет",
    swimming_pool: "Басейн",
    wheelchair_access: "Інвалідна коляска",
    central_heating: "Центральне опалення",
    invalid_bedrooms: "Недійсні спальні, будь ласка, встановіть спальні знову.",
    invalid_bathrooms:
      "Недійсні ванні кімнати, будь ласка, встановіть ванні кімнати знову.",
    chinese_simplified_language: "Китайський спрощений",
    chinese_traditional_language: "Китайський традиційний",
    czech_language: "Чеська",
    danish_language: "Данська мова",
    dutch_language: "Голландський",
    finnish_language: "Фінський",
    french_language: "Французький",
    german_language: "Німецький",
    greek_language: "Грецький",
    hungarian_language: "Угорський",
    indonesian_language: "Індонезійський",
    italian_language: "Італійський",
    japanese_language: "Японський",
    korean_language: "Корейський",
    norwegian_language: "Норвезький",
    polish_language: "Польський",
    portuguese_language: "Португальська мова",
    portuguese_brazilian_language: "Португальська, бразильська",
    romanian_language: "Румунський",
    russian_language: "російський",
    swedish_language: "Шведський",
    turkish_language: "Турецький",
    ukrainian_language: "Український",
    urdu_pakistan_language: "Урду (Пакистан)",
    vietnamese_language: "В'єтнамський",
    category_home_sale_or_rent: "Будинок для продажу або оренди",
    square_meter: "Квадратний метр",
    copy_text: "Копіювати",
    copyied_to_clipboard: "Скопійовано в буфер обміну",
    inbox: "Папця",
    input_title_listening: "Прослуховування ...",
    input_subtitle_listening: "Скажи що-небудь",
    input_title_error: "На жаль, ми не зробили це.",
    input_subtitle_error: "Спробуйте повторити свій запит.",
    input_hint_error: "Повторіть спробу",
    price_less_than_or_equal: "Ціна менше або дорівнює",
    any_price: "Будь-яка ціна",
    any_condition: "Будь-який стан",
    any_time: "У будь-який час",
    days_ago: "днів тому",
    any_distance: "Будь-яка відстань",
    distance_within: "Відстань всередині",
    new_notification: "Нове повідомлення",
    deleted: "Видалений",
    processing_image: "Обробка зображення",
    remove_dialog_message: "Ви дійсно хочете видалити цей продукт?",
    deleted_thread: "Це повідомлення видалено",
    category_yard_sale_event: "Подія продажу дворів",
    yard_first_date: "ДЕРЖАВА ПЕРШИЙ ДАТА",
    yard_second_date: "ДЕРЖАВНА ДАТО",
    yard_third_date: "ДЕРЖАВА ПРОДАЖ ТІЛЬКИ ДАТИ",
    yard_start_time: "Час початку",
    yard_end_time: "Закінчення часу",
    yard_end_timestamp: "Кінець мітки",
    invalid_date1:
      "Недійсна перша дата, будь ласка, встановіть першу дату знову",
    invalid_start_time:
      "Недійсний час початку, будь ласка, встановіть час початку",
    invalid_end_time:
      "Недійсний час закінчення, будь ласка, встановіть час закінчення",
    yard_sale_title: "Гаражний розпродаж",
    garage_tag: "гараж",
    yard_tag: "двір",
    from: "Від",
    to: "До",
    block: "Блок",
    un_block: "Розблокувати",
    sign_email: "Увійдіть у систему електронною поштою",
    invalid_first_date:
      "Недійсна перша дата, будь ласка, переконайтеся, що перша дата до другого та третього",
    invalid_second_date:
      "Недійсна друга дата, будь ласка, переконайтеся, що друга дата до третього дати",
    invalid_start_time_value:
      "Недійсний час початку, будь ласка, переконайтеся, що час початку - до закінчення часу",
    use_default_yard_photo: "Використовуйте фото за умовчанням",
    active_label: "Активний",
    enable_notifications: "Увімкнути сповіщення",
    login: "Вхід",
    january: "Січень",
    february: "Лютий",
    march: "Березня",
    april: "Квітня",
    may: "Може",
    june: "Червень",
    july: "Липень",
    august: "Серпень",
    september: "Вересень",
    october: "Жовтень",
    november: "Листопад",
    december: "Грудень",
    since: "З тих пір",
    product_views: "Вид продукту",
    shop_views: "Вид на магазин",
    total_sales: "Загальний обсяг продажів",
    total_orders: "Загальні замовлення",
    last_twelvth_months: "Останні дванадцять місяців",
    last_nine_months: "Останні дев'ять місяців",
    last_six_months: "Останні шість місяців",
    last_three_months: "Останні три місяці",
    last_12_months: "Останні 12 місяців",
    last_9_months: "Останні 9 місяців",
    last_6_months: "Останні 6 місяців",
    last_3_months: "Останні 3 місяці",
    months: "Місяці",
    open: "відчинено",
    reset_password: "Скинути пароль",
    create_new_shop: "Створити новий магазин",
    download_app: "Завантажити додаток",
    log_in: "Увійти",
    sign_up: "Зареєструватися",
    no_result: "Немає результату",
    max_price: "Максимальна ціна",
    max_distance: "Максимальна відстань",
    max_time: "Макс",
    posted_less_than: "Розміщено менше",
    result: "Результат",
    more: "Більше",
    or: "Або",
    password: "Пароль",
    forgot_password: "Забули пароль?",
    and: "і",
    download_for: "Завантажити",
    apple_ios: "Apple iOS",
    android: "Андроїд",
    image: "Образ",
    edit_image: "Редагувати зображення",
    please_complete: "Будь ласка, заповніть",
    enter_your_offer: "Введіть свою пропозицію",
    categories: "Категорії",
    upload_image: "Завантажити зображення",
    upload_images: "Завантажте зображення",
    back: "Замикання",
    see_more: "Побачити більше",
    add_product: "Додати продукт",
    selected: "Обраний",
    create: "Створювати",
    rate_the_buyer: "Оцініть покупця",
    delete_product: "Видалити продукт",
    product: "Продукт",
    un_block_product: "Розблокувати продукт",
    share_your_product: "Поділіться своїм продуктом",
    boost_details: "Підвищення деталей",
    remove_all_products: "Видалити всі продукти",
    remove_all: "Видалити всі",
    add_vehicle: "Додати транспортний засіб",
    edit_vehicle: "Редагувати автомобіль",
    upload_a_photo: "Завантажте фотографію",
    view_details: "Докладніше",
    add_yard_sale: "Додати дворні продаж",
    edit_yard_sale: "Редагувати продаж двору",
    users: "Користувачі",
    users_details: "Інформація про користувачі",
    users_by_country: "Користувачі по країні",
    blocked_users: "Заблоковані користувачі",
    products_cards: "Картки продуктів",
    archived_products: "Архівовані продукти",
    blocked_products: "Заблоковані продукти",
    products_by_country: "Продукти по країні",
    reports: "Доповідь",
    reports_details: "Звіти Детальніше",
    closed_reports: "Закриті звіти",
    threads: "Нитки",
    threads_details: "Нитки деталі",
    chat_support: "Підтримка чату",
    actions: "Акції",
    search_actions: "Пошук Дії",
    product_view_actions: "Дії перегляду продукту",
    contact_seller_product: "Зв'язатися з продавцем",
    contact_owner_shop: "Інтернет-магазин",
    ratings: "Рейтинги",
    reviews: "Відгуки",
    products_all_countries: "Продукція Всі країни",
    edit_profile: "Редагувати профіль",
    my_profile: "Мій профіль",
    profile_updated_successfully: "Профіль успішно оновлюється",
    are_you_sure: "Ти впевнений",
    my_used_products: "Мої використовувані продукти",
    my_shops: "Мої магазини",
    my_boosted_products: "Мої прискорені продукти",
    messages_type_message_here: "Введіть повідомлення тут",
    messages_product_sold: "Цей продукт продається або видаляється",
    seen: "Видно",
    messages_never_miss_message: "Ніколи не пропустіть повідомлення",
    enable: "Дозволяти",
    send_notify: "Надсилати повідомлення",
    un_close: "Нерозумний",
    type_your_review: "Введіть свій відгук",
    again_question: "знову?",
    ratings_already_submitted_review: "Ви вже подали огляд",
    set_product_category: "Встановіть категорію продукту",
    auth_email_password_incorrect:
      "Вашу електронну пошту або пароль неправильно",
    auth_insert_your_name: "Вставте своє ім'я",
    auth_email_address_badly: "Адреса електронної пошти погано відформатована",
    auth_email_address_used:
      "Адреса електронної пошти вже використовується іншим обліковим записом",
    auth_invalid_password: "Пароль повинен бути не менше 6 символів",
    auth_reset_email: "Введіть свою електронну пошту, щоб скинути пароль",
    auth_check_email:
      "Будь ласка, перевірте свою електронну пошту, щоб скинути пароль",
    auth_can_sign_in_google: "Ви можете увійти в систему Google",
    auth_do_not_have_account: "У вас немає облікового запису?",
    auth_have_account: "Чи є у вас рахунок?",
    log_terms_privacy_part1:
      "Підписавшись або увійшовши, ви погоджуєтеся з перерахованим поруч зі мною",
    boost_this_product: "Підвищити цей продукт?",
    product_successfully_boosted: "Продукт успішно збільшений",
    product_failed_boost: "Продукт не вдалося підробити",
    no_products_for_sale:
      "Наразі у вас немає використаних продуктів, перелічених для продажу.",
    not_sold_listed_near_me: "Я не продавав його на перераховані поруч зі мною",
    agree_add_product:
      "Натиснувши пост, щоб опублікувати свій продукт, ви погоджуєтеся з перерахованим поблизу MES.",
    click_to_boost: "Натисніть на продукт, щоб збільшити його",
    listed_terms_of_service: "Перераховані поруч зі мною Умови надання послуг",
    receive_emails_for_users:
      "Отримувати електронні листи для повідомлень користувачів",
    receive_emails_for_newly_posted:
      "Отримуйте електронні листи для новоутворених продуктів",
    disable_push_notifications: "Відключити сповіщення",
    sms_during_day: "Отримайте SMS протягом дня",
    sms_24_hours: "Отримайте SMS 24 години",
    products: "Продукти",
    product_no_longer_available: "На жаль, цей продукт більше не доступний",
    add_home: "Додати додому",
    edit_home: "Редагувати додому",
    fill_required_fields: "Заповніть всі необхідні поля",
    no_notification: "Немає повідомлень",
    orders_history: "Історія замовлень",
    privacy: "Конфіденційність",
    terms: "Умови",
    report_a_problem: "Повідомити про проблему",
    approximation_protect_user_privacy:
      "Наближення для захисту конфіденційності користувача",
    do_not_have_products: "У вас немає продуктів",
    emails: "Електронна пошта",
    lead_deletion_products: "Це призведе до видалення всіх ваших продуктів",
    confirm_legal_message:
      "Ви несете виключну відповідальність за прийняття всіх необхідних запобіжних заходів при взаємодії з іншими, особливо під час зустрічі незнайомця вперше. Будь ласка, перегляньте умови надання послуг для отримання додаткової інформації.",
    push_notifications_notified_instantly:
      "Увімкнути сповіщення, щоб миттєво отримувати сповіщення",
    rate_seller: "Ставка продавця",
    user_journey: "Подорож користувача",
    user: "Користувач",
    user_id: "Ідентифікатор користувача",
    action_id: "Ідентифікатор дії",
    select_model_car: "Виберіть модель автомобіля",
    boost_1_day: "Збільшити 1 день",
    boost_3_days: "Збільшити 3 дні",
    boost_7_days: "Збільшити 7 днів",
    agree_boost_terms: "Шляхом натискання, ви погоджуєтеся",
    add: "Додавати",
    add_tag: "Додати тег",
    brand_title: "Марка",
    category_mobiles: "Мобиль",
    category_tablets: "Таблетки",
    screen_size: "Розмір екрану",
    has_cellular_capability: "Має клітинну здатність",
    default_internal_memory: "Внутрішня пам'ять",
    network_carrier: "Мережевий носій",
    is_unlocked: "Розблоковано",
    mobile_model_warning: "Спочатку виберіть бренд",
    missing_image: "Відсутні зображення, спробуйте додати зображення знову.",
    add_mobile: "Додати мобільний",
    edit_mobile: "Редагувати мобільний",
    add_tablet: "Додати таблетку",
    edit_tablet: "Редагувати планшет",
    keywords:
      "Покупки, купити, продавати, заробляти гроші, торгівля, місцеві жителі, сусіди, авто, транспортні засоби",
    country: "Країна",
    phone_number: "Номер телефону",
    verification_code: "Код підтвердження",
    error_occurred: "Сталася помилка. Будь ласка, спробуйте ще раз пізніше",
    invalid_state:
      "Недійсна держава: отримано зворотний дзвінок, але не було надіслано жодного запиту входу.",
    sign_in: "Увійти",
    sign_in_apple: "Увійдіть з Apple",
    sign_in_google: "Увійдіть у Google",
    sign_in_phone: "Увійдіть за допомогою телефону",
    sign_in_facebook: "Увійдіть у Facebook",
    create_account: "Створити аккаунт",
    email: "Електронна пошта",
    invalid_field: "Будь ласка, заповніть необхідні поля",
    code_sent: "Код надіслано SMS",
    verify_number: "Перевірте номер телефону",
    tapping_verify_number:
      "Натиснувши (перевіряйте номер телефону), SMS буде надіслано.",
    email_exists:
      "Рахунок вже існує, і вам потрібно отримати доступ до нього через кнопку Google, кнопку Facebook або кнопку Apple",
    ok: "Добре",
    sure_back: "Ви впевнені, що повернулися?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "тому",
    add_model: "Додати модель",
    no_search_results_us:
      "Немає результатів пошуку поблизу вас протягом 120 миль. Спробуйте змінити ключове слово пошуку або пошук.",
    no_search_results:
      "Немає результатів пошуку поблизу вас протягом 200 км. Спробуйте змінити ключове слово пошуку або пошук.",
    plan_date: "Дата планування",
    plan_time: "Планувати час",
    invalid_plan_date:
      "Недійсна дата плану, будь ласка, встановіть дату плану ще раз",
    invalid_plan_time:
      "Недійсний час плану, будь ласка, встановіть час плану ще раз",
    plan_name: "Назва плану",
    plan_title: "Планувати",
    update_plan_name: "Назва плану оновлення",
    delete_plan_question: "Ви впевнені, що хочете видалити цей план?",
    plan_reminder_message: "Вам буде нагадати за годину раніше",
    plan_dialog_title: "План зустрічей",
    planners_title: "Планувальники",
    unable_sending_messages:
      "Вони побачать ваші повідомлення, коли вони повернуться в Інтернет.",
    its_text: "Його",
    for_your_text: "для вашого одержувача.",
  },
  "ur-PK": {
    invalid_area: "غلط علاقے، براہ کرم دوبارہ علاقے مقرر کریں.",
    invalid_lot_size:
      "غلط جائیداد بہت سائز، براہ مہربانی دوبارہ بہت سائز مقرر کریں.",
    property_area: "پراپرٹی کے علاقے",
    app_store_name:
      "میرے قریب درج کردہ - استعمال شدہ اشیاء خریدیں، نقد رقم کے لئے فروخت کریں",
    app_store_short:
      "مقامی بیچنے والے کے لئے ایک مارکیٹ. فروخت کے لئے ایک آئٹم کی فہرست اور پیسہ کمائیں.",
    app_store_full:
      "میرے قریب درج کردہ چیزوں پر آپ کو فروخت کرنا چاہتے ہیں پر بہت سودے تلاش کرنا آسان بناتا ہے. یہ آپ کے کمیونٹی یا پڑوس میں خریدنے اور فروخت کرنے کا بہترین طریقہ ہے جو آپ پر اعتماد کر سکتے ہیں. یہ کیسے کام کرتا ہے: 1- کچھ خریدیں یا فروخت کریں؛ آسانی سے سیکنڈ میں فروخت کے لئے اپنی اشیاء کو پوسٹ کریں. 2- کپڑے، فرنیچر، سیل فونز، الیکٹرانکس، بچے اور بچوں کی اشیاء، کھیلوں کا سامان، استعمال کاروں، کپڑے، جوتے، اور گھڑیاں، استعمال شدہ کاریں، کپڑے، جوتے، اور گھڑیاں، استعمال شدہ کھلونے، استعمال کردہ لیپ ٹاپ، ایک دوسری گاڑی اور یہاں تک کہ حقیقی پر بہت سودے اور چھوٹ تلاش کریں. فروخت یا کرایہ کے لئے اسٹیٹ. 3- فروخت کے لئے مقامی اشیاء کو براؤز کریں. 4- ایپ کے اندر سے پیغام خریداروں اور بیچنے والے. 5- تصویر کی طرف سے اشیاء کو براؤز کریں اور قسم کے ذریعے ترتیب دیں. میرے قریب درج ذیل کے بارے میں مذاق حقائق: 1- میرے قریب درج ذیل کے ساتھ آپ آسانی سے کسی بھی چیز کو فروخت کرسکتے ہیں، کپڑے سے الیکٹرانکس کو کاروں کا استعمال کرتے ہیں. 2- خریداروں اور بیچنے والے کے درمیان مواصلات پیغام رسانی کے ذریعہ اپلی کیشن کے ذریعہ ہوتا ہے. 3- میرے قریب درج کردہ گیراج کی فروخت سے بہتر ہے؛ آپ کے فون یا ٹیبلٹ پر رعایت پر جو کچھ آپ چاہتے ہیں تلاش کریں.",
    app_store_release:
      "میرے قریب درج - مقامی لوگوں کے ساتھ تجارت. مقامی خریداروں اور بیچنے والے کے لئے موبائل مارکیٹ میں شمولیت اختیار کریں!",
    app_name: "میرے قریب درج",
    title_buy: "خریدنے",
    title_messages: "پیغامات",
    title_sell: "فروخت",
    title_profile_image: "پروفائل تصویر",
    title_account: "کھاتہ",
    account_settings: "اکاؤنٹ کی ترتیبات",
    settings: "ترتیبات",
    color_theme: "رنگین تھیم",
    device_settings: "ڈیوائس کی ترتیبات",
    public_profile: "عوامی پروفائل",
    light_mode: "روشنی موڈ",
    dark_mode: "گہرا موڈ",
    title_sell_faster: "تیزی سے فروخت",
    send_button_label: "بھیجیں",
    rate_message: "میری درجہ بندی کرو...",
    already_rated: "آپ نے پہلے ہی جائزہ لیا پیش کیا",
    rate_review_question: "کیا آپ سے نمٹنے کے لئے پسند کریں گے",
    again: "ایک بار پھر؟",
    action_logout: "لاگ آوٹ",
    action_category: "قسم",
    action_search: "تلاش",
    action_refer: "دوست کا حوالہ دیں",
    dialog_choose_location: "مقام منتخب کریں",
    dialog_change_username: "صارف کا نام تبدیل کریں",
    dialog_change_language: "زبان تبدیل کریں",
    dialog_image_tags: "تصویری ٹیگز",
    dialog_emails_notifications: "ای میل اطلاعات",
    dialog_push_notifications: "پش اطلاعات",
    fragment_product_detail: "مصنوعات کی تفصیل",
    fragment_message_details: "پیغامات تفصیل",
    fragment_sell: "فروخت",
    dialog_tags_title: "ٹیگز",
    dialog_location_title: "مقام اپ ڈیٹ کریں",
    dialog_username_title: "صارف کا نام تبدیل کریں",
    tab_photo: "تصویر",
    tab_details: "تفصیلات",
    tab_price: "قیمت",
    tab_finish: "ختم",
    profile: "پروفائل",
    search: "تلاش",
    choose_product: "مصنوعات کا انتخاب کریں",
    rating_review: "درجہ بندی اور جائزہ",
    select_buyer: "خریدار کو منتخب کریں",
    tab_my_used_products: "میری مصنوعات",
    price_label: "قیمت",
    text_savings: "اپ بچت کریں",
    search_hint: "مصنوعات کے لئے تلاش کریں ...",
    empty_text:
      "اس زمرے میں یا منتخب کردہ فاصلے کے اندر اندر کوئی مصنوعات نہیں ہیں.",
    filter_menu_text: "فلٹر",
    error_contacting_seller: "بیچنے والے سے رابطہ کرنے میں خرابی",
    edit_product: "مصنوعات میں ترمیم کریں",
    contact_seller: "رابطہ بیچنے والے",
    signup_to_contact_seller: "بیچنے والے سے رابطہ کرنے کے لئے سائن اپ کریں",
    signup_to_make_offer: "پیشکش کرنے کے لئے سائن اپ کریں",
    product_details: "تفصیلات",
    product_category: "قسم",
    product_condition: "حالت",
    product_description: "تفصیل",
    product_location: "پروڈکٹ کا مقام",
    product_location_approximate: "مقام تخمینہ ہے",
    over_week_time_ago: "ایک ہفتے پہلے",
    boosted: "بڑھایا",
    threads_no_results: "کوئی پیغام نہیں",
    message_no_results: "کوئی پیغام نہیں",
    message_warning:
      "دوسروں کے ساتھ بات چیت کرتے وقت آپ تمام ضروری احتیاطی تدابیر اختیار کرنے کے لئے مکمل طور پر ذمہ دار ہیں ، خاص طور پر جب پہلی بار شخصی طور پر کسی اجنبی سے ملاقات کریں۔ براہ کرم کوئی ذاتی معلومات ، توثیق کوڈ یا ادائیگی کی کوئی معلومات شیئر نہ کریں۔ براہ کرم مزید تفصیلات کے لئے خدمت کی شرائط کا جائزہ لیں۔",
    message_block: "آپ اس وقت پیغامات بھیج سکتے ہیں یا وصول نہیں کرسکتے ہیں.",
    select_location: "مقام منتخب کریں",
    location_permission_denied_message:
      "اے پی پی مناسب طریقے سے کام کرنے کے لئے مقام کی اجازت کی ضرورت ہے.",
    signed_in: "سائن ان!",
    sign_in_canceller: "منسوخ کر دیا گیا",
    version: "ورژن",
    build: "تعمیر",
    name: "نام",
    location: "مقام",
    language: "زبان",
    about_app: "میرے قریب درج کے بارے میں",
    terms_of_service: "سروس کی شرائط",
    privacy_policy: "پرائیویسی پالیسی",
    report_feedback: "رائے بھیجیں",
    report_bug: "ایک بگ کی رپورٹ کرنے کے لئے فون ہلا",
    change_image: "تصویر تبدیل کریں",
    update_location: "مقام اپ ڈیٹ کریں",
    about_the_app: "اپلی کیشن کے بارے میں",
    update_label: "اپ ڈیٹ",
    uploading: "اپ لوڈ کرنا",
    adding: "لسٹنگ شامل کرنا",
    removing: "لسٹنگ کو ہٹانے",
    updating: "لسٹنگ کو اپ ڈیٹ کرنا",
    uploaded_image: "اپ لوڈ کردہ تصویر:",
    image_storage_failed: "تصویر ذخیرہ کرنے میں ناکام",
    product_updated: "پروڈکٹ نے کامیابی سے اپ ڈیٹ کیا",
    location_error: "مقام محفوظ نہیں ہے، براہ کرم دوبارہ کوشش کریں",
    product_removed: "مصنوعات کامیابی سے ہٹا دیا",
    deleted_product: "اس کی مصنوعات کو خارج کر دیا گیا ہے",
    invalid_title: "غلط عنوان، براہ کرم دوبارہ عنوان مقرر کریں.",
    invalid_image: "غلط تصویر کا راستہ، دوبارہ تصویر شامل کریں.",
    invalid_price: "غلط قیمت، براہ کرم دوبارہ قیمت مقرر کریں.",
    invalid_location: "غلط مقام، براہ کرم دوبارہ جگہ مقرر کریں.",
    invalid_category: "غلط زمرہ، براہ کرم دوبارہ زمرے مقرر کریں.",
    invalid_condition: "غلط حالت، براہ کرم دوبارہ شرط مقرر کریں.",
    removing_title: "پروفائل تصویر کو ہٹا دیں",
    image_not_saved: "تصویری محفوظ ناکام ہوگئی!",
    product_load_failed: "کوئی مصنوعات نہیں",
    take_photo: "تصویر لو",
    select_photo: "تصویر منتخب کریں",
    product_title_hint: "یہ کیا ہے؟ نام، برانڈ، ماڈل، وغیرہ",
    delete_photo: "تصویر حذف کریں",
    product_title: "عنوان",
    mark_as_sold: "فروخت کے طور پر مارک",
    product_share: "بانٹیں",
    product_make_offer: "پیشکش",
    product_cover: "کور تصویر کے طور پر مقرر کریں",
    product_tags: "ٹیگز",
    product_posted: "پوسٹ کیا گیا:",
    product_change: "تبدیل",
    product_post: "پوسٹ",
    product_selling_from: "مقام سے فروخت",
    product_select_location: "مقام منتخب کریں",
    product_map_approximate:
      "نقشہ بیچنے والے کی جگہ نجی رکھنے کے لئے نقشہ تخمینہ ہے",
    product_terms:
      "آپ کی مصنوعات کو شائع کرنے کے لئے پوسٹ ٹیپنگ کرکے، آپ مجھ سے رابطہ کریں <u> سروس کی شرائط کے قریب درج ہیں. </ u>",
    condition_other: "دیگر (تفصیل دیکھیں)",
    condition_for_parts: "حصوں کے لئے",
    condition_used: "استعمال کیا جاتا ہے (عام لباس)",
    condition_open_box: "کھولیں باکس (کبھی نہیں استعمال کیا جاتا ہے)",
    condition_reconditioned: "دوبارہ ترمیم / تصدیق",
    condition_new: "نیا (کبھی نہیں استعمال کیا جاتا ہے)",
    select_category: "زمرہ منتخب کریں",
    select_all_category: "تمام منتخب کریں",
    category_loading_error:
      "زمرہ جات کی فہرست کو اپ ڈیٹ نہیں کر سکتے ہیں، براہ کرم بعد میں دوبارہ کوشش کریں.",
    category_vehicles: "گاڑیاں",
    category_furniture: "فرنیچر",
    category_electronics: "الیکٹرانکس",
    category_appliances: "ہوم & amp؛ آلات",
    category_fashion_accessories: "فیشن اور amp؛ لوازمات",
    category_baby_kids: "بچے اور amp؛ بچے",
    category_antiques_collectibles: "قدیم چیزیں & amp؛ جمع کردہ اشیاء",
    category_auto_parts_tools_machinery: "آٹو حصوں، اوزار اور AMP؛ مشینری",
    category_sports_outdoors: "کھیل اور AMP؛ باہر",
    category_others: "دیگر",
    location_enter_zip_code: "زپ کوڈ درج",
    location_get_current_location: "موجودہ مقام حاصل کریں",
    location_select_location: "مقام منتخب کریں",
    location_update_location: "مقام اپ ڈیٹ کریں",
    location_new_location: "نیا مقام",
    search_filter_results: "فلٹر کے نتائج",
    search_filter_min: "کم از کم فلٹر",
    search_filter_at_least: "کم از کم",
    price_filter: "قیمت فلٹر",
    product_name: "پروڈکٹ کا نام",
    english_language: "انگریزی",
    arabic_language: "عربی",
    spanish_language: "ہسپانوی",
    system_language: "نظام",
    share_link: "اشتراک لنک",
    save: "بچت",
    cancel: "منسوخ",
    loading: "لوڈنگ",
    yes: "جی ہاں",
    no: "نہیں",
    report: "رپورٹ",
    report_product: "مصنوعات کی رپورٹ",
    report_user: "رپورٹ صارف",
    block_user: "بلوک یوزر",
    un_block_user: "صارف کو ان بلاک",
    why_product: "آپ اس شے کو کیوں رپورٹ کرنا چاہتے ہیں؟",
    why_user: "آپ اس صارف کو کیوں رپورٹ کرنا چاہتے ہیں؟",
    block_user_confirm: "کیا آپ اس صارف کو مستقل طور پر بلاک کرنا چاہتے ہیں؟",
    un_block_user_confirm:
      "کیا آپ مستقل طور پر اس صارف کو غیر فعال کرنا چاہتے ہیں؟",
    prohibited: "میرے قریب درج کردہ پر پابندی",
    offensive: "جارحانہ یا غیر مناسب",
    duplicate: "ڈپلیکیٹ پوسٹ",
    wrong_category: "غلط قسم",
    scam: "ایک اسکام کی طرح لگ رہا ہے",
    stolen: "مجھے لگتا ہے کہ یہ چوری ہے",
    product_other: "دوسرا",
    product_is_sold: "اس کی مصنوعات کو فروخت کیا گیا تھا",
    missed_meeting: "انہوں نے ہماری ملاقات کی",
    low_offer: "کم پیشکش کی",
    rude: "بدقسمتی یا غیر مناسب",
    items: "اشیاء کے ساتھ مسئلہ",
    trouble_meetup: "ملنے میں مصیبت",
    messaging: "پیغام رسانی کے مسائل",
    user_other: "دوسرا",
    new_version_available: "نیا ورژن دستیاب",
    please_update_app:
      "براہ کرم، جاری رکھنے کیلئے نئے ورژن پر اپلی کیشن اپ ڈیٹ کریں.",
    update: "اپ ڈیٹ",
    no_thanks: "نہیں شکریہ",
    contact_support_confirmation:
      "موجودہ ردعمل کا وقت 24-48 گھنٹے ہے. کیا آپ مجھے اے پی پی چیٹ کی حمایت کے قریب درج کردہ رابطہ سے رابطہ کرنا چاہتے ہیں؟",
    unboost_confirmation:
      "کیا آپ کو یقین ہے کہ آپ اس کی مصنوعات کو غیر معمولی کرنا چاہتے ہیں؟",
    no_used_products: "آپ کے پاس ابھی تک کوئی لسٹنگ نہیں ہے",
    no_boosted_products: "آپ کو کوئی بھی مصنوعات نہیں ہے",
    next: "اگلے",
    previous: "پچھلا",
    skip: "چھوڑ دو",
    start: "شروع",
    list_used: "ایک استعمال شدہ مصنوعات کی فہرست",
    buy_description:
      "آپ کے ارد گرد پڑوسیوں کی طرف سے پیش کردہ مصنوعات کی تلاش اور تلاش کریں",
    sell_description: "مصنوعات کی فہرست آپ کو اب فروخت کے لئے ضرورت نہیں ہے",
    list_used_description:
      "20 سیکنڈ سے کم میں فروخت کے لئے ایک استعمال شدہ مصنوعات کی فہرست",
    boost_product_option_1: "<b> فروغ 1  nday </ b>  n  n <b> $ 0.99 </ B>",
    boost_product_option_2:
      "<b> 3  ndays کو فروغ دیں </ b>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<b> فروغ 7  ndays </ b>  n  n <b> $ 3.99 </ B>",
    boost_product_description:
      "ہر دن زیادہ خیالات حاصل کریں. آپ کا آئٹم خرید اور زمرے میں سب سے اوپر 30 اشیاء کے اندر نمایاں پوزیشنوں میں پیش آئے گا. فروغ شدہ اشیاء نامزد مقامات کے درمیان گھومتے ہیں لہذا ہر چیز کو منصفانہ نمائش ملتی ہے.",
    boost_cta: "تیزی سے فروخت",
    boost_terms:
      "فروغ دینے کی طرف سے، آپ مجھ سے رابطہ کریں <u> سروس کی شرائط کے قریب درج ہیں. </ u>",
    boost_best_value: "بہترین قیمت",
    already_boosted: "اس کی مصنوعات کو فروغ دیا گیا ہے",
    clicks: "کلکس",
    impressions: "نقوش",
    end: "آخر",
    transactions_empty_text:
      "آپ کو ابھی تک کوئی ٹرانزیکشن نہیں ہے. آپ فروخت ٹیب کا دورہ کر سکتے ہیں اور اپنی مصنوعات کو بڑھانے کے لئے شروع کر سکتے ہیں.",
    transactions_loading_error:
      "ٹرانزیکشن کی فہرست کو اپ ڈیٹ نہیں کر سکتے ہیں، براہ کرم بعد میں دوبارہ کوشش کریں.",
    transactions_history_title: "ٹرانزیکشن کی تاریخ کو فروغ دینا",
    communicative_postive: "مواصلات",
    communicative_negative: "غیر معمولی",
    ontime_postive: "وقت پر",
    ontime_negative: "دیر",
    reliable_postive: "قابل اعتماد",
    reliable_negative: "ناقابل اعتماد",
    friendly_postive: "دوستانہ",
    friendly_negative: "بے حد",
    itemasdescribed_postive: "آئٹم کے طور پر بیان",
    itemasdescribed_negative: "آئٹم بیان نہیں کیا گیا ہے",
    other: "دوسرا",
    submit: "جمع کرائیں",
    adding_rating_reviews: "درجہ بندی اور جائزے شامل کرنا",
    no_internet_title: "کوئی انٹرنیٹ کنکشن نہیں",
    no_internet_message:
      "اس بات کو یقینی بنائیں کہ آپ انٹرنیٹ سے منسلک ہیں اور دوبارہ کوشش کریں گے",
    retry: "دوبارہ کوشش کریں",
    near_me: "میرے قریب",
    newest_first: "سب سے تازہ ترین",
    miles: "میل",
    km: "کلومیٹر",
    similar_products: "اسی طرح کی مصنوعات",
    favorite_products: "پسندیدہ مصنوعات",
    items_for_sale: "اشیاء برائے فروخت",
    joined: "شمولیت",
    favorites_transactions_title: "پسندیدہ",
    boosted_products_transactions_history:
      "مصنوعات کی ٹرانزیکشن کی تاریخ کو فروغ دیا",
    views: "مناظر",
    boost_graph_title: "گراف بڑھاؤ",
    no_favorite_products: "آپ کے پاس کوئی پسندیدہ مصنوعات نہیں ہے",
    make_offer_buy: "میں خریدنا پسند کروں گا",
    make_offer_buy_for: "کے لئے",
    notifications: "اطلاعات",
    push_notifications: "دھکا",
    emails_notifications: "ای میل",
    apply: "درخواست دیں",
    email_messages: "پیغامات کے لئے ای میل",
    email_new_products: "نئی مصنوعات کے لئے ای میل",
    push_day_only: "صرف نوٹیفکیشن دن پش",
    push_24_hours: "اطلاعات 24 گھنٹے پش",
    edit: "ترمیم",
    map: "نقشہ",
    camera: "کیمرے",
    gallery: "گیلری، نگارخانہ",
    delete: "حذف کریں",
    no_sell_items: "فروخت کے لئے کوئی اشیاء نہیں",
    who_bought_question: "کون نے اسے خریدا؟",
    sold_elsewhere_question: "اسے کہیں اور فروخت کیا",
    confirm: "تصدیق",
    over_limit_camera: "آپ پانچ سے زائد تصاویر شامل نہیں کر سکتے ہیں",
    boost_failed: "فروغ ناکام ہوگیا براہ کرم کچھ دیر بعد کوشش کریں",
    after_purchase: "ادائیگی کامیاب  nproduct بڑھا",
    pay_failed: "ادائیگی ناکام ہوگئی. دوبارہ کوشش کریں",
    done: "ہو گیا",
    not_now: "ابھی نہیں",
    boost: "فروغ",
    invalid_zip_code: "غلط زپ کوڈ",
    invalid_user_name: "غلط صارف نام",
    comments: "تبصرے",
    questions: "سوالات",
    bug_reports: "بگ رپورٹس",
    feature_request: "خصوصیت کی درخواست",
    feedback_type: "تاثرات کی قسم",
    feedback_description:
      "ہم آپ کے خیالات یا رائے کو سننا پسند کریں گے کہ ہم آپ کے تجربے کو کیسے بہتر بنا سکتے ہیں!",
    feedback: "تاثرات",
    feedback_text: "آپ کا جواب",
    suggestions: "بہتری کے لئے تجاویز",
    delete_account: "کھاتہ مٹا دو",
    new_message: "نیا پیغام",
    online: "آن لائن",
    km_50: "50 کلومیٹر",
    km_100: "100 کلومیٹر",
    km_200: "200 کلومیٹر",
    miles_30: "30 میل",
    miles_60: "60 میل",
    miles_120: "120 میل",
    rate_app_question: "اپلی کیشن اسٹور پر ایک درجہ بندی کے بارے میں، پھر؟",
    enjoying_question: "میرے قریب درج کردہ لطف اندوز",
    not_enjoy: "واقعی نہیں",
    feedback_question: "کیا آپ ہمیں کچھ رائے دیتے ہیں؟",
    yes_sure: "ٹھیک ہے، یقینا",
    product_available_question: "ہیلو، کیا یہ اب بھی دستیاب ہے؟",
    buy_question: "ہیلو، میں یہ خریدنے کے لئے پسند کرتا ہوں",
    meet_question: "ہیلو، کیا آپ آج مل سکتے ہیں؟",
    follow: "پیروی",
    followers: "پیروکاروں",
    following: "درج ذیل",
    feedback_thanks: "آپ کی راے کا شکریہ",
    all_categories: "تمام زمرے",
    deleted_account: "یہ اکاؤنٹ خارج کر دیا گیا ہے",
    delete_account_question: "کیا آپ واقعی یہ اکاؤنٹ حذف کرنا چاہتے ہیں؟",
    no_followings: "کسی کو پیروی نہیں کرتا",
    when_following: "کب",
    no_followings_subtitle: "لوگوں کی پیروی کرتا ہے، آپ انہیں یہاں دیکھیں گے",
    no_followers: "پیروکار نہیں ہیں",
    no_followers_subtitle: "لوگوں کے بعد، آپ انہیں یہاں دیکھیں گے",
    distance: "فاصلے",
    filter_method: "فلٹر کا طریقہ",
    see_listings: "لسٹنگ دیکھیں",
    sold: "فروخت",
    bought: "خریدا",
    no_notifications: "جب آپ اطلاعات وصول کرتے ہیں، تو وہ یہاں آئیں گے",
    items_title: "اشیاء",
    new_listing_title: "نئی لسٹنگ بنائیں",
    dialog_year_title: "سال",
    dialog_make_title: "بنائیں",
    dialog_model_title: "ماڈل",
    dialog_body_style_title: "جسمانی انداز",
    dialog_exterior_color_title: "بیرونی رنگ",
    dialog_interior_color_title: "داخلہ رنگ",
    dialog_transmission_title: "منتقلی",
    dialog_fuel_type_title: "ایندھن کی قسم",
    dialog_owners_num_title: "مالکان کی تعداد",
    dialog_vehicle_owed_money_title:
      "کیا اس گاڑی پر ابھی بھی پیسہ کمایا گیا ہے؟",
    automatic_transmission: "خودکار",
    manual_transmission: "دستی",
    not_sure: "یقین نہیں",
    wagon_hatchback: "وگن اور amp؛ ہچ بیک بیک",
    convertible: "تبدیل",
    coupe: "کوپ",
    sedan: "سلیمان",
    black_color: "بلیک",
    blue_color: "بلیو",
    brown_color: "براؤن",
    gold_color: "گولڈ",
    green_color: "سبز",
    grey_color: "سرمئی",
    pink_color: "گلابی",
    purple_color: "جامنی",
    red_color: "سرخ",
    silver_color: "سلور",
    orange_color: "کینو",
    white_color: "سفید",
    yellow_color: "پیلا",
    charcol_color: "چارٹ",
    fuel_diesel: "ڈیزل",
    fuel_electric: "بجلی",
    fuel_gasoline: "پٹرول",
    fuel_flex: "Flex.",
    fuel_hybrid: "ہائبرڈ",
    fuel_petrol: "پیٹرول",
    fuel_plugin_hybrid: "پلگ ان میں ہائبرڈ",
    truck: "ٹرک",
    van_minivan: "وین اور amp؛ منیوان",
    suv_crossover: "ایس یو وی & amp؛ صلیب",
    awd_4wd: "AWD / 4WD.",
    fwd: "Fwd.",
    rwd: "RWD.",
    off_white_color: "ہلکا سفید",
    tan_color: "ٹین",
    beige_color: "بیج",
    burgundy_color: "برگنڈی",
    turquoise_color: "فیروزی",
    title_status_clean: "صاف",
    title_status_rebuilt: "دوبارہ تعمیر",
    title_status_salvage: "بچاؤ",
    title_status_missing: "لاپتہ",
    title_status_lien: "لین",
    title_status: "عنوان کی حیثیت",
    mileage: "میلے",
    dialog_drivetrain_title: "Drivetrain.",
    model_warning: "براہ کرم سب سے پہلے بنائیں",
    required_field_warning: "اس کو پر کرنا ضروری ہے",
    vehicle_vin: "ون",
    invalid_vin: "غلط وین، براہ کرم دوبارہ وین مقرر کریں.",
    invalid_mileage: "غلط میلہ، براہ کرم میلاج دوبارہ مقرر کریں.",
    clean_description: "زیادہ تر گاڑیاں جو حادثے میں نہیں ہیں",
    rebuilt_description: "ایک بچت کار جس کی تعمیر کی گئی ہے",
    salvage_description: "ایک حادثے کے بعد کل سمجھا جاتا ہے",
    missing_description: "ایک نیا DMV کے مسائل کے عنوان کی ضرورت ہوگی",
    lien_description: "ایک بینک یا عدالت کے حل کی ملکیت",
    nearme: "میرے قریب",
    newest: "تازہ ترین",
    contact_support: "رابطہ سپورٹ",
    create_home_title: "فروخت یا کرایہ کے لئے گھروں",
    for_sale: "فروخت کے لئے",
    for_rent: "کرایہ کے لئے",
    property_type: "جائداد کی نوعیت",
    apartment: "اپارٹمنٹ",
    house: "گھر",
    room_only: "صرف کمرہ",
    townhouse: "قصبے کا گھر",
    bedrooms: "بیڈروم",
    bathrooms: "باتھ",
    property_address: "پراپرٹی ایڈریس",
    price_per_month: "فی مہینہ قیمت",
    square_feet: "مربع فٹ",
    year_built: "سال کی تعمیر",
    year_renovated: "سال کی بحالی",
    lot_size: "بہت سائز",
    laundry_type: "لانڈری کی قسم",
    in_unit_laundry: "یونٹ یونٹ لانڈری",
    laundry_building: "عمارت میں لانڈری",
    laundry_available: "لانڈری دستیاب",
    none: "کوئی نہیں",
    parking_type: "پارکنگ کی قسم",
    garage_parking: "گیراج پارکنگ",
    street_parking: "سٹریٹ پارکنگ",
    off_street_parking: "آف گلی پارکنگ",
    available_parking: "پارکنگ دستیاب",
    air_cond_type: "ایئر کنڈیشنگ کی قسم",
    ac_available: "AC دستیاب",
    central_ac: "سینٹرل AC.",
    heating_type: "حرارتی قسم",
    electric_heating: "الیکٹرک ہیٹنگ",
    gas_heating: "گیس حرارتی",
    radiator_heating: "ریڈی ایٹر ہیٹنگ",
    available_heating: "حرارتی دستیاب",
    amenities: "سہولیات",
    date_available: "دستیاب تاریخ",
    lease_length: "لیز کی لمبائی",
    month_to_month: "مہینے مہینہ",
    three_months: "3 ماہ",
    six_months: "6 ماہ",
    one_year: "1 سال",
    more_one_year: "1+ سال",
    cat_friendly: "بلی دوستانہ",
    dog_friendly: "کتے دوستانہ",
    balcony: "بالکنی",
    basement: "تہھانے",
    bike_parking: "موٹر سائیکل پارکنگ",
    cable_tv: "کیبل ٹی وی",
    ceiling_fan: "پنکھا",
    concierge: "کنسرج",
    dishwasher: "برتنیں دھونے والا",
    doorman: "دروازہ",
    elevator: "لفٹ",
    fireplace: "چمنی",
    fitness_center: "کسرت گاه",
    garbage_disposal: "گندم کو ضائع کرنا",
    microwave: "مائکروویو",
    online_app: "آن لائن درخواست",
    oven: "تندور",
    package_service: "پیکیج سروس",
    patio: "پیٹنٹ",
    pet_park: "پالتو جانور پارک",
    refrigerator: "ریفریجریٹر",
    resident_lounge: "رہائشی لاؤنج",
    roof_deck: "چھت ڈیک",
    secured_entry: "محفوظ اندراج",
    storage: "ذخیرہ",
    walk_in_closet: "الماری میں چلتے ہیں",
    swimming_pool: "سوئمنگ پول",
    wheelchair_access: "پہئے والی کرسی تک رسائی",
    central_heating: "مرکزی حرارت",
    invalid_bedrooms: "غلط بیڈروم، براہ مہربانی دوبارہ بیڈروم مقرر کریں.",
    invalid_bathrooms: "غلط باتھ روم، براہ مہربانی دوبارہ باتھ روم مقرر کریں.",
    chinese_simplified_language: "آسان چینی زبان",
    chinese_traditional_language: "چینی روایتی",
    czech_language: "چیک",
    danish_language: "ڈینش",
    dutch_language: "ڈچ",
    finnish_language: "فینیش",
    french_language: "فرانسیسی",
    german_language: "جرمن",
    greek_language: "یونانی",
    hungarian_language: "ہنگری",
    indonesian_language: "انڈونیشیا",
    italian_language: "اطالوی",
    japanese_language: "جاپانی",
    korean_language: "کورین",
    norwegian_language: "ناروے",
    polish_language: "پولش",
    portuguese_language: "پرتگالی",
    portuguese_brazilian_language: "پرتگالی، برازیل",
    romanian_language: "رومانیہ",
    russian_language: "روسی",
    swedish_language: "سویڈش",
    turkish_language: "ترکی",
    ukrainian_language: "یوکرینیائی",
    urdu_pakistan_language: "اردو (پاکستان)",
    vietnamese_language: "ویتنامی",
    category_home_sale_or_rent: "فروخت یا کرایہ کے لئے گھر",
    square_meter: "مربع میٹر",
    copy_text: "کاپی",
    copyied_to_clipboard: "کلپ بورڈ پر کاپی",
    inbox: "ان باکس",
    input_title_listening: "سننا ...",
    input_subtitle_listening: "کچھ بولیں",
    input_title_error: "افسوس، ہم نے اسے کافی نہیں لیا.",
    input_subtitle_error: "اپنی درخواست کو دوبارہ کوشش کریں.",
    input_hint_error: "دوبارہ کوشش کریں",
    price_less_than_or_equal: "قیمت سے کم یا برابر",
    any_price: "کوئی قیمت",
    any_condition: "کوئی شرط",
    any_time: "کسی بھی وقت",
    days_ago: "دنوں پہلے",
    any_distance: "کوئی فاصلہ",
    distance_within: "فاصلے کے اندر اندر",
    new_notification: "نئی اطلاع",
    deleted: "حذف کر دیا",
    processing_image: "پروسیسنگ تصویر",
    remove_dialog_message: "کیا آپ واقعی اس کی مصنوعات کو دور کرنا چاہتے ہیں؟",
    deleted_thread: "یہ پیغام خارج کر دیا گیا ہے",
    category_yard_sale_event: "یارڈ فروخت کی تقریب",
    yard_first_date: "یارڈ فروخت کی پہلی تاریخ",
    yard_second_date: "یارڈ فروخت دوسری تاریخ",
    yard_third_date: "یارڈ فروخت تیسری تاریخ",
    yard_start_time: "وقت آغاز",
    yard_end_time: "اختتامی وقت",
    yard_end_timestamp: "اختتام ٹائمسٹیمپ",
    invalid_date1: "غلط پہلی تاریخ، براہ کرم پہلی تاریخ دوبارہ مقرر کریں",
    invalid_start_time: "غلط آغاز کا وقت، براہ کرم دوبارہ شروع وقت مقرر کریں",
    invalid_end_time: "غلط وقت کے وقت، براہ کرم دوبارہ ختم وقت مقرر کریں",
    yard_sale_title: "یارڈ فروخت",
    garage_tag: "گیراج",
    yard_tag: "یارڈ",
    from: "سے",
    to: "کرنے کے لئے",
    block: "بلاک",
    un_block: "ان بلاک",
    sign_email: "ای میل کے ساتھ سائن ان کریں",
    invalid_first_date:
      "غلط پہلی تاریخ، براہ کرم یقینی بنائیں کہ پہلی تاریخ دوسری اور تیسری سے پہلے ہے",
    invalid_second_date:
      "غلط دوسری تاریخ، براہ کرم یقینی بنائیں کہ دوسری تاریخ تیسری تاریخ سے پہلے ہے",
    invalid_start_time_value:
      "غلط آغاز کا وقت، براہ کرم یقینی بنائیں کہ وقت کا وقت ختم ہونے سے پہلے وقت ہے",
    use_default_yard_photo: "ڈیفالٹ یارڈ فروخت کی تصویر کا استعمال کریں",
    active_label: "فعال",
    enable_notifications: "اطلاعات کو فعال کریں",
    login: "لاگ ان کریں",
    january: "جنوری",
    february: "فروری",
    march: "مارچ",
    april: "اپریل",
    may: "مئی",
    june: "جون",
    july: "جولائی",
    august: "اگست",
    september: "ستمبر",
    october: "اکتوبر",
    november: "نومبر",
    december: "دسمبر",
    since: "چونکہ",
    product_views: "پروڈکٹ مناظر",
    shop_views: "دکان کے خیالات",
    total_sales: "کل فروخت",
    total_orders: "کل احکامات",
    last_twelvth_months: "آخری بارہ ماہ",
    last_nine_months: "آخری نو ماہ",
    last_six_months: "گزشتہ چھ ماہ",
    last_three_months: "گزشتہ تین ماہ",
    last_12_months: "آخری 12 ماہ",
    last_9_months: "گزشتہ 9 ماہ",
    last_6_months: "گزشتہ 6 ماہ",
    last_3_months: "آخری 3 ماہ",
    months: "مہینے",
    open: "کھولیں",
    reset_password: "پاس ورڈ ری سیٹ",
    create_new_shop: "نئی دکان بنائیں",
    download_app: "اپلی کیشن ڈاؤن لوڈ کریں",
    log_in: "لاگ ان کریں",
    sign_up: "سائن اپ",
    no_result: "کو ئی نتیجہ",
    max_price: "زیادہ سے زیادہ قیمت",
    max_distance: "زیادہ سے زیادہ فاصلہ",
    max_time: "زیادہ سے زیادہ وقت",
    posted_less_than: "کم سے کم پوسٹ کیا",
    result: "نتیجہ",
    more: "مزید",
    or: "یا",
    password: "پاس ورڈ",
    forgot_password: "پاسورڈ بھول گے؟",
    and: "اور",
    download_for: "کے لئے ڈاؤن لوڈ کریں",
    apple_ios: "ایپل iOS.",
    android: "انڈروئد",
    image: "تصویر",
    edit_image: "تصویر میں ترمیم کریں",
    please_complete: "براہ مہربانی مکمل کریں",
    enter_your_offer: "اپنی پیشکش درج کریں",
    categories: "اقسام",
    upload_image: "تصویر انٹرنیٹ پر ڈالنا",
    upload_images: "تصاویر اپ لوڈ کریں",
    back: "پیچھے",
    see_more: "دیکھیں مزید",
    add_product: "مصنوعات شامل کریں",
    selected: "منتخب شدہ",
    create: "بنانا",
    rate_the_buyer: "خریدار کی شرح",
    delete_product: "مصنوعات کو حذف کریں",
    product: "مصنوعات",
    un_block_product: "مصنوعات کو غیر مقفل کریں",
    share_your_product: "اپنی مصنوعات کا اشتراک کریں",
    boost_details: "تفصیلات بڑھانے",
    remove_all_products: "تمام مصنوعات کو ہٹا دیں",
    remove_all: "سب کو ہٹا دیں",
    add_vehicle: "گاڑی شامل کریں",
    edit_vehicle: "گاڑی میں ترمیم کریں",
    upload_a_photo: "تصویر اپ لوڈ کریں",
    view_details: "تفصیلات دیکھیں",
    add_yard_sale: "یارڈ فروخت شامل کریں",
    edit_yard_sale: "یارڈ فروخت میں ترمیم کریں",
    users: "صارفین",
    users_details: "صارفین کی تفصیلات",
    users_by_country: "ملک کی طرف سے صارفین",
    blocked_users: "بلاک شدہ صارفین",
    products_cards: "مصنوعات کارڈ",
    archived_products: "محفوظ شدہ مصنوعات",
    blocked_products: "بلاک شدہ مصنوعات",
    products_by_country: "ملک کی طرف سے مصنوعات",
    reports: "رپورٹ",
    reports_details: "رپورٹیں تفصیلات",
    closed_reports: "بند رپورٹ",
    threads: "موضوعات",
    threads_details: "موضوعات کی تفصیلات",
    chat_support: "چیٹ کی حمایت",
    actions: "اعمال",
    search_actions: "تلاش کے اعزاز",
    product_view_actions: "پروڈکٹ دیکھیں اعزاز",
    contact_seller_product: "بیچنے والے کی مصنوعات سے رابطہ کریں",
    contact_owner_shop: "رابطہ مالک کی دکان",
    ratings: "درجہ بندی",
    reviews: "جائزے",
    products_all_countries: "مصنوعات تمام ممالک",
    edit_profile: "پروفائل میں ترمیم کریں",
    my_profile: "میری پروفائل",
    profile_updated_successfully: "پروفائل کامیابی سے اپ ڈیٹ",
    are_you_sure: "کیا تمہیں یقین ہے",
    my_used_products: "میری استعمال کردہ مصنوعات",
    my_shops: "میری دکانیں",
    my_boosted_products: "میری بڑھتی ہوئی مصنوعات",
    messages_type_message_here: "یہاں اپنا پیغام لکھو",
    messages_product_sold: "اس کی مصنوعات کو فروخت یا ہٹا دیا جاتا ہے",
    seen: "دیکھا",
    messages_never_miss_message: "پیغام کو کبھی بھی یاد نہیں",
    enable: "فعال",
    send_notify: "مطلع بھیجیں",
    un_close: "unclose.",
    type_your_review: "اپنا جائزہ لیں",
    again_question: "ایک بار پھر؟",
    ratings_already_submitted_review: "آپ نے پہلے ہی جائزہ لیا پیش کیا",
    set_product_category: "مصنوعات کی قسم مقرر کریں",
    auth_email_password_incorrect: "آپ کا ای میل یا پاس ورڈ غلط ہے",
    auth_insert_your_name: "اپنا نام درج کریں",
    auth_email_address_badly: "ای میل ایڈریس بری طرح سے فارمیٹ کیا جاتا ہے",
    auth_email_address_used:
      "ای میل ایڈریس پہلے سے ہی ایک اور اکاؤنٹ کے ذریعہ استعمال میں ہے",
    auth_invalid_password: "پاس ورڈ کم از کم 6 حروف ہونا چاہئے",
    auth_reset_email:
      "اپنا پاس ورڈ دوبارہ ترتیب دینے کیلئے اپنا ای میل درج کریں",
    auth_check_email:
      "براہ کرم پاس ورڈ دوبارہ ترتیب دینے کیلئے اپنا ای میل چیک کریں",
    auth_can_sign_in_google: "آپ Google بٹن کے ساتھ سائن ان کرسکتے ہیں",
    auth_do_not_have_account: "کیا آپ کا اکاؤنٹ نہیں ہے؟",
    auth_have_account: "کیا آپ کا اکاؤنٹ ہے؟",
    log_terms_privacy_part1:
      "سائن اپ یا لاگ ان کرکے، آپ میرے قریب درج کردہ اتفاق کرتے ہیں",
    boost_this_product: "اس کی مصنوعات کو فروغ دینا",
    product_successfully_boosted: "مصنوعات کو کامیابی سے بڑھا دیا گیا ہے",
    product_failed_boost: "مصنوعات کو فروغ دینے میں ناکام رہا ہے",
    no_products_for_sale:
      "آپ فی الحال فروخت کے لئے درج کردہ استعمال کردہ مصنوعات نہیں ہیں.",
    not_sold_listed_near_me: "میں نے اسے قریب میں درج نہیں کیا تھا",
    agree_add_product:
      "اپنی مصنوعات کو شائع کرنے کے لئے پوسٹ ٹیپ کرکے، آپ میرے قریب درج کردہ سروس اور رازداری کی پالیسی کی شرائط سے اتفاق کرتے ہیں.",
    click_to_boost: "اسے بڑھانے کے لئے مصنوعات پر کلک کریں",
    listed_terms_of_service: "میرے قریب درج کردہ سروس کی شرائط",
    receive_emails_for_users: "صارفین کے پیغامات کے لئے ای میلز وصول کریں",
    receive_emails_for_newly_posted:
      "اپنی نئی پوسٹ کردہ مصنوعات کے لئے ای میلز وصول کریں",
    disable_push_notifications: "دھکا اطلاعات کو غیر فعال کریں",
    sms_during_day: "دن کے دوران ایس ایم ایس وصول کریں",
    sms_24_hours: "ایس ایم ایس 24 گھنٹے وصول کریں",
    products: "مصنوعات",
    product_no_longer_available: "افسوس، اس کی مصنوعات اب دستیاب نہیں ہے",
    add_home: "گھر شامل کریں",
    edit_home: "گھر میں ترمیم کریں",
    fill_required_fields: "تمام مطلوبہ شعبوں کو بھریں",
    no_notification: "کوئی اطلاع نہیں ہے",
    orders_history: "احکامات تاریخ",
    privacy: "پرائیویسی",
    terms: "شرائط",
    report_a_problem: "مسئلے کے بارے میں بتائیے",
    approximation_protect_user_privacy:
      "صارف کی رازداری کی حفاظت کے لئے سنجیدگی",
    do_not_have_products: "آپ کی مصنوعات نہیں ہے",
    emails: "ای میل",
    lead_deletion_products: "یہ آپ کی تمام مصنوعات کی حذف کرے گی",
    confirm_legal_message:
      "دوسروں کے ساتھ بات چیت کرتے وقت آپ کو تمام ضروری احتیاطی تدابیر لینے کے لئے مکمل طور پر ذمہ دار ہیں، خاص طور پر جب پہلی بار شخص میں اجنبی سے ملیں. مزید تفصیلات کے لئے سروس کی شرائط کا جائزہ لیں.",
    push_notifications_notified_instantly:
      "فوری اطلاعات کو فوری طور پر مطلع کرنے کے لئے فعال کریں",
    rate_seller: "فروخت کنندہ کی شرح",
    user_journey: "صارف کا سفر",
    user: "صارف",
    user_id: "صارف کی شناخت",
    action_id: "ایکشن ID.",
    select_model_car: "کار کا ماڈل منتخب کریں",
    boost_1_day: "1 دن بڑھاؤ",
    boost_3_days: "3 دن بڑھاؤ",
    boost_7_days: "7 دن بڑھاؤ",
    agree_boost_terms: "فروغ دینے کی طرف سے، آپ اتفاق کرتے ہیں",
    add: "شامل",
    add_tag: "ٹیگ شامل کریں",
    brand_title: "برانڈ",
    category_mobiles: "موبائل",
    category_tablets: "گولیاں",
    screen_size: "اسکرین سائز",
    has_cellular_capability: "سیلولر کی صلاحیت ہے",
    default_internal_memory: "اندرونی یاداشت",
    network_carrier: "نیٹ ورک کیریئر",
    is_unlocked: "کھلا ہے",
    mobile_model_warning: "براہ کرم برانڈ منتخب کریں",
    missing_image: "لاپتہ تصویر، دوبارہ تصویر شامل کریں.",
    add_mobile: "موبائل شامل کریں",
    edit_mobile: "موبائل میں ترمیم کریں",
    add_tablet: "ٹیبلٹ شامل کریں",
    edit_tablet: "ٹیبلٹ میں ترمیم کریں",
    keywords:
      "خریداری، خرید، فروخت، پیسہ کمانے، تجارت، مقامی، پڑوسیوں، آٹو، گاڑیاں",
    country: "ملک",
    phone_number: "فون نمبر",
    verification_code: "تصدیقی کوڈ",
    error_occurred:
      "ایک خامی پیش آگئی. برائے مہربانی کچھ دیر بعد دوبارہ کوشش کریں",
    invalid_state:
      "غلط ریاست: ایک لاگ ان کال بیک موصول ہوا، لیکن کوئی لاگ ان کی درخواست نہیں بھیجا گیا.",
    sign_in: "سائن ان",
    sign_in_apple: "ایپل کے ساتھ سائن ان کریں",
    sign_in_google: "Google کے ساتھ سائن ان کریں",
    sign_in_phone: "فون کے ساتھ سائن ان کریں",
    sign_in_facebook: "فیس بک کے ساتھ سائن ان کریں",
    create_account: "کھاتا کھولیں",
    email: "ای میل",
    invalid_field: "براہ کرم ضروری شعبوں میں بھریں",
    code_sent: "کوڈ ایس ایم ایس کے ذریعہ بھیجا گیا ہے",
    verify_number: "فون نمبر کی توثیق کریں",
    tapping_verify_number:
      "ٹیپ کی طرف سے (فون نمبر کی توثیق)، ایک ایس ایم ایس بھیجا جائے.",
    email_exists:
      "اکاؤنٹ پہلے ہی موجود ہے اور آپ کو Google بٹن، فیس بک بٹن یا ایپل بٹن کے ذریعہ اس تک رسائی حاصل کرنے کی ضرورت ہے",
    ok: "ٹھیک ہے",
    sure_back: "کیا آپ کو یقین ہے؟",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "پہلے",
    add_model: "ماڈل شامل کریں",
    no_search_results_us:
      "120 میل کے فاصلے پر آپ کے قریب تلاش کا کوئی نتیجہ نہیں ہے۔ سرچ فلٹر یا سرچ کلیدی لفظ کو تبدیل کرنے کی کوشش کریں۔",
    no_search_results:
      "200 کلومیٹر کے فاصلے پر آپ کے قریب تلاش کا کوئی نتیجہ نہیں ہے۔ سرچ فلٹر یا سرچ کلیدی لفظ کو تبدیل کرنے کی کوشش کریں۔",
    plan_date: "منصوبہ بندی کی تاریخ",
    plan_time: "منصوبہ بندی کا وقت",
    invalid_plan_date:
      "غلط منصوبہ بندی کی تاریخ ، براہ کرم دوبارہ منصوبہ بندی کی تاریخ طے کریں",
    invalid_plan_time:
      "پلان کا غلط وقت ، براہ کرم دوبارہ منصوبہ بندی کا وقت طے کریں",
    plan_name: "منصوبہ نام",
    plan_title: "منصوبہ",
    update_plan_name: "پلان کا نام اپ ڈیٹ کریں",
    delete_plan_question: "کیا آپ واقعی اس منصوبے کو حذف کرنا چاہتے ہیں؟",
    plan_reminder_message: "آپ کو ایک گھنٹہ پہلے یاد دلایا جائے گا",
    plan_dialog_title: "میٹنگ کا منصوبہ",
    planners_title: "منصوبہ ساز",
    unable_sending_messages:
      "جب وہ آن لائن واپس آئیں گے تو وہ آپ کے پیغامات دیکھیں گے۔",
    its_text: "یہ ہے",
    for_your_text: "آپ کے وصول کنندہ کے لئے",
  },
  vi: {
    invalid_area: "Khu vực không hợp lệ, vui lòng đặt lại khu vực.",
    invalid_lot_size:
      "Kích thước lô thuộc tính không hợp lệ, vui lòng đặt kích thước lô một lần nữa.",
    property_area: "Khu bất động sản.",
    app_store_name:
      "Được liệt kê gần tôi - Mua vật phẩm đã qua sử dụng, bán tiền mặt",
    app_store_short:
      "Một thị trường cho người bán hàng địa phương. Liệt kê một mặt hàng để bán và kiếm tiền.",
    app_store_full:
      "Được liệt kê gần tôi giúp dễ dàng tìm thấy những ưu đãi tuyệt vời về những điều bạn muốn và kiếm tiền cho những thứ bạn muốn bán. Đây là cách tốt nhất để mua và bán trong cộng đồng hoặc khu phố của bạn với những người bạn có thể tin tưởng. Cách thức hoạt động: 1- Mua hoặc bán bất cứ thứ gì; Dễ dàng đăng các mặt hàng của bạn để bán trong vài giây. 2- Tìm các ưu đãi tuyệt vời và giảm giá cho quần áo, đồ nội thất, điện thoại di động, điện tử, đồ trẻ em và trẻ em, thiết bị thể thao, xe hơi đã qua sử dụng, váy, giày và đồng hồ, để sách, đồ chơi đã qua sử dụng, một chiếc xe cũ và thậm chí là thật bất động sản để bán hoặc tiền thuê. 3- Duyệt các mặt hàng địa phương để bán. 4- Người mua tin nhắn và người bán từ trong ứng dụng. 5- Duyệt các mục theo hình ảnh và sắp xếp theo danh mục. Sự thật thú vị về được liệt kê gần tôi: 1- Với được liệt kê gần tôi, bạn có thể dễ dàng bán bất cứ thứ gì, từ quần áo đến xe ô tô đã qua sử dụng đến điện tử. 2- Giao tiếp giữa người mua và người bán đã xảy ra thông qua ứng dụng thông qua nhắn tin. 3- Được liệt kê gần tôi là tốt hơn so với bán nhà để xe; Tìm bất cứ điều gì bạn muốn ở mức giảm giá, ngay trên điện thoại hoặc máy tính bảng của bạn.",
    app_store_release:
      "Liệt kê gần tôi - giao dịch với người dân địa phương. Tham gia thị trường di động cho người mua và người bán hàng địa phương!",
    app_name: "Được liệt kê gần tôi.",
    title_buy: "Mua",
    title_messages: "Thông điệp",
    title_sell: "Bán",
    title_profile_image: "Hình ảnh hồ sơ cá nhân",
    title_account: "Tài khoản",
    account_settings: "Cài đặt tài khoản",
    settings: "Cài đặt",
    color_theme: "Chủ đề màu sắc",
    device_settings: "Cài đặt thiết bị",
    public_profile: "Hồ sơ công khai",
    light_mode: "Chế độ sáng",
    dark_mode: "Chế độ tối",
    title_sell_faster: "Bán nhanh hơn",
    send_button_label: "Gửi",
    rate_message: "Đánh giá tôi...",
    already_rated: "Bạn đã gửi đánh giá",
    rate_review_question: "Bạn có muốn đối phó với",
    again: "lần nữa?",
    action_logout: "Đăng xuất",
    action_category: "Loại",
    action_search: "Tìm kiếm",
    action_refer: "Tham khảo một người bạn",
    dialog_choose_location: "Chọn địa điểm",
    dialog_change_username: "Thay đổi tên người dùng.",
    dialog_change_language: "Thay đổi ngôn ngữ",
    dialog_image_tags: "Thẻ hình ảnh",
    dialog_emails_notifications: "Email thông báo",
    dialog_push_notifications: "Đẩy thông báo",
    fragment_product_detail: "Chi tiết sản phẩm",
    fragment_message_details: "Tin nhắn chi tiết",
    fragment_sell: "Bán",
    dialog_tags_title: "Tags.",
    dialog_location_title: "Cập nhật địa điểm",
    dialog_username_title: "Thay đổi tên người dùng.",
    tab_photo: "ảnh",
    tab_details: "Thông tin chi tiết",
    tab_price: "Giá",
    tab_finish: "Hoàn thành",
    profile: "Hồ sơ",
    search: "Tìm kiếm",
    choose_product: "Chọn sản phẩm",
    rating_review: "Đánh giá và đánh giá",
    select_buyer: "Chọn một người mua",
    tab_my_used_products: "Sản phẩm của tôi",
    price_label: "Giá",
    text_savings: "Bạn tiết kiệm",
    search_hint: "Tìm kiếm sản phẩm…",
    empty_text:
      "Không có sản phẩm được liệt kê trong danh mục này hoặc trong khoảng cách đã chọn.",
    filter_menu_text: "Lọc",
    error_contacting_seller: "Lỗi liên hệ với người bán",
    edit_product: "Chỉnh sửa sản phẩm",
    contact_seller: "Liên hệ với người bán.",
    signup_to_contact_seller: "Đăng ký để liên hệ với người bán",
    signup_to_make_offer: "Đăng ký để cung cấp",
    product_details: "Thông tin chi tiết",
    product_category: "Loại",
    product_condition: "Tình trạng",
    product_description: "Sự miêu tả",
    product_location: "Vị trí sản phẩm",
    product_location_approximate: "Vị trí là gần đúng.",
    over_week_time_ago: "Một tuần vừa qua",
    boosted: "Boosted.",
    threads_no_results: "Không có tin nhắn",
    message_no_results: "Không có tin nhắn",
    message_warning:
      "Bạn chỉ chịu trách nhiệm thực hiện tất cả các biện pháp phòng ngừa cần thiết khi tương tác với người khác, đặc biệt là khi gặp người lạ lần đầu tiên. Vui lòng không chia sẻ bất kỳ thông tin cá nhân, mã xác minh hoặc bất kỳ thông tin thanh toán nào. Vui lòng xem xét các điều khoản dịch vụ để biết thêm chi tiết.",
    message_block: "Bạn không thể gửi hoặc nhận tin nhắn tại thời điểm này.",
    select_location: "Chọn địa điểm",
    location_permission_denied_message:
      "Ứng dụng này yêu cầu sự cho phép vị trí để hoạt động đúng.",
    signed_in: "Đăng nhập!",
    sign_in_canceller: "Đăng nhập hủy",
    version: "Phiên bản",
    build: "Xây dựng",
    name: "Tên",
    location: "Địa điểm",
    language: "Ngôn ngữ",
    about_app: "Về được liệt kê gần tôi",
    terms_of_service: "Điều khoản dịch vụ",
    privacy_policy: "Chính sách bảo mật",
    report_feedback: "Gửi thông tin phản hồi",
    report_bug: "Lắc điện thoại để báo cáo lỗi",
    change_image: "Đổi hình ảnh",
    update_location: "Cập nhật địa điểm",
    about_the_app: "Giới thiệu về ứng dụng",
    update_label: "Cập nhật",
    uploading: "Tải lên",
    adding: "Thêm danh sách",
    removing: "Xóa danh sách",
    updating: "Cập nhật danh sách",
    uploaded_image: "Tải lên hình ảnh:",
    image_storage_failed: "Không thể lưu trữ hình ảnh:",
    product_updated: "Sản phẩm cập nhật thành công",
    location_error: "Vị trí không được lưu, vui lòng thử lại",
    product_removed: "Sản phẩm đã loại bỏ thành công",
    deleted_product: "Sản phẩm này bị xóa",
    invalid_title: "Tiêu đề không hợp lệ, vui lòng đặt tiêu đề một lần nữa.",
    invalid_image:
      "Đường dẫn hình ảnh không hợp lệ, thử thêm hình ảnh một lần nữa.",
    invalid_price: "Giá không hợp lệ, xin vui lòng đặt giá một lần nữa.",
    invalid_location: "Vị trí không hợp lệ, vui lòng đặt lại vị trí.",
    invalid_category: "Danh mục không hợp lệ, vui lòng đặt lại danh mục.",
    invalid_condition:
      "Điều kiện không hợp lệ, xin vui lòng đặt lại điều kiện.",
    removing_title: "Xóa hình ảnh hồ sơ",
    image_not_saved: "Lưu hình ảnh thất bại!",
    product_load_failed: "Không có sản phẩm",
    take_photo: "Chụp hình",
    select_photo: "Chọn ảnh",
    product_title_hint: "Nó là gì? Tên, thương hiệu, mô hình, vv",
    delete_photo: "Xóa ảnh",
    product_title: "Chức vụ",
    mark_as_sold: "Đánh dấu như đã bán",
    product_share: "Chia sẻ",
    product_make_offer: "Đưa ra lời đề nghị",
    product_cover: "Đặt dưới dạng ảnh bìa",
    product_tags: "Tags.",
    product_posted: "Đăng:",
    product_change: "Biến đổi",
    product_post: "Bài đăng",
    product_selling_from: "Bán hàng từ địa điểm",
    product_select_location: "Chọn địa điểm",
    product_map_approximate: "Bản đồ gần đúng để giữ vị trí của người bán",
    product_terms:
      "Bằng cách nhấn vào bài đăng để xuất bản sản phẩm của bạn, bạn đồng ý với <u> được liệt kê gần tôi Điều khoản dịch vụ. </ U>",
    condition_other: "Khác (xem mô tả)",
    condition_for_parts: "Cho các bộ phận",
    condition_used: "Sử dụng (mặc bình thường)",
    condition_open_box: "Hộp mở (không bao giờ sử dụng)",
    condition_reconditioned: "Tân trang / chứng nhận",
    condition_new: "Mới (không bao giờ sử dụng)",
    select_category: "Chọn Thể loại",
    select_all_category: "Chọn tất cả",
    category_loading_error:
      "Không thể cập nhật danh sách danh mục, vui lòng thử lại sau.",
    category_vehicles: "Xe cộ",
    category_furniture: "Đồ nội thất",
    category_electronics: "Thiết bị điện tử",
    category_appliances: "Nhà &  Thiết bị",
    category_fashion_accessories: "Thời trang &  Phụ kiện",
    category_baby_kids: "Bé &  Trẻ em",
    category_antiques_collectibles: "Đồ cổ &  Sưu tầm",
    category_auto_parts_tools_machinery: "Phụ tùng ô tô, công cụ &  Máy móc",
    category_sports_outdoors: "Thể thao &  Ngoài trời",
    category_others: "Khác",
    location_enter_zip_code: "Nhập mã zip",
    location_get_current_location: "Nhận vị trí hiện tại",
    location_select_location: "Chọn địa điểm",
    location_update_location: "Cập nhật địa điểm",
    location_new_location: "Vị trí mới",
    search_filter_results: "Kết quả lọc",
    search_filter_min: "Bộ lọc tối thiểu",
    search_filter_at_least: "Ít nhất",
    price_filter: "Bộ lọc giá",
    product_name: "tên sản phẩm",
    english_language: "Tiếng Anh",
    arabic_language: "tiếng Ả Rập",
    spanish_language: "người Tây Ban Nha",
    system_language: "Hệ thống",
    share_link: "Chia sẻ đường link",
    save: "Cứu",
    cancel: "Hủy bỏ",
    loading: "Đang tải",
    yes: "Đúng",
    no: "Không",
    report: "Báo cáo",
    report_product: "Báo cáo sản phẩm",
    report_user: "Báo cáo người dùng",
    block_user: "Khối người dùng",
    un_block_user: "Mở khoá người dùng",
    why_product: "Tại sao bạn muốn báo cáo mục này?",
    why_user: "Tại sao bạn muốn báo cáo người dùng này?",
    block_user_confirm: "Bạn có muốn chặn vĩnh viễn người dùng này?",
    un_block_user_confirm: "Bạn có muốn bỏ chặn vĩnh viễn người dùng này?",
    prohibited: "Bị cấm trong danh sách gần tôi",
    offensive: "Tấn công hoặc không phù hợp",
    duplicate: "Sao chép bài viết.",
    wrong_category: "Danh mục sai",
    scam: "Trông giống như một scam",
    stolen: "Tôi nghĩ rằng nó bị đánh cắp",
    product_other: "Khác",
    product_is_sold: "Sản phẩm này đã được bán",
    missed_meeting: "Họ đã bỏ lỡ cuộc họp của chúng tôi",
    low_offer: "Đưa ra một đề nghị thấp",
    rude: "Thô lỗ hoặc không phù hợp",
    items: "Vấn đề với các mục",
    trouble_meetup: "Rắc rối khi gặp nhau",
    messaging: "Vấn đề nhắn tin",
    user_other: "Khác",
    new_version_available: "Phiên bản mới có sẵn.",
    please_update_app:
      "Xin vui lòng, cập nhật ứng dụng cho phiên bản mới để tiếp tục.",
    update: "Cập nhật",
    no_thanks: "Không, cám ơn",
    contact_support_confirmation:
      "Thời gian đáp ứng hiện tại là 24-48 giờ. Bạn có muốn liên hệ với danh sách gần tôi hỗ trợ trò chuyện ứng dụng không?",
    unboost_confirmation: "Bạn có chắc chắn muốn sản phẩm này không?",
    no_used_products: "Bạn chưa có bất kỳ danh sách nào",
    no_boosted_products: "Bạn không có bất kỳ sản phẩm được tăng cường",
    next: "Kế tiếp",
    previous: "Trước",
    skip: "Nhảy",
    start: "Khởi đầu",
    list_used: "Liệt kê một sản phẩm đã sử dụng",
    buy_description:
      "Khám phá và tìm kiếm các sản phẩm được cung cấp bởi hàng xóm xung quanh bạn",
    sell_description: "Liệt kê các sản phẩm bạn không còn cần bán",
    list_used_description:
      "Liệt kê một sản phẩm được sử dụng để bán trong vòng chưa đầy 20 giây",
    boost_product_option_1: "<b> Boost 1  ndday </ b>  n  n <b> $ 0,99 </ b>",
    boost_product_option_2: "<b> Boost 3  Ndays </ b>  n  n <b> $ 1.99 </ b>",
    boost_product_option_3: "<b> Boost 7  Ndays </ b>  n  n <b> $ 3,99 </ b>",
    boost_product_description:
      "Lượt xem nhiều hơn mỗi ngày. Mục của bạn sẽ xuất hiện trong các vị trí nổi bật trong 30 mục hàng đầu trong Mua và Danh mục. Các mặt hàng được quảng cáo được xoay giữa các điểm được chỉ định để mọi mục đều được tiếp xúc công bằng.",
    boost_cta: "Bán nhanh hơn",
    boost_terms:
      "Bằng cách khai thác Boost, bạn đồng ý với <U> được liệt kê gần tôi Điều khoản dịch vụ. </ U>",
    boost_best_value: "Giá trị tốt nhất",
    already_boosted: "Sản phẩm này được tăng cường",
    clicks: "Nhấp chuột",
    impressions: "Ấn tượng",
    end: "Chấm dứt",
    transactions_empty_text:
      "Bạn chưa có bất kỳ giao dịch tăng nào. Bạn có thể truy cập tab Bán và bắt đầu tăng sản phẩm của bạn.",
    transactions_loading_error:
      "Không thể cập nhật danh sách giao dịch, vui lòng thử lại sau.",
    transactions_history_title: "Tăng cường giao dịch lịch sử",
    communicative_postive: "Giao tiếp",
    communicative_negative: "Không phổ biến.",
    ontime_postive: "Kịp thời",
    ontime_negative: "Muộn",
    reliable_postive: "Đáng tin cậy",
    reliable_negative: "Không đáng tin cậy",
    friendly_postive: "Thân thiện",
    friendly_negative: "Bất lịch sự",
    itemasdescribed_postive: "Mục như mô tả",
    itemasdescribed_negative: "Mục không như mô tả",
    other: "Khác",
    submit: "Nộp",
    adding_rating_reviews: "Thêm đánh giá và đánh giá",
    no_internet_title: "Không có kết nối Internet",
    no_internet_message: "Đảm bảo bạn được kết nối với Internet và thử lại",
    retry: "Thử lại",
    near_me: "Gần tôi",
    newest_first: "Mới nhất đầu tiên",
    miles: "Dặm.",
    km: "Km.",
    similar_products: "sản phẩm liên quan",
    favorite_products: "Sản phẩm yêu thích",
    items_for_sale: "Bán vật phẩm",
    joined: "Tham gia.",
    favorites_transactions_title: "Yêu thích",
    boosted_products_transactions_history:
      "Tăng cường các sản phẩm giao dịch Lịch sử",
    views: "Lượt xem",
    boost_graph_title: "Boost đồ thị",
    no_favorite_products: "Bạn không có sản phẩm yêu thích nào",
    make_offer_buy: "Tôi muốn mua",
    make_offer_buy_for: "vì",
    notifications: "Thông báo.",
    push_notifications: "Đẩy",
    emails_notifications: "E-mail",
    apply: "Nộp đơn",
    email_messages: "Email cho tin nhắn",
    email_new_products: "Email cho sản phẩm mới",
    push_day_only: "Thông báo đẩy ngày chỉ",
    push_24_hours: "Thông báo đẩy 24 giờ",
    edit: "Biên tập",
    map: "Bản đồ",
    camera: "Máy ảnh",
    gallery: "Phòng trưng bày",
    delete: "Xóa bỏ",
    no_sell_items: "Không có mặt hàng để bán",
    who_bought_question: "Ai đã mua nó?",
    sold_elsewhere_question: "Bán nó ở một nơi khác",
    confirm: "Xác nhận",
    over_limit_camera: "Bạn không thể thêm nhiều hơn năm hình ảnh",
    boost_failed: "Boost thất bại. Vui lòng thử lại sau",
    after_purchase: "Thanh toán thành công  Nproduct đã tăng cường",
    pay_failed: "Thanh toán không thành công. Vui lòng thử lại",
    done: "Làm xong",
    not_now: "Không phải bây giờ",
    boost: "Tăng",
    invalid_zip_code: "Mã bưu chính không hợp lệ",
    invalid_user_name: "Tên sử dụng không hợp lệ",
    comments: "Bình luận",
    questions: "Câu hỏi",
    bug_reports: "Báo cáo lỗi",
    feature_request: "Yêu cầu tính năng",
    feedback_type: "Loại phản hồi",
    feedback_description:
      "Chúng tôi rất thích nghe những suy nghĩ hoặc phản hồi của bạn về cách chúng tôi có thể cải thiện trải nghiệm của mình!",
    feedback: "Phản hồi",
    feedback_text: "Câu trả lời của bạn",
    suggestions: "Góp ý để phát triển",
    delete_account: "Xóa tài khoản",
    new_message: "Tin nhắn mới",
    online: "Trực tuyến",
    km_50: "50 km",
    km_100: "100 km",
    km_200: "200 km",
    miles_30: "30 dặm",
    miles_60: "60 dặm",
    miles_120: "120 dặm.",
    rate_app_question: "Làm thế nào về một đánh giá trên App Store, sau đó?",
    enjoying_question: "Thưởng thức được liệt kê gần tôi?",
    not_enjoy: "Không thực sự",
    feedback_question: "Bạn có phiền cho chúng tôi một số phản hồi?",
    yes_sure: "OK chắc chắn",
    product_available_question: "Xin chào, điều này có còn có sẵn không?",
    buy_question: "Xin chào, tôi muốn mua cái này",
    meet_question: "Xin chào, bạn có thể gặp hôm nay không?",
    follow: "Theo dõi",
    followers: "Người theo dõi",
    following: "Tiếp theo",
    feedback_thanks: "Cảm ơn phản hồi của bạn",
    all_categories: "Tất cả danh mục",
    deleted_account: "Tài khoản này bị xóa",
    delete_account_question: "Bạn có chắc chắn muốn xóa tài khoản này?",
    no_followings: "không theo ai",
    when_following: "khi nào",
    no_followings_subtitle: "Theo dõi mọi người, bạn sẽ thấy họ ở đây",
    no_followers: "không có người theo dõi",
    no_followers_subtitle: "tiếp theo là những người, bạn sẽ thấy họ ở đây",
    distance: "Khoảng cách",
    filter_method: "Phương pháp lọc.",
    see_listings: "Xem danh sách",
    sold: "Đã bán",
    bought: "Mua",
    no_notifications: "Khi bạn nhận được thông báo, họ sẽ xuất hiện ở đây",
    items_title: "vật phẩm",
    new_listing_title: "Tạo danh sách mới",
    dialog_year_title: "Năm",
    dialog_make_title: "Chế tạo",
    dialog_model_title: "Mô hình",
    dialog_body_style_title: "Phong cách cơ thể",
    dialog_exterior_color_title: "Màu ngoại thất.",
    dialog_interior_color_title: "Màu nội thất",
    dialog_transmission_title: "Quá trình lây truyền",
    dialog_fuel_type_title: "Loại nhiên liệu",
    dialog_owners_num_title: "Số lượng chủ sở hữu",
    dialog_vehicle_owed_money_title: "Có tiền vẫn còn nợ trên chiếc xe này?",
    automatic_transmission: "Tự động",
    manual_transmission: "Thủ công",
    not_sure: "Không chắc",
    wagon_hatchback: "Wagon &  Hatchback.",
    convertible: "Mui trần.",
    coupe: "Coupe.",
    sedan: "SEDAN.",
    black_color: "Màu đen",
    blue_color: "Màu xanh lam",
    brown_color: "màu nâu",
    gold_color: "Vàng",
    green_color: "Màu xanh lá",
    grey_color: "Xám",
    pink_color: "Hồng",
    purple_color: "Màu tía",
    red_color: "màu đỏ",
    silver_color: "Màu bạc",
    orange_color: "trái cam",
    white_color: "trắng",
    yellow_color: "Màu vàng",
    charcol_color: "Charcol.",
    fuel_diesel: "Dầu diesel",
    fuel_electric: "Điện",
    fuel_gasoline: "Xăng",
    fuel_flex: "Uốn cong",
    fuel_hybrid: "Hỗn hợp",
    fuel_petrol: "Xăng dầu",
    fuel_plugin_hybrid: "Nhúng vào hỗn hợp",
    truck: "Xe tải",
    van_minivan: "Van &  Minivan.",
    suv_crossover: "SUV &  Crossover.",
    awd_4wd: "AWD / 4WD.",
    fwd: "Fwd.",
    rwd: "Rwd.",
    off_white_color: "Màu trắng ngà",
    tan_color: "Tan.",
    beige_color: "Be",
    burgundy_color: "Burgundy.",
    turquoise_color: "Ngọc lam.",
    title_status_clean: "Dọn dẹp",
    title_status_rebuilt: "Xây dựng lại.",
    title_status_salvage: "Cứu hộ",
    title_status_missing: "Còn thiếu",
    title_status_lien: "LIEN.",
    title_status: "Trạng thái tiêu đề.",
    mileage: "Mileage.",
    dialog_drivetrain_title: "Hệ thống truyền lực",
    model_warning: "Vui lòng chọn Làm đầu tiên",
    required_field_warning: "Trường này là bắt buộc",
    vehicle_vin: "Vin.",
    invalid_vin: "VIN không hợp lệ, vui lòng đặt lại VIN.",
    invalid_mileage: "Mileage không hợp lệ, vui lòng đặt số dặm một lần nữa.",
    clean_description: "Hầu hết các phương tiện đã không gặp tai nạn",
    rebuilt_description: "Một chiếc xe đã trục vớt đã được xây dựng lại",
    salvage_description: "Được coi là tổng số sau một tai nạn",
    missing_description: "Sẽ cần một tiêu đề vấn đề DMV mới",
    lien_description: "Thuộc sở hữu của một ngân hàng hoặc giải quyết tòa án",
    nearme: "Gần tôi",
    newest: "Mới nhất",
    contact_support: "Liên hệ hỗ trợ",
    create_home_title: "Nhà bán hoặc cho thuê",
    for_sale: "Rao bán",
    for_rent: "Cho thuê",
    property_type: "Loại tài sản",
    apartment: "Chung cư",
    house: "nhà ở",
    room_only: "Chỉ phòng",
    townhouse: "Nhà phố.",
    bedrooms: "Phòng ngủ",
    bathrooms: "Phòng tắm",
    property_address: "Địa chỉ tài sản",
    price_per_month: "Giá mỗi tháng",
    square_feet: "Thước vuông",
    year_built: "Năm xây dựng",
    year_renovated: "Năm cải tạo",
    lot_size: "Kích thước lô.",
    laundry_type: "Giặt ủi",
    in_unit_laundry: "Giặt ủi trong đơn vị",
    laundry_building: "Giặt ủi trong tòa nhà.",
    laundry_available: "Giặt ủi có sẵn",
    none: "Không có",
    parking_type: "Loại đậu xe",
    garage_parking: "Nhà để xe",
    street_parking: "Bãi đậu xe đường phố",
    off_street_parking: "Bãi đậu xe ngoài đường",
    available_parking: "Đỗ xe có sẵn",
    air_cond_type: "Loại điều hòa không khí",
    ac_available: "Ac có sẵn",
    central_ac: "Trung AC.",
    heating_type: "Loại sưởi ấm",
    electric_heating: "Nhiệt điện",
    gas_heating: "Khí nóng",
    radiator_heating: "Hệ thống sưởi tản nhiệt",
    available_heating: "Sưởi ấm có sẵn",
    amenities: "Tiện nghi",
    date_available: "Ngày có sẵn",
    lease_length: "Cho thuê dài",
    month_to_month: "Tháng đến tháng",
    three_months: "3 tháng",
    six_months: "6 tháng",
    one_year: "1 năm",
    more_one_year: "Hơn 1 năm",
    cat_friendly: "Cat thân thiện",
    dog_friendly: "Chó thân thiện",
    balcony: "Ban công",
    basement: "Tầng hầm",
    bike_parking: "Đỗ xe đạp xe",
    cable_tv: "Truyền hình cáp",
    ceiling_fan: "Quạt trần",
    concierge: "Hướng dẫn viên",
    dishwasher: "Máy rửa chén",
    doorman: "Người gác cửa",
    elevator: "Thang máy",
    fireplace: "Lò sưởi",
    fitness_center: "Trung tâm thể dục",
    garbage_disposal: "Xử lý rác thải",
    microwave: "Lò vi sóng",
    online_app: "Ứng dụng trực tuyến",
    oven: "Lò",
    package_service: "Dịch vụ trọn gói",
    patio: "Sân tích",
    pet_park: "Pet Park.",
    refrigerator: "Tủ lạnh",
    resident_lounge: "Phòng thường trú",
    roof_deck: "Sàn nhà",
    secured_entry: "Nhập cảnh bảo đảm",
    storage: "Kho",
    walk_in_closet: "Tủ âm tường",
    swimming_pool: "Hồ bơi",
    wheelchair_access: "Truy cập xe lăn",
    central_heating: "Hệ thống sưởi trung tâm",
    invalid_bedrooms:
      "Phòng ngủ không hợp lệ, vui lòng đặt phòng ngủ một lần nữa.",
    invalid_bathrooms:
      "Phòng tắm không hợp lệ, vui lòng đặt phòng tắm một lần nữa.",
    chinese_simplified_language: "Tiếng Trung giản thể",
    chinese_traditional_language: "Truyền thống Trung Hoa",
    czech_language: "Séc.",
    danish_language: "người Đan Mạch",
    dutch_language: "Hà Lan.",
    finnish_language: "Phần Lan.",
    french_language: "người Pháp",
    german_language: "tiếng Đức",
    greek_language: "người Hy Lạp",
    hungarian_language: "người Hungary",
    indonesian_language: "Indonesia",
    italian_language: "người Ý",
    japanese_language: "tiếng Nhật",
    korean_language: "Hàn Quốc",
    norwegian_language: "Na Uy",
    polish_language: "đánh bóng",
    portuguese_language: "Bồ Đào Nha",
    portuguese_brazilian_language: "Bồ Đào Nha, Brazil.",
    romanian_language: "Rumani.",
    russian_language: "tiếng Nga",
    swedish_language: "Thụy Điển",
    turkish_language: "Tiếng Thổ Nhĩ Kỳ",
    ukrainian_language: "Ukraina",
    urdu_pakistan_language: "Urdu (Pakistan)",
    vietnamese_language: "Tiếng Việt",
    category_home_sale_or_rent: "Bán nhà hoặc cho thuê",
    square_meter: "Mét vuông",
    copy_text: "Sao chép",
    copyied_to_clipboard: "Sao chép vào clipboard",
    inbox: "Hộp thư đến",
    input_title_listening: "Lắng nghe ...",
    input_subtitle_listening: "Nói gì đó đi",
    input_title_error: "Xin lỗi, chúng tôi đã không nhận được điều đó.",
    input_subtitle_error: "Hãy thử lặp lại yêu cầu của bạn.",
    input_hint_error: "Thử lại",
    price_less_than_or_equal: "Giá nhỏ hơn hoặc bằng",
    any_price: "Bất cứ giá nào",
    any_condition: "Bất cứ điều kiện nào",
    any_time: "Bất cứ lúc nào",
    days_ago: "ngày trước",
    any_distance: "Bất kỳ khoảng cách",
    distance_within: "Khoảng cách trong vòng",
    new_notification: "Thông báo mới",
    deleted: "Đã xóa",
    processing_image: "Xử lý hình ảnh",
    remove_dialog_message: "Bạn có thực sự muốn loại bỏ sản phẩm này?",
    deleted_thread: "Thông báo này bị xóa",
    category_yard_sale_event: "Sự kiện bán hàng sân",
    yard_first_date: "Bán sân ngày đầu tiên",
    yard_second_date: "Bán sân ngày thứ hai",
    yard_third_date: "Bán sân ngày thứ ba",
    yard_start_time: "Thời gian bắt đầu",
    yard_end_time: "Thời gian kết thúc",
    yard_end_timestamp: "End timestamp.",
    invalid_date1: "Ngày đầu tiên không hợp lệ, vui lòng đặt lại ngày đầu tiên",
    invalid_start_time:
      "Thời gian bắt đầu không hợp lệ, xin vui lòng đặt lại thời gian bắt đầu",
    invalid_end_time:
      "Thời gian kết thúc không hợp lệ, xin vui lòng đặt thời gian kết thúc một lần nữa",
    yard_sale_title: "Bán sân",
    garage_tag: "ga-ra",
    yard_tag: "cái sân",
    from: "Từ",
    to: "Đến",
    block: "Khối",
    un_block: "Mở khóa",
    sign_email: "Đăng nhập bằng email",
    invalid_first_date:
      "Ngày đầu tiên không hợp lệ, vui lòng đảm bảo ngày đầu tiên là trước thứ hai và thứ ba",
    invalid_second_date:
      "Ngày thứ hai không hợp lệ, vui lòng đảm bảo ngày thứ hai là trước ngày thứ ba",
    invalid_start_time_value:
      "Thời gian bắt đầu không hợp lệ, vui lòng đảm bảo thời gian bắt đầu là trước khi kết thúc thời gian",
    use_default_yard_photo: "Sử dụng ảnh bán hàng mặc định",
    active_label: "Tích cực",
    enable_notifications: "Bật thông báo",
    login: "Đăng nhập",
    january: "Tháng một",
    february: "tháng 2",
    march: "hành khúc",
    april: "tháng tư",
    may: "Có thể",
    june: "tháng Sáu",
    july: "tháng Bảy",
    august: "tháng Tám",
    september: "Tháng Chín",
    october: "Tháng Mười",
    november: "tháng Mười Một",
    december: "tháng 12",
    since: "Từ",
    product_views: "Lượt xem sản phẩm",
    shop_views: "Cửa hàng Lượt xem",
    total_sales: "Tổng doanh số",
    total_orders: "Tổng số đơn đặt hàng",
    last_twelvth_months: "Tháng mười hai lần cuối",
    last_nine_months: "Chín tháng qua",
    last_six_months: "Sáu tháng qua",
    last_three_months: "Ba tháng qua",
    last_12_months: "12 tháng qua",
    last_9_months: "9 tháng qua",
    last_6_months: "6 tháng qua",
    last_3_months: "3 tháng qua",
    months: "Tháng",
    open: "Mở",
    reset_password: "Đặt lại mật khẩu",
    create_new_shop: "Tạo cửa hàng mới",
    download_app: "Tải ứng dụng",
    log_in: "Đăng nhập",
    sign_up: "Đăng ký",
    no_result: "Không kết quả",
    max_price: "Giá tối đa",
    max_distance: "Khoảng cách tối đa",
    max_time: "Time Max",
    posted_less_than: "Đăng ít hơn",
    result: "Kết quả",
    more: "Hơn",
    or: "HOẶC LÀ",
    password: "Mật khẩu",
    forgot_password: "Quên mật khẩu?",
    and: "và",
    download_for: "Tải về cho",
    apple_ios: "Apple ios.",
    android: "Android.",
    image: "Hình ảnh",
    edit_image: "Chỉnh sửa hình ảnh",
    please_complete: "Vui lòng hoàn thành",
    enter_your_offer: "Nhập lời đề nghị của bạn",
    categories: "Thể loại",
    upload_image: "Tải lên hình ảnh",
    upload_images: "Đăng tải hình ảnh",
    back: "Trở lại",
    see_more: "Xem thêm",
    add_product: "Thêm sản phẩm",
    selected: "Đã chọn",
    create: "Tạo ra",
    rate_the_buyer: "Đánh giá người mua",
    delete_product: "Xóa sản phẩm",
    product: "Sản phẩm",
    un_block_product: "Bỏ chặn sản phẩm",
    share_your_product: "Chia sẻ sản phẩm của bạn",
    boost_details: "Tăng cường chi tiết",
    remove_all_products: "Loại bỏ tất cả các sản phẩm",
    remove_all: "Xóa bỏ tất cả",
    add_vehicle: "Thêm xe",
    edit_vehicle: "Chỉnh sửa xe",
    upload_a_photo: "Tải lên một bức ảnh",
    view_details: "Xem chi tiết",
    add_yard_sale: "Thêm bán sân",
    edit_yard_sale: "Chỉnh sửa sân bán",
    users: "Người dùng",
    users_details: "Chi tiết người dùng",
    users_by_country: "Người dùng theo quốc gia",
    blocked_users: "Người dùng bị chặn",
    products_cards: "Thẻ sản phẩm",
    archived_products: "Sản phẩm lưu trữ",
    blocked_products: "Sản phẩm bị chặn",
    products_by_country: "Sản phẩm theo quốc gia",
    reports: "Báo cáo",
    reports_details: "Báo cáo chi tiết",
    closed_reports: "Đóng báo cáo",
    threads: "Chủ đề",
    threads_details: "CHI TIẾT CHI TIẾT",
    chat_support: "Hỗ trợ trò chuyện",
    actions: "Hành động",
    search_actions: "Hành động tìm kiếm.",
    product_view_actions: "Chế độ xem sản phẩm Hành động",
    contact_seller_product: "Liên hệ sản phẩm người bán",
    contact_owner_shop: "Liên hệ cửa hàng chủ",
    ratings: "Xếp hạng",
    reviews: "Đánh giá",
    products_all_countries: "Sản phẩm Tất cả các quốc gia",
    edit_profile: "Chỉnh sửa hồ sơ.",
    my_profile: "Thông tin của tôi",
    profile_updated_successfully: "Hô sơ được cập nhật thành công",
    are_you_sure: "Bạn có chắc không",
    my_used_products: "Sản phẩm đã qua sử dụng của tôi",
    my_shops: "Cửa hiệu của tôi",
    my_boosted_products: "Sản phẩm tăng cường của tôi",
    messages_type_message_here: "gõ tin nhắn của bạn ở đây",
    messages_product_sold: "Sản phẩm này được bán hoặc loại bỏ",
    seen: "Đã xem",
    messages_never_miss_message: "Không bao giờ bỏ lỡ một tin nhắn",
    enable: "Cho phép",
    send_notify: "Gửi thông báo",
    un_close: "Cởi bỏ",
    type_your_review: "Nhập đánh giá của bạn",
    again_question: "lần nữa ?",
    ratings_already_submitted_review: "Bạn đã gửi đánh giá",
    set_product_category: "Đặt loại sản phẩm",
    auth_email_password_incorrect:
      "E-mail hoặc mật khẩu của bạn không chính xác",
    auth_insert_your_name: "Vui lòng chèn tên của bạn",
    auth_email_address_badly: "Địa chỉ email được định dạng xấu",
    auth_email_address_used:
      "Địa chỉ email đã được sử dụng bởi một tài khoản khác",
    auth_invalid_password: "Mật khẩu phải có ít nhất 6 ký tự",
    auth_reset_email: "Nhập email của bạn để thiết lập lại mật khẩu của bạn",
    auth_check_email: "Vui lòng kiểm tra email của bạn để đặt lại mật khẩu",
    auth_can_sign_in_google: "Bạn có thể đăng nhập bằng nút google",
    auth_do_not_have_account: "Bạn không có một tài khoản?",
    auth_have_account: "Bạn đã có tài khoản chưa?",
    log_terms_privacy_part1:
      "Bằng cách đăng ký hoặc đăng nhập, bạn đồng ý với danh sách gần tôi",
    boost_this_product: "Tăng sản phẩm này?",
    product_successfully_boosted: "Sản phẩm đã được tăng cường thành công",
    product_failed_boost: "Sản phẩm đã thất bại trong việc tăng cường",
    no_products_for_sale:
      "Bạn hiện không có bất kỳ sản phẩm nào được sử dụng được liệt kê để bán.",
    not_sold_listed_near_me: "Tôi đã không bán nó trên danh sách gần tôi",
    agree_add_product:
      "Bằng cách nhấn vào bài đăng để xuất bản sản phẩm của bạn, bạn đồng ý với các điều khoản về dịch vụ và quyền riêng tư của tôi.",
    click_to_boost: "Nhấp vào sản phẩm để tăng nó",
    listed_terms_of_service: "Được liệt kê gần tôi Điều khoản dịch vụ",
    receive_emails_for_users: "Nhận email cho người dùng tin nhắn",
    receive_emails_for_newly_posted:
      "Nhận email cho các sản phẩm mới đăng của bạn",
    disable_push_notifications: "Vô hiệu hóa thông báo đẩy",
    sms_during_day: "Nhận SMS trong ngày",
    sms_24_hours: "Nhận SMS 24 giờ",
    products: "Các sản phẩm",
    product_no_longer_available: "Xin lỗi, sản phẩm này không còn có sẵn",
    add_home: "Thêm nhà",
    edit_home: "Chỉnh sửa về nhà",
    fill_required_fields: "Điền vào tất cả các trường bắt buộc",
    no_notification: "Không có thông báo",
    orders_history: "Đặt hàng lịch sử",
    privacy: "Sự riêng tư",
    terms: "Điều kiện",
    report_a_problem: "Báo cáo một vấn đề",
    approximation_protect_user_privacy:
      "Xấp xỉ để bảo vệ quyền riêng tư của người dùng",
    do_not_have_products: "Bạn không có sản phẩm",
    emails: "Email.",
    lead_deletion_products:
      "Điều này sẽ dẫn đến việc xóa tất cả các sản phẩm của bạn",
    confirm_legal_message:
      "Bạn hoàn toàn chịu trách nhiệm thực hiện tất cả các biện pháp phòng ngừa cần thiết khi tương tác với người khác, đặc biệt là khi gặp một người xa lạ trong người lần đầu tiên. Vui lòng xem lại Điều khoản dịch vụ để biết thêm chi tiết.",
    push_notifications_notified_instantly:
      "Cho phép thông báo đẩy được thông báo ngay lập tức",
    rate_seller: "Tỷ lệ người bán",
    user_journey: "Hành trình người dùng",
    user: "Người dùng",
    user_id: "Tên người dùng",
    action_id: "ID hành động",
    select_model_car: "Chọn mô hình xe hơi",
    boost_1_day: "Tăng 1 ngày",
    boost_3_days: "Tăng 3 ngày",
    boost_7_days: "Tăng 7 ngày",
    agree_boost_terms: "Bằng cách nhấn mạnh, bạn đồng ý với",
    add: "cộng",
    add_tag: "Thêm thẻ",
    brand_title: "Nhãn hiệu",
    category_mobiles: "Điện thoại di động",
    category_tablets: "Máy tính bảng",
    screen_size: "Kích thước màn hình",
    has_cellular_capability: "Có khả năng di động",
    default_internal_memory: "Bộ nhớ trong",
    network_carrier: "Hãng mạng",
    is_unlocked: "Được mở khóa",
    mobile_model_warning: "Vui lòng chọn Thương hiệu đầu tiên",
    missing_image: "Thiếu hình ảnh, thử thêm hình ảnh một lần nữa.",
    add_mobile: "Thêm điện thoại di động",
    edit_mobile: "Chỉnh sửa điện thoại di động",
    add_tablet: "Thêm máy tính bảng",
    edit_tablet: "Chỉnh sửa máy tính bảng",
    keywords:
      "Mua sắm, Mua, Bán, Kiếm tiền, Thương mại, Người dân địa phương, Hàng xóm, Ô tô, Xe cộ",
    country: "Quốc gia",
    phone_number: "Số điện thoại",
    verification_code: "Mã xác nhận",
    error_occurred: "Một lỗi xảy ra, xin vui lòng thử lại sau",
    invalid_state:
      "Trạng thái không hợp lệ: Đã nhận được cuộc gọi lại đăng nhập, nhưng không có yêu cầu đăng nhập nào được gửi.",
    sign_in: "Đăng nhập",
    sign_in_apple: "Đăng nhập bằng Apple",
    sign_in_google: "Đăng nhập bằng Google",
    sign_in_phone: "Đăng nhập bằng điện thoại",
    sign_in_facebook: "Đăng nhập bằng facebook",
    create_account: "Tạo một tài khoản",
    email: "E-mail",
    invalid_field: "Vui lòng điền vào phần được yêu cầu",
    code_sent: "Mã đã được gửi bởi SMS",
    verify_number: "Xác minh số điện thoại",
    tapping_verify_number:
      "Bằng cách nhấn (xác minh số điện thoại), SMS sẽ được gửi.",
    email_exists:
      "Tài khoản đã tồn tại và bạn cần truy cập nó qua nút Google, nút Facebook hoặc nút Apple",
    ok: "Được",
    sure_back: "Bạn có chắc chắn để quay lại?",
    terms_url: "https://listednearme.com/dynamicLinks/4vDS",
    privacy_url: "https://listednearme.com/dynamicLinks/bjYi",
    ago: "trước kia",
    add_model: "Thêm mô hình",
    no_search_results_us:
      "Không có kết quả tìm kiếm gần bạn trong vòng 120 dặm. Cố gắng thay đổi bộ lọc tìm kiếm hoặc từ khóa tìm kiếm.",
    no_search_results:
      "Không có kết quả tìm kiếm gần bạn trong vòng 200 km. Cố gắng thay đổi bộ lọc tìm kiếm hoặc từ khóa tìm kiếm.",
    plan_date: "Kế hoạch ngày",
    plan_time: "Kế hoạch thời gian",
    invalid_plan_date:
      "Ngày kế hoạch không hợp lệ, vui lòng đặt lại ngày lập kế hoạch",
    invalid_plan_time:
      "Thời gian kế hoạch không hợp lệ, vui lòng đặt lại thời gian của kế hoạch",
    plan_name: "Tên kế hoạch",
    plan_title: "Kế hoạch",
    update_plan_name: "Cập nhật tên kế hoạch",
    delete_plan_question: "Bạn có chắc là bạn muốn xóa kế hoạch này?",
    plan_reminder_message: "Bạn sẽ được nhắc nhở một giờ trước",
    plan_dialog_title: "Kế hoạch gặp gỡ",
    planners_title: "Nhà hoạch định",
    unable_sending_messages:
      "Họ sẽ thấy tin nhắn của bạn khi họ trở lại trực tuyến.",
    its_text: "Của nó",
    for_your_text: "cho người nhận của bạn.",
  },
};
